/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _index = __webpack_require__(1);

	var _index2 = __webpack_require__(2);

	var _index3 = __webpack_require__(3);

	var _index4 = __webpack_require__(4);

	var _index5 = __webpack_require__(7);

	var _index6 = __webpack_require__(8);

	var _index7 = __webpack_require__(9);

	var _localStorage = __webpack_require__(10);

	var _index8 = __webpack_require__(11);

	var _index9 = _interopRequireDefault(_index8);

	var _index10 = __webpack_require__(165);

	var _index11 = _interopRequireDefault(_index10);

	var _index12 = __webpack_require__(166);

	var _index13 = _interopRequireDefault(_index12);

	var _index14 = __webpack_require__(256);

	var _index15 = _interopRequireDefault(_index14);

	var _utils = __webpack_require__(283);

	var _utils2 = _interopRequireDefault(_utils);

	var _utils3 = __webpack_require__(284);

	var _utils4 = _interopRequireDefault(_utils3);

	var _utils5 = __webpack_require__(285);

	var _utils6 = _interopRequireDefault(_utils5);

	var _utils7 = __webpack_require__(286);

	var _utils8 = _interopRequireDefault(_utils7);

	var _utils9 = __webpack_require__(287);

	var _utils10 = _interopRequireDefault(_utils9);

	var _uuidService = __webpack_require__(288);

	var _uuidService2 = _interopRequireDefault(_uuidService);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/* global  moment:true*/
	angular.module('efimob', ['ngMaterial', 'ngMessages', 'ngCookies', 'ngStorage', 'ngSanitize', 'ngAnimate', 'ngTouch', 'ui.router', 'ui.bootstrap', 'ui.tinymce', 'angularLoad', 'pascalprecht.translate', 'ui.tree', _index15.default, _index9.default, _index11.default, _utils2.default, _utils4.default, _utils6.default, _utils8.default, _utils10.default, _index13.default]).constant('moment', moment).constant('COOKIE', _index6.COOKIE).constant('ENV', _index6.ENV).constant('PRELOADED_TRANSLATIONS', _index6.PRELOADED_TRANSLATIONS).constant('VERSION', _index6.VERSION).config(_index.config).config(_index2.routerConfig).config(_index4.translateConfig).config(_index3.decorators).run(_index5.runBlock).factory('LocalStorage', _localStorage.LocalStorageFactory).factory('Global', _index7.GlobalFactory).factory('TranslationsLoaderErrorHandler', _index4.TranslationsLoaderErrorHandler).factory('uuid', _uuidService2.default);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';

	config.$inject = ["$httpProvider", "$sanitizeProvider", "$mdAriaProvider", "$qProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = config;
	function config($httpProvider, $sanitizeProvider, $mdAriaProvider, $qProvider) {
	  'ngInject';

	  $httpProvider.interceptors.push(["$rootScope", function ($rootScope) {
	    return {
	      'responseError': function responseError(response) {
	        switch (response.status) {
	          case 401:
	            $rootScope.Auth.logout();
	            break;
	          case 403:
	          case 404:
	          default:
	            break;
	        }

	        return Promise.reject(response);
	      }
	    };
	  }]);

	  $sanitizeProvider.addValidElements(['accent']);
	  $sanitizeProvider.addValidAttrs(['uib-tooltip']);
	  $mdAriaProvider.disableWarnings();
	  $qProvider.errorOnUnhandledRejections(false);
	}

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	routerConfig.$inject = ["$stateProvider", "$locationProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerConfig = routerConfig;
	function routerConfig($stateProvider, $locationProvider, $urlRouterProvider) {
	  'ngInject';

	  $locationProvider.html5Mode(true);
	  $urlRouterProvider.otherwise('/');

	  $stateProvider.state('efimob', {
	    url: '',
	    views: {
	      'left': {
	        templateUrl: 'app/views/left/left.html',
	        controller: 'LeftController',
	        controllerAs: 'ctrl'
	      },
	      'header': {
	        templateUrl: 'app/views/header/header.html',
	        controller: 'HeaderController',
	        controllerAs: 'ctrl'
	      },
	      'content': {
	        template: '<ui-view></ui-view>'
	      }
	    },
	    resolve: {
	      'username': ["Auth", "App", function username(Auth, App) {
	        App.setPreLoading(true);
	        return Auth.me().then(function () {
	          return App.setPreLoading(false);
	        });
	      }],
	      'roles': ["App", "UsersService", function roles(App, UsersService) {
	        App.setPreLoading(true);
	        return UsersService.getRoles().then(function () {
	          return App.setPreLoading(false);
	        });
	      }],
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('_global_');
	      }]
	    }
	  }).state('efimob.home', {
	    url: '/',
	    data: {
	      redirect: { 'efimob.home': 'efimob.dashboard' }
	    }
	  }).state('efimob.dashboard', {
	    url: '/dashboard',
	    params: {
	      'organization': { value: undefined },
	      'group': { value: undefined },
	      'groupName': { value: undefined }
	    },
	    templateUrl: 'app/views/dashboard/dashboard.html',
	    controller: 'DashboardController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.DASHBOARD', icon: 'tachometer-alt' },
	      back: { display: 'BACK.DASHBOARD' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations(['dashboard', 'charges']);
	      }]
	    }
	  })

	  /* #region  GROUPS */
	  .state('efimob.groups', {
	    url: '/zonas/:organization',
	    params: {
	      'group': { value: undefined },
	      'groupName': { value: undefined }
	    },
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.GROUPS', icon: 'project-diagram' },
	      redirect: { 'efimob.groups': 'efimob.groups.list' }
	    }
	  }).state('efimob.groups.list', {
	    url: '?zona',
	    params: {
	      'zona': { value: undefined, squash: true }
	    },
	    templateUrl: 'app/views/groups/groups.html',
	    controller: 'GroupsController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'BACK.GROUPS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('groups');
	      }]
	    }
	  }).state('efimob.groups.item', {
	    url: '/:id/:tab?tipo?conectado?status?nombre?punto_id?punto_serial?marca?modelo?creado_desde?creado_hasta?actualizacion_desde?actualizacion_hasta?llave?autorizada?bloqueada?maestra?activada_desde?activada_hasta?caducada_desde?caducada_hasta?desde?hasta?punto?cliente?inicio_cp?fin_cp?coste_min?coste_max?carga_min?carga_max?potencia_min?potencia_max?duracion_min?duracion_max?duracion_efectiva_min?duracion_efectiva_max',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false },
	      'tipo': { dynamic: true },
	      'conectado': { dynamic: true },
	      'status': { dynamic: true },
	      'nombre': { dynamic: true },
	      'punto_id': { dynamic: true },
	      'punto_serial': { dynamic: true },
	      'marca': { dynamic: true },
	      'modelo': { dynamic: true },
	      'creado_desde': { dynamic: true },
	      'creado_hasta': { dynamic: true },
	      'actualizacion_desde': { dynamic: true },
	      'actualizacion_hasta': { dynamic: true },
	      'llave': { dynamic: true },
	      'autorizada': { dynamic: true },
	      'bloqueada': { dynamic: true },
	      'maestra': { dynamic: true },
	      'activada_desde': { dynamic: true },
	      'activada_hasta': { dynamic: true },
	      'caducada_desde': { dynamic: true },
	      'caducada_hasta': { dynamic: true },
	      'desde': { dynamic: true },
	      'hasta': { dynamic: true },
	      'punto': { dynamic: true },
	      'cliente': { dynamic: true },
	      'inicio_cp': { dynamic: true },
	      'fin_cp': { dynamic: true },
	      'coste_min': { dynamic: true },
	      'coste_max': { dynamic: true },
	      'carga_min': { dynamic: true },
	      'carga_max': { dynamic: true },
	      'potencia_min': { dynamic: true },
	      'potencia_max': { dynamic: true },
	      'duracion_min': { dynamic: true },
	      'duracion_max': { dynamic: true },
	      'duracion_efectiva_min': { dynamic: true },
	      'duracion_efectiva_max': { dynamic: true }
	    },
	    templateUrl: 'app/views/group/group.html',
	    controller: 'GroupController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.GROUP', icon: 'project-diagram' },
	      back: { display: 'BACK.GROUP' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations(['groups', 'group']);
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  CHARGEPOINTS */
	  .state('efimob.chargepoints', {
	    url: '/puntos',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.CHARGEPOINTS', icon: 'charging-station' },
	      redirect: { 'efimob.chargepoints': 'efimob.chargepoints.at' }
	    }
	  }).state('efimob.chargepoints.at', {
	    url: '/:organization',
	    params: {
	      'group': { value: undefined },
	      'groupName': { value: undefined }
	    },
	    data: {
	      redirect: { 'efimob.chargepoints.at': 'efimob.chargepoints.at.list' }
	    }
	  }).state('efimob.chargepoints.at.list', {
	    url: '?zona?tipo?conectado?status?nombre?punto_id?punto_serial?marca?modelo?creado_desde?creado_hasta?actualizacion_desde?actualizacion_hasta',
	    templateUrl: 'app/views/charge-points/charge-points.html',
	    controller: 'ChargepointsController',
	    controllerAs: 'ctrl',
	    params: {
	      'zona': { value: undefined, squash: true },
	      'tipo': { dynamic: true },
	      'conectado': { dynamic: true },
	      'status': { dynamic: true },
	      'nombre': { dynamic: true },
	      'punto_id': { dynamic: true },
	      'punto_serial': { dynamic: true },
	      'marca': { dynamic: true },
	      'modelo': { dynamic: true },
	      'creado_desde': { dynamic: true },
	      'creado_hasta': { dynamic: true },
	      'actualizacion_desde': { dynamic: true },
	      'actualizacion_hasta': { dynamic: true }
	    },
	    data: {
	      back: { display: 'BACK.CHARGEPOINTS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('charge-points');
	      }]
	    }
	  }).state('efimob.chargepoints.at.item', {
	    url: '/:id/:tab?desde?hasta?cliente?llave?inicio_cp?fin_cp?coste_min?coste_max?carga_min?carga_max?potencia_min?potencia_max?duracion_min?duracion_max?duracion_efectiva_min?duracion_efectiva_max',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false },
	      'desde': { dynamic: true },
	      'hasta': { dynamic: true },
	      'cliente': { dynamic: true },
	      'llave': { dynamic: true },
	      'inicio_cp': { dynamic: true },
	      'fin_cp': { dynamic: true },
	      'coste_min': { dynamic: true },
	      'coste_max': { dynamic: true },
	      'carga_min': { dynamic: true },
	      'carga_max': { dynamic: true },
	      'potencia_min': { dynamic: true },
	      'potencia_max': { dynamic: true },
	      'duracion_min': { dynamic: true },
	      'duracion_max': { dynamic: true },
	      'duracion_efectiva_min': { dynamic: true },
	      'duracion_efectiva_max': { dynamic: true }
	    },
	    templateUrl: 'app/views/charge-point/charge-point.html',
	    controller: 'ChargepointController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.CHARGEPOINT', icon: 'charging-station' },
	      back: { display: 'BACK.CHARGEPOINT' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations(['charge-points', 'charge-point']);
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  USERKEYS */
	  .state('efimob.userkeys', {
	    url: '/llaves',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.USERKEYS', icon: 'address-card' },
	      redirect: { 'efimob.userkeys': 'efimob.userkeys.at' }
	    }
	  }).state('efimob.userkeys.at', {
	    url: '/:organization',
	    params: {
	      'group': { value: undefined },
	      'groupName': { value: undefined }
	    },
	    data: {
	      redirect: { 'efimob.userkeys.at': 'efimob.userkeys.at.list' }
	    }
	  }).state('efimob.userkeys.at.list', {
	    url: '?zona?llave?autorizada?bloqueada?maestra?activada_desde?activada_hasta?caducada_desde?caducada_hasta',
	    params: {
	      'zona': { value: undefined, squash: true },
	      'llave': { dynamic: true },
	      'autorizada': { dynamic: true },
	      'bloqueada': { dynamic: true },
	      'maestra': { dynamic: true },
	      'activada_desde': { dynamic: true },
	      'activada_hasta': { dynamic: true },
	      'caducada_desde': { dynamic: true },
	      'caducada_hasta': { dynamic: true }
	    },
	    templateUrl: 'app/views/user-keys/user-keys.html',
	    controller: 'UserKeysController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'BACK.USERKEYS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('user-keys');
	      }]
	    }
	  }).state('efimob.userkeys.at.item', {
	    url: '/:id/:tab?desde?hasta?punto?cliente?llave?inicio_cp?fin_cp?coste_min?coste_max?carga_min?carga_max?potencia_min?potencia_max?duracion_min?duracion_max?duracion_efectiva_min?duracion_efectiva_max',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false },
	      'desde': { dynamic: true },
	      'hasta': { dynamic: true },
	      'punto': { dynamic: true },
	      'cliente': { dynamic: true },
	      'llave': { dynamic: true },
	      'inicio_cp': { dynamic: true },
	      'fin_cp': { dynamic: true },
	      'coste_min': { dynamic: true },
	      'coste_max': { dynamic: true },
	      'carga_min': { dynamic: true },
	      'carga_max': { dynamic: true },
	      'potencia_min': { dynamic: true },
	      'potencia_max': { dynamic: true },
	      'duracion_min': { dynamic: true },
	      'duracion_max': { dynamic: true },
	      'duracion_efectiva_min': { dynamic: true },
	      'duracion_efectiva_max': { dynamic: true }
	    },
	    templateUrl: 'app/views/user-key/user-key.html',
	    controller: 'UserKeyController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.USERKEY', icon: 'address-card' },
	      back: { display: 'BACK.USERKEY' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations(['user-keys', 'user-key']);
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  CHARGES */
	  .state('efimob.charges', {
	    url: '/recargas',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.CHARGES', icon: 'battery-bolt' },
	      redirect: 'efimob.charges.at'
	    }
	  }).state('efimob.charges.at', {
	    url: '/:organization',
	    params: {
	      'group': { value: undefined },
	      'groupName': { value: undefined }
	    },
	    data: {
	      // breadcrums: {title: 'Recargas', icon: 'battery-bolt'},
	      redirect: { 'efimob.charges.at': 'efimob.charges.at.list' }
	    }
	  }).state('efimob.charges.at.list', {
	    url: '?zona?desde?hasta?punto?cliente?llave?inicio_cp?fin_cp?coste_min?coste_max?carga_min?carga_max?potencia_min?potencia_max?duracion_min?duracion_max?duracion_efectiva_min?duracion_efectiva_max',
	    params: {
	      'zona': { value: undefined, squash: true },
	      'desde': { dynamic: true },
	      'hasta': { dynamic: true },
	      'punto': { dynamic: true },
	      'cliente': { dynamic: true },
	      'llave': { dynamic: true },
	      'inicio_cp': { dynamic: true },
	      'fin_cp': { dynamic: true },
	      'coste_min': { dynamic: true },
	      'coste_max': { dynamic: true },
	      'carga_min': { dynamic: true },
	      'carga_max': { dynamic: true },
	      'potencia_min': { dynamic: true },
	      'potencia_max': { dynamic: true },
	      'duracion_min': { dynamic: true },
	      'duracion_max': { dynamic: true },
	      'duracion_efectiva_min': { dynamic: true },
	      'duracion_efectiva_max': { dynamic: true }
	    },
	    templateUrl: 'app/views/charges/charges.html',
	    controller: 'ChargesController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'BACK.CHARGES' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('charges');
	      }]
	    }
	  }).state('efimob.charges.at.item', {
	    url: '/:id/:tab',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false }
	    },
	    templateUrl: 'app/views/charge/charge.html',
	    controller: 'ChargeController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.CHARGE', icon: 'battery-bolt' },
	      back: { display: 'BACK.CHARGE' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations(['charges', 'charge']);
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  CUSTOMERS */
	  .state('efimob.customers', {
	    url: '/clientes/:organization',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.CUSTOMERS', icon: 'car' },
	      redirect: { 'efimob.customers': 'efimob.customers.list' }
	    }
	  }).state('efimob.customers.list', {
	    url: '?nombre',
	    params: {
	      'nombre': { dynamic: true }
	    },
	    templateUrl: 'app/views/customers/customers.html',
	    controller: 'CustomersController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'BACK.CUSTOMERS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('customers');
	      }]
	    }
	  }).state('efimob.customers.item', {
	    url: '/:id/:tab',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false }
	    },
	    templateUrl: 'app/views/customer/customer.html',
	    controller: 'CustomerController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.CUSTOMER', icon: 'car' },
	      back: { display: 'BACK.CUSTOMER' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations(['customers', 'customer']);
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  ORGANIZATION  */
	  .state('efimob.organizations', {
	    url: '/empresas',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.ORGANIZATIONS', icon: 'building' },
	      redirect: { 'efimob.organizations': 'efimob.organizations.list' }
	    }
	  }).state('efimob.organizations.list', {
	    url: '?nombre',
	    params: {
	      'nombre': { dynamic: true }
	    },
	    templateUrl: 'app/views/organizations/organizations.html',
	    controller: 'OrganizationsController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'BACK.ORGANIZATIONS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('organizations');
	      }]
	    }
	  }).state('efimob.organizations.item', {
	    url: '/:id/:tab',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false }
	    },
	    templateUrl: 'app/views/organization/organization.html',
	    controller: 'OrganizationController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.ORGANIZATION', icon: 'building' },
	      back: { display: 'BACK.ORGANIZATION'
	        // authorization: {'entity': 'organization', 'id': ':id', 'role': 'doer'},
	      } },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('organization');
	      }]
	    }
	  })
	  /* #endregion */

	  .state('efimob.settings', {
	    url: '/ajustes/:tab',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false }
	    },
	    templateUrl: 'app/views/settings/settings.html',
	    controller: 'SettingsController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.SETTINGS', icon: 'cogs' },
	      back: { display: 'BACK.SETTINGS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('settings');
	      }]
	    }
	  }).state('efimob.profile', {
	    url: '/perfil/:tab',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false }
	    },
	    templateUrl: 'app/views/profile/profile.html',
	    controller: 'ProfileController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'BREADCRUMS_TITLE.PROFILE', icon: 'user-cog' },
	      back: { display: 'BACK.PROFILE' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('profile');
	      }]
	    }
	  })

	  /* #region  Tariff */
	  .state('efimob.tariffs', {
	    url: '/tariffs/:organization',
	    data: {
	      breadcrums: { title: 'TARIFFS', icon: 'receipt' },
	      redirect: { 'efimob.tariffs': 'efimob.tariffs.list' }
	    }
	  }).state('efimob.tariffs.list', {
	    url: '?name',
	    params: {
	      'name': { dynamic: true }
	    },
	    templateUrl: 'app/views/tariffs/tariffs.html',
	    controller: 'TariffsController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'TARIFFS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations();
	      }]
	    }
	  }).state('efimob.tariffs.item', {
	    url: '/:id/:tab',
	    params: {
	      'tab': { value: null, squash: true, dynamic: true, inherit: false },
	      'location': { value: undefined, squash: true }
	    },
	    templateUrl: 'app/views/tariff/tariff.html',
	    controller: 'TariffController',
	    controllerAs: 'ctrl',
	    data: {
	      breadcrums: { title: 'TARIFF', icon: 'receipt' },
	      back: { display: 'TARIFFS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations();
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  Agreements */
	  .state('efimob.agreements', {
	    url: '/agreements/:organization',
	    data: {
	      breadcrums: { title: 'INTEROPERABILITY', icon: 'handshake' },
	      redirect: { 'efimob.agreements': 'efimob.agreements.list' }
	    }
	  }).state('efimob.agreements.list', {
	    url: '?agreementCode?organizationName?agreementId?operationName?locationName?agreementName',
	    params: {
	      'agreementCode': { dynamic: true },
	      'organizationName': { dynamic: true },
	      'agreementid': { dynamic: true },
	      'operationName': { dynamic: true },
	      'locationName': { dynamic: true },
	      'agreementName': { dynamic: true }
	    },
	    templateUrl: 'app/views/agreements/agreements.html',
	    controller: 'AgreementsController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'INTEROPERABILITY' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations();
	      }]
	    }
	  })
	  /* #endregion */

	  /* #region  Location */
	  .state('efimob.locations', {
	    url: '/locations/:organization',
	    params: {
	      'group': { value: undefined },
	      'groupName': { value: undefined }
	    },
	    data: {
	      breadcrums: { title: 'LOCATIONS', icon: 'project-diagram' },
	      redirect: { 'efimob.locations': 'efimob.locations.list' }
	    }
	  }).state('efimob.locations.list', {
	    url: '?purpose?onlyAtomic?locationName?operationId?roamingId',
	    params: {
	      'purpose': { dynamic: true },
	      'onlyAtomic': { dynamic: true },
	      'locationName': { dynamic: true },
	      'operationId': { dynamic: true },
	      'roamingId': { dynamic: true }
	    },
	    templateUrl: 'app/views/locations/locations.html',
	    controller: 'LocationsController',
	    controllerAs: 'ctrl',
	    data: {
	      back: { display: 'LOCATIONS' }
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations();
	      }]
	    }
	  })
	  /* #endregion */

	  .state('efimob.unauthorized', {
	    url: '/unauthorized',
	    template: '<div class="fatal-message"><i class="fal fa-exclamation-triangle"></i><p>{{\'ROUTER.UNAUTHORIZED\' | translate}}</p></div>'
	  }).state('efimob.no-roles', {
	    url: '/sin-roles',
	    template: '<div class="fatal-message"><i class="fal fa-building"></i><p>{{\'ROUTER.NO_ROLES_A\' | translate}}<br><span class="">{{\'ROUTER.NO_ROLES_B\' | translate}}</span></p></div>'
	  }).state('login', {
	    url: '/login',
	    views: {
	      'content': {
	        templateUrl: 'app/views/login/login.html',
	        controller: 'LoginController',
	        controllerAs: 'ctrl'
	      }
	    },
	    data: {
	      'header': null,
	      'menu': null,
	      breadcrums: null
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('login');
	      }]
	    }
	  }).state('welcome', {
	    url: '/welcome?token?result',
	    views: {
	      'content': {
	        templateUrl: 'app/views/welcome/welcome.html',
	        controller: 'WelcomeController',
	        controllerAs: 'ctrl'
	      }
	    },
	    data: {
	      'header': null,
	      'menu': null,
	      breadcrums: null
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('welcome');
	      }]
	    }
	  }).state('reset-password', {
	    url: '/reset-password?token',
	    views: {
	      'content': {
	        templateUrl: 'app/views/reset-password/reset-password.html',
	        controller: 'ResetPasswordController',
	        controllerAs: 'ctrl'
	      }
	    },
	    data: {
	      'header': null,
	      'menu': null,
	      breadcrums: null
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('reset-password');
	      }]
	    }
	  }).state('signup', {
	    url: '/signup',
	    views: {
	      'content': {
	        templateUrl: 'app/views/signup/signup.html',
	        controller: 'SignUpController',
	        controllerAs: 'ctrl'
	      }
	    },
	    data: {
	      'header': null,
	      'menu': null,
	      breadcrums: null
	    }
	  }).state('forgot-password', {
	    url: '/forgot-password',
	    views: {
	      'content': {
	        templateUrl: 'app/views/forgot-password/forgot-password.html',
	        controller: 'ForgotPasswordController',
	        controllerAs: 'ctrl'
	      }
	    },
	    data: {
	      'header': null,
	      'menu': null,
	      breadcrums: null
	    },
	    resolve: {
	      'translations': ["App", function translations(App) {
	        return App.loadTranslations('forgot-password');
	      }]
	    }
	  });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	decorators.$inject = ["$provide"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.decorators = decorators;
	function decorators($provide) {
	    'ngInject';

	    $provide.decorator('$mdSelect', ['$delegate', '$timeout', '$interval', function ($delegate, $timeout, $interval) {
	        var origShow = $delegate.show;
	        var stop;
	        $delegate.show = function () {
	            var onShow = origShow.apply(this, arguments);
	            onShow.then(function () {
	                $interval.cancel(stop);
	                stop = undefined;
	            });
	            var selectInput = arguments[0].target;
	            var selectDropDown = arguments[0].element;
	            //angular.element(selectDropDown[0]).find('md-select-menu')[0].style.display = 'none';
	            $timeout(function () {
	                var boundings = selectInput.getBoundingClientRect();
	                selectDropDown[0].style.left = boundings.left + "px";
	                selectDropDown[0].style.top = boundings.top + boundings.height + "px";
	                var dropDownBoundings = selectDropDown[0].getBoundingClientRect();
	                if (dropDownBoundings.width < boundings.width) {
	                    selectDropDown[0].style.width = boundings.width + "px";
	                }
	                //angular.element(selectDropDown[0]).find('md-select-menu')[0].style.display = '';
	                stop = $interval(function () {
	                    selectDropDown[0].style.left = boundings.left + "px";
	                    selectDropDown[0].style.top = boundings.top + boundings.height + "px";
	                }, 13);
	            }, 60);
	            return onShow;
	        };

	        return $delegate;
	    }]);
	}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	translateConfig.$inject = ["$translateProvider", "PRELOADED_TRANSLATIONS", "ENV"];
	TranslationsLoaderErrorHandler.$inject = ["$q", "$log"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateConfig = translateConfig;
	exports.TranslationsLoaderErrorHandler = TranslationsLoaderErrorHandler;

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function translateConfig($translateProvider, PRELOADED_TRANSLATIONS, ENV) {
	  'ngInject';

	  // Preload some translations to avoid translation keys flashes

	  _lodash2.default.forEach(ENV.LANGS.SUPPORTED, function (code) {
	    return $translateProvider.translations(code, PRELOADED_TRANSLATIONS[code] || {});
	  });

	  // Map languages like 'es_ES' to 'es'
	  // and not supported languages to fallback
	  var aliases = _lodash2.default.keyBy(ENV.LANGS.SUPPORTED, function (code) {
	    return code + '_*';
	  });
	  aliases['*'] = ENV.LANGS.FALLBACK;
	  $translateProvider.registerAvailableLanguageKeys(ENV.LANGS.SUPPORTED, aliases);

	  // Set preferred and fallback languages
	  if (ENV.LANGS.PREFERRED && ENV.LANGS.PREFERRED !== 'auto') {
	    $translateProvider.preferredLanguage(ENV.LANGS.PREFERRED);
	  } else {
	    $translateProvider.uniformLanguageTag('java').determinePreferredLanguage();
	  }
	  $translateProvider.fallbackLanguage(ENV.LANGS.FALLBACK);

	  // Lazy loading strategy
	  $translateProvider.useLoader('$translatePartialLoader', {
	    urlTemplate: 'i18n/{part}/{lang}.json',
	    loadFailureHandler: 'TranslationsLoaderErrorHandler'
	  });

	  // Security strategy
	  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
	}

	function TranslationsLoaderErrorHandler($q, $log) {
	  'ngInject';

	  return function (part, lang) {
	    $log.log('Translations "' + part + '/' + lang + '" not loaded');
	    return $q.when({});
	  };
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '4.17.15';

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';

	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';

	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;

	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;

	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;

	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;

	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;

	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);

	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;

	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;

	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;

	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;

	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';

	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');

	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');

	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');

	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();

	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;

	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;

	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;

	      if (types) {
	        return types;
	      }

	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());

	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }

	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;

	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }

	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;

	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');

	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }

	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }

	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }

	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }

	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }

	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }

	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;

	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }

	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;

	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);

	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }

	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }

	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }

	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }

	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;

	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;

	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;

	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }

	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }

	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }

	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];

	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }

	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);

	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }

	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }

	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }

	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }

	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }

	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }

	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }

	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;

	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());

	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;

	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());

	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;

	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }

	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }

	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }

	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }

	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);

	      this.size = data.size;
	      return result;
	    }

	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }

	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }

	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }

	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;

	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }

	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }

	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }

	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }

	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }

	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;

	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }

	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;

	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;

	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);

	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }

	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);

	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }

	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];

	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }

	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;

	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);

	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;

	      predicate || (predicate = isFlattenable);
	      result || (result = []);

	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }

	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }

	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }

	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }

	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }

	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];

	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];

	      var index = -1,
	          seen = caches[0];

	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }

	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }

	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }

	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }

	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);

	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;

	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;

	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }

	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }

	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }

	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }

	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }

	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];

	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }

	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;

	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);

	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;

	      var isCommon = newValue === undefined;

	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }

	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }

	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }

	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};

	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);

	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;

	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;

	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;

	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }

	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);

	      return result;
	    }

	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }

	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }

	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }

	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;

	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };

	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);

	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);

	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;

	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }

	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }

	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}

	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }

	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);

	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;

	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }

	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};

	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }

	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }

	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }

	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;

	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }

	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };

	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	      buffer.copy(result);
	      return result;
	    }

	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }

	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }

	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }

	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }

	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }

	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);

	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);

	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }

	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;

	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;

	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];

	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;

	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }

	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }

	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }

	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};

	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }

	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;

	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;

	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;

	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);

	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;

	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);

	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);

	        return chr[methodName]() + trailing;
	      };
	    }

	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);

	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;

	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;

	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }

	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }

	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);

	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }

	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;

	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];

	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }

	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));

	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };

	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;

	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);

	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];

	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);

	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	      stack.set(array, other);
	      stack.set(other, array);

	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;

	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;

	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');

	        case mapTag:
	          var convert = mapToArray;

	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);

	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;

	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;

	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);

	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }

	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }

	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }

	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;

	      while (length--) {
	        var key = result[length],
	            value = object[key];

	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];

	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };

	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };

	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;

	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';

	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }

	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          result = false;

	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);

	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case dataViewTag:
	          return cloneDataView(object, isDeep);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);

	        case mapTag:
	          return new Ctor;

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          return cloneRegExp(object);

	        case setTag:
	          return new Ctor;

	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }

	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }

	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;

	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }

	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];

	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;

	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	      return value === proto;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }

	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);

	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }

	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }

	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }

	      if (key == '__proto__') {
	        return;
	      }

	      return object[key];
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);

	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };

	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);

	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }

	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;

	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }

	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;

	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];

	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;

	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }

	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }

	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }

	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }

	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }

	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};

	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }

	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });

	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }

	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }

	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);

	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }

	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);

	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));

	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }

	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }

	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }

	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }

	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }

	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });

	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);

	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }

	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;

	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }

	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };

	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });

	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];

	      return { 'done': done, 'value': value };
	    }

	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }

	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }

	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);

	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }

	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });

	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });

	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }

	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }

	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;

	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }

	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }

	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize.Cache = MapCache;

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);

	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });

	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);

	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }

	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }

	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }

	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });

	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }

	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }

	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }

	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }

	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }

	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

	      return func(value);
	    }

	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }

	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;

	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }

	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }

	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });

	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });

	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });

	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });

	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);

	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }

	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);

	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;

	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }

	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;

	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];

	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }

	      return object;
	    });

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }

	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }

	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }

	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      result[value] = key;
	    }, constant(identity));

	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }

	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);

	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }

	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }

	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });

	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });

	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }

	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });

	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }

	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length;

	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }

	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }

	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }

	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);

	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }

	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }

	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }

	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }

	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }

	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });

	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }

	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);

	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);

	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }

	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }

	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);

	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }

	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }

	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);

	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);

	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
	      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      // Like with sourceURL, we take care to not check the option's prototype,
	      // as this configuration is a code injection vector.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }

	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;

	      return castSlice(strSymbols, start, end).join('');
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

	      return castSlice(strSymbols, 0, end).join('');
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));

	      return castSlice(strSymbols, start).join('');
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);

	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);

	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;

	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });

	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;

	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });

	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();

	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });

	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }

	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }

	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);

	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);

	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);

	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });

	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }

	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }

	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);

	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);

	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);

	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();

	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);

	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }

	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }

	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }

	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }

	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }

	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);

	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;

	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }

	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);

	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);

	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }

	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }

	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }

	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }

	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }

	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }

	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);

	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);

	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }

	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }

	    /*------------------------------------------------------------------------*/

	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;

	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;

	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();

	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };

	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };

	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });

	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;

	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });

	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });

	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];

	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;

	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;

	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(6)(module)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	runBlock.$inject = ["$rootScope", "$log", "$state", "$transitions", "$translate", "App", "LocalStorage", "Auth", "ENV", "$window"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runBlock = runBlock;

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function runBlock($rootScope, $log, $state, $transitions, $translate, App, LocalStorage, Auth, ENV, $window) {
	  'ngInject';

	  $rootScope.$state = $state;

	  // Info: Workaround for multiple tabs in browser
	  var isHidden = false;
	  function handleVisibilityChange() {
	    isHidden = $window.document.hidden;
	  }
	  $window.document.addEventListener("visibilitychange", handleVisibilityChange, false);

	  if (ENV.ID != 'production') App.setPreffixTitle('[' + ENV.NAME.toUpperCase() + '] ');
	  $log.log('%s ready.\nEnv: %s (backend at: %s)', App.config.name, ENV.NAME, ENV.URL);

	  $transitions.onStart({}, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    var toState = transition.$to();
	    var fromState = transition.$from();
	    if (toState.name !== fromState.name) {
	      if (toState.data && toState.data.breadcrums === null) {
	        App.setBreadcrums(null);
	      } else {
	        App.setBreadcrums($translate.instant(_lodash2.default.get(toState, 'data.breadcrums.title', ' ')), _lodash2.default.get(toState, 'data.breadcrums.icon', null));
	      }
	      App.menu.hidden = toState.data && toState.data.menu === null;
	      App.header.hidden = toState.data && toState.data.header === null;
	      App.setLoading(false);
	    }
	  });

	  $transitions.onSuccess({}, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    App.setTitle(_lodash2.default.upperFirst($translate.instant(_lodash2.default.get(transition.$to(), 'data.breadcrums.title', ''))));
	  });

	  //Hook to redirect to login page prior to navigate to any page if not logged in user.PRIORITY: 10
	  $transitions.onStart({ from: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    if (!$rootScope.user) {
	      return transition.router.stateService.target('login');
	    }
	  }, { priority: 10 });

	  // Hook to forbid access to pages requiring users with privileges. PRIORITY: 10
	  $transitions.onFinish({ to: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    if (!Auth.isAuthorized(_lodash2.default.get(transition.$to(), 'data.authorization', null), transition.params())) {
	      return transition.router.stateService.target('efimob.unauthorized');
	    }
	  }, { priority: 10 });

	  // Hook to redirect users with no roles. PRIORITY: 9
	  $transitions.onFinish({ to: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    if (!$rootScope.role && transition.$to().name !== 'efimob.no-roles' && transition.$to().name !== 'efimob.profile') {
	      return transition.router.stateService.target('efimob.no-roles');
	    }
	  }, { priority: 9 });

	  // Hook to redirect parent abstract states to one of its children (based in data.redirect)
	  $transitions.onSuccess({ to: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    var redirect = _lodash2.default.get(transition.$to(), 'data.redirect', null);
	    if (redirect && redirect[transition.$to().name]) {
	      $state.go(redirect[transition.$to().name], transition.params());
	    }
	  }, { priority: 5 });

	  // Alias params
	  $transitions.onFinish({ to: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    var params = angular.extend({}, transition.params());
	    var redirect = false;
	    // zona
	    if (params.hasOwnProperty('group') && angular.isUndefined(params.group) && params.hasOwnProperty('zona') && params.zona) {
	      params.group = params.zona;
	      redirect = true;
	    }
	    if (redirect) return transition.router.stateService.target(transition.to(), params);
	  }, { priority: 4 });

	  // // // Infer missing params
	  $transitions.onFinish({ to: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    var params = angular.extend({}, transition.params());
	    var redirect = false;
	    // organization
	    if (params.hasOwnProperty('organization') && angular.isUndefined(params.organization)) {
	      if ($rootScope.role && $rootScope.role.organization) {
	        params.organization = $rootScope.role.organization;
	        redirect = true;
	      }
	    }
	    // group
	    if (params.hasOwnProperty('group') && angular.isUndefined(params.group)) {
	      if ($rootScope.role && $rootScope.role.entity === 'group') {
	        params.group = $rootScope.role.id;
	        params.groupName = $rootScope.role.groupName;
	        redirect = true;
	      }
	    }
	    if (redirect) return transition.router.stateService.target(transition.to(), params);
	    // provider's fav organization
	    if ($rootScope.role && $rootScope.role.entity === 'provider') {
	      if (params.hasOwnProperty('organization') && params.organization) {
	        LocalStorage.setProviderOrganization(params.organization);
	        $rootScope.providerOrganization = params.organization;
	      }
	    }
	  }, { priority: 3 });

	  // PUSH TO APP.BACK
	  $transitions.onSuccess({ to: 'efimob.**' }, function (transition) {
	    if (isHidden) {
	      return transition.abort();
	    }
	    var toState = transition.$to();
	    var fromState = transition.$from();
	    var back = _lodash2.default.get(fromState, 'data.back', null);
	    if (back) {
	      // If 'from' state has 'back' data, it is a candidate to be saved in the stack
	      var toPush = true;
	      var redirect = _lodash2.default.get(toState, 'data.redirect', null);
	      if (redirect && redirect[toState.name] == fromState.name) {
	        // But we won't push it if 'to' state is going to redirect to current 'from' state
	        toPush = false;
	      }
	      if (toPush && fromState.name === toState.name) {
	        // If we are going to remain in the same state, we have to compare params like 'id', 'tab'
	        toPush = false;
	        var diff = _lodash2.default.omit(transition.params('from'), function (v, k) {
	          return transition.params('to')[k] === v;
	        });
	        for (var k in diff) {
	          if (!toState.params[k] || !toState.params[k].isOptional) {
	            // If there is at least one param that differs between 'from' and 'to' that is not optional, then we save 'from' state in the stack (e.g 'id')
	            toPush = false;
	            break;
	          }
	        }
	      }
	      // Avoid to stack when we are using 'goBack' feature
	      if (toPush && App.back.popping) {
	        App.back.popping = null;
	        toPush = false;
	      }
	      if (toPush) {
	        var fromHref = transition.router.stateService.href(fromState.name, transition.params('from'), { absolute: true });
	        App.back.stack.push({
	          href: fromHref,
	          stateName: fromState.name,
	          stateParams: transition.params('from'),
	          data: back,
	          breadcrumsTitle: App.breadcrums.title
	        });
	      }
	    }
	    // Avoid to stack the same page as last stacked (it could happen due to redirections)
	    if (App.back.stack.length > 0) {
	      var lastStacked = App.back.stack[App.back.stack.length - 1];
	      if (toState.name === lastStacked.stateName) {
	        // If last stacked state is the same than 'to' state, then it is candidate to be removed from the stack
	        var toRemove = true;
	        var _diff = _lodash2.default.omit(transition.params('to'), function (v, k) {
	          return lastStacked.stateParams[k] === v;
	        });
	        for (var _k in _diff) {
	          if (!toState.params[_k] || !toState.params[_k].isOptional) {
	            // If there is at least one param that differs between 'to' and last stacked that is not optional, then last state remains in the stack (e.g 'id')
	            toRemove = false;
	            break;
	          }
	        }
	        if (toRemove) App.back.stack.pop();
	      }
	    }
	  });

	  // Hook to redirect to login page if logout
	  var logoutListener = $rootScope.$on('logout', function () {
	    $state.go('login');
	  });

	  // Hook to redirect to home page if role changed
	  var roleChangedListener = $rootScope.$on('role-changed', function () {
	    $state.go('efimob.home');
	  });

	  $rootScope.$on('$destroy', logoutListener, roleChangedListener);
	}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable angular/window-service */

	var COOKIE = exports.COOKIE = {
	  USER: 'efimob.user',
	  ROLE: 'efimob.role',
	  PROVIDER_ORGANIZATION: 'efimob.providerOrganization',
	  APP_MENU_IS_CLOSED: 'efimob.menuIsClosed'
	};

	var VERSION = exports.VERSION = "1.83.0";

	var PRELOADED_TRANSLATIONS = exports.PRELOADED_TRANSLATIONS = preloaded_translations; // eslint-disable-line no-undef

	var e = {
	  PROVIDER: 'efimob',
	  APP: {
	    NAME: 'Ev Manager'
	  },
	  EMAIL: {
	    FROM: 'Efimob Ev Manager <ev-manager@efimob.com>'
	  },
	  LANGS: {
	    SUPPORTED: ['es', 'gl', 'en', 'pt'],
	    PREFERRED: 'auto',
	    FALLBACK: 'es'
	  }
	};

	switch (window.location.hostname) {
	  case 'localhost':
	  case '127.0.0.1':
	    e.ID = 'local';
	    e.NAME = 'Localhost';
	    e.URL = 'http://localhost:8182';
	    e.WEBSOCKET = 'ws://localhost:8182';
	    e.WEBSOCKET_PATH = '/ocpp/api/client';
	    e.MAPS = 'AIzaSyA0FiSa6B5Lo0PDYS7itt8a7fU07IrbABA'; //Vizibles
	    break;
	  case 'evmanager.pre.efimob.net':
	    e.ID = 'pre';
	    e.NAME = 'Pre';
	    e.URL = 'https://api.pre.efimob.net';
	    e.WEBSOCKET = 'wss://api.pre.efimob.net';
	    e.WEBSOCKET_PATH = '/ocpp/api/client';
	    e.MAPS = 'AIzaSyAgT_4IFF4YPutDB2F56PhnBf68B1jJTNU'; //Efimob
	    break;
	  case 'evmon.efimob.net':
	  case 'evmanager.efimob.net':
	  case 'naturgy.efimob.com':
	  default:
	    e.ID = 'production';
	    e.NAME = 'Producción';
	    e.URL = 'https://api.efimob.com';
	    e.WEBSOCKET = 'wss://api.efimob.com';
	    e.WEBSOCKET_PATH = '/ocpp/api/client';
	    e.MAPS = 'AIzaSyAgT_4IFF4YPutDB2F56PhnBf68B1jJTNU'; //Efimob
	    break;
	  case 'app-evmanager.efimob.net':
	  case 'evmanager.users.efimob.net':
	    e.ID = 'app';
	    e.NAME = 'App';
	    e.URL = 'https://api.users.efimob.net'; // api pre users
	    e.WEBSOCKET = 'wss://api.users.efimob.net';
	    e.WEBSOCKET_PATH = '/ocpp/api/client';
	    e.MAPS = 'AIzaSyAgT_4IFF4YPutDB2F56PhnBf68B1jJTNU'; //Efimob
	    break;
	  case 'evmanager.dev.efimob.net':
	  case 'evmanager-dev.efimob.net':
	    e.ID = 'dev';
	    e.NAME = 'Dev';
	    e.URL = 'https://api.dev.efimob.net'; // api dev
	    e.WEBSOCKET = 'wss://api.dev.efimob.net';
	    e.WEBSOCKET_PATH = '/ocpp/api/client';
	    e.MAPS = 'AIzaSyAgT_4IFF4YPutDB2F56PhnBf68B1jJTNU'; //Efimob
	    break;
	  case 'evmanager.tst.efimob.net':
	    e.ID = 'tst';
	    e.NAME = 'Test';
	    e.URL = 'https://api.tst.efimob.net'; // api tst
	    e.WEBSOCKET = 'wss://api.tst.efimob.net';
	    e.WEBSOCKET_PATH = '/ocpp/api/client';
	    e.MAPS = 'AIzaSyAgT_4IFF4YPutDB2F56PhnBf68B1jJTNU'; //Efimob
	    break;
	}

	var ENV = exports.ENV = e;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";

	GlobalFactory.$inject = ["$http", "LocalStorage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GlobalFactory = GlobalFactory;
	function GlobalFactory($http, LocalStorage) {
	    'ngInject';

	    $http.defaults.headers.common["Accept"] = "application/json";
	    $http.defaults.headers.common["Content-Type"] = "application/json";

	    var user = LocalStorage.getUser();
	    if (user && user.token) setDefaultAuthHeader(user.token);

	    function setDefaultAuthHeader(token) {
	        if (!token) delete $http.defaults.headers.common.Authorization;else $http.defaults.headers.common.Authorization = 'Bearer ' + token;
	    }

	    return {
	        setDefaultAuthHeader: setDefaultAuthHeader
	    };
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	'use strict';

	LocalStorageFactory.$inject = ["$cookies", "COOKIE"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LocalStorageFactory = LocalStorageFactory;
	function LocalStorageFactory($cookies, COOKIE) {
	    'ngInject';

	    function setUser(user) {
	        $cookies.putObject(COOKIE.USER, user);
	    }

	    function getUser() {
	        return $cookies.getObject(COOKIE.USER);
	    }

	    function deleteUser() {
	        $cookies.remove(COOKIE.USER);
	    }

	    function setRole(role) {
	        $cookies.putObject(COOKIE.ROLE, role);
	    }

	    function getRole() {
	        return $cookies.getObject(COOKIE.ROLE);
	    }

	    function deleteRole() {
	        $cookies.remove(COOKIE.ROLE);
	    }

	    function setProviderOrganization(providerOrganization) {
	        $cookies.put(COOKIE.PROVIDER_ORGANIZATION, providerOrganization);
	    }

	    function getProviderOrganization() {
	        return $cookies.get(COOKIE.PROVIDER_ORGANIZATION);
	    }

	    function deleteProviderOrganization() {
	        $cookies.remove(COOKIE.PROVIDER_ORGANIZATION);
	    }

	    function setMenuIsClosed(menuIsClosed) {
	        $cookies.put(COOKIE.APP_MENU_IS_CLOSED, menuIsClosed);
	    }

	    function getMenuIsClosed() {
	        return $cookies.get(COOKIE.APP_MENU_IS_CLOSED) === 'true';
	    }

	    function deleteMenuIsClosed() {
	        $cookies.remove(COOKIE.APP_MENU_IS_CLOSED);
	    }

	    function clearAll() {
	        $cookies.remove(COOKIE.USER);
	        $cookies.remove(COOKIE.ROLE);
	        $cookies.remove(COOKIE.PROVIDER_ORGANIZATION);
	        $cookies.remove(COOKIE.APP_MENU_IS_CLOSED);
	    }

	    return {
	        setUser: setUser, getUser: getUser, deleteUser: deleteUser,
	        setRole: setRole, getRole: getRole, deleteRole: deleteRole,
	        setProviderOrganization: setProviderOrganization, getProviderOrganization: getProviderOrganization, deleteProviderOrganization: deleteProviderOrganization,
	        setMenuIsClosed: setMenuIsClosed, getMenuIsClosed: getMenuIsClosed, deleteMenuIsClosed: deleteMenuIsClosed,
	        clearAll: clearAll
	    };
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _utils = __webpack_require__(12);

	var _utils2 = _interopRequireDefault(_utils);

	var _validator = __webpack_require__(13);

	var _validator2 = _interopRequireDefault(_validator);

	var _unitConversion = __webpack_require__(14);

	var _unitConversion2 = _interopRequireDefault(_unitConversion);

	var _utils3 = __webpack_require__(15);

	var _utils4 = _interopRequireDefault(_utils3);

	var _priceComponentCost = __webpack_require__(16);

	var _priceComponentCost2 = _interopRequireDefault(_priceComponentCost);

	var _widgetPropertiesEditor = __webpack_require__(17);

	var _widgetPropertiesEditor2 = _interopRequireDefault(_widgetPropertiesEditor);

	var _widgetTree = __webpack_require__(18);

	var _widgetTree2 = _interopRequireDefault(_widgetTree);

	var _widgetSwitch = __webpack_require__(19);

	var _widgetSwitch2 = _interopRequireDefault(_widgetSwitch);

	var _richTextComponent = __webpack_require__(20);

	var _richTextComponent2 = _interopRequireDefault(_richTextComponent);

	var _selectComponent = __webpack_require__(21);

	var _selectComponent2 = _interopRequireDefault(_selectComponent);

	var _selectWithInputComponent = __webpack_require__(22);

	var _selectWithInputComponent2 = _interopRequireDefault(_selectWithInputComponent);

	var _selectWithTimeInputComponent = __webpack_require__(23);

	var _selectWithTimeInputComponent2 = _interopRequireDefault(_selectWithTimeInputComponent);

	var _multiSelectComponent = __webpack_require__(24);

	var _multiSelectComponent2 = _interopRequireDefault(_multiSelectComponent);

	var _multiLanguageInputComponent = __webpack_require__(25);

	var _multiLanguageInputComponent2 = _interopRequireDefault(_multiLanguageInputComponent);

	var _agreementInputComponent = __webpack_require__(26);

	var _agreementInputComponent2 = _interopRequireDefault(_agreementInputComponent);

	var _locationsTableComponent = __webpack_require__(27);

	var _locationsTableComponent2 = _interopRequireDefault(_locationsTableComponent);

	var _dualListComponent = __webpack_require__(28);

	var _dualListComponent2 = _interopRequireDefault(_dualListComponent);

	var _infiniteScroll = __webpack_require__(29);

	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);

	var _charts = __webpack_require__(30);

	var _charts2 = _interopRequireDefault(_charts);

	var _uploadFile = __webpack_require__(161);

	var _uploadFile2 = _interopRequireDefault(_uploadFile);

	var _widgetFilters = __webpack_require__(162);

	var _widgetTable = __webpack_require__(163);

	var _widgetSearchAutocomplete = __webpack_require__(164);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('directives', ['ui.tree', 'rzModule', _utils2.default, _validator2.default, _unitConversion2.default, _utils4.default, _priceComponentCost2.default, _widgetPropertiesEditor2.default, _widgetTree2.default, _widgetSwitch2.default, _richTextComponent2.default, _selectComponent2.default, _selectWithInputComponent2.default, _selectWithTimeInputComponent2.default, _multiSelectComponent2.default, _multiLanguageInputComponent2.default, _agreementInputComponent2.default, _locationsTableComponent2.default, _dualListComponent2.default, _charts2.default, _uploadFile2.default, _infiniteScroll2.default]).directive('widgetFilters', _widgetFilters.widgetFilters).directive('widgetTable', _widgetTable.widgetTable).directive('widgetSearchAutocomplete', _widgetSearchAutocomplete.widgetSearchAutocomplete).name;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// import * as MarkerClusterer from '@google/markerclusterer'

	exports.default = angular.module('utils', []).directive('toggle', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            // Hack that lets a [data-toggle=collapse] know if its bound .collapse container is collapsed or not
	            if (attrs['toggle'] == 'collapse') {
	                var $ul = angular.element(element).next();
	                if ($ul.hasClass('collapse')) {
	                    scope.$watch(function () {
	                        return $ul.hasClass('in');
	                    }, function (newValue, oldValue) {
	                        if (newValue === true || newValue === false) {
	                            angular.element(element).attr('aria-expanded', newValue);
	                        }
	                        if (newValue === true && oldValue === false) {
	                            angular.element('.collapse.in').collapse('show');
	                        }
	                    });
	                }
	            }

	            // Hack to close the other .collapse containers
	            if (attrs['toggle'] == 'collapse' || attrs['toggle'] == 'collapse-anyway') {
	                element.bind('click', function () {
	                    var element = angular.element('.collapse');
	                    if (element.collapse) element.collapse('hide');
	                });
	            }
	        }
	    };
	}).directive('openSubmenu', ["App", "$timeout", function (App, $timeout) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var submenu = attrs['openSubmenu'];
	            if (submenu) {
	                if (!App.submenu[submenu]) App.submenu[submenu] = { open: false };

	                element.bind('mouseover', function () {
	                    App.submenu._lastOpen = submenu;
	                    App.submenu._lastEntered = null;
	                    App.submenu[submenu].open = true;
	                    scope.$apply();
	                });
	                element.bind('mouseleave', function () {
	                    $timeout(function () {
	                        if (App.submenu._lastEntered !== submenu) App.submenu[submenu].open = false;
	                        scope.$apply();
	                    }, 0);
	                });
	            }
	        }
	    };
	}]).directive('submenu', ["$timeout", "App", function ($timeout, App) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var submenu = attrs['submenu'];
	            element.bind('mouseover', function () {
	                App.submenu._lastEntered = submenu;
	                App.submenu[submenu].open = true;
	                scope.$apply();
	            });
	            element.bind('mouseleave', function () {
	                $timeout(function () {
	                    if (App.submenu._lastEntered === submenu) {
	                        App.submenu[submenu].open = false;
	                        var levels = submenu.split('-');
	                        if (levels.length >= 2) {
	                            App.submenu[levels[0]].open = false;
	                        }
	                    }
	                    if (App.submenu._lastOpen.indexOf(submenu) != 0) {
	                        App.submenu[submenu].open = false;
	                    }
	                    scope.$apply();
	                }, 50);
	            });
	        }
	    };
	}]).directive('rightPanel', ["App", function (App) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {

	            function updateClass() {
	                if (App.rightPanel.closed) angular.element(element).addClass('closed');else angular.element(element).removeClass('closed');
	            }

	            element.bind('click', function () {
	                App.openRightPanel();
	                updateClass();
	            });

	            var toggler = angular.element('<span class="toggler"></span>');
	            toggler.bind('click', function ($event) {
	                App.toggleRightPanel();
	                updateClass();
	                $event.stopPropagation();
	            });
	            element.append(toggler);

	            updateClass();
	        }
	    };
	}])

	// Thanks to: https://stackoverflow.com/questions/19726179/how-to-make-ng-bind-html-compile-angularjs-code
	.directive('bindHtmlCompile', ["$compile", "$sanitize", function ($compile, $sanitize) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            scope.$watch(function () {
	                return scope.$eval(attrs.bindHtmlCompile);
	            }, function (value) {
	                // Prevent HTML and XSS injections
	                var safe = $sanitize(value);
	                // Prevent client-side template injections
	                if (attrs.trustCsti !== 'true' && safe.includes('{{')) {
	                    safe = '<ng-container ng-non-bindable>' + safe + '</ng-container>';
	                    // uib-tooltip will not work in this case so we use native title as fallback
	                    safe = safe.replace(/uib-tooltip/g, 'title');
	                }
	                element.html(safe);
	                $compile(element.contents())(scope);
	            });
	        }
	    };
	}]).directive('stopPropagationOnAnchor', ["$document", "$timeout", "$state", "$urlService", function ($document, $timeout, $state, $urlService) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            $timeout(function () {
	                var anchors = element[0].querySelectorAll('a[href]');
	                if (anchors.length > 0) {
	                    angular.element(anchors).bind('click', function (event) {
	                        if (!event.target.attributes['href'].value || event.target.attributes['href'].value.length <= 0) return;
	                        // We need to get the target state and params coded in href
	                        // Reference: https://github.com/angular-ui/ui-router/issues/2166
	                        // First use a temporary anchor element in order to use its enhanced url parser
	                        var parser = $document[0].createElement('a');
	                        parser.href = event.target.attributes['href'].value;
	                        // Then, use Angular UI's match to get required state name and params, and go to it
	                        var rule = $urlService.match({ path: parser.pathname, search: parser.search, hash: parser.hash });
	                        // Finally, go to the href using state.go in order to track current state into back stack
	                        $state.go(rule.rule.state.name, rule.match);
	                        // And prevent event for doing nothing more
	                        event.stopPropagation();
	                        event.preventDefault();
	                    });
	                }
	            }, 400);
	        }
	    };
	}])

	// Tooltips using tippy.js
	// .directive('title', () => {
	//     return {
	//         restrict: 'A',
	//         link: (scope, element) => {
	//             tippy(element[0]);
	//         }
	//     }
	// })

	// Auto select all text in an input when receive focus
	.directive('autoSelectAll', ["$window", function ($window) {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.on('focus', function () {
	                // Arrow function doesn't work, the context is necessary
	                if (!$window.getSelection().toString()) {
	                    // Required for mobile Safari
	                    this.setSelectionRange(0, this.value.length);
	                }
	            });
	        }
	    };
	}])

	// Auto focus on condition (usually the same as in ng-show)
	.directive('autofocusOn', ["$timeout", function ($timeout) {
	    return function (scope, element, attrs) {
	        scope.$watch(attrs.autofocusOn, function (newValue) {
	            return $timeout(function () {
	                return newValue && element[0].focus();
	            });
	        }, true);
	    };
	}]).directive('widgetSlider', function () {
	    return {
	        template: '<rzslider ng-if="model" class="custom-slider single" rz-slider-model="model" rz-slider-options="slider"></rzslider>' + '<rzslider ng-if="range" class="custom-slider double" rz-slider-model="range.min" rz-slider-high="range.max" rz-slider-options="slider"></rzslider>',

	        scope: {
	            model: '=?',
	            range: '=?',
	            slider: '=params',
	            onChange: '&'
	        },
	        controller: ["$scope", "$rootScope", "App", "$timeout", function controller($scope, $rootScope, App, $timeout) {
	            $scope.id = App.getUID('slider');
	            $scope._render = function () {
	                $rootScope.$broadcast('rzSliderForceRender');
	            };
	            $timeout($scope._render, 0);
	            $scope.$watch('slider', function () {
	                if ($scope.slider) {
	                    $scope.slider['onEnd'] = function () {
	                        if ($scope.onChange()) $scope.onChange()();
	                    };
	                }
	            });
	        }]
	    };
	}).directive('widgetTabs', function () {
	    return {
	        template: '<ul class="nav nav-tabs" ng-show="(tabs.list.length>0)" ng-class="{left: tabs.left}">' + '<li ng-repeat="tab in tabs.list" ng-show="!tab.hide" ng-class="{active: tabs.active.id==tab.id}" ng-mouseenter="_onTabMouseEnter(tab)" ng-mouseleave="_onTabMouseLeave(tab)"><a ng-click="tabs.active=tab">{{tab.display}}<span ng-show="(tab.count !== null && tab.count !== undefined)" class="count">{{tab.count(tab)}}</span></a></li>' + '</ul>',

	        scope: {
	            tabs: '=params',
	            onTabMouse: '&'
	        },
	        controller: ["$scope", "$state", function controller($scope, $state) {
	            $scope._onTabMouseEnter = function (tab) {
	                if ($scope.onTabMouse()) $scope.onTabMouse()('enter', tab);
	            };
	            $scope._onTabMouseLeave = function (tab) {
	                if ($scope.onTabMouse()) $scope.onTabMouse()('leave', tab);
	            };
	            $scope.$watch('tabs.active', function () {
	                if ($scope.tabs.active) {
	                    $state.go('.', { 'tab': $scope.tabs.active.url });
	                }
	            });
	        }]
	    };
	}).directive('widgetMap', ["$document", "$filter", function ($document, $filter) {
	    return {
	        template: '<div id="{{id}}" class="map"></div>',
	        scope: {
	            options: '=params',
	            points: '=items',
	            onItemClick: '&',
	            onReload: '&'
	        },
	        controller: ["$scope", "App", "angularLoad", "$timeout", "$log", function controller($scope, App, angularLoad, $timeout, $log) {
	            $scope.id = App.getUID('map');
	            $scope.map = null;
	            $scope.defaultCenter = { 'lat': 0, 'lng': 0 };
	            $scope.defaultZoom = 12;
	            $scope.defaultMaxZoom = 20;
	            $scope.markers = [];
	            $scope.picker = null;
	            $scope.mapWasHidden = false;

	            function onReady(done) {
	                angularLoad.loadScript('https://maps.googleapis.com/maps/api/js?key=' + $scope.options.key).then(function () {
	                    if ($document[0].getElementById($scope.id)) return done();
	                    $timeout(function () {
	                        return onReady(done);
	                    }, 50);
	                }).catch(function () {
	                    $log.log('Google Maps failed!');
	                });
	            }

	            onReady(function () {
	                $scope.map = new google.maps.Map($document[0].getElementById($scope.id), {
	                    center: $scope.defaultCenter,
	                    zoom: $scope.defaultZoom,
	                    maxZoom: $scope.options.maxZoom || $scope.defaultMaxZoom,
	                    disableDefaultUI: true,
	                    fullscreenControl: true,
	                    zoomControl: true
	                });

	                $scope.markerClusterer = new MarkerClusterer($scope.map, [], { gridSize: 32, imagePath: '../../assets/images/markerclusterer/m', averageCenter: true });

	                if ($scope.options.pick) {
	                    google.maps.event.addListener($scope.map, 'bounds_changed', function () {
	                        if ($scope.map.getDiv().offsetParent === null) {
	                            $scope.mapWasHidden = true;
	                        } else {
	                            var reFit = $scope.mapWasHidden;
	                            $scope.mapWasHidden = false;
	                            if (reFit) $scope.autoFit();
	                        }
	                    });
	                }
	                $scope.reload();
	            });

	            $scope.autoFit = function () {
	                if (_lodash2.default.isArray($scope.points)) {
	                    var total = 0;
	                    // Center in the middle of points
	                    var bounds = new google.maps.LatLngBounds();
	                    _lodash2.default.each($scope.points, function (point) {
	                        if (point && point.location && (point.location.latitude || point.location.longitude)) {
	                            bounds.extend(new google.maps.LatLng({ lat: point.location.latitude, lng: point.location.longitude }));
	                            total++;
	                        }
	                    });
	                    if (total > 0) {
	                        $scope.map.fitBounds(bounds);
	                        if (total == 1) google.maps.event.addListenerOnce($scope.map, 'idle', function () {
	                            return $scope.map.setZoom($scope.defaultZoom);
	                        });
	                    }
	                }
	                if ($scope.options.pick) {
	                    var pickerPosition = { latitude: $scope.options.pick.latitude, longitude: $scope.options.pick.longitude };
	                    bounds = new google.maps.LatLngBounds(null);
	                    bounds.extend(new google.maps.LatLng({ lat: pickerPosition.latitude, lng: pickerPosition.longitude }));
	                    $scope.map.setCenter(bounds.getCenter());
	                    $scope.map.setZoom($scope.defaultZoom);
	                    $scope.map.fitBounds(bounds, 20);
	                }
	            };

	            $scope.clearMarkers = function () {
	                _lodash2.default.each($scope.markers, function (marker) {
	                    marker.setMap(null);
	                });
	                $scope.markers = [];
	                if ($scope.markerClusterer) $scope.markerClusterer.clearMarkers();
	            };

	            $scope.reload = function () {
	                if (!$scope.map) return;
	                // Markers
	                $scope.clearMarkers();
	                if (_lodash2.default.isArray($scope.points)) {
	                    _lodash2.default.each($scope.points, function (point) {
	                        if (point && point.location && (point.location.latitude || point.location.longitude)) {
	                            var marker = new google.maps.Marker({
	                                map: $scope.map,
	                                animation: google.maps.Animation.DROP,
	                                position: { lat: point.location.latitude, lng: point.location.longitude },
	                                // title: point.name,
	                                icon: _lodash2.default.get($scope.options, 'marker.icon', undefined),
	                                custom: { point: point }
	                            });
	                            var infowindow = new google.maps.InfoWindow({
	                                content: '<div><accent><strong>' + $filter('safe')(point.name) + '</strong></accent></div>'
	                            });
	                            marker.addListener('mouseover', function () {
	                                infowindow.open($scope.map, marker);
	                            });
	                            marker.addListener('mouseout', function () {
	                                infowindow.close();
	                            });
	                            marker.addListener('click', function () {
	                                if ($scope.onItemClick() && marker.custom && marker.custom.point) $scope.onItemClick()(marker.custom.point);
	                            });
	                            $scope.markers.push(marker);
	                        }
	                    });

	                    $scope.markerClusterer.addMarkers($scope.markers);
	                }

	                // picker
	                if ($scope.options.pick && angular.isDefined($scope.options.pick.latitude) && angular.isDefined($scope.options.pick.longitude)) {

	                    if ($scope.options.pick.latitude == null || $scope.options.pick.longitude == null) {
	                        var center = $scope.map.getCenter();
	                        $scope.options.pick.latitude = center.lat();
	                        $scope.options.pick.longitude = center.lng();
	                        $timeout(function () {
	                            $scope.$apply();
	                        }, 0);
	                    }

	                    $scope.picker = new google.maps.Marker({
	                        map: $scope.map,
	                        draggable: true,
	                        animation: google.maps.Animation.DROP,
	                        position: { lat: $scope.options.pick.latitude, lng: $scope.options.pick.longitude },
	                        // title: point.name,
	                        icon: _lodash2.default.get($scope.options, 'marker.icon', undefined)
	                        // custom: { point: point }
	                    });

	                    $scope.picker.addListener('drag' /* 'dragend'*/, function () {
	                        $scope.options.pick.latitude = $scope.picker.getPosition().lat();
	                        $scope.options.pick.longitude = $scope.picker.getPosition().lng();
	                        $scope.$apply();
	                    });
	                }
	                $timeout(function () {
	                    $scope.autoFit();
	                }, 100);
	            };

	            $scope.$watchCollection('points', function () {
	                $scope.reload();
	            });

	            if ($scope.options.pick) {

	                $scope.$watch('options.pick.latitude', function (lat) {
	                    if (!$scope.picker) return;
	                    var position = $scope.picker.getPosition();
	                    if (position.lat() != lat) {
	                        $scope.picker.setPosition({ lat: lat, lng: position.lng() });
	                    }
	                });

	                $scope.$watch('options.pick.longitude', function (lng) {
	                    if (!$scope.picker) return;
	                    var position = $scope.picker.getPosition();
	                    if (position.lng() != lng) {
	                        $scope.picker.setPosition({ lat: position.lat(), lng: lng });
	                    }
	                });
	            }
	        }]
	    };
	}]).directive('widgetSelector', function () {
	    return {
	        template: '<div id="{{id}}" class="selector">' + '<a ng-repeat="item in selector.list" ng-class="{active: (item.id===model)}" ng-click="_setValue(item.id)">{{item.display}}</a>' + '</div>',

	        scope: {
	            model: '=',
	            selector: '=params'
	        },
	        controller: ["$scope", "App", function controller($scope, App) {
	            $scope.id = App.getUID('selector');
	            $scope._setValue = function (value) {
	                $scope.model = value;
	            };
	            $scope.$watch('model', function () {
	                if ($scope.model) {
	                    //$log.log('SELECTOR %s value: %s', $scope.id, $scope.model);
	                }
	            });
	        }]
	    };
	}).directive('myEnter', function () {
	    return function (scope, element, attrs) {
	        element.bind("keydown keypress", function (event) {
	            if (event.which === 13) {
	                scope.$apply(function () {
	                    scope.$eval(attrs.myEnter);
	                });

	                event.preventDefault();
	            }
	        });
	    };
	}).directive('focusMe', function () {
	    return {
	        link: function link(scope, element, attrs) {
	            scope.$watch(attrs.focusMe, function (value) {
	                if (value === true) {
	                    element[0].focus();
	                    element[0].select();
	                }
	            });
	        }
	    };
	}).directive('onlyNumbers', function () {
	    return {
	        restrict: 'A',
	        link: function link(_, element) {
	            element.on('keypress', function (event) {
	                var char = String.fromCharCode(event.which || event.keyCode);
	                if (!/[0-9]/.test(char)) {
	                    event.preventDefault();
	                }
	            });
	        }
	    };
	}).directive('decimalNumber', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var precision = Number(attrs.decimalNumber) || 2;
	            element.on('keypress', function (event) {
	                var char = String.fromCharCode(event.which || event.keyCode);
	                var regex = new RegExp('^[0-9]+\\.?[0-9]{0,' + precision + '}$');
	                if (!regex.test('' + element.val() + char)) {
	                    event.preventDefault();
	                }
	            });
	        }
	    };
	}).directive('mdAutocompleteFocusOpen', ["$timeout", function ($timeout) {
	    return {
	        restrict: 'A',
	        require: 'mdAutocomplete',
	        link: function link(scope, element, attrs, mdAutocompleteCtrl) {
	            $timeout(function waitForInput() {
	                var input = element.find('input');
	                if (!input || !input.length) {
	                    return $timeout(waitForInput, 50);
	                }

	                function triggerAutocomplete() {
	                    var value = mdAutocompleteCtrl.scope.searchText || '';
	                    mdAutocompleteCtrl.scope.searchText = value + ' ';
	                    $timeout(function () {
	                        mdAutocompleteCtrl.scope.searchText = value;
	                    });
	                }

	                input.on('focus', triggerAutocomplete);
	                input.on('click', triggerAutocomplete);

	                scope.$on('$destroy', function () {
	                    input.off('focus', triggerAutocomplete);
	                    input.off('click', triggerAutocomplete);
	                });
	            });
	        }
	    };
	}]).directive('recalculatePrice', ["Utils", function (Utils) {
	    return {
	        restrict: 'A',
	        scope: {
	            sourcePrice: '=',
	            vat: '=',
	            targetPrice: '=',
	            operation: '@'
	        },
	        link: function link(scope) {
	            function recalculate() {
	                if (scope.sourcePrice == null || scope.vat == null) {
	                    return;
	                }
	                switch (scope.operation) {
	                    case 'withoutVat':
	                        scope.targetPrice = Utils.calculatePriceWithoutVat(scope.sourcePrice, scope.vat);
	                        break;
	                    case 'withVat':
	                        scope.targetPrice = Utils.calculatePriceWithVat(scope.sourcePrice, scope.vat);
	                        break;
	                }
	            }
	            scope.$watchGroup(['sourcePrice', 'vat'], recalculate);
	        }
	    };
	}]).name; /*global google, MarkerClusterer*/

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('validatorDirective', []).directive('timetableValidator', function () {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      var timeRangeRegex = /^([01]\d|2[0-3]):[0-5]\d-([01]\d|2[0-3]):[0-5]\d$/;
	      ngModel.$validators.timetableValidator = function (value) {
	        return !value || timeRangeRegex.test(value);
	      };
	      attrs.$observe('timetableValidator', function () {
	        ngModel.$validate();
	      });
	    }
	  };
	}).directive('emailValidator', function () {
	  var emailRegex = /^[^@]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      ngModel.$validators.emailValidator = function (value) {
	        if (!value) {
	          return true;
	        }
	        return emailRegex.test(value || '');
	      };
	    }
	  };
	}).directive('durationValidator', function () {
	  return {
	    require: 'ngModel',
	    scope: {
	      minDuration: '=',
	      maxDuration: '='
	    },
	    link: function link(scope, elem, attrs, ngModel) {
	      function isPositiveInteger(value) {
	        return Number.isInteger(value) && value >= 0;
	      }

	      function isRangeValid(min, max) {
	        return isPositiveInteger(min) && isPositiveInteger(max) && min < max;
	      }

	      function validate() {
	        var min = scope.minDuration;
	        var max = scope.maxDuration;
	        var isValid = true;
	        if (!_lodash2.default.isNumber(min) || !isPositiveInteger(min)) {
	          isValid = false;
	        }
	        if (_lodash2.default.isNumber(max)) {
	          isValid = isRangeValid(min, max);
	        }
	        ngModel.$setValidity('durationValidator', isValid);
	      }

	      scope.$watchGroup(['minDuration', 'maxDuration'], validate);
	    }
	  };
	}).directive('energyValidator', function () {
	  return {
	    require: 'ngModel',
	    scope: {
	      minWh: '=',
	      maxWh: '='
	    },
	    link: function link(scope, elem, attrs, ngModel) {
	      function isPositiveInteger(value) {
	        return Number.isInteger(value) && value >= 0;
	      }

	      function isRangeValid(min, max) {
	        return isPositiveInteger(min) && isPositiveInteger(max) && min < max;
	      }

	      function validate() {
	        var min = scope.minWh;
	        var max = scope.maxWh;
	        var isValid = true;
	        if (!_lodash2.default.isNumber(min) || !isPositiveInteger(min)) {
	          isValid = false;
	        }
	        if (_lodash2.default.isNumber(max)) {
	          isValid = isRangeValid(min, max);
	        }
	        ngModel.$setValidity('energyValidator', isValid);
	      }

	      scope.$watchGroup(['minWh', 'maxWh'], validate);
	    }
	  };
	}).directive('hourRangeValidator', function () {
	  return {
	    link: function link(scope) {
	      function validateHourRange(value) {
	        if (!value) {
	          return false;
	        }

	        if (!value.hasOwnProperty('min') || !value.hasOwnProperty('max')) {
	          return false;
	        }

	        var isSameTime = value.min === value.max;
	        return !isSameTime;
	      }

	      scope.$watch('modal.startEndTimeSlider.value', function (newValue) {
	        var isValid = validateHourRange(newValue);
	        scope.modal.hourRangeValid = isValid;
	        scope.$emit('hourRangeValidated', isValid);
	      }, true);
	    }
	  };
	}).directive('daysOfWeekValidator', function () {
	  return {
	    link: function link(scope) {
	      function validateDaysOfWeek(value) {
	        return value.length > 0;
	      }
	      scope.$watch('modal.daysOfWeek', function (newValue) {
	        var isValid = validateDaysOfWeek(newValue);
	        scope.modal.daysOfWeekValid = isValid;
	        scope.$emit('daysOfWeekValidated', isValid);
	      }, true);
	    }
	  };
	}).directive('priceComponentsValidator', function () {
	  return {
	    link: function link(scope) {

	      function isPositiveNumber(value) {
	        return Number.isInteger(value) && value >= 0;
	      }

	      function validateVAT(vatValue) {
	        if (_lodash2.default.isNull(vatValue)) {
	          return true;
	        }

	        var num = parseFloat(vatValue);
	        if (isNaN(num)) {
	          return false;
	        }

	        if (!isPositiveNumber(num)) {
	          return false;
	        }

	        if (num < 0 || num > 100) {
	          return false;
	        }

	        var decimals = (num.toString().split('.')[1] || '').length;
	        if (decimals > 3) {
	          return false;
	        }

	        return true;
	      }

	      function validatePriceComponents(priceComponents) {
	        var isValid = false;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;

	        try {
	          var _loop = function _loop() {
	            var priceComponent = _step.value;

	            isValid = Object.keys(priceComponent).every(function (key) {
	              if (key === 'vat') {
	                return validateVAT(priceComponent.vat);
	              }
	              return ![null, undefined, ''].includes(priceComponent[key]);
	            });
	            if (!isValid) {
	              return 'break';
	            }
	          };

	          for (var _iterator = priceComponents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _ret = _loop();

	            if (_ret === 'break') break;
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }

	        return isValid;
	      }
	      scope.$watch('modal.restriction.priceComponents', function (newValue) {
	        var isValid = validatePriceComponents(newValue);
	        scope.modal.priceComponentsValid = isValid;
	        scope.$emit('priceComponentsValidated', isValid);
	      }, true);
	    }
	  };
	}).name;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('unitConversionDirective', []).directive('whToKwh', function () {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      // model → view (Wh → kWh)
	      ngModel.$formatters.push(function (value) {
	        return value / 1000;
	      });
	      // view → model (kWh → Wh)
	      ngModel.$parsers.push(function (value) {
	        return value * 1000;
	      });
	    }
	  };
	}).directive('whToKwhNullable', function () {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      // model → view (Wh → kWh)
	      ngModel.$formatters.push(function (value) {
	        if (_lodash2.default.isNil(value) || value === '') return null;
	        return value / 1000;
	      });

	      // view → model (kWh → Wh)
	      ngModel.$parsers.push(function (value) {
	        if (_lodash2.default.isNil(value) || value === '' || isNaN(value)) return null;
	        return value * 1000;
	      });
	    }
	  };
	}).directive('whToKwhAutocomplete', ['$parse', function ($parse) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var modelExpr = attrs.whToKwhAutocomplete;
	      var searchExpr = attrs.mdSearchText;

	      if (!modelExpr || !searchExpr) {
	        return;
	      }

	      var modelGetter = $parse(modelExpr);
	      var modelSetter = $parse(modelExpr).assign;
	      var searchSetter = $parse(searchExpr).assign;

	      // model → view (Wh → kWh)
	      scope.$watch(modelExpr, function (value) {
	        var aux = parseInt(value);
	        if (!Number.isNaN(aux)) {
	          searchSetter(scope, (aux / 1000).toString());
	        }
	      });

	      // view → model (kWh → Wh)
	      scope.$watch(searchExpr, function (value) {
	        var aux = parseInt(value);
	        if (!Number.isNaN(aux)) {
	          modelSetter(scope, aux * 1000);
	        } else {
	          modelSetter(scope, null);
	        }
	      });

	      // INIT view → model (kWh → Wh)
	      var value = modelGetter(scope);
	      var aux = parseInt(value);
	      if (value != null && !Number.isNaN(aux)) {
	        searchSetter(scope, (aux / 1000).toString());
	      } else {
	        searchSetter(scope, value);
	      }
	    }
	  };
	}]).directive('sToMin', function () {
	  return {
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      // model → view (s → min)
	      ngModel.$formatters.push(function (value) {
	        return value / 60;
	      });
	      // view → model (min → s)
	      ngModel.$parsers.push(function (value) {
	        return value * 60;
	      });
	    }
	  };
	}).directive('sToMinAutocomplete', ['$parse', function ($parse) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var modelExpr = attrs.sToMinAutocomplete;
	      var searchExpr = attrs.mdSearchText;

	      if (!modelExpr || !searchExpr) {
	        return;
	      }

	      var modelGetter = $parse(modelExpr);
	      var modelSetter = $parse(modelExpr).assign;
	      var searchSetter = $parse(searchExpr).assign;

	      // model → view (s → min)
	      scope.$watch(modelExpr, function (value) {
	        var aux = parseInt(value);
	        if (!Number.isNaN(aux)) {
	          searchSetter(scope, (aux / 60).toString());
	        }
	      });

	      // view → model (min → s)
	      scope.$watch(searchExpr, function (value) {
	        var aux = parseInt(value);
	        if (!Number.isNaN(aux)) {
	          modelSetter(scope, aux * 60);
	        } else {
	          modelSetter(scope, null);
	        }
	      });

	      // INIT view → model (min → s)
	      var value = modelGetter(scope);
	      var aux = parseInt(value);
	      if (value != null && !Number.isNaN(aux)) {
	        searchSetter(scope, (aux / 60).toString());
	      } else {
	        searchSetter(scope, value);
	      }
	    }
	  };
	}]).name;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('tariffUtilsDirective', []).directive('gracePeriodModel', function () {
	  return {
	    require: 'ngModel',
	    scope: {
	      type: '@gracePeriodModel'
	    },
	    link: function link(scope, element, attrs, ngModel) {
	      function getEntry(list) {
	        return (list || []).find(function (e) {
	          return e.type === scope.type;
	        });
	      }

	      // model → view
	      ngModel.$formatters.push(function (list) {
	        var entry = getEntry(list);
	        return entry ? entry.value : 0;
	      });

	      // view → model
	      ngModel.$parsers.push(function (value) {
	        var list = ngModel.$modelValue || [];
	        var entry = getEntry(list);
	        if (!entry) {
	          entry = { type: scope.type, value: value };
	          list = list.concat(entry);
	        } else {
	          entry.value = value;
	        }
	        return list;
	      });
	    }
	  };
	}).directive('vatAutocomplete', ['$parse', function ($parse) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var modelExpr = attrs.vatAutocomplete;
	      var searchExpr = attrs.mdSearchText;

	      if (!modelExpr || !searchExpr) {
	        return;
	      }

	      var modelGetter = $parse(modelExpr);
	      var modelSetter = $parse(modelExpr).assign;
	      var searchSetter = $parse(searchExpr).assign;

	      // model → view
	      scope.$watch(modelExpr, function (value) {
	        var aux = parseInt(value);
	        if (!Number.isNaN(aux)) {
	          searchSetter(scope, aux.toString());
	        } else if (attrs.vatNoTaxesText) {
	          searchSetter(scope, attrs.vatNoTaxesText);
	        }
	      });

	      // view → model
	      scope.$watch(searchExpr, function (value) {
	        var aux = parseInt(value);
	        if (!Number.isNaN(aux)) {
	          modelSetter(scope, aux);
	        } else {
	          modelSetter(scope, null);
	        }
	      });

	      // INIT view → model
	      var value = modelGetter(scope);
	      var aux = parseInt(value);
	      if (value != null && !Number.isNaN(aux)) {
	        searchSetter(scope, aux.toString());
	      } else {
	        searchSetter(scope, value);
	      }
	    }
	  };
	}]).directive('resetOnTypeChange', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModel) {
	      scope.$watch('priceComponent.type', function (value, oldValue) {
	        if (value !== oldValue) {
	          ngModel.$setViewValue(0);
	          ngModel.$render();
	        }
	      });
	    }
	  };
	}).directive('clearDurationOnDisable', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope) {
	      scope.$watch('modal.withDuration', function (newValue, oldValue) {
	        if (!_lodash2.default.isUndefined(newValue) && newValue !== oldValue) {
	          if (newValue === false) {
	            scope.modal.restriction.minDuration = null;
	            scope.modal.restriction.maxDuration = null;
	          }
	        }
	      });
	    }
	  };
	}).directive('clearEnergyOnDisable', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope) {
	      scope.$watch('modal.withEnergy', function (newValue, oldValue) {
	        if (!_lodash2.default.isUndefined(newValue) && newValue !== oldValue) {
	          if (newValue === false) {
	            scope.modal.restriction.minWh = null;
	            scope.modal.restriction.maxWh = null;
	          }
	        }
	      });
	    }
	  };
	}).directive('recalculatePriceWithoutVat', ["Utils", function (Utils) {
	  return {
	    restrict: 'A',
	    link: function link(scope) {
	      scope.$watch('priceComponent.priceWithVat', function (newValue, oldValue) {
	        if (newValue !== oldValue && scope.priceComponent) {
	          scope.priceComponent.price = Utils.calculatePriceWithoutVat(newValue, scope.priceComponent.vat);
	        }
	      });

	      scope.$watch('priceComponent.vat', function (newValue, oldValue) {
	        if (newValue !== oldValue && scope.priceComponent) {
	          scope.priceComponent.price = Utils.calculatePriceWithoutVat(scope.priceComponent.priceWithVat, newValue);
	        }
	      });
	    }
	  };
	}]).directive('priceAdapter', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    scope: {
	      conversionFactor: '@priceAdapter'
	    },
	    link: function link(scope, _, attrs, ngModel) {
	      // Initial price adapter
	      $timeout(function () {
	        var factor = parseFloat(scope.conversionFactor) || 1;
	        var value = ngModel.$modelValue;
	        if (!isNaN(value)) {
	          var price = value / factor;
	          ngModel.$setViewValue(price);
	          ngModel.$render();
	          scope.$emit('price:ready', price);
	        }
	      });

	      // Destroy price adapter
	      scope.$on('$destroy', function () {
	        var factor = parseFloat(scope.conversionFactor) || 1;
	        var value = ngModel.$viewValue;
	        if (!isNaN(value)) {
	          ngModel.$setViewValue(value * factor);
	        }
	      });
	    }
	  };
	}]).directive('priceWithVatInitializer', ["Utils", function (Utils) {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, _, attrs, ngModel) {
	      scope.$on('price:ready', function (_, value) {
	        var price = value;
	        var vat = scope.priceComponent.vat;
	        var priceWithVat = Utils.calculatePriceWithVat(price, vat, 1e3);
	        ngModel.$setViewValue(priceWithVat);
	        ngModel.$render();
	      });
	    }
	  };
	}]).name;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var PriceComponentCostController = function () {
	  PriceComponentCostController.$inject = ["$translate"];
	  function PriceComponentCostController($translate) {
	    'ngInject';

	    _classCallCheck(this, PriceComponentCostController);

	    this.$translate = $translate;
	    this.typeMap = [];
	  }

	  _createClass(PriceComponentCostController, [{
	    key: 'initType',
	    value: function initType(priceComponent) {
	      return this.priceComponentTypeOptions.find(function (option) {
	        return option.id === priceComponent.type;
	      });
	    }
	  }, {
	    key: 'typeChanged',
	    value: function typeChanged(priceComponentTypeOption, priceComponent) {
	      priceComponent.type = priceComponentTypeOption.id;
	    }
	  }, {
	    key: 'isTypeAvailable',
	    value: function isTypeAvailable(option, currentComponent) {
	      return this.priceComponents.every(function (pc) {
	        return pc === currentComponent || pc.type !== option.id;
	      });
	    }
	  }, {
	    key: 'inputChanged',
	    value: function inputChanged(item, index) {
	      if (this.onInputChange()) {
	        this.onInputChange()({ item: item, index: index });
	      }
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(index) {
	      this.priceComponents.splice(index, 1);
	      this.typeMap.splice(index, 1);
	    }
	  }, {
	    key: 'addItem',
	    value: function addItem() {
	      var _this = this;

	      var priceComponent = _lodash2.default.cloneDeep(this.defaultPriceComponent);
	      var availablePriceComponentTypeOption = this.priceComponentTypeOptions.find(function (option) {
	        return _this.isTypeAvailable(option, priceComponent);
	      });
	      priceComponent.type = availablePriceComponentTypeOption.id;
	      this.priceComponents.push(priceComponent);
	    }
	  }, {
	    key: 'getConversionFactor',
	    value: function getConversionFactor(type) {
	      var conversionFactor = {
	        TIME: 60,
	        ENERGY: 1,
	        FLAT: 1
	      };
	      return conversionFactor[type] || 1;
	    }
	  }]);

	  return PriceComponentCostController;
	}();

	exports.default = angular.module('priceComponentCost', []).directive('priceComponentCost', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/views/tariff/directives/price-component-cost/price-component-cost.html',
	    scope: {
	      priceComponents: '=',
	      defaultPriceComponent: '=',
	      priceComponentTypeOptions: '=',
	      priceComponentVatOptions: '='
	    },
	    controller: ["$translate", function controller($translate) {
	      return new PriceComponentCostController($translate);
	    }],
	    controllerAs: 'ctrl',
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WidgetPropertiesController = function () {
	    WidgetPropertiesController.$inject = ["$scope", "$translate", "App", "$timeout"];
	    function WidgetPropertiesController($scope, $translate, App, $timeout) {
	        'ngInject';

	        _classCallCheck(this, WidgetPropertiesController);

	        this.$scope = $scope;
	        this.$translate = $translate;
	        this.App = App;
	        this.$timeout = $timeout;
	        this.onEdition = false;
	        this.addingProperty = false;
	        this.keyToAdd = null;
	        this.confirmed = [];
	        this.dataItem = null;
	    }

	    _createClass(WidgetPropertiesController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;

	            this.$scope.$watch('ctrl.enabled', function () {
	                _this.editionEnabled = _lodash2.default.isUndefined(_this.enabled) ? true : _this.enabled;
	                if (!_this.editionEnabled) {
	                    _this.onEdition = false;
	                }
	            });
	            this.$scope.$watch('ctrl.properties', function () {
	                if (_this.properties) {
	                    _this.properties['controls'] = {
	                        'enterEdition': function enterEdition() {
	                            return _this._enterEdition();
	                        }
	                    };
	                    _this.reloadKeys();
	                }
	            });

	            this.$scope.$watch('ctrl.item', function () {
	                if (_this.item) {
	                    _this.dataItem = _this.path != undefined ? _this.item[_this.path] : _this.item;
	                    _this.reloadKeys();
	                }
	            });
	            this.$scope.$watch('ctrl.onEdition', function () {
	                return _this.properties && _this.properties.controls ? _this.properties.controls.onEdition = _this.onEdition : null;
	            });
	        }
	    }, {
	        key: 'reloadKeys',
	        value: function reloadKeys() {
	            var _this2 = this;

	            if (this.properties.keys) {
	                if (this.properties.canAdmin && !this.properties.canAdmin()) {
	                    this._keys = _lodash2.default.filter(this.properties.keys, function (key) {
	                        return !_this2._isKeyOnlyAdmin(key);
	                    });
	                    this._headers = _lodash2.default.filter(this.properties.headers, function (header, idx) {
	                        return !_this2._isKeyOnlyAdmin(_this2.properties.keys[idx]);
	                    });
	                } else {
	                    this._keys = this.properties.keys;
	                    this._headers = this.properties.headers;
	                }
	            } else if (_lodash2.default.isArray(this.dataItem)) {
	                this._keys = _lodash2.default.map(this.dataItem, function (property, index) {
	                    return property[_this2.properties.key || 'key'] || index;
	                });
	            } else {
	                this._keys = _lodash2.default.keys(this.dataItem) || [];
	            }
	        }
	    }, {
	        key: 'getIndex',
	        value: function getIndex(key) {
	            if (!_lodash2.default.isArray(this.dataItem)) return null;
	            return _lodash2.default.findIndex(this.dataItem, [this.properties.key || 'key', key]);
	        }
	    }, {
	        key: '_getValueForView',
	        value: function _getValueForView(key, index) {
	            var response = "<span class=&quot;empty&quot;>--</span>";
	            var value = this._getValue(key, index);
	            if (value) {
	                if (_lodash2.default.isArray(value)) {
	                    if (value.length != 0) {
	                        response = value;
	                    }
	                } else {
	                    response = value;
	                }
	            }
	            return response;
	        }
	    }, {
	        key: '_getValue',
	        value: function _getValue(key, index, unfiltered) {
	            if (_lodash2.default.isArray(this.dataItem)) {
	                if (angular.isDefined(index)) index = this.getIndex(key);
	                return this.dataItem[index][this.properties.value || 'value'];
	            }
	            return this.$scope.$eval(unfiltered ? this.App.onlyKey(key) : key, this.dataItem);
	        }
	    }, {
	        key: '_getHeader',
	        value: function _getHeader(key, index) {
	            if (_lodash2.default.isArray(this._headers) && this._headers.length > index) return this._headers[index];

	            return this.App.onlyKey(key);
	        }
	    }, {
	        key: '_isEditable',
	        value: function _isEditable() {
	            var _properties = this.properties,
	                isEditableFlagOnly = _properties.isEditableFlagOnly,
	                editable = _properties.editable;


	            if (isEditableFlagOnly) {
	                return this.editionEnabled === true;
	            }

	            if (editable === true) {
	                return true;
	            }

	            return _lodash2.default.isArray(editable) && editable.length > 0;
	        }
	    }, {
	        key: '_getKeyInfo',
	        value: function _getKeyInfo(key) {
	            if (!key) return undefined;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['info'] ? this.properties.meta[this.App.onlyKey(key)]['info'] : undefined;
	        }
	    }, {
	        key: '_getKeyHelp',
	        value: function _getKeyHelp(key) {
	            if (!key) return undefined;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['help'] ? this.properties.meta[this.App.onlyKey(key)]['help'] : undefined;
	        }
	    }, {
	        key: '_getKeyWarn',
	        value: function _getKeyWarn(key) {
	            if (!key) return undefined;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['warn'] ? this.properties.meta[this.App.onlyKey(key)]['warn'] : undefined;
	        }
	    }, {
	        key: '_getKeyType',
	        value: function _getKeyType(key) {
	            if (!key) return 'text';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['type']) return this.properties.meta[this.App.onlyKey(key)]['type'];
	            return 'text';
	        }
	    }, {
	        key: '_getMin',
	        value: function _getMin(key) {
	            if (!key) return '';
	            var meta = this.properties.meta;
	            if (meta && meta[this.App.onlyKey(key)] && !_lodash2.default.isNil(meta[this.App.onlyKey(key)]['min'])) return meta[this.App.onlyKey(key)]['min'];
	            return '';
	        }
	    }, {
	        key: '_getMax',
	        value: function _getMax(key) {
	            if (!key) return '';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['max']) return this.properties.meta[this.App.onlyKey(key)]['max'];
	            return '';
	        }
	    }, {
	        key: '_getChipValidate',
	        value: function _getChipValidate(key, item) {
	            if (!key) return '';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['validate']) {
	                return this.properties.meta[this.App.onlyKey(key)]['validate'](item, this.properties.meta[this.App.onlyKey(key)], this.input[this._keys.indexOf(key)].value);
	            }
	            return '';
	        }
	    }, {
	        key: '_getChipDelete',
	        value: function _getChipDelete(key) {
	            if (!key) return '';
	            if (!this.input[this._keys.indexOf(key)].value) {
	                this.input[this._keys.indexOf(key)].value = [];
	            }
	        }
	    }, {
	        key: '_getStep',
	        value: function _getStep(key) {
	            if (!key) return '';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['step']) return this.properties.meta[this.App.onlyKey(key)]['step'];
	            return '';
	        }
	    }, {
	        key: '_getOnChange',
	        value: function _getOnChange(key, model) {
	            if (!key) return '';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['onChange']) {
	                return this.properties.meta[this.App.onlyKey(key)]['onChange']({ model: model }, this.properties.meta[this.App.onlyKey(key)], this.input);
	            }
	            return '';
	        }
	    }, {
	        key: '_getKeyRequired',
	        value: function _getKeyRequired(key) {
	            if (!key) return false;
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['required']) {
	                return this.properties.meta[this.App.onlyKey(key)]['required'];
	            }
	            return false;
	        }
	    }, {
	        key: '_getKeyOptions',
	        value: function _getKeyOptions(key) {
	            if (!key) return undefined;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['options'] ? this.properties.meta[this.App.onlyKey(key)]['options'] : [];
	        }
	    }, {
	        key: '_getKeyOptionsField',
	        value: function _getKeyOptionsField(key) {
	            if (!key) return undefined;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['optionsField'] ? this.properties.meta[this.App.onlyKey(key)]['optionsField'] : 'display';
	        }
	    }, {
	        key: '_getConflictMessage',
	        value: function _getConflictMessage(key) {
	            if (!key) return '';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['conflict']) {
	                return this.properties.meta[this.App.onlyKey(key)]['conflict']['message'];
	            }
	            return '';
	        }
	    }, {
	        key: '_getConflictData',
	        value: function _getConflictData(key) {
	            if (!key) return '';
	            if (this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['conflict']) {
	                return this.properties.meta[this.App.onlyKey(key)]['conflict']['data'];
	            }
	            return '';
	        }
	    }, {
	        key: '_showHTMLPreview',
	        value: function _showHTMLPreview(content) {
	            this.$scope.modal = {
	                content: content
	            };
	            this.App.openModal(this.$scope, 'preview-html.html', { 'size': 'lg' });
	        }
	    }, {
	        key: '_isKeyRemovable',
	        value: function _isKeyRemovable(key) {
	            if (!key) return false;
	            if (this.added && this.added[key]) return true;
	            if (_lodash2.default.isArray(this.properties.removable) && this.properties.removable.indexOf(this.App.onlyKey(key)) >= 0) return true;
	            return this.properties.removeItems;
	        }
	    }, {
	        key: '_isKeyEditable',
	        value: function _isKeyEditable(key) {
	            if (!key) return false;
	            if (this.added && this.added[key]) return true;
	            if (this.properties.isKeyEditable) return this.properties.isKeyEditable(key, _lodash2.default.isArray(this.dataItem) ? this.dataItem[this.getIndex(key)] : undefined);
	            if (this.properties.isKeyRestricted) {
	                var isKeyRestricted = this.properties.isKeyRestricted(this.App.onlyKey(key));
	                if (isKeyRestricted != undefined) return isKeyRestricted;
	            }
	            if (this.properties.editable === true) return true;
	            if (_lodash2.default.isArray(this.properties.editable) && this.properties.editable.indexOf(this.App.onlyKey(key)) >= 0) return true;
	            return false;
	        }
	    }, {
	        key: '_isKeyOnlyAdmin',
	        value: function _isKeyOnlyAdmin(key) {
	            if (!key) return false;
	            if (this.added && this.added[key]) return false;
	            if (this.properties.onlyAdmin === true) return true;
	            if (_lodash2.default.isArray(this.properties.onlyAdmin) && this.properties.onlyAdmin.indexOf(this.App.onlyKey(key)) >= 0) return true;
	            return false;
	        }
	    }, {
	        key: '_propertyChanged',
	        value: function _propertyChanged(property) {
	            var response = false;
	            if (this.added[property.key]) {
	                response = !this.removed[property.key];
	            } else {
	                var itemValue;
	                if (_lodash2.default.isArray(this.dataItem)) {
	                    itemValue = this.dataItem[this.getIndex(property.key)][this.properties.value || 'value'];
	                } else {
	                    itemValue = this.dataItem[property.key];
	                }
	                response = !angular.equals(this._getKeyAdaptTo(property.key, property.value), itemValue);
	            }
	            return response;
	        }
	    }, {
	        key: 'getChanged',
	        value: function getChanged() {
	            var _this3 = this;

	            var changed = {};
	            _lodash2.default.each(this.input, function (property) {
	                if (_this3._isKeyEditable(property.key) && _this3._propertyChanged(property)) {
	                    if (!_this3.removed[property.key]) changed[property.key] = _this3._getKeyAdaptTo(property.key, property.value);
	                }
	            });
	            return changed;
	        }
	    }, {
	        key: 'getRemoved',
	        value: function getRemoved() {
	            var _this4 = this;

	            return _lodash2.default.filter(_lodash2.default.keys(this.removed), function (keyRemoved) {
	                if (_this4.added[keyRemoved]) return false;
	                return true;
	            });
	        }
	    }, {
	        key: '_askToAdd',
	        value: function _askToAdd() {
	            this.addingProperty = true;
	            this.keyToAdd = '';
	        }
	    }, {
	        key: '_isValidToAdd',
	        value: function _isValidToAdd() {
	            return this.keyToAdd && this.keyToAdd.length > 0 && this._keys.indexOf(this.keyToAdd) < 0;
	        }
	    }, {
	        key: '_discardAdd',
	        value: function _discardAdd() {
	            this.addingProperty = false;
	        }
	    }, {
	        key: '_add',
	        value: function _add(key) {
	            if (!this._isValidToAdd(key)) return;
	            this.addingProperty = false;
	            this.added[key] = true;
	            this.input.push({
	                key: key,
	                value: ''
	            });
	            this._keys.push(key);
	        }
	    }, {
	        key: '_remove',
	        value: function _remove(key) {
	            this.removed[key] = true;
	        }
	    }, {
	        key: '_undoRemove',
	        value: function _undoRemove(key) {
	            delete this.removed[key];
	        }
	    }, {
	        key: '_enterEdition',
	        value: function _enterEdition() {
	            var _this5 = this;

	            if (!this._isEditable()) return;
	            this.added = {};
	            this.removed = {};
	            this.input = [];
	            _lodash2.default.each(this._keys, function (key, index) {
	                var value = _this5._getValue(key, index, true);
	                _this5.input.push({
	                    key: _this5.App.onlyKey(key),
	                    value: _lodash2.default.cloneDeep(_this5._getKeyAdaptFrom(key, value))
	                });
	            });
	            this.onEdition = true;
	        }
	    }, {
	        key: '_cancelEdition',
	        value: function _cancelEdition() {
	            this.reloadKeys();
	            this.onEdition = false;
	        }
	    }, {
	        key: 'onSaveResult',
	        value: function onSaveResult(err) {
	            var _this6 = this;

	            if (err) {
	                var code = _lodash2.default.get(err, 'data.error.code', null) || err.status || null;
	                var errorMessage = _lodash2.default.get(this.properties, 'error.' + code, null) || _lodash2.default.get(this.properties, 'error.default', null);
	                if (!errorMessage) errorMessage = this.$translate.instant('W.PROPS.FAILED') + (code ? ' (' + code + ')' : '');
	                this.App.showNotification(errorMessage, 'error');
	            } else {
	                this.$timeout(function () {
	                    _this6.onEdition = false;
	                    _this6.reloadKeys();
	                });
	            }
	        }
	    }, {
	        key: '_confirmChangedKey',
	        value: function _confirmChangedKey(key) {
	            var _this7 = this;

	            this.confirmed.push(key);
	            this.App.closeModal('dismiss');
	            this.$timeout(function () {
	                return _this7._confirmNext();
	            }, 100);
	        }
	    }, {
	        key: '_getIndexByKey',
	        value: function _getIndexByKey(key) {
	            var _this8 = this;

	            return _lodash2.default.map(this._keys, function (key) {
	                return _this8.App.onlyKey(key);
	            }).indexOf(key);
	        }
	    }, {
	        key: '_interpolateMessage',
	        value: function _interpolateMessage(key, message) {
	            var newValue = this.input[this._getIndexByKey(key)].value;
	            var oldValue = this.dataItem[key];
	            while (message.indexOf('__NEW_VALUE__') >= 0) {
	                message = message.replace('__NEW_VALUE__', newValue);
	            }while (message.indexOf('__OLD_VALUE__') >= 0) {
	                message = message.replace('__OLD_VALUE__', oldValue);
	            }return message;
	        }
	    }, {
	        key: '_confirmNext',
	        value: function _confirmNext() {
	            var changed = this.getChanged();
	            var removed = this.getRemoved();
	            for (var key in changed) {
	                if (_lodash2.default.get(this.properties.confirmationRequired, key) && this.confirmed.indexOf(key) < 0) {
	                    if (this.properties.removedValue && this.properties.removedValue[key] === changed[key]) {
	                        removed.push(key);
	                        continue;
	                    }
	                    this.$scope.modal = {
	                        key: key,
	                        header: this.properties.headers[this._getIndexByKey(key)],
	                        remove: false,
	                        message: this._interpolateMessage(key, _lodash2.default.get(this.properties.confirmationRequired, key).onChanged.message),
	                        warning: this._interpolateMessage(key, _lodash2.default.get(this.properties.confirmationRequired, key).onChanged.warning)
	                    };
	                    this.App.openModal(this.$scope, 'property-changed-confirmation.html', { 'size': 'md' });
	                    return;
	                }
	            }
	            for (var i in removed) {
	                var _key = removed[i];
	                if (_lodash2.default.get(this.properties.confirmationRequired, _key) && this.confirmed.indexOf(_key) < 0) {
	                    this.$scope.modal = {
	                        key: _key,
	                        header: this.properties.headers[this._getIndexByKey(_key)],
	                        remove: true,
	                        message: this._interpolateMessage(_key, _lodash2.default.get(this.properties.confirmationRequired, _key).onRemoved.message),
	                        warning: this._interpolateMessage(_key, _lodash2.default.get(this.properties.confirmationRequired, _key).onRemoved.warning)
	                    };
	                    this.App.openModal(this.$scope, 'property-changed-confirmation.html', { 'size': 'md' });
	                    return;
	                }
	            }
	            this._saveEdition();
	        }
	    }, {
	        key: '_confirmAndSaveEdition',
	        value: function _confirmAndSaveEdition() {
	            this.confirmed = [];
	            this._confirmNext();
	        }
	    }, {
	        key: '_saveEdition',
	        value: function _saveEdition() {
	            var _this9 = this;

	            if (this.properties.onSave) {
	                var changed = this.getChanged();
	                var removed = this.getRemoved();
	                for (var i in removed) {
	                    if (this.properties.removedValue && removed[i] in this.properties.removedValue) {
	                        changed[removed[i]] = this.properties.removedValue[removed[i]];
	                    }
	                }
	                this.properties.onSave({ 'changed': changed, 'removed': removed, 'item': this.dataItem }).then(function () {
	                    return _this9.onSaveResult();
	                }).catch(function (err) {
	                    return _this9.onSaveResult(err);
	                });
	            } else {
	                this.onEdition = false;
	                this.reloadKeys();
	            }
	        }
	    }, {
	        key: '_onlyIf',
	        value: function _onlyIf() {
	            return !this.properties["onlyIf"] || this.properties["onlyIf"](this.item);
	        }
	    }, {
	        key: '_getKeyAdaptFrom',
	        value: function _getKeyAdaptFrom(key, value) {
	            if (!key) return value;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['adaptFrom'] ? this.properties.meta[this.App.onlyKey(key)]['adaptFrom'](value) : value;
	        }
	    }, {
	        key: '_getKeyAdaptTo',
	        value: function _getKeyAdaptTo(key, value) {
	            if (!key) return value;
	            return this.properties.meta && this.properties.meta[this.App.onlyKey(key)] && this.properties.meta[this.App.onlyKey(key)]['adaptTo'] ? this.properties.meta[this.App.onlyKey(key)]['adaptTo'](value) : value;
	        }
	    }, {
	        key: '_isFromValid',
	        value: function _isFromValid() {
	            var valid = true;
	            for (var key in this.properties.meta) {
	                var property = this.properties.meta[key];
	                if (property.conflict && property.conflict.data) {
	                    valid = false;
	                    break;
	                }
	            }
	            return valid;
	        }
	    }]);

	    return WidgetPropertiesController;
	}();

	exports.default = angular.module('widgetPropertiesEditor', []).directive('widgetPropertiesEditor', function () {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/directives/widget-properties-editor/widget-properties-editor.html',
	        scope: {
	            properties: '=params',
	            item: '=item',
	            path: '=path',
	            enabled: '=enabled',
	            onItemClick: '&',
	            onReload: '&'
	        },
	        controller: ["$scope", "$translate", "App", "$timeout", function controller($scope, $translate, App, $timeout) {
	            return new WidgetPropertiesController($scope, $translate, App, $timeout);
	        }],
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).name;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WidgetTreeController = function () {
	    WidgetTreeController.$inject = ["$scope", "$window", "App", "$filter"];
	    function WidgetTreeController($scope, $window, App, $filter) {
	        'ngInject';

	        _classCallCheck(this, WidgetTreeController);

	        this.$scope = $scope;
	        this.$window = $window;
	        this.App = App;
	        this.$filter = $filter;
	    }

	    _createClass(WidgetTreeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;

	            var tree = this.tree;
	            this.$scope.$watchCollection('ctrl.nodes', function () {
	                _this.nodes = _this._order(_this.nodes);
	            });
	            this._dragHandlers = {
	                accept: function accept(sourceNodeScope, destNodesScope) {
	                    if (tree.preventMovingToRoot && typeof destNodesScope.node == 'undefined') return false;
	                    return true;
	                },

	                dropped: function dropped(e) {
	                    var moved = e.source.nodeScope.$modelValue;
	                    var from = e.source.nodesScope.$parent.$modelValue;
	                    var to = e.dest.nodesScope.$parent.$modelValue;
	                    if (tree.onReorder) {
	                        tree.onReorder(moved, from, to);
	                    }
	                }
	            };
	        }
	    }, {
	        key: '_toggle',
	        value: function _toggle(scope) {
	            scope.toggle();
	        }
	    }, {
	        key: '_remove',
	        value: function _remove(scope) {
	            scope.remove();
	        }
	    }, {
	        key: '_collapseAll',
	        value: function _collapseAll() {
	            this.$scope.$broadcast('angular-ui-tree:collapse-all');
	        }
	    }, {
	        key: '_expandAll',
	        value: function _expandAll() {
	            this.$scope.$broadcast('angular-ui-tree:expand-all');
	        }
	    }, {
	        key: '_isSelected',
	        value: function _isSelected(item) {
	            if (!item) return false;
	            return _lodash2.default.includes(this.tree.selected, item[this.tree.id]);
	        }
	    }, {
	        key: '_onItemClick',
	        value: function _onItemClick(item) {
	            if (this.App.isSelectedText()) return;

	            if (this.tree.selectable) {
	                if (this.tree.selectable == 'multi') {
	                    this.tree.selected = _lodash2.default.xor(this.tree.selected, [item[this.tree.id]]);
	                } else {
	                    this.tree.selected = [item[this.tree.id]];
	                }
	            }

	            if (this.onItemClick()) this.onItemClick()(item);
	        }
	    }, {
	        key: '_order',
	        value: function _order(nodes) {
	            var _this2 = this;

	            var items = this.$filter('orderBy')(nodes, 'name');
	            return _lodash2.default.map(items, function (item) {
	                if (item.groups && item.groups.length > 0) {
	                    item.groups = _this2._order(item.groups);
	                }
	                return item;
	            });
	        }
	    }]);

	    return WidgetTreeController;
	}();

	exports.default = angular.module('widgetTree', []).directive('widgetTree', function () {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/directives/widget-tree/widget-tree.html',
	        scope: {
	            tree: '=params',
	            nodes: '=items',
	            onItemClick: '&',
	            onReload: '&'
	        },
	        controller: ["$scope", "$window", "App", "$filter", function controller($scope, $window, App, $filter) {
	            return new WidgetTreeController($scope, $window, App, $filter);
	        }],
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).name;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WidgetSwitchController = function () {
	    WidgetSwitchController.$inject = ["$scope", "App", "$timeout"];
	    function WidgetSwitchController($scope, App, $timeout) {
	        'ngInject';

	        _classCallCheck(this, WidgetSwitchController);

	        this.$scope = $scope;
	        this.$timeout = $timeout;

	        this.id = App.getUID('switch');
	        this._model = this.model;
	        this.disabled = !!this.disabled || false;
	        this._loading = this.loading;
	        this.ignoreChangesTimer = null;
	    }

	    _createClass(WidgetSwitchController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;

	            this.$scope.$watch('ctrl.model', function () {
	                if (_this._loading) return;
	                _this._model = _this.model;
	            });

	            this.$scope.$on('$destroy', function () {
	                return _this.cleanTimer();
	            });

	            this.$scope.$watch('ctrl.loading', function (now) {

	                if (now === true) {
	                    _this._loading = true;
	                }
	                if (now === false) {
	                    _this.cleanTimer();
	                    _this.ignoreChangesTimer = _this.$timeout(function () {
	                        _this._loading = false;
	                        _this._model = _this.model;
	                    }, 1000);
	                }
	            });
	        }
	    }, {
	        key: '_onChange',
	        value: function _onChange() {
	            var _this2 = this;

	            if (!this.onChange()) this.model = this._model;
	            this.$timeout(function () {
	                if (_this2.onChange()) _this2.onChange()(_this2._model, _this2.onChangeArg);
	            }, 0);
	        }
	    }, {
	        key: 'cleanTimer',
	        value: function cleanTimer() {
	            if (this.ignoreChangesTimer) {
	                this.$timeout.cancel(this.ignoreChangesTimer);
	                this.ignoreChangesTimer = null;
	            }
	        }
	    }]);

	    return WidgetSwitchController;
	}();

	exports.default = angular.module('widgetSwitch', []).directive('widgetSwitch', function () {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/directives/widget-switch/widget-switch.html',
	        scope: {
	            model: '=',
	            disabled: '=?',
	            loading: '=?',
	            onChange: '&',
	            onChangeArg: '='
	        },
	        controller: ["$scope", "App", "$timeout", function controller($scope, App, $timeout) {
	            return new WidgetSwitchController($scope, App, $timeout);
	        }],
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).name;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SelectComponentController = function () {
	  SelectComponentController.$inject = ["$scope", "$document"];
	  function SelectComponentController($scope, $document) {
	    'ngInject';

	    _classCallCheck(this, SelectComponentController);

	    this.$scope = $scope;
	    this.$document = $document;
	    this.tinymceOptions = {
	      menubar: false,
	      plugins: '',
	      toolbar: 'formatselect | bold italic | alignleft aligncenter alignright alignjustify'
	    };
	  }

	  _createClass(SelectComponentController, [{
	    key: '_onChange',
	    value: function _onChange() {
	      if (this.hasOwnProperty('onChange')) {
	        this.onChange()(this.item);
	      }
	    }
	  }]);

	  return SelectComponentController;
	}();

	exports.default = angular.module('richTextComponent', []).directive('richTextComponent', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/directives/rich-text/rich-text-component.html',
	    scope: {
	      item: '=',
	      onChange: '&'
	    },
	    controller: ["$scope", "$document", function controller($scope, $document) {
	      return new SelectComponentController($scope, $document);
	    }],
	    controllerAs: 'ctrl',
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SelectComponentController = function () {
	    SelectComponentController.$inject = ["$scope", "$element", "$attrs", "$document", "$mdSelect", "$timeout"];
	    function SelectComponentController($scope, $element, $attrs, $document, $mdSelect, $timeout) {
	        'ngInject';

	        var _this2 = this;

	        _classCallCheck(this, SelectComponentController);

	        var _this = this;
	        this.$scope = $scope;
	        this.$document = $document;
	        this.$timeout = $timeout;
	        this.$mdSelect = $mdSelect;
	        this.searchTerm = '';
	        this.search = $attrs.hasOwnProperty('search');
	        this.pagination = {
	            currentPage: 1,
	            itemsPerPage: 10,
	            totalItems: 0,
	            maxPages: 10
	        };
	        $element.find('input').on('keydown', function (ev) {
	            ev.stopPropagation();
	        });
	        $document[0].addEventListener('click', function (event) {
	            _this2._clickTrick(_this, event);
	        });
	        $element.find('md-content').on('scroll', function () {
	            if (_this.pagination.currentPage * _this.pagination.itemsPerPage < _this.pagination.totalItems) {
	                var element = this;
	                var scrollTop = element.scrollTop;
	                var scrollHeight = element.scrollHeight;
	                var clientHeight = element.clientHeight;
	                if (scrollTop + clientHeight + 2 >= scrollHeight) {
	                    _this.pagination.currentPage++;
	                    _this._onSearch();
	                }
	            }
	        });
	    }

	    _createClass(SelectComponentController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this3 = this;

	            this.$scope.$watch('ctrl.item', function () {
	                _this3.item = _this3.item ? _this3.items.find(function (item) {
	                    return _lodash2.default.isEqual(item, _this3.item);
	                }) || null : null;
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            var _this4 = this;

	            var _this = this;
	            this.$document[0].removeEventListener('click', function (event) {
	                _this4._clickTrick(_this, event);
	            });
	        }
	    }, {
	        key: '_onChange',
	        value: function _onChange() {
	            if (this.onChange()) {
	                this.onChange()(this.item, this.onChangeArg);
	            }
	        }
	    }, {
	        key: '_onSearchAux',
	        value: function _onSearchAux() {
	            var _this = this;
	            this.pagination.currentPage = 1;
	            this.items = [];
	            this.$timeout(function () {
	                _this._onSearch();
	            }, 500);
	        }
	    }, {
	        key: '_onSearch',
	        value: function _onSearch() {
	            var _this5 = this;

	            if (this.onSearch()) {
	                this.onSearch()(this.searchTerm, this.pagination).then(function (data) {
	                    if (data) {
	                        _this5.items = _this5.items.concat(data.docs);
	                        _this5.pagination.currentPage = data.currentPage;
	                        _this5.pagination.totalItems = data.totalItems;
	                    }
	                });
	            }
	        }
	    }, {
	        key: '_clickTrick',
	        value: function _clickTrick(_this, event) {
	            var closeMdSelect = true;
	            var mdSelects = _this.$document[0].getElementsByTagName('md-select');
	            _lodash2.default.forEach(mdSelects, function (mdSelect) {
	                mdSelect = angular.element(mdSelect);
	                if (mdSelect.is(event.target) || mdSelect.has(event.target).length !== 0) {
	                    closeMdSelect = false;
	                    return false;
	                }
	            });
	            if (closeMdSelect) {
	                this.$mdSelect.hide();
	            }
	        }
	    }, {
	        key: '_clearSearchTerm',
	        value: function _clearSearchTerm(id) {
	            this._active(id, false);
	            this.searchTerm = '';
	        }
	    }, {
	        key: '_focusSearchInput',
	        value: function _focusSearchInput(id) {
	            this._active(id, true);
	            var input = this.$document[0].getElementById('input-' + id);
	            if (input) {
	                this.$timeout(function () {
	                    input.focus();
	                }, 500);
	            }
	        }
	    }, {
	        key: '_active',
	        value: function _active(id, option) {
	            var element = this.$document[0].getElementById('select-' + id);
	            if (option) {
	                element.classList.remove("deactivate");
	                element.classList.add("active");
	            } else {
	                element.classList.remove("active");
	                element.classList.add("deactivate");
	            }
	        }
	    }, {
	        key: '_getDisplay',
	        value: function _getDisplay(item) {
	            var result = item;
	            if (this.field && angular.isObject(item)) {
	                result = result[this.field];
	            }
	            if (this.customDisplay()) {
	                result = this.customDisplay()(item);
	            }
	            return result;
	        }
	    }]);

	    return SelectComponentController;
	}();

	exports.default = angular.module('selectComponent', []).directive('selectComponent', function () {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/directives/select/select-component.html',
	        scope: {
	            items: '=',
	            item: '=',
	            field: '=?',
	            customDisplay: '&',
	            onChange: '&',
	            onChangeArg: '=?',
	            onSearch: '&'
	        },
	        controller: ["$scope", "$element", "$attrs", "$document", "$mdSelect", "$timeout", function controller($scope, $element, $attrs, $document, $mdSelect, $timeout) {
	            return new SelectComponentController($scope, $element, $attrs, $document, $mdSelect, $timeout);
	        }],
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).name;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SelectWithInputComponentController = function () {
	  function SelectWithInputComponentController() {
	    "ngInject";

	    _classCallCheck(this, SelectWithInputComponentController);
	  }

	  _createClass(SelectWithInputComponentController, [{
	    key: "selectChanged",
	    value: function selectChanged(list) {
	      if (this.onSelectChange()) {
	        this.onSelectChange()(list);
	      }
	    }
	  }, {
	    key: "inputChanged",
	    value: function inputChanged(item) {
	      if (item[this.secondItem] === null) {
	        item[this.secondItem] = this.getMin();
	      }
	      this._inputChanged(this.list);
	    }
	  }, {
	    key: "removeItem",
	    value: function removeItem(id) {
	      this.list.splice(id, 1);
	      this.selectChanged(this.list);
	      this._inputChanged(this.list);
	    }
	  }, {
	    key: "addItem",
	    value: function addItem() {
	      var _list$push;

	      this.list.push((_list$push = {}, _defineProperty(_list$push, this.firstItem, this.listOptions[0].id), _defineProperty(_list$push, this.secondItem, 100), _list$push));
	      this.selectChanged(this.list);
	      this._inputChanged(this.list);
	    }
	  }, {
	    key: "getMin",
	    value: function getMin() {
	      return !_lodash2.default.isUndefined(this.min) ? this.min : 1;
	    }
	  }, {
	    key: "getMax",
	    value: function getMax() {
	      return !_lodash2.default.isUndefined(this.max) ? this.max : 100;
	    }
	  }, {
	    key: "_inputChanged",
	    value: function _inputChanged(list) {
	      if (this.onInputChange()) {
	        this.onInputChange()(list);
	      }
	    }
	  }]);

	  return SelectWithInputComponentController;
	}();

	exports.default = angular.module("selectWithInputComponent", []).directive("selectWithInputComponent", function () {
	  return {
	    restrict: "E",
	    templateUrl: "app/directives/select-with-input/select-with-input-component.html",
	    scope: {
	      list: "=",
	      listOptions: "=",
	      firstItem: "=",
	      secondItem: "=",
	      secondItemUnit: "=?",
	      min: "=?",
	      max: "=?",
	      onSelectChange: '&',
	      onInputChange: '&'
	    },
	    controller: function controller() {
	      return new SelectWithInputComponentController();
	    },
	    controllerAs: "ctrl",
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SelectWithTimeInputComponentController = function () {
	  function SelectWithTimeInputComponentController() {
	    "ngInject";

	    _classCallCheck(this, SelectWithTimeInputComponentController);
	  }

	  _createClass(SelectWithTimeInputComponentController, [{
	    key: "selectChanged",
	    value: function selectChanged(item, index) {
	      if (this.onSelectChange()) {
	        this.onSelectChange()({ item: item, index: index });
	      }
	    }
	  }, {
	    key: "inputChanged",
	    value: function inputChanged(item, index) {
	      if (this.onInputChange()) {
	        this.onInputChange()({ item: item, index: index });
	      }
	    }
	  }, {
	    key: "removeItem",
	    value: function removeItem(id) {
	      this.list.splice(id, 1);
	      this.selectChanged();
	      this.inputChanged();
	    }
	  }, {
	    key: "addItem",
	    value: function addItem() {
	      var _item;

	      var time = this._getDefaultTime();
	      var item = (_item = {}, _defineProperty(_item, this.firstItem, this.listOptions[0].id), _defineProperty(_item, this.secondItem, time), _defineProperty(_item, this.thirdItem, time), _item);
	      this.list.push(item);
	      //this.selectChanged(this.list);
	      this.inputChanged(item, this.list.length - 1);
	    }
	  }, {
	    key: "_getDefaultTime",
	    value: function _getDefaultTime() {
	      var aux = new Date(0);
	      aux.setHours(0, 0);
	      return aux;
	    }
	  }]);

	  return SelectWithTimeInputComponentController;
	}();

	exports.default = angular.module("selectWithTimeInputComponent", []).directive("selectWithTimeInputComponent", function () {
	  return {
	    restrict: "E",
	    templateUrl: "app/directives/select-with-time-input/select-with-time-input-component.html",
	    scope: {
	      list: "=",
	      listOptions: "=",
	      firstItem: "=",
	      secondItem: "=",
	      thirdItem: "=",
	      onSelectChange: '&',
	      onInputChange: '&'
	    },
	    controller: function controller() {
	      return new SelectWithTimeInputComponentController();
	    },
	    controllerAs: "ctrl",
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MultiSelectComponentController = function () {
	    MultiSelectComponentController.$inject = ["$scope", "$element", "$attrs", "$document", "$mdSelect", "$timeout"];
	    function MultiSelectComponentController($scope, $element, $attrs, $document, $mdSelect, $timeout) {
	        'ngInject';

	        var _this2 = this;

	        _classCallCheck(this, MultiSelectComponentController);

	        var _this = this;
	        this.$scope = $scope;
	        this.$document = $document;
	        this.$timeout = $timeout;
	        this.$mdSelect = $mdSelect;
	        this.searchTerm = '';
	        this.search = $attrs.hasOwnProperty('search');
	        this.pagination = {
	            currentPage: 1,
	            itemsPerPage: 10,
	            totalItems: 0,
	            maxPages: 10
	        };
	        $element.find('input').on('keydown', function (ev) {
	            ev.stopPropagation();
	        });
	        $document[0].addEventListener('click', function (event) {
	            _this2._clickTrick(_this, event);
	        });
	        $element.find('md-content').on('scroll', function () {
	            if (_this.pagination.currentPage * _this.pagination.itemsPerPage < _this.pagination.totalItems) {
	                var element = this;
	                var scrollTop = element.scrollTop;
	                var scrollHeight = element.scrollHeight;
	                var clientHeight = element.clientHeight;
	                if (scrollTop + clientHeight + 2 >= scrollHeight) {
	                    _this.pagination.currentPage++;
	                    _this._onSearch();
	                }
	            }
	        });
	    }

	    _createClass(MultiSelectComponentController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this3 = this;

	            this.item = this.item || [];
	            this.auxItems = [].concat(_toConsumableArray(this.items));
	            this.auxItem = this.auxItems.filter(function (e) {
	                return _this3.item.includes(e.id);
	            });

	            this.$scope.$watchCollection('ctrl.item', function (newVal, oldVal) {
	                if (_lodash2.default.isEqual(newVal, oldVal)) {
	                    return;
	                }

	                if (!_lodash2.default.isArray(_this3.item)) {
	                    _this3.item = [];
	                    return;
	                }

	                if (!_lodash2.default.isArray(_this3.items)) {
	                    return;
	                }

	                var updatedItems = _this3.item.map(function (selectedItem) {
	                    if (!selectedItem) return null;
	                    return _this3.auxItems.find(function (item) {
	                        return item.id && selectedItem.id && item.id === selectedItem.id || item === selectedItem;
	                    }) || selectedItem;
	                }).filter(Boolean);

	                if (updatedItems.length == _this3.item.length && _this3.item.length != _this3.auxItem.length) {
	                    _this3.auxItem = [].concat(_toConsumableArray(_this3.auxItems));
	                } else if (!_lodash2.default.isEqual(updatedItems, _this3.item)) {
	                    _this3.item = updatedItems;
	                }
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            var _this4 = this;

	            var _this = this;
	            this.$document[0].removeEventListener('click', function (event) {
	                _this4._clickTrick(_this, event);
	            });
	        }
	    }, {
	        key: '_onChange',
	        value: function _onChange(data) {
	            if (this.onChange()) {
	                var params = data ? data : this.item;
	                this.onChange()(params);
	            }
	        }
	    }, {
	        key: '_onSearchAux',
	        value: function _onSearchAux() {
	            var _this = this;
	            this.pagination.currentPage = 1;
	            this.items = [];
	            this.$timeout(function () {
	                _this._onSearch();
	            }, 500);
	        }
	    }, {
	        key: '_onSearch',
	        value: function _onSearch() {
	            if (this.onSearch()) {
	                this.onSearch()(this.searchTerm, this.pagination);
	            }
	        }
	    }, {
	        key: '_clickTrick',
	        value: function _clickTrick(_this, event) {
	            var closeMdSelect = true;
	            var mdSelects = _this.$document[0].getElementsByTagName('md-select');
	            _lodash2.default.forEach(mdSelects, function (mdSelect) {
	                mdSelect = angular.element(mdSelect);
	                if (mdSelect.is(event.target) || mdSelect.has(event.target).length !== 0) {
	                    closeMdSelect = false;
	                    return false;
	                }
	            });
	            if (closeMdSelect) {
	                this.$mdSelect.hide();
	            }
	        }
	    }, {
	        key: '_clearSearchTerm',
	        value: function _clearSearchTerm(id) {
	            this._active(id, false);
	            var input = this.$document[0].getElementById('input-' + id);
	            if (input) {
	                input.blur();
	            }
	            this.searchTerm = '';
	        }
	    }, {
	        key: '_focusSearchInput',
	        value: function _focusSearchInput(id) {
	            this._active(id, true);
	            var input = this.$document[0].getElementById('input-' + id);
	            if (input) {
	                this.$timeout(function () {
	                    input.focus();
	                }, 500);
	            }
	        }
	    }, {
	        key: '_active',
	        value: function _active(id, option) {
	            var element = this.$document[0].getElementById('multi-select-component-' + id);
	            if (option) {
	                element.classList.remove("deactivate");
	                element.classList.add("active");
	            } else {
	                element.classList.remove("active");
	                element.classList.add("deactivate");
	            }
	        }
	    }, {
	        key: '_getDisplay',
	        value: function _getDisplay(item) {
	            var result = item;
	            if (this.field && angular.isObject(item)) {
	                result = result[this.field];
	            }
	            if (this.customDisplay()) {
	                result = this.customDisplay()(item);
	            }
	            return result;
	        }
	    }, {
	        key: '_syncSelectedItems',
	        value: function _syncSelectedItems() {
	            var _this5 = this;

	            this.item = this.auxItem.map(function (item) {
	                return item.id;
	            });
	            this.$timeout(function () {
	                _this5._onChange();
	            });
	        }
	    }]);

	    return MultiSelectComponentController;
	}();

	exports.default = angular.module('multiSelectComponent', []).directive('multiSelectComponent', function () {
	    return {
	        restrict: 'E',
	        templateUrl: 'app/directives/multi-select-component/multi-select-component.html',
	        scope: {
	            items: '<',
	            item: '=',
	            field: '=?',
	            customDisplay: '&',
	            onChange: '&',
	            onChangeArg: '=?',
	            onSearch: '&',
	            placeholder: '=?'
	        },
	        controller: ["$scope", "$element", "$attrs", "$document", "$mdSelect", "$timeout", function controller($scope, $element, $attrs, $document, $mdSelect, $timeout) {
	            return new MultiSelectComponentController($scope, $element, $attrs, $document, $mdSelect, $timeout);
	        }],
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).name;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MultiLanguageInputComponentController = function () {
	  MultiLanguageInputComponentController.$inject = ["$scope", "$translate", "App"];
	  function MultiLanguageInputComponentController($scope, $translate, App) {
	    'ngInject';

	    _classCallCheck(this, MultiLanguageInputComponentController);

	    this.$scope = $scope;
	    this.$translate = $translate;
	    this.App = App;

	    this.lang = {
	      option: $translate.use(),
	      options: this.App.getLanguages()
	    };

	    this.localizedTexts = {};
	  }

	  _createClass(MultiLanguageInputComponentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (!_lodash2.default.isEmpty(this.value)) {
	        this.setValue(this.value);
	      }

	      this.updateOutput();
	    }
	  }, {
	    key: 'onLanguageChange',
	    value: function onLanguageChange() {
	      this.currentText = this.localizedTexts[this.lang.option] || '';
	      this.updateOutput();
	    }
	  }, {
	    key: 'onTextChange',
	    value: function onTextChange() {
	      if (this.currentText.length === 0) {
	        delete this.localizedTexts[this.lang.option];
	      } else {
	        this.localizedTexts[this.lang.option] = this.currentText;
	      }
	      this.updateOutput();
	    }
	  }, {
	    key: 'checkEmpty',
	    value: function checkEmpty(lang) {
	      if (this.localizedTexts[lang] === '') {
	        delete this.localizedTexts[lang];
	      }
	    }
	  }, {
	    key: 'updateOutput',
	    value: function updateOutput() {
	      var _this = this;

	      var outputArray = Object.keys(this.localizedTexts).map(function (lang) {
	        return {
	          language: lang,
	          text: _this.localizedTexts[lang]
	        };
	      });

	      this.value = outputArray;
	      if (this.onChange) {
	        this.onChange({ texts: outputArray });
	      }
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(texts) {
	      var _this2 = this;

	      if (_lodash2.default.isArray(texts)) {
	        var indexToDelete = void 0;
	        this.localizedTexts = {};
	        texts.forEach(function (item, index) {
	          _this2.localizedTexts[item.language] = item.text;
	          if (_lodash2.default.isString(item.text) && item.text === '') {
	            indexToDelete = index;
	          }
	        });
	        if (!_lodash2.default.isUndefined(indexToDelete)) {
	          texts.splice(indexToDelete, 1);
	        }
	        this.currentText = this.localizedTexts[this.lang.option] || '';
	      }
	    }
	  }]);

	  return MultiLanguageInputComponentController;
	}();

	exports.default = angular.module('multiLanguageInputComponent', []).directive('multiLanguageInputComponent', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/directives/multi-language-input-component/multi-language-input-component.html',
	    scope: {
	      onChange: '&',
	      value: '=',
	      placeholder: '@'
	    },
	    controller: MultiLanguageInputComponentController,
	    controllerAs: 'ctrl',
	    bindToController: true,
	    link: function link(scope, element, attrs, ctrl) {
	      scope.$watch('ctrl.value', function (newValue) {
	        if (newValue) {
	          ctrl.setValue(newValue);
	        }
	      });
	    }
	  };
	}).name;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgreementInputComponentController = function () {
	  AgreementInputComponentController.$inject = ["$window", "$scope", "$element", "$attrs", "$document", "$mdSelect", "$timeout", "AgreementService"];
	  function AgreementInputComponentController($window, $scope, $element, $attrs, $document, $mdSelect, $timeout, AgreementService) {
	    'ngInject';

	    var _this2 = this;

	    _classCallCheck(this, AgreementInputComponentController);

	    var _this = this;
	    this.$window = $window;
	    this.$scope = $scope;
	    this.$document = $document;
	    this.$timeout = $timeout;
	    this.$mdSelect = $mdSelect;
	    this.AgreementService = AgreementService;
	    this.searchTerm = '';
	    this.search = $attrs.hasOwnProperty('search');
	    this.pagination = {
	      currentPage: 1,
	      itemsPerPage: 10,
	      totalItems: 0,
	      maxPages: 10
	    };

	    $element.find('input').on('keydown', function (ev) {
	      ev.stopPropagation();
	    });

	    $document[0].addEventListener('click', function (event) {
	      _this2._clickTrick(_this, event);
	    });

	    $element.find('md-content').on('scroll', function () {
	      if (_this.pagination.currentPage * _this.pagination.itemsPerPage < _this.pagination.totalItems) {
	        var element = this;
	        var scrollTop = element.scrollTop;
	        var scrollHeight = element.scrollHeight;
	        var clientHeight = element.clientHeight;
	        if (scrollTop + clientHeight + 2 >= scrollHeight) {
	          _this.pagination.currentPage++;
	        }
	      }
	    });
	  }

	  _createClass(AgreementInputComponentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.resizeHandler = this._handleResize.bind(this);
	      this.$window.addEventListener('resize', this.resizeHandler);

	      if (!this.items || this.items.length === 0) {
	        this._loadAgreements();
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      var _this3 = this;

	      var _this = this;
	      this.$document[0].removeEventListener('click', function (event) {
	        _this3._clickTrick(_this, event);
	      });

	      this.$window.removeEventListener('resize', this.resizeHandler);
	    }
	  }, {
	    key: '_handleResize',
	    value: function _handleResize() {
	      this.$mdSelect.hide();
	    }
	  }, {
	    key: '_loadAgreements',
	    value: function _loadAgreements() {
	      var _this4 = this;

	      var options = {
	        organizationId: this.organization,
	        params: { organizationRole: 'cpo' }
	      };

	      this.AgreementService.getAgreements(options).then(function (agreements) {
	        _this4.items = agreements.filter(function (agreement) {
	          return agreement.role === 'emsp';
	        });
	        _this4.item = _this4.items.find(function (item) {
	          return item.id === _this4.value;
	        }) || undefined;
	      });
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange() {
	      if (this.onChange()) {
	        this.onChange()(this.item, this.onChangeArg);
	      }
	    }
	  }, {
	    key: '_clickTrick',
	    value: function _clickTrick(_this, event) {
	      var closeMdSelect = true;
	      var mdSelects = _this.$document[0].getElementsByTagName('md-select');
	      _lodash2.default.forEach(mdSelects, function (mdSelect) {
	        mdSelect = angular.element(mdSelect);
	        if (mdSelect.is(event.target) || mdSelect.has(event.target).length !== 0) {
	          closeMdSelect = false;
	          return false;
	        }
	      });
	      if (closeMdSelect) {
	        this.$mdSelect.hide();
	      }
	    }
	  }, {
	    key: '_clearSearchTerm',
	    value: function _clearSearchTerm(id) {
	      this._active(id, false);
	      this.searchTerm = '';
	    }
	  }, {
	    key: '_focusSearchInput',
	    value: function _focusSearchInput(id) {
	      this._active(id, true);
	      var input = this.$document[0].getElementById('input-' + id);
	      if (input) {
	        this.$timeout(function () {
	          input.focus();
	        }, 500);
	      }
	    }
	  }, {
	    key: '_active',
	    value: function _active(id, option) {
	      var element = this.$document[0].getElementById('agreement-input-component-' + id);
	      if (option) {
	        element.classList.remove('deactivate');
	        element.classList.add('active');
	      } else {
	        element.classList.remove('active');
	        element.classList.add('deactivate');
	      }
	    }
	  }, {
	    key: '_getDisplay',
	    value: function _getDisplay(item) {
	      if (this.customDisplay()) {
	        return this.customDisplay()(item);
	      }
	      return item ? item.organizationName + ' - ' + item.partyId : '';
	    }
	  }]);

	  return AgreementInputComponentController;
	}();

	exports.default = angular.module('agreementInputComponent', []).directive('agreementInputComponent', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/directives/agreement-input-component/agreement-input-component.html',
	    scope: {
	      items: '=?',
	      item: '=?',
	      value: '=',
	      organization: '=?',
	      customDisplay: '&',
	      onChange: '&',
	      onChangeArg: '=?',
	      disabled: '=?',
	      placeholder: '=?'
	    },
	    controller: ["$window", "$scope", "$element", "$attrs", "$document", "$mdSelect", "$timeout", "AgreementService", function controller($window, $scope, $element, $attrs, $document, $mdSelect, $timeout, AgreementService) {
	      return new AgreementInputComponentController($window, $scope, $element, $attrs, $document, $mdSelect, $timeout, AgreementService);
	    }],
	    controllerAs: 'ctrl',
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LocationsTableComponentController = function () {
	  LocationsTableComponentController.$inject = ["App", "$scope", "$state", "$translate", "$filter", "LocationsService", "OperationService"];
	  function LocationsTableComponentController(App, $scope, $state, $translate, $filter, LocationsService, OperationService) {
	    'ngInject';

	    _classCallCheck(this, LocationsTableComponentController);

	    this.App = App;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.LocationsService = LocationsService;
	    this.OperationService = OperationService;

	    this.filters = {};
	    this.filterControls = {};
	    this.table = this.App.getTable('locations');
	    this.locations = [];
	    this.initLocations = [];
	    this.defaultBreadcrumb = [{ label: 'Root', id: null, location: null }];
	    this.breadcrumbs = [];
	    this.enabledBreadcrumbs = true;
	    this.enabledServerRequest = true;
	    this.listeners = {};
	    this.organizationId = null;
	  }

	  _createClass(LocationsTableComponentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.filters = this.App.getTableFilters('locations', { context: this, organizationId: this.data.organizationId });

	      this.initApi();
	      this.initData();

	      this.reloadTable = this.reloadTable.bind(this);
	      this.onChangedFilters = this.onChangedFilters.bind(this);
	      this._onClickLocation = this._onClickLocation.bind(this);
	      this.onClickBreadcrumb = this.onClickBreadcrumb.bind(this);

	      this.reload();
	    }
	  }, {
	    key: 'initApi',
	    value: function initApi() {
	      var _this = this;

	      this.api = this.api || {};
	      this.api.reloadCurrent = this.reloadCurrent.bind(this);
	      this.api.getBreadcrumbs = function () {
	        return _this.breadcrumbs;
	      };
	      this.api.getLocations = function () {
	        return _this.locations;
	      };
	      this.api.removeLocation = function (location) {
	        return _lodash2.default.remove(_this.locations, function (loc) {
	          return loc.id === location.id;
	        });
	      };
	      this.api.getSelectedLocations = function () {
	        return _this.table.selected;
	      };
	      this.listeners = {};
	      this.api.on = function (event, cb) {
	        _this.listeners[event] = _this.listeners[event] || [];
	        _this.listeners[event].push(cb);
	        return function () {
	          _lodash2.default.remove(_this.listeners[event], function (fn) {
	            return fn === cb;
	          });
	        };
	      };
	      this.$scope.$watchCollection('ctrl.table.selected', function () {
	        _this._emit('selectedEvent', _this.table.selected);
	      });
	    }
	  }, {
	    key: 'initData',
	    value: function initData() {
	      var _this2 = this;

	      if ('table' in this.data) {
	        this.updateConfiguration(this.table, this.data.table);
	      }
	      if ('filters' in this.data) {
	        this.updateConfiguration(this.filters, this.data.filters);
	      }
	      if ('enabledBreadcrumbs' in this.data) {
	        this.enabledBreadcrumbs = this.data.enabledBreadcrumbs;
	      }
	      if ('locations' in this.data) {
	        this.locations = this.data.locations;
	        this.enabledServerRequest = false;
	        this.$scope.$watchCollection('ctrl.data.locations', function () {
	          _this2.locations = _this2.data.locations;
	        });
	      }
	      if ('initLocations' in this.data) {
	        this.initLocations = this.data.initLocations;
	      }
	      this.organizationId = this.data.organizationId;
	    }
	  }, {
	    key: 'onClickBreadcrumb',
	    value: function onClickBreadcrumb(crumb) {
	      this.App.setLoading(true);
	      this.clearFilters();
	      if (crumb.location) {
	        this._emit('breadcrumbChanged', crumb.location);
	        this.getLocations(crumb.location.id);
	      } else {
	        this.reload();
	      }
	    }
	  }, {
	    key: 'onChangedFilters',
	    value: function onChangedFilters() {
	      var last = this.getLastLocationFromBreadcrumb();
	      this.getLocations(last.location ? last.location.id : null);
	    }
	  }, {
	    key: '_onClickLocation',
	    value: function _onClickLocation(location) {
	      if (location.isAtomic) {
	        if (this.onClickLocation()) {
	          this.onClickLocation()(location);
	        }
	      } else {
	        this.clearFilters();
	        this.upsertBreadcrumb(location);
	        this.getLocations(location.id);
	      }
	    }
	  }, {
	    key: 'reloadTable',
	    value: function reloadTable() {
	      this.reloadCurrent();
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      this.breadcrumbs = _lodash2.default.cloneDeep(this.defaultBreadcrumb);
	      if (this.initLocations.length > 0) {
	        this.locations = _lodash2.default.cloneDeep(this.initLocations);
	        this.App.setLoading(false);
	      } else {
	        this.getLocations(this.breadcrumbs[0].id);
	      }
	    }
	  }, {
	    key: 'reloadCurrent',
	    value: function reloadCurrent() {
	      var last = this.getLastLocationFromBreadcrumb();
	      if (last && last.location) {
	        this.getLocations(last.location.id);
	      } else {
	        this.reload();
	      }
	    }
	  }, {
	    key: 'upsertBreadcrumb',
	    value: function upsertBreadcrumb(location) {
	      var last = this.getLastLocationFromBreadcrumb();
	      this._emit('breadcrumbChanged', location);
	      if (last && last.id !== location.id) {
	        this.breadcrumbs.push({
	          label: location.name,
	          id: location.id,
	          location: location
	        });
	      }
	    }
	  }, {
	    key: 'clearFilters',
	    value: function clearFilters() {
	      if (this.filterControls['clear']) {
	        this.filterControls['clear']([this.filters[1]]);
	      }
	    }
	  }, {
	    key: 'getLocations',
	    value: function getLocations(locationId) {
	      var _this3 = this;

	      if (!this.enabledServerRequest) {
	        return;
	      }
	      var options = {
	        filters: this.filters,
	        pagination: this.table.pagination,
	        sorting: this.table.sorting,
	        organizationId: this.organizationId,
	        locationId: locationId
	      };
	      this.App.setLoading(true);
	      return this.LocationsService.getLocations(options, true).then(function (data) {
	        _this3.locations = data.docs;
	        _this3.table.pagination.currentPage = data.currentPage;
	        _this3.table.pagination.totalItems = data.totalItems;
	        _this3.App.setLoading(false);
	      }).catch(function () {
	        _this3.locations = [];
	        _this3.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'updateConfiguration',
	    value: function updateConfiguration(current, update) {
	      if (_lodash2.default.isEmpty(update)) {
	        if (_lodash2.default.isArray(current)) {
	          current.length = 0;
	        } else if (_lodash2.default.isObject(current)) {
	          _lodash2.default.forOwn(current, function (v, k) {
	            return delete current[k];
	          });
	        }
	        return;
	      }
	      if (_lodash2.default.isArray(current) && _lodash2.default.isArray(update)) {
	        current.length = 0;
	        current.push.apply(current, _toConsumableArray(update));
	        return;
	      }
	      _lodash2.default.merge(current, update);
	    }
	  }, {
	    key: 'getLastLocationFromBreadcrumb',
	    value: function getLastLocationFromBreadcrumb() {
	      return this.breadcrumbs[this.breadcrumbs.length - 1];
	    }
	  }, {
	    key: '_emit',
	    value: function _emit(event, payload) {
	      (this.listeners[event] || []).forEach(function (cb) {
	        return cb(payload);
	      });
	    }
	  }]);

	  return LocationsTableComponentController;
	}();

	exports.default = angular.module('locationsTableComponent', []).directive('locationsTableComponent', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/directives/locations-table-component/locations-table-component.html',
	    scope: {
	      data: '=',
	      api: '=?',
	      onClickLocation: '&'
	    },
	    controller: ["App", "$scope", "$state", "$translate", "$filter", "LocationsService", "OperationService", function controller(App, $scope, $state, $translate, $filter, LocationsService, OperationService) {
	      return new LocationsTableComponentController(App, $scope, $state, $translate, $filter, LocationsService, OperationService);
	    }],
	    controllerAs: 'ctrl',
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DualListComponentController = function () {
	  DualListComponentController.$inject = ["$scope"];
	  function DualListComponentController($scope) {
	    'ngInject';

	    _classCallCheck(this, DualListComponentController);

	    this.$scope = $scope;

	    this.availableState = this.getState('available');
	    this.assignedState = this.getState('assigned');
	    this.selectedAvailable = null;
	    this.selectedAssigned = null;
	    this.isInternalUpdate = false;
	    this.trackBy = 'id';
	  }

	  _createClass(DualListComponentController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;

	      this.initApi();
	      this.initData();

	      // INFO: It will not be necessary if agreements table is paginated
	      this.availableState.list = _lodash2.default.differenceBy(this.availableState.list, this.assignedState.list, this.trackBy);
	      this.$scope.$watchCollection('ctrl.data.available', function () {
	        if (_this.isInternalUpdate) {
	          _this.isInternalUpdate = false;
	          return;
	        }
	        _this.availableState.list = _lodash2.default.differenceBy(_this.data.available, _this.assignedState.list, _this.trackBy);
	      });

	      this.selectAvailable = this.selectAvailable.bind(this);
	      this.selectAssigned = this.selectAssigned.bind(this);
	      this.isSelected = this.isSelected.bind(this);
	      this.moveSelectedToRight = this.moveSelectedToRight.bind(this);
	      this.moveSelectedToLeft = this.moveSelectedToLeft.bind(this);
	      this.requestMoreAvailableItems = this.requestMoreAvailableItems.bind(this);
	      this.requestMoreAssignedItems = this.requestMoreAssignedItems.bind(this);
	    }
	  }, {
	    key: 'getState',
	    value: function getState(type) {
	      return _lodash2.default.cloneDeep({
	        type: type,
	        list: [],
	        page: 0,
	        loading: false,
	        hasMore: true,
	        enabled: false,
	        title: '',
	        help: ''
	      });
	    }
	  }, {
	    key: 'initApi',
	    value: function initApi() {
	      var _this2 = this;

	      this.api = this.api || {};
	      this.api.getAssigned = function () {
	        return _this2.assignedState.list;
	      };
	    }
	  }, {
	    key: 'initData',
	    value: function initData() {
	      var _this3 = this;

	      this.availableState.list = this.data.available;
	      this.availableState.title = this.data.availableTitle;
	      this.availableState.help = this.data.availableHelp;
	      this.assignedState.list = this.data.assigned;
	      this.assignedState.title = this.data.assignedTitle;
	      this.assignedState.help = this.data.assignedHelp;
	      if ('trackBy' in this.data) {
	        this.trackBy = this.data.trackBy;
	      }
	      if ('requestEnabled' in this.data) {
	        this.availableState.enabled = this.data.requestEnabled;
	        this.assignedState.enabled = this.data.requestEnabled;
	        Promise.all([this.requestMoreItems(this.availableState), this.requestMoreItems(this.assignedState)]).then(function () {
	          _this3.availableState.list = _lodash2.default.differenceBy(_this3.availableState.list, _this3.assignedState.list, _this3.trackBy);
	        });
	      }
	      this.display = function (item) {
	        return _this3.data.display(item);
	      };
	    }
	  }, {
	    key: 'selectAvailable',
	    value: function selectAvailable(contract) {
	      this.selectedAvailable = contract;
	      this.selectedAssigned = null;
	    }
	  }, {
	    key: 'selectAssigned',
	    value: function selectAssigned(contract) {
	      this.selectedAssigned = contract;
	      this.selectedAvailable = null;
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected(contract, listType) {
	      if (listType === 'available') return this.selectedAvailable === contract;
	      if (listType === 'assigned') return this.selectedAssigned === contract;
	      return false;
	    }
	  }, {
	    key: 'moveSelectedToRight',
	    value: function moveSelectedToRight() {
	      var _this4 = this;

	      if (this.selectedAvailable) {
	        this.isInternalUpdate = true;
	        this.assignedState.list.push(this.selectedAvailable);
	        this.availableState.list = this.availableState.list.filter(function (c) {
	          return c[_this4.trackBy] !== _this4.selectedAvailable[_this4.trackBy];
	        });
	        this.selectedAvailable = null;
	      }
	    }
	  }, {
	    key: 'moveSelectedToLeft',
	    value: function moveSelectedToLeft() {
	      var _this5 = this;

	      if (this.selectedAssigned) {
	        this.isInternalUpdate = true;
	        this.availableState.list.push(this.selectedAssigned);
	        this.assignedState.list = this.assignedState.list.filter(function (c) {
	          return c[_this5.trackBy] !== _this5.selectedAssigned[_this5.trackBy];
	        });
	        this.selectedAssigned = null;
	      }
	    }
	  }, {
	    key: 'requestMoreAvailableItems',
	    value: function requestMoreAvailableItems() {
	      return this.requestMoreItems(this.availableState);
	    }
	  }, {
	    key: 'requestMoreAssignedItems',
	    value: function requestMoreAssignedItems() {
	      return this.requestMoreItems(this.assignedState);
	    }
	  }, {
	    key: 'requestMoreItems',
	    value: function requestMoreItems(state) {
	      if (!state.enabled || !state.hasMore || !this.onRequest()) {
	        return;
	      }
	      var nextPage = state.page + 1;
	      state.loading = true;
	      return this.onRequest()(state.type, nextPage).then(function () {
	        var _state$list;

	        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	        if (!items.length) {
	          state.hasMore = false;
	          return;
	        }
	        state.page = nextPage;
	        (_state$list = state.list).push.apply(_state$list, _toConsumableArray(items));
	      }).finally(function () {
	        state.loading = false;
	      });
	    }
	  }]);

	  return DualListComponentController;
	}();

	exports.default = angular.module('dualListComponent', []).directive('dualListComponent', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/directives/dual-list-component/dual-list-component.html',
	    scope: {
	      data: '=',
	      api: '=?',
	      onRequest: '&'
	    },
	    controller: ["$scope", function controller($scope) {
	      return new DualListComponentController($scope);
	    }],
	    controllerAs: 'ctrl',
	    bindToController: true
	  };
	}).name;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('infiniteScroll', []).directive('infiniteScroll', function () {
	  return {
	    restrict: 'A',
	    scope: {
	      infiniteScroll: '&',
	      infiniteScrollDisabled: '=?',
	      infiniteScrollDistance: '=?'
	    },
	    link: function link(scope, element) {
	      var distance = scope.infiniteScrollDistance || 10;
	      function onScroll() {
	        if (scope.infiniteScrollDisabled) return;
	        var el = element[0];
	        var bottomReached = el.scrollTop + el.clientHeight >= el.scrollHeight - distance;
	        if (bottomReached) {
	          scope.$applyAsync(function () {
	            scope.infiniteScroll();
	          });
	        }
	      }
	      element.on('scroll', onScroll);
	      scope.$on('$destroy', function () {
	        element.off('scroll', onScroll);
	      });
	    }
	  };
	}).name;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable angular/window-service */

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _chart = __webpack_require__(31);

	var _chart2 = _interopRequireDefault(_chart);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Chartist = window.Chartist;

	var ChartsCommonService = function () {
	    function ChartsCommonService() {
	        'ngInject';

	        _classCallCheck(this, ChartsCommonService);

	        this.colors = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC'];
	    }

	    _createClass(ChartsCommonService, [{
	        key: "getRandomColor",
	        value: function getRandomColor(label) {
	            var seed = 0;
	            for (var i = 0; i < label.length; i++) {
	                seed += label.charCodeAt(i) * 17;
	            } // a) Generated on hue, saturation, lightness
	            return 'hsl(' + seed % 360 + ', 65%, 45%)';
	            // b) From a curated list
	            // return ChartsCommon.colors[(seed % ChartsCommon.colors.length)];
	        }
	    }, {
	        key: "getRandomColors",
	        value: function getRandomColors(labels) {
	            var _this = this;

	            var colors = [];
	            _lodash2.default.each(labels, function (label) {
	                return colors.push(_this.getRandomColor(label));
	            });
	            return colors;
	        }
	    }]);

	    return ChartsCommonService;
	}();

	var ChartsPieController = function () {
	    ChartsPieController.$inject = ["$scope", "App", "ChartsCommon", "$window", "$timeout", "$document"];
	    function ChartsPieController($scope, App, ChartsCommon, $window, $timeout, $document) {
	        'ngInject';

	        _classCallCheck(this, ChartsPieController);

	        this.$scope = $scope;
	        this.App = App;
	        this.ChartsCommon = ChartsCommon;
	        this.$window = $window;
	        this.$timeout = $timeout;
	        this.$document = $document;

	        this.id = App.getUID('pie');
	        this.hidden = false;
	        this.total = null;
	    }

	    _createClass(ChartsPieController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this2 = this;

	            if (this.data && this.params) this.$timeout(this.onReady.bind(this), 0);

	            this.$scope.$watchCollection('ctrl.data', function () {
	                if (_this2.data) {
	                    _this2.setTotal();
	                    _this2._refresh();
	                    //this.$timeout(this._refresh, 400); // Hack to redraw chart
	                }
	            });
	        }
	    }, {
	        key: "onReady",
	        value: function onReady() {
	            var _this3 = this;

	            var ctx = this.$document[0].getElementById(this.id).getContext('2d');
	            this.chart = new _chart2.default(ctx, {
	                type: 'doughnut',
	                data: {
	                    datasets: [{
	                        data: this.data.series,
	                        backgroundColor: this.params.colors || this.ChartsCommon.colors
	                    }],
	                    labels: this.params.labels
	                },
	                options: {
	                    responsive: false,
	                    aspectRatio: 1.5,
	                    layout: {
	                        padding: {
	                            top: 0, right: 50, bottom: 0, left: 50
	                        }
	                    },
	                    cutoutPercentage: 85,
	                    rotation: -1.0 * Math.PI,
	                    legend: {
	                        display: false,
	                        position: 'top'
	                    },
	                    title: {
	                        display: false,
	                        text: 'Un título'
	                    },
	                    animation: {
	                        animateScale: true,
	                        animateRotate: true
	                    },
	                    onClick: function onClick(e, data) {
	                        if (data && data.length > 0 && _this3.params.onClick) {
	                            _this3.params.onClick(data[0]['_index']);
	                        }
	                    },
	                    onHover: function onHover(e, data) {
	                        if (data && data.length > 0) {
	                            var point = _this3.chart.getElementAtEvent(e);
	                            if (_this3.params.onClick && point.length) return e.target.style.cursor = 'pointer';
	                        }
	                        e.target.style.cursor = 'default';
	                    },
	                    plugins: { labels: false }
	                }
	            });

	            this.$window.addEventListener('resize', function () {
	                if (_this3.chart) {
	                    _this3.chart.resize();
	                }
	            }, true);

	            this._refresh();
	        }
	    }, {
	        key: "_refresh",
	        value: function _refresh() {
	            if (!this.chart || !this.data) return;
	            this.hidden = !this.data.series || !_lodash2.default.isArray(this.data.series) || _lodash2.default.sum(this.data.series) <= 0;

	            if (!this.hidden) {
	                this.chart.data.datasets[0].data = this.data.series;
	                if (this.data.labels) {
	                    this.chart.data.labels = this.data.labels;
	                    if (!this.params.colors) {
	                        this.chart.data.datasets[0].backgroundColor = this.ChartsCommon.getRandomColors(this.data.labels);
	                    }
	                }
	                this.chart.update();
	            }
	        }
	    }, {
	        key: "setTotal",
	        value: function setTotal() {
	            this.total = this.data.series && _lodash2.default.isArray(this.data.series) ? _lodash2.default.sum(this.data.series) : null;
	        }
	    }]);

	    return ChartsPieController;
	}();

	var ChartsBarController = function () {
	    ChartsBarController.$inject = ["$scope", "App", "$timeout"];
	    function ChartsBarController($scope, App, $timeout) {
	        'ngInject';

	        _classCallCheck(this, ChartsBarController);

	        this.$scope = $scope;
	        this.App = App;
	        this.$timeout = $timeout;

	        this.id = App.getUID('bars');
	        this.hidden = false;
	        this.defaults = {
	            fullWidth: true,
	            axisX: {
	                showGrid: false
	            }
	        };
	    }

	    _createClass(ChartsBarController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this4 = this;

	            if (this.data && this.params) this.$timeout(this.onReady.bind(this), 0);
	            this.$scope.$watch('data', function () {
	                if (_this4.data) {
	                    _this4._refresh();
	                }
	            });
	        }
	    }, {
	        key: "onReady",
	        value: function onReady() {
	            var _this5 = this;

	            this.chart = new Chartist.Bar('#' + this.id, this.data, _lodash2.default.defaultsDeep({}, _lodash2.default.get(this.params, 'customOptions', {}), { plugins: [Chartist.plugins.legend(_lodash2.default.defaultsDeep({}, _lodash2.default.get(this.params, 'legend', {})))] }, this.defaults));
	            // Custom colors
	            if (this.params && this.params.colors) {
	                this.chart.on('draw', function (context) {
	                    if (context.type === 'bar') {
	                        context.element.attr({
	                            // style: 'stroke: ' + $scope.params.colors[( $scope.chart.options.stackBars? context.seriesIndex : context.index)] + ';'
	                            style: '' + 'stroke: ' + _this5.params.colors[_this5.chart.options.stackBars ? context.seriesIndex : context.index] + '; ' + 'stroke-width: ' + 50 + 'px; '
	                        });
	                    }
	                });
	            }
	            this._refresh();
	        }
	    }, {
	        key: "_refresh",
	        value: function _refresh() {
	            if (!this.chart || !this.data) return;
	            // $scope.hidden = ($scope.data.series.reduce(function(a,b) {return a+b}) <= 0);
	            if (!this.hidden) this.chart.update(this.data);
	        }
	    }]);

	    return ChartsBarController;
	}();

	exports.default = angular.module('charts', []).service('ChartsCommon', ChartsCommonService).directive('chartPie', function () {
	    return {
	        template: "\n                <div class=\"chart-pie-container\" style=\"width:100%;\">\n                    <span class=\"chart-pie-total\">{{ctrl.total}}</span>\n                    <canvas id=\"{{ctrl.id}}\" style=\"width:100%;\"></canvas>\n                </div>\n            ",
	        scope: {
	            params: '=',
	            data: '='
	        },
	        replace: true,
	        controller: ChartsPieController,
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).directive('chartBar', function () {
	    return {
	        template: "\n                <div ng-show=\"!hidden\" class=\"ct-chart\" id=\"{{ctrl.id}}\"></div>\n                <div ng-show=\"hidden\" class=\"zero-results\">{{ctrl.params.zeroResults || \"\"}}</div>\n            ",
	        scope: {
	            params: '=',
	            data: '='
	        },
	        controller: ChartsBarController,
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}).name;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.8.0
	 * https://www.chartjs.org
	 * (c) 2019 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(32); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';

	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

	/* MIT license */

	var conversions = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,

	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,

	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,

	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,

	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,

	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,

	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,

	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,

	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	};


	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;

	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;

	  h = Math.min(h * 60, 360);

	  if (h < 0)
	    h += 360;

	  l = (min + max) / 2;

	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);

	  return [h, s * 100, l * 100];
	}

	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;

	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;

	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;

	  h = Math.min(h * 60, 360);

	  if (h < 0)
	    h += 360;

	  v = ((max / 255) * 1000) / 10;

	  return [h, s, v];
	}

	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

	  return [h, w * 100, b * 100];
	}

	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;

	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}

	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}

	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;

	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	  return [x * 100, y *100, z * 100];
	}

	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;

	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;

	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);

	  return [l, a, b];
	}

	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}

	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;

	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }

	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;

	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;

	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;

	    rgb[i] = val * 255;
	  }

	  return rgb;
	}

	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;

	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }

	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}

	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}

	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}

	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}


	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;

	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;

	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}

	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;

	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}

	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}

	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}

	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}

	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;

	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }

	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation

	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }

	  return [r * 255, g * 255, b * 255];
	}

	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}

	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}

	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}

	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}

	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;

	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}

	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}

	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}

	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}

	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}


	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;

	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);

	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);

	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);

	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);

	  return [r * 255, g * 255, b * 255];
	}

	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;

	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;

	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);

	  return [l, a, b];
	}

	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}

	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;

	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }

	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

	  return [x, y, z];
	}

	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;

	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}

	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}

	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;

	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}

	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}

	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}

	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}

	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}

	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}

	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}

	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}

	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}

	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}

	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};

	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}

	var convert = function() {
	   return new Converter();
	};

	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);

	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];

	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};

	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword

	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}


	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};

	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }

	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};

	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);

	      this.convs[space] = vals;
	   }
	  return vals;
	};

	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   };
	});

	var colorConvert = convert;

	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

	/* MIT license */


	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,

	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};

	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;

	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }

	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}

	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}

	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}

	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}

	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}

	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}

	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}

	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}

	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}

	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);

	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}

	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}

	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}

	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}

	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}

	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}

	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}

	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}


	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName) {
	   reverseNames[colorName[name]] = name;
	}

	/* MIT license */



	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}

		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};

		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};

	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},

		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},

		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},

		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},

		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},

		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},

		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},

		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}

			return (contrastRatio >= 4.5) ? 'AA' : '';
		},

		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},

		light: function () {
			return !this.dark();
		},

		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},

		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},

		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},

		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},

		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},

		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},

		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},

		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;

			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();

			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;

			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},

		toJSON: function () {
			return this.rgb();
		},

		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;

			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}

			return result;
		}
	};

	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};

	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};

	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};

		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}

		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}

		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};

	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;

		this.valid = true;

		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}

			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];

			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}

			alpha = vals.alpha;
		}

		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

		if (space === 'alpha') {
			return false;
		}

		var capped;

		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}

		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}

		return true;
	};

	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];

		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}

		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}

		this.setValues(space, vals);
		return this;
	};

	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}

		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);

		return this;
	};

	if (typeof window !== 'undefined') {
		window.Color = Color;
	}

	var chartjsColor = Color;

	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},

		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),

		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},

		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},

		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},

		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},

		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},

		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},

		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},

		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},

		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;

			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}

			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];

				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}

			return true;
		},

		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}

			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;

				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}

				return target;
			}

			return source;
		},

		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];

			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},

		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];

			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},

		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;

			if (!helpers.isObject(target)) {
				return target;
			}

			options = options || {};
			merge = options.merger || helpers._merger;

			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}

				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}

			return target;
		},

		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},

		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: function(target) {
			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments[i], setFn);
			}
			return target;
		},

		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};

			var Surrogate = function() {
				this.constructor = ChartElement;
			};

			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;

			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}

			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};

	var helpers_core = helpers;

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;

	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};

	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;

	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},

		easeInQuad: function(t) {
			return t * t;
		},

		easeOutQuad: function(t) {
			return -t * (t - 2);
		},

		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},

		easeInCubic: function(t) {
			return t * t * t;
		},

		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},

		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},

		easeInQuart: function(t) {
			return t * t * t * t;
		},

		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},

		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},

		easeInQuint: function(t) {
			return t * t * t * t * t;
		},

		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},

		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},

		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},

		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},

		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},

		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},

		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},

		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},

		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},

		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},

		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},

		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},

		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},

		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},

		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},

		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},

		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},

		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},

		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};

	var helpers_easing = {
		effects: effects
	};

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;

	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;

	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},

		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;

				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},

		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;

			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}

			if (isNaN(radius) || radius <= 0) {
				return;
			}

			ctx.beginPath();

			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}

			ctx.fill();
			ctx.stroke();
		},

		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},

		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},

		unclipArea: function(ctx) {
			ctx.restore();
		},

		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}

			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}

			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};

	var helpers_canvas = exports$1;

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;

	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};

	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};

	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});

	var core_defaults = defaults;

	var valueOrDefault = helpers_core.valueOrDefault;

	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}

		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}

	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}

			value = +matches[2];

			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}

			return size * value;
		},

		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;

			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}

			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},

		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};

			font.string = toFontString(font);
			return font;
		},

		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;

			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};

	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;

	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];

			target = model[key];

			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}

			actual = view[key];

			if (actual === target || key[0] === '_') {
				continue;
			}

			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}

			origin = start[key];

			type = typeof target;

			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}

			view[key] = target;
		}
	}

	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};

	helpers$1.extend(Element.prototype, {

		initialize: function() {
			this.hidden = false;
		},

		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.clone(me._model);
			}
			me._start = {};
			return me;
		},

		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;

			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}

			if (!view) {
				view = me._view = {};
			}

			if (!start) {
				start = me._start = {};
			}

			interpolate(start, view, model, ease);

			return me;
		},

		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},

		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});

	Element.extend = helpers$1.inherits;

	var core_element = Element;

	var exports$2 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	var core_animation = exports$2;

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$2.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$2.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});

	var core_animations = {
		animations: [],
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;

			me.advance();

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;

			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;

				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);

				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	var resolve = helpers$1.options.resolve;

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers$1.extend(DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null || !(meta.xAxisID in me.chart.scales)) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in me.chart.scales)) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},

		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers$1.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;

			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};

			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	DatasetController.extend = helpers$1.inherits;

	var core_datasetController = DatasetController;

	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});

	var element_arc = core_element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;

			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},

		inRange: function(chartX, chartY) {
			var vm = this._view;

			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;

				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}

				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

				return (betweenAngles && withinRadius);
			}
			return false;
		},

		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},

		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},

		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},

		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var angleMargin;

			ctx.save();

			ctx.beginPath();
			ctx.arc(vm.x, vm.y, Math.max(vm.outerRadius - pixelMargin, 0), sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
			ctx.closePath();

			ctx.fillStyle = vm.backgroundColor;
			ctx.fill();

			if (vm.borderWidth) {
				if (vm.borderAlign === 'inner') {
					// Draw an inner border by cliping the arc and drawing a double-width border
					// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
					ctx.beginPath();
					angleMargin = pixelMargin / vm.outerRadius;
					ctx.arc(vm.x, vm.y, vm.outerRadius, sA - angleMargin, eA + angleMargin);
					if (vm.innerRadius > pixelMargin) {
						angleMargin = pixelMargin / vm.innerRadius;
						ctx.arc(vm.x, vm.y, vm.innerRadius - pixelMargin, eA + angleMargin, sA - angleMargin, true);
					} else {
						ctx.arc(vm.x, vm.y, pixelMargin, eA + Math.PI / 2, sA - Math.PI / 2);
					}
					ctx.closePath();
					ctx.clip();

					ctx.beginPath();
					ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
					ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
					ctx.closePath();

					ctx.lineWidth = vm.borderWidth * 2;
					ctx.lineJoin = 'round';
				} else {
					ctx.lineWidth = vm.borderWidth;
					ctx.lineJoin = 'bevel';
				}

				ctx.strokeStyle = vm.borderColor;
				ctx.stroke();
			}

			ctx.restore();
		}
	});

	var valueOrDefault$1 = helpers$1.valueOrDefault;

	var defaultColor = core_defaults.global.defaultColor;

	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});

	var element_line = core_element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;

			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}

			ctx.save();

			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}

			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;

			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers$1.previousItem(points, index);
				currentVM = current._view;

				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers$1.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}

			ctx.stroke();
			ctx.restore();
		}
	});

	var valueOrDefault$2 = helpers$1.valueOrDefault;

	var defaultColor$1 = core_defaults.global.defaultColor;

	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});

	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}

	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}

	var element_point = core_element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},

		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,

		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},

		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},

		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},

		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

			if (vm.skip) {
				return;
			}

			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});

	var defaultColor$2 = core_defaults.global.defaultColor;

	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});

	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}

	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;

		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}

		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}

	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}

	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};

		if (!edge) {
			return res;
		}

		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}

		res[edge] = true;
		return res;
	}

	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;

		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}

	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);

		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}

	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}

	var element_rectangle = core_element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;

			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}

			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},

		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},

		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},

		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},

		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},

		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},

		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}

			return {x: x, y: y};
		},

		getArea: function() {
			var vm = this._view;

			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},

		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});

	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;

	var resolve$1 = helpers$1.options.resolve;

	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',
				categoryPercentage: 0.8,
				barPercentage: 0.9,
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],

			yAxes: [{
				type: 'linear'
			}]
		}
	});

	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale.isHorizontal() ? scale.width : scale.height;
		var ticks = scale.getTicks();
		var prev, curr, i, ilen;

		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, curr - prev) : min;
			prev = curr;
		}

		return min;
	}

	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var size, ratio;

		if (helpers$1.isNullOrUndef(thickness)) {
			size = ruler.min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}

		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}

	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;

		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}

		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}

		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;

		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}

	var controller_bar = core_datasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			core_datasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveElementOptions(rectangle, index);

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};

			me._updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me._getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks;
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present

			return (index === -1)
				? stacks.length - 1
				: index;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var pixels = [];
			var i, ilen, min;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			min = helpers$1.isNullOrUndef(scale.options.barThickness)
				? computeMinSampleSize(scale, pixels)
				: -1;

			return {
				min: min,
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var value = +scale.getRightValue(datasets[datasetIndex].data[index]);
			var minBarLength = scale.options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller._getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = +scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = head - base;

			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (value >= 0 && !isHorizontal || value < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);

			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				helpers$1.valueOrDefault(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);

			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers$1.canvas.unclipArea(chart.ctx);
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(rectangle, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = rectangle.custom || {};
			var options = chart.options.elements.rectangle;
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderSkipped',
				'borderWidth'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$1([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			return values;
		}
	});

	var valueOrDefault$3 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;

	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},

		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});

	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = valueOrDefault$3(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$3(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$3(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle',
				'rotation'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$2([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve$2([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);

			return values;
		}
	});

	var resolve$3 = helpers$1.options.resolve;
	var valueOrDefault$4 = helpers$1.valueOrDefault;

	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');

			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;

			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}

			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var arcOpts = chart.options.elements.arc;
							var fill = resolve$3([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
							var stroke = resolve$3([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
							var bw = resolve$3([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);

							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}

				chart.update();
			}
		},

		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,

		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,

		// The total circumference of the chart.
		circumference: Math.PI * 2.0,

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}

					return dataLabel;
				}
			}
		}
	});

	var controller_doughnut = core_datasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers$1.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var availableWidth = chartArea.right - chartArea.left;
			var availableHeight = chartArea.bottom - chartArea.top;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var i, ilen;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveElementOptions(arcs[i], i);
			}

			chart.borderWidth = me.getMaxBorderWidth();
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};

			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (Math.abs(value) / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}

			if (!arcs) {
				return 0;
			}

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				options = controller ? controller._resolveElementOptions(arc, i) : arc._options;
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;

					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;

			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};

			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(arc, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = arc.custom || {};
			var options = chart.options.elements.arc;
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'borderAlign',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$3([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			return values;
		},

		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;

			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}

			return ringWeightOffset;
		},

		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$4(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},

		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});

	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},

		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],

			yAxes: [{
				type: 'category',
				position: 'left',
				categoryPercentage: 0.8,
				barPercentage: 0.9,
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},

		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},

		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});

	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});

	var valueOrDefault$5 = helpers$1.valueOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;

	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,

		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});

	function lineEnabled(dataset, options) {
		return valueOrDefault$5(dataset.showLine, options.showLines);
	}

	var controller_line = core_datasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.getScaleForId(meta.yAxisID);
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, me.chart.options);
			var i, ilen;

			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveLineOptions(line);

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var lineModel = meta.dataset._model;
			var x, y;

			var options = me._resolvePointOptions(point, index);

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$5(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},

		/**
		 * @private
		 */
		_resolvePointOptions: function(element, index) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options.elements.point;
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var ELEMENT_OPTIONS = {
				backgroundColor: 'pointBackgroundColor',
				borderColor: 'pointBorderColor',
				borderWidth: 'pointBorderWidth',
				hitRadius: 'pointHitRadius',
				hoverBackgroundColor: 'pointHoverBackgroundColor',
				hoverBorderColor: 'pointHoverBorderColor',
				hoverBorderWidth: 'pointHoverBorderWidth',
				hoverRadius: 'pointHoverRadius',
				pointStyle: 'pointStyle',
				radius: 'pointRadius',
				rotation: 'pointRotation'
			};
			var keys = Object.keys(ELEMENT_OPTIONS);

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$4([
					custom[key],
					dataset[ELEMENT_OPTIONS[key]],
					dataset[key],
					options[key]
				], context, index);
			}

			return values;
		},

		/**
		 * @private
		 */
		_resolveLineOptions: function(element) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options;
			var elementOptions = options.elements.line;
			var values = {};
			var i, ilen, key;

			var keys = [
				'backgroundColor',
				'borderWidth',
				'borderColor',
				'borderCapStyle',
				'borderDash',
				'borderDashOffset',
				'borderJoinStyle',
				'fill',
				'cubicInterpolationMode'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$4([
					custom[key],
					dataset[key],
					elementOptions[key]
				]);
			}

			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$5(dataset.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$5(dataset.lineTension, elementOptions.tension);
			values.steppedLine = resolve$4([custom.steppedLine, dataset.steppedLine, elementOptions.stepped]);

			return values;
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var halfBorderWidth;
			var i = 0;

			if (lineEnabled(me.getDataset(), chart.options)) {
				halfBorderWidth = (meta.dataset._model.borderWidth || 0) / 2;

				helpers$1.canvas.clipArea(chart.ctx, {
					left: area.left,
					right: area.right,
					top: area.top - halfBorderWidth,
					bottom: area.bottom + halfBorderWidth
				});

				meta.dataset.draw();

				helpers$1.canvas.unclipArea(chart.ctx);
			}

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$5(options.hoverRadius, options.radius);
		},
	});

	var resolve$5 = helpers$1.options.resolve;

	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},

		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},

		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');

			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;

			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}

			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var arcOpts = chart.options.elements.arc;
							var fill = resolve$5([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
							var stroke = resolve$5([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
							var bw = resolve$5([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);

							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}

				chart.update();
			}
		},

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});

	var controller_polarArea = core_datasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers$1.noop,

		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;

			me._updateRadius();

			meta.count = me.countVisibleElements();

			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},

		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};

			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			arc.pivot();
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;

			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};

			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(arc, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = arc.custom || {};
			var options = chart.options.elements.arc;
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'borderAlign',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$5([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			return values;
		},

		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();

			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}

			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			return resolve$5([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});

	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});

	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;

	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$6 = helpers$1.options.resolve;

	core_defaults._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});

	var controller_radar = core_datasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers$1.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var dataset = me.getDataset();
			var i, ilen;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveLineOptions(line);

			line.pivot();

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			// Update bezier control points
			me.updateBezierControlPoints();

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolvePointOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;

			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),

				// Tooltip
				hitRadius: options.hitRadius
			};
		},

		/**
		 * @private
		 */
		_resolvePointOptions: function(element, index) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options.elements.point;
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var ELEMENT_OPTIONS = {
				backgroundColor: 'pointBackgroundColor',
				borderColor: 'pointBorderColor',
				borderWidth: 'pointBorderWidth',
				hitRadius: 'pointHitRadius',
				hoverBackgroundColor: 'pointHoverBackgroundColor',
				hoverBorderColor: 'pointHoverBorderColor',
				hoverBorderWidth: 'pointHoverBorderWidth',
				hoverRadius: 'pointHoverRadius',
				pointStyle: 'pointStyle',
				radius: 'pointRadius',
				rotation: 'pointRotation'
			};
			var keys = Object.keys(ELEMENT_OPTIONS);

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$6([
					custom[key],
					dataset[ELEMENT_OPTIONS[key]],
					dataset[key],
					options[key]
				], context, index);
			}

			return values;
		},

		/**
		 * @private
		 */
		_resolveLineOptions: function(element) {
			var me = this;
			var chart = me.chart;
			var dataset = chart.data.datasets[me.index];
			var custom = element.custom || {};
			var options = chart.options.elements.line;
			var values = {};
			var i, ilen, key;

			var keys = [
				'backgroundColor',
				'borderWidth',
				'borderColor',
				'borderCapStyle',
				'borderDash',
				'borderDashOffset',
				'borderJoinStyle',
				'fill'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve$6([
					custom[key],
					dataset[key],
					options[key]
				]);
			}

			values.tension = valueOrDefault$6(dataset.lineTension, options.tension);

			return values;
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},

		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		}
	});

	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},

		showLines: false,

		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});

	// Scatter charts use line controllers
	var controller_scatter = controller_line;

	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).

	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};

	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}

		return helpers$1.getRelativePosition(e, chart);
	}

	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}

			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}

	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];

		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});

		return elements;
	}

	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];

		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}

			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});

		return nearestItems;
	}

	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;

		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}

	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];

		if (!items.length) {
			return [];
		}

		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];

				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});

		return elements;
	}

	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */

	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];

				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});

				return elements.slice(0, 1);
			},

			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,

			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,

			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}

				return items;
			},

			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},

			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},

			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},

			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},

			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};

	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.position === position;
		});
	}

	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}

	function findMaxPadding(boxes) {
		var top = 0;
		var left = 0;
		var bottom = 0;
		var right = 0;
		helpers$1.each(boxes, function(box) {
			if (box.getPadding) {
				var boxPadding = box.getPadding();
				top = Math.max(top, boxPadding.top);
				left = Math.max(left, boxPadding.left);
				bottom = Math.max(bottom, boxPadding.bottom);
				right = Math.max(right, boxPadding.right);
			}
		});
		return {
			top: top,
			left: left,
			bottom: bottom,
			right: right
		};
	}

	function addSizeByPosition(boxes, size) {
		helpers$1.each(boxes, function(box) {
			size[box.position] += box.isHorizontal() ? box.height : box.width;
		});
	}

	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});

	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},

		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;

			chart.boxes.push(item);
		},

		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;

			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);

			var verticalBoxes = leftBoxes.concat(rightBoxes);
			var horizontalBoxes = topBoxes.concat(bottomBoxes);
			var outerBoxes = verticalBoxes.concat(horizontalBoxes);

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area

			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%

			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / verticalBoxes.length;

			// Step 3
			// TODO re-limit horizontal axis height (this limit has affected only padding calculation since PR 1837)
			// var horizontalBoxHeight = (height - chartAreaHeight) / horizontalBoxes.length;

			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
			var minBoxSizes = [];
			var maxPadding;

			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();

				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, maxChartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}

				minBoxSizes.push({
					horizontal: isHorizontal,
					width: minSize.width,
					box: box,
				});
			}

			helpers$1.each(outerBoxes, getMinimumBoxSize);

			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			maxPadding = findMaxPadding(outerBoxes);

			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6

			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});

				if (minBoxSize) {
					if (minBoxSize.horizontal) {
						var scaleMargin = {
							left: Math.max(outerBoxSizes.left, maxPadding.left),
							right: Math.max(outerBoxSizes.right, maxPadding.right),
							top: 0,
							bottom: 0
						};

						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.width, maxChartAreaHeight);
					}
				}
			}

			// Update, and calculate the left and right margins for the horizontal boxes
			helpers$1.each(verticalBoxes, fitBox);
			addSizeByPosition(verticalBoxes, outerBoxSizes);

			// Set the Left and Right margins for the horizontal boxes
			helpers$1.each(horizontalBoxes, fitBox);
			addSizeByPosition(horizontalBoxes, outerBoxSizes);

			function finalFitVerticalBox(box) {
				var minBoxSize = helpers$1.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});

				var scaleMargin = {
					left: 0,
					right: 0,
					top: outerBoxSizes.top,
					bottom: outerBoxSizes.bottom
				};

				if (minBoxSize) {
					box.update(minBoxSize.width, maxChartAreaHeight, scaleMargin);
				}
			}

			// Let the left layout know the final margin
			helpers$1.each(verticalBoxes, finalFitVerticalBox);

			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			outerBoxSizes = {top: topPadding, left: leftPadding, bottom: bottomPadding, right: rightPadding};
			addSizeByPosition(outerBoxes, outerBoxSizes);

			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxPadding.left - outerBoxSizes.left, 0);
			outerBoxSizes.left += leftPaddingAddition;
			outerBoxSizes.right += Math.max(maxPadding.right - outerBoxSizes.right, 0);

			var topPaddingAddition = Math.max(maxPadding.top - outerBoxSizes.top, 0);
			outerBoxSizes.top += topPaddingAddition;
			outerBoxSizes.bottom += Math.max(maxPadding.bottom - outerBoxSizes.bottom, 0);

			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - outerBoxSizes.top - outerBoxSizes.bottom;
			var newMaxChartAreaWidth = width - outerBoxSizes.left - outerBoxSizes.right;

			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers$1.each(verticalBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers$1.each(horizontalBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}

			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;

			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : outerBoxSizes.left;
					box.right = box.fullWidth ? width - rightPadding : outerBoxSizes.left + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;

					// Move to next point
					top = box.bottom;

				} else {

					box.left = left;
					box.right = left + box.width;
					box.top = outerBoxSizes.top;
					box.bottom = outerBoxSizes.top + maxChartAreaHeight;

					// Move to next point
					left = box.right;
				}
			}

			helpers$1.each(leftBoxes.concat(topBoxes), placeBox);

			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;

			helpers$1.each(rightBoxes, placeBox);
			helpers$1.each(bottomBoxes, placeBox);

			// Step 8
			chart.chartArea = {
				left: outerBoxSizes.left,
				top: outerBoxSizes.top,
				right: outerBoxSizes.left + maxChartAreaWidth,
				bottom: outerBoxSizes.top + maxChartAreaHeight
			};

			// Step 9
			helpers$1.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;

				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};

	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */

	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			return item && item.getContext('2d') || null;
		}
	};

	var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	default: platform_dom
	});

	function getCjsExportFromNamespace (n) {
		return n && n.default || n;
	}

	var stylesheet = getCjsExportFromNamespace(platform_dom$1);

	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};

	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}

	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;

		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');

		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};

		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';

		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}

		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}

		return canvas;
	}

	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());

	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}

	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}

	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}

	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}

	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];

		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;

			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}

	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}

	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;

		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());

		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};

		var onScroll = function() {
			resizer._reset();
			handler();
		};

		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

		return resizer;
	}

	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};

		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});

		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;

		node.classList.add(CSS_RENDER_MONITOR);
	}

	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;

		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});

			delete expando.renderProxy;
		}

		node.classList.remove(CSS_RENDER_MONITOR);
	}

	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));

		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}

				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}

	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;

		delete expando.resizer;
		unwatchForRender(node);

		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}

	function injectCSS(platform, css) {
		// https://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}

		style.appendChild(document.createTextNode(css));
	}

	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,

		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

		/**
		 * @private
		 */
		_ensureLoaded: function() {
			if (this._loaded) {
				return;
			}

			this._loaded = true;

			// https://github.com/chartjs/Chart.js/issues/5208
			if (!this.disableCSSInjection) {
				injectCSS(this, stylesheet);
			}
		},

		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}

			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');

			// Load platform resources on first chart creation, to make possible to change
			// platform options after importing the library (e.g. `disableCSSInjection`).
			this._ensureLoaded();

			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}

			return null;
		},

		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}

			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});

			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});

			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;

			delete canvas[EXPANDO_KEY];
		},

		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}

			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};

			addListener(canvas, type, proxy);
		},

		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}

			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}

			removeListener(canvas, type, proxy);
		}
	};

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;

	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;

	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},

		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},

		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},

		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},

		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}

	}, implementation);

	core_defaults._set('global', {
		plugins: {}
	});

	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],

		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,

		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},

		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},

		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};

			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},

		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};

	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};

	var valueOrDefault$7 = helpers$1.valueOrDefault;

	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;

					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}

					return title;
				},
				afterTitle: helpers$1.noop,

				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,

				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';

					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,

				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,

				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});

	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: x / count,
				y: y / count
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}


	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$7(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$7(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$7(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$7(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$7(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$7(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$7(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$7(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$7(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}

	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}

	var exports$3 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},

		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},

		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;

			if (title.length) {
				pt.x = getAlignedX(vm, vm._titleAlign);

				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},

		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var labelColors = vm.labelColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
			var textColor;

			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			pt.x = getAlignedX(vm, bodyAlign);

			// Before Body
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);

			xLinePadding = drawColorBoxes && bodyAlign !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;

			// Draw body lines now
			helpers$1.each(body, function(bodyItem, i) {
				textColor = vm.labelTextColors[i];
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);

				helpers$1.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(colorX, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors[i].borderColor;
						ctx.strokeRect(colorX, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = labelColors[i].backgroundColor;
						ctx.fillRect(colorX + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers$1.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},

		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;

			if (footer.length) {
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers$1.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},

		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},

		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;

				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);

				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx);

				// Body
				this.drawBody(pt, vm, ctx);

				// Footer
				this.drawFooter(pt, vm, ctx);

				ctx.restore();
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);

			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;

				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};

					me.update(true);
					me.pivot();
				}
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;

	var core_tooltip = exports$3;
	core_tooltip.positioners = positioners_1;

	var valueOrDefault$8 = helpers$1.valueOrDefault;

	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});

	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$8(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}

	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}

	function initConfig(config) {
		config = config || {};

		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});

		return config;
	}

	function updateConfig(chart) {
		var newOptions = chart.options;

		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});

		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);

		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();

		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');

			helpers$1.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildOrUpdateScales();
			me.initToolTip();

			// After init plugin notification
			core_plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers$1.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}

				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$8(scaleOptions.type, item.dtype);

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}

				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});

			me.scales = scales;

			core_scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];

			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);

			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			core_layouts.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			core_plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var animationOptions = me.options.animation;
			var duration = valueOrDefault$8(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;

			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (me.width <= 0 || me.height <= 0) {
				return;
			}

			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers$1.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			core_plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}

			core_plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers$1.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};

	var core_controller = Chart;

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;

	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};

	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;

	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;

	var core_helpers = function() {

		// -- Basic js utility methods

		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];

			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});

			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};

		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
				// Check for whole powers of 10,
				// which due to floating point rounding error should be corrected.
				var powerOf10 = Math.round(exponent);
				var isPowerOf10 = x === Math.pow(10, powerOf10);

				return isPowerOf10 ? powerOf10 : exponent;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};

		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};

		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}

			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};

		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};

		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};

		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html

			// This function must also respect "skipped" points

			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;

			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);

			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;

			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;

			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});

			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}

				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}

				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}

			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}

				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}

				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}

				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}

			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}

				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;

			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}

			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();

			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;

			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}

			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

			return {
				x: mouseX,
				y: mouseY
			};

		};

		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);

				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}

			return valueInPixels;
		}

		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}

		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;

			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}

			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);

			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}

			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}

			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}

			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;

			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);

			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];

			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}

			ctx.font = font;
			var longest = 0;
			helpers$1.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers$1.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});

			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};

		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}

				return chartjsColor(value);
			};

		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};

	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}

	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */

	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */

	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}

	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,

		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,

		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,

		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,

		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,

		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,

		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,

		// DEPRECATIONS

		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});

	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};

	var _date = DateAdapter;

	var core_adapters = {
		_date: _date
	};

	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},

			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}

				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';

				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						tickString = tickValue.toExponential(Math.floor(logTick) - Math.floor(logDelta));
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}

				return tickString;
			},

			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};

	var valueOrDefault$9 = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,

		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},

		// scale label
		scaleLabel: {
			// display property
			display: false,

			// actual label
			labelString: '',

			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},

		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});

	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}

		return labels;
	}

	function getPixelForGridLine(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);

		if (offsetGridLines) {
			if (scale.getTicks().length === 1) {
				lineValue -= scale.isHorizontal() ?
					Math.max(lineValue - scale.left, scale.right - lineValue) :
					Math.max(lineValue - scale.top, scale.bottom - lineValue);
			} else if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}

	function computeTextSize(context, tick, font) {
		return helpers$1.isArray(tick) ?
			helpers$1.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	var core_scale = core_element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},

		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);

			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (helpers$1.isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},

		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = helpers$1.options._parseFont(tickOpts);
			context.font = tickFont.string;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers$1.longestText(context, tickFont.string, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers$1.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var position = opts.position;
			var isHorizontal = me.isHorizontal();

			var parseFont = helpers$1.options._parseFont;
			var tickFont = parseFont(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelFont = parseFont(scaleLabelOpts);
				var scaleLabelPadding = helpers$1.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelFont.lineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var largestTextWidth = helpers$1.longestText(me.ctx, tickFont.string, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers$1.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				// Store max number of lines and widest label for _autoSkip
				me._maxLabelLines = tallestLabelHeightInLines;
				me.longestLabelWidth = largestTextWidth;

				if (isHorizontal) {
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.lineHeight * tallestLabelHeightInLines)
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.string;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.string);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.string);
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(labels.length - 1);
					var paddingLeft, paddingRight;

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						paddingLeft = position === 'bottom' ? (cosRotation * firstLabelWidth) : (cosRotation * lineSpace);
						paddingRight = position === 'bottom' ? (cosRotation * lineSpace) : (cosRotation * lastLabelWidth);
					} else {
						paddingLeft = firstLabelWidth / 2;
						paddingRight = lastLabelWidth / 2;
					}
					me.paddingLeft = Math.max(paddingLeft - offsetLeft, 0) + 3; // add 3 px to move away from canvas edges
					me.paddingRight = Math.max(paddingRight - offsetRight, 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers$1.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + pixel;
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + valueOffset;
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var skipRatio = false;
			var maxTicks = optionTicks.maxTicksLimit;

			// Total space needed to display all ticks. First and last ticks are
			// drawn as their center at end of axis, so tickCount-1
			var ticksLength = me._tickSize() * (tickCount - 1);

			// Axis length
			var axisLength = isHorizontal
				? me.width - (me.paddingLeft + me.paddingRight)
				: me.height - (me.paddingTop + me.PaddingBottom);

			var result = [];
			var i, tick;

			if (ticksLength > axisLength) {
				skipRatio = 1 + Math.floor(ticksLength / axisLength);
			}

			// if they defined a max number of optionTicks,
			// increase skipRatio until that number is met
			if (tickCount > maxTicks) {
				skipRatio = Math.max(skipRatio, 1 + Math.floor(tickCount / maxTicks));
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				if (skipRatio > 1 && i % skipRatio > 0) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;

			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));

			var padding = optionTicks.autoSkipPadding || 0;
			var w = (me.longestLabelWidth + padding) || 0;

			var tickFont = helpers$1.options._parseFont(optionTicks);
			var h = (me._maxLabelLines * tickFont.lineHeight + padding) || 0;

			// Calculate space needed for 1 tick in axis direction.
			return isHorizontal
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},

		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;

			if (display !== 'auto') {
				return !!display;
			}

			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}

			return false;
		},

		/**
		 * Actually draw the scale on the canvas
		 * @param {object} chartArea - the area of the chart to draw full grid lines on
		 */
		draw: function(chartArea) {
			var me = this;
			var options = me.options;

			if (!me._isVisible()) {
				return;
			}

			var chart = me.chart;
			var context = me.ctx;
			var globalDefaults = core_defaults.global;
			var defaultFontColor = globalDefaults.defaultFontColor;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;
			var position = options.position;

			var isRotated = me.labelRotation !== 0;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();

			var parseFont = helpers$1.options._parseFont;
			var ticks = optionTicks.display && optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = valueOrDefault$9(optionTicks.fontColor, defaultFontColor);
			var tickFont = parseFont(optionTicks);
			var lineHeight = tickFont.lineHeight;
			var majorTickFontColor = valueOrDefault$9(optionMajorTicks.fontColor, defaultFontColor);
			var majorTickFont = parseFont(optionMajorTicks);
			var tickPadding = optionTicks.padding;
			var labelOffset = optionTicks.labelOffset;

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = valueOrDefault$9(scaleLabel.fontColor, defaultFontColor);
			var scaleLabelFont = parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers$1.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var alignPixel = helpers$1._alignPixel;
			var borderValue, tickStart, tickEnd;

			if (position === 'top') {
				borderValue = alignPixel(chart, me.bottom, axisWidth);
				tickStart = me.bottom - tl;
				tickEnd = borderValue - axisWidth / 2;
			} else if (position === 'bottom') {
				borderValue = alignPixel(chart, me.top, axisWidth);
				tickStart = borderValue + axisWidth / 2;
				tickEnd = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignPixel(chart, me.right, axisWidth);
				tickStart = me.right - tl;
				tickEnd = borderValue - axisWidth / 2;
			} else {
				borderValue = alignPixel(chart, me.left, axisWidth);
				tickStart = borderValue + axisWidth / 2;
				tickEnd = me.left + tl;
			}

			var epsilon = 0.0000001; // 0.0000001 is margin in pixels for Accumulated error.

			helpers$1.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers$1.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = valueAtIndexOrDefault(gridLines.color, index);
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY, textOffset, textAlign;
				var labelCount = helpers$1.isArray(label) ? label.length : 1;
				var lineValue = getPixelForGridLine(me, index, gridLines.offsetGridLines);

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (lineValue < me.left - epsilon) {
						lineColor = 'rgba(0,0,0,0)';
					}

					tx1 = tx2 = x1 = x2 = alignPixel(chart, lineValue, lineWidth);
					ty1 = tickStart;
					ty2 = tickEnd;
					labelX = me.getPixelForTick(index) + labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					if (position === 'top') {
						y1 = alignPixel(chart, chartArea.top, axisWidth) + axisWidth / 2;
						y2 = chartArea.bottom;
						textOffset = ((!isRotated ? 0.5 : 1) - labelCount) * lineHeight;
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					} else {
						y1 = chartArea.top;
						y2 = alignPixel(chart, chartArea.bottom, axisWidth) - axisWidth / 2;
						textOffset = (!isRotated ? 0.5 : 0) * lineHeight;
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					}
				} else {
					var labelXOffset = (isMirrored ? 0 : tl) + tickPadding;

					if (lineValue < me.top - epsilon) {
						lineColor = 'rgba(0,0,0,0)';
					}

					tx1 = tickStart;
					tx2 = tickEnd;
					ty1 = ty2 = y1 = y2 = alignPixel(chart, lineValue, lineWidth);
					labelY = me.getPixelForTick(index) + labelOffset;
					textOffset = (1 - labelCount) * lineHeight / 2;

					if (position === 'left') {
						x1 = alignPixel(chart, chartArea.left, axisWidth) + axisWidth / 2;
						x2 = chartArea.right;
						textAlign = isMirrored ? 'left' : 'right';
						labelX = me.right - labelXOffset;
					} else {
						x1 = chartArea.left;
						x2 = alignPixel(chart, chartArea.right, axisWidth) - axisWidth / 2;
						textAlign = isMirrored ? 'right' : 'left';
						labelX = me.left + labelXOffset;
					}
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textOffset: textOffset,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers$1.each(itemsToDraw, function(itemToDraw) {
				var glWidth = itemToDraw.glWidth;
				var glColor = itemToDraw.glColor;

				if (gridLines.display && glWidth && glColor) {
					context.save();
					context.lineWidth = glWidth;
					context.strokeStyle = glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.string : tickFont.string;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = 'middle';
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					var y = itemToDraw.textOffset;
					if (helpers$1.isArray(label)) {
						for (var i = 0; i < label.length; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							y += lineHeight;
						}
					} else {
						context.fillText(label, 0, y);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = scaleLabelFont.lineHeight / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.string;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, ticks.length - 1, 0);
				var x1, x2, y1, y2;

				if (isHorizontal) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}

				context.lineWidth = axisWidth;
				context.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});

	var defaultConfig = {
		position: 'bottom'
	};

	var scale_category = core_scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;

			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}

			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + widthOffset;
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + heightOffset;
		},

		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},

		getBasePixel: function() {
			return this.bottom;
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;

	var noop = helpers$1.noop;
	var isNullOrUndef = helpers$1.isNullOrUndef;

	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.

		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;

		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef(min) && isNullOrUndef(max)) {
			return [rmin, rmax];
		}

		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}

		if (stepSize || isNullOrUndef(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}

		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;

		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}

		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}

		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef(max) ? niceMax : max);

		return ticks;
	}

	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},

		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;

			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}

			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}

			return maxTicks;
		},

		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},

		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},

		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			core_scale.prototype.convertTicksToLabels.call(me);
		}
	});

	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};

	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers$1.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers$1.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers$1.min(values);
					var maxVal = helpers$1.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers$1.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},

		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;

			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},

		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},

		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},

		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
			} else {
				pixel = me.bottom - (me.height / range * (rightValue - start));
			}
			return pixel;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},

		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;

	var valueOrDefault$a = helpers$1.valueOrDefault;

	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];

		var tickVal = valueOrDefault$a(generationOptions.min, Math.pow(10, Math.floor(helpers$1.log10(dataRange.min))));

		var endExp = Math.floor(helpers$1.log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;

		if (tickVal === 0) {
			exp = Math.floor(helpers$1.log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(helpers$1.log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

		do {
			ticks.push(tickVal);

			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}

			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));

		var lastTick = valueOrDefault$a(generationOptions.max, tickVal);
		ticks.push(lastTick);

		return ticks;
	}

	var defaultConfig$2 = {
		position: 'left',

		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};

	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}

	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers$1.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}
							values[index] = values[index] || 0;
							values[index] += value;
						});
					}
				});

				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					}
				});

			} else {
				helpers$1.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers$1.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							// invalid, hidden and negative values are ignored
							if (isNaN(value) || meta.data[index].hidden || value < 0) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},

		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;

			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers$1.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers$1.log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(helpers$1.log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(helpers$1.log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(helpers$1.log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},

		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();

			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);

			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},

		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			core_scale.prototype.convertTicksToLabels.call(this);
		},

		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},

		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},

		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(helpers$1.log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));

			return significand * Math.pow(10, exp);
		},

		getPixelForValue: function(value) {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = tickOpts.reverse;
			var log10 = helpers$1.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var offset = 0;
			var innerDimension, pixel, start, end, sign;

			value = +me.getRightValue(value);
			if (reverse) {
				start = me.end;
				end = me.start;
				sign = -1;
			} else {
				start = me.start;
				end = me.end;
				sign = 1;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				pixel = reverse ? me.right : me.left;
			} else {
				innerDimension = me.height;
				sign *= -1; // invert, since the upper-left corner of the canvas is at pixel (0, 0)
				pixel = reverse ? me.top : me.bottom;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
					innerDimension -= offset;
					start = firstTickValue;
				}
				if (value !== 0) {
					offset += innerDimension / (log10(end) - log10(start)) * (log10(value) - log10(start));
				}
				pixel += sign * offset;
			}
			return pixel;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = tickOpts.reverse;
			var log10 = helpers$1.log10;
			var firstTickValue = me._getFirstTickValue(me.minNotZero);
			var innerDimension, start, end, value;

			if (reverse) {
				start = me.end;
				end = me.start;
			} else {
				start = me.start;
				end = me.end;
			}
			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = reverse ? me.right - pixel : pixel - me.left;
			} else {
				innerDimension = me.height;
				value = reverse ? pixel - me.top : me.bottom - pixel;
			}
			if (value !== start) {
				if (start === 0) { // include zero tick
					var offset = valueOrDefault$a(tickOpts.fontSize, core_defaults.global.defaultFontSize);
					value -= offset;
					innerDimension -= offset;
					start = firstTickValue;
				}
				value *= log10(end) - log10(start);
				value /= innerDimension;
				value = Math.pow(10, log10(start) + value);
			}
			return value;
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;

	var valueOrDefault$b = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$7 = helpers$1.options.resolve;

	var defaultConfig$3 = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: core_ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;

		if (tickOpts.display && opts.display) {
			return valueOrDefault$b(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}

	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {

		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;

		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var gridLineOpts = opts.gridLines;
		var pointLabelOpts = opts.pointLabels;
		var lineWidth = valueOrDefault$b(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$b(angleLineOpts.color, gridLineOpts.color);
		var tickBackdropHeight = getTickBackdropHeight(opts);

		ctx.save();
		ctx.lineWidth = lineWidth;
		ctx.strokeStyle = lineColor;
		if (ctx.setLineDash) {
			ctx.setLineDash(resolve$7([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
			ctx.lineDashOffset = resolve$7([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
		}

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = helpers$1.options._parseFont(pointLabelOpts);

		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display && lineWidth && lineColor) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
			}

			if (pointLabelOpts.display) {
				// Extra pixels out for some label spacing
				var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers$1.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.lineHeight);
			}
		}
		ctx.restore();
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = getValueCount(scale);
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;

		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}

		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}

		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}

	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}

	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;

			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},

		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},

		convertTicksToLabels: function() {
			var me = this;

			scale_linearbase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},

		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},

		fit: function() {
			var me = this;
			var opts = me.options;

			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},

		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},

		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},

		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},

		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},

		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);
				var tickFont = helpers$1.options._parseFont(tickOpts);

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}

				helpers$1.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault$b(tickOpts.fontColor, core_defaults.global.defaultFontColor);
							ctx.font = tickFont.string;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFont.size / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFont.size + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});
			}
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;

	var valueOrDefault$c = helpers$1.valueOrDefault;

	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 15, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 15, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};

	var UNITS = Object.keys(INTERVALS);

	function sorter(a, b) {
		return a - b;
	}

	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}

		return out;
	}

	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}

		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;

		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}

		items.push(max);

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];

			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}

		return table;
	}

	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;

		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];

			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}

		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}

	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);

		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;

		return prev[tkey] + offset;
	}

	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;

		if (typeof parser === 'function') {
			value = parser(value);
		}

		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}

		if (value !== null) {
			return +value;
		}

		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);

			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}

		return value;
	}

	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}

		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}

		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}

		return value;
	}

	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;

		if (!steps) {
			return Math.ceil(range / (capacity * milliseconds));
		}

		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}

		return factor;
	}

	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;

		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}

		return UNITS[ilen - 1];
	}

	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, ticks, minUnit, min, max) {
		var ilen = UNITS.length;
		var i, unit;

		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= ticks.length) {
				return unit;
			}
		}

		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}

	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}

	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = valueOrDefault$c(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = min;
		var last = max;
		var ticks = [];
		var time;

		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}

		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
			last = +adapter.startOf(last, 'isoWeek', weekday);
		}

		// Align first/last ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
		last = +adapter.startOf(last, weekday ? 'day' : minor);

		// Make sure that the last tick include max
		if (last < max) {
			last = +adapter.add(last, 1, minor);
		}

		time = first;

		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time = +adapter.startOf(time, major);
			time = +adapter.add(time, ~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}

		for (; time < last; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(+time);
		}

		ticks.push(+time);

		return ticks;
	}

	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;

		if (options.offset && ticks.length) {
			if (!options.time.min) {
				first = interpolate$1(table, 'time', ticks[0], 'pos');
				if (ticks.length === 1) {
					start = 1 - first;
				} else {
					start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
				}
			}
			if (!options.time.max) {
				last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
				if (ticks.length === 1) {
					end = last;
				} else {
					end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
				}
			}
		}

		return {start: start, end: end};
	}

	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;

		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +scale._adapter.startOf(value, majorUnit) : false;

			ticks.push({
				value: value,
				major: major
			});
		}

		return ticks;
	}

	var defaultConfig$4 = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from https://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);

			// DEPRECATIONS: output a message only one time per update
			if (time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());

			return core_scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var timeOpts = me.options.time;
			var unit = timeOpts.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;
			var dataLabels = chart.data.labels || [];

			// Convert labels to timestamps
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						for (j = 0, jlen = labels.length; j < jlen; ++j) {
							timestamps.push(labels[j]);
						}
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(me, timeOpts.min) || min;
			max = parse(me, timeOpts.max) || max;

			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(me, min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(me, timeOpts.min) || min;
			max = parse(me, timeOpts.max) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(me, ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);

			if (options.ticks.reverse) {
				ticks.reverse();
			}

			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = +adapter.startOf(time, majorUnit);
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = valueOrDefault$c(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var isReverse = me.options.ticks.reverse;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? isReverse ? me.right : me.left : isReverse ? me.bottom : me.top;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			var offset = size * (me._offsets.start + pos) / (me._offsets.start + 1 + me._offsets.end);

			return isReverse ? start - offset : start + offset;
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(me, value);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.start + 1 + me._offsets.start) - me._offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');

			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$c(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			// pick the longest format (milliseconds) for guestimation
			var format = me.options.time.displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, [], format);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;
			var capacity = Math.floor(innerWidth / tickLabelWidth);

			return capacity > 0 ? capacity : 1;
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;

	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};

	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};

	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY

		formats: function() {
			return FORMATS;
		},

		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},

		format: function(time, format) {
			return moment(time).format(format);
		},

		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},

		diff: function(max, min, unit) {
			return moment.duration(moment(max).diff(moment(min))).as(unit);
		},

		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},

		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},

		// DEPRECATIONS

		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});

	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});

	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;

			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},

		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;

			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}

	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}

		return null;
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;

		ctx.beginPath();

		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	var plugin_filler = {
		id: 'filler',

		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}

			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	};

	var noop$1 = helpers$1.noop;
	var valueOrDefault$d = helpers$1.valueOrDefault;

	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,

			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);

				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

				// We hid a dataset ... rerender the chart
				ci.update();
			},

			onHover: null,
			onLeave: null,

			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers$1.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers$1.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,

							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},

		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});

	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}

	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({

		initialize: function(config) {
			helpers$1.extend(this, config);

			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];

			/**
	 		 * @private
	 		 */
			this._hoveredItem = null;

			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop$1,

		//

		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,

		//

		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,

		//

		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (display) {
				ctx.font = labelFont.string;

				if (isHorizontal) {
					// Labels

					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = 0;

					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';

					helpers$1.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						if (i === 0 || lineWidths[lineWidths.length - 1] + width + labelOpts.padding > minSize.width) {
							totalHeight += fontSize + labelOpts.padding;
							lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = labelOpts.padding;
						}

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};

						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});

					minSize.height += totalHeight;

				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;

					helpers$1.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						// If too tall, go to new column
						if (i > 0 && currentColHeight + itemHeight > minSize.height - vPadding) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width

							currentColWidth = 0;
							currentColHeight = 0;
						}

						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});

					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;

			if (opts.display) {
				var ctx = me.ctx;
				var fontColor = valueOrDefault$d(labelOpts.fontColor, globalDefaults.defaultFontColor);
				var labelFont = helpers$1.options._parseFont(labelOpts);
				var fontSize = labelFont.size;
				var cursor;

				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont.string;

				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;

				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}

					// Set the ctx for the box
					ctx.save();

					var lineWidth = valueOrDefault$d(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.fillStyle = valueOrDefault$d(legendItem.fillStyle, defaultColor);
					ctx.lineCap = valueOrDefault$d(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault$d(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault$d(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = lineWidth;
					ctx.strokeStyle = valueOrDefault$d(legendItem.strokeStyle, defaultColor);

					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault$d(legendItem.lineDash, lineDefault.borderDash));
					}

					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = boxWidth * Math.SQRT2 / 2;
						var centerX = x + boxWidth / 2;
						var centerY = y + fontSize / 2;

						// Draw pointStyle as legend symbol
						helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (lineWidth !== 0) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}

					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;

					ctx.fillText(legendItem.text, xLeft, yMiddle);

					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};

				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2) + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}

				var itemHeight = fontSize + labelOpts.padding;
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;

					// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
					// instead of me.right and me.bottom because me.width and me.height
					// may have been changed since me.minSize was calculated
					if (isHorizontal) {
						if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2) + labelOpts.padding;
						}
					} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}

					drawLegendBox(x, y, legendItem);

					hitboxes[i].left = x;
					hitboxes[i].top = y;

					// Fill the actual label
					fillText(x, y, legendItem, textWidth);

					if (isHorizontal) {
						cursor.x += width + labelOpts.padding;
					} else {
						cursor.y += itemHeight;
					}

				});
			}
		},

		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}

			return null;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;

			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);

			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}

				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}

	var plugin_legend = {
		id: 'legend',

		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,

		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};

	var noop$2 = helpers$1.noop;

	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});

	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: noop$2,

		//

		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,

		//

		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,

		//

		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var display = opts.display;
			var minSize = me.minSize;
			var lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			var fontOpts = helpers$1.options._parseFont(opts);
			var textSize = display ? (lineCount * fontOpts.lineHeight) + (opts.padding * 2) : 0;

			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}

			me.width = minSize.width;
			me.height = minSize.height;

		},
		afterFit: noop$2,

		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;

			if (opts.display) {
				var fontOpts = helpers$1.options._parseFont(opts);
				var lineHeight = fontOpts.lineHeight;
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;

				ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
				ctx.font = fontOpts.string;

				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}

				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';

				var text = opts.text;
				if (helpers$1.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}

				ctx.restore();
			}
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}

	var plugin_title = {
		id: 'title',

		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,

		beforeInit: function(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);

				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};

	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;

	/**
	 * @namespace Chart
	 */


	core_controller.helpers = helpers$1;

	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers(core_controller);

	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;

	// Register built-in scales

	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});

	// Load to register built-in adapters (as side effects)


	// Loading built-in plugins

	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}

	core_controller.platform.initialize();

	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;

	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;

	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;

	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;

	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});

	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;

	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;

	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;

	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);

	return src;

	})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js

	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';

	    var hookCallback;

	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }

	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }

	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }

	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }

	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }

	    function isUndefined(input) {
	        return input === void 0;
	    }

	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }

	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }

	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }

	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }

	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }

	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }

	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }

	        return a;
	    }

	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }

	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }

	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }

	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;

	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }

	            return false;
	        };
	    }

	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));

	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }

	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }

	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }

	        return m;
	    }

	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];

	    function copyConfig(to, from) {
	        var i, prop, val;

	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }

	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }

	        return to;
	    }

	    var updateInProgress = false;

	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }

	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }

	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }

	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;

	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }

	        return value;
	    }

	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }

	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }

	    function deprecate(msg, fn) {
	        var firstTime = true;

	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }

	    var deprecations = {};

	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }

	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;

	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }

	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }

	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }

	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }

	    var keys;

	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }

	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };

	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }

	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };

	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];

	        if (format || !formatUpper) {
	            return format;
	        }

	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });

	        return this._longDateFormat[key];
	    }

	    var defaultInvalidDate = 'Invalid date';

	    function invalidDate () {
	        return this._invalidDate;
	    }

	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }

	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };

	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }

	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }

	    var aliases = {};

	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }

	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }

	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;

	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }

	        return normalizedInput;
	    }

	    var priorities = {};

	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }

	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }

	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }

	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

	    var formatFunctions = {};

	    var formatTokenFunctions = {};

	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }

	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }

	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;

	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }

	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }

	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }

	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

	        return formatFunctions[format](m);
	    }

	    function expandFormat(format, locale) {
	        var i = 5;

	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }

	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }

	        return format;
	    }

	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

	    var regexes = {};

	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }

	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }

	        return regexes[token](config._strict, config._locale);
	    }

	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }

	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }

	    var tokens = {};

	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }

	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }

	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }

	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;

	    // FORMATTING

	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });

	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });

	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	    // ALIASES

	    addUnitAlias('year', 'y');

	    // PRIORITIES

	    addUnitPriority('year', 1);

	    // PARSING

	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);

	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });

	    // HELPERS

	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }

	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }

	    // HOOKS

	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };

	    // MOMENTS

	    var getSetYear = makeGetSet('FullYear', true);

	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }

	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }

	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }

	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }

	    // MOMENTS

	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }


	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }

	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }

	    var indexOf;

	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }

	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }

	    // FORMATTING

	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });

	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });

	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });

	    // ALIASES

	    addUnitAlias('month', 'M');

	    // PRIORITY

	    addUnitPriority('month', 8);

	    // PARSING

	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });

	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });

	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });

	    // LOCALES

	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }

	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }

	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;

	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }

	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }

	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function setMonth (mom, value) {
	        var dayOfMonth;

	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }

	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }

	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }

	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }

	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }

	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }

	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }

	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }

	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }

	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }

	        return date;
	    }

	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }

	        return date;
	    }

	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	        return -fwdlw + fwd - 1;
	    }

	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;

	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }

	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }

	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;

	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }

	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }

	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }

	    // FORMATTING

	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	    // ALIASES

	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');

	    // PRIORITIES

	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);

	    // PARSING

	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);

	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });

	    // HELPERS

	    // LOCALES

	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }

	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };

	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }

	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }

	    // MOMENTS

	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    // FORMATTING

	    addFormatToken('d', 0, 'do', 'day');

	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });

	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });

	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });

	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');

	    // ALIASES

	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');

	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);

	    // PARSING

	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });

	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });

	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });

	    // HELPERS

	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }

	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }

	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }

	        return null;
	    }

	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }

	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }

	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }

	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }

	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }

	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];

	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;

	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }

	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }

	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already

	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }

	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }

	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }

	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.

	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }

	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }

	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }

	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }


	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }

	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;

	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }

	    // FORMATTING

	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }

	    function kFormat() {
	        return this.hours() || 24;
	    }

	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);

	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });

	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });

	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }

	    meridiem('a', true);
	    meridiem('A', false);

	    // ALIASES

	    addUnitAlias('hour', 'h');

	    // PRIORITY
	    addUnitPriority('hour', 13);

	    // PARSING

	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }

	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);

	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);

	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });

	    // LOCALES

	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }

	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }


	    // MOMENTS

	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);

	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,

	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,

	        week: defaultLocaleWeek,

	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,

	        meridiemParse: defaultLocaleMeridiemParse
	    };

	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;

	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }

	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;

	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }

	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(33)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }

	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }

	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }

	        return globalLocale._abbr;
	    }

	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));

	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }

	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);


	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }

	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;

	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }

	    // returns locale data
	    function getLocale (key) {
	        var locale;

	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }

	        if (!key) {
	            return globalLocale;
	        }

	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }

	        return chooseLocale(key);
	    }

	    function listLocales() {
	        return keys(locales);
	    }

	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;

	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;

	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }

	            getParsingFlags(m).overflow = overflow;
	        }

	        return m;
	    }

	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }

	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }

	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

	        if (config._d) {
	            return;
	        }

	        currentDate = currentDateArray(config);

	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }

	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }

	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }

	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }

	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }

	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }

	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }

	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }

	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }

	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;

	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;

	            var curWeek = weekOfYear(createLocal(), dow, doy);

	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

	            // Default to current week.
	            week = defaults(w.w, curWeek.week);

	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }

	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];

	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];

	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;

	        if (match) {
	            getParsingFlags(config).iso = true;

	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }

	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];

	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }

	        return result;
	    }

	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }

	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }

	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }

	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };

	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }

	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }

	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);

	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }

	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);

	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }

	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }

	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );

	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};

	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};

	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;

	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;

	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }

	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }

	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }

	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

	        configFromArray(config);
	        checkOverflow(config);
	    }


	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;

	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }

	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,

	            scoreToBeat,
	            i,
	            currentScore;

	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }

	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);

	            if (!isValid(tempConfig)) {
	                continue;
	            }

	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;

	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	            getParsingFlags(tempConfig).score = currentScore;

	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }

	        extend(config, bestMoment || tempConfig);
	    }

	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }

	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });

	        configFromArray(config);
	    }

	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }

	        return res;
	    }

	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;

	        config._locale = config._locale || getLocale(config._l);

	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }

	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }

	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }

	        if (!isValid(config)) {
	            config._d = null;
	        }

	        return config;
	    }

	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }

	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};

	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }

	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;

	        return createFromConfig(c);
	    }

	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }

	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );

	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );

	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }

	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isBefore', args);
	    }

	    function max () {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isAfter', args);
	    }

	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };

	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }

	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }

	        return true;
	    }

	    function isValid$1() {
	        return this._isValid;
	    }

	    function createInvalid$1() {
	        return createDuration(NaN);
	    }

	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;

	        this._isValid = isDurationValid(normalizedInput);

	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;

	        this._data = {};

	        this._locale = getLocale();

	        this._bubble();
	    }

	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }

	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }

	    // FORMATTING

	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }

	    offset('Z', ':');
	    offset('ZZ', '');

	    // PARSING

	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });

	    // HELPERS

	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;

	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);

	        if (matches === null) {
	            return null;
	        }

	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);

	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }

	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }

	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }

	    // HOOKS

	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};

	    // MOMENTS

	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }

	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }

	            this.utcOffset(input, keepLocalTime);

	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }

	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }

	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;

	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }

	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }

	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;

	        return (this.utcOffset() - input) % 60 === 0;
	    }

	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }

	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }

	        var c = {};

	        copyConfig(c, this);
	        c = prepareConfig(c);

	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }

	        return this._isDSTShifted;
	    }

	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }

	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }

	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }

	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;

	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }

	        ret = new Duration(duration);

	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }

	        return ret;
	    }

	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;

	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }

	    function positiveMomentsDifference(base, other) {
	        var res = {};

	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }

	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

	        return res;
	    }

	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }

	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }

	        return res;
	    }

	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }

	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }

	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);

	        if (!mom.isValid()) {
	            // No op
	            return;
	        }

	        updateOffset = updateOffset == null ? true : updateOffset;

	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }

	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');

	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }

	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';

	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }

	    function clone () {
	        return new Moment(this);
	    }

	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }

	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }

	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }

	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }

	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }

	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }

	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;

	        if (!this.isValid()) {
	            return NaN;
	        }

	        that = cloneWithOffset(input, this);

	        if (!that.isValid()) {
	            return NaN;
	        }

	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	        units = normalizeUnits(units);

	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }

	        return asFloat ? output : absFloor(output);
	    }

	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;

	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }

	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }

	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }

	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }

	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';

	        return this.format(prefix + year + datetime + suffix);
	    }

	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }

	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }

	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }

	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;

	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }

	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );

	    function localeData () {
	        return this._locale;
	    }

	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }

	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }

	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }

	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }

	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }

	    function toDate () {
	        return new Date(this.valueOf());
	    }

	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }

	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }

	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }

	    function isValid$2 () {
	        return isValid(this);
	    }

	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }

	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }

	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }

	    // FORMATTING

	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });

	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });

	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }

	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	    // ALIASES

	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');

	    // PRIORITY

	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);


	    // PARSING

	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);

	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });

	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });

	    // MOMENTS

	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }

	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }

	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }

	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }

	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }

	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }

	    // FORMATTING

	    addFormatToken('Q', 0, 'Qo', 'quarter');

	    // ALIASES

	    addUnitAlias('quarter', 'Q');

	    // PRIORITY

	    addUnitPriority('quarter', 7);

	    // PARSING

	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });

	    // MOMENTS

	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }

	    // FORMATTING

	    addFormatToken('D', ['DD', 2], 'Do', 'date');

	    // ALIASES

	    addUnitAlias('date', 'D');

	    // PRIORITY
	    addUnitPriority('date', 9);

	    // PARSING

	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });

	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });

	    // MOMENTS

	    var getSetDayOfMonth = makeGetSet('Date', true);

	    // FORMATTING

	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	    // ALIASES

	    addUnitAlias('dayOfYear', 'DDD');

	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);

	    // PARSING

	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });

	    // HELPERS

	    // MOMENTS

	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }

	    // FORMATTING

	    addFormatToken('m', ['mm', 2], 0, 'minute');

	    // ALIASES

	    addUnitAlias('minute', 'm');

	    // PRIORITY

	    addUnitPriority('minute', 14);

	    // PARSING

	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);

	    // MOMENTS

	    var getSetMinute = makeGetSet('Minutes', false);

	    // FORMATTING

	    addFormatToken('s', ['ss', 2], 0, 'second');

	    // ALIASES

	    addUnitAlias('second', 's');

	    // PRIORITY

	    addUnitPriority('second', 15);

	    // PARSING

	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);

	    // MOMENTS

	    var getSetSecond = makeGetSet('Seconds', false);

	    // FORMATTING

	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });

	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });

	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });


	    // ALIASES

	    addUnitAlias('millisecond', 'ms');

	    // PRIORITY

	    addUnitPriority('millisecond', 16);

	    // PARSING

	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);

	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }

	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }

	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS

	    var getSetMillisecond = makeGetSet('Milliseconds', false);

	    // FORMATTING

	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');

	    // MOMENTS

	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }

	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }

	    var proto = Moment.prototype;

	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }

	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }

	    function preParsePostFormat (string) {
	        return string;
	    }

	    var proto$1 = Locale.prototype;

	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;

	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;

	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;

	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }

	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';

	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }

	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }

	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;

	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        }

	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;

	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }

	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }

	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }

	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }

	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }

	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }

	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }

	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });

	    // Side effect imports

	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

	    var mathAbs = Math.abs;

	    function abs () {
	        var data           = this._data;

	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);

	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);

	        return this;
	    }

	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);

	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;

	        return duration._bubble();
	    }

	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }

	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }

	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }

	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;

	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }

	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;

	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;

	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;

	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;

	        days += absFloor(hours / 24);

	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        data.days   = days;
	        data.months = months;
	        data.years  = years;

	        return this;
	    }

	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }

	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }

	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;

	        units = normalizeUnits(units);

	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }

	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }

	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }

	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');

	    function clone$1 () {
	        return createDuration(this);
	    }

	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }

	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }

	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');

	    function weeks () {
	        return absFloor(this.days() / 7);
	    }

	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };

	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }

	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));

	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];

	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }

	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }

	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }

	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);

	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }

	        return locale.postformat(output);
	    }

	    var abs$1 = Math.abs;

	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }

	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;

	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;

	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;


	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();

	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }

	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }

	    var proto$2 = Duration.prototype;

	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;

	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;

	    // Side effect imports

	    // FORMATTING

	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');

	    // PARSING

	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });

	    // Side effect imports


	    hooks.version = '2.24.0';

	    setHookCallback(createLocal);

	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;

	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };

	    return hooks;

	})));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)(module)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 34,
		"./af.js": 34,
		"./ar": 35,
		"./ar-dz": 36,
		"./ar-dz.js": 36,
		"./ar-kw": 37,
		"./ar-kw.js": 37,
		"./ar-ly": 38,
		"./ar-ly.js": 38,
		"./ar-ma": 39,
		"./ar-ma.js": 39,
		"./ar-sa": 40,
		"./ar-sa.js": 40,
		"./ar-tn": 41,
		"./ar-tn.js": 41,
		"./ar.js": 35,
		"./az": 42,
		"./az.js": 42,
		"./be": 43,
		"./be.js": 43,
		"./bg": 44,
		"./bg.js": 44,
		"./bm": 45,
		"./bm.js": 45,
		"./bn": 46,
		"./bn.js": 46,
		"./bo": 47,
		"./bo.js": 47,
		"./br": 48,
		"./br.js": 48,
		"./bs": 49,
		"./bs.js": 49,
		"./ca": 50,
		"./ca.js": 50,
		"./cs": 51,
		"./cs.js": 51,
		"./cv": 52,
		"./cv.js": 52,
		"./cy": 53,
		"./cy.js": 53,
		"./da": 54,
		"./da.js": 54,
		"./de": 55,
		"./de-at": 56,
		"./de-at.js": 56,
		"./de-ch": 57,
		"./de-ch.js": 57,
		"./de.js": 55,
		"./dv": 58,
		"./dv.js": 58,
		"./el": 59,
		"./el.js": 59,
		"./en-SG": 60,
		"./en-SG.js": 60,
		"./en-au": 61,
		"./en-au.js": 61,
		"./en-ca": 62,
		"./en-ca.js": 62,
		"./en-gb": 63,
		"./en-gb.js": 63,
		"./en-ie": 64,
		"./en-ie.js": 64,
		"./en-il": 65,
		"./en-il.js": 65,
		"./en-nz": 66,
		"./en-nz.js": 66,
		"./eo": 67,
		"./eo.js": 67,
		"./es": 68,
		"./es-do": 69,
		"./es-do.js": 69,
		"./es-us": 70,
		"./es-us.js": 70,
		"./es.js": 68,
		"./et": 71,
		"./et.js": 71,
		"./eu": 72,
		"./eu.js": 72,
		"./fa": 73,
		"./fa.js": 73,
		"./fi": 74,
		"./fi.js": 74,
		"./fo": 75,
		"./fo.js": 75,
		"./fr": 76,
		"./fr-ca": 77,
		"./fr-ca.js": 77,
		"./fr-ch": 78,
		"./fr-ch.js": 78,
		"./fr.js": 76,
		"./fy": 79,
		"./fy.js": 79,
		"./ga": 80,
		"./ga.js": 80,
		"./gd": 81,
		"./gd.js": 81,
		"./gl": 82,
		"./gl.js": 82,
		"./gom-latn": 83,
		"./gom-latn.js": 83,
		"./gu": 84,
		"./gu.js": 84,
		"./he": 85,
		"./he.js": 85,
		"./hi": 86,
		"./hi.js": 86,
		"./hr": 87,
		"./hr.js": 87,
		"./hu": 88,
		"./hu.js": 88,
		"./hy-am": 89,
		"./hy-am.js": 89,
		"./id": 90,
		"./id.js": 90,
		"./is": 91,
		"./is.js": 91,
		"./it": 92,
		"./it-ch": 93,
		"./it-ch.js": 93,
		"./it.js": 92,
		"./ja": 94,
		"./ja.js": 94,
		"./jv": 95,
		"./jv.js": 95,
		"./ka": 96,
		"./ka.js": 96,
		"./kk": 97,
		"./kk.js": 97,
		"./km": 98,
		"./km.js": 98,
		"./kn": 99,
		"./kn.js": 99,
		"./ko": 100,
		"./ko.js": 100,
		"./ku": 101,
		"./ku.js": 101,
		"./ky": 102,
		"./ky.js": 102,
		"./lb": 103,
		"./lb.js": 103,
		"./lo": 104,
		"./lo.js": 104,
		"./lt": 105,
		"./lt.js": 105,
		"./lv": 106,
		"./lv.js": 106,
		"./me": 107,
		"./me.js": 107,
		"./mi": 108,
		"./mi.js": 108,
		"./mk": 109,
		"./mk.js": 109,
		"./ml": 110,
		"./ml.js": 110,
		"./mn": 111,
		"./mn.js": 111,
		"./mr": 112,
		"./mr.js": 112,
		"./ms": 113,
		"./ms-my": 114,
		"./ms-my.js": 114,
		"./ms.js": 113,
		"./mt": 115,
		"./mt.js": 115,
		"./my": 116,
		"./my.js": 116,
		"./nb": 117,
		"./nb.js": 117,
		"./ne": 118,
		"./ne.js": 118,
		"./nl": 119,
		"./nl-be": 120,
		"./nl-be.js": 120,
		"./nl.js": 119,
		"./nn": 121,
		"./nn.js": 121,
		"./pa-in": 122,
		"./pa-in.js": 122,
		"./pl": 123,
		"./pl.js": 123,
		"./pt": 124,
		"./pt-br": 125,
		"./pt-br.js": 125,
		"./pt.js": 124,
		"./ro": 126,
		"./ro.js": 126,
		"./ru": 127,
		"./ru.js": 127,
		"./sd": 128,
		"./sd.js": 128,
		"./se": 129,
		"./se.js": 129,
		"./si": 130,
		"./si.js": 130,
		"./sk": 131,
		"./sk.js": 131,
		"./sl": 132,
		"./sl.js": 132,
		"./sq": 133,
		"./sq.js": 133,
		"./sr": 134,
		"./sr-cyrl": 135,
		"./sr-cyrl.js": 135,
		"./sr.js": 134,
		"./ss": 136,
		"./ss.js": 136,
		"./sv": 137,
		"./sv.js": 137,
		"./sw": 138,
		"./sw.js": 138,
		"./ta": 139,
		"./ta.js": 139,
		"./te": 140,
		"./te.js": 140,
		"./tet": 141,
		"./tet.js": 141,
		"./tg": 142,
		"./tg.js": 142,
		"./th": 143,
		"./th.js": 143,
		"./tl-ph": 144,
		"./tl-ph.js": 144,
		"./tlh": 145,
		"./tlh.js": 145,
		"./tr": 146,
		"./tr.js": 146,
		"./tzl": 147,
		"./tzl.js": 147,
		"./tzm": 148,
		"./tzm-latn": 149,
		"./tzm-latn.js": 149,
		"./tzm.js": 148,
		"./ug-cn": 150,
		"./ug-cn.js": 150,
		"./uk": 151,
		"./uk.js": 151,
		"./ur": 152,
		"./ur.js": 152,
		"./uz": 153,
		"./uz-latn": 154,
		"./uz-latn.js": 154,
		"./uz.js": 153,
		"./vi": 155,
		"./vi.js": 155,
		"./x-pseudo": 156,
		"./x-pseudo.js": 156,
		"./yo": 157,
		"./yo.js": 157,
		"./zh-cn": 158,
		"./zh-cn.js": 158,
		"./zh-hk": 159,
		"./zh-hk.js": 159,
		"./zh-tw": 160,
		"./zh-tw.js": 160
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 33;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });

	    return af;

	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];

	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return ar;

	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return arDz;

	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return arKw;

	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];

	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return arLy;

	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return arMa;

	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };

	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return arSa;

	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return arTn;

	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };

	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return az;

	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }

	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return be;

	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return bg;

	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return bm;

	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };

	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return bn;

	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };

	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return bo;

	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }

	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return br;

	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }

	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return bs;

	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ca;

	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }

	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return cs;

	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return cv;

	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return cy;

	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return da;

	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }

	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return de;

	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }

	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return deAt;

	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }

	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return deCh;

	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];

	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {

	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return dv;

	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';

	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }


	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });

	    return el;

	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return enSG;

	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return enAu;

	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });

	    return enCa;

	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return enGb;

	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return enIe;

	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });

	    return enIl;

	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return enNz;

	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return eo;

	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return es;

	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return esDo;

	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return esUs;

	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }

	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return et;

	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return eu;

	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };

	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return fa;

	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }

	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fi;

	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fo;

	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');

	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');

	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fr;

	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');

	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });

	    return frCa;

	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');

	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return frCh;

	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return fy;

	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';



	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];

	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];

	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];

	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];

	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];

	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ga;

	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];

	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return gd;

	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return gl;

	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }

	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });

	    return gomLatn;

	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };

	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return gu;

	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });

	    return he;

	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };

	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return hi;

	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }

	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return hr;

	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }

	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return hu;

	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return hyAm;

	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return id;

	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }

	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return is;

	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return it;

	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return itCh;

	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });

	    return ja;

	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return jv;

	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });

	    return ka;

	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };

	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return kk;

	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };

	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return km;

	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };

	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return kn;

	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });

	    return ko;

	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];


	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return ku;

	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };

	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return ky;

	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }

	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return lb;

	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });

	    return lo;

	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return lt;

	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }

	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return lv;

	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };

	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',

	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return me;

	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return mi;

	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return mk;

	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });

	    return ml;

	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }

	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });

	    return mn;

	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };

	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }

	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return mr;

	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return ms;

	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return msMy;

	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return mt;

	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };

	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return my;

	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nb;

	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };

	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return ne;

	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },

	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,

	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nl;

	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },

	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,

	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nlBe;

	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return nn;

	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };

	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return paIn;

	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }

	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';

	                    case 2:
	                        return '[We wtorek o] LT';

	                    case 3:
	                        return '[W środę o] LT';

	                    case 6:
	                        return '[W sobotę o] LT';

	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return pl;

	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return pt;

	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });

	    return ptBr;

	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }

	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return ro;

	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,

	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ru;

	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];

	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sd;

	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return se;

	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });

	    return si;

	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }

	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sk;

	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }

	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',

	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return sl;

	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sq;

	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };

	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return sr;

	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };

	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return srCyrl;

	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ss;

	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return sv;

	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return sw;

	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };

	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return ta;

	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });

	    return te;

	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return tet;

	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };

	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });

	    return tg;

	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });

	    return th;

	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return tlPh;

	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }

	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }

	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }

	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }

	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return tlh;

	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';

	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };

	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return tr;

	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }

	    return tzl;

	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return tzm;

	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });

	    return tzmLatn;

	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },

	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });

	    return ugCn;

	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };

	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }

	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }

	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return uk;

	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];

	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return ur;

	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return uz;

	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });

	    return uzLatn;

	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return vi;

	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return xPseudo;

	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return yo;

	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });

	    return zhCn;

	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });

	    return zhHk;

	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration

	;(function (global, factory) {
	    true ? factory(__webpack_require__(32)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';


	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });

	    return zhTw;

	})));


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UploadFileController = function () {
	  UploadFileController.$inject = ["$scope", "$element", "$attrs", "$timeout", "App", "$translate"];
	  function UploadFileController($scope, $element, $attrs, $timeout, App, $translate) {
	    'ngInject';

	    _classCallCheck(this, UploadFileController);

	    this.$scope = $scope;
	    this.$element = $element;
	    this.$timeout = $timeout;
	    this.App = App;
	    this.$translate = $translate;

	    this.maxFileSize = 3 * 1024 * 1024; // 3MB default size
	    this.isDragOver = false;
	    this.errorMessage = '';
	    this.file = null;
	    this.fileName = '';
	  }

	  _createClass(UploadFileController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      if (this.maxFileSizeAttr) {
	        this.maxFileSize = this.maxFileSizeAttr;
	      }

	      this._setupEventListeners();
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this._removeEventListeners();
	    }
	  }, {
	    key: '_setupEventListeners',
	    value: function _setupEventListeners() {
	      var _this = this;

	      var dropZone = this.$element.find('.upload-drop-zone')[0];

	      if (dropZone) {
	        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
	          dropZone.addEventListener(eventName, _this._preventDefaults.bind(_this), false);
	        });

	        ['dragenter', 'dragover'].forEach(function (eventName) {
	          dropZone.addEventListener(eventName, _this._handleDragEnter.bind(_this), false);
	        });

	        ['dragleave', 'drop'].forEach(function (eventName) {
	          dropZone.addEventListener(eventName, _this._handleDragLeave.bind(_this), false);
	        });

	        dropZone.addEventListener('drop', this._handleDrop.bind(this), false);
	      }
	    }
	  }, {
	    key: '_removeEventListeners',
	    value: function _removeEventListeners() {
	      var _this2 = this;

	      var dropZone = this.$element.find('.upload-drop-zone')[0];

	      if (dropZone) {
	        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (eventName) {
	          dropZone.removeEventListener(eventName, _this2._preventDefaults.bind(_this2), false);
	          dropZone.removeEventListener(eventName, _this2._handleDragEnter.bind(_this2), false);
	          dropZone.removeEventListener(eventName, _this2._handleDragLeave.bind(_this2), false);
	          dropZone.removeEventListener(eventName, _this2._handleDrop.bind(_this2), false);
	        });
	      }
	    }
	  }, {
	    key: '_preventDefaults',
	    value: function _preventDefaults(e) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }, {
	    key: '_handleDragEnter',
	    value: function _handleDragEnter() {
	      this.isDragOver = true;
	      this._clearMessages();
	    }
	  }, {
	    key: '_handleDragLeave',
	    value: function _handleDragLeave() {
	      this.isDragOver = false;
	    }
	  }, {
	    key: '_handleDrop',
	    value: function _handleDrop(e) {
	      this.isDragOver = false;

	      var files = e.dataTransfer.files;
	      if (files.length > 0) {
	        this._handleFileSelection(files[0]);
	      }
	    }
	  }, {
	    key: '_handleFileSelection',
	    value: function _handleFileSelection(file) {
	      this._clearMessages();

	      if (this._validateFile(file)) {
	        this.file = file;
	        this.fileName = file.name;

	        if (this.onFileSelected) {
	          this.onFileSelected({ file: file });
	        }
	      } else {
	        this.removeFile(false);
	      }

	      this.$scope.$apply();
	    }
	  }, {
	    key: '_validateFile',
	    value: function _validateFile(file) {
	      if (file.size > this.maxFileSize) {
	        this.errorMessage = this.$translate.instant('UPLOAD_FILE_ERROR_SIZE', {
	          maxSize: this._formatFileSize(this.maxFileSize)
	        });
	        return false;
	      }

	      if (!this.allowedTypes.includes(file.type) && file.type !== '') {
	        this.errorMessage = this.$translate.instant('UPLOAD_FILE_ERROR_TYPE', {
	          allowedTypes: this.allowedTypes.join(', ')
	        });
	        return false;
	      }

	      var fileName = file.name.toLowerCase();
	      var hasValidExtension = this.allowedExtensions.some(function (ext) {
	        return fileName.endsWith(ext);
	      });

	      if (!hasValidExtension) {
	        this.errorMessage = this.$translate.instant('UPLOAD_FILE_ERROR_EXTENSION', {
	          allowedExtensions: this.allowedExtensions.join(', ')
	        });
	        return false;
	      }

	      return true;
	    }
	  }, {
	    key: '_formatFileSize',
	    value: function _formatFileSize(bytes) {
	      if (bytes === 0) return '0 Bytes';
	      var k = 1024;
	      var sizes = ['Bytes', 'KB', 'MB', 'GB'];
	      var i = Math.floor(Math.log(bytes) / Math.log(k));
	      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
	    }
	  }, {
	    key: '_clearMessages',
	    value: function _clearMessages() {
	      this.errorMessage = '';
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile() {
	      var clearMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	      this.file = null;
	      this.fileName = '';
	      if (clearMessages) {
	        this._clearMessages();
	      }

	      if (this.onFileRemoved) {
	        this.onFileRemoved();
	      }
	    }
	  }, {
	    key: 'onFileInputChange',
	    value: function onFileInputChange(event) {
	      var file = event.target.files[0];
	      if (file) {
	        this._handleFileSelection(file);
	      }
	    }
	  }]);

	  return UploadFileController;
	}();

	exports.default = angular.module('uploadFile', []).directive('uploadFile', function () {
	  return {
	    restrict: 'E',
	    templateUrl: 'app/directives/upload-file/upload-file.html',
	    scope: {
	      file: '=?',
	      externalErrorMessage: '=?',

	      maxFileSizeAttr: '=?',
	      allowedExtensions: '=?',
	      allowedTypes: '=?',

	      disabled: '=?',

	      onFileSelected: '&',
	      onFileRemoved: '&'
	    },
	    controller: ["$scope", "$element", "$attrs", "$timeout", "App", "$translate", function controller($scope, $element, $attrs, $timeout, App, $translate) {
	      return new UploadFileController($scope, $element, $attrs, $timeout, App, $translate);
	    }],
	    controllerAs: 'ctrl',
	    bindToController: true,
	    link: function link(scope, element, attrs, ctrl) {
	      var fileInput = element.find('input[type="file"]');
	      fileInput.attr('accept', ctrl.allowedExtensions.join(', '));
	      fileInput.attr('disabled', ctrl.disabled);
	    }
	  };
	}).name;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.widgetFilters = widgetFilters;

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function widgetFilters() {
	    'ngInject';

	    var directive = {
	        restrict: 'E',
	        templateUrl: 'app/directives/widget-filters/widget-filters.html',
	        scope: {
	            filters: '=params',
	            onReload: '&',
	            onClearOcppPagination: '&',
	            controls: '=?',
	            displayButton: '=?'
	        },
	        controller: widgetFiltersController,
	        controllerAs: 'ctrl',
	        bindToController: true
	    };

	    return directive;
	}

	var widgetFiltersController = function () {
	    widgetFiltersController.$inject = ["$state", "$scope", "$rootScope", "$location", "App", "$timeout", "moment"];
	    function widgetFiltersController($state, $scope, $rootScope, $location, App, $timeout, moment) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, widgetFiltersController);

	        this.$state = $state;
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$location = $location;
	        this.App = App;
	        this.$timeout = $timeout;
	        this.moment = moment;
	        this.initiated = false;

	        $scope.$watchCollection('ctrl.filters', function () {
	            if (!_this.initiated && _lodash2.default.isArray(_this.filters) && _this.filters.length > 0) _this._onInit();
	        });
	    }

	    _createClass(widgetFiltersController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (!this.initiated && _lodash2.default.isArray(this.filters) && this.filters.length > 0) this._onInit();
	        }
	    }, {
	        key: '_onInit',
	        value: function _onInit() {
	            var _this2 = this;

	            this.initiated = true;
	            this._onChangeForced = this._onChangeForced.bind(this);
	            this._clearAllInFilterGroup = this._clearAllInFilterGroup.bind(this);

	            this.id = this.App.getUID('filter');
	            this.mainFilters = _lodash2.default.filter(this.filters, function (filter) {
	                return !filter.advanced;
	            });
	            this.filterGroups = {};
	            this.advancedFiltersOpen = false;
	            this.withAdvancedFilters = this.filters.length - this.mainFilters.length > 0;
	            this.displayButton = this.displayButton != undefined ? this.displayButton : true;

	            // Exported controls
	            if (this.controls) {
	                this.controls['toggleAdvancedFilters'] = function () {
	                    _this2.advancedFiltersOpen = !_this2.advancedFiltersOpen;
	                };
	                this.controls['clear'] = function () {
	                    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	                    var avoidReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	                    var filters = list.length > 0 ? list : _this2.filters;
	                    _lodash2.default.each(filters, function (filter) {
	                        return _this2._clear(filter, avoidReload);
	                    });
	                };
	            }

	            this.$scope.$watch('ctrl.advancedFiltersOpen', function () {
	                _this2.$timeout(function () {
	                    return _this2.$rootScope.$broadcast('rzSliderForceRender');
	                }, 0); // Hack
	            });

	            this.getFilterGroups();

	            _lodash2.default.each(this.filters, function (filter) {
	                // Init
	                _this2._init(filter);
	                // Set useful functions in own filter
	                filter._isActive = function () {
	                    return _this2._isActive(filter);
	                };

	                filter._clear = function () {
	                    return _this2._clear(filter);
	                };
	            });
	        }
	    }, {
	        key: '_isActive',
	        value: function _isActive(filter) {
	            if (filter.value && (!filter.defaultValue || filter.defaultValue !== filter.value)) {
	                if (filter.type === 'select' && filter.value != 'all') {
	                    return true;
	                }
	                if (filter.type === 'text' && filter.value.length > 0) {
	                    return true;
	                }
	                if (filter.type === 'date' && _lodash2.default.isDate(filter.value)) {
	                    return true;
	                }
	                if (filter.type === 'range') {
	                    if (filter.value.min > filter.options.floor) return true;
	                    if (filter.value.max < filter.options.ceil) return true;
	                    return false;
	                }
	                if (filter.type === 'number' && filter.value != 0) {
	                    return true;
	                }

	                if (filter.type === 'multi-select') {
	                    return filter.value.length != filter.defaultValue.length;
	                }

	                if (filter.type === 'select-search' && filter.value) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: '_onChange',
	        value: function _onChange(filter) {
	            var _this3 = this;

	            if (!filter) return;

	            if (filter.url && filter.scope && filter.scope.url) {
	                filter.url = filter.scope.url;
	            }

	            if (['select', 'date', 'buttons', 'multi-select', 'select-search'].includes(filter.type)) {
	                if (this.onClearOcppPagination()) {
	                    this.onClearOcppPagination()();
	                }
	                this.$timeout(function () {
	                    return _this3._onReload();
	                }, 0);
	            }
	        }
	    }, {
	        key: 'onComboChange',
	        value: function onComboChange(filter, scope) {
	            if (scope && scope.url) {
	                if (this.$location.search()[filter.url]) {
	                    this.$location.search(filter.url, undefined);
	                    this.$location.search(scope.url, filter.value);
	                }
	                filter.url = scope.url;
	            }
	            filter.scope = scope;
	        }
	    }, {
	        key: 'onSelectArea',
	        value: function onSelectArea(filter, item) {
	            var value = item.id;
	            if (filter.url && angular.isDefined(filter.valueName)) {
	                var valueName = filter.values.find(function (d) {
	                    return d.id === item.id;
	                });
	                if (valueName) {
	                    if (valueName.id === 'all') {
	                        value = null;
	                        filter.valueName = null;
	                        this.$location.search(filter.url, undefined);
	                    } else {
	                        filter.valueName = valueName.label;
	                        this.$location.search(filter.url, valueName.label);
	                    }
	                }
	            }
	            filter.value = value;
	            this._onReload();
	        }
	    }, {
	        key: '_onReload',
	        value: function _onReload() {
	            if (this.onReload()) {
	                this._updateUrlFilters();
	                this.onReload()();
	            }
	        }
	    }, {
	        key: '_updateUrlFilters',
	        value: function _updateUrlFilters() {
	            var data = {};
	            _lodash2.default.each(this.filters, function (filter) {
	                if (filter.url !== true) {
	                    data[filter.url] = angular.isObject(filter.value) ? encodeURIComponent(JSON.stringify(filter.value)) : filter.value;
	                }
	            });
	            this.$state.transitionTo(this.$state.current.name, data, {
	                notify: false,
	                reload: false,
	                inherit: true,
	                location: 'replace'
	            });
	        }
	    }, {
	        key: '_onChangeForced',
	        value: function _onChangeForced() {
	            this._onReload();
	        }
	    }, {
	        key: '_clear',
	        value: function _clear(filter, avoidReload) {
	            if (filter.hide) return;
	            if (filter.type === 'buttons') return;
	            if (filter.type === 'range') {
	                filter.value.min = filter.options.floor;
	                filter.value.max = filter.options.ceil;
	            } else if (filter.type === 'multi-select') {
	                filter.value = filter.defaultValue;
	            } else {
	                filter.value = filter.defaultValue || null;
	                filter.valueName = null;
	            }
	            if (!avoidReload) {
	                if (this.onClearOcppPagination()) {
	                    this.onClearOcppPagination()();
	                }
	                this._onReload();
	            }
	        }
	    }, {
	        key: '_clearAllInFilterGroup',
	        value: function _clearAllInFilterGroup(filterGroup) {
	            var _this4 = this;

	            var currentActive = 0;
	            _lodash2.default.each(filterGroup.filters, function (filter) {
	                if (_this4._isActive(filter)) {
	                    if (filter.filterGroup.metaFilter) {
	                        if (filter.type === 'range') {
	                            filterGroup.metaFilters[filter.filterGroup.metaFilter] = {
	                                'min': filter.value.min,
	                                'max': filter.value.max
	                            };
	                        } else {
	                            filterGroup.metaFilters[filter.filterGroup.metaFilter] = filter.value;
	                        }
	                    }
	                    currentActive++;
	                }
	                _this4._clear(filter, true);
	            });
	            this.$timeout(function () {
	                _this4.$rootScope.$broadcast('rzSliderForceRender');
	            }, 0); // Hack
	            if (currentActive > 0) {
	                // Preload values from other combo value
	                _lodash2.default.each(filterGroup.filters, function (filter) {
	                    if (filter.filterGroup.comboId === filterGroup.currentComboId) {
	                        if (filter.filterGroup.metaFilter && filterGroup.metaFilters[filter.filterGroup.metaFilter]) {
	                            if (filter.type === 'range') {
	                                filter.value.min = filterGroup.metaFilters[filter.filterGroup.metaFilter].min;
	                                filter.value.max = filterGroup.metaFilters[filter.filterGroup.metaFilter].max;
	                            } else {
	                                filter.value = filterGroup.metaFilters[filter.filterGroup.metaFilter];
	                            }
	                            filterGroup.metaFilters[filter.filterGroup.metaFilter] = null;
	                        }
	                    }
	                });
	                this._onReload();
	            }
	        }
	    }, {
	        key: '_clearAll',
	        value: function _clearAll() {
	            var _this5 = this;

	            _lodash2.default.each(this.filters, function (filter) {
	                return _this5._clear(filter, true);
	            });
	            if (this.onClearOcppPagination()) {
	                this.onClearOcppPagination()();
	            }
	            this._onReload();
	        }
	    }, {
	        key: '_totalActive',
	        value: function _totalActive() {
	            var _this6 = this;

	            var total = 0;
	            _lodash2.default.each(this.filters, function (filter) {
	                if (_this6._isActive(filter) && !filter.hide && filter.type !== 'buttons') total++;
	            });
	            return total;
	        }
	    }, {
	        key: '_init',
	        value: function _init(filter) {
	            if (!filter) return;
	            if (filter.type === 'select') {
	                if (!filter.values && filter.initValues) filter.values = filter.initValues;
	            }
	        }
	    }, {
	        key: '_asLabel',
	        value: function _asLabel(filter) {
	            if (filter && filter.type === 'select') {
	                var value = _lodash2.default.find(filter.values, { id: filter.value });
	                if (value) return value.label;
	            }
	            return filter.value;
	        }
	    }, {
	        key: '_openSelect',
	        value: function _openSelect(filter) {
	            if (filter && filter.type === 'select' && !filter._valuesLoaded && _lodash2.default.isFunction(filter.reloadValues)) {
	                filter._valuesLoaded = 'loading';
	                filter.reloadValues(filter).then(function (values) {
	                    filter.values = values;
	                    filter._valuesLoaded = true;
	                });
	            }
	        }
	    }, {
	        key: '_onSubmit',
	        value: function _onSubmit() {
	            this._onReload();
	        }
	    }, {
	        key: 'getFilterGroups',
	        value: function getFilterGroups() {
	            var _this7 = this;

	            this.filterGroups = {};
	            _lodash2.default.each(this.filters, function (filter) {
	                if (filter.filterGroup && filter.filterGroup.id) {
	                    if (!_this7.filterGroups[filter.filterGroup.id]) {
	                        _this7.filterGroups[filter.filterGroup.id] = filter.filterGroup;
	                        _this7.filterGroups[filter.filterGroup.id]['filters'] = [];
	                        _this7.filterGroups[filter.filterGroup.id]['metaFilters'] = {};
	                    }
	                    _this7.filterGroups[filter.filterGroup.id].filters.push(filter);
	                    if (filter.filterGroup.metaFilter) _this7.filterGroups[filter.filterGroup.id].metaFilters[filter.filterGroup.metaFilter] = null;

	                    if (filter.filterGroup.currentComboId) {
	                        _this7.filterGroups[filter.filterGroup.id]['currentComboId'] = filter.filterGroup.currentComboId;
	                    }
	                }
	            });
	        }
	    }]);

	    return widgetFiltersController;
	}();

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.widgetTable = widgetTable;

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function widgetTable() {
	    'ngInject';

	    return {
	        templateUrl: 'app/directives/widget-table/widget-table.html',
	        scope: {
	            table: '=params',
	            items: '=',
	            enabledBreadcrumbs: '=',
	            breadcrumbs: '=',
	            onItemClick: '&',
	            onItemMouse: '&',
	            onReload: '&',
	            onReloadPagination: '&',
	            onClickBreadcrumb: '&'
	        },
	        controller: WidgetTableController,
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}

	var WidgetTableController = function () {
	    WidgetTableController.$inject = ["$scope", "$timeout", "App", "$translate", "$filter"];
	    function WidgetTableController($scope, $timeout, App, $translate, $filter) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, WidgetTableController);

	        this.$timeout = $timeout;
	        this.App = App;
	        this.$translate = $translate;
	        this.$filter = $filter;

	        this.compact = this.table && this.table.compact === true;
	        this.itemsPerPageOptions = [10, 20, 50];

	        $scope.$watch('ctrl.table.pagination.itemsPerPage', function (current, prev) {
	            if (prev && current != prev) {
	                _this._onReload();
	            }
	        });

	        $scope.$watchCollection('ctrl.items', function () {
	            if (_this.table && _this.table.synchronous && _this.items && _this.items.length >= 0) {
	                _this.table.pagination.totalItems = _this.items.length;
	            }
	            if (_this.table && _this.table.pagination) {
	                _this.reloadPagination();
	            }
	        });
	    }

	    _createClass(WidgetTableController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.clickable = this.onItemClick;
	            if (this.table) {
	                this.table['controls'] = {
	                    'pulse': this._pulse.bind(this)
	                };
	            }
	        }
	    }, {
	        key: 'reloadPagination',
	        value: function reloadPagination() {
	            this.start = (this.table.pagination.currentPage - 1) * this.table.pagination.itemsPerPage + 1;
	            this.end = this.table.pagination.totalItems;
	            if (this.table.pagination.itemsPerPage < this.table.pagination.totalItems) {
	                this.end = this.table.pagination.itemsPerPage * this.table.pagination.currentPage;
	                if (this.end > this.table.pagination.totalItems) {
	                    this.end = this.table.pagination.totalItems;
	                }
	            }
	            if (this.onReloadPagination() && this.items) {
	                this.onReloadPagination()(this._sortItems().slice(this.start - 1, this.end));
	            }
	        }
	    }, {
	        key: '_sortItems',
	        value: function _sortItems() {
	            return this.$filter("sorting")(this.items, this.table);
	        }
	    }, {
	        key: '_keyId',
	        value: function _keyId(key) {
	            if (key.indexOf('|') > 0) {
	                return key.substr(0, key.indexOf('|') - 1).trim();
	            }
	            return key;
	        }
	    }, {
	        key: '_onItemClick',
	        value: function _onItemClick(item) {
	            if (this.App.isSelectedText()) return;
	            if (this.onItemClick()) this.onItemClick()(item);
	        }
	    }, {
	        key: '_onItemMouseEnter',
	        value: function _onItemMouseEnter(item) {
	            if (this.onItemMouse()) this.onItemMouse()('enter', item);
	        }
	    }, {
	        key: '_onItemMouseLeave',
	        value: function _onItemMouseLeave(item) {
	            if (this.onItemMouse()) this.onItemMouse()('leave', item);
	        }
	    }, {
	        key: '_isColumnCenter',
	        value: function _isColumnCenter(key) {
	            return this.table && _lodash2.default.isArray(this.table.centerColumns) && this.table.centerColumns.indexOf(this._keyId(key)) >= 0;
	        }
	    }, {
	        key: '_onNewSorting',
	        value: function _onNewSorting(by) {
	            if (_lodash2.default.includes(this.table.sorting.keys, by)) {
	                if (this.table.sorting.key === by) {
	                    this.table.sorting.order = this.table.sorting.order == 'asc' ? 'desc' : 'asc';
	                } else {
	                    this.table.sorting.key = by;
	                }
	                if (this.table.pagination) {
	                    this.table.pagination.currentPage = 1;
	                }
	                this._onReload();
	            }
	        }
	    }, {
	        key: '_onNewPagination',
	        value: function _onNewPagination() {
	            this._onReload();
	        }
	    }, {
	        key: '_getMultiSelectHeaderIcon',
	        value: function _getMultiSelectHeaderIcon() {
	            if (this._isSelectAll()) return 'check';
	            return 'times';
	        }
	    }, {
	        key: '_getMultiSelectHeaderTooltip',
	        value: function _getMultiSelectHeaderTooltip() {
	            if (this._isSelectAll()) return this.$translate.instant('W.TABLE.SELECT_ALL');
	            return this.$translate.instant('W.TABLE.UNSELECT_ALL');
	        }
	    }, {
	        key: '_pulse',
	        value: function _pulse(id) {
	            var predicate = {};
	            predicate[this.table.trackBy || 'id'] = id;
	            var item = _lodash2.default.find(this.items, predicate);
	            if (!item) return;
	            item._pulsing = true;
	            this.$timeout(function () {
	                item._pulsing = false;
	            }, 1200);
	        }
	    }, {
	        key: '_onReload',
	        value: function _onReload() {
	            if (!this.table.synchronous) {
	                this.onReload()();
	            } else {
	                this.reloadPagination();
	            }
	        }
	    }, {
	        key: '_onClickBreadcrumb',
	        value: function _onClickBreadcrumb(index) {
	            var crumb = this.breadcrumbs[index];
	            this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
	            this.onClickBreadcrumb()(crumb);
	        }
	    }, {
	        key: '_onSelectItem',
	        value: function _onSelectItem(item) {
	            if (!this.table.selectable || !this.table.selected) return;
	            switch (this.table.selectable) {
	                case 'multi':
	                    this._toggleMultiSelectedItem(item);
	                    break;
	                case 'one':
	                    this._toggleSelectedItem(item);
	                    break;
	                default:
	                    this.table.selected = [item];
	            }
	        }
	    }, {
	        key: '_isSelected',
	        value: function _isSelected(item) {
	            var _this2 = this;

	            if (!item || !this.table.selected) return false;
	            return this.table.selected.some(function (sel) {
	                return sel[_this2.table.trackBy] === item[_this2.table.trackBy];
	            });
	        }
	    }, {
	        key: '_isSelectAll',
	        value: function _isSelectAll() {
	            var _this3 = this;

	            if (!this.items || !this.items.length) return false;
	            return this.items.every(function (item) {
	                return !_this3.table.selected.some(function (sel) {
	                    return sel[_this3.table.trackBy] === item[_this3.table.trackBy];
	                });
	            });
	        }
	    }, {
	        key: '_onMultiSelectHeader',
	        value: function _onMultiSelectHeader() {
	            var _this4 = this;

	            if (this._isSelectAll()) {
	                this.items.forEach(function (item) {
	                    if (!_this4._isSelected(item)) {
	                        _this4._toggleMultiSelectedItem(item);
	                    }
	                });
	            } else {
	                this.items.forEach(function (item) {
	                    if (_this4._isSelected(item)) {
	                        _this4._toggleMultiSelectedItem(item);
	                    }
	                });
	            }
	        }
	    }, {
	        key: '_toggleMultiSelectedItem',
	        value: function _toggleMultiSelectedItem(item) {
	            var _this5 = this;

	            var index = this.table.selected.findIndex(function (sel) {
	                return sel[_this5.table.trackBy] === item[_this5.table.trackBy];
	            });
	            if (index === -1) {
	                this.table.selected.push(item);
	            } else {
	                this.table.selected.splice(index, 1);
	            }
	        }
	    }, {
	        key: '_toggleSelectedItem',
	        value: function _toggleSelectedItem(item) {
	            var _this6 = this;

	            var index = this.table.selected.findIndex(function (sel) {
	                return sel[_this6.table.trackBy] === item[_this6.table.trackBy];
	            });
	            if (index === -1) {
	                this.table.selected = [item];
	            } else {
	                this.table.selected = [];
	            }
	        }
	    }]);

	    return WidgetTableController;
	}();

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	exports.widgetSearchAutocomplete = widgetSearchAutocomplete;

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function widgetSearchAutocomplete() {
	    'ngInject';

	    return {
	        templateUrl: 'app/directives/widget-search-autocomplete/widget-search-autocomplete.html',
	        scope: {
	            autocomplete: '=params',
	            items: '=',
	            onItemClick: '&',
	            onReload: '&'
	        },
	        controller: widgetSearchAutocompleteController,
	        controllerAs: 'ctrl',
	        bindToController: true
	    };
	}

	var widgetSearchAutocompleteController = function () {
	    widgetSearchAutocompleteController.$inject = ["$scope", "$timeout", "App", "$filter"];
	    function widgetSearchAutocompleteController($scope, $timeout, App, $filter) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, widgetSearchAutocompleteController);

	        this.$timeout = $timeout;
	        this.App = App;
	        this.$filter = $filter;
	        this.throttle = this.autocomplete && this.autocomplete.throttle ? this.autocomplete.throttle : 1200;
	        this.focused = 0;

	        $scope.$watchCollection('ctrl.items', function () {
	            if (_this.autocomplete && _this.autocomplete.synchronous && _this.items && _this.items.length >= 0) {
	                _this.autocomplete.pagination.totalItems = _this.items.length;
	            }
	            if (_this.autocomplete && _this.autocomplete.pagination) _this.reloadPagination();
	        });
	    }

	    _createClass(widgetSearchAutocompleteController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.id = this.App.getUID('autocomplete');
	            this._onChange = _lodash2.default.throttle(this._throttledOnChange.bind(this), this.throttle, { 'leading': false, 'trailing': true });
	        }
	    }, {
	        key: 'reloadPagination',
	        value: function reloadPagination() {
	            this.start = (this.autocomplete.pagination.currentPage - 1) * this.autocomplete.pagination.itemsPerPage + 1;
	            this.end = this.autocomplete.pagination.totalItems;
	            if (this.autocomplete.pagination.itemsPerPage < this.autocomplete.pagination.totalItems) {
	                this.end = this.autocomplete.pagination.itemsPerPage * this.autocomplete.pagination.currentPage;
	                if (this.end > this.autocomplete.pagination.totalItems) {
	                    this.end = this.autocomplete.pagination.totalItems;
	                }
	            }
	        }
	    }, {
	        key: '_keyId',
	        value: function _keyId(key) {
	            if (key.indexOf('|') > 0) {
	                return key.substr(0, key.indexOf('|') - 1).trim();
	            }
	            return key;
	        }
	    }, {
	        key: '_isSelected',
	        value: function _isSelected(item) {
	            if (!item) return false;
	            return _lodash2.default.includes(this.autocomplete.selected, item[this.autocomplete.trackBy]);
	        }
	    }, {
	        key: '_throttledOnChange',
	        value: function _throttledOnChange(filter) {
	            if (!filter) return;
	            this.autocomplete.isTyping = false;
	            this._onReload();
	        }
	    }, {
	        key: '_onItemClick',
	        value: function _onItemClick(item, index) {
	            this.focused = index + 1;
	            if (this.App.isSelectedText()) return;
	            if (this.autocomplete.selectable) {
	                this.autocomplete.selected = [item[this.autocomplete.trackBy]];
	            }
	            if (this.onItemClick()) this.onItemClick()(item);
	        }
	    }, {
	        key: '_onArrowUp',
	        value: function _onArrowUp() {
	            if (this.focused > 0) this.focused--;
	        }
	    }, {
	        key: '_onArrowDown',
	        value: function _onArrowDown() {
	            // var length = (this.$filter('pagination')(this.items, this.autocomplete)).length;
	            // if (this.focused < this.items.length) this.focused++;
	            if (this.focused < this.$filter('pagination')(this.items, this.autocomplete).length) this.focused++;
	        }
	    }, {
	        key: '_onNewPagination',
	        value: function _onNewPagination() {
	            this._onReload();
	        }
	    }, {
	        key: '_onReload',
	        value: function _onReload() {
	            this.focused = 0;
	            if (!this.autocomplete.synchronous) {
	                this.onReload()();
	            } else {
	                this.reloadPagination();
	                if (this.autocomplete.selectable) {
	                    this.autocomplete.selected = [];
	                }
	                this.onReload()();
	            }
	        }
	    }]);

	    return widgetSearchAutocompleteController;
	}();

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('filters', []).filter('safe', function () {
	    return function (html) {
	        return _lodash2.default.escape(html);
	    };
	}).filter('chargepointLink', ["$state", function ($state) {
	    return function (id, options, organization, name, altId) {
	        if (angular.isUndefined(organization)) {
	            organization = $state.params.organization;
	        }
	        name = name || (options ? options.name : null) || id;
	        var href = $state.href('efimob.chargepoints.at.item', { id: altId || id, organization: organization });
	        return '<a href="' + href + '">' + name + '</a>';
	    };
	}]).filter('chargepointName', ["$state", "$translate", "ChargepointHelper", function ($state, $translate, ChargepointHelper) {
	    return function (name, chargepoint) {
	        var response = name || (chargepoint ? chargepoint.name : null) || (chargepoint ? chargepoint.id : null) || '--';
	        var organizationId = chargepoint.organizationId ? chargepoint.organizationId : chargepoint.organization ? chargepoint.organization.id : null;
	        if (chargepoint) {
	            var type = ChargepointHelper.getType(chargepoint);
	            var badge = type !== "" ? '<sup class="neutral" uib-tooltip="' + $translate.instant('FILTER.CHARGEPOINT.' + type + '_HELP') + '">' + type + '</sup>' : "";
	            if (chargepoint.id) {
	                var href = $state.href('efimob.chargepoints.at.item', { id: chargepoint.id, organization: organizationId });
	                response = '<a href="' + href + '">' + response + '</a> ' + badge;
	            } else {
	                response += " " + badge;
	            }
	        }
	        return response;
	    };
	}]).filter('chargepointOrganization', ["$state", "$translate", "$filter", function ($state, $translate, $filter) {
	    return function (organizationName, chargepoint) {
	        var organizationId = chargepoint ? chargepoint.organizationId : null;
	        if (organizationId === null) return '<i class="muted">' + $translate.instant('FILTER.CHARGEPOINT.NOT_ASSIGNED_ONE') + '</i>';
	        var href = $state.href('efimob.organizations.item', { id: organizationId });
	        return '<a href="' + href + '">' + (organizationName ? $filter('safe')(organizationName) : organizationId) + '</a>';
	    };
	}]).filter('chargepointGroup', ["$state", "$filter", function ($state, $filter) {
	    return function (group, chargepoint) {
	        if (chargepoint && chargepoint.groupName) {
	            if (chargepoint.groupId && chargepoint.organizationId) {
	                var href = $state.href('efimob.groups.item', { id: chargepoint.groupId, organization: chargepoint.organizationId });
	                return '<a href="' + href + '">' + $filter('safe')(chargepoint.groupName) + '</a>';
	            }
	            return $filter('safe')(chargepoint.groupName);
	        }
	        return $filter('safe')(group);
	    };
	}]).filter('chargepointOwnership', ["$translate", function ($translate) {
	    return function (ownership) {
	        switch (ownership) {
	            case 'public':
	                return $translate.instant('FILTER.CHARGEPOINT.OWNERSHIP_TYPES.PUBLIC');
	            case 'roaming':
	                return $translate.instant('FILTER.CHARGEPOINT.OWNERSHIP_TYPES.ROAMING');
	        }
	        return ownership;
	    };
	}]).filter('vehicleType', ["$translate", function ($translate) {
	    return function (vehicleType) {
	        switch (vehicleType) {
	            case 'motorcycle':
	                return $translate.instant('FILTER.CHARGEPOINT.VEHICLE_TYPES.MOTORCYCLE');
	            case 'AllVehicles':
	                return $translate.instant('FILTER.CHARGEPOINT.VEHICLE_TYPES.ALL_VEHICLE');
	        }
	        return vehicleType;
	    };
	}]).filter('capabilities', ["$translate", function ($translate) {
	    return function (capabilities) {
	        return capabilities && capabilities.map(function (capability) {
	            return $translate.instant(capability);
	        }).join(', ');
	    };
	}]).filter('chargepointOperationalStatus', ["$filter", "$translate", function ($filter, $translate) {
	    return function (chargepointOperationalStatus) {
	        switch (chargepointOperationalStatus) {
	            case 'Operative':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.OPERATIVE');
	            case 'Disabled':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.DISABLED');
	            case 'WaitingRepair':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.WAITING_REPAIR');
	            case 'InTests':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.IN_TESTS');
	            case 'InWarehouse':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.IN_WAREHOUSE');
	            case 'DeletePending':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.DELETE_PENDING');
	            case 'TestsOK':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.TESTS_OK');
	            case 'OpeningSoon':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.OPENING_SOON');
	            case 'NoManaged':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.NO_MANAGED');
	            case 'SemiPublic':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.SEMIPUBLIC');
	            case 'Private':
	                return $translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.PRIVATE');
	        }
	    };
	}]).filter('chargepointProxyList', function () {
	    return function (proxyList) {
	        var response;
	        if (angular.isArray(proxyList) && proxyList.length > 0) {
	            response = proxyList[0];
	        }
	        return response;
	    };
	}).filter('organizationEnvironment', ["$translate", function ($translate) {
	    return function (data) {
	        var response = "";
	        switch (data) {
	            case "test":
	                response = $translate.instant("DEVELOPMENT");
	                break;
	            case "prod":
	                response = $translate.instant("PRODUCTION");
	                break;
	        }
	        return response;
	    };
	}]).filter('organizationAppFlavour', function () {
	    return function (data) {
	        var response = "";
	        switch (data) {
	            case "EfimobApp":
	                response = "Efimob";
	                break;
	            case "NaturgyApp":
	                response = "Naturgy";
	                break;
	            case "MelibApp":
	                response = "Melib";
	                break;
	            case "CabildoGCApp":
	                response = "CabildoGC";
	                break;
	        }
	        return response;
	    };
	}).filter('chargepointConnected', ["$translate", function ($translate) {
	    return function (connected) {
	        if (connected === "true" || connected === true) return '<span uib-tooltip="' + $translate.instant('FILTER.CHARGEPOINT.CONNECTED') + '"><i class="fal fa-check good"></i></span>';
	        if (connected === "false" || connected === false) return '<span uib-tooltip="' + $translate.instant('FILTER.CHARGEPOINT.DISCONNECTED') + '" class="badge small" type="discrete-bad">' + $translate.instant('FILTER.CHARGEPOINT.WITHOUT_CONNECTION') + '</span>';
	        return connected;
	    };
	}]).filter('onlyConnectors', function () {
	    return function (connectors) {
	        return _lodash2.default.reject(connectors, { id: '0' });
	    };
	}).filter('connectorsSorted', function () {
	    var collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
	    return function (connectors) {
	        return connectors.slice().sort(function (a, b) {
	            return collator.compare(parseInt(a.id, 10), parseInt(b.id, 10));
	        });
	    };
	}).filter('isConnected', function () {
	    return function (connected) {
	        return connected === true ? 'conectado' : 'offline';
	    };
	}).filter('chargepointOperationalStatus', ["ChargepointHelper", function (ChargepointHelper) {
	    return function (operationalStatus) {
	        return _lodash2.default.get(_lodash2.default.find(ChargepointHelper.operationalStatuses, { id: operationalStatus }), 'display', '--');
	    };
	}]).filter('chargepointStatus', ["$translate", "OCPP", "ChargepointHelper", function ($translate, OCPP, ChargepointHelper) {
	    return function (connectors, chargepoint, asText) {
	        var status = _lodash2.default.get(_lodash2.default.find(connectors, { id: '0' }), 'status.status', null);
	        if (status) {
	            var classes = [];
	            var title = $translate.instant('FILTER.CHARGEPOINT.STATUS', { status: status });
	            var content = status;
	            var type = '';
	            if (OCPP.ChargePointStatus[status].operative) {
	                classes.push('good');
	                if (!asText) {
	                    content = '<i class="fal fa-check good"></i>';
	                }
	            } else if (status === 'Unavailable') {
	                classes.push('badge');
	                classes.push('small');
	                type = 'discrete-neutral';
	            } else {
	                classes.push('badge');
	                classes.push('small');
	                type = 'discrete-bad';
	            }
	            if (chargepoint && ChargepointHelper.isDisconnected(chargepoint)) {
	                classes.push('muted italic');
	                title = $translate.instant('FILTER.CHARGEPOINT.STATUS_NO_CONNECTION', { status: status });
	            }
	            return '<span class="' + classes.join(' ') + '" uib-tooltip="' + title + '" type="' + type + '">' + content + '</span>';
	        }
	        return status;
	    };
	}]).filter('status', ["OCPP", function (OCPP) {
	    return function (status) {
	        if (OCPP.ChargePointStatus[status]) {
	            return '<span class="' + (OCPP.ChargePointStatus[status].operative ? '' : 'danger') + '">' + status + '</span>';
	        }
	        return status;
	    };
	}]).filter('errorCode', ["OCPP", "$translate", function (OCPP, $translate) {
	    return function (errorCode) {
	        if (OCPP.ChargePointErrorCode[errorCode] && !OCPP.ChargePointErrorCode[errorCode].error) return $translate.instant('FILTER.CHARGEPOINT.CONNECTORS_NO_ERRORS');
	        return '<span class="danger">' + errorCode + '</span>';
	    };
	}]).filter('totalConnectors', function () {
	    return function (connectors) {
	        if (_lodash2.default.isArray(connectors)) {
	            return connectors.filter(function (connector) {
	                return connector.id !== '0';
	            }).length;
	        }
	        return '';
	    };
	}).filter('getPhysicalReferenceFromConnectors', function () {
	    return function (connectors) {
	        if (_lodash2.default.isArray(connectors)) {
	            return connectors.filter(function (connector) {
	                return connector.id !== '0' && connector.physicalReference;
	            }).map(function (connector) {
	                return connector.physicalReference;
	            }).join(', ');
	        }
	        return '';
	    };
	}).filter('ocppMessageInput', ["$translate", function ($translate) {
	    return function (input) {
	        if (input === true || input === "true") return $translate.instant('FILTER.CHARGEPOINT.OCPPMESSAGE_FROM_CHARGEPOINT');
	        if (input === false || input === "false") return $translate.instant('FILTER.CHARGEPOINT.OCPPMESSAGE_FROM_SERVER');
	        return input;
	    };
	}]).filter('asResultType', function () {
	    return function (input) {
	        if (input === "Uploaded") return "good";
	        if (input === "UploadFailed") return "bad";
	        if (input === "Downloaded") return "good";
	        if (input === "DownloadFailed") return "bad";
	        return 'neutral';
	    };
	}).filter('connectorType', function () {
	    return function (input) {
	        var display = null;
	        if (display) return input + ' <span class="small-text">(' + display + ')</span>';
	        return input;
	    };
	}).filter('connectorMode', function () {
	    return function (input, connector, style) {
	        if (style) {
	            if (style === 'mini-badge') {
	                if (input === 'MODE1') return 'M<span>1</span>';
	                if (input === 'MODE2') return 'M<span>2</span>';
	                if (input === 'MODE3') return 'M<span>3</span>';
	                if (input === 'MODE4') return 'M<span>4</span>';
	                return '--';
	            }
	        }
	        return input;
	    };
	}).filter('connectorPower', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return $filter('number')(input) + 'kW';
	    };
	}]).filter('wToKw', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return $filter('number')(input / 1000) + ' kW';
	    };
	}]).filter('minutes', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return $filter('number')(input) + ' min';
	    };
	}]).filter('sToMin', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return $filter('number')(input / 60) + ' min';
	    };
	}]).filter('connectorCurrent', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return $filter('number')(input) + 'A';
	    };
	}]).filter('connectorVoltage', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return $filter('number')(input) + 'V';
	    };
	}]).filter('evseId', function () {
	    // eMI3 Standard v1.0, part 2
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        return input.match(/^[A-Z]{2}\*[\dA-Z]{3}\*E(?=.{1,31}$)(?:[A-Za-z\d]+(?:\*[A-Za-z\d]+)?)$/) ? input : null;
	    };
	}).filter('duration', ["moment", function (moment) {
	    return function (input) {
	        function pad2(n) {
	            return (n < 10 ? '0' : '') + n;
	        }

	        var duration = moment.duration(input);
	        if (moment.isDuration(duration)) {
	            return '' + pad2(Math.floor(duration.asHours())) + ':' + pad2(duration.minutes()) + ':' + pad2(duration.seconds());
	        }
	        return input;
	    };
	}]).filter('chargeMeter', ["$filter", function ($filter) {
	    return function (input, charge) {
	        var res = $filter('number')(input);
	        var hasCurrentMeter = charge && angular.isDefined(charge.currentMeter) && charge.currentMeter !== null;
	        if (hasCurrentMeter) {
	            res = '<span class="alive">' + $filter('number')(charge.currentMeter) + '</span>';
	        }
	        return res;
	    };
	}]).filter('chargeDuration', ["moment", function (moment) {
	    return function (input, charge) {
	        var duration = null;
	        var alive = false;
	        function pad2(n) {
	            return (n < 10 ? '0' : '') + n;
	        }

	        if (input) {
	            duration = moment.duration(input);
	        } else if (charge && charge.start && charge.start.dateTime) {
	            duration = moment.duration(moment().diff(moment(charge.start.dateTime)));
	            alive = true;
	        }
	        if (moment.isDuration(duration)) {
	            var result = '' + pad2(Math.floor(duration.asHours())) + ':' + pad2(duration.minutes()) + ':' + pad2(duration.seconds());
	            if (alive) result = '<span class="alive">' + result + '</span>';
	            return result;
	        }
	        return input;
	    };
	}]).filter('kWh', function () {
	    return function (input) {
	        if (_lodash2.default.isNumber(input)) {
	            return (input / 1000.0).toFixed(2);
	        }
	        return input;
	    };
	}).filter('cO2Saved', ["ChargeHelper", function (ChargeHelper) {
	    return function (input) {
	        if (_lodash2.default.isNumber(input)) {
	            return (input * ChargeHelper.CO2KG_PER_KWH / 1000.0).toFixed(2);
	        }
	        return input;
	    };
	}]).filter('chargesMeter', ["$filter", "$state", "$translate", function ($filter, $state, $translate) {
	    return function (input, charge) {
	        var href = null;
	        if (charge && charge.id) {
	            var organization = $state.params.organization;
	            href = $state.href('efimob.charges.at.item', { id: charge.id, organization: organization });
	        }
	        if (angular.isUndefined(input) || input === null) {
	            return '<a href="' + href + '" class="nowrap" tooltip-placement="auto" uib-tooltip="' + $translate.instant('FILTER.CHARGE.CHARGED_ENERGY_NOT_AVAILABLE') + '"><span class="steroids-text">' + '--,--' + '</span> kWh</a>';
	        } else {
	            return '<a href="' + href + '" class="nowrap" tooltip-placement="auto" uib-tooltip="' + $translate.instant('FILTER.CHARGE.CHARGED_ENERGY') + $filter('number')(input) + ' kWh"><span class="steroids-text">' + $filter('number')(input, 2) + '</span> kWh</a>';
	        }
	    };
	}]).filter('chargeCustomerName', ["$translate", function ($translate) {
	    return function (customerName) {
	        if (!customerName) return '<i class="muted">' + $translate.instant('FILTER.CHARGE.NO_CUSTOMER') + '</i>';
	        return customerName;
	    };
	}]).filter('chargeUserkey', ["$state", function ($state) {
	    return function (keyId, options) {
	        var id = options && options.start ? options.start.userKeyUUID : null;
	        var organization = $state.params.organization;
	        if (keyId && id) {
	            var href = $state.href('efimob.userkeys.at.item', { id: id, organization: organization });
	            return '<a href="' + href + '">' + keyId + '</a>';
	        }
	        return '';
	    };
	}]).filter('chargeDate', ["$filter", "moment", "$translate", function ($filter, moment, $translate) {
	    return function (date) {
	        var d = date ? moment(date) : null;
	        if (d && d.isValid()) {
	            if (d.isAfter(moment().startOf('day'))) {
	                return '<span uib-tooltip="' + date + '">' + $translate.instant('FILTER.CHARGE.TODAY') + $filter('toDate')(date, 'time') + '</span>';
	            } else if (d.isAfter(moment().subtract(1, 'day').startOf('day'))) {
	                return '<span uib-tooltip="' + date + '">' + $translate.instant('FILTER.CHARGE.YESTERDAY') + $filter('toDate')(date, 'time') + '</span>';
	            }
	            return '<span uib-tooltip="' + date + '">' + $filter('toDate')(date) + '</span>';
	        }
	        return '<span class="muted"></span>';
	    };
	}]).filter('chargeMaxPower', ["$filter", "$translate", function ($filter, $translate) {
	    return function (input) {
	        if (_lodash2.default.isNil(input) || !_lodash2.default.isFinite(input)) return '<span class="muted" uib-tooltip="' + $translate.instant('FILTER.CHARGE.MAX_POWER_UNKNOWN') + '">--,--</span>';
	        return '<span uib-tooltip="' + $filter('number')(input) + ' kW">' + $filter('number')(input, 2) + ' <span class="small-text">kW</span></span>';
	    };
	}]).filter('chargeState', ["ChargeHelper", "$translate", function (ChargeHelper, $translate) {
	    return function (input, charge) {
	        if (!charge) return ' ';
	        if (ChargeHelper.isCharging(charge)) return '<span uib-tooltip="' + $translate.instant('FILTER.CHARGE.STATE_CHARGING_HINT') + '" class="badge small" type="alive">' + $translate.instant('FILTER.CHARGE.STATE_CHARGING') + '</span>';
	        if (ChargeHelper.isFinished(charge)) return '<span uib-tooltip="' + $translate.instant('FILTER.CHARGE.STATE_FINISHED_HINT') + '" class="badge small" type="discrete-neutral">' + $translate.instant('FILTER.CHARGE.STATE_FINISHED') + '</span>';
	        if (ChargeHelper.isFinishedWithError(charge)) return '<span uib-tooltip="' + $translate.instant('FILTER.CHARGE.STATE_FINISHED_WITH_ERROR_HINT') + '" class="badge small" type="warning">' + $translate.instant('FILTER.CHARGE.STATE_FINISHED_WITH_ERROR') + '</span>';
	        // if (ChargeHelper.isFinished(charge)) return '<span uib-tooltip="Recarga finalizada"><i class="fal fa-battery-full neutral"></i></span>';
	    };
	}]).filter('chargesDuration', ["moment", function (moment) {
	    return function (input, charge, custom) {
	        var duration = null;
	        var alive = false;
	        if (input) {
	            if (charge && !charge.stop) {
	                if (custom === 'start') {
	                    duration = charge.start && charge.start.dateTime ? moment.duration(moment().diff(moment(charge.start.dateTime))) : moment.duration(input);
	                    alive = charge.start && charge.start.dateTime ? true : false;
	                } else if (custom === 'mainCharge') {
	                    duration = charge.mainCharge && charge.mainCharge.startDateTime ? moment.duration(moment().diff(moment(charge.mainCharge.startDateTime))) : moment.duration(input);
	                    alive = charge.mainCharge && charge.mainCharge.startDateTime ? true : false;
	                }
	            } else {
	                duration = moment.duration(input);
	            }
	        }
	        if (moment.isDuration(duration)) {
	            var result = '';
	            result += '<span class="duration-days">' + (duration.asDays() >= 1 ? Math.floor(duration.asDays()) + '<span>d</span>' : '') + '</span>';
	            result += '<span class="duration-hours">' + (duration.asHours() >= 1 ? duration.hours() + '<span>h</span>' : '') + '</span>';
	            result += '<span class="duration-minutes">' + (duration.asMinutes() >= 1 ? duration.minutes() + '<span>m</span>' : '') + '</span>';
	            result += '<span class="duration-seconds">' + (duration.seconds() + '<span>s</span>') + '</span>';
	            if (alive) result = '<span class="duration alive">' + result + '</span>';
	            return '<span class="duration">' + result + '</span>';
	        }
	        return input;
	    };
	}]).filter('customerName', ["$state", function ($state) {
	    return function (name, customer) {
	        if (customer && customer.userId && customer.name === ' ') return customer.userId;
	        if (!customer || !customer.id) return name;
	        var href = $state.href('efimob.customers.item', { id: customer.id });
	        return '<a href="' + href + '">' + name + '</a>';
	    };
	}]).filter('personType', ["$filter", "$translate", function ($filter, $translate) {
	    return function (personType) {
	        switch (personType) {
	            case 'Individual':
	                return $translate.instant('FILTER.CUSTOMER.TYPES.INDIVIDUAL');
	            case 'LegalEntity':
	                return $translate.instant('FILTER.CUSTOMER.TYPES.LEGAL_ENTITY');
	            case 'Contract':
	                return $translate.instant('FILTER.CUSTOMER.TYPES.CONTRACT');
	            default:
	                return $translate.instant('FILTER.CUSTOMER.TYPES.UNKNOWN');
	        }
	    };
	}]).filter('customerEmail', function () {
	    return function (userId, customer) {
	        if (customer && customer.userId && !userId) return customer.userId;
	        return userId;
	    };
	}).filter('customerCity', function () {
	    return function (address) {
	        var response = "";
	        if (address) {
	            var aux = response || address.city;
	            response = "" + aux + (address.country ? " (" + address.country + ")" : "");
	        }
	        return response;
	    };
	}).filter('customerOrganization', ["$state", "$filter", function ($state, $filter) {
	    return function (organization, customer) {
	        var href = $state.href('efimob.organizations.item', { id: organization });
	        return '<a href="' + href + '">' + (customer && customer.organizationName ? $filter('safe')(customer.organizationName) : organization) + '</a>';
	    };
	}]).filter('customerChargeTarget', ["$translate", function ($translate) {
	    return function (target) {
	        var res = void 0;
	        if (target) {
	            res = target.active === true ? $translate.instant('FILTER.CUSTOMER.CHARGE_TARGET.ACTIVE') : $translate.instant('FILTER.CUSTOMER.CHARGE_TARGET.NOT_ACTIVE');
	            res += ' (' + $translate.instant('FILTER.CUSTOMER.CHARGE_TARGET.TARGET_BOTH', { 'percentage': target.targetSoC, 'time': target.targetTime }) + ')';
	            return res;
	        }
	        return '--';
	    };
	}]).filter('sortedOrganizations', function () {
	    return function (organizations) {
	        return _lodash2.default.sortBy(_lodash2.default.map(organizations), 'name');
	    };
	}).filter('organizationName', ["Cache", "$filter", function (Cache, $filter) {
	    return function (organizationId) {
	        if (Cache.organization && Cache.organization[organizationId]) return $filter('safe')(Cache.organization[organizationId].name);
	        return organizationId;
	    };
	}]).filter('userkeysSorting', function () {
	    return function (userkeys) {
	        var lastChar = String.fromCharCode(255);
	        var collator = new Intl.Collator(undefined, { numeric: false, sensitivity: 'accent' });
	        var sorted = userkeys.slice().sort(function (a, b) {
	            // Sort by customer name and then by idToken
	            var aValue = _lodash2.default.get(a, 'userKey.customerName');
	            if (_lodash2.default.isNil(aValue)) aValue = lastChar;
	            aValue += _lodash2.default.get(a, 'userKey.idToken');
	            var bValue = _lodash2.default.get(b, 'userKey.customerName');
	            if (_lodash2.default.isNil(bValue)) bValue = lastChar;
	            bValue += _lodash2.default.get(b, 'userKey.idToken');
	            return collator.compare(aValue, bValue);
	        });
	        return sorted;
	    };
	}).filter('userkeyName', ["$state", function ($state) {
	    return function (name, userkey) {
	        name = name || (userkey ? userkey.name : null) || (userkey ? userkey.keyId : null) || '--';
	        if (userkey && userkey.keyId) {
	            var href = $state.href('efimob.userkeys.at.item', {
	                id: userkey.keyId,
	                organization: userkey.organizationId
	            });
	            return '<a href="' + href + '">' + name + '</a>';
	        }
	        return name;
	    };
	}]).filter('userkeyActive', ["$filter", "$translate", "moment", function ($filter, $translate, moment) {
	    return function (blocked, userkey) {
	        if (blocked === "true" || blocked === true) return '<span uib-tooltip="' + $translate.instant('FILTER.USERKEY.ACTIVE.IS_BLOCKED') + '" class="badge small" type="discrete-bad">' + $translate.instant('FILTER.USERKEY.ACTIVE.BLOCKED') + '</span>';
	        if (userkey && userkey.activeFrom && userkey.activeTo) {
	            if (moment(userkey.activeTo).isBefore()) return '<span uib-tooltip="' + $translate.instant('FILTER.USERKEY.ACTIVE.IS_EXPIRED') + '" class="badge small" type="discrete-bad">' + $translate.instant('FILTER.USERKEY.ACTIVE.EXPIRED') + '</span>';
	            if (moment(userkey.activeFrom).isAfter()) return '<span uib-tooltip="' + $translate.instant('FILTER.USERKEY.ACTIVE.IS_NOT_ACTIVATED') + '" class="badge small" type="discrete-warning">' + $translate.instant('FILTER.USERKEY.ACTIVE.NOT_ACTIVATED') + '</span>';
	        }
	        if (blocked === "false" || blocked === false) return '<span uib-tooltip="' + $translate.instant('FILTER.USERKEY.ACTIVE.IS_ACTIVE') + '"><i class="fal fa-check good"></i></span>';
	        return $filter('yesno')(!blocked);
	    };
	}]).filter('userkeyOrganization', ["$state", "$translate", function ($state, $translate) {
	    return function (organization, userkey) {
	        if (organization === null || angular.isUndefined(organization)) return '<i class="muted">' + $translate.instant('FILTER.USERKEY.NOT_ASSIGNED') + '</i>';
	        var href = $state.href('efimob.organizations.item', { id: organization });
	        return '<a href="' + href + '">' + (userkey && userkey.organizationName ? userkey.organizationName : organization) + '</a>';
	    };
	}]).filter('userkeyCustomer', ["$state", "$translate", function ($state, $translate) {
	    return function (customerName, userkey) {
	        var response = '<i class="muted">' + $translate.instant('FILTER.USERKEY.NO_CUSTOMER') + '</i>';
	        var name = customerName || userkey && userkey.customerName;
	        if (name) {
	            var customerId = userkey ? userkey.customerId : null;
	            var href = $state.href('efimob.customers.item', { id: customerId, organization: userkey.organizationId });
	            response = '<a href="' + href + '">' + name + '</a>';
	        }
	        return response;
	    };
	}]).filter('userkeyChargepoint', ["$state", "$translate", function ($state, $translate) {
	    return function (chargepointName, userkey) {
	        var chargepointId = userkey && userkey.chargepointId ? userkey.chargepointId : null;
	        if (userkey && chargepointId === null) return '<i class="muted">' + $translate.instant('FILTER.USERKEY.NO_CHARGEPOINT') + '</i>';
	        var href = $state.href('efimob.chargepoints.at.item', { id: chargepointId, organization: userkey.organizationId });
	        return '<a href="' + href + '">' + (chargepointName || userkey.chargepointName) + '</a>';
	    };
	}]).filter('userkeyAdminGroup', ["$state", "$filter", function ($state, $filter) {
	    return function (group, admin) {
	        if (admin && admin.organizationId) {
	            return '<a href="' + $state.href('efimob.groups.item', { id: admin.id, organization: admin.organizationId }) + '">' + (admin.name ? $filter('safe')(admin.name) : admin.id) + '</a>';
	        }
	        return group;
	    };
	}]).filter('userkeyGroupRoleId', ["$state", "$translate", function ($state, $translate) {
	    return function (groupLevel, userkey) {
	        if (groupLevel && userkey && userkey.organizationId) {
	            return groupLevel ? $translate.instant('FILTER.USERKEY.LEVEL', { name: '<a href="' + $state.href('efimob.groups.item', { id: groupLevel.id, organization: userkey.organizationId }) + '">' + groupLevel.name + '</a>' }) : '';
	        }
	    };
	}]).filter('userkeyGroups', ["$state", "$filter", function ($state, $filter) {
	    return function (groups, userkey) {
	        if (_lodash2.default.isArray(groups)) {
	            var anchors = _lodash2.default.map(groups, function (group) {
	                if (userkey && userkey.organizationId) {
	                    if (_lodash2.default.isObject(group)) return '<a href="' + $state.href('efimob.groups.item', { id: group.id, organization: userkey.organizationId }) + '">' + $filter('safe')(group.name) + '</a>';else return '<a href="' + $state.href('efimob.groups.item', { id: group, organization: userkey.organizationId }) + '">' + $filter('safe')(group) + '</a>';
	                } else {
	                    return $filter('safe')(group);
	                }
	            });
	            return anchors.join(', ');
	        }
	        return groups;
	    };
	}]).filter('userkeyActiveFrom', ["$filter", "$translate", "moment", function ($filter, $translate, moment) {
	    return function (activeFrom) {
	        var from = moment(activeFrom);
	        if (from && from.isValid() && from.isAfter()) return '<span class="warning" uib-tooltip="' + $translate.instant('FILTER.USERKEY.STILL_NOT_ACTIVATED') + '">' + $filter('toDate')(activeFrom) + '<span>';
	        return $filter('toDate')(activeFrom);
	    };
	}]).filter('userkeyActiveTo', ["$filter", "$translate", "moment", function ($filter, $translate, moment) {
	    return function (activeTo) {
	        var to = moment(activeTo);
	        if (to && to.isValid() && to.isBefore()) return '<span class="danger" uib-tooltip="' + $translate.instant('FILTER.USERKEY.ALREADY_EXPIRED') + '">' + $filter('toDate')(activeTo) + '<span>';
	        return $filter('toDate')(activeTo);
	    };
	}]).filter('sorting', function () {
	    function _getRecursiveValue(data, keys, acc) {
	        if (keys.length !== 0) {
	            if (data.hasOwnProperty(keys[0])) {
	                acc = data[keys[0]];
	                return _getRecursiveValue(acc, keys.slice(1), acc);
	            } else {
	                return acc;
	            }
	        } else {
	            return acc;
	        }
	    }
	    function _getValue(data, types, key) {
	        var response = String.fromCharCode(255);
	        var realKey = key;
	        var auxKey = key.split(".");
	        if (auxKey.length > 1) {
	            realKey = auxKey[0];
	        }
	        if (types && types[key]) {
	            var aux = types[key].split(":");
	            if (aux.length > 1 && data.hasOwnProperty(realKey)) {
	                switch (aux[0]) {
	                    case 'object':
	                        response = _getRecursiveValue(data[realKey], aux.slice(1));
	                        break;
	                    case 'array':
	                        response = _getRecursiveValue(data[realKey][aux[1]], aux.slice(2));
	                        break;
	                }
	            } else if (data.hasOwnProperty(realKey)) {
	                response = data[realKey];
	            }
	        } else {
	            if (data.hasOwnProperty(realKey)) {
	                response = data[realKey];
	            }
	        }
	        return response;
	    }
	    return function (input, table) {
	        if (table && table.synchronous && _lodash2.default.isArray(input)) {
	            var asc = input;
	            _lodash2.default.forEachRight([table.sorting.key], function (key) {
	                var isAlphanumeric = table.sorting.types && table.sorting.types[key] === 'string';
	                var collator = new Intl.Collator(undefined, { numeric: !isAlphanumeric, sensitivity: isAlphanumeric ? 'accent' : 'base' });
	                asc = asc.slice().sort(function (a, b) {
	                    var aValue = _getValue(a, table.sorting.types, key);
	                    var bValue = _getValue(b, table.sorting.types, key);
	                    return collator.compare(aValue, bValue);
	                });
	            });
	            return table.sorting.order === 'desc' ? asc.reverse() : asc;
	        }
	        return input;
	    };
	}).filter('pagination', function () {
	    return function (input, table) {
	        if (table && table.synchronous && _lodash2.default.isArray(input) && table.pagination) {
	            var start = (table.pagination.currentPage - 1) * table.pagination.itemsPerPage;
	            var end = Math.min(start + table.pagination.itemsPerPage, table.pagination.totalItems);
	            return _lodash2.default.slice(input, start, end);
	        }
	        return input;
	    };
	}).filter('total', function () {
	    return function (input, forceNumber) {
	        if (_lodash2.default.isArray(input)) return input.length;
	        if (forceNumber && !input) return 0;
	        return input;
	    };
	}).filter('not', function () {
	    return function (input) {
	        if (input === true) return false;
	        if (input === false) return true;
	        return input;
	    };
	}).filter('yesno', ["$translate", function ($translate) {
	    return function (input) {
	        if (input === true || input === "true") return $translate.instant('FILTER.YES');
	        if (input === false || input === "false") return $translate.instant('FILTER.NO');
	        return input;
	    };
	}]).filter('unknown', function () {
	    return function (input, message) {
	        if (!input) return '<i>' + (message || '--') + '</i>';
	        return input;
	    };
	}).filter('ago', ["moment", function (moment) {
	    return function (input) {
	        if (angular.isUndefined(input) || input === null) return '<span class="muted warning">nunca</span>';
	        if (input) return moment(input).fromNow();
	        return input;
	    };
	}]).filter('type', function () {
	    return function (input, about) {
	        if (about == 'device') {
	            if (input === 'DESKTOP') return 'PC';
	            if (input === 'MOBILE') return 'Tablet/Móvil';
	        }
	        return input;
	    };
	}).filter('active', function () {
	    return function (input) {
	        if (input === 'ACTIVE') return 'Activo';
	        if (input === 'INACTIVE') return 'Inactivo';
	        return input;
	    };
	}).filter('badge', function () {
	    return function (input, type) {
	        if (type == 'role') {
	            return '<span role="' + input + '">' + input + '</span>';
	        }
	        return input;
	    };
	}).filter('link', function () {
	    return function (input, text) {
	        return '<a href="' + input + '">' + (angular.isDefined(text) ? text : input) + '</a>';
	    };
	}).filter('switch', function () {
	    return function (input, localScope, model, disabled, onChange, onChangeArg) {
	        var scope = localScope;
	        while (!scope[onChange]) {
	            if (!scope.$parent) break;
	            scope = scope.$parent;
	        }
	        localScope._onChange = function (newValue) {
	            if (scope[onChange]) scope[onChange](newValue, onChangeArg);
	        };
	        return '<widget-switch model="' + model + '" disabled="' + disabled + '" on-change="_onChange" ></widget-switch>';
	    };
	}).filter('role', ["$translate", function ($translate) {
	    return function (input) {
	        if (input === 'admin') return $translate.instant('FILTER.ROLE.ADMIN');
	        if (input === 'doer') return $translate.instant('FILTER.ROLE.DOER');
	        return input;
	    };
	}]).filter('roleEntity', ["$translate", function ($translate) {
	    return function (entity) {
	        if (entity === 'group') return $translate.instant('FILTER.ROLE.GROUP');
	        if (entity === 'organization') return $translate.instant('FILTER.ROLE.ORGANIZATION');
	        if (entity === 'provider') return $translate.instant('FILTER.ROLE.PROVIDER');
	        return entity;
	    };
	}]).filter('roleId', ["$state", "$rootScope", "$filter", function ($state, $rootScope, $filter) {
	    return function (id, role) {
	        var entity = role.entity;
	        var name = role[entity + 'Name'] || id;
	        var href = null;
	        var organization = role['organization'] || $rootScope.role.organization;

	        if (entity === 'group') href = $state.href('efimob.groups.item', { id: id, organization: organization });
	        if (entity === 'organization') href = $state.href('efimob.organizations.item', { id: id });
	        if (entity === 'provider') href = $state.href('efimob.settings', {});

	        return '<a href="' + href + '">' + $filter('safe')(name) + '</a>';
	    };
	}]).filter('identity', ["App", "$filter", "$translate", function (App, $filter, $translate) {
	    return function (role) {
	        if (!role) return null;
	        var name = role[role.entity + 'Name'];
	        var result = '<i class="fal fa-' + App.icon[role.entity] + '"></i>';
	        return result + $filter('role')(role.role) + $translate.instant('HEADER.ROLE_DESC') + (name ? $filter('safe')(name) : role.id) + '</b>';
	    };
	}]).filter('groupName', ["$rootScope", function ($rootScope) {
	    return function (groupId) {
	        var role = _lodash2.default.find($rootScope.roles, { 'entity': 'group', 'id': groupId });
	        if (role) return role.groupName;
	        return groupId;
	    };
	}]).filter('providerName', ["$rootScope", function ($rootScope) {
	    return function (providerId) {
	        var role = _lodash2.default.find($rootScope.roles, { 'entity': 'provider', 'id': providerId });
	        if (role) return role.providerName;
	        return providerId;
	    };
	}]).filter('chargeCost', ["$filter", function ($filter) {
	    return function (cost, textRightNotForced) {
	        if (cost && _lodash2.default.isFinite(_lodash2.default.toNumber(cost))) {
	            return '<div class="' + (textRightNotForced ? '' : 'text-right') + '">' + $filter('number')(cost, 2).concat(' €') + '</div>';
	        }
	        return '<span class="muted">--</span>';
	    };
	}]).filter('chargeSoC', ["$translate", function ($translate) {
	    return function (SoC) {
	        if (angular.isUndefined(SoC) || SoC === null) return '<span class="muted" uib-tooltip="' + $translate.instant('FILTER.CHARGE.SOC_UNAVAILABLE') + '">--</span>';
	        return '' + SoC + '%';
	    };
	}]).filter('empty', function () {
	    return function (data) {
	        if (angular.isUndefined(data) || data === null) return '<span class="muted">--</span>';
	        return data;
	    };
	}).filter('bigNumber', ["$filter", function ($filter) {
	    return function (input) {
	        if (input === null || angular.isUndefined(input)) return null;
	        if (input >= 100000000) {
	            return $filter('number')(input / 1000000, 0) + 'M';
	        }
	        if (input >= 10000000) {
	            return $filter('number')(input / 1000000, 1) + 'M';
	        }
	        if (input >= 1000000) {
	            return $filter('number')(input / 1000000, 2) + 'M';
	        }
	        if (input >= 100000) {
	            return $filter('number')(input / 1000, 0) + 'K';
	        }
	        if (input >= 10000) {
	            return $filter('number')(input / 1000, 1) + 'K';
	        }
	        if (input >= 1000) {
	            return $filter('number')(input / 1000, 2) + 'K';
	        }
	        return $filter('number')(input, 0);
	    };
	}]).filter('tariffArea', ["$translate", function ($translate) {
	    return function (users) {
	        var res = '<span>' + $translate.instant('ACTION.ADD_TARIFF.GENERIC') + '</span>';
	        if (users != undefined && users.length != 0) {
	            res = '<span class="accent-alt" uib-tooltip="' + users.join(', ') + '">' + users.length + ' ' + $translate.instant('COMMON.USERS') + '</span>';
	        }
	        return res;
	    };
	}]).filter('capitalize', function () {
	    return function (input) {
	        return angular.isString(input) && input.length > 0 ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
	    };
	}).filter('boolean', ["$translate", function ($translate) {
	    return function (input) {
	        if (typeof input == "boolean" && input === true) {
	            return '<span uib-tooltip="' + $translate.instant('COMMON.YES') + '"><i class="fal fa-check good"></i></span>';
	        } else {
	            return '<span uib-tooltip="' + $translate.instant('COMMON.NO') + '"><i class="fal fa-times bad"></i></span>';
	        }
	    };
	}]).filter('language', function () {
	    return function (input, code) {
	        code = code || 'es';
	        if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) == "object") {
	            return input[code] || '';
	        }
	        return input;
	    };
	}).filter('getByLang', function () {
	    return function (input) {
	        return (typeof input === 'undefined' ? 'undefined' : _typeof(input)) == "object" ? input["es"] : input;
	    };
	}).filter('displayLang', ["$translate", function ($translate) {
	    return function (input) {
	        var id = "COMMON.LANG_ES";
	        if (input) {
	            id = "COMMON.LANG_" + input.toUpperCase();
	        }
	        return $translate.instant(id);
	    };
	}]).filter('displaySecurityProfile', ["$translate", function ($translate) {
	    return function (type) {
	        var id = "DISABLED";
	        switch (parseInt(type)) {
	            case 1:
	                id = "BASIC_SECURITY_PROFILE";
	                break;
	            case 2:
	                id = "TLS_BASIC_AUTHENTICATION";
	                break;
	            case 3:
	                id = "TLS_CLIENT_CERTIFICATES";
	                break;
	        }
	        return $translate.instant(id);
	    };
	}]).filter('toDate', ["$filter", "moment", function ($filter, moment) {
	    return function (date) {
	        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dateTime";
	        var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	        var response = "";
	        var d = date ? moment(date) : null;
	        if (d && d.isValid()) {
	            //TODO: evaluate whether to change the date to ISO format d.format("DD-MM-YYYY HH:mm:ss.SSS");
	            switch (type) {
	                case "date":
	                    response = $filter('date')(date, 'dd/MM/yyyy');
	                    break;
	                case "time":
	                    response = $filter('date')(date, option ? 'HH:mm:ss' : 'HH:mm:ss.sss');
	                    break;
	                case "dateTime":
	                    response = $filter('date')(date, option ? 'dd/MM/yyyy HH:mm:ss' : 'dd/MM/yyyy HH:mm:ss.sss');
	                    break;
	            }
	        }
	        return response;
	    };
	}]).filter('toDay', ["$translate", function ($translate) {
	    return function (data) {
	        var response = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
	        return $translate.instant(response[data]);
	    };
	}]).filter('withUnit', function () {
	    return function (value, unit) {
	        var res = '';
	        if (angular.isDefined(value) && value != null) {
	            res += value;
	            if (unit && unit.length > 0) {
	                res += '<span class="accent-alt small ml-xs">' + unit + '</span>';
	            }
	        }
	        return res;
	    };
	}).filter('displayBoolean', ["$translate", function ($translate) {
	    return function (data) {
	        var value = data ? "ENABLED" : "DISABLED";
	        return $translate.instant(value);
	    };
	}]).filter('objectArrayToString', ["$translate", function ($translate) {
	    return function (data, firstItem, secondItem) {
	        var symbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

	        var response = "";
	        if (data) {
	            response = data.reduce(function (acc, item, index) {
	                var end = ", ";
	                if (index === data.length - 1) {
	                    end = ".";
	                }
	                return acc + $translate.instant(item[firstItem]) + " (" + item[secondItem] + symbol + ")" + end;
	            }, "");
	        }
	        return response;
	    };
	}]).filter('toDayOcpi', ["$translate", function ($translate) {
	    return function (data) {
	        var response = ["", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
	        return $translate.instant(response[data]);
	    };
	}]).filter('toDateTimeOcpi', ["$filter", function ($filter) {
	    return function (data) {
	        var firstItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'weekday';
	        var secondItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'period_begin';
	        var thridItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'period_end';

	        var response = "";
	        if (data) {
	            response = data.reduce(function (acc, item, index) {
	                var end = ", ";
	                if (index === data.length - 1) {
	                    end = ".";
	                }
	                return acc + $filter('toDayOcpi')(item[firstItem]) + " (" + item[secondItem] + " - " + item[thridItem] + ")" + end;
	            }, "");
	        }
	        return response;
	    };
	}]).filter('organizationLink', ["$state", "$filter", function ($state, $filter) {
	    return function (organizationName, organization) {
	        var split = organization.split('#');
	        var name = split.length > 1 ? split[1] : organization;
	        var href = $state.href('efimob.organizations.item', { id: name });
	        return '<a href="' + href + '">' + $filter('safe')(organizationName) + '</a>';
	    };
	}]).filter('groupLink', ["$state", function ($state) {
	    return function (groups, item) {
	        var res = [];
	        if (_lodash2.default.isArray(groups) && groups.length > 0) {
	            var split = item.organizationId.split('#');
	            var name = split.length > 1 ? split[1] : item.organizationId;
	            for (var i = 0; i < groups.length; i++) {
	                var group = groups[i];
	                var href = $state.href('efimob.groups.item', { id: group.id, organization: name });
	                res.push('<a href="' + href + '">' + group.name + '</a>');
	            }
	        }
	        return res.join(', ');
	    };
	}]).filter('addressDisplay', function () {
	    return function (data) {
	        var res = [];
	        var properties = ['address', 'postalCode', 'city', 'province', 'country'];
	        if (data) {
	            for (var i = 0; i < properties.length; i++) {
	                var property = properties[i];
	                if (data[property]) {
	                    res.push(data[property]);
	                }
	            }
	        }
	        return res.join(', ');
	    };
	}).filter('adaptToSelectOptions', function () {
	    return function (data) {
	        var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
	        var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

	        var res = [];
	        var aux = data ? data : [];
	        _lodash2.default.forEach(aux, function (item) {
	            res.push({ display: item[display], id: item[id] });
	        });
	        return res;
	    };
	}).filter('searchInArrayOfObjects', function () {
	    return function (value, array) {
	        var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	        var display = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'name';

	        var res = value;
	        if (_lodash2.default.isArray(array)) {
	            var item = array.find(function (item) {
	                return item[field] === value;
	            });
	            res = angular.isUndefined(item) ? value : item[display];
	        }
	        return res;
	    };
	}).filter('adaptLangsToString', ["$translate", function ($translate) {
	    return function (data) {
	        var response = '';
	        if (!_lodash2.default.isEmpty(data)) {
	            var list = _lodash2.default.keys(data);
	            var lisLength = list.length;
	            for (var index = 0; index < lisLength; index++) {
	                var item = list[index];
	                var separator = lisLength === index + 1 ? '' : ', ';
	                response = response + $translate.instant('COMMON.LANG_' + item.toUpperCase()) + separator;
	            }
	        }
	        return response;
	    };
	}]).filter('identifierType', function () {
	    return function (identifierNumber, personType) {
	        var isNie = /^[XYZ][0-9]{7}[A-Z]$/.test(identifierNumber);
	        var isPassport = /^[A-Za-z0-9]*$/.test(identifierNumber);
	        var isNif = /^[0-9]{8,8}[A-Za-z]$/.test(identifierNumber);
	        var isLegalEntity = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/.test(identifierNumber);
	        if (isNif || personType === 'LegalEntity' && isLegalEntity) {
	            return 'NIF';
	        }
	        if (isNie) {
	            return 'NIE';
	        }
	        if (isPassport) {
	            return 'Passport';
	        }
	        return '';
	    };
	}).filter('countryCodeToName', ["StaticListService", function (StaticListService) {
	    return function (code) {
	        var aux = StaticListService.getCountryCodes().find(function (item) {
	            return item.value === code;
	        });
	        return aux ? aux.display : code;
	    };
	}]).filter('extractText', ["$translate", function ($translate) {
	    return function (field) {
	        if (_lodash2.default.isArray(field)) {
	            var currentLanguage = $translate.use();
	            var localizedItem = field.find(function (item) {
	                return item.language === currentLanguage;
	            });
	            return localizedItem ? localizedItem.text : field[0] ? field[0].text : '';
	        }
	        return field;
	    };
	}]).filter('tariffLocationNameLink', ["$state", function ($state) {
	    return function (locations, tariff) {
	        if (_lodash2.default.isArray(locations)) {
	            return _lodash2.default.map(locations, function (location) {
	                var href = $state.href('efimob.groups.item', { id: location.id, organization: tariff.organizationId });
	                return '<a href="' + href + '">' + location.name + '</a>';
	            }).join(', ');
	        }
	        return '';
	    };
	}]).filter('connectorTypesDisplay', ["$translate", function ($translate) {
	    return function (connectorTypes) {
	        var length = connectorTypes.length;
	        var res = $translate.instant('ANY_TYPE');
	        if (length < 6) {
	            res = '<span class="accent-alt" uib-tooltip="' + connectorTypes.join(', ') + '">' + length + ' ' + $translate.instant('TYPES') + '</span>';
	        }
	        return res;
	    };
	}]).filter('powerRangeWToKw', ["$translate", function ($translate) {
	    return function (_, field) {
	        var maxPowerKw = field.maxPower ? field.maxPower / 1000 : null;
	        var minPowerKw = field.minPower / 1000;
	        var maxPowerKwIsNull = maxPowerKw === null;

	        if (minPowerKw === 0 && maxPowerKwIsNull) {
	            return $translate.instant('ANY_POWER');
	        }
	        if (minPowerKw > 0 && maxPowerKwIsNull) {
	            return $translate.instant('POWER_ABOVE_KW', { power: minPowerKw });
	        }
	        if (minPowerKw === 0 && !maxPowerKwIsNull) {
	            return $translate.instant('POWER_BELOW_KW', { power: maxPowerKw });
	        }
	        if (minPowerKw > 0 && !maxPowerKwIsNull) {
	            return $translate.instant('MIN_POWER_MAX_POWER_KW', { min: minPowerKw, max: maxPowerKw });
	        }

	        return '';
	    };
	}]).filter('length', function () {
	    return function (data) {
	        return angular.isArray(data) ? data.length : 0;
	    };
	}).name;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _auth = __webpack_require__(167);

	var _app = __webpack_require__(168);

	var _cache = __webpack_require__(169);

	var _utils = __webpack_require__(170);

	var _organizations = __webpack_require__(171);

	var _organizationsHelper = __webpack_require__(172);

	var _chargeHelper = __webpack_require__(173);

	var _ocpp = __webpack_require__(174);

	var _chargePointHelper = __webpack_require__(175);

	var _groupsHelper = __webpack_require__(180);

	var _alarms = __webpack_require__(181);

	var _userKeyHelper = __webpack_require__(182);

	var _users = __webpack_require__(183);

	var _usersHelper = __webpack_require__(184);

	var _chargePoints = __webpack_require__(185);

	var _chargePointsHelper = __webpack_require__(186);

	var _chargeSessions = __webpack_require__(187);

	var _customers = __webpack_require__(188);

	var _groups = __webpack_require__(189);

	var _ittt = __webpack_require__(190);

	var _providers = __webpack_require__(191);

	var _providersHelper = __webpack_require__(192);

	var _socket = __webpack_require__(193);

	var _request = __webpack_require__(244);

	var _staticList = __webpack_require__(245);

	var _agreement = __webpack_require__(246);

	var _tariffs = __webpack_require__(247);

	var _tariffsHelper = __webpack_require__(248);

	var _locations = __webpack_require__(249);

	var _operation = __webpack_require__(250);

	var _operationsHelper = __webpack_require__(251);

	var _agreementsHelper = __webpack_require__(252);

	var _customerHelper = __webpack_require__(253);

	var _margin = __webpack_require__(254);

	var _marginHelper = __webpack_require__(255);

	exports.default = angular.module('services', []).service('Alarms', _alarms.AlarmsService).service('App', _app.AppService).service('Auth', _auth.AuthService).service('Cache', _cache.CacheService).service('ChargeHelper', _chargeHelper.ChargeHelper).service('ChargepointHelper', _chargePointHelper.ChargePointHelperService).service('ChargePointsService', _chargePoints.ChargePointsService).service('ChargePointsHelper', _chargePointsHelper.ChargePointsHelper).service('ChargeSessionsService', _chargeSessions.ChargeSessionsService).service('CustomersService', _customers.CustomersService).service('GroupsService', _groups.GroupsService).service('GroupsHelper', _groupsHelper.GroupsHelperService).service('ItttService', _ittt.ItttService).service('OCPP', _ocpp.OCPPService).service('Organization', _organizations.OrganizationsService).service('OrganizationsHelper', _organizationsHelper.OrganizationsHelper).service('ProvidersService', _providers.ProvidersService).service('ProvidersHelperService', _providersHelper.ProvidersHelperService).service('AgreementService', _agreement.AgreementService).service('AgreementsHelperService', _agreementsHelper.AgreementsHelperService).service('OperationService', _operation.OperationService).service('OperationsHelperService', _operationsHelper.OperationsHelperService).service('SocketService', _socket.SocketService).service('RequestService', _request.RequestService).service('UserKeyHelper', _userKeyHelper.UserKeyHelper).service('UsersService', _users.UsersService).service('UsersHelper', _usersHelper.UsersHelper).service('Utils', _utils.UtilsService).service('StaticListService', _staticList.StaticListService).service('TariffsService', _tariffs.TariffsService).service('TariffsHelperService', _tariffsHelper.TariffsHelperService).service('LocationsService', _locations.LocationsService).service('CustomerHelperService', _customerHelper.CustomerHelperService).service('MarginService', _margin.MarginService).service('MarginHelperService', _marginHelper.MarginHelperService).name;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AuthService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AuthService = exports.AuthService = function () {
	    AuthService.$inject = ["$rootScope", "$http", "$state", "$translate", "ENV", "App", "LocalStorage", "SocketService", "Global", "RequestService"];
	    function AuthService($rootScope, $http, $state, $translate, ENV, App, LocalStorage, SocketService, Global, RequestService) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, AuthService);

	        this.$http = $http;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.LocalStorage = LocalStorage;
	        this.$rootScope = $rootScope;
	        this.ENV = ENV;
	        this.App = App;
	        this.Global = Global;
	        this.SocketService = SocketService;
	        this.RequestService = RequestService;
	        this.user = {};

	        var Auth = this;
	        $rootScope.Auth = Auth;

	        Auth.logout = function () {
	            _this.LocalStorage.deleteUser();
	            $rootScope.$broadcast('logout');
	        };
	    }

	    _createClass(AuthService, [{
	        key: 'me',
	        value: function me() {
	            var _this2 = this;

	            return this.$http.get(this.ENV.URL + '/users/me', {}).then(function (res) {
	                return res.data;
	            }).then(function (user) {
	                return _this2.setUser(user);
	            });
	        }
	    }, {
	        key: 'setUser',
	        value: function setUser(user, rememberMe) {
	            var _this3 = this;

	            this.user = user;
	            this.$rootScope.user = this.user;

	            this.setLang(user);
	            if (rememberMe) {
	                if (user) {
	                    this.LocalStorage.setUser(user);
	                    if (user.token) this.Global.setDefaultAuthHeader(user.token);
	                } else this.LocalStorage.deleteUser();
	            }

	            if (user && user.token && angular.isUndefined(this.SocketService.id)) {
	                return this.SocketService.openChannel(user.token).then(function () {
	                    return _this3.$rootScope.$applyAsync();
	                }).then(function () {
	                    return user;
	                });
	            }
	            if ((!user || !user.token) && this.SocketService.socket) {
	                this.SocketService.disconnect();
	            }

	            this.$rootScope.$applyAsync();

	            return Promise.resolve(user);
	        }
	    }, {
	        key: 'login',
	        value: function login(user, captcha, authcode) {
	            var _this4 = this;

	            var payload = { 'username': user.username, 'password': user.password };
	            if (captcha["status"]) payload['captcha'] = parseInt(captcha["solution"], 10);
	            if (authcode["status"]) payload['code'] = authcode["value"];
	            return this.$http.post(this.ENV.URL + '/login', payload).then(function (res) {
	                return res.data;
	            }).then(function (res) {
	                _this4.Global.setDefaultAuthHeader(res.token);
	                return res;
	            }).then(function (res) {
	                return _this4.setUser(res, true);
	            });
	        }
	    }, {
	        key: 'setPassword',
	        value: function setPassword(password, currentPassword) {
	            var _this5 = this;

	            return this.$http.post(this.ENV.URL + '/users/me/password', {
	                'oldPassword': currentPassword,
	                'newPassword': password
	            }).then(function (res) {
	                return res.data;
	            }).then(function (res) {
	                _this5.Global.setDefaultAuthHeader(res.token);
	                return res;
	            }).then(function (res) {
	                return _this5.setUser(res, true);
	            });
	        }
	    }, {
	        key: 'recoveryAutologin',
	        value: function recoveryAutologin(token) {
	            var _this6 = this;

	            return this.$http.get(this.ENV.URL + '/users/recovery/' + token).then(function (res) {
	                _this6.setLang(res.data);
	                return res.data;
	            });
	        }
	    }, {
	        key: 'setRecoveryPassword',
	        value: function setRecoveryPassword(password, token) {
	            var _this7 = this;

	            return this.$http.post(this.ENV.URL + '/users/recovery/password', {
	                'token': token,
	                'password': password
	            }).then(function (res) {
	                return res.data;
	            }).then(function (res) {
	                _this7.Global.setDefaultAuthHeader(res.token);
	                return res;
	            }).then(function (res) {
	                return _this7.setUser(res, true);
	            });
	        }
	    }, {
	        key: 'welcomeAutologin',
	        value: function welcomeAutologin(token) {
	            var _this8 = this;

	            return this.$http.get(this.ENV.URL + '/users/signup/' + token).then(function (res) {
	                _this8.setLang(res.data);
	                return res.data;
	            });
	        }
	    }, {
	        key: 'setWelcomePassword',
	        value: function setWelcomePassword(password, token) {
	            var _this9 = this;

	            return this.$http.post(this.ENV.URL + '/users/signup/password', {
	                'token': token,
	                'password': password
	            }).then(function (res) {
	                return res.data;
	            }).then(function (res) {
	                _this9.Global.setDefaultAuthHeader(res.token);
	                return res;
	            }).then(function (res) {
	                return _this9.setUser(res, true);
	            });
	        }
	    }, {
	        key: 'resetPassword',
	        value: function resetPassword(username) {
	            return this.$http.post(this.ENV.URL + '/forgotpassword', {
	                'username': username
	            }).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'editProfile',
	        value: function editProfile(changed) {
	            var _this10 = this;

	            return this.$http.post(this.ENV.URL + '/users/me/settings/profile', changed).then(function () {
	                return _this10.me();
	            }).then(function (user) {
	                return _this10.setUser(user, true);
	            });
	        }
	    }, {
	        key: 'isAuthorized',
	        value: function isAuthorized(authorization, params) {
	            if (!authorization) return true;
	            if (!this.$rootScope.me && !this.$rootScope.roles) return false;

	            var required = {};

	            if (authorization.entity) required['entity'] = authorization.entity;

	            if (authorization.id) required['id'] = authorization.id === ':id' && params && params.id ? params.id : authorization.id;

	            if (required.entity === 'provider') {
	                if (this.anyValid(_lodash2.default.filter(this.$rootScope.roles, required), authorization.role)) return true;
	                return false;
	            }
	            if (required.entity === 'organization') {
	                if (this.anyValid(_lodash2.default.filter(this.$rootScope.roles, required), authorization.role)) return true;
	                if (this.anyValid(_lodash2.default.filter(this.$rootScope.roles, { entity: 'provider', id: this.ENV.PROVIDER }), authorization.role)) return;
	                return false;
	            }
	            //TODO - Groups?
	            // if (required.entity === 'group') {
	            // }

	            return true;
	        }

	        // IDENTITY

	    }, {
	        key: 'anyValid',
	        value: function anyValid(roles, requiredRole) {
	            var knownRoles = ['doer', 'admin'];
	            if (!roles || roles.length <= 0) return false;
	            if (!requiredRole) return true;
	            for (var i in roles) {
	                if (roles[i].role === requiredRole) return true;
	                if (knownRoles.indexOf(roles[i].role) >= knownRoles.indexOf(requiredRole)) {
	                    return true;
	                }
	            }
	        }
	    }, {
	        key: 'setLang',
	        value: function setLang(user) {
	            if (user && user.lang) {
	                this.$translate.use(user.lang);
	            }
	        }
	    }, {
	        key: 'isPlatform',
	        value: function isPlatform() {
	            return this.$rootScope.isPlatform;
	        }
	    }, {
	        key: 'isProvider',
	        value: function isProvider() {
	            return this.$rootScope.role.entity === "provider";
	        }
	    }, {
	        key: 'isAdmin',
	        value: function isAdmin() {
	            return this.$rootScope.role.role === "admin";
	        }
	    }, {
	        key: 'isAdminOfOrganization',
	        value: function isAdminOfOrganization() {
	            return this.$rootScope.role.role === "admin" && this.$rootScope.role.entity === "organization";
	        }
	    }, {
	        key: 'isAdminOfProvider',
	        value: function isAdminOfProvider() {
	            return this.$rootScope.role.role === "admin" && this.$rootScope.role.entity === "provider";
	        }
	    }, {
	        key: 'isAdminOfGroup',
	        value: function isAdminOfGroup() {
	            return this.$rootScope.role.role === "admin" && this.$rootScope.role.entity === "group";
	        }
	    }, {
	        key: 'isDoerOfGroup',
	        value: function isDoerOfGroup() {
	            return this.$rootScope.role.role === "doer" && this.$rootScope.role.entity === "group";
	        }
	    }, {
	        key: 'isMe',
	        value: function isMe(user) {
	            return this.$rootScope.user.username === user.username;
	        }
	    }, {
	        key: 'getPasswordLength',
	        value: function getPasswordLength() {
	            return this.isAdmin() ? 15 : 8;
	        }
	    }, {
	        key: 'checkAuthcode',
	        value: function checkAuthcode(code) {
	            var payload = { 'code': code };
	            return this.RequestService.post(this.ENV.URL + '/users/me/tfa/verify', payload);
	        }
	    }, {
	        key: 'setupTfa',
	        value: function setupTfa() {
	            return this.RequestService.post(this.ENV.URL + '/users/me/tfa/setup');
	        }
	    }, {
	        key: 'enableDisableTfa',
	        value: function enableDisableTfa(user, value) {
	            var _this11 = this;

	            return this.RequestService.post(this.ENV.URL + '/users/me/settings/profile', {
	                'tfaRequired': value
	            }).then(function (res) {
	                if (res["status"]) {
	                    var data = res.data;
	                    _this11.Global.setDefaultAuthHeader(data.token);
	                    _this11.setUser(data, true);
	                }
	                return res;
	            });
	        }
	    }]);

	    return AuthService;
	}();

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AppService = exports.AppService = function () {
	    AppService.$inject = ["$rootScope", "$state", "$stateParams", "$translate", "$translatePartialLoader", "ENV", "$uibModal", "$timeout", "$filter", "$window", "$document", "moment", "LocalStorage"];
	    function AppService($rootScope, $state, $stateParams, $translate, $translatePartialLoader, ENV, $uibModal, $timeout, $filter, $window, $document, moment, LocalStorage) {
	        'ngInject';

	        _classCallCheck(this, AppService);

	        this.$rootScope = $rootScope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        this.$translatePartialLoader = $translatePartialLoader;
	        this.ENV = ENV;
	        this.$uibModal = $uibModal;
	        this.$timeout = $timeout;
	        this.$filter = $filter;
	        this.$window = $window;
	        this.$document = $document;
	        this.moment = moment;

	        this.LocalStorage = LocalStorage;

	        $rootScope.ENV = ENV;
	        $rootScope.App = this;
	        $rootScope.user = LocalStorage.getUser() || null;
	        $rootScope.role = LocalStorage.getRole() || null;

	        this.counter = 0;
	        this.config = {
	            'name': ENV.APP.NAME,
	            'email': {
	                'from': null,
	                'signature': '<br><br><i>' + this.$translate.instant('EMAIL_SIGNATURE', { team: ENV.APP.NAME }) + '</i>'
	            }
	        };

	        this.menu = {
	            closed: LocalStorage.getMenuIsClosed(),
	            hidden: false
	        };
	        this.submenu = {
	            _lastOpen: null,
	            _lastEntered: null
	        };
	        this.organizationMenu = { 'open': false };
	        this.roleMenu = { 'open': false };
	        this.rightPanel = { 'closed': false };

	        this.header = { 'hidden': false };

	        this.breadcrums = {
	            title: '',
	            icon: null,
	            hidden: false,
	            loading: false,
	            steps: null,
	            scope: null,
	            billboard: null,
	            rightActions: [],
	            status: [],
	            back: null
	        };

	        this.icon = {
	            provider: 'crown',
	            organization: 'building',
	            group: 'project-diagram',
	            location: 'project-diagram',
	            dashboard: 'tachometer-alt',
	            chargepoint: 'charging-station',
	            charge: 'battery-bolt',
	            userkey: 'address-card',
	            customer: 'car',
	            settings: 'cogs',
	            tariff: 'receipt',
	            agreement: 'handshake'
	        };

	        this.loading = { totalPreloading: 0 };

	        this.title = {
	            preffix: null,
	            title: ''
	        };

	        this.modals = {};

	        this.notification = {
	            visible: false,
	            message: '',
	            style: 'ok',
	            icon: 'check-circle',
	            timer: null,
	            delayer: null,
	            keepAnyNotificationYet: false,
	            notificationKeeper: null
	        };

	        this.back = {
	            stack: [],
	            popping: null
	        };
	    }

	    _createClass(AppService, [{
	        key: 'getUID',
	        value: function getUID(prefix, sufix) {
	            return (prefix ? prefix + '-' : '') + this.counter++ + (sufix ? sufix + '-' : '');
	        }
	    }, {
	        key: 'asId',
	        value: function asId(input) {
	            return _lodash2.default.deburr(input).replace(/[ ]+/g, '-').toLowerCase();
	        }
	    }, {
	        key: 'isValidId',
	        value: function isValidId(input) {
	            return input && input.match(/^[a-z0-9\-]+$/);
	        }
	    }, {
	        key: 'onlyKey',
	        value: function onlyKey(key) {
	            if (key.indexOf('|') > 0) {
	                return key.substr(0, key.indexOf('|') - 1).trim();
	            }
	            return key;
	        }
	    }, {
	        key: 'getRandomString',
	        value: function getRandomString(len) {
	            var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	            var random = "";
	            var values = void 0;

	            if (this.$window.crypto && this.$window.crypto.getRandomValues) {
	                values = new Uint32Array(len);
	                this.$window.crypto.getRandomValues(values);
	                for (var i = 0; i < len; i++) {
	                    random += charset[values[i] % charset.length];
	                }
	            } else {
	                for (var _i = 0; _i < len; _i++) {
	                    random += charset[Math.floor(Math.random() * charset.length)];
	                }
	            }
	            return random;
	        }
	    }, {
	        key: 'getSelectedText',
	        value: function getSelectedText() {
	            var text = "";
	            if (this.$window.getSelection) {
	                text = this.$window.getSelection().toString();
	            } else if (this.$document[0].selection && this.$document[0].selection.type != "Control") {
	                text = this.$document[0].selection.createRange().text;
	            }
	            return text;
	        }
	    }, {
	        key: 'isSelectedText',
	        value: function isSelectedText() {
	            return this.getSelectedText() !== '';
	        }
	    }, {
	        key: 'toggleMenu',
	        value: function toggleMenu() {
	            angular.element('#left').css('transition', 'all 0.5s ease');
	            this.menu.closed = !this.menu.closed;
	            this.LocalStorage.setMenuIsClosed(this.menu.closed);
	        }
	    }, {
	        key: 'closeOrganizationMenu',
	        value: function closeOrganizationMenu() {
	            this.organizationMenu.open = false;
	        }
	    }, {
	        key: 'closeRoleMenu',
	        value: function closeRoleMenu() {
	            this.roleMenu.open = false;
	        }
	    }, {
	        key: 'toggleRightPanel',
	        value: function toggleRightPanel() {
	            this.rightPanel.closed = !this.rightPanel.closed;
	            this.$rootScope.$broadcast('layoutChanged');
	        }
	    }, {
	        key: 'openRightPanel',
	        value: function openRightPanel() {
	            this.rightPanel.closed = false;
	            this.$rootScope.$broadcast('layoutChanged');
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums(title, icon) {
	            this.breadcrums = Object.assign(this.breadcrums, {
	                title: title || '',
	                icon: icon || null,
	                steps: [],
	                scope: null,
	                billboard: null,
	                rightActions: [],
	                status: [],
	                hidden: false,
	                loading: title ? false : this.breadcrums.loading
	            });
	        }
	    }, {
	        key: 'setBreadcrumsTitle',
	        value: function setBreadcrumsTitle() {
	            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	            this.breadcrums.title = title;
	        }
	    }, {
	        key: 'setBreadcrumsSteps',
	        value: function setBreadcrumsSteps() {
	            var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	            this.breadcrums.steps = steps;
	        }
	    }, {
	        key: 'setBreadcrumsStatus',
	        value: function setBreadcrumsStatus() {
	            var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	            this.breadcrums.status = status;
	        }
	    }, {
	        key: 'setBreadcrumsBillboard',
	        value: function setBreadcrumsBillboard() {
	            var billboard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	            this.breadcrums.billboard = billboard;
	        }
	    }, {
	        key: 'setBreadcrumsRightActions',
	        value: function setBreadcrumsRightActions() {
	            var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	            this.breadcrums.rightActions = actions;
	        }
	    }, {
	        key: 'getActionReload',
	        value: function getActionReload(onReload) {
	            return { tooltip: this.$translate.instant('APP.ACTION.RELOAD_DATA'), onClick: onReload, icon: 'sync' };
	        }
	    }, {
	        key: 'getActionToggleAdvancedFilters',
	        value: function getActionToggleAdvancedFilters(onToggleAdvancedFilters) {
	            return { tooltip: this.$translate.instant('APP.ACTION.ADVANCED_SEARCH'), onClick: onToggleAdvancedFilters, icon: 'sliders-h' };
	        }
	    }, {
	        key: 'getActionUp',
	        value: function getActionUp(href, tooltip) {
	            return { tooltip: tooltip || this.$translate.instant('APP.ACTION.BROWSE_UP'), href: href, icon: 'chevron-up' };
	        }
	    }, {
	        key: 'getActionBack',
	        value: function getActionBack(href, tooltip) {
	            var back = _lodash2.default.last(this.back.stack);
	            if (back) return {
	                tooltip: this.$translate.instant('APP.ACTION.BACK_TO') + ' ' + this.$translate.instant(back.data.display),
	                href: back.href,
	                onClick: this.goBack.bind(this),
	                icon: 'chevron-left'
	            };
	            if (href) return {
	                tooltip: tooltip || this.$translate.instant('APP.ACTION.BACK'),
	                href: href,
	                icon: 'chevron-left'
	            };
	        }
	    }, {
	        key: 'getActionSearch',
	        value: function getActionSearch(onSearch) {
	            var _this = this;

	            return {
	                tooltip: this.$translate.instant('APP.ACTION.SEARCH_CHARGER'),
	                onClick: onSearch,
	                icon: 'fal fa-search',
	                onlyIf: function onlyIf() {
	                    return _this.$rootScope.role.entity === "provider";
	                }
	            };
	        }
	    }, {
	        key: 'setBreadcrumsCurrentScope',
	        value: function setBreadcrumsCurrentScope(data) {
	            var organizationId = data.organizationId,
	                groupId = data.groupId,
	                custom = data.custom,
	                little = data.little;

	            if (!_lodash2.default.isArray(this.breadcrums.status)) this.breadcrums.status = [];
	            var display = null;
	            if (groupId) {
	                display = this.$filter('groupName')(groupId);
	            } else if (organizationId) {
	                display = this.$filter('organizationName')(this.$rootScope.role.organizationName);
	                if (!display) display = this.$filter('organizationName')(organizationId);
	            }
	            this.breadcrums.scope = {
	                display: display || custom || null,
	                little: little || (custom ? '' : this.$translate.instant('APP.BREADCRUMS.OF'))
	            };
	        }
	    }, {
	        key: 'setLoading',
	        value: function setLoading(loading) {
	            var _this2 = this;

	            if (this.notification['keepAnyNotificationYet']) this.updateNotificationKeeper();
	            if (loading && !this.notification['keepAnyNotificationYet']) this.hideNotification();
	            this.$timeout(function () {
	                return _this2.breadcrums.loading = loading;
	            }, 0);
	        }
	    }, {
	        key: 'setPreLoading',
	        value: function setPreLoading(loading) {
	            if (loading) {
	                this.loading.totalPreloading++;
	                this.setLoading(true);
	            } else {
	                this.loading.totalPreloading--;
	                if (this.loading.totalPreloading <= 0) this.setLoading(false);
	            }
	        }
	    }, {
	        key: 'setPreffixTitle',
	        value: function setPreffixTitle() {
	            var preffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	            this.title.preffix = preffix;
	        }
	    }, {
	        key: 'setTitle',
	        value: function setTitle() {
	            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	            this.$document[0].title = (this.title.preffix ? this.title.preffix + ' ' : '') + title;
	        }
	    }, {
	        key: 'openModal',
	        value: function openModal($scope, filename, options) {
	            var templateUrl = "app/views/modals/" + filename;
	            var name = options && options.name ? options.name : 'default';
	            this.modals[name] = this.$uibModal.open(_lodash2.default.defaults({}, options, {
	                animation: false,
	                backdrop: 'static',
	                keyboard: false,
	                size: 'md', // 'sm', 'lg'
	                templateUrl: templateUrl,
	                scope: $scope
	            }));
	        }
	    }, {
	        key: 'closeModal',
	        value: function closeModal(reason, options) {
	            var name = options && options.name ? options.name : 'default';
	            if (this.modals[name]) {
	                this.modals[name].close(reason);
	            }
	        }
	    }, {
	        key: 'openLockedModal',
	        value: function openLockedModal($scope, templateUrl, options) {
	            this.openModal($scope, templateUrl, _lodash2.default.defaults({}, options, {
	                backdrop: 'static',
	                keyboard: false
	            }));
	        }
	    }, {
	        key: 'getTableFilters',
	        value: function getTableFilters(name) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var filters = [];
	            switch (name) {
	                case "charge":
	                    filters = [].concat(_toConsumableArray(this._getComplexFilter('startAndMainChargeStart')), [this._getFilter('search', {
	                        combo: [{ id: 'chargepointName.ilike', url: 'punto', label: this.$translate.instant('FILTER.CHARGES.CHARGEPOINT') }, { id: 'start.customerName.ilike', url: 'cliente', label: this.$translate.instant('FILTER.CHARGES.CUSTOMER') }, { id: 'start.userKeyId.ilike', url: 'llave', label: this.$translate.instant('FILTER.CHARGES.KEY') }, { id: 'receiptCode', url: 'receipt_code', label: this.$translate.instant('RECEIPT_CODE') }, { id: 'emsp', url: 'emsp', label: this.$translate.instant('EMSP') }, { id: 'cpo', url: 'cpo', label: this.$translate.instant('CPO') }]
	                    }), this._getFilter('duration'), this._getFilter('effectiveDuration'), this._getFilter('meter'), this._getFilter('maxPower'), this._getFilter('totalCost'), this._getFilter('status'), this._getFilter('roaming')]);
	                    break;
	                case "zone":
	                    filters = [];
	                    break;
	                case "userKey":
	                    filters = [].concat(_toConsumableArray(this._getComplexFilter('activeFromAndActiveTo')), [this._getFilter('search', {
	                        combo: [{ id: 'idToken.ilike', url: 'llave', label: this.$translate.instant('FILTER.USERKEYS.USERKEY') }, { id: 'customerName.ilike', url: 'Cliente', label: this.$translate.instant('FILTER.CHARGES.CUSTOMER') }, { id: 'type', url: 'type', label: this.$translate.instant('TYPE') }, { id: 'origin', url: 'origin', label: this.$translate.instant('COMMON.ORIGIN') }, { id: 'roamingOrganizationName.ilike', url: 'roaming-organization-name', label: this.$translate.instant('ROAMING_ORGANIZATION') }]
	                    }), this._getFilter('group', {
	                        reloadValues: function reloadValues(filter) {
	                            var values = [];
	                            if (filter && filter.initValues) for (var i in filter.initValues) {
	                                values.push(filter.initValues[i]);
	                            }return options["context"]["GroupsService"].getGroups({ organization: options["context"]["organization"], group: options["context"]["group"]["id"] }).then(function (groups) {
	                                var flattenedGroups = options["context"]["GroupsHelper"].flatten(groups);
	                                for (var i in flattenedGroups) {
	                                    values.push({ id: flattenedGroups[i].id, label: flattenedGroups[i].name });
	                                }return values;
	                            });
	                        }
	                    }), this._getFilter('blocked'), this._getFilter('master'), this._getFilter('roaming')]);
	                    break;
	                case "customer":
	                    filters = [this._getFilter('search', {
	                        combo: [{ id: 'name.ilike', url: 'nombre', label: this.$translate.instant('FILTER.NAME') }, { id: 'userId.ilike', url: 'email', label: this.$translate.instant('FILTER.EMAIL') }]
	                    }), this._getFilter('personType')];
	                    break;
	                case "organization":
	                    filters = [this._getFilter('search', {
	                        combo: [{ id: 'name.ilike', url: 'nombre', label: this.$translate.instant('FILTER.NAME') }]
	                    })];
	                    break;
	                case "tariff":
	                    filters = [this._getFilter('includeInherited')];
	                    break;
	                case "user":
	                    filters = [];
	                    break;
	                case "chargepoint":
	                    filters = [].concat(_toConsumableArray(this._getComplexFilter('createdAtAndUpdatedAt')), [this._getFilter('ownership'), this._getFilter('search', {
	                        combo: [{ id: 'name.ilike', url: 'nombre', label: this.$translate.instant('FILTER.CHARGEPOINTS.NAME') }, { id: 'serialOCPP.ilike', url: 'punto_serial', label: this.$translate.instant('FILTER.CHARGEPOINTS.SERIAL_OCPP') }, { id: 'id.ilike', url: 'punto_id', label: this.$translate.instant('FILTER.CHARGEPOINTS.UUID') }, { id: 'chargePointVendor.ilike', url: 'marca', label: this.$translate.instant('FILTER.CHARGEPOINTS.VENDOR') }, { id: 'chargePointModel.ilike', url: 'modelo', label: this.$translate.instant('FILTER.CHARGEPOINTS.MODEL') }, { id: 'groupName.ilike', url: 'grupo', label: this.$translate.instant('APP.HEADER.CHARGEPOINTS.GROUP') }, { id: 'physicalReference', url: 'physical_reference', label: this.$translate.instant('PHYSICAL_REFERENCE') }, { id: 'serialNumber.ilike', url: 'serial_number', label: this.$translate.instant('SERIAL_NUMBER') }]
	                    }), this._getFilter('ocppConnection.connected'), this._getFilter('chargepointConnectorStatus')]);
	                    break;
	                case "auditory":
	                    filters = [this._getFilter('from'), this._getFilter('to')];
	                    break;
	                case "settings_billing":
	                    filters = [this._getFilter('fromDate'), this._getFilter('toDate'), this._getFilter('fromDuration'), this._getFilter('fromPower'), this._getFilter('billable')];
	                    break;
	                case "maintainers":
	                    filters = [this._getFilter('search', {
	                        combo: [{ id: 'companyName.ilike', url: 'company_name', label: this.$translate.instant('COMPANY') }]
	                    })];
	                    break;
	                case "holidays":
	                    filters = [];
	                    break;
	                case "tariffs":
	                    filters = [this._getFilter('search', {
	                        combo: [{ id: 'locationName', label: this.$translate.instant('ZONE') }, { id: 'name', label: this.$translate.instant('NAME') }]
	                    }), this._getFilter('group', {
	                        id: 'groupId',
	                        label: null,
	                        advanced: true,
	                        filterGroup: {
	                            id: 'group',
	                            label: this.$translate.instant('ZONE')
	                        },
	                        reloadValues: function reloadValues(filter) {
	                            var values = [];
	                            if (filter && filter.initValues) for (var i in filter.initValues) {
	                                values.push(filter.initValues[i]);
	                            }return options["context"]["GroupsService"].getGroups({ organization: options["context"]["organization"], group: options["context"]["group"] }).then(function (groups) {
	                                var flattenedGroups = options["context"]["GroupsHelper"].flatten(groups);
	                                for (var i in flattenedGroups) {
	                                    values.push({ id: flattenedGroups[i].id, label: flattenedGroups[i].name });
	                                }return values;
	                            });
	                        }
	                    }), this._getFilter('scope', {
	                        value: null,
	                        defaultValue: null,
	                        values: [{ id: 'EMSP', label: this.$translate.instant('EMSP') }, { id: 'CPO', label: this.$translate.instant('CPO') }, { id: 'QR', label: this.$translate.instant('QR') }, { id: null, label: this.$translate.instant('COMMON.ALL') }]
	                    }), this._getFilter('includeDisabled', {
	                        advanced: true,
	                        filterGroup: {
	                            id: 'includeDisabled',
	                            label: this.$translate.instant('SHOW_DELETED_TARIFFS')
	                        }
	                    }), this._getFilter('includeInherited', {
	                        label: null,
	                        advanced: true,
	                        filterGroup: {
	                            id: 'includeInherited',
	                            label: this.$translate.instant('SHOW_INHERITED_TARIFFS')
	                        }
	                    }), this._getFilter('connectorTypes'), this._getFilter('maxPower', {
	                        id: 'powerRange',
	                        as: { min: 'powerRangeFrom', max: 'powerRangeTo' },
	                        filterGroup: {
	                            id: 'powerRange',
	                            label: this.$translate.instant('POWER_RANGE')
	                        }
	                    })].concat();
	                    break;
	                case "agreements":
	                    filters = [this._getFilter('search', {
	                        combo: [{ id: 'agreementCode', url: 'agreementCode', label: this.$translate.instant('CODE') }, { id: 'organizationName', url: 'organizationName', label: this.$translate.instant('ORGANIZATION_NAME') }, { id: 'agreementId', url: 'agreementId', label: this.$translate.instant('ID') }]
	                    })];
	                    break;
	                case "operations":
	                    filters = [this._getFilter('search', {
	                        combo: [{ id: 'operationName', url: 'operationName', label: this.$translate.instant('NAME') }, { id: 'locationName', url: 'locationName', label: this.$translate.instant('LOCATION_NAME') }, { id: 'agreementName', url: 'agreementName', label: this.$translate.instant('AGREEMENT_NAME') }]
	                    })];
	                    break;
	                case "locations":
	                    filters = [this._getSelectFilter('purpose', 'SCOPE', null, [{ id: null, label: this.$translate.instant('ALL') }, { id: 'General', label: this.$translate.instant('OWN') }, { id: 'Roaming', label: this.$translate.instant('ROAMING') }]), this._getBooleanFilter('onlyAtomic', 'ONLY_ATOMIC', 'false'), this._getSelectSearchFilter('operationId', 'OPERATION', 'id', '', [], function (operation) {
	                        return operation.name;
	                    }, function (term, pagination) {
	                        var aux = {
	                            pagination: pagination,
	                            params: {
	                                operationName: term,
	                                orderby: 'id,asc',
	                                organizationId: options.organizationId
	                            }
	                        };
	                        return options["context"]["OperationService"].getOperations(aux);
	                    }), this._getFilter('search', {
	                        combo: [{ id: 'locationName', url: 'locationName', label: this.$translate.instant('NAME') }, { id: 'roamingId', url: 'roamingId', label: this.$translate.instant('ROAMING_ID') }]
	                    })];
	                    break;
	                case "margins":
	                    filters = [this._getFilter('includeDisabled', {
	                        advanced: true,
	                        filterGroup: {
	                            id: 'includeDisabled',
	                            label: this.$translate.instant('SHOW_DELETED_MARGINS')
	                        }
	                    }), this._getFilter('includeInherited', {
	                        label: null,
	                        advanced: true,
	                        filterGroup: {
	                            id: 'includeInherited',
	                            label: this.$translate.instant('SHOW_INHERITED_MARGINS')
	                        }
	                    })].concat();
	                    break;
	            }
	            if (options && options.omit) {
	                filters = this._omitFilters(filters, options["omit"]);
	            }
	            if (options && options.modify) {
	                this._modifyFilters(filters, options["modify"]);
	            }
	            return this._setQueryFilters(filters);
	        }
	    }, {
	        key: 'getPagination',
	        value: function getPagination(itemsPerPage, maxPages) {
	            return {
	                currentPage: 1,
	                itemsPerPage: itemsPerPage > 0 ? itemsPerPage : 20,
	                totalItems: 0,
	                maxPages: maxPages || 10
	            };
	        }
	    }, {
	        key: 'getSorting',
	        value: function getSorting(keys, key, order) {
	            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	            var transform = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (key) {
	                return key;
	            };

	            return {
	                keys: keys,
	                key: key ? key : keys[0],
	                defaultKey: key ? key : keys[0],
	                order: order ? order : 'asc',
	                types: options.types || undefined,
	                multiple: options.multiple || undefined,
	                transform: transform
	            };
	        }
	    }, {
	        key: 'getTable',
	        value: function getTable(type, custom) {
	            var table = this._getTable(type);
	            if (custom && custom.omit) this._omitFromTable(table, custom.omit);
	            if (custom && custom.modify) {
	                this._modifyFromTable(table, custom.modify);
	            }
	            return table;
	        }
	    }, {
	        key: 'getGroupsTreeCustom',
	        value: function getGroupsTreeCustom() {
	            return '<span class="mini"><i class="fal fa-charging-station mr"></i>{{node._total.chargepoints}}</span>';
	        }
	    }, {
	        key: 'getMap',
	        value: function getMap() {
	            return {
	                key: this.ENV.MAPS,
	                marker: { icon: "../../assets/images/marker-group.png" }
	            };
	        }
	    }, {
	        key: 'getOrganizationFromScope',
	        value: function getOrganizationFromScope(scope) {
	            var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;

	            if (scope && scope.organization) return scope.organization;
	            if (scope && scope.ctrl && scope.ctrl.organization) return scope.ctrl.organization;
	            if (scope.$parent && deep > 0) return this.getOrganizationFromScope(scope.$parent, deep - 1);
	            return null;
	        }
	    }, {
	        key: 'getIdFromScope',
	        value: function getIdFromScope(scope) {
	            if (scope && scope.id) return scope.id;else if (scope && scope.$parent && scope.$parent.id) return scope.$parent.id;else if (scope && scope.$parent.$parent && scope.$parent.$parent.id) return scope.$parent.$parent.id;else if (scope && scope.$parent.$parent.$parent && scope.$parent.$parent.$parent.id) return scope.$parent.$parent.$parent.id;
	            return null;
	        }
	    }, {
	        key: 'showNotification',
	        value: function showNotification(message, style, duration, delay) {
	            var _this3 = this;

	            if (delay) {
	                if (this.notification['delayer']) {
	                    this.$timeout.cancel(this.notification['delayer']);
	                    this.notification['delayer'] = null;
	                }
	                this.notification['delayer'] = this.$timeout(function () {
	                    _this3.showNotification(message, style, duration);
	                }, delay);
	                return;
	            }
	            this.notification['visible'] = false;
	            this.notification['message'] = message;
	            this.notification['style'] = style || 'ok';
	            switch (this.notification['style']) {
	                case 'error':
	                    this.notification['icon'] = 'times-circle';
	                    break;
	                case 'warning':
	                    this.notification['icon'] = 'exclamation-circle';
	                    break;
	                case 'ok':
	                    this.notification['icon'] = 'check-circle';
	                    break;
	            }
	            if (angular.isUndefined(duration) || duration === null) {
	                duration = 4000;
	                if (this.notification['style'] == 'error') {
	                    duration = -1;
	                }
	            }
	            if (this.notification['timer']) {
	                this.$timeout.cancel(this.notification['timer']);
	                this.notification['timer'] = null;
	            }
	            if (duration > 0) {
	                this.notification['timer'] = this.$timeout(function () {
	                    _this3.notification['visible'] = false;
	                }, duration);
	            }
	            this.notification['keepAnyNotificationYet'] = true;
	            this.updateNotificationKeeper();
	            this.notification['visible'] = true;
	        }
	    }, {
	        key: 'updateNotificationKeeper',
	        value: function updateNotificationKeeper() {
	            var _this4 = this;

	            if (this.notification['notificationKeeper']) {
	                this.$timeout.cancel(this.notification['notificationKeeper']);
	                this.notification['notificationKeeper'] = null;
	            }
	            this.notification['notificationKeeper'] = this.$timeout(function () {
	                _this4.notification['keepAnyNotificationYet'] = false;
	            }, 1200);
	        }
	    }, {
	        key: 'hideNotification',
	        value: function hideNotification() {
	            this.notification['visible'] = false;
	        }
	    }, {
	        key: 'asCSV',
	        value: function asCSV(data) {
	            var csv = [];
	            var comma = ';';
	            if (data && _lodash2.default.isPlainObject(data)) {
	                for (var k in data) {
	                    csv.push(k + comma + data[k]);
	                }
	            }
	            return csv;
	        }
	    }, {
	        key: 'downloadCSV',
	        value: function downloadCSV(csv, filename) {
	            var csvFile;
	            var downloadLink;
	            filename = filename || "data.csv";
	            if (!_lodash2.default.endsWith(filename.toLowerCase(), '.csv')) filename = filename + '.csv';
	            // CSV file
	            csvFile = new Blob([_lodash2.default.isArray(csv) ? csv.join("\n") : csv], { type: "text/csv" });
	            // Download link
	            downloadLink = this.$document[0].createElement("a");
	            // File name
	            downloadLink.download = filename;
	            // Create a link to the file
	            downloadLink.href = this.$window.URL.createObjectURL(csvFile);
	            // Hide download link
	            downloadLink.style.display = "none";
	            // Add the link to DOM
	            this.$document[0].body.appendChild(downloadLink);
	            // Click download link
	            downloadLink.click();
	            this.$document[0].body.removeChild(downloadLink);
	        }
	    }, {
	        key: 'downloadAsCSV',
	        value: function downloadAsCSV(data, filename) {
	            this.downloadCSV(this.asCSV(data), filename);
	        }
	    }, {
	        key: 'canBeCSV',
	        value: function canBeCSV(data) {
	            if (data && _lodash2.default.isPlainObject(data)) {
	                for (var k in data) {
	                    if (_lodash2.default.isObject(data[k])) return false;
	                }
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'downloadJSON',
	        value: function downloadJSON(json, filename) {
	            var jsonFile;
	            var downloadLink;
	            filename = filename || "data.json";
	            if (!_lodash2.default.endsWith(filename.toLowerCase(), '.json')) filename = filename + '.json';
	            // JSON file
	            jsonFile = new Blob([JSON.stringify(json, null, 2)], { type: "application/json" });
	            // Download link
	            downloadLink = this.$document[0].createElement("a");
	            // File name
	            downloadLink.download = filename;
	            // Create a link to the file
	            downloadLink.href = this.$window.URL.createObjectURL(jsonFile);
	            // Hide download link
	            downloadLink.style.display = "none";
	            // Add the link to DOM
	            this.$document[0].body.appendChild(downloadLink);
	            // Click download link
	            downloadLink.click();
	            this.$document[0].body.removeChild(downloadLink);
	        }
	    }, {
	        key: 'goBack',
	        value: function goBack() {
	            var back = this.back.stack.pop();
	            if (back) {
	                this.back.popping = back;
	                this.$state.go(back.stateName, back.stateParams);
	            }
	        }
	    }, {
	        key: 'loadTranslations',
	        value: function loadTranslations(parts) {
	            if (parts) {
	                if (_lodash2.default.isArray(parts)) {
	                    for (var i in parts) {
	                        this.$translatePartialLoader.addPart(parts[i]);
	                    }
	                } else {
	                    this.$translatePartialLoader.addPart(parts);
	                }
	            }
	            return this.$translate.refresh();
	        }
	    }, {
	        key: 'getLanguages',
	        value: function getLanguages() {
	            return [{ display: this.$translate.instant('COMMON.LANG_ES'), id: 'es' }, { display: this.$translate.instant('COMMON.LANG_EN'), id: 'en' }, { display: this.$translate.instant('COMMON.LANG_GL'), id: 'gl' }, { display: this.$translate.instant('COMMON.LANG_PT'), id: 'pt' }, { display: this.$translate.instant('COMMON.LANG_PT-BR'), id: 'pt-br' }, { display: this.$translate.instant('COMMON.LANG_CA-ES'), id: 'ca-es' }, { display: this.$translate.instant('COMMON.LANG_DE'), id: 'de' }, { display: this.$translate.instant('COMMON.LANG_FR'), id: 'fr' }, { display: this.$translate.instant('COMMON.LANG_EU-ES'), id: 'eu-es' }];
	        }
	    }, {
	        key: 'updateComplexDataObject',
	        value: function updateComplexDataObject(currentObject, newObject) {
	            var _this5 = this;

	            for (var key in newObject) {
	                var newData = newObject[key];
	                var currentData = currentObject[key];
	                if (angular.isObject(newData)) {
	                    if (angular.isArray(newData)) {
	                        if (!angular.isArray(currentData)) {
	                            currentObject[key] = newData.slice();
	                        } else if (currentData.length > 0 && !angular.isObject(currentData[0]) || newData.length > 0 && !angular.isObject(newData[0])) {
	                            currentObject[key] = newData;
	                        } else {
	                            var _loop = function _loop(i) {
	                                var item = newData[i];
	                                var index = currentData.findIndex(function (aux) {
	                                    return aux.id === (item && item.hasOwnProperty('id') ? item.id : null);
	                                });
	                                if (index !== -1) {
	                                    currentObject[key][index] = _this5.updateComplexDataObject(currentData[index], item);
	                                } else {
	                                    currentObject[key].push(item);
	                                }
	                            };

	                            for (var i = 0; i < newData.length; i++) {
	                                _loop(i);
	                            }
	                        }
	                    } else if (angular.isObject(currentData)) {
	                        currentObject[key] = this.updateComplexDataObject(currentData, newData);
	                    } else {
	                        currentObject[key] = newData;
	                    }
	                } else {
	                    currentObject[key] = newData;
	                }
	            }
	            return currentObject;
	        }
	    }, {
	        key: '_getFilter',
	        value: function _getFilter(name) {
	            var _this6 = this;

	            var custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var filter = {};
	            switch (name) {
	                case 'search':
	                    filter = {
	                        label: this.$translate.instant('FILTER.SEARCH_FOR'),
	                        //url: 'search',
	                        url: true,
	                        type: 'text',
	                        value: null,
	                        scope: null
	                    };
	                    break;
	                case 'date':
	                    filter = {
	                        label: 'Fecha',
	                        //url: 'date',
	                        type: 'date',
	                        value: null,
	                        format: 'dd MMM yyyy',
	                        opened: false,
	                        options: {
	                            showWeeks: false,
	                            startingDay: 1
	                        }
	                    };
	                    break;
	                case 'from':
	                    filter = {
	                        label: this.$translate.instant('FILTER.FROM'),
	                        url: 'desde',
	                        type: 'date',
	                        value: null,
	                        format: 'dd MMM yyyy',
	                        queryFormat: 'YYYY-MM-DDTHH:mm:ss[Z]',
	                        opened: false,
	                        startOfDay: true,
	                        options: {
	                            showWeeks: false,
	                            startingDay: 1
	                        }
	                    };
	                    break;
	                case 'to':
	                    filter = {
	                        label: this.$translate.instant('FILTER.TO'),
	                        url: 'hasta',
	                        type: 'date',
	                        value: null,
	                        format: 'dd MMM yyyy',
	                        queryFormat: 'YYYY-MM-DDTHH:mm:ss[Z]',
	                        opened: false,
	                        endOfDay: true,
	                        options: {
	                            showWeeks: false,
	                            startingDay: 1
	                        }
	                    };
	                    break;
	                case 'range':
	                    filter = {
	                        label: 'Rango temporal',
	                        //url: 'range',
	                        type: 'select',
	                        value: 'now-6M',
	                        values: [{
	                            id: 'now-24h',
	                            label: 'Últimas 24 horas'
	                        }, {
	                            id: 'now-7d',
	                            label: 'Últimos 7 días'
	                        }, {
	                            id: 'now-1M',
	                            label: 'Último mes'
	                        }, {
	                            id: 'now-6M',
	                            label: 'Últimos 6 meses'
	                        }, {
	                            id: 'now-1y',
	                            label: 'Último año'
	                        }, {
	                            id: 'now-100y',
	                            label: 'Desde siempre'
	                        }]
	                    };
	                    break;
	                case 'location':
	                    filter = {
	                        label: 'Localización',
	                        //url: 'location',
	                        type: 'geo',
	                        value: {
	                            location: {
	                                latitude: 40.42519001583666, // Madrid
	                                longitude: -3.7073974609375
	                            },
	                            radius: 20000,
	                            locationName: null
	                        },
	                        radiusValues: [{ value: 500, label: '500m' }, { value: 1000, label: '1Km' }, { value: 5000, label: '5Km' }, { value: 10000, label: '10Km' }, { value: 20000, label: '20Km' }, { value: 50000, label: '50Km' }, { value: 100000, label: '100Km' }, { value: 200000, label: '200Km' }]
	                    };
	                    break;
	                case 'duration':
	                    filter = {
	                        url: { min: 'duracion_min', max: 'duracion_max' },
	                        label: null,
	                        type: 'range',
	                        value: { min: 9, max: 172800 },
	                        as: { min: 'duration.from', max: 'duration.to' },
	                        format: function format(value) {
	                            if (value <= 3600) return value;
	                            return value - value % 60;
	                        },
	                        options: {
	                            floor: 9,
	                            ceil: 172800,
	                            logScale: true,
	                            translate: function translate(value) {
	                                if (value <= 9) return '0s';
	                                if (value >= 172800) return '>48h';
	                                if (value == 172799) return '48h';
	                                var duration = _this6.moment.duration(value, 's');
	                                var result = '';
	                                if (duration.asHours() >= 1) result += Math.floor(duration.asHours()) + 'h ';
	                                if (duration.asMinutes() >= 1 && duration.minutes() > 0) result += Math.floor(duration.minutes()) + 'm ';
	                                if (duration.seconds() > 0 && duration.asHours() < 1) result += duration.seconds() + 's';
	                                return result;
	                            },
	                            showTicksValues: true,
	                            ticksArray: [1, 60, 600, 3600, 14400, 43200, 86400, 172799]
	                        },
	                        advanced: true,
	                        filterGroup: {
	                            id: 'duration',
	                            label: this.$translate.instant('FILTER.CHARGES.DURATION'),
	                            comboId: 'duration',
	                            metaFilter: 'duration',
	                            combo: [{ id: 'duration', label: this.$translate.instant('FILTER.CHARGES.DURATION') }, { id: 'effectiveDuration', label: this.$translate.instant('FILTER.CHARGES.EFFECTIVE_DURATION') }]
	                        }
	                    };
	                    break;
	                case 'effectiveDuration':
	                    filter = {
	                        url: { min: 'duracion_efectiva_min', max: 'duracion_efectiva_max' },
	                        label: null,
	                        type: 'range',
	                        value: { min: 9, max: 172800 },
	                        as: { min: 'effectiveDuration.from', max: 'effectiveDuration.to' },
	                        format: function format(value) {
	                            if (value <= 3600) return value;
	                            return value - value % 60;
	                        },
	                        options: {
	                            floor: 9,
	                            ceil: 172800,
	                            logScale: true,
	                            translate: function translate(value) {
	                                if (value <= 9) return '0s';
	                                if (value >= 172800) return '>48h';
	                                if (value == 172799) return '48h';
	                                var duration = _this6.moment.duration(value, 's');
	                                var result = '';
	                                if (duration.asHours() >= 1) result += Math.floor(duration.asHours()) + 'h ';
	                                if (duration.asMinutes() >= 1 && duration.minutes() > 0) result += Math.floor(duration.minutes()) + 'm ';
	                                if (duration.seconds() > 0 && duration.asHours() < 1) result += duration.seconds() + 's';
	                                return result;
	                            },
	                            showTicksValues: true,
	                            ticksArray: [1, 60, 600, 3600, 14400, 43200, 86400, 172799]
	                        },
	                        advanced: true,
	                        filterGroup: { id: 'duration', comboId: 'effectiveDuration', metaFilter: 'duration' }
	                    };
	                    break;
	                case 'meter':
	                    filter = {
	                        url: { min: 'carga_min', max: 'carga_max' },
	                        as: { min: 'meter.from', max: 'meter.to' },
	                        label: null,
	                        type: 'range',
	                        value: { min: 10, max: 10000 },
	                        format: function format(value) {
	                            return value / 100;
	                        },
	                        options: {
	                            floor: 10,
	                            ceil: 10000,
	                            logScale: true,
	                            translate: function translate(value) {
	                                if (value == 10) return '0';
	                                if (value >= 10000) return '>100';
	                                if (value == 9999) return '100kWh';
	                                if (value == 9) return '0kWh';
	                                return value / 100 + '';
	                            },
	                            showTicksValues: true,
	                            ticksArray: [9, 100, 500, 1000, 2000, 5000, 9999]
	                        },
	                        advanced: true,
	                        filterGroup: { id: 'meter', label: this.$translate.instant('FILTER.CHARGES.CHARGE') }
	                    };
	                    break;
	                case 'maxPower':
	                    filter = {
	                        url: { min: 'potencia_min', max: 'potencia_max' },
	                        as: { min: 'maxPower.from', max: 'maxPower.to' },
	                        label: null,
	                        type: 'range',
	                        value: { min: 2, max: 4000 },
	                        format: function format(value) {
	                            return value / 10;
	                        },
	                        options: {
	                            floor: 2,
	                            ceil: 4000,
	                            logScale: true,
	                            translate: function translate(value) {
	                                if (value == 2) return '0';
	                                if (value >= 4000) return '>400';
	                                if (value == 1) return '0kW';
	                                if (value == 3999) return '400kW';
	                                return value / 10 + '';
	                            },
	                            showTicksValues: true,
	                            ticksArray: [1, 10, 50, 100, 200, 500, 1000, 2000, 3999]
	                        },
	                        advanced: true,
	                        filterGroup: { id: 'maxPower', label: this.$translate.instant('FILTER.CHARGES.MAX_POWER') }
	                    };
	                    break;
	                case 'totalCost':
	                    filter = {
	                        url: { min: 'coste_min', max: 'coste_max' },
	                        as: { min: 'totalCost.from', max: 'totalCost.to' },
	                        label: null,
	                        type: 'range',
	                        value: { min: 0, max: 100 },
	                        options: {
	                            floor: 0,
	                            ceil: 100,
	                            translate: function translate(value) {
	                                if (value == 0) return '0€';
	                                if (value >= 100) return '>100€';
	                                return value + '€';
	                            },
	                            showTicksValues: true,
	                            ticksArray: [0, 5, 10, 25, 50, 75, 99]
	                        },
	                        advanced: true,
	                        filterGroup: { id: 'totalCost', label: this.$translate.instant('FILTER.CHARGES.TOTAL_COST') }
	                    };
	                    break;
	                case 'status':
	                    filter = {
	                        url: 'estado',
	                        type: 'select',
	                        value: 'all',
	                        values: [{ id: 'Active', label: this.$translate.instant('FILTER.CHARGES.STATUS_ACTIVE') }, { id: 'Failed', label: this.$translate.instant('FILTER.CHARGES.STATUS_FAILED') }, { id: 'Finished', label: this.$translate.instant('FILTER.CHARGES.STATUS_FINISHED') }, { id: 'all', label: this.$translate.instant('FILTER.CHARGES.STATUS_ALL') }],
	                        defaultValue: 'all',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'status', label: this.$translate.instant('FILTER.CHARGES.STATUS')
	                        }
	                    };
	                    break;
	                case 'ownership':
	                    filter = {
	                        type: 'buttons',
	                        url: 'tipo',
	                        value: 'public',
	                        values: [{ id: 'public', label: this.$translate.instant('FILTER.CHARGEPOINTS.OWNERSHIP.PUBLIC') }, { id: 'roaming', label: this.$translate.instant('FILTER.CHARGEPOINTS.OWNERSHIP.ROAMING') }]
	                    };
	                    break;
	                case 'ocppConnection.connected':
	                    filter = {
	                        url: 'conectado',
	                        type: 'select',
	                        value: 'all',
	                        values: [{ id: 'true', label: this.$translate.instant('FILTER.CHARGEPOINTS.YES') }, { id: 'false', label: this.$translate.instant('FILTER.CHARGEPOINTS.NO') }, { id: 'all', label: this.$translate.instant('FILTER.CHARGEPOINTS.ALL') }],
	                        defaultValue: 'all',
	                        advanced: true,
	                        filterGroup: { id: 'ocppConnection.connected', label: this.$translate.instant('FILTER.CHARGEPOINTS.IS_CONNECTED') }
	                    };
	                    break;
	                case 'chargepointConnectorStatus':
	                    filter = {
	                        url: 'status',
	                        type: 'select',
	                        value: 'all',
	                        values: [{ id: 'Available', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_AVAILABLE', { status: 'Available' }) }, { id: 'Preparing', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_PREPARING', { status: 'Preparing' }) }, { id: 'Charging,SuspendedEV,SuspendedEVSE,Finishing', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_CHARGING') }, { id: 'Charging', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_CHARGING_WITH_STATUS', { status: 'Charging' }) }, { id: 'SuspendedEV', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_CHARGING_WITH_STATUS', { status: 'SuspendedEV' }) }, { id: 'SuspendedEVSE', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_CHARGING_WITH_STATUS', { status: 'SuspendedEVSE' }) }, { id: 'Finishing', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_CHARGING_WITH_STATUS', { status: 'Finishing' }) }, { id: 'Reserved', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_RESERVED', { status: 'Reserved' }) }, { id: 'Unavailable', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_NOT_AVAILABLE', { status: 'Unavailable' }) }, { id: 'Faulted', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_OUT_OF_SERVICE', { status: 'Faulted' }) }, { id: 'all', label: this.$translate.instant('FILTER.CHARGEPOINTS.STATUS_ALL') }],
	                        defaultValue: 'all',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'chargepointStatus', label: this.$translate.instant('FILTER.CHARGEPOINTS.WITH_CONNECTORS_IN_STATUS')
	                        }
	                    };
	                    break;
	                case 'group':
	                    filter = {
	                        url: 'autorizada',
	                        label: this.$translate.instant('FILTER.USERKEYS.AUTHORIZED'),
	                        type: 'select',
	                        asPathParam: true,
	                        value: 'all',
	                        valueName: '',
	                        values: null,
	                        initValues: [{
	                            id: 'all',
	                            label: this.$translate.instant('FILTER.USERKEYS.ANY_GROUP')
	                        }],
	                        defaultValue: 'all'
	                    };
	                    break;
	                case 'blocked':
	                    filter = {
	                        url: 'bloqueada',
	                        type: 'select',
	                        value: 'all',
	                        values: [{
	                            id: 'true',
	                            label: this.$translate.instant('FILTER.USERKEYS.YES')
	                        }, {
	                            id: 'false',
	                            label: this.$translate.instant('FILTER.USERKEYS.NO')
	                        }, {
	                            id: 'all',
	                            label: this.$translate.instant('FILTER.USERKEYS.ALL')
	                        }],
	                        defaultValue: 'all',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'blocked',
	                            label: this.$translate.instant('FILTER.USERKEYS.IS_BLOCKED')
	                        }
	                    };
	                    break;
	                case 'master':
	                    filter = {
	                        url: 'maestra',
	                        type: 'select',
	                        value: 'all',
	                        values: [{
	                            id: 'true',
	                            label: this.$translate.instant('FILTER.USERKEYS.YES')
	                        }, {
	                            id: 'false',
	                            label: this.$translate.instant('FILTER.USERKEYS.NO')
	                        }, {
	                            id: 'all',
	                            label: this.$translate.instant('FILTER.USERKEYS.ALL')
	                        }],
	                        defaultValue: 'all',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'master',
	                            label: this.$translate.instant('FILTER.USERKEYS.IS_MASTER')
	                        }
	                    };
	                    break;
	                case 'roaming':
	                    filter = {
	                        url: 'roaming',
	                        type: 'select',
	                        value: 'all',
	                        values: [{
	                            id: 'true',
	                            label: this.$translate.instant('COMMON.YES')
	                        }, {
	                            id: 'false',
	                            label: this.$translate.instant('COMMON.NO')
	                        }, {
	                            id: 'all',
	                            label: this.$translate.instant('COMMON.ALL')
	                        }],
	                        defaultValue: 'all',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'roaming',
	                            label: this.$translate.instant('FILTER.IS_ROAMING')
	                        }
	                    };
	                    break;
	                case 'includeInherited':
	                    filter = {
	                        label: this.$translate.instant('FILTER.TARIFF.SHOW'),
	                        //url: 'inherited',
	                        type: 'select',
	                        value: 'true',
	                        values: [{
	                            id: 'true',
	                            label: this.$translate.instant('ALL_AVAILABLE')
	                        }, {
	                            id: 'false',
	                            label: this.$translate.instant('ONLY_DEFINED_HERE')
	                        }],
	                        defaultValue: 'true'
	                    };
	                    break;
	                case 'personType':
	                    filter = {
	                        url: 'personType',
	                        label: this.$translate.instant('FILTER.CUSTOMER.CUSTOMER_TYPE'),
	                        type: 'select',
	                        value: 'all',
	                        defaultValue: 'all',
	                        values: [{ id: 'all', label: this.$translate.instant('FILTER.CUSTOMER.TYPES.ANY_TYPE') }, { id: 'Individual', label: this.$translate.instant('FILTER.CUSTOMER.TYPES.INDIVIDUAL') }, { id: 'LegalEntity', label: this.$translate.instant('FILTER.CUSTOMER.TYPES.LEGAL_ENTITY') }, { id: 'Contract', label: this.$translate.instant('FILTER.CUSTOMER.TYPES.CONTRACT') }]
	                    };
	                    break;
	                case 'fromDate':
	                    filter = {
	                        label: this.$translate.instant('FILTER.FROM'),
	                        url: 'desde',
	                        type: 'date',
	                        value: null,
	                        format: 'dd MMM yyyy',
	                        queryFormat: 'YYYY-MM-DDTHH:mm:ss[Z]',
	                        opened: false,
	                        startOfDay: true,
	                        options: {
	                            showWeeks: false,
	                            startingDay: 1
	                        }
	                    };
	                    break;
	                case 'toDate':
	                    filter = {
	                        label: this.$translate.instant('FILTER.TO'),
	                        url: 'hasta',
	                        type: 'date',
	                        value: null,
	                        format: 'dd MMM yyyy',
	                        queryFormat: 'YYYY-MM-DDTHH:mm:ss[Z]',
	                        opened: false,
	                        endOfDay: true,
	                        options: {
	                            showWeeks: false,
	                            startingDay: 1
	                        }
	                    };
	                    break;
	                case 'fromDuration':
	                    filter = {
	                        label: this.$translate.instant('DURATION'),
	                        url: 'duration',
	                        type: 'number',
	                        value: null
	                    };
	                    break;
	                case 'fromPower':
	                    filter = {
	                        label: this.$translate.instant('POWER'),
	                        url: 'power',
	                        type: 'number',
	                        value: null
	                    };
	                    break;
	                case 'billable':
	                    filter = {
	                        label: this.$translate.instant('BILLABLE'),
	                        type: 'select',
	                        url: 'billable',
	                        value: 'true',
	                        values: [{
	                            id: 'true',
	                            label: this.$translate.instant('YES')
	                        }, {
	                            id: 'false',
	                            label: this.$translate.instant('NO')
	                        }],
	                        defaultValue: 'true'
	                    };
	                    break;
	                case 'includeDisabled':
	                    filter = {
	                        id: 'includeDisabled',
	                        type: 'select',
	                        value: 'false',
	                        defaultValue: 'false',
	                        values: [{
	                            id: 'true',
	                            label: this.$translate.instant('FILTER.USERKEYS.YES')
	                        }, {
	                            id: 'false',
	                            label: this.$translate.instant('FILTER.USERKEYS.NO')
	                        }],
	                        advanced: true,
	                        filterGroup: {
	                            id: 'includeDisabled',
	                            label: this.$translate.instant('INCLUDE_DISABLED')
	                        }

	                    };
	                    break;
	                case 'scope':
	                    filter = {
	                        id: 'scope',
	                        // url: 'scope',
	                        type: 'select',
	                        value: 'EMSP',
	                        values: [{ id: 'EMSP', label: 'EMSP' }, { id: 'CPO', label: 'CPO' }],
	                        defaultValue: 'EMSP',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'scope',
	                            label: this.$translate.instant('TYPE')
	                        }
	                    };
	                    break;
	                case 'connectorTypes':
	                    filter = {
	                        advanced: true,
	                        id: 'connectorTypes',
	                        type: 'multi-select',
	                        value: ['TYPE2', 'TYPE2_CABLE', 'TYPE1_CABLE', 'CHADEMO', 'CCS', 'SCHUKO'],
	                        defaultValue: ['TYPE2', 'TYPE2_CABLE', 'TYPE1_CABLE', 'CHADEMO', 'CCS', 'SCHUKO'],
	                        values: [{ id: 'TYPE2', display: 'TYPE2' }, { id: 'TYPE2_CABLE', display: 'TYPE2_CABLE' }, { id: 'TYPE1_CABLE', display: 'TYPE1_CABLE' }, { id: 'CHADEMO', display: 'CHADEMO' }, { id: 'CCS', display: 'CCS' }, { id: 'SCHUKO', display: 'SCHUKO' }],
	                        filterGroup: {
	                            id: 'connectorTypes',
	                            label: this.$translate.instant('CONNECTOR_TYPES')
	                        }
	                    };
	                    break;
	            }
	            return _lodash2.default.defaultsDeep({}, custom, { id: name }, filter);
	        }
	    }, {
	        key: '_getSelectFilter',
	        value: function _getSelectFilter(id, label, value, values) {
	            var custom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

	            var filter = {
	                id: id,
	                label: this.$translate.instant(label),
	                url: id,
	                type: 'select',
	                value: value,
	                defaultValue: value,
	                values: values
	            };
	            return _lodash2.default.defaultsDeep({}, custom, filter);
	        }
	    }, {
	        key: '_getSelectSearchFilter',
	        value: function _getSelectSearchFilter(id, label, queryParam, value, values, display, onSearch) {
	            var custom = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};

	            var filter = {
	                id: id,
	                label: this.$translate.instant(label),
	                url: id,
	                type: 'select-search',
	                queryParam: queryParam,
	                value: value,
	                values: values,
	                display: display,
	                onSearch: onSearch
	            };
	            return _lodash2.default.defaultsDeep({}, custom, filter);
	        }
	    }, {
	        key: '_getBooleanFilter',
	        value: function _getBooleanFilter(id, label, value) {
	            var custom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	            var filter = {
	                id: id,
	                label: this.$translate.instant(label),
	                url: id,
	                type: 'select',
	                value: value,
	                defaultValue: value,
	                values: [{
	                    id: 'true',
	                    label: this.$translate.instant('YES')
	                }, {
	                    id: 'false',
	                    label: this.$translate.instant('NO')
	                }]
	            };
	            return _lodash2.default.defaultsDeep({}, custom, filter);
	        }
	    }, {
	        key: '_getTableSwitchFilter',
	        value: function _getTableSwitchFilter(id, values) {
	            var custom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var filter = {
	                id: id,
	                type: 'buttons',
	                url: id,
	                value: values[0].id,
	                values: values
	            };
	            return _lodash2.default.defaultsDeep({}, custom, filter);
	        }
	    }, {
	        key: '_getComplexFilter',
	        value: function _getComplexFilter(name) {
	            var filter = [];
	            switch (name) {
	                case "startAndMainChargeStart":
	                    filter = [this._getFilter('from', {
	                        id: 'start.dateTime.from',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'dateTime',
	                            label: this.$translate.instant('FILTER.CHARGES.BY_DATE'),
	                            comboId: 'start.dateTime',
	                            metaFilter: 'from',
	                            combo: [{ id: 'start.dateTime', label: this.$translate.instant('FILTER.CHARGES.CHARGE_START') }, { id: 'mainCharge.startDateTime', label: this.$translate.instant('FILTER.CHARGES.MAIN_CHARGE_START') }, { id: 'stop.dateTime', label: this.$translate.instant('END') }]
	                        }
	                    }), this._getFilter('to', {
	                        id: 'start.dateTime.to',
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'start.dateTime', metaFilter: 'to' }
	                    }), this._getFilter('from', {
	                        id: 'mainCharge.startDateTime.from',
	                        url: 'inicio_cp',
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'mainCharge.startDateTime', metaFilter: 'from' }
	                    }), this._getFilter('to', {
	                        id: 'mainCharge.startDateTime.to',
	                        url: 'fin_cp',
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'mainCharge.startDateTime', metaFilter: 'to' }
	                    }), this._getFilter('from', {
	                        id: 'stop.dateTime.from',
	                        url: true,
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'stop.dateTime', metaFilter: 'from' }
	                    }), this._getFilter('to', {
	                        id: 'stop.dateTime.to',
	                        url: true,
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'stop.dateTime', metaFilter: 'to' }
	                    })];
	                    break;
	                case "createdAtAndUpdatedAt":
	                    filter = [this._getFilter('from', {
	                        id: 'createdAt.from',
	                        url: 'creado_desde',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'dateTime',
	                            label: this.$translate.instant('FILTER.CHARGEPOINTS.BY_DATE'),
	                            comboId: 'createdAt',
	                            metaFilter: 'from',
	                            combo: [{ id: 'createdAt', label: this.$translate.instant('FILTER.CHARGEPOINTS.CREATION') }, { id: 'updatedAt', label: this.$translate.instant('FILTER.CHARGEPOINTS.LAST_TIME_UPDATED') }]
	                        }
	                    }), this._getFilter('to', {
	                        id: 'createdAt.to',
	                        url: 'creado_hasta',
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'createdAt', metaFilter: 'to' }
	                    }), this._getFilter('from', {
	                        id: 'updatedAt.from',
	                        url: 'actualizacion_desde',
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'updatedAt', metaFilter: 'from' }
	                    }), this._getFilter('to', {
	                        id: 'updatedAt.to',
	                        url: 'actualizacion_hasta',
	                        advanced: true,
	                        filterGroup: { id: 'dateTime', comboId: 'updatedAt', metaFilter: 'to' }
	                    })];
	                    break;
	                case "activeFromAndActiveTo":
	                    filter = [this._getFilter('from', {
	                        id: 'activeFrom.from',
	                        url: 'activada_desde',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'dateTime',
	                            label: this.$translate.instant('FILTER.USERKEYS.BY_DATE'),
	                            comboId: 'activeFrom',
	                            metaFilter: 'from',
	                            combo: [{ id: 'activeFrom', label: this.$translate.instant('FILTER.USERKEYS.ACTIVATION') }, { id: 'activeTo', label: this.$translate.instant('FILTER.USERKEYS.EXPIRATION') }]
	                        }
	                    }), this._getFilter('to', {
	                        id: 'activeFrom.to',
	                        url: 'activada_hasta',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'dateTime',
	                            comboId: 'activeFrom',
	                            metaFilter: 'to'
	                        }
	                    }), this._getFilter('from', {
	                        id: 'activeTo.from',
	                        url: 'caducada_desde',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'dateTime',
	                            comboId: 'activeTo',
	                            metaFilter: 'from'
	                        }
	                    }), this._getFilter('to', {
	                        id: 'activeTo.to',
	                        url: 'caducada_hasta',
	                        advanced: true,
	                        filterGroup: {
	                            id: 'dateTime',
	                            comboId: 'activeTo',
	                            metaFilter: 'to'
	                        }
	                    })];
	                    break;
	            }
	            return filter;
	        }
	    }, {
	        key: '_getTable',
	        value: function _getTable(type) {
	            var response = {};
	            switch (type) {
	                case "charges":
	                    response = {
	                        keys: ['meter | chargesMeter:item:this', 'state | chargeState:item', 'cost.totalCost | chargeCost', 'SoC | chargeSoC', 'effectiveDuration | chargesDuration:item:"mainCharge"', 'chargepointName | chargepointLink:this:undefined:item.chargepointName:item.chargepointId', 'start.customerName | chargeCustomerName', 'start.userKeyId | chargeUserkey:item:this', 'start.dateTime | chargeDate', 'stop.dateTime | chargeDate', 'mainCharge.startDateTime | chargeDate', 'mainCharge.endDateTime | chargeDate', 'duration | chargesDuration:item:"start"', 'maxPower | chargeMaxPower', 'connectorId', 'emsp | empty', 'cpo | empty', 'receiptCode'],
	                        headers: [this.$translate.instant('APP.HEADER.CHARGES.METER'), this.$translate.instant('APP.HEADER.CHARGES.STATE'), this.$translate.instant('APP.HEADER.CHARGES.COST'), this.$translate.instant('APP.HEADER.CHARGES.SOC'), this.$translate.instant('APP.HEADER.CHARGES.MAIN_CHARGE_DURATION'), this.$translate.instant('APP.HEADER.CHARGES.CHARGEPOINT'), this.$translate.instant('APP.HEADER.CHARGES.CUSTOMER'), this.$translate.instant('APP.HEADER.CHARGES.USERKEY'), this.$translate.instant('APP.HEADER.CHARGES.START'), this.$translate.instant('APP.HEADER.CHARGES.STOP'), this.$translate.instant('APP.HEADER.CHARGES.MAIN_CHARGE_START'), this.$translate.instant('APP.HEADER.CHARGES.MAIN_CHARGE_STOP'), this.$translate.instant('APP.HEADER.CHARGES.DURATION'), this.$translate.instant('APP.HEADER.CHARGES.MAX_POWER'), this.$translate.instant('APP.HEADER.CHARGES.CONNECTOR'), this.$translate.instant('EMSP'), this.$translate.instant('CPO'), this.$translate.instant('RECEIPT_CODE')],
	                        trackBy: 'id',
	                        compact: true,
	                        synchronous: false,
	                        centerColumns: ['state', 'maxPower', 'connectorId'],
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['meter', 'cost.totalCost', 'effectiveDuration', 'chargepointName', 'start.userKeyId', 'start.dateTime', 'stop.dateTime', 'mainCharge.startDateTime', 'mainCharge.endDateTime', 'duration', 'maxPower', 'receiptCode'], 'start.dateTime', 'desc', {}, function (data) {
	                            var key = 'cost.';
	                            return data.includes(key) ? data.replace(key, '') : data;
	                        })
	                    };
	                    break;
	                case "chargepoints":
	                    response = {
	                        keys: ['name | chargepointName:item', 'serialOCPP', 'organizationName | chargepointOrganization:item', 'groupName | chargepointGroup:item', 'status | chargepointOperationalStatus:item', 'ocppConnection.connected | chargepointConnected', 'connectors | chargepointStatus:item', 'ocppConnection.lastTimeSeen | toDate', 'hash', 'chargePointSerialNumber', 'chargePointVendor', 'chargePointModel', 'connectors | totalConnectors', 'connectors | getPhysicalReferenceFromConnectors', 'createdAt | toDate'],
	                        headers: [this.$translate.instant('APP.HEADER.CHARGEPOINTS.NAME'), this.$translate.instant('SERIAL_OCPP'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.ORGANIZATION'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.GROUP'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.OPERATIONAL_STATUS'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.CONNECTED'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.STATUS'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.LAST_TIME_SEEN'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.HASH'), this.$translate.instant('SERIAL_NUMBER'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.VENDOR'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.MODEL'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.CONNECTORS'), this.$translate.instant('PHYSICAL_REFERENCES'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.CREATED')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        centerColumns: ['ocppConnection.connected', 'connectors'],
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name', 'organizationName', 'serialOCPP', 'ocppConnection.connected', 'ocppConnection.lastTimeSeen', 'hash', 'chargePointVendor', 'chargePointModel', 'createdAt'], 'name', 'asc', {
	                            types: {
	                                name: 'string',
	                                organizationName: 'string',
	                                'ocppConnection.connected': 'object:connected',
	                                'ocppConnection.lastTimeSeen': 'object:lastTimeSeen',
	                                chargePointVendor: 'string',
	                                chargePointModel: 'string'
	                            }
	                        })
	                    };
	                    break;
	                case "chargepointsWithProgramedReboots":
	                    response = {
	                        keys: ['name | chargepointName:item', 'groupName | chargepointGroup:item', 'period', 'windowStart', 'windowEnd'],
	                        headers: [this.$translate.instant('APP.HEADER.CHARGEPOINTS.NAME'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.GROUP'), this.$translate.instant('APP.HEADER.PROGRAMED_REBOOT.PERIOD'), this.$translate.instant('APP.HEADER.PROGRAMED_REBOOT.FROM'), this.$translate.instant('APP.HEADER.PROGRAMED_REBOOT.TO')],
	                        trackBy: 'id',
	                        synchronous: true,
	                        compact: true,
	                        centerColumns: [],
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name', 'groupName', 'period', 'windowStart', 'windowEnd'], 'name', 'asc', {
	                            types: { name: 'string', groupName: 'string', period: 'string' }
	                        })
	                    };
	                    break;
	                case "userkeys":
	                    response = {
	                        keys: ['idToken | userkeyName:item', 'organizationId | userkeyOrganization:item', 'customerName | userkeyCustomer:item', 'chargepointName | userkeyChargepoint:item', 'blocked | userkeyActive:item', 'master | yesno', 'groups | userkeyGroups:item', 'activeFrom | userkeyActiveFrom', 'activeTo | userkeyActiveTo', 'origin | capitalize', 'type | capitalize', 'roamingInfo.roamingOrganizationName | empty'],
	                        headers: [this.$translate.instant('APP.HEADER.USERKEYS.KEY'), this.$translate.instant('APP.HEADER.USERKEYS.ORGANIZATION'), this.$translate.instant('APP.HEADER.USERKEYS.CUSTOMER'), this.$translate.instant('APP.HEADER.USERKEYS.CHARGEPOINT'), this.$translate.instant('APP.HEADER.USERKEYS.ACTIVE'), this.$translate.instant('APP.HEADER.USERKEYS.MASTER'), this.$translate.instant('APP.HEADER.USERKEYS.AUTHORIZED_GROUPS'), this.$translate.instant('APP.HEADER.USERKEYS.ACTIVE_FROM'), this.$translate.instant('APP.HEADER.USERKEYS.ACTIVE_TO'), this.$translate.instant('COMMON.ORIGIN'), this.$translate.instant('TYPE'), this.$translate.instant('ROAMING_ORGANIZATION')],
	                        trackBy: 'userKeyId',
	                        synchronous: false,
	                        compact: true,
	                        centerColumns: ['blocked', 'master'],
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['idToken', 'organizationId', 'customerName', 'chargepointName', 'blocked', 'master', 'activeFrom', 'activeTo'], 'activeTo', 'desc', {
	                            types: { idToken: 'string', customerName: 'string' }
	                        })
	                    };
	                    break;
	                case "validUserkeys":
	                    response = {
	                        keys: ['idToken | userkeyName:item', 'customerName | userkeyCustomer:item', 'blocked | userkeyActive:item', 'master | yesno', 'groups | userkeyGroups:item', 'activeFrom | userkeyActiveFrom', 'activeTo | userkeyActiveTo', 'groupLevel | userkeyGroupRoleId:item'],
	                        headers: [this.$translate.instant('APP.HEADER.VALID_USERKEYS.KEY'), this.$translate.instant('APP.HEADER.USERKEYS.CUSTOMER'), this.$translate.instant('APP.HEADER.VALID_USERKEYS.ACTIVE'), this.$translate.instant('APP.HEADER.VALID_USERKEYS.MASTER'), this.$translate.instant('APP.HEADER.VALID_USERKEYS.AUTHORIZED_GROUPS'), this.$translate.instant('APP.HEADER.VALID_USERKEYS.ACTIVE_FROM'), this.$translate.instant('APP.HEADER.VALID_USERKEYS.ACTIVE_TO'), this.$translate.instant('APP.HEADER.VALID_USERKEYS.LEVEL')],
	                        hints: {
	                            "groups": this.$translate.instant('APP.HEADER.VALID_USERKEYS.AUTHORIZED_GROUPS_HINT'),
	                            id: this.$translate.instant('APP.HEADER.VALID_USERKEYS.LEVEL_HINT_A') + '\n' + this.$translate.instant('APP.HEADER.VALID_USERKEYS.LEVEL_HINT_B')
	                        },
	                        trackBy: 'idToken',
	                        synchronous: false,
	                        compact: true,
	                        centerColumns: ['blocked', 'master'],
	                        pagination: this.getPagination(10),
	                        sortingAuxKey: '',
	                        sorting: this.getSorting(['idToken', 'blocked', 'master', 'activeFrom', 'activeTo'], 'idToken', 'asc', {
	                            types: { "idToken": 'string' }
	                        })
	                    };
	                    break;
	                case "customers":
	                    response = {
	                        keys: ['name | customerName:item', 'nif', 'userId | customerEmail:item', 'personType | personType:item', 'address | customerCity:item', 'organizationId | customerOrganization:item'],
	                        headers: [this.$translate.instant('APP.HEADER.CUSTOMERS.NAME'), this.$translate.instant('IDENTIFIER_NUMBER'), this.$translate.instant('APP.HEADER.CUSTOMERS.EMAIL'), this.$translate.instant('APP.HEADER.CUSTOMERS.PERSONTYPE'), this.$translate.instant('APP.HEADER.CUSTOMERS.CITY'), this.$translate.instant('APP.HEADER.CUSTOMERS.ORGANIZATION')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name', 'nif', 'userId', 'personType', 'organizationId'], 'name', 'asc', {
	                            types: {
	                                name: 'string',
	                                nif: 'string',
	                                userId: 'string',
	                                personType: 'string',
	                                organizationId: 'string'
	                            }
	                        })
	                    };
	                    break;
	                case "roles":
	                    response = {
	                        keys: ['displayName | safe', 'username', 'role | role', 'entity | roleEntity', 'id | roleId:item:this'],
	                        headers: [this.$translate.instant('APP.HEADER.ROLES.NAME'), this.$translate.instant('APP.HEADER.ROLES.EMAIL'), this.$translate.instant('APP.HEADER.ROLES.ROLE'), this.$translate.instant('APP.HEADER.ROLES.ENTITY'), this.$translate.instant('APP.HEADER.ROLES.AT')],
	                        trackBy: 'username',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['displayName', 'username', 'role', 'entity', 'id'], 'displayName', 'asc', {
	                            types: { username: 'string', role: 'string', entity: 'string', id: 'string' }
	                        })
	                    };
	                    break;
	                case "organizations":
	                    response = {
	                        keys: ['id', 'name'],
	                        headers: [this.$translate.instant('APP.HEADER.ORGANIZATIONS.ID'), this.$translate.instant('APP.HEADER.ORGANIZATIONS.NAME')],
	                        trackBy: 'id',
	                        synchronous: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['id', 'name'], 'id', 'asc', {
	                            types: { id: 'string', name: 'string' }
	                        })
	                    };
	                    break;
	                case "permissions":
	                    response = {
	                        keys: ['role | role', 'entity | roleEntity', 'id | roleId:item'],
	                        headers: [this.$translate.instant('APP.HEADER.PERMISSIONS.ROLE'), this.$translate.instant('APP.HEADER.PERMISSIONS.ENTITY'), this.$translate.instant('APP.HEADER.PERMISSIONS.AT')],
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['role', 'entity', 'id'], 'role', 'asc', {
	                            types: { role: 'string', entity: 'string', id: 'string' }
	                        })
	                    };
	                    break;
	                case "banners":
	                    response = {
	                        keys: ['type | capitalize', 'title | getByLang', 'fromDate | toDate', 'toDate | toDate', 'dismiss | boolean'],
	                        headers: [this.$translate.instant('APP.HEADER.BANNERS.TYPE'), this.$translate.instant('APP.HEADER.BANNERS.TITLE'), this.$translate.instant('APP.HEADER.BANNERS.FROM'), this.$translate.instant('APP.HEADER.BANNERS.TO'), this.$translate.instant('APP.HEADER.BANNERS.DISMISS')],
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['type', 'title', 'fromDate', 'toDate', 'dismiss'], 'type', 'asc')
	                    };
	                    break;
	                case "programedReboots":
	                    response = {
	                        keys: ['period', 'windowStart', 'windowEnd'],
	                        headers: [this.$translate.instant('APP.HEADER.PROGRAMED_REBOOT.PERIOD'), this.$translate.instant('APP.HEADER.PROGRAMED_REBOOT.FROM'), this.$translate.instant('APP.HEADER.PROGRAMED_REBOOT.TO')],
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['period', 'windowStart', 'windowEnd'], 'type', 'desc')
	                    };
	                    break;
	                case "ocppMessages":
	                    response = {
	                        keys: ['timestamp | toDate:"dateTime":false', 'input | ocppMessageInput', 'source', 'json'],
	                        headers: [this.$translate.instant('APP.HEADER.OCPPMESSAGES.TIMESTAMP'), this.$translate.instant('APP.HEADER.OCPPMESSAGES.INPUT'), this.$translate.instant('APP.HEADER.OCPPMESSAGES.TYPE'), this.$translate.instant('APP.HEADER.OCPPMESSAGES.MESSAGE')],
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['timestamp', 'input', 'source', 'json'], 'timestamp', 'desc')
	                    };
	                    break;
	                case "diagnostics":
	                    response = {
	                        keys: ['createdAt | toDate', 'filename', 'size'],
	                        headers: [this.$translate.instant('APP.HEADER.DIAGNOSTICS.CREATED'), this.$translate.instant('APP.HEADER.DIAGNOSTICS.FILENAME'), this.$translate.instant('APP.HEADER.DIAGNOSTICS.SIZE')],
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['createdAt', 'filename', 'size'], 'createdAt', 'desc')
	                    };
	                    break;
	                case "payments":
	                    response = {
	                        keys: ['id', 'amount', 'operationType', 'status', 'timestamp | toDate', 'responseMessage'],
	                        headers: [this.$translate.instant('APP.HEADER.PAYMENTS.ID'), this.$translate.instant('APP.HEADER.PAYMENTS.AMOUNT'), this.$translate.instant('APP.HEADER.PAYMENTS.TYPE'), this.$translate.instant('APP.HEADER.PAYMENTS.STATUS'), this.$translate.instant('APP.HEADER.PAYMENTS.TIMESTAMP'), this.$translate.instant('APP.HEADER.PAYMENTS.RESPONSE_MESSAGE')],
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['id'], 'id', 'desc')
	                    };
	                    break;
	                case "connectors":
	                    response = {
	                        keys: ['id', 'label', 'type', 'mode', 'power', 'current', 'voltage'],
	                        headers: [this.$translate.instant('APP.HEADER.CONNECTORS.ID'), this.$translate.instant('APP.HEADER.CONNECTORS.LABEL'), this.$translate.instant('APP.HEADER.CONNECTORS.TYPE'), this.$translate.instant('APP.HEADER.CONNECTORS.MODE'), this.$translate.instant('APP.HEADER.CONNECTORS.POWER'), this.$translate.instant('APP.HEADER.CONNECTORS.CURRENT'), this.$translate.instant('APP.HEADER.CONNECTORS.VOLTAGE')],
	                        trackBy: 'id',
	                        synchronous: true,
	                        compact: true,
	                        centerColumns: [],
	                        hideItemsPerPageSelector: true,
	                        pagination: false
	                    };
	                    break;
	                case "ocppSearch":
	                    response = {
	                        keys: ['serialOCPP | chargepointLink:name:organizationId:undefined:id', 'name', 'organizationName', 'groupName'],
	                        headers: [this.$translate.instant('DASHBOARD.SEARCH_CHARGEPOINT.OCPP'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.NAME'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.ORGANIZATION'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.GROUP')],
	                        trackBy: 'id',
	                        synchronous: true,
	                        compact: true,
	                        centerColumns: [],
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name', 'organizationName', 'groupName'], 'name', 'asc', {
	                            types: { name: 'string', organizationName: 'string', groupName: 'string' }
	                        })
	                    };
	                    break;
	                case "chargepointSearch":
	                    response = {
	                        keys: ['name', 'organizationName', 'groupName'],
	                        headers: [this.$translate.instant('APP.HEADER.CHARGEPOINTS.NAME'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.ORGANIZATION'), this.$translate.instant('APP.HEADER.CHARGEPOINTS.GROUP')],
	                        trackBy: 'id',
	                        selected: [],
	                        selectable: 'multi',
	                        synchronous: true,
	                        compact: true,
	                        centerColumns: [],
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name', 'organizationName', 'groupName'], 'name', 'asc', {
	                            types: { name: 'string', organizationName: 'string', groupName: 'string' },
	                            multiple: { groupName: ['groupId'] }
	                        })
	                    };
	                    break;
	                case "rechargingSchedule":
	                    response = {
	                        keys: ['startDayOfWeek | toDay', 'startTime', 'endDayOfWeek | toDay', 'endTime', 'unit', 'limit'],
	                        headers: [this.$translate.instant('START'), this.$translate.instant('START_TIME'), this.$translate.instant('END'), this.$translate.instant('END_TIME'), this.$translate.instant('UNIT'), this.$translate.instant('LIMIT')],
	                        trackBy: 'startDayOfWeek',
	                        synchronous: true,
	                        compact: true,
	                        centerColumns: [],
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['startDayOfWeek', 'startTime', 'endDayOfWeek', 'endTime', 'unit', 'limit'], 'startDayOfWeek', 'asc', {
	                            types: { startDayOfWeek: 'string' }
	                        })
	                    };
	                    break;
	                case "proxies":
	                    response = {
	                        keys: ['name', 'url'],
	                        headers: [this.$translate.instant('NAME'), this.$translate.instant('URL')],
	                        synchronous: true,
	                        compact: true,
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['name'], 'name', 'asc')
	                    };
	                    break;
	                case "holidays":
	                    response = {
	                        keys: ['country | countryCodeToName', 'date | date:"dd/MM/yyyy"', 'description'],
	                        headers: [this.$translate.instant('COUNTRY'), this.$translate.instant('DATE'), this.$translate.instant('DESCRIPTION')],
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['country'], 'country', 'asc')
	                    };
	                    break;
	                case "maintainers":
	                    response = {
	                        keys: ['companyName', 'name', 'contractNumber', 'timetable', 'phone', 'email'],
	                        headers: [this.$translate.instant('COMPANY'), this.$translate.instant('NAME'), this.$translate.instant('CONTRACT_NUMBER'), this.$translate.instant('TIMETABLE'), this.$translate.instant('PHONE'), this.$translate.instant('EMAIL')],
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['companyName'], 'companyName', 'asc')
	                    };
	                    break;
	                case "consents":
	                    response = {
	                        keys: ['id', 'title | getByLang', 'mandatory', 'url'],
	                        headers: [this.$translate.instant('ID'), this.$translate.instant('TITLE'), this.$translate.instant('MANDATORY'), this.$translate.instant('URL')],
	                        synchronous: true,
	                        compact: true,
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['id'], 'id', 'asc')
	                    };
	                    break;
	                case "customerConsents":
	                    response = {
	                        keys: ['id', 'title | getByLang', 'mandatory', 'accepted'],
	                        headers: [this.$translate.instant('ID'), this.$translate.instant('TITLE'), this.$translate.instant('MANDATORY'), this.$translate.instant('ACCEPTED')],
	                        synchronous: true,
	                        compact: true,
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['id'], 'id', 'asc')
	                    };
	                    break;
	                case "owners":
	                    response = {
	                        keys: ['name', 'identifierNumber', 'ownerCode', 'email', 'phone', 'address | addressDisplay', 'organizationName | organizationLink:organizationId'],
	                        headers: [this.$translate.instant('NAME'), this.$translate.instant('IDENTIFIER_NUMBER'), this.$translate.instant('OWNER_CODE'), this.$translate.instant('EMAIL'), this.$translate.instant('PHONE'), this.$translate.instant('ADDRESS'), this.$translate.instant('CH.ORGANIZATION')],
	                        synchronous: true,
	                        compact: true,
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(20),
	                        sorting: this.getSorting(['name'], 'name', 'asc')
	                    };
	                    break;
	                case "disconnectedChargepoints":
	                    response = {
	                        keys: ['name | chargepointName:item', 'organizationName | chargepointOrganization:item', 'groupName | chargepointGroup:item', 'ocppConnection.lastTimeSeen | toDate'],
	                        headers: [this.$translate.instant('DASHBOARD.ALARMS.DISCONNECTED_CHS.CHARGEPOINT'), this.$translate.instant('DASHBOARD.ALARMS.DISCONNECTED_CHS.ORGANIZATION'), this.$translate.instant('DASHBOARD.ALARMS.DISCONNECTED_CHS.GROUP'), this.$translate.instant('DASHBOARD.ALARMS.DISCONNECTED_CHS.LAST_TIME_SEEN')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        zeroResults: this.$translate.instant('DASHBOARD.ALARMS.DISCONNECTED_CHS.ZERO_RESULTS'),
	                        centerColumns: ['ocppConnection.connected'],
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name', 'organizationName', 'groupName', 'ocppConnection.lastTimeSeen'], 'ocppConnection.lastTimeSeen', 'desc', {
	                            types: { name: 'string', organizationName: 'string', groupName: 'string' }
	                        })
	                    };
	                    break;
	                case "unavailableChargepoints":
	                    response = {
	                        keys: ['name | chargepointName:item', 'organizationName | chargepointOrganization:item', 'groupName | chargepointGroup:item', 'ocppConnection.lastTimeSeen | toDate'],
	                        headers: [this.$translate.instant('DASHBOARD.ALARMS.UNAVAILABLE_CHS.CHARGEPOINT'), this.$translate.instant('DASHBOARD.ALARMS.UNAVAILABLE_CHS.ORGANIZATION'), this.$translate.instant('DASHBOARD.ALARMS.UNAVAILABLE_CHS.GROUP'), this.$translate.instant('DASHBOARD.ALARMS.UNAVAILABLE_CHS.LAST_TIME_SEEN')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        zeroResults: this.$translate.instant('DASHBOARD.ALARMS.UNAVAILABLE_CHS.ZERO_RESULTS'),
	                        centerColumns: ['connectors'],
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(10, 4),
	                        sorting: this.getSorting(['name', 'organizationName', 'groupName', 'ocppConnection.lastTimeSeen'], 'ocppConnection.lastTimeSeen', 'desc', {
	                            types: { name: 'string', organizationName: 'string', groupName: 'string' }
	                        })
	                    };
	                    break;
	                case "lastCharges":
	                    response = {
	                        keys: ['meter | chargesMeter:item:this', 'state | chargeState:item', 'cost.totalCost | chargeCost', 'effectiveDuration | chargesDuration:item:"mainCharge"', 'chargepointId | chargepointLink:this:undefined:item.chargepointName', 'start.dateTime | chargeDate'],
	                        headers: [this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.CHARGE'), this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.STATUS'), this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.COST'), this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.EFFECTIVE_DURATION'), this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.CHARGEPOINT'), this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.START_DATE')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        zeroResults: this.$translate.instant('DASHBOARD.CHARGES.LAST_CHARGES.ZERO_RESULTS'),
	                        centerColumns: ['meter', 'effectiveDuration'],
	                        hideItemsPerPageSelector: true,
	                        pagination: this.getPagination(5, 4),
	                        sorting: this.getSorting(['start.dateTime', 'chargepointId', 'effectiveDuration', 'meter', 'cost.totalCost'], 'start.dateTime', 'desc')
	                    };
	                    break;
	                case "tariffs":
	                    response = {
	                        keys: ['name | extractText', 'description | extractText', 'scope', 'roamingAgreementName', 'locations | tariffLocationNameLink:item', 'users | tariffArea', 'connectorTypes | connectorTypesDisplay', 'maxPower | powerRangeWToKw:item', 'startDateTime | toDate', 'endDateTime | toDate'],
	                        headers: [this.$translate.instant('NAME'), this.$translate.instant('DESCRIPTION'), this.$translate.instant('TYPE'), this.$translate.instant('AGREEMENT'), this.$translate.instant('ZONE'), this.$translate.instant('APP.HEADER.TARIFFS.AREA'), this.$translate.instant('APPLIES_TO_CONNECTORS'), this.$translate.instant('POWER_RANGE'), this.$translate.instant('START_DATE_TIME'), this.$translate.instant('END_DATE_TIME')],
	                        trackBy: 'name',
	                        synchronous: false,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name'], 'name', 'asc', {
	                            types: { name: 'string' }
	                        })
	                    };
	                    break;
	                case "chargePointsAssignedToTariff":
	                    response = {
	                        keys: ['name | chargepointName:item', 'serialOcpp', 'location.name', 'evses | evsesToConnectorsList'],
	                        headers: [this.$translate.instant('NAME'), this.$translate.instant('SERIAL_OCPP'), this.$translate.instant('LOCATION_NAME'), this.$translate.instant('APPLIES_TO_CONNECTORS')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name'], 'name', 'asc', {
	                            types: {
	                                name: 'string'
	                            }
	                        })
	                    };
	                    break;
	                case "connectorTariffs":
	                    response = {
	                        keys: ['connectorId', 'name | connectorTariffNameToLink:item', 'type'],
	                        headers: [this.$translate.instant('CONNECTOR_ID'), this.$translate.instant('NAME'), this.$translate.instant('TYPE')],
	                        trackBy: 'name',
	                        synchronous: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['connectorId'], 'connectorId', 'asc', {
	                            types: { connectorId: 'string' }
	                        })
	                    };
	                    break;
	                case "restrictions":
	                    response = {
	                        keys: ['description | restrictionDescription:item'],
	                        headers: [this.$translate.instant('DESCRIPTION')],
	                        trackBy: 'description',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['description'], 'description', 'asc', {
	                            types: { description: 'string' }
	                        })
	                    };
	                    break;
	                case "agreements":
	                    response = {
	                        keys: ['code', 'organizationName', 'countryCode | agreementId:item', 'role | uppercase', 'startsAt', 'protocol | agreementProtocol:item', 'scope', 'active | boolean', 'totalChargePoints'],
	                        headers: [this.$translate.instant('CODE'), this.$translate.instant('THIRD_PARTY_ORGANIZATION'), this.$translate.instant('ID'), this.$translate.instant('ROLE'), this.$translate.instant('DATE_OF_REGISTRATION'), this.$translate.instant('PROTOCOL'), this.$translate.instant('SCOPE'), this.$translate.instant('ACTIVE'), this.$translate.instant('TOTAL_CHARGE_POINTS')],
	                        trackBy: 'code',
	                        synchronous: true,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['code'], 'code', 'asc', {
	                            types: { code: 'number' }
	                        })
	                    };
	                    break;
	                case "operations":
	                    response = {
	                        keys: ['name', 'agreements | agreementsToNameList', 'locations | length'],
	                        headers: [this.$translate.instant('OPERATION_ID'), this.$translate.instant('AGREEMENTS'), this.$translate.instant('LOCATIONS')],
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['id'], 'id', 'asc', {
	                            types: { id: 'string' }
	                        })
	                    };
	                    break;
	                case "locations":
	                    response = {
	                        keys: ['name | locationNameLink:item', 'location | locationCountry', 'totalChargepoints'],
	                        headers: [this.$translate.instant('NAME'), this.$translate.instant('COUNTRY'), this.$translate.instant('TOTAL_CHARGE_POINTS')],
	                        trackBy: 'name',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['name'], 'name', 'asc', {
	                            types: { name: 'string' }
	                        })
	                    };
	                    break;
	                case "margins":
	                    response = {
	                        keys: ['name', 'organizationId', 'locationName | marginLocationNameLink:item', 'percentage', 'flat | calculatePriceWithVat:item.vat', 'vat'],
	                        headers: [this.$translate.instant('NAME'), this.$translate.instant('BREADCRUMS_TITLE.ORGANIZATION'), this.$translate.instant('LOCATION'), this.$translate.instant('PERCENTAGE'), this.$translate.instant('FLAT'), this.$translate.instant('TAXES')],
	                        hints: {
	                            flat: this.$translate.instant('PRICE_WITH_TAXES')
	                        },
	                        trackBy: 'id',
	                        synchronous: false,
	                        compact: true,
	                        pagination: this.getPagination(10),
	                        sorting: this.getSorting(['id'], 'id', 'asc', {
	                            types: { id: 'string' }
	                        })
	                    };
	                    break;
	            }
	            return response;
	        }
	    }, {
	        key: '_setQueryFilters',
	        value: function _setQueryFilters(filters) {
	            var _this7 = this;

	            return _lodash2.default.each(filters, function (filter) {
	                if (filter.url && angular.isDefined(_this7.$stateParams[filter.url])) {
	                    var value = _this7.$stateParams[filter.url];
	                    if (filter.type === 'date' && filter.filterGroup) {
	                        filter.filterGroup.currentComboId = filter.filterGroup.comboId;
	                        value = _this7.moment(value).toDate();
	                    }
	                    filter.value = value;
	                    if (filter.id === 'group') {
	                        filter.valueName = value;
	                    }
	                }
	                if (filter.url && filter.combo && filter.combo.length > 0) {
	                    var scope = _lodash2.default.find(filter.combo, function (combo) {
	                        return angular.isDefined(_this7.$stateParams[combo.url]);
	                    });
	                    if (scope) {
	                        filter.value = _this7.$stateParams[scope.url];
	                        filter.scope = scope;
	                        filter.url = scope.url;
	                    }
	                }
	                if (filter.url && angular.isObject(filter.url) && filter.type === 'range') {
	                    var min = _this7.$stateParams[filter.url.min];
	                    var max = _this7.$stateParams[filter.url.max];
	                    if (angular.isDefined(filter.filterGroup.comboId) && (angular.isDefined(min) || angular.isDefined(max))) {
	                        filter.filterGroup.currentComboId = filter.filterGroup.comboId;
	                    }
	                    if (angular.isDefined(min)) {
	                        filter.value.min = min;
	                    }
	                    if (angular.isDefined(max)) {
	                        filter.value.max = max;
	                    }
	                }
	                if (filter.url && filter.type === 'select-search') {
	                    var _value = _this7.$stateParams[filter.url];
	                    if (_value) {
	                        var decoded = JSON.parse(decodeURIComponent(_value));
	                        filter.value = decoded;
	                        filter.values = [decoded];
	                    }
	                }
	                return filter;
	            });
	        }
	    }, {
	        key: '_omitFromTable',
	        value: function _omitFromTable(table, omit) {
	            var _this8 = this;

	            if (!table || !_lodash2.default.isArray(omit)) return;
	            var removeIndexes = [];
	            _lodash2.default.each(table.keys, function (key, idx) {
	                if (omit.indexOf(_this8.onlyKey(key)) >= 0) {
	                    removeIndexes.push(idx);
	                }
	            });
	            _lodash2.default.pullAt(table.keys, removeIndexes);
	            _lodash2.default.pullAt(table.headers, removeIndexes);
	        }
	    }, {
	        key: '_modifyFromTable',
	        value: function _modifyFromTable(table, toModify) {
	            if (!_lodash2.default.isObject(table) || !_lodash2.default.isObject(toModify)) return;
	            _lodash2.default.merge(table, toModify);
	        }

	        //TODO: improve it

	    }, {
	        key: '_omitFilters',
	        value: function _omitFilters(filters, toOmit) {
	            if (!_lodash2.default.isArray(filters) || !_lodash2.default.isArray(toOmit)) return;
	            _lodash2.default.each(toOmit, function (toOmit) {
	                for (var i = 0; i < filters.length; i++) {
	                    if (filters[i].id === toOmit) {
	                        filters.splice(i, 1);
	                        break;
	                    }
	                    if (_lodash2.default.isArray(filters[i].combo)) {
	                        for (var j = 0; j < filters[i].combo.length; j++) {
	                            if (filters[i].combo[j].id === toOmit) {
	                                filters[i].combo.splice(j, 1);
	                                break;
	                            }
	                        }
	                    }
	                    if (_lodash2.default.isArray(filters[i].values)) {
	                        for (var k = 0; k < filters[i].values.length; k++) {
	                            if (filters[i].values[k].id === toOmit) {
	                                filters[i].values.splice(k, 1);
	                                break;
	                            }
	                        }
	                    }
	                }
	            });
	            return filters;
	        }
	    }, {
	        key: '_modifyFilters',
	        value: function _modifyFilters(filters, toModify) {
	            if (!_lodash2.default.isArray(filters) || !_lodash2.default.isObject(toModify)) return;
	            _lodash2.default.each(toModify, function (value, key) {
	                var filter = _lodash2.default.find(filters, function (filter) {
	                    return filter.id === key;
	                });
	                if (filter) {
	                    _lodash2.default.merge(filter, value);
	                }
	            });
	        }
	    }]);

	    return AppService;
	}();

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CacheService = undefined;

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CacheService = exports.CacheService = ["$rootScope", function CacheService($rootScope) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, CacheService);

	    var Cache = this;
	    this.$rootScope = $rootScope;
	    $rootScope.Cache = Cache;
	    this.listeners = {};

	    this._store = function (data, options) {
	        if (!data || !options || !options.as) return;
	        if (!Cache[options.as] || options.flush) Cache[options.as] = {};
	        if (!_lodash2.default.isArray(data)) data = [data];
	        for (var i in data) {
	            if (angular.isDefined(data[i][options.trackBy])) {
	                Cache[options.as][data[i][options.trackBy]] = data[i];
	                if (_this.listeners[options.as] && _this.listeners[options.as][data[i][options.trackBy]]) {
	                    _this.listeners[options.as][data[i][options.trackBy]](data[i]);
	                    _this.listeners[options.as][data[i][options.trackBy]] = null;
	                }
	            }
	        }
	    };

	    this._subscribeOnce = function (as, id, cb) {
	        if (!id && cb) return cb(null);
	        if (_this.listeners[as] && _this.listeners[as][id]) _this.listeners[as][id] = null;
	        if (Cache[as] && Cache[as][id]) return cb(Cache[as][id]);
	        if (!_this.listeners[as]) _this.listeners[as] = {};
	        _this.listeners[as][id] = cb;
	    };
	}];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UtilsService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UtilsService = exports.UtilsService = function () {
	    UtilsService.$inject = ["$http", "ENV", "moment"];
	    function UtilsService($http, ENV, moment) {
	        'ngInject';

	        _classCallCheck(this, UtilsService);

	        this.$http = $http;
	        this.ENV = ENV;
	        this.moment = moment;
	    }

	    _createClass(UtilsService, [{
	        key: 'getVersion',
	        value: function getVersion() {
	            return this.$http.get(this.ENV.URL + '/version', {});
	        }
	    }, {
	        key: 'getSummary',
	        value: function getSummary(options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            var group = _lodash2.default.get(options, 'group', null);
	            return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + (group ? '/groups/' + group : '') + '/summary', {}).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getOrganizationQuery',
	        value: function getOrganizationQuery(organization) {
	            return organization ? '/organizations/' + organization : '';
	        }
	    }, {
	        key: 'getGroupQuery',
	        value: function getGroupQuery(group) {
	            return group ? '/groups/' + group : '';
	        }
	    }, {
	        key: 'getActiveFilters',
	        value: function getActiveFilters(options) {
	            var activeFilters = {};

	            if (!options || !options.filters) return activeFilters;

	            for (var i in options.filters) {
	                var filter = options.filters[i];
	                if (filter.value) {
	                    if (filter.type === 'buttons' && filter.id && angular.isDefined(filter.value)) {
	                        activeFilters[filter.id] = filter.value;
	                    }
	                    if (filter.type === 'select' && filter.id !== 'group' && filter.value != 'all') {
	                        activeFilters[filter.id] = filter.value;
	                    }
	                    if (filter.type === 'text' && filter.value.length > 0) {
	                        if (filter.scope && filter.scope.asPair) {
	                            activeFilters[filter.scope.asPair.key] = filter.combo && filter.scope ? filter.scope.id : filter.id;
	                            activeFilters[filter.scope.asPair.value] = encodeURI(filter.value);
	                        } else {
	                            activeFilters[filter.combo && filter.scope ? filter.scope.id : filter.id] = encodeURI(filter.value);
	                        }
	                    }
	                    if (filter.type === 'date' && _lodash2.default.isDate(filter.value)) {
	                        var mo = this.moment(filter.value);
	                        if (filter.startOfDay) mo.startOf('day');
	                        if (filter.endOfDay) mo.endOf('day');
	                        if (filter.startOfNextDay) mo.add(1, 'days').startOf('day'); // a bit awful
	                        activeFilters[filter.id] = mo.format();
	                    }
	                    if (filter.type === 'geo' && filter.value.locationName && filter.value.locationName.length > 0) {
	                        activeFilters[filter.id] = filter.value.location.latitude + ',' + filter.value.location.longitude + ',' + filter.value.radius;
	                    }
	                    if (filter.type === 'range') {
	                        if (filter.value.min > filter.options.floor) activeFilters[filter.as['min']] = filter.format ? filter.format(filter.value.min) : filter.value.min;
	                        if (filter.value.max < filter.options.ceil) activeFilters[filter.as['max']] = filter.format ? filter.format(filter.value.max) : filter.value.max;
	                    }
	                    if (filter.id === 'search') {
	                        activeFilters[filter.scope.id] = filter.value;
	                    }
	                    if (filter.type === 'number') {
	                        activeFilters[filter.id] = filter.value;
	                    }
	                    if (filter.type === 'multi-select') {
	                        if (filter.value && filter.value.length > 0) {
	                            activeFilters[filter.id] = filter.value.join(',');
	                        }
	                    }
	                    if (filter.type === 'select-search') {
	                        if (filter.value) {
	                            activeFilters[filter.id] = filter.value[filter.queryParam];
	                        }
	                    }
	                }
	            }
	            return activeFilters;
	        }
	    }, {
	        key: 'setParams',
	        value: function setParams() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	            var apiV1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	            if (options.filters) {
	                options.params = Object.assign(options.params || {}, this.getActiveFilters(options));
	            }
	            if (options.sorting) {
	                var key = options.sorting.transform(options.sorting.key);
	                options.params = Object.assign(options.params || {}, { orderby: key + ',' + options.sorting.order });
	            }

	            if (options.params && options.params.output === 'csv') {
	                options['responseType'] = 'blob';
	            }

	            if (isPaginated && options.pagination) {
	                var _options$pagination = options.pagination,
	                    itemsPerPage = _options$pagination.itemsPerPage,
	                    currentPage = _options$pagination.currentPage;

	                var paginationParams = apiV1 ? { limit: itemsPerPage, offset: (currentPage - 1) * itemsPerPage } : { items: itemsPerPage, page: currentPage };
	                options.params = Object.assign(options.params || {}, paginationParams);
	            }

	            return options;
	        }
	    }, {
	        key: 'parsePaginationResponse',
	        value: function parsePaginationResponse(response, itemsPerPage) {
	            var res = {
	                docs: [],
	                currentPage: 0,
	                totalItems: 0
	            };
	            var contentRange = response.headers('Content-Range').split(' ')[1];
	            if (contentRange) {
	                var startRange = parseInt(contentRange.split('/')[0].split('-')[0]);
	                var totalItems = parseInt(contentRange.split('/')[1]);
	                res = {
	                    docs: response.data,
	                    currentPage: totalItems === 0 ? 1 : startRange / itemsPerPage + 1,
	                    totalItems: totalItems
	                };
	            }
	            return res;
	        }
	    }, {
	        key: 'parsePaginationResponseForV1',
	        value: function parsePaginationResponseForV1(response, itemsPerPage) {
	            var startRange = response.data.offset;
	            var totalItems = response.data.total;
	            return {
	                docs: response.data.items,
	                currentPage: totalItems === 0 ? 1 : startRange / itemsPerPage + 1,
	                totalItems: totalItems
	            };
	        }
	    }, {
	        key: 'parseExportCsvResponse',
	        value: function parseExportCsvResponse(response) {
	            var res = {
	                docs: response.data,
	                emailExport: false
	            };
	            var emailExport = response.headers('content-type').split(';')[0] === 'application/json';
	            if (emailExport) {
	                res.emailExport = emailExport;
	            }
	            return res;
	        }
	    }, {
	        key: 'validateEmailOrDomain',
	        value: function validateEmailOrDomain(item) {
	            return !this.validateEmailComplete(item) && !this.validateEmailDomain(item);
	        }
	    }, {
	        key: 'validateEmailDomain',
	        value: function validateEmailDomain(item) {
	            var regexExp = /^@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	            return regexExp.test(item);
	        }
	    }, {
	        key: 'validateEmailComplete',
	        value: function validateEmailComplete(item) {
	            var regexExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	            return regexExp.test(item);
	        }
	    }, {
	        key: 'validateStringBetween',
	        value: function validateStringBetween(data, min, max) {
	            return data && data.length >= min && data.length <= max;
	        }
	    }, {
	        key: 'getObjectDifferences',
	        value: function getObjectDifferences(base, update) {
	            var differences = {};
	            for (var key in update) {
	                if (update[key] !== base[key]) {
	                    differences[key] = update[key] === '' ? null : update[key];
	                }
	            }
	            return differences;
	        }
	    }, {
	        key: 'calculatePriceWithVat',
	        value: function calculatePriceWithVat(price, vat) {
	            var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e7;

	            if (price && vat && !isNaN(vat)) {
	                return Math.round(price * (1 + vat / 100) * precision) / precision;
	            }
	            return price;
	        }
	    }, {
	        key: 'calculatePriceWithoutVat',
	        value: function calculatePriceWithoutVat(price, vat) {
	            var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e7;

	            if (price && vat && !isNaN(vat)) {
	                return Math.round(price / (1 + vat / 100) * precision) / precision;
	            }
	            return price;
	        }
	    }]);

	    return UtilsService;
	}();

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationsService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsService = exports.OrganizationsService = function () {
	  OrganizationsService.$inject = ["$http", "ENV", "Cache", "$rootScope", "LocalStorage", "Utils", "RequestService"];
	  function OrganizationsService($http, ENV, Cache, $rootScope, LocalStorage, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, OrganizationsService);

	    this.$http = $http;
	    this.ENV = ENV;
	    this.Cache = Cache;
	    this.$rootScope = $rootScope;
	    this.LocalStorage = LocalStorage;
	    this.Utils = Utils;
	    this.RequestService = RequestService;
	    this._initializeNotifications();
	  }

	  _createClass(OrganizationsService, [{
	    key: 'getOrganizations',
	    value: function getOrganizations() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      options = this.Utils.setParams(options);
	      return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations', options).then(function (res) {
	        _this.Cache._store(res.data, { store: _this.Cache, as: 'organization', trackBy: 'id', flush: true });
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getOrganization',
	    value: function getOrganization(id) {
	      var _this2 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id, options).then(function (res) {
	        _this2.Cache._store(res.data, { store: _this2.Cache, as: 'organization', trackBy: 'id' });
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getOrganizationPrivate',
	    value: function getOrganizationPrivate(id) {
	      var _this3 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	      options = this.Utils.setParams(options, isPaginated);
	      var notifications = this.RequestService.getNotifications(options, this._notifications["getOrganizationPrivate"]);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/admin';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this3.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'addOrganization',
	    value: function addOrganization(id, data) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id, data, options).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'editOrganization',
	    value: function editOrganization(id, changed) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      return this.$http.put(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id, changed, options).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'editOrganizationAsProvider',
	    value: function editOrganizationAsProvider(id, changed) {
	      var _this4 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications["editOrganizationAsProvider"]);
	      var data = changed;
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/admin/providerprotectedsettings';
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this4.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeOrganization',
	    value: function removeOrganization(id) {
	      var _this5 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      return this.$http.delete(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id, options).then(function (res) {
	        return res.data;
	      }).then(function () {
	        if (id === _this5.$rootScope.providerOrganization) {
	          _this5.$rootScope.providerOrganization = undefined;
	          _this5.LocalStorage.deleteProviderOrganization();
	        }
	      });
	    }
	  }, {
	    key: 'addOrganizationRole',
	    value: function addOrganizationRole(id, role) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/admin/roles', role, options).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'removeOrganizationRole',
	    value: function removeOrganizationRole(id, username, options) {
	      return this.addOrganizationRole(id, { username: username, role: null }, options);
	    }
	  }, {
	    key: 'editAppMessages',
	    value: function editAppMessages(id, changed) {
	      return this.editOrganization(id, changed);
	    }
	  }, {
	    key: 'unblockOrganizationUser',
	    value: function unblockOrganizationUser(id, username) {
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/users/' + username + '/unblock', options).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getPayments',
	    value: function getPayments(id) {
	      var _this6 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications["getPayments"]);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/admin/payments';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this6.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'editPayments',
	    value: function editPayments(id, data) {
	      var _this7 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications["editPayments"]);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/admin/payments';
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this7.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'getConsents',
	    value: function getConsents(id) {
	      var _this8 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications["getConsents"]);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + id + '/admin/consents';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this8.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'setConsent',
	    value: function setConsent(data) {
	      var _this9 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.setConsent);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/admin/consents';
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this9.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeConsent',
	    value: function removeConsent(id) {
	      var _this10 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.removeConsent);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/admin/consents/' + id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this10.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'getOwners',
	    value: function getOwners() {
	      var _this11 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.getOwners);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/owners';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this11.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'createOwner',
	    value: function createOwner(data) {
	      var _this12 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.createOwner);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/owners';
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this12.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateOwner',
	    value: function updateOwner(id, data) {
	      var _this13 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.updateOwner);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/owners/' + id;
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this13.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'deleteOwner',
	    value: function deleteOwner(id) {
	      var _this14 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.deleteOwner);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/owners/' + id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this14.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'getFiscalInformation',
	    value: function getFiscalInformation() {
	      var _this15 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.getFiscalInformation);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/admin/fiscal';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this15.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'editFiscalInformation',
	    value: function editFiscalInformation(data) {
	      var _this16 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organization = _lodash2.default.get(options, 'organization', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.editFiscalInformation);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization.id + '/admin/fiscal';
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this16.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'getMaintainers',
	    value: function getMaintainers() {
	      var _this17 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.getMaintainers);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/maintainers';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this17.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'addMaintainer',
	    value: function addMaintainer(maintainer) {
	      var _this18 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.addMaintainer);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/maintainers';
	      return this.RequestService.post(url, maintainer, options, notifications).then(function (res) {
	        return _this18.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateMaintainer',
	    value: function updateMaintainer(maintainerId, data) {
	      var _this19 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.updateMaintainer);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/maintainers/' + maintainerId;
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this19.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeMaintainer',
	    value: function removeMaintainer(maintainer) {
	      var _this20 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.removeMaintainer);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/maintainers/' + maintainer.id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this20.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'uploadUserkeysXlsx',
	    value: function uploadUserkeysXlsx(file) {
	      var _this21 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var formData = new FormData();
	      formData.append('userkeys', file);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/upload-userkeys-xlsx';

	      return this.RequestService.post(url, formData, options, this._notifications.uploadUserkeysXlsx).then(function (res) {
	        return _this21.RequestService.getResponse(res, {}, true);
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        editOrganizationAsProvider: { success: "PROXY_ENABLED_SUCCESS", error: "PROXY_ENABLED_FAILED" },
	        getPayments: null,
	        editPayments: null,
	        getConsents: null,
	        setConsent: null,
	        removeConsent: null,
	        getOwners: null,
	        createOwner: { success: "CREATE_OWNER_SUCCESS", error: "CREATE_OWNER_FAILED" },
	        updateOwner: { success: "UPDATE_OWNER_SUCCESS", error: "UPDATE_OWNER_FAILED" },
	        deleteOwner: { success: "REMOVE_OWNER_SUCCESS", error: "REMOVE_OWNER_FAILED" },
	        getFiscalInformation: null,
	        editFiscalInformation: null,
	        getOrganizationPrivate: null,
	        getMaintainers: null,
	        addMaintainer: null,
	        updateMaintainer: null,
	        removeMaintainer: null,
	        uploadUserkeysXlsx: null
	      };
	    }
	  }]);

	  return OrganizationsService;
	}();

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationsHelper = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsHelper = exports.OrganizationsHelper = function () {
	  OrganizationsHelper.$inject = ["$filter", "$translate", "App", "$document", "Organization", "Utils", "uuid"];
	  function OrganizationsHelper($filter, $translate, App, $document, Organization, Utils, uuid) {
	    "ngInject";

	    _classCallCheck(this, OrganizationsHelper);

	    this.$filter = $filter;
	    this.$translate = $translate;
	    this.App = App;
	    this.$document = $document;
	    this.Organization = Organization;
	    this.Utils = Utils;
	    this.uuid = uuid;

	    this.defaultBanner = {
	      id: undefined,
	      type: "promo",
	      title: {},
	      body: {},
	      url: "",
	      fromDate: "",
	      toDate: "",
	      dismiss: true
	    };
	    this._defaultConsent = {
	      title: {},
	      mandatory: false,
	      url: ''
	    };
	    this._defaultConsentSummary = {};
	    this._defaultOwner = {
	      name: ''
	    };
	    this._defaultMaintainer = {
	      companyName: ''
	    };

	    this._regexExp = {};
	    this._initRegexExp();
	  }

	  _createClass(OrganizationsHelper, [{
	    key: "addBanner",
	    value: function addBanner($scope, options) {
	      return this._editBanner($scope, null, options);
	    }
	  }, {
	    key: "editBanner",
	    value: function editBanner($scope, banner, options) {
	      return this._editBanner($scope, banner, options);
	    }
	  }, {
	    key: "removeBanner",
	    value: function removeBanner($scope, banner, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope["modal"] = {
	          banner: banner,
	          done: function done() {
	            return resolve(_this._removeBanner($scope["modal"]["banner"], options));
	          }
	        };
	        _this.App.openModal($scope, "remove-banner.html");
	      });
	    }
	  }, {
	    key: "addConsent",
	    value: function addConsent($scope, options) {
	      return this._editConsent($scope, null, options);
	    }
	  }, {
	    key: "editConsent",
	    value: function editConsent($scope, data, options) {
	      return this._editConsent($scope, data, options);
	    }
	  }, {
	    key: "removeConsent",
	    value: function removeConsent($scope, data, options) {
	      var _this2 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          consents: _lodash2.default.cloneDeep(options.consents) || [],
	          index: options.index,
	          data: data,
	          done: function done() {
	            resolve(_this2.Organization.removeConsent($scope.modal.data.id, options).then(function () {
	              _this2.App.closeModal();
	            }));
	          }
	        };
	        _this2.App.openModal($scope, 'remove-consent.html');
	      });
	    }
	  }, {
	    key: "editConsentSummary",
	    value: function editConsentSummary($scope, data, options) {
	      var _this3 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          lang: _this3._getLang(),
	          data: data ? _lodash2.default.cloneDeep(data) : _lodash2.default.cloneDeep(_this3._defaultConsentSummary),
	          isValid: function isValid(modal) {
	            return modal.data && modal.data.es !== '';
	          },
	          validateText: function validateText(data) {
	            $scope.modal.data[$scope.modal.lang.option] = data;
	          },
	          done: function done() {
	            var data = {
	              consentSummary: $scope.modal.data
	            };
	            resolve(_this3.Organization.setConsent(data, options).then(function () {
	              _this3.App.closeModal();
	            }));
	          }
	        };
	        _this3.App.openModal($scope, 'edit-consent-summary.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: "addOwner",
	    value: function addOwner($scope, options) {
	      return this._editOwner($scope, null, options);
	    }
	  }, {
	    key: "editOwner",
	    value: function editOwner($scope, data, options) {
	      return this._editOwner($scope, data, options);
	    }
	  }, {
	    key: "removeOwner",
	    value: function removeOwner($scope, data, options) {
	      var _this4 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          data: data,
	          done: function done() {
	            resolve(_this4.Organization.deleteOwner($scope.modal.data.id, options).then(function () {
	              _this4.App.closeModal();
	            }));
	          }
	        };
	        _this4.App.openModal($scope, 'remove-owner.html');
	      });
	    }
	  }, {
	    key: "_editOwner",
	    value: function _editOwner($scope, data, options) {
	      var _this5 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          owners: _lodash2.default.cloneDeep(options.owners) || [],
	          isEdit: !!data,
	          index: options.index,
	          data: data ? _lodash2.default.cloneDeep(data) : _lodash2.default.cloneDeep(_this5._defaultOwner),
	          wizard: {
	            step: 0,
	            steps: [{ id: "data", title: _this5.$translate.instant("DATA"), intro: _this5.$translate.instant("ENTER_DATA") }, { id: "address", title: _this5.$translate.instant("ADDRESS"), intro: _this5.$translate.instant("ENTER_ADDRESS") }, { id: "summary", title: _this5.$translate.instant("SUMMARY"), intro: _this5.$translate.instant("ENTER_SUMMARY") }]
	          },
	          next: function next() {
	            var step = $scope.modal.wizard.step;
	            if ($scope.modal.wizard.steps[step].id === "address") {
	              if ($scope.modal.data.address && !$scope.modal.data.address.address && !$scope.modal.data.address.city && !$scope.modal.data.address.postalCode && !$scope.modal.data.address.province && !$scope.modal.data.address.country) {
	                delete $scope.modal.data.address;
	              }
	            }
	            $scope.modal.wizard.step = step + 1;
	          },
	          back: function back() {
	            var step = $scope.modal.wizard.step;
	            $scope.modal.wizard.step = step - 1;
	          },
	          done: function done() {
	            resolve($scope.modal.isEdit ? _this5.Organization.updateOwner($scope.modal.data.id, $scope.modal.data, options).then(function () {
	              _this5.App.closeModal();
	            }) : _this5.Organization.createOwner($scope.modal.data, options).then(function () {
	              _this5.App.closeModal();
	            }));
	          }
	        };
	        _this5.App.openModal($scope, 'edit-owner.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: "_editConsent",
	    value: function _editConsent($scope, data, options) {
	      var _this6 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          consents: _lodash2.default.cloneDeep(options.consents) || [],
	          isEdit: !!data,
	          index: options.index,
	          data: data ? _lodash2.default.cloneDeep(data) : _lodash2.default.cloneDeep(_this6._defaultConsent),
	          conflict: _this6._getDefaultConflict(),
	          lang: _this6._getLang(),
	          wizard: {
	            step: 0,
	            steps: [],
	            setSteps: function setSteps(modal) {
	              modal.wizard.steps = [{ id: "options", title: _this6.$translate.instant("OPTIONS"), intro: _this6.$translate.instant("ENTER_OPTIONS") }, { id: "summary", title: _this6.$translate.instant("SUMMARY"), intro: _this6.$translate.instant("ENTER_SUMMARY") }];
	            }
	          },
	          next: function next() {
	            var step = $scope.modal.wizard.step;
	            $scope.modal.wizard.step = step + 1;
	          },
	          back: function back() {
	            var step = $scope.modal.wizard.step;
	            $scope.modal.wizard.step = step - 1;
	          },
	          validateTitle: function validateTitle(title, key) {
	            if (key === 'es') {
	              $scope.modal.conflict.title = !title[key] && title[key] === '';
	            }
	          },
	          validateUrl: function validateUrl() {
	            _this6._validateUrl($scope.modal);
	          },
	          isValid: function isValid(modal) {
	            var res = true;
	            var step = modal.wizard.step;
	            if (modal.wizard.steps[step].id === "options") {
	              res = !modal.conflict.title && !modal.conflict.format && modal.data.title.es && modal.data.title.es !== '' && modal.data.url !== '';
	            }
	            return res;
	          },
	          done: function done() {
	            var data = {
	              consents: [$scope.modal.data]
	            };
	            resolve(_this6.Organization.setConsent(data, options).then(function () {
	              _this6.App.closeModal();
	            }));
	          }
	        };
	        $scope.modal.wizard.setSteps($scope.modal);
	        _this6.App.openModal($scope, 'edit-consent.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: "addMaintainer",
	    value: function addMaintainer($scope, options) {
	      return this._editMaintainer($scope, null, options);
	    }
	  }, {
	    key: "editMaintainer",
	    value: function editMaintainer($scope, data, options) {
	      return this._editMaintainer($scope, data, options);
	    }
	  }, {
	    key: "removeMaintainer",
	    value: function removeMaintainer($scope, data, options) {
	      var _this7 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          maintainer: data,
	          done: function done() {
	            resolve(_this7.Organization.removeMaintainer($scope.modal.maintainer, options).then(function () {
	              _this7.App.closeModal();
	            }));
	          }
	        };
	        _this7.App.openModal($scope, 'remove-maintainer.html');
	      });
	    }
	  }, {
	    key: "uploadUserkeysXlsx",
	    value: function uploadUserkeysXlsx($scope, options) {
	      var _this8 = this;

	      $scope.modal = {
	        file: null,
	        isUploading: false,
	        externalErrorMessage: undefined,
	        errorList: undefined,
	        tab: 0,
	        onFileSelected: function onFileSelected(file) {
	          $scope.modal._reset();
	          $scope.modal.file = file;
	        },
	        onFileRemoved: function onFileRemoved() {
	          $scope.modal._reset();
	        },
	        changeTab: function changeTab(tab) {
	          $scope.modal.tab = tab;
	        },
	        done: function done() {
	          $scope.modal.isUploading = true;
	          var file = $scope.modal.file;
	          options = {
	            organizationId: options.organizationId,
	            transformRequest: angular.identity,
	            headers: {
	              'Content-Type': undefined
	            }
	          };
	          _this8.Organization.uploadUserkeysXlsx(file, options).then(function (res) {
	            if (!res.status) {
	              var errorList = res.error && res.error.error && res.error.error.description ? [{
	                token: {
	                  idToken: ''
	                },
	                error: res.error.error.description
	              }] : undefined;
	              $scope.modal._setUploadError(_this8.$translate.instant('UPLOAD_FILE_ERROR_DEFAULT'), errorList);
	              return;
	            }

	            var hasFailures = res.data.failed > 0;
	            if (hasFailures) {
	              $scope.modal._setUploadError(_this8.$translate.instant('UPLOAD_SHOW_ERRORS_MESSAGE'), res.data.list);
	              return;
	            }

	            _this8.App.showNotification(_this8.$translate.instant('UPLOAD_FILE_SUCCESS_MESSAGE'));
	            _this8.App.closeModal();
	          }).catch(function (error) {
	            var message = _this8.$translate.instant('UPLOAD_FILE_ERROR_DEFAULT');
	            if (error && error.data) {
	              if (error.data.error && error.data.error.description) {
	                message = error.data.error.description;
	              }
	            }
	            $scope.modal._setUploadError(message);
	          });
	        },
	        _reset: function _reset() {
	          $scope.modal.isUploading = false;
	          $scope.modal.externalErrorMessage = undefined;
	          $scope.modal.errorList = undefined;
	          $scope.modal.tab = 0;
	          $scope.modal.file = null;
	        },
	        _setUploadError: function _setUploadError(message) {
	          var errorList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

	          $scope.modal._reset();
	          $scope.modal.externalErrorMessage = message;
	          $scope.modal.errorList = errorList;
	        }
	      };
	      this.App.openModal($scope, 'upload-xlsx-file.html', { size: 'lg' });
	    }
	  }, {
	    key: "_editMaintainer",
	    value: function _editMaintainer($scope, data, options) {
	      var _this9 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          maintainers: _lodash2.default.cloneDeep(options.maintainers) || [],
	          isEdit: !!data,
	          index: options.index,
	          maintainer: data ? _lodash2.default.cloneDeep(data) : _lodash2.default.cloneDeep(_this9._defaultMaintainer),
	          wizard: {
	            step: 0,
	            steps: [{ id: "data", title: _this9.$translate.instant("MAINTAINER"), intro: _this9.$translate.instant("COMPLETE_THE_MAINTAINER_INFO") }, { id: "summary", title: _this9.$translate.instant("SUMMARY"), intro: _this9.$translate.instant("REVIEW_THE_SUMMARY") }]
	          },
	          done: function done() {
	            if ($scope.modal.isEdit) {
	              var differences = _this9.Utils.getObjectDifferences(data, $scope.modal.maintainer);
	              if (Object.keys(differences).length > 0) {
	                return resolve(_this9.Organization.updateMaintainer($scope.modal.maintainer.id, differences, options).then(function () {
	                  _this9.App.closeModal();
	                }));
	              } else {
	                _this9.App.closeModal();
	              }
	            } else {
	              return resolve(_this9.Organization.addMaintainer($scope.modal.maintainer, options).then(function () {
	                _this9.App.closeModal();
	              }));
	            }
	          }
	        };
	        _this9.App.openModal($scope, 'edit-maintainer.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: "_getDefaultConflict",
	    value: function _getDefaultConflict() {
	      return {
	        title: false,
	        format: false,
	        titleText: 'CONFLICT_EMPTY_TEXT',
	        urlFormat: 'CONFLICT_URL_FORMAT'
	      };
	    }
	  }, {
	    key: "_validateUrl",
	    value: function _validateUrl(modal) {
	      var regexp = new RegExp('^https?:\\/\\/(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$');
	      var res = !!regexp.exec(modal.data.url);
	      modal.conflict.format = !res;
	    }
	  }, {
	    key: "_getLang",
	    value: function _getLang() {
	      return {
	        option: "es",
	        options: this.App.getLanguages()
	      };
	    }
	  }, {
	    key: "_removeBanner",
	    value: function _removeBanner(banner, options) {
	      var _this10 = this;

	      var payload = {
	        "appMessages": this._getUpdatedBannerList("remove", options["banners"], this._getObjectIndexList(options["banners"], banner), banner)
	      };
	      return this.Organization.editAppMessages(options["organization"]["id"], payload).then(function () {
	        if (!options || !options.avoidNotifications) _this10.App.closeModal();
	      }).catch(function () {
	        if (!options || !options.avoidNotifications) {
	          _this10.App.showNotification(_this10.$translate.instant("ACTION.REMOVE_BANNER.FAILED"), "error");
	          _this10.App.closeModal();
	        }
	      });
	    }
	  }, {
	    key: "_editBanner",
	    value: function _editBanner($scope, banner, options) {
	      var _this11 = this;

	      var isValid = function isValid(modal) {
	        var step = modal["wizard"]["step"];
	        if (modal["wizard"]["steps"][step]["id"] === "options") {
	          return !modal["conflict"] && (modal["banner"]["type"] == "info" || modal["banner"]["url"] && modal["banner"]["url"].length > 0) && modal["fromDate"]["date"] != "" && modal["toDate"]["date"] != "";
	        }
	        if (modal["wizard"]["steps"][step]["id"] === "message") {
	          return modal["banner"]["title"]["es"] && modal["banner"]["title"]["es"].length > 0 && modal["banner"]["body"]["es"] && modal["banner"]["body"]["es"].length > 0;
	        }
	        return true;
	      };

	      var next = function next(modal) {
	        var step = modal["wizard"]["step"];
	        var stepId = modal["wizard"]["steps"][step]["id"];
	        switch (stepId) {
	          case "options":
	            modal["banner"]["fromDate"] = modal["fromDate"]["date"].toISOString();
	            modal["banner"]["toDate"] = modal["toDate"]["date"].toISOString();
	            break;
	        }
	        modal["conflict"] = null;
	        modal["wizard"]["step"] = step + 1;
	      };

	      var back = function back(modal) {
	        var step = modal["wizard"]["step"];
	        modal["conflict"] = null;
	        modal["wizard"]["step"] = step - 1;
	      };

	      return new Promise(function (resolve) {
	        $scope["modal"] = {
	          isEdit: banner ? true : false,
	          conflict: null,
	          banners: options["banners"],
	          bannerIndex: null,
	          lang: _this11._getLang(),
	          banner: banner ? _lodash2.default.cloneDeep(banner) : _lodash2.default.cloneDeep(_this11.defaultBanner),
	          organization: options["organization"],
	          types: [{ id: "promo", display: "Promo" }, { id: "info", display: "Info" }],
	          fromDate: {
	            date: banner ? new Date(banner["fromDate"]) : "",
	            open: false,
	            options: {}
	          },
	          toDate: {
	            date: banner ? new Date(banner["toDate"]) : "",
	            open: false,
	            options: {}
	          },
	          wizard: {
	            step: 0,
	            steps: [],
	            setSteps: function setSteps(modal) {
	              modal["wizard"]["steps"] = [{ "id": "options", "title": _this11.$translate.instant("ACTION.ADD_BANNER.OPTIONS"), "intro": _this11.$translate.instant("ACTION.ADD_BANNER.ENTER_OPTIONS") }, { "id": "message", "title": _this11.$translate.instant("ACTION.ADD_BANNER.MESSAGE"), "intro": _this11.$translate.instant("ACTION.ADD_BANNER.ENTER_MESSAGE") }, { "id": "summary", "title": _this11.$translate.instant("ACTION.ADD_BANNER.SUMMARY"), "intro": _this11.$translate.instant("ACTION.ADD_BANNER.ENTER_SUMMARY") }];
	            }
	          },
	          validateUrl: function validateUrl(url) {
	            if (url != "") {
	              var valid = _this11._regexExp["url"].test(url);
	              if (!valid) {
	                $scope["modal"]["conflict"] = { name: url };
	                $scope["modal"]["banner"]["url"] = "";
	              } else {
	                $scope["modal"]["conflict"] = null;
	              }
	            }
	          },
	          validateDate: function validateDate(type, date) {
	            var fields = [{ value: "toDate", op: function op(x, y) {
	                return x < y;
	              } }, { value: "fromDate", op: function op(x, y) {
	                return x > y;
	              } }];
	            if (["object", "undefined"].includes(typeof date === "undefined" ? "undefined" : _typeof(date))) {
	              if (!(date instanceof Date)) {
	                var inputValue = _this11.$document[0].getElementById('input-' + type).value;
	                $scope["modal"]["conflict"] = inputValue != "" ? { name: inputValue } : null;
	                $scope["modal"][type]["date"] = "";
	              } else {
	                var otherFiled = _lodash2.default.filter(fields, function (item) {
	                  return item["value"] != type;
	                }).pop();
	                var otherDate = $scope["modal"][otherFiled["value"]]["date"];
	                if (otherDate instanceof Date) {
	                  if (!otherFiled["op"](date.getTime(), otherDate.getTime())) {
	                    $scope["modal"]["conflict"] = { name: _this11.$document[0].getElementById('input-' + type).value };
	                    $scope["modal"][type]["date"] = "";
	                  } else {
	                    $scope["modal"]["conflict"] = null;
	                  }
	                } else {
	                  $scope["modal"]["conflict"] = null;
	                }
	              }
	            }
	          },
	          updateType: function updateType() {
	            if ($scope["modal"]["banner"]["type"] == "info") {
	              delete $scope["modal"]["banner"]["url"];
	            } else {
	              $scope["modal"]["banner"]["url"] = "";
	            }
	          },
	          isUndefined: function isUndefined(thing) {
	            return typeof thing === "undefined";
	          },
	          isValid: isValid,
	          next: next,
	          back: back,
	          done: function done() {
	            options = options || {};
	            var payload = {
	              "appMessages": _this11._getUpdatedBannerList("change", $scope["modal"]["banners"], $scope["modal"]["bannerIndex"], $scope["modal"]["banner"])
	            };
	            return resolve(_this11.Organization.editAppMessages($scope["modal"]["organization"]["id"], payload).then(function () {
	              if (!options || !options.avoidNotifications) {
	                _this11.App.showNotification(_this11.$translate.instant("ACTION.ADD_BANNER.ADD_SUCCESS"), "ok", null, 700);
	                _this11.App.closeModal();
	              }
	            }).catch(function () {
	              if (!options || !options.avoidNotifications) {
	                _this11.App.showNotification(_this11.$translate.instant("ACTION.ADD_BANNER.ADD_FAILED"), "error");
	                _this11.App.closeModal();
	              }
	            }));
	          }
	        };
	        $scope["modal"]["bannerIndex"] = _this11._getObjectIndexList($scope["modal"]["banners"], $scope["modal"]["banner"]);
	        $scope["modal"]["banner"]["id"] = $scope["modal"]["banner"]["id"] ? $scope["modal"]["banner"]["id"] : _this11.uuid.generate();
	        $scope["modal"]["wizard"].setSteps($scope["modal"]);
	        _this11.App.openModal($scope, "add-banner.html", { "size": "lg" });
	      });
	    }
	  }, {
	    key: "_getUpdatedBannerList",
	    value: function _getUpdatedBannerList(action, banners, newBannerIndex, newBanner) {
	      switch (action) {
	        case "remove":
	          banners.splice(newBannerIndex, 1);
	          break;
	        case "change":
	          if (newBannerIndex != -1) {
	            banners[newBannerIndex] = newBanner;
	          } else {
	            banners.push(newBanner);
	          }
	          break;
	      }
	      return banners;
	    }
	  }, {
	    key: "_getObjectIndexList",
	    value: function _getObjectIndexList(list, object) {
	      return list.findIndex(function (element) {
	        return _lodash2.default.isEqual(element, object);
	      });
	    }
	  }, {
	    key: "_initRegexExp",
	    value: function _initRegexExp() {
	      this._regexExp = {
	        url: /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
	      };
	    }
	  }]);

	  return OrganizationsHelper;
	}();

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChargeHelper = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargeHelper = exports.ChargeHelper = function () {
	  ChargeHelper.$inject = ["$rootScope", "App", "OCPP", "ChargepointHelper", "ChargePointsService", "ChargeSessionsService", "UsersService", "Auth", "GroupsService", "moment", "$translate"];
	  function ChargeHelper($rootScope, App, OCPP, ChargepointHelper, ChargePointsService, ChargeSessionsService, UsersService, Auth, GroupsService, moment, $translate) {
	    'ngInject';

	    _classCallCheck(this, ChargeHelper);

	    this.App = App;
	    this.OCPP = OCPP;
	    this.GroupsService = GroupsService;
	    this.UsersService = UsersService;
	    this.AuthService = Auth;
	    this.ChargePointsService = ChargePointsService;
	    this.ChargeSessionsService = ChargeSessionsService;
	    this.ChargepointHelper = ChargepointHelper;
	    this.moment = moment;
	    this.$translate = $translate;
	    this.CO2KG_PER_KWH = 0.201; // Provided by Efimob: saved CO2 using electric vehicles vs gas/diesel
	  }

	  _createClass(ChargeHelper, [{
	    key: 'isAdminProvider',
	    value: function isAdminProvider() {
	      return this.AuthService.isProvider();
	    }
	  }, {
	    key: 'isCharging',
	    value: function isCharging(charge) {
	      return charge && charge.start && !charge.stop;
	    }
	  }, {
	    key: 'isFinished',
	    value: function isFinished(charge) {
	      return charge && charge.start && charge.stop && !charge.unfinished;
	    }
	  }, {
	    key: 'isFinishedWithError',
	    value: function isFinishedWithError(charge) {
	      return charge && charge.start && charge.stop && charge.unfinished;
	    }
	  }, {
	    key: 'getCurrentMeter',
	    value: function getCurrentMeter(charge, meterValues) {
	      if (!charge) return null;
	      if (charge.meter) return charge.meter;
	      if (!meterValues || !_lodash2.default.isArray(meterValues) || meterValues.length <= 0) return null;
	      if (!charge.start || angular.isUndefined(charge.start.meter) || charge.start.meter === null) return null;
	      if (charge.stop) return null;
	      // WARNING: To calculate energy/power you need the overall values (not phases).
	      var aux = _lodash2.default.filter(meterValues, { measurand: 'Energy.Active.Import.Register', phase: null });
	      var sortedMeterValues = _lodash2.default.sortBy(aux, 'timestamp');
	      var lastMeter = _lodash2.default.findLast(sortedMeterValues, { measurand: 'Energy.Active.Import.Register' });
	      if (!lastMeter) return 0;
	      var lastMeterkWh = parseFloat(lastMeter.value);
	      if (lastMeter.unit === 'Wh') lastMeterkWh = lastMeterkWh / 1000;
	      return lastMeterkWh - charge.start.meter;
	    }
	  }, {
	    key: 'askForForcedClosure',
	    value: function askForForcedClosure($scope, options, params) {
	      var _this = this;

	      function isValid(modal) {
	        if (modal.wizard.steps[modal.wizard.step].id === 'forceClosure') {
	          return modal.dataClose.stopDateTime && modal.dataClose.meter != null && modal.dataClose.meter >= 0;
	        }
	        return true;
	      }

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          dataClose: {
	            stopDateTime: params.timestamp,
	            meter: params.meterValue,
	            closeProcess: params.state.closeProcess
	          },
	          wizard: {
	            step: 0,
	            steps: [{
	              "id": "forceClosure",
	              "title": _this.$translate.instant("CHARGE.MODAL.NAME"),
	              "intro": _this.$translate.instant("CHARGE.MODAL.WHAT_CLOSE")
	            }]
	          },
	          isValid: isValid,
	          done: function done() {
	            var payload = _lodash2.default.assign($scope.modal.dataClose);
	            resolve(_this.ChargeSessionsService.closeTransaction(params.id, payload, options).then(function () {
	              _this.App.closeModal();
	            }));
	          }
	        };
	        _this.App.openModal($scope, "add-forced-closure-data.html", { "size": "lg" });
	      });
	    }
	  }]);

	  return ChargeHelper;
	}();

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OCPPService = exports.OCPPService = function () {
	    OCPPService.$inject = ["$rootScope", "$translate"];
	    function OCPPService($rootScope, $translate) {
	        'ngInject';

	        _classCallCheck(this, OCPPService);

	        var OCPP = this;
	        $rootScope.OCPP = OCPP;
	        this.$translate = $translate;

	        this.ChargePointErrorCode = {
	            'ConnectorLockFailure': { error: true },
	            'EVCommunicationError': { error: true },
	            'GroundFailure': { error: true },
	            'HighTemperature': { error: true },
	            'InternalError': { error: true },
	            'LocalListConflict': { error: true },
	            'NoError': { error: false },
	            'OtherError': { error: true },
	            'OverCurrentFailure': { error: true },
	            'OverVoltage': { error: true },
	            'PowerMeterFailure': { error: true },
	            'PowerSwitchFailure': { error: true },
	            'ReaderFailure': { error: true },
	            'ResetFailure': { error: true },
	            'UnderVoltage': { error: true },
	            'WeakSignal': { error: true }
	        };

	        this.ChargePointStatus = {
	            'Available': { operative: true },
	            'Preparing': { operative: true },
	            'Charging': { operative: true },
	            'SuspendedEVSE': { operative: true },
	            'SuspendedEV': { operative: true },
	            'Finishing': { operative: true },
	            'Reserved': { operative: true },
	            'Unavailable': { operative: false },
	            'Faulted': { operative: false }
	        };

	        this.AvailabilityStatus = {
	            'Accepted': { error: false },
	            'Rejected': { error: true, notification: { message: this.$translate.instant('ACTION.CHANGE_AVAILABILITY.REJECTED'), style: 'error' } },
	            'Scheduled': { error: false, notification: { message: this.$translate.instant('ACTION.CHANGE_AVAILABILITY.SCHEDULED'), style: 'warning' } }
	        };

	        this.UnlockStatus = {
	            'Unlocked': { error: false, notification: { message: this.$translate.instant('ACTION.UNLOCK.UNLOCKED'), style: 'ok' } },
	            'UnlockFailed': { error: true, notification: { message: this.$translate.instant('ACTION.UNLOCK.UNLOCK_FAILED'), style: 'error' } },
	            'NotSupported': { error: false, notification: { message: this.$translate.instant('ACTION.UNLOCK.NOT_SUPPORTED'), style: 'warning' } }
	        };

	        this.ClearCacheStatus = {
	            'Accepted': { error: false, notification: { message: this.$translate.instant('ACTION.CLEAR_CACHE.ACCEPTED'), style: 'ok' } },
	            'Rejected': { error: true, notification: { message: this.$translate.instant('ACTION.CLEAR_CACHE.REJECTED'), style: 'error' } }
	        };

	        this.ResetStatus = {
	            'Accepted': { error: false, notification: { message: this.$translate.instant('ACTION.RESET.ACCEPTED'), style: 'ok' } },
	            'Rejected': { error: true, notification: { message: this.$translate.instant('ACTION.RESET.REJECTED'), style: 'error' } }
	        };

	        this.RemoteStartStopStatus = {
	            'Accepted': { error: false, notification: { message: 'Operación Reset aceptada', style: 'ok' } },
	            'Rejected': { error: true, notification: { message: 'Operación Reset Rechazada', style: 'error' } }
	        };

	        this._RemoteStartStatus = {
	            'Accepted': { error: false, notification: { message: this.$translate.instant('ACTION.SRT.ACCEPTED'), style: 'ok' } },
	            'Rejected': { error: true, notification: { message: this.$translate.instant('ACTION.SRT.REJECTED'), style: 'error' } }
	        };

	        this._RemoteStopStatus = {
	            'Accepted': { error: false, notification: { message: this.$translate.instant('ACTION.STOP_RT.ACCEPTED'), style: 'ok' } },
	            'Rejected': { error: true, notification: { message: this.$translate.instant('ACTION.STOP_RT.REJECTED'), style: 'error' } }
	        };

	        this.UpdateStatus = {
	            'Accepted': { error: false, notification: { message: this.$translate.instant('ACTION.UPDATE_STATUS.ACCEPTED'), style: 'ok' } },
	            'Failed': { error: true, notification: { message: this.$translate.instant('ACTION.UPDATE_STATUS.FAILED'), style: 'error' } },
	            'NotSupported': { error: false, notification: { message: this.$translate.instant('ACTION.UPDATE_STATUS.NOT_SUPPORTED'), style: 'warning' } },
	            'VersionMismatch': { error: true, notification: { message: this.$translate.instant('ACTION.UPDATE_STATUS.VERSION_MISMATCH'), style: 'error' } }
	        };

	        this.TriggerMessageStatus = {
	            'Accepted': { error: false, notification: { message: this.$translate.instant('ACTION.TRIGGER_MESSAGE_STATUS.ACCEPTED'), style: 'ok' } },
	            'Rejected': { error: true, notification: { message: this.$translate.instant('ACTION.TRIGGER_MESSAGE_STATUS.REJECTED'), style: 'error' } },
	            'NotImplemented': { error: true, notification: { message: this.$translate.instant('ACTION.TRIGGER_MESSAGE_STATUS.NOT_IMPLEMENTED'), style: 'error' } }
	        };
	    }

	    _createClass(OCPPService, [{
	        key: 'onCallResult',
	        value: function onCallResult(command, result) {
	            switch (command) {
	                case 'ChangeAvailability':
	                    return this._getResponse(result, this.AvailabilityStatus, "Rejected");
	                case 'UnlockConnector':
	                    return this._getResponse(result, this.UnlockStatus, "UnlockFailed");
	                case 'ClearCache':
	                    return this._getResponse(result, this.ClearCacheStatus, "Rejected");
	                case 'Reset':
	                    return this._getResponse(result, this.ResetStatus, "Rejected");
	                case 'RemoteStartTransaction':
	                    return this._getResponse(result, this._RemoteStartStatus, "Rejected");
	                case 'RemoteStopTransaction':
	                    return this._getResponse(result, this._RemoteStopStatus, "Rejected");
	                case 'SendLocalList':
	                    return this._getResponse(result, this.UpdateStatus, "Failed");
	                case 'GetConfiguration':
	                    return result.configurationKey || [];
	                case 'TriggerMessage':
	                    return this._getResponse(result, this.TriggerMessageStatus, "Rejected");
	                case 'GetDiagnostics':
	                    return result.fileName || null;
	                case 'UpdateFirmware':
	                    return result || null;
	            }
	            return { error: true, notification: { message: this.$translate.instant('ACTION.UNEXPECTED_RESULT'), style: 'warning' } };
	        }
	    }, {
	        key: '_getResponse',
	        value: function _getResponse(result, data, defaultField) {
	            return data[result["status"]] ? data[result["status"]] : data[defaultField];
	        }
	    }]);

	    return OCPPService;
	}();

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChargePointHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _async = __webpack_require__(176);

	var _async2 = _interopRequireDefault(_async);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargePointHelperService = exports.ChargePointHelperService = function () {
	    ChargePointHelperService.$inject = ["$rootScope", "$filter", "$translate", "App", "OCPP", "GroupsHelper", "GroupsService", "Organization", "ChargePointsService", "UsersService", "moment"];
	    function ChargePointHelperService($rootScope, $filter, $translate, App, OCPP, GroupsHelper, GroupsService, Organization, ChargePointsService, UsersService, moment) {
	        'ngInject';

	        _classCallCheck(this, ChargePointHelperService);

	        this.$filter = $filter;
	        this.$translate = $translate;
	        this.async = _async2.default;
	        this.App = App;
	        this.OCPP = OCPP;
	        this.GroupsHelper = GroupsHelper;
	        this.GroupsService = GroupsService;
	        this.Organization = Organization;
	        this.ChargePointsService = ChargePointsService;
	        this.UsersService = UsersService;
	        this.moment = moment;

	        $rootScope.ChargepointHelper = this;

	        this.ownershipTypes = [{ 'id': 'public', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OWNERSHIP_TYPES.PUBLIC') }, { 'id': 'roaming', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OWNERSHIP_TYPES.ROAMING') }];

	        this.operationalStatuses = [{ 'id': 'Operative', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.OPERATIVE') }, { 'id': 'Disabled', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.DISABLED') }, { 'id': 'WaitingRepair', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.WAITING_REPAIR') }, { 'id': 'InTests', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.IN_TESTS') }, { 'id': 'InWarehouse', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.IN_WAREHOUSE') }, { 'id': 'DeletePending', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.DELETE_PENDING') }, { 'id': 'TestsOK', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.TESTS_OK') }, { 'id': 'OpeningSoon', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.OPENING_SOON') }, { 'id': 'NoManaged', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.NO_MANAGED') }, { 'id': 'SemiPublic', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.SEMIPUBLIC') }, { 'id': 'Private', 'display': this.$translate.instant('FILTER.CHARGEPOINT.OPERATIONAL_TYPES.PRIVATE') }];

	        this.connectorTypes = [{ id: 'TYPE2', display: 'TYPE2' }, { id: 'TYPE2_CABLE', display: 'TYPE2_CABLE' }, { id: 'TYPE1_CABLE', display: 'TYPE1_CABLE' }, { id: 'CHADEMO', display: 'CHADEMO' }, { id: 'CCS', display: 'CCS' }, { id: 'SCHUKO', display: 'SCHUKO' }];

	        this.authModes = [{ id: 'PlugAndCharge', display: 'Plug & Charge' }, { id: 'RFID', display: 'RFID' }];

	        this.defaultProgramedReboot = {
	            type: "reboot",
	            period: 1,
	            windowStart: "02:00",
	            windowEnd: "04:00"
	        };

	        this.defaultProgramedRebootPeriods = [{ id: 1, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAY', { d: 1 }) }, { id: 2, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 2 }) }, { id: 3, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 3 }) }, { id: 4, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 4 }) }, { id: 5, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 5 }) }, { id: 7, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 7 }) }, { id: 10, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 10 }) }, { id: 15, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 15 }) }, { id: 30, display: this.$translate.instant('FILTER.CHARGEPOINT.PROGRAMED_REBOOT.DAYS', { d: 30 }) }];

	        this.defaultRechargingSchedule = {
	            startDayOfWeek: 1,
	            startTime: "00:00",
	            endDayOfWeek: 2,
	            endTime: "00:00",
	            unit: "A",
	            limit: 1
	        };

	        this.defaultChargePoint = {
	            ownership: 'public',
	            serialOCPP: null,
	            name: null,
	            group: null,
	            vehicleType: null
	        };
	    }

	    _createClass(ChargePointHelperService, [{
	        key: 'getConnectorZero',
	        value: function getConnectorZero(chargepoint) {
	            if (!chargepoint) return null;
	            return _lodash2.default.find(chargepoint.connectors, { id: '0' });
	        }
	    }, {
	        key: 'isConnector',
	        value: function isConnector(connector) {
	            if (!connector || !connector.id) return false;
	            return connector.id != '0';
	        }
	    }, {
	        key: 'isConnected',
	        value: function isConnected(chargepoint) {
	            return _lodash2.default.get(chargepoint, 'ocppConnection.connected') === "true" || _lodash2.default.get(chargepoint, 'ocppConnection.connected') === true;
	        }
	    }, {
	        key: 'isDisconnected',
	        value: function isDisconnected(chargepoint) {
	            return _lodash2.default.get(chargepoint, 'ocppConnection.connected') === "false" || _lodash2.default.get(chargepoint, 'ocppConnection.connected') === false;
	        }
	    }, {
	        key: 'isWebsocket',
	        value: function isWebsocket(chargepoint) {
	            return _lodash2.default.get(chargepoint, 'ocppConnection.websocketConnected') === "true" || _lodash2.default.get(chargepoint, 'ocppConnection.websocketConnected') === true;
	        }
	    }, {
	        key: 'isPooling',
	        value: function isPooling(chargepoint) {
	            return _lodash2.default.get(chargepoint, 'ocppConnection.websocketConnected') === "false" || _lodash2.default.get(chargepoint, 'ocppConnection.websocketConnected') === false;
	        }
	    }, {
	        key: 'isProxy',
	        value: function isProxy(chargepoint) {
	            var aux = _lodash2.default.get(chargepoint, 'proxyList');
	            return aux != undefined && _lodash2.default.isArray(aux) && aux.length > 0;
	        }
	    }, {
	        key: 'isRoaming',
	        value: function isRoaming(chargepoint) {
	            return this.checkOwnership("roaming", chargepoint);
	        }
	    }, {
	        key: 'getType',
	        value: function getType(chargepoint) {
	            var response = "";
	            switch (true) {
	                case this.isPooling(chargepoint):
	                    response = "POOLING";
	                    break;
	                case this.isProxy(chargepoint):
	                    response = "PROXY";
	                    break;
	                case this.isRoaming(chargepoint):
	                    response = "ROAMING";
	                    break;
	            }
	            return response;
	        }
	    }, {
	        key: 'isOperative',
	        value: function isOperative(chargepoint) {
	            var status = _lodash2.default.get(this.getConnectorZero(chargepoint), 'status.status');
	            if (status && this.OCPP.ChargePointStatus[status]) return this.OCPP.ChargePointStatus[status].operative;
	            return false;
	        }
	    }, {
	        key: 'checkOwnership',
	        value: function checkOwnership(type, chargepoint) {
	            return _lodash2.default.get(chargepoint, 'ownership', null) === type;
	        }
	    }, {
	        key: 'getOwnership',
	        value: function getOwnership(chargepoint) {
	            return _lodash2.default.get(chargepoint, 'ownership');
	        }
	    }, {
	        key: 'getErrors',
	        value: function getErrors(chargepoint) {
	            var _this = this;

	            if (!chargepoint) return [];

	            var errors = [];
	            _lodash2.default.each(chargepoint.connectors, function (connector) {
	                var errorCode = _lodash2.default.get(connector, 'status.errorCode');
	                if (errorCode) {
	                    if (!_this.OCPP.ChargePointErrorCode[errorCode] || _this.OCPP.ChargePointErrorCode[errorCode].error) {
	                        errors.push({
	                            errorCode: errorCode,
	                            connectorId: connector.id,
	                            isChargepoint: connector.id === '0'
	                        });
	                    }
	                }
	            });
	            return errors;
	        }
	    }, {
	        key: 'isConnectorOperative',
	        value: function isConnectorOperative(connector) {
	            var status = _lodash2.default.get(connector, 'status.status');
	            if (status && this.OCPP.ChargePointStatus[status]) return this.OCPP.ChargePointStatus[status].operative;
	            return false;
	        }
	    }, {
	        key: 'isConnectorAvailableForCharging',
	        value: function isConnectorAvailableForCharging(connector) {
	            return connector && this.isConnector(connector) && this.isConnectorOperative(connector);
	        }
	    }, {
	        key: 'askToAssignToOrganization',
	        value: function askToAssignToOrganization($scope, chargepoints) {
	            var _this2 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    chargepoints: chargepoints,
	                    organization: null,
	                    organizations: null,
	                    organizationsLoading: true,
	                    location: null,
	                    locationView: {
	                        locationTableData: {
	                            enabledBreadcrumbs: false,
	                            organizationId: null,
	                            table: {
	                                keys: ['name | locationName:item'],
	                                selected: [],
	                                selectable: 'one'
	                            },
	                            filters: _this2.App.getTableFilters('locations', { context: _this2, modify: { purpose: { hide: true, value: 'General' }, onlyAtomic: { hide: true, value: 'true' } } })
	                        },
	                        locationTableApi: {},
	                        unsubscribeSelectedEvent: null,
	                        unsubscribe: null,
	                        subscribe: function subscribe() {
	                            return $scope.$watch(function () {
	                                return $scope.modal.locationView.locationTableApi.on;
	                            }, function (onFn) {
	                                if (!onFn) return;
	                                $scope.modal.locationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                                    if (_lodash2.default.isArray(selected)) {
	                                        $scope.modal.location = selected[0];
	                                    }
	                                });
	                            });
	                        }
	                    },
	                    wizard: {
	                        step: 0,
	                        steps: [{
	                            id: 'organization',
	                            title: _this2.$translate.instant('CPS.ATO.ORGANIZATION'),
	                            intro: chargepoints.length > 1 ? _this2.$translate.instant('CPS.ATO.ENTER_ORGANIZATION') : _this2.$translate.instant('CPS.ATO.ENTER_ORGANIZATION_ONE')
	                        }, {
	                            id: 'location',
	                            title: _this2.$translate.instant('CPS.ATO.GROUP'),
	                            intro: _this2.$translate.instant('CPS.ATO.ENTER_GROUP')
	                        }, {
	                            id: 'summary',
	                            title: _this2.$translate.instant('CPS.ATO.SUMMARY'),
	                            intro: _this2.$translate.instant('CPS.ATO.ENTER_SUMMARY')
	                        }]
	                    },
	                    isValid: function isValid(modal) {
	                        if (modal.wizard.steps[modal.wizard.step].id === 'organization') {
	                            return !!modal.organization;
	                        }
	                        if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	                            return !!modal.location;
	                        }
	                        return true;
	                    },
	                    next: function next(modal) {
	                        var step = modal.wizard.step;
	                        if (modal.wizard.steps[step].id === 'organization') {
	                            modal.locationView.locationTableData.organizationId = modal.organization.id;
	                        }
	                        modal.conflict = null;
	                        modal.wizard.step = step + 1;
	                    },
	                    back: function back(modal) {
	                        var step = modal.wizard.step;
	                        modal.conflict = null;
	                        modal.wizard.step = step - 1;
	                    },
	                    close: function close() {
	                        if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	                            $scope.modal.locationView.unsubscribeSelectedEvent();
	                            $scope.modal.locationView.unsubscribe();
	                        }
	                        $scope.App.closeModal();
	                    },
	                    done: function done() {
	                        $scope.modal.state = 'working';
	                        if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	                            $scope.modal.locationView.unsubscribeSelectedEvent();
	                            $scope.modal.locationView.unsubscribe();
	                        }
	                        var customOptions = {
	                            'location': $scope.modal.location,
	                            'leavingOrganization': options ? options.leavingOrganization : undefined
	                        };
	                        return resolve(_this2.assignToOrganizationAndGroup($scope.modal.chargepoints, $scope.modal.organization, $scope.modal.location, customOptions));
	                    }
	                };
	                $scope.modal.locationView.unsubscribe = $scope.modal.locationView.subscribe();
	                _this2.Organization.getOrganizations().then(function (organizations) {
	                    $scope.modal.organizations = organizations;
	                    $scope.modal.organization = organizations.length > 0 ? organizations[0] : null;
	                    $scope.modal.organizationsLoading = false;
	                }).catch(function () {
	                    $scope.modal.organizationsLoading = false;
	                });
	                _this2.App.openModal($scope, 'assign-chargepoint.html', { 'size': 'lg' });
	            });
	        }
	    }, {
	        key: 'assignToOrganizationAndGroup',
	        value: function assignToOrganizationAndGroup(chargepoints, organization, group, options) {
	            var _this3 = this;

	            return new Promise(function (resolve, reject) {
	                _this3.async.mapLimit(chargepoints, 20, _this3.async.asyncify(function (chargepoint) {
	                    if (options && options.leavingOrganization) {
	                        return _this3.ChargePointsService.reassignChargepoint(chargepoint, { organization: organization.id, group: group.id, leavingOrganization: options.leavingOrganization });
	                    } else {
	                        return _this3.ChargePointsService.assignChargepoint(chargepoint, { organization: organization.id, group: group.id });
	                    }
	                }), function (err, results) {
	                    if (err) {
	                        _this3.App.closeModal();
	                        _this3.App.showNotification(_this3.$translate.instant('CPS.ATO.ASSIGNATION_FAILED'), 'error');
	                        return reject(err);
	                    } else {
	                        _this3.App.closeModal();
	                        if (chargepoints.length == 1) _this3.App.showNotification(_this3.$translate.instant('CPS.ATO.ASSIGNATION_OK_ONE', { name: '<b>' + chargepoints[0] + '</b>' }));
	                        if (chargepoints.length > 1) _this3.App.showNotification(_this3.$translate.instant('CPS.ATO.ASSIGNATION_OK', { quantity: chargepoints.length }));

	                        return resolve({ chargepoints: results, organization: organization.id, group: group.id });
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'getParentGroups',
	        value: function getParentGroups(chargepoint) {
	            var _this4 = this;

	            return new Promise(function (resolve) {
	                var parents = {
	                    parent: null,
	                    parentWithLocation: null
	                };
	                var getLocationOfGroup = function getLocationOfGroup(id, parents) {
	                    return _this4.GroupsService.getGroup(id, { organization: chargepoint.organizationId }).then(function (group) {
	                        if (!parents.parent) parents.parent = group;
	                        if (group.location && group.location.latitude && group.location.longitude) {
	                            parents.parentWithLocation = group;
	                            return parents;
	                        }
	                        if (group.parentGroupId) {
	                            return getLocationOfGroup(group.parentGroupId, parents);
	                        }
	                    });
	                };
	                if (chargepoint.organizationId && chargepoint.groupId) {
	                    return getLocationOfGroup(chargepoint.groupId, parents).then(function (parents) {
	                        return resolve(parents);
	                    });
	                } else {
	                    resolve(parents);
	                }
	            });
	        }
	    }, {
	        key: 'addProgramReboot',
	        value: function addProgramReboot($scope, options) {
	            return this._editProgramedReboot($scope, null, options);
	        }
	    }, {
	        key: 'editProgramReboot',
	        value: function editProgramReboot($scope, programedReboot, options) {
	            return this._editProgramedReboot($scope, programedReboot, options);
	        }
	    }, {
	        key: 'removeProgramReboot',
	        value: function removeProgramReboot($scope, programedReboot, options) {
	            var _this5 = this;

	            return new Promise(function (resolve) {
	                $scope["modal"] = {
	                    programedReboot: programedReboot,
	                    done: function done() {
	                        return resolve(_this5._removeProgramReboot($scope["ctrl"]["chargepoint"]["id"], $scope["modal"]["programedReboot"], options));
	                    }
	                };
	                _this5.App.openModal($scope, "remove-programed_reboot.html");
	            });
	        }
	    }, {
	        key: '_removeProgramReboot',
	        value: function _removeProgramReboot(chargepointId, programedReboot, options) {
	            var _this6 = this;

	            return this.ChargePointsService.removeChargepointProgramReboot(chargepointId, programedReboot, options).then(function () {
	                if (!options || !options.avoidNotifications) _this6.App.closeModal();
	            }).catch(function () {
	                if (!options || !options.avoidNotifications) {
	                    _this6.App.showNotification(_this6.$translate.instant("ACTION.REMOVE_PROGRAM_REBOOT.FAILED"), "error");
	                    _this6.App.closeModal();
	                }
	            });
	        }
	    }, {
	        key: '_editProgramedReboot',
	        value: function _editProgramedReboot($scope, programedReboot, options) {
	            var _this7 = this;

	            return new Promise(function (resolve) {
	                $scope["modal"] = {
	                    isEdit: programedReboot ? true : false,
	                    programedReboot: programedReboot ? _lodash2.default.cloneDeep(programedReboot) : _lodash2.default.cloneDeep(_this7.defaultProgramedReboot),
	                    chargepoint: $scope["ctrl"]["chargepoint"],
	                    periods: _this7.defaultProgramedRebootPeriods,
	                    slider: {
	                        value: { min: 8, max: 16 },
	                        options: {
	                            floor: 0,
	                            ceil: 96,
	                            translate: function translate(value) {
	                                if (value <= 0) return '00:00';
	                                if (value >= 96) return '24:00';
	                                return _this7.moment().startOf('day').add(_this7.moment.duration(value * 15, 'm')).format('HH:mm');
	                            },
	                            showTicksValues: true,
	                            ticksArray: [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96]
	                        },
	                        onChange: function onChange() {
	                            $scope["modal"]["programedReboot"]["windowStart"] = _this7.moment().startOf('day').add(_this7.moment.duration($scope["modal"]["slider"]["value"]["min"] * 15, 'm')).format("HH:mm");
	                            $scope["modal"]["programedReboot"]["windowEnd"] = _this7.moment().startOf('day').add(_this7.moment.duration($scope["modal"]["slider"]["value"]["max"] * 15, 'm')).format("HH:mm");
	                        }
	                    },
	                    done: function done() {
	                        return resolve(_this7.ChargePointsService.programChargepointReboot($scope["modal"]["chargepoint"]["id"], $scope["modal"]["programedReboot"], options).then(function () {
	                            _this7.App.showNotification(_this7.$translate.instant("ACTION.ADD_PROGRAMED_REBOOT.ADD_SUCCESS"), "ok", null, 700);
	                            _this7.App.closeModal();
	                        }).catch(function () {
	                            _this7.App.showNotification(_this7.$translate.instant("ACTION.ADD_PROGRAMED_REBOOT.ADD_FAILED"), "error");
	                            _this7.App.closeModal();
	                        }));
	                    }
	                };
	                $scope["modal"]["slider"]["onChange"]();
	                _this7.App.openModal($scope, "add-programed_reboot.html", { "size": "lg" });
	            });
	        }
	    }, {
	        key: 'addRechargingSchedule',
	        value: function addRechargingSchedule($scope, data, options) {
	            return this._editRechargingSchedule($scope, data, options);
	        }
	    }, {
	        key: 'editRechargingSchedule',
	        value: function editRechargingSchedule($scope, data, options) {
	            return this._editRechargingSchedule($scope, data, options);
	        }
	    }, {
	        key: 'removeRechargingSchedule',
	        value: function removeRechargingSchedule($scope, data, options) {
	            var _this8 = this;

	            return new Promise(function (resolve) {
	                $scope["modal"] = {
	                    list: data.list,
	                    data: data.current,
	                    removed_period: _this8._getRechargingScheduleText(data.current.startDayOfWeek, data.current.startTime, data.current.endDayOfWeek, data.current.endTime),
	                    done: function done() {
	                        var aux = $scope["modal"]["list"].filter(function (value, index) {
	                            return index != data.index;
	                        });
	                        resolve(_this8._removeRechargingSchedule($scope["ctrl"]["chargepoint"]["id"], aux, options));
	                    }
	                };
	                _this8.App.openModal($scope, "remove-recharging-schedule.html");
	            });
	        }
	    }, {
	        key: '_removeRechargingSchedule',
	        value: function _removeRechargingSchedule(chargepointId, data, options) {
	            options.notifications = true;
	            return this.ChargePointsService.setRechargingSchedule(chargepointId, data, options).then(this.App.closeModal());
	        }
	    }, {
	        key: '_editRechargingSchedule',
	        value: function _editRechargingSchedule($scope, data, options) {
	            var _this9 = this;

	            return new Promise(function (resolve) {
	                $scope["modal"] = {
	                    isEdit: data.current ? true : false,
	                    list: data.list,
	                    data: data.current ? _lodash2.default.cloneDeep(data.current) : _lodash2.default.cloneDeep(_this9.defaultRechargingSchedule),
	                    conflict: null,
	                    days: [{ id: 0, display: _this9.$translate.instant('SUNDAY') }, { id: 1, display: _this9.$translate.instant('MONDAY') }, { id: 2, display: _this9.$translate.instant('TUESDAY') }, { id: 3, display: _this9.$translate.instant('WEDNESDAY') }, { id: 4, display: _this9.$translate.instant('THURSDAY') }, { id: 5, display: _this9.$translate.instant('FRIDAY') }, { id: 6, display: _this9.$translate.instant('SATURDAY') }],
	                    units: [{ id: 'A', display: _this9.$translate.instant('AMPS') }, { id: 'W', display: _this9.$translate.instant('WATTS') }],
	                    chargepoint: $scope["ctrl"]["chargepoint"],
	                    slider: {
	                        value: { min: 0, max: 8 },
	                        options: {
	                            floor: 0,
	                            ceil: 96,
	                            translate: function translate(value) {
	                                if (value <= 0) return '00:00';
	                                if (value >= 96) return '24:00';
	                                return _this9.moment().startOf('day').add(_this9.moment.duration(value * 15, 'm')).format('HH:mm');
	                            },
	                            showTicksValues: true,
	                            ticksArray: [0, 8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96]
	                        },
	                        onChange: function onChange() {
	                            $scope["modal"]["data"]["startTime"] = _this9.moment().startOf('day').add(_this9.moment.duration($scope["modal"]["slider"]["value"]["min"] * 15, 'm')).format("HH:mm");
	                            $scope["modal"]["data"]["endTime"] = _this9.moment().startOf('day').add(_this9.moment.duration($scope["modal"]["slider"]["value"]["max"] * 15, 'm')).format("HH:mm");
	                            $scope.modal.validateRechargeSchedule();
	                        }
	                    },
	                    wizard: {
	                        step: 0,
	                        steps: [],
	                        setSteps: function setSteps(modal) {
	                            modal["wizard"]["steps"] = [{ "id": "config", "title": _this9.$translate.instant("CONFIGURATION"), "intro": _this9.$translate.instant("SET_RECHARGING_SCHEDULE_OPTIONS") }, { "id": "summary", "title": _this9.$translate.instant("SUMMARY"), "intro": _this9.$translate.instant("CHECK_SUMMARY_DATA") }];
	                        }
	                    },
	                    validateRechargeSchedule: function validateRechargeSchedule() {
	                        var list = _lodash2.default.cloneDeep($scope.modal.list);
	                        var newData = _lodash2.default.cloneDeep($scope.modal.data);
	                        newData.current = true;
	                        if (newData.limit.toString().length > 3) {
	                            conflict = { text: _this9.$translate.instant('CONFLICT_LIMIT_FIELD') };
	                        } else {
	                            if ($scope.modal.isEdit) {
	                                list[data["index"]] = newData;
	                            } else {
	                                list.push(newData);
	                            }
	                            for (var i = 0; i < list.length; i++) {
	                                var startTimeSplitted = _this9.moment.tz(list[i].startTime, 'HH:mm', "UTC").utc().format('HH:mm').split(':');
	                                var endTimeSplitted = _this9.moment.tz(list[i].endTime, 'HH:mm', "UTC").utc().format('HH:mm').split(':');
	                                list[i].startTimeSeconds = list[i].startDayOfWeek * 24 * 60 * 60 + Number(startTimeSplitted[0]) * 60 * 60 + Number(startTimeSplitted[1]) * 60;
	                                list[i].endTimeSeconds = list[i].endDayOfWeek * 24 * 60 * 60 + Number(endTimeSplitted[0]) * 60 * 60 + Number(endTimeSplitted[1]) * 60;
	                            }
	                            list = _lodash2.default.orderBy(list, ['startTimeSeconds']);
	                            var conflict = null;
	                            for (i = 0; i < list.length; i++) {
	                                if (list[i].endTimeSeconds < list[i].startTimeSeconds) {
	                                    conflict = { text: _this9.$translate.instant('CONFLICT_END_DATE_LESS_START_DATE') };
	                                    break;
	                                }
	                                if (i > 0) {
	                                    if (list[i].startTimeSeconds < list[i - 1].endTimeSeconds) {
	                                        var aux = list[i].current ? i - 1 : i;
	                                        conflict = { name: _this9._getRechargingScheduleText(list[aux].startDayOfWeek, list[aux].startTime, list[aux].endDayOfWeek, list[aux].endTime) };
	                                        break;
	                                    }
	                                    if (list[i].unit != list[i - 1].unit) {
	                                        conflict = { text: _this9.$translate.instant('CONFLICT_UNIT_RECHARGE_SCHEDULE') };
	                                        break;
	                                    }
	                                }
	                            }
	                        }
	                        $scope.modal.conflict = conflict;
	                    },
	                    isValid: function isValid(modal) {
	                        if (modal.wizard.steps[modal.wizard.step].id === 'config') {
	                            return !modal.conflict && modal.data.startTime != "" && modal.data.endTime != "" && angular.isNumber(modal.data.limit) && modal.data.limit >= 0;
	                        }
	                        return true;
	                    },
	                    next: function next(modal) {
	                        var step = modal["wizard"]["step"];
	                        modal["conflict"] = null;
	                        modal["wizard"]["step"] = step + 1;
	                    },
	                    back: function back(modal) {
	                        var step = modal["wizard"]["step"];
	                        modal["conflict"] = null;
	                        modal["wizard"]["step"] = step - 1;
	                    },
	                    done: function done() {
	                        options.notifications = true;
	                        if ($scope["modal"]["isEdit"]) {
	                            $scope["modal"]["list"][data["index"]] = $scope["modal"]["data"];
	                        } else {
	                            $scope["modal"]["list"].push($scope["modal"]["data"]);
	                        }
	                        return resolve(_this9.ChargePointsService.setRechargingSchedule($scope["modal"]["chargepoint"]["id"], $scope["modal"]["list"], options).then(function () {
	                            _this9.App.closeModal();
	                        }));
	                    }
	                };
	                var auxStartTime = _this9.moment.tz($scope.modal.data.startTime, 'HH:mm', "UTC");
	                var auxEndTime = _this9.moment.tz($scope.modal.data.endTime, 'HH:mm', "UTC");
	                $scope.modal.slider.value.min = (auxStartTime.hour() * 60 + auxStartTime.minute()) / 15;
	                $scope.modal.slider.value.max = (auxEndTime.hour() * 60 + auxEndTime.minute()) / 15;
	                $scope["modal"]["slider"]["onChange"]();
	                $scope["modal"]["wizard"].setSteps($scope["modal"]);
	                _this9.App.openModal($scope, "add-recharging-schedule.html", { "size": "lg" });
	            });
	        }
	    }, {
	        key: '_getRechargingScheduleText',
	        value: function _getRechargingScheduleText(startDayOfWeek, startTime, endDayOfWeek, endTime) {
	            return this.$filter('toDay')(startDayOfWeek) + "(" + startTime + ") - " + this.$filter('toDay')(endDayOfWeek) + "(" + endTime + ")";
	        }
	    }, {
	        key: 'addChargePoint',
	        value: function addChargePoint($scope, data, options) {
	            var _this10 = this;

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    chargepoint: _lodash2.default.cloneDeep(_this10.defaultChargePoint),
	                    organizationId: options.organizationId,
	                    location: null,
	                    locationView: {
	                        locationTableData: {
	                            enabledBreadcrumbs: false,
	                            organizationId: options.organizationId,
	                            table: {
	                                keys: ['name | locationName:item'],
	                                selected: [],
	                                selectable: 'one'
	                            },
	                            filters: _this10.App.getTableFilters('locations', { context: _this10, modify: { purpose: { hide: true, value: 'General' }, onlyAtomic: { hide: true, value: 'true' } } })
	                        },
	                        locationTableApi: {},
	                        unsubscribeSelectedEvent: null,
	                        unsubscribe: null,
	                        subscribe: function subscribe() {
	                            return $scope.$watch(function () {
	                                return $scope.modal.locationView.locationTableApi.on;
	                            }, function (onFn) {
	                                if (!onFn) return;
	                                $scope.modal.locationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                                    if (_lodash2.default.isArray(selected)) {
	                                        $scope.modal.location = selected[0];
	                                    }
	                                });
	                            });
	                        }
	                    },
	                    ownershipTypes: [{ id: 'public', display: _this10.$translate.instant('NEW_CP_OWNERSHIP_TYPE_PUBLIC') }],
	                    vehicleTypes: [{ id: 'AllVehicles', display: _this10.$translate.instant('NEW_CP_VEHICLE_TYPES_ALL_VEHICLE') }, { id: 'motorcycle', display: _this10.$translate.instant('NEW_CP_VEHICLE_TYPES_MOTORCYCLE') }],
	                    wizard: {
	                        step: 0,
	                        steps: [],
	                        setSteps: function setSteps(modal) {
	                            var steps = [{ id: 'ownership', title: _this10.$translate.instant('NEW_CP_OWNERSHIP'), intro: _this10.$translate.instant('NEW_CP_ENTER_OWNERSHIP') }, { id: 'serialOCPP', title: _this10.$translate.instant('NEW_CP_SERIAL_OCPP'), intro: _this10.$translate.instant('NEW_CP_ENTER_SERIAL_OCPP') }, { id: 'name', title: _this10.$translate.instant('NEW_CP_INFO'), intro: _this10.$translate.instant('NEW_CP_ENTER_INFO') }, { id: 'location', title: _this10.$translate.instant('NEW_CP_GROUP'), intro: _this10.$translate.instant('NEW_CP_ENTER_GROUP') }, { id: 'summary', title: _this10.$translate.instant('NEW_CP_SUMMARY'), intro: _this10.$translate.instant('NEW_CP_ENTER_SUMMARY') }];
	                            steps = _lodash2.default.filter(steps, function (step) {
	                                if (step.id === 'ownership' && modal.organizationId) return false;
	                                if (step.id === 'location' && data.group) return false;
	                                return !(step.id === 'location' && !modal.organizationId);
	                            });
	                            modal.wizard.steps = steps;
	                        }
	                    },
	                    isValid: function isValid(modal) {
	                        if (modal.wizard.steps[modal.wizard.step].id === 'serialOCPP') {
	                            return modal.chargepoint.serialOCPP && modal.chargepoint.serialOCPP.length > 0;
	                        }
	                        if (modal.wizard.steps[modal.wizard.step].id === 'name') {
	                            return modal.chargepoint.name && modal.chargepoint.name.length > 0 && modal.chargepoint.vehicleType && modal.chargepoint.vehicleType.id.length > 0;
	                        }
	                        if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	                            return !!modal.location;
	                        }
	                        return true;
	                    },
	                    next: function next(modal) {
	                        var step = modal.wizard.step;
	                        if (modal.wizard.steps[step].id === 'serialOCPP') {
	                            modal.chargepoint.name = _this10.$translate.instant('NEW_CP_SUGGESTED_NAME', { serial: modal.chargepoint.serialOCPP });
	                            modal.chargepoint.vehicleType = modal.vehicleTypes[0];
	                        }
	                        if (modal.wizard.steps[step].id === 'name' && modal.organizationId) {
	                            modal.wizard.steps[2].intro = _this10.$translate.instant('NEW_CP_ENTER_GROUP');
	                            if (data.group) {
	                                modal.chargepoint.group = data.group;
	                            }
	                        }
	                        if (modal.wizard.steps[step].id === 'location') {
	                            modal.chargepoint.group = modal.location;
	                        }
	                        modal.conflict = null;
	                        modal.wizard.step = step + 1;
	                    },
	                    back: function back(modal) {
	                        var step = modal.wizard.step;
	                        modal.conflict = null;
	                        modal.wizard.step = step - 1;
	                    },
	                    close: function close() {
	                        if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	                            $scope.modal.locationView.unsubscribeSelectedEvent();
	                            $scope.modal.locationView.unsubscribe();
	                        }
	                        $scope.App.closeModal();
	                    },
	                    done: function done() {
	                        if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	                            $scope.modal.locationView.unsubscribeSelectedEvent();
	                            $scope.modal.locationView.unsubscribe();
	                        }
	                        $scope.modal.state = 'working';
	                        return resolve(_this10._addChargepointToGroup($scope.modal));
	                    }
	                };
	                $scope.modal.wizard.setSteps($scope.modal);
	                $scope.modal.locationView.unsubscribe = $scope.modal.locationView.subscribe();
	                _this10.App.openModal($scope, 'add-chargepoint.html', { 'size': 'lg' });
	            });
	        }
	    }, {
	        key: '_addChargepointToGroup',
	        value: function _addChargepointToGroup(modal) {
	            var _this11 = this;

	            this.App.hideNotification();
	            if (modal.createGroup) {
	                modal.chargepoint.group['location'] = modal.location;
	                this.GroupsService.addGroup(modal.chargepoint.group, { organization: modal.organizationId }).then(function (newGroup) {
	                    if (!angular.equals(newGroup, {})) {
	                        modal.chargepoint.group = newGroup;
	                        return _this11._addChargepoint(modal);
	                    } else {
	                        return Promise.reject(_this11.$translate.instant('NEW_CP_ADDED_FAILED_BECAUSE_GROUP_FAILED', { serial: '<accent>' + modal.chargepoint.serialOCPP + '</accent>', group: '<accent>' + modal.chargepoint.group.name + '</accent>' }));
	                    }
	                });
	            } else {
	                return this._addChargepoint(modal);
	            }
	        }
	    }, {
	        key: '_addChargepoint',
	        value: function _addChargepoint(modal) {
	            var _this12 = this;

	            return this.ChargePointsService.addChargepoint(modal.chargepoint.serialOCPP, modal.chargepoint.group ? modal.chargepoint.group.id : null, {
	                name: modal.chargepoint.name,
	                vehicleType: modal.chargepoint.vehicleType.id,
	                ownership: modal.chargepoint.ownership,
	                organization: modal.organizationId
	            }).catch(function () {
	                return Promise.reject(_this12.$translate.instant('NEW_CP_ADDED_FAILED', { serial: '<accent>' + modal.chargepoint.serialOCPP + '</accent>' }));
	            });
	        }
	    }, {
	        key: 'editConnectorSettings',
	        value: function editConnectorSettings($scope, data, options) {
	            var _this13 = this;

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    chargepoint: options.chargepoint,
	                    organization: options.organization,
	                    connector: data,
	                    settings: {},
	                    types: [{
	                        id: null,
	                        display: _this13.$translate.instant('CH.CONNECTORS.SETTINGS.UNDEFINED')
	                    },
	                    // {id:'TYPE2', display:'Type 2 sin cable (Mennekes)'},
	                    // {id:'TYPE2_CABLE', display:'Type 2 con cable (Mennekes)'},
	                    // {id:'TYPE1_CABLE', display:'Type 1 con cable'},
	                    // {id:'CHADEMO', display:'CHAdeMO'},
	                    // {id:'CCS', display:'CCS (Combined Charging System)'},
	                    // {id:'SCHUKO', display:'Schuko'},
	                    { id: 'TYPE2', display: 'TYPE2' }, { id: 'TYPE2_CABLE', display: 'TYPE2_CABLE' }, { id: 'TYPE1_CABLE', display: 'TYPE1_CABLE' }, { id: 'CHADEMO', display: 'CHADEMO' }, { id: 'CCS', display: 'CCS' }, { id: 'SCHUKO', display: 'SCHUKO' }],
	                    modes: [{
	                        id: null,
	                        display: _this13.$translate.instant('CH.CONNECTORS.SETTINGS.UNDEFINED')
	                    }, { id: 'MODE1', display: 'MODE1' }, { id: 'MODE2', display: 'MODE2' }, { id: 'MODE3', display: 'MODE3' }, { id: 'MODE4', display: 'MODE4' }],
	                    done: function done() {
	                        return resolve(_this13._editConnectorSettings($scope.modal));
	                    }
	                };
	                $scope.modal.settings.type = $scope.modal.connector.type || null;
	                $scope.modal.settings.mode = $scope.modal.connector.mode || null;
	                $scope.modal.settings.power = Number($scope.modal.connector.power);
	                $scope.modal.settings.current = Number($scope.modal.connector.current);
	                $scope.modal.settings.voltage = Number($scope.modal.connector.voltage);
	                $scope.modal.settings.physicalReference = $scope.modal.connector.physicalReference;
	                $scope.modal.settings.evseId = $scope.modal.connector.evseId;
	                _this13.App.openModal($scope, 'edit-chargepoint-connector-settings.html');
	            });
	        }
	    }, {
	        key: '_editConnectorSettings',
	        value: function _editConnectorSettings(modal) {
	            var _this14 = this;

	            return this.ChargePointsService.editChargepointConnector(modal.chargepoint.id, modal.connector.id, modal.settings, {
	                organization: modal.organization,
	                notifications: true
	            }).then(function () {
	                return _this14.App.closeModal();
	            });
	        }
	    }, {
	        key: 'askToStartRemoteTransaction',
	        value: function askToStartRemoteTransaction($scope, data, options) {
	            var _this15 = this;

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    chargepoint: options.chargepoint,
	                    organization: options.organization,
	                    connector: data,
	                    userKeys: [],
	                    userKey: null,
	                    filters: [],
	                    displayForUserKeys: function displayForUserKeys(data) {
	                        return _this15._displayForUserKeys(data);
	                    },
	                    onSearch: function onSearch(term, pagination) {
	                        _this15._onSearchForUserkeys($scope, term, pagination);
	                    },
	                    done: function done() {
	                        var options = {
	                            organization: $scope.modal.organization,
	                            notifications: {
	                                success: function success(response) {
	                                    var result = _this15.OCPP.onCallResult('RemoteStartTransaction', response);
	                                    return { value: result.notification.message, model: {}, style: result.notification.style };
	                                }
	                            }
	                        };
	                        resolve(_this15.ChargePointsService.startChargepointConnectorRemoteTransaction($scope.modal.chargepoint.id, $scope.modal.connector.id, $scope.modal.userKey.idToken, options).then(function () {
	                            _this15.App.closeModal();
	                        }));
	                    }
	                };
	                var aux = _this15.App.getTableFilters("userKey").find(function (item) {
	                    return item.id === 'search';
	                });
	                aux.scope = aux.combo.find(function (item) {
	                    return item.id === 'idToken.ilike';
	                });
	                $scope.modal.filters.push(aux);
	                _this15.App.openModal($scope, 'start-remote-transaction.html');
	            });
	        }
	    }, {
	        key: '_displayForUserKeys',
	        value: function _displayForUserKeys(data) {
	            var display = '';
	            if (data.idToken) {
	                display += data.idToken;
	            }
	            if (data.customerName) {
	                display += ' - ' + data.customerName;
	            } else {
	                display += ' - ' + this.$translate.instant('FILTER.USERKEY.NO_CUSTOMER');
	            }
	            return display;
	        }
	    }, {
	        key: '_onSearchForUserkeys',
	        value: function _onSearchForUserkeys($scope, term, pagination) {
	            $scope.modal.filters[0].value = term;
	            var aux = {
	                filters: $scope.modal.filters,
	                pagination: pagination,
	                sorting: this.App.getSorting(['idToken'], 'idToken', 'asc'),
	                organization: $scope.modal.organization,
	                group: $scope.modal.chargepoint.groupId
	            };
	            this.UsersService.getUserKeys(aux).then(function (data) {
	                $scope.modal.userKeys = $scope.modal.userKeys.concat(data.docs);
	                pagination.totalItems = data.totalItems;
	            });
	        }
	    }, {
	        key: 'changeLocation',
	        value: function changeLocation($scope, data, options) {
	            var _this16 = this;

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    chargepoint: data.chargepoint,
	                    organizationId: options.organizationId,
	                    location: null,
	                    locationView: {
	                        locationTableData: {
	                            enabledBreadcrumbs: false,
	                            organizationId: options.organizationId,
	                            table: {
	                                keys: ['name | locationName:item'],
	                                selected: [{ id: data.chargepoint.groupId, name: data.chargepoint.groupName }],
	                                selectable: 'one'
	                            },
	                            filters: _this16.App.getTableFilters('locations', { context: _this16, modify: { purpose: { hide: true, value: 'General' }, onlyAtomic: { hide: true, value: 'true' } } })
	                        },
	                        locationTableApi: {},
	                        unsubscribeSelectedEvent: null,
	                        unsubscribe: null,
	                        subscribe: function subscribe() {
	                            return $scope.$watch(function () {
	                                return $scope.modal.locationView.locationTableApi.on;
	                            }, function (onFn) {
	                                if (!onFn) return;
	                                $scope.modal.locationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                                    if (_lodash2.default.isArray(selected)) {
	                                        $scope.modal.location = selected[0];
	                                    }
	                                });
	                            });
	                        }
	                    },
	                    isValid: function isValid(modal) {
	                        return !!modal.location && modal.location.id !== data.chargepoint.groupId;
	                    },
	                    close: function close() {
	                        if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	                            $scope.modal.locationView.unsubscribeSelectedEvent();
	                            $scope.modal.locationView.unsubscribe();
	                        }
	                        $scope.App.closeModal();
	                    },
	                    done: function done() {
	                        if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	                            $scope.modal.locationView.unsubscribeSelectedEvent();
	                            $scope.modal.locationView.unsubscribe();
	                        }
	                        var locationId = $scope.modal.location.id;
	                        return resolve(_this16.ChargePointsService.addChargepointToGroup($scope.modal.chargepoint.id, locationId, { organization: $scope.modal.organizationId }));
	                    }
	                };
	                $scope.modal.locationView.unsubscribe = $scope.modal.locationView.subscribe();
	                _this16.App.openModal($scope, 'change-chargepoint-group.html', { size: 'lg' });
	            });
	        }
	    }]);

	    return ChargePointHelperService;
	}();

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, process) {(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (factory((global.async = {})));
	}(this, (function (exports) { 'use strict';

	    /**
	     * Creates a continuation function with some arguments already applied.
	     *
	     * Useful as a shorthand when combined with other control flow functions. Any
	     * arguments passed to the returned function are added to the arguments
	     * originally passed to apply.
	     *
	     * @name apply
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {Function} fn - The function you want to eventually apply all
	     * arguments to. Invokes with (arguments...).
	     * @param {...*} arguments... - Any number of arguments to automatically apply
	     * when the continuation is called.
	     * @returns {Function} the partially-applied function
	     * @example
	     *
	     * // using apply
	     * async.parallel([
	     *     async.apply(fs.writeFile, 'testfile1', 'test1'),
	     *     async.apply(fs.writeFile, 'testfile2', 'test2')
	     * ]);
	     *
	     *
	     * // the same process without using apply
	     * async.parallel([
	     *     function(callback) {
	     *         fs.writeFile('testfile1', 'test1', callback);
	     *     },
	     *     function(callback) {
	     *         fs.writeFile('testfile2', 'test2', callback);
	     *     }
	     * ]);
	     *
	     * // It's possible to pass any number of additional arguments when calling the
	     * // continuation:
	     *
	     * node> var fn = async.apply(sys.puts, 'one');
	     * node> fn('two', 'three');
	     * one
	     * two
	     * three
	     */
	    function apply(fn, ...args) {
	        return (...callArgs) => fn(...args,...callArgs);
	    }

	    function initialParams (fn) {
	        return function (...args/*, callback*/) {
	            var callback = args.pop();
	            return fn.call(this, args, callback);
	        };
	    }

	    /* istanbul ignore file */

	    var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
	    var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';

	    function fallback(fn) {
	        setTimeout(fn, 0);
	    }

	    function wrap(defer) {
	        return (fn, ...args) => defer(() => fn(...args));
	    }

	    var _defer;

	    if (hasSetImmediate) {
	        _defer = setImmediate;
	    } else if (hasNextTick) {
	        _defer = process.nextTick;
	    } else {
	        _defer = fallback;
	    }

	    var setImmediate$1 = wrap(_defer);

	    /**
	     * Take a sync function and make it async, passing its return value to a
	     * callback. This is useful for plugging sync functions into a waterfall,
	     * series, or other async functions. Any arguments passed to the generated
	     * function will be passed to the wrapped function (except for the final
	     * callback argument). Errors thrown will be passed to the callback.
	     *
	     * If the function passed to `asyncify` returns a Promise, that promises's
	     * resolved/rejected state will be used to call the callback, rather than simply
	     * the synchronous return value.
	     *
	     * This also means you can asyncify ES2017 `async` functions.
	     *
	     * @name asyncify
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @alias wrapSync
	     * @category Util
	     * @param {Function} func - The synchronous function, or Promise-returning
	     * function to convert to an {@link AsyncFunction}.
	     * @returns {AsyncFunction} An asynchronous wrapper of the `func`. To be
	     * invoked with `(args..., callback)`.
	     * @example
	     *
	     * // passing a regular synchronous function
	     * async.waterfall([
	     *     async.apply(fs.readFile, filename, "utf8"),
	     *     async.asyncify(JSON.parse),
	     *     function (data, next) {
	     *         // data is the result of parsing the text.
	     *         // If there was a parsing error, it would have been caught.
	     *     }
	     * ], callback);
	     *
	     * // passing a function returning a promise
	     * async.waterfall([
	     *     async.apply(fs.readFile, filename, "utf8"),
	     *     async.asyncify(function (contents) {
	     *         return db.model.create(contents);
	     *     }),
	     *     function (model, next) {
	     *         // `model` is the instantiated model object.
	     *         // If there was an error, this function would be skipped.
	     *     }
	     * ], callback);
	     *
	     * // es2017 example, though `asyncify` is not needed if your JS environment
	     * // supports async functions out of the box
	     * var q = async.queue(async.asyncify(async function(file) {
	     *     var intermediateStep = await processFile(file);
	     *     return await somePromise(intermediateStep)
	     * }));
	     *
	     * q.push(files);
	     */
	    function asyncify(func) {
	        if (isAsync(func)) {
	            return function (...args/*, callback*/) {
	                const callback = args.pop();
	                const promise = func.apply(this, args);
	                return handlePromise(promise, callback)
	            }
	        }

	        return initialParams(function (args, callback) {
	            var result;
	            try {
	                result = func.apply(this, args);
	            } catch (e) {
	                return callback(e);
	            }
	            // if result is Promise object
	            if (result && typeof result.then === 'function') {
	                return handlePromise(result, callback)
	            } else {
	                callback(null, result);
	            }
	        });
	    }

	    function handlePromise(promise, callback) {
	        return promise.then(value => {
	            invokeCallback(callback, null, value);
	        }, err => {
	            invokeCallback(callback, err && err.message ? err : new Error(err));
	        });
	    }

	    function invokeCallback(callback, error, value) {
	        try {
	            callback(error, value);
	        } catch (err) {
	            setImmediate$1(e => { throw e }, err);
	        }
	    }

	    function isAsync(fn) {
	        return fn[Symbol.toStringTag] === 'AsyncFunction';
	    }

	    function isAsyncGenerator(fn) {
	        return fn[Symbol.toStringTag] === 'AsyncGenerator';
	    }

	    function isAsyncIterable(obj) {
	        return typeof obj[Symbol.asyncIterator] === 'function';
	    }

	    function wrapAsync(asyncFn) {
	        if (typeof asyncFn !== 'function') throw new Error('expected a function')
	        return isAsync(asyncFn) ? asyncify(asyncFn) : asyncFn;
	    }

	    // conditionally promisify a function.
	    // only return a promise if a callback is omitted
	    function awaitify (asyncFn, arity = asyncFn.length) {
	        if (!arity) throw new Error('arity is undefined')
	        function awaitable (...args) {
	            if (typeof args[arity - 1] === 'function') {
	                return asyncFn.apply(this, args)
	            }

	            return new Promise((resolve, reject) => {
	                args[arity - 1] = (err, ...cbArgs) => {
	                    if (err) return reject(err)
	                    resolve(cbArgs.length > 1 ? cbArgs : cbArgs[0]);
	                };
	                asyncFn.apply(this, args);
	            })
	        }

	        Object.defineProperty(awaitable, 'name', {
	            value: `awaitable(${asyncFn.name})`
	        });

	        return awaitable
	    }

	    function applyEach (eachfn) {
	        return function applyEach(fns, ...callArgs) {
	            const go = awaitify(function (callback) {
	                var that = this;
	                return eachfn(fns, (fn, cb) => {
	                    wrapAsync(fn).apply(that, callArgs.concat(cb));
	                }, callback);
	            });
	            return go;
	        };
	    }

	    function _asyncMap(eachfn, arr, iteratee, callback) {
	        arr = arr || [];
	        var results = [];
	        var counter = 0;
	        var _iteratee = wrapAsync(iteratee);

	        return eachfn(arr, (value, _, iterCb) => {
	            var index = counter++;
	            _iteratee(value, (err, v) => {
	                results[index] = v;
	                iterCb(err);
	            });
	        }, err => {
	            callback(err, results);
	        });
	    }

	    function isArrayLike(value) {
	        return value &&
	            typeof value.length === 'number' &&
	            value.length >= 0 &&
	            value.length % 1 === 0;
	    }

	    // A temporary value used to identify if the loop should be broken.
	    // See #1064, #1293
	    const breakLoop = {};

	    function once(fn) {
	        function wrapper (...args) {
	            if (fn === null) return;
	            var callFn = fn;
	            fn = null;
	            callFn.apply(this, args);
	        }
	        Object.assign(wrapper, fn);
	        return wrapper
	    }

	    function getIterator (coll) {
	        return coll[Symbol.iterator] && coll[Symbol.iterator]();
	    }

	    function createArrayIterator(coll) {
	        var i = -1;
	        var len = coll.length;
	        return function next() {
	            return ++i < len ? {value: coll[i], key: i} : null;
	        }
	    }

	    function createES2015Iterator(iterator) {
	        var i = -1;
	        return function next() {
	            var item = iterator.next();
	            if (item.done)
	                return null;
	            i++;
	            return {value: item.value, key: i};
	        }
	    }

	    function createObjectIterator(obj) {
	        var okeys = obj ? Object.keys(obj) : [];
	        var i = -1;
	        var len = okeys.length;
	        return function next() {
	            var key = okeys[++i];
	            return i < len ? {value: obj[key], key} : null;
	        };
	    }

	    function createIterator(coll) {
	        if (isArrayLike(coll)) {
	            return createArrayIterator(coll);
	        }

	        var iterator = getIterator(coll);
	        return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
	    }

	    function onlyOnce(fn) {
	        return function (...args) {
	            if (fn === null) throw new Error("Callback was already called.");
	            var callFn = fn;
	            fn = null;
	            callFn.apply(this, args);
	        };
	    }

	    // for async generators
	    function asyncEachOfLimit(generator, limit, iteratee, callback) {
	        let done = false;
	        let canceled = false;
	        let awaiting = false;
	        let running = 0;
	        let idx = 0;

	        function replenish() {
	            //console.log('replenish')
	            if (running >= limit || awaiting || done) return
	            //console.log('replenish awaiting')
	            awaiting = true;
	            generator.next().then(({value, done: iterDone}) => {
	                //console.log('got value', value)
	                if (canceled || done) return
	                awaiting = false;
	                if (iterDone) {
	                    done = true;
	                    if (running <= 0) {
	                        //console.log('done nextCb')
	                        callback(null);
	                    }
	                    return;
	                }
	                running++;
	                iteratee(value, idx, iterateeCallback);
	                idx++;
	                replenish();
	            }).catch(handleError);
	        }

	        function iterateeCallback(err, result) {
	            //console.log('iterateeCallback')
	            running -= 1;
	            if (canceled) return
	            if (err) return handleError(err)

	            if (err === false) {
	                done = true;
	                canceled = true;
	                return
	            }

	            if (result === breakLoop || (done && running <= 0)) {
	                done = true;
	                //console.log('done iterCb')
	                return callback(null);
	            }
	            replenish();
	        }

	        function handleError(err) {
	            if (canceled) return
	            awaiting = false;
	            done = true;
	            callback(err);
	        }

	        replenish();
	    }

	    var eachOfLimit = (limit) => {
	        return (obj, iteratee, callback) => {
	            callback = once(callback);
	            if (limit <= 0) {
	                throw new RangeError('concurrency limit cannot be less than 1')
	            }
	            if (!obj) {
	                return callback(null);
	            }
	            if (isAsyncGenerator(obj)) {
	                return asyncEachOfLimit(obj, limit, iteratee, callback)
	            }
	            if (isAsyncIterable(obj)) {
	                return asyncEachOfLimit(obj[Symbol.asyncIterator](), limit, iteratee, callback)
	            }
	            var nextElem = createIterator(obj);
	            var done = false;
	            var canceled = false;
	            var running = 0;
	            var looping = false;

	            function iterateeCallback(err, value) {
	                if (canceled) return
	                running -= 1;
	                if (err) {
	                    done = true;
	                    callback(err);
	                }
	                else if (err === false) {
	                    done = true;
	                    canceled = true;
	                }
	                else if (value === breakLoop || (done && running <= 0)) {
	                    done = true;
	                    return callback(null);
	                }
	                else if (!looping) {
	                    replenish();
	                }
	            }

	            function replenish () {
	                looping = true;
	                while (running < limit && !done) {
	                    var elem = nextElem();
	                    if (elem === null) {
	                        done = true;
	                        if (running <= 0) {
	                            callback(null);
	                        }
	                        return;
	                    }
	                    running += 1;
	                    iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
	                }
	                looping = false;
	            }

	            replenish();
	        };
	    };

	    /**
	     * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name eachOfLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.eachOf]{@link module:Collections.eachOf}
	     * @alias forEachOfLimit
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - An async function to apply to each
	     * item in `coll`. The `key` is the item's key, or index in the case of an
	     * array.
	     * Invoked with (item, key, callback).
	     * @param {Function} [callback] - A callback which is called when all
	     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	     * @returns {Promise} a promise, if a callback is omitted
	     */
	    function eachOfLimit$1(coll, limit, iteratee, callback) {
	        return eachOfLimit(limit)(coll, wrapAsync(iteratee), callback);
	    }

	    var eachOfLimit$2 = awaitify(eachOfLimit$1, 4);

	    // eachOf implementation optimized for array-likes
	    function eachOfArrayLike(coll, iteratee, callback) {
	        callback = once(callback);
	        var index = 0,
	            completed = 0,
	            {length} = coll,
	            canceled = false;
	        if (length === 0) {
	            callback(null);
	        }

	        function iteratorCallback(err, value) {
	            if (err === false) {
	                canceled = true;
	            }
	            if (canceled === true) return
	            if (err) {
	                callback(err);
	            } else if ((++completed === length) || value === breakLoop) {
	                callback(null);
	            }
	        }

	        for (; index < length; index++) {
	            iteratee(coll[index], index, onlyOnce(iteratorCallback));
	        }
	    }

	    // a generic version of eachOf which can handle array, object, and iterator cases.
	    function eachOfGeneric (coll, iteratee, callback) {
	        return eachOfLimit$2(coll, Infinity, iteratee, callback);
	    }

	    /**
	     * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
	     * to the iteratee.
	     *
	     * @name eachOf
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias forEachOf
	     * @category Collection
	     * @see [async.each]{@link module:Collections.each}
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A function to apply to each
	     * item in `coll`.
	     * The `key` is the item's key, or index in the case of an array.
	     * Invoked with (item, key, callback).
	     * @param {Function} [callback] - A callback which is called when all
	     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	     * @returns {Promise} a promise, if a callback is omitted
	     * @example
	     *
	     * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
	     * var configs = {};
	     *
	     * async.forEachOf(obj, function (value, key, callback) {
	     *     fs.readFile(__dirname + value, "utf8", function (err, data) {
	     *         if (err) return callback(err);
	     *         try {
	     *             configs[key] = JSON.parse(data);
	     *         } catch (e) {
	     *             return callback(e);
	     *         }
	     *         callback();
	     *     });
	     * }, function (err) {
	     *     if (err) console.error(err.message);
	     *     // configs is now a map of JSON data
	     *     doSomethingWith(configs);
	     * });
	     */
	    function eachOf(coll, iteratee, callback) {
	        var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
	        return eachOfImplementation(coll, wrapAsync(iteratee), callback);
	    }

	    var eachOf$1 = awaitify(eachOf, 3);

	    /**
	     * Produces a new collection of values by mapping each value in `coll` through
	     * the `iteratee` function. The `iteratee` is called with an item from `coll`
	     * and a callback for when it has finished processing. Each of these callback
	     * takes 2 arguments: an `error`, and the transformed item from `coll`. If
	     * `iteratee` passes an error to its callback, the main `callback` (for the
	     * `map` function) is immediately called with the error.
	     *
	     * Note, that since this function applies the `iteratee` to each item in
	     * parallel, there is no guarantee that the `iteratee` functions will complete
	     * in order. However, the results array will be in the same order as the
	     * original `coll`.
	     *
	     * If `map` is passed an Object, the results will be an Array.  The results
	     * will roughly be in the order of the original Objects' keys (but this can
	     * vary across JavaScript engines).
	     *
	     * @name map
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with the transformed item.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Results is an Array of the
	     * transformed items from the `coll`. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
	     *     // results is now an array of stats for each file
	     * });
	     */
	    function map (coll, iteratee, callback) {
	        return _asyncMap(eachOf$1, coll, iteratee, callback)
	    }
	    var map$1 = awaitify(map, 3);

	    /**
	     * Applies the provided arguments to each function in the array, calling
	     * `callback` after all functions have completed. If you only provide the first
	     * argument, `fns`, then it will return a function which lets you pass in the
	     * arguments as if it were a single function call. If more arguments are
	     * provided, `callback` is required while `args` is still optional. The results
	     * for each of the applied async functions are passed to the final callback
	     * as an array.
	     *
	     * @name applyEach
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s
	     * to all call with the same arguments
	     * @param {...*} [args] - any number of separate arguments to pass to the
	     * function.
	     * @param {Function} [callback] - the final argument should be the callback,
	     * called when all functions have completed processing.
	     * @returns {AsyncFunction} - Returns a function that takes no args other than
	     * an optional callback, that is the result of applying the `args` to each
	     * of the functions.
	     * @example
	     *
	     * const appliedFn = async.applyEach([enableSearch, updateSchema], 'bucket')
	     *
	     * appliedFn((err, results) => {
	     *     // results[0] is the results for `enableSearch`
	     *     // results[1] is the results for `updateSchema`
	     * });
	     *
	     * // partial application example:
	     * async.each(
	     *     buckets,
	     *     async (bucket) => async.applyEach([enableSearch, updateSchema], bucket)(),
	     *     callback
	     * );
	     */
	    var applyEach$1 = applyEach(map$1);

	    /**
	     * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
	     *
	     * @name eachOfSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.eachOf]{@link module:Collections.eachOf}
	     * @alias forEachOfSeries
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * Invoked with (item, key, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Invoked with (err).
	     * @returns {Promise} a promise, if a callback is omitted
	     */
	    function eachOfSeries(coll, iteratee, callback) {
	        return eachOfLimit$2(coll, 1, iteratee, callback)
	    }
	    var eachOfSeries$1 = awaitify(eachOfSeries, 3);

	    /**
	     * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
	     *
	     * @name mapSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.map]{@link module:Collections.map}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with the transformed item.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Results is an array of the
	     * transformed items from the `coll`. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function mapSeries (coll, iteratee, callback) {
	        return _asyncMap(eachOfSeries$1, coll, iteratee, callback)
	    }
	    var mapSeries$1 = awaitify(mapSeries, 3);

	    /**
	     * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
	     *
	     * @name applyEachSeries
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.applyEach]{@link module:ControlFlow.applyEach}
	     * @category Control Flow
	     * @param {Array|Iterable|AsyncIterable|Object} fns - A collection of {@link AsyncFunction}s to all
	     * call with the same arguments
	     * @param {...*} [args] - any number of separate arguments to pass to the
	     * function.
	     * @param {Function} [callback] - the final argument should be the callback,
	     * called when all functions have completed processing.
	     * @returns {AsyncFunction} - A function, that when called, is the result of
	     * appling the `args` to the list of functions.  It takes no args, other than
	     * a callback.
	     */
	    var applyEachSeries = applyEach(mapSeries$1);

	    const PROMISE_SYMBOL = Symbol('promiseCallback');

	    function promiseCallback () {
	        let resolve, reject;
	        function callback (err, ...args) {
	            if (err) return reject(err)
	            resolve(args.length > 1 ? args : args[0]);
	        }

	        callback[PROMISE_SYMBOL] = new Promise((res, rej) => {
	            resolve = res,
	            reject = rej;
	        });

	        return callback
	    }

	    /**
	     * Determines the best order for running the {@link AsyncFunction}s in `tasks`, based on
	     * their requirements. Each function can optionally depend on other functions
	     * being completed first, and each function is run as soon as its requirements
	     * are satisfied.
	     *
	     * If any of the {@link AsyncFunction}s pass an error to their callback, the `auto` sequence
	     * will stop. Further tasks will not execute (so any other functions depending
	     * on it will not run), and the main `callback` is immediately called with the
	     * error.
	     *
	     * {@link AsyncFunction}s also receive an object containing the results of functions which
	     * have completed so far as the first argument, if they have dependencies. If a
	     * task function has no dependencies, it will only be passed a callback.
	     *
	     * @name auto
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Object} tasks - An object. Each of its properties is either a
	     * function or an array of requirements, with the {@link AsyncFunction} itself the last item
	     * in the array. The object's key of a property serves as the name of the task
	     * defined by that property, i.e. can be used when specifying requirements for
	     * other tasks. The function receives one or two arguments:
	     * * a `results` object, containing the results of the previously executed
	     *   functions, only passed if the task has any dependencies,
	     * * a `callback(err, result)` function, which must be called when finished,
	     *   passing an `error` (which can be `null`) and the result of the function's
	     *   execution.
	     * @param {number} [concurrency=Infinity] - An optional `integer` for
	     * determining the maximum number of tasks that can be run in parallel. By
	     * default, as many as possible.
	     * @param {Function} [callback] - An optional callback which is called when all
	     * the tasks have been completed. It receives the `err` argument if any `tasks`
	     * pass an error to their callback. Results are always returned; however, if an
	     * error occurs, no further `tasks` will be performed, and the results object
	     * will only contain partial results. Invoked with (err, results).
	     * @returns {Promise} a promise, if a callback is not passed
	     * @example
	     *
	     * async.auto({
	     *     // this function will just be passed a callback
	     *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
	     *     showData: ['readData', function(results, cb) {
	     *         // results.readData is the file's contents
	     *         // ...
	     *     }]
	     * }, callback);
	     *
	     * async.auto({
	     *     get_data: function(callback) {
	     *         console.log('in get_data');
	     *         // async code to get some data
	     *         callback(null, 'data', 'converted to array');
	     *     },
	     *     make_folder: function(callback) {
	     *         console.log('in make_folder');
	     *         // async code to create a directory to store a file in
	     *         // this is run at the same time as getting the data
	     *         callback(null, 'folder');
	     *     },
	     *     write_file: ['get_data', 'make_folder', function(results, callback) {
	     *         console.log('in write_file', JSON.stringify(results));
	     *         // once there is some data and the directory exists,
	     *         // write the data to a file in the directory
	     *         callback(null, 'filename');
	     *     }],
	     *     email_link: ['write_file', function(results, callback) {
	     *         console.log('in email_link', JSON.stringify(results));
	     *         // once the file is written let's email a link to it...
	     *         // results.write_file contains the filename returned by write_file.
	     *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
	     *     }]
	     * }, function(err, results) {
	     *     console.log('err = ', err);
	     *     console.log('results = ', results);
	     * });
	     */
	    function auto(tasks, concurrency, callback) {
	        if (typeof concurrency !== 'number') {
	            // concurrency is optional, shift the args.
	            callback = concurrency;
	            concurrency = null;
	        }
	        callback = once(callback || promiseCallback());
	        var numTasks = Object.keys(tasks).length;
	        if (!numTasks) {
	            return callback(null);
	        }
	        if (!concurrency) {
	            concurrency = numTasks;
	        }

	        var results = {};
	        var runningTasks = 0;
	        var canceled = false;
	        var hasError = false;

	        var listeners = Object.create(null);

	        var readyTasks = [];

	        // for cycle detection:
	        var readyToCheck = []; // tasks that have been identified as reachable
	        // without the possibility of returning to an ancestor task
	        var uncheckedDependencies = {};

	        Object.keys(tasks).forEach(key => {
	            var task = tasks[key];
	            if (!Array.isArray(task)) {
	                // no dependencies
	                enqueueTask(key, [task]);
	                readyToCheck.push(key);
	                return;
	            }

	            var dependencies = task.slice(0, task.length - 1);
	            var remainingDependencies = dependencies.length;
	            if (remainingDependencies === 0) {
	                enqueueTask(key, task);
	                readyToCheck.push(key);
	                return;
	            }
	            uncheckedDependencies[key] = remainingDependencies;

	            dependencies.forEach(dependencyName => {
	                if (!tasks[dependencyName]) {
	                    throw new Error('async.auto task `' + key +
	                        '` has a non-existent dependency `' +
	                        dependencyName + '` in ' +
	                        dependencies.join(', '));
	                }
	                addListener(dependencyName, () => {
	                    remainingDependencies--;
	                    if (remainingDependencies === 0) {
	                        enqueueTask(key, task);
	                    }
	                });
	            });
	        });

	        checkForDeadlocks();
	        processQueue();

	        function enqueueTask(key, task) {
	            readyTasks.push(() => runTask(key, task));
	        }

	        function processQueue() {
	            if (canceled) return
	            if (readyTasks.length === 0 && runningTasks === 0) {
	                return callback(null, results);
	            }
	            while(readyTasks.length && runningTasks < concurrency) {
	                var run = readyTasks.shift();
	                run();
	            }

	        }

	        function addListener(taskName, fn) {
	            var taskListeners = listeners[taskName];
	            if (!taskListeners) {
	                taskListeners = listeners[taskName] = [];
	            }

	            taskListeners.push(fn);
	        }

	        function taskComplete(taskName) {
	            var taskListeners = listeners[taskName] || [];
	            taskListeners.forEach(fn => fn());
	            processQueue();
	        }


	        function runTask(key, task) {
	            if (hasError) return;

	            var taskCallback = onlyOnce((err, ...result) => {
	                runningTasks--;
	                if (err === false) {
	                    canceled = true;
	                    return
	                }
	                if (result.length < 2) {
	                    [result] = result;
	                }
	                if (err) {
	                    var safeResults = {};
	                    Object.keys(results).forEach(rkey => {
	                        safeResults[rkey] = results[rkey];
	                    });
	                    safeResults[key] = result;
	                    hasError = true;
	                    listeners = Object.create(null);
	                    if (canceled) return
	                    callback(err, safeResults);
	                } else {
	                    results[key] = result;
	                    taskComplete(key);
	                }
	            });

	            runningTasks++;
	            var taskFn = wrapAsync(task[task.length - 1]);
	            if (task.length > 1) {
	                taskFn(results, taskCallback);
	            } else {
	                taskFn(taskCallback);
	            }
	        }

	        function checkForDeadlocks() {
	            // Kahn's algorithm
	            // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
	            // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
	            var currentTask;
	            var counter = 0;
	            while (readyToCheck.length) {
	                currentTask = readyToCheck.pop();
	                counter++;
	                getDependents(currentTask).forEach(dependent => {
	                    if (--uncheckedDependencies[dependent] === 0) {
	                        readyToCheck.push(dependent);
	                    }
	                });
	            }

	            if (counter !== numTasks) {
	                throw new Error(
	                    'async.auto cannot execute tasks due to a recursive dependency'
	                );
	            }
	        }

	        function getDependents(taskName) {
	            var result = [];
	            Object.keys(tasks).forEach(key => {
	                const task = tasks[key];
	                if (Array.isArray(task) && task.indexOf(taskName) >= 0) {
	                    result.push(key);
	                }
	            });
	            return result;
	        }

	        return callback[PROMISE_SYMBOL]
	    }

	    var FN_ARGS = /^(?:async\s+)?(?:function)?\s*\w*\s*\(\s*([^)]+)\s*\)(?:\s*{)/;
	    var ARROW_FN_ARGS = /^(?:async\s+)?\(?\s*([^)=]+)\s*\)?(?:\s*=>)/;
	    var FN_ARG_SPLIT = /,/;
	    var FN_ARG = /(=.+)?(\s*)$/;
	    var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;

	    function parseParams(func) {
	        const src = func.toString().replace(STRIP_COMMENTS, '');
	        let match = src.match(FN_ARGS);
	        if (!match) {
	            match = src.match(ARROW_FN_ARGS);
	        }
	        if (!match) throw new Error('could not parse args in autoInject\nSource:\n' + src)
	        let [, args] = match;
	        return args
	            .replace(/\s/g, '')
	            .split(FN_ARG_SPLIT)
	            .map((arg) => arg.replace(FN_ARG, '').trim());
	    }

	    /**
	     * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
	     * tasks are specified as parameters to the function, after the usual callback
	     * parameter, with the parameter names matching the names of the tasks it
	     * depends on. This can provide even more readable task graphs which can be
	     * easier to maintain.
	     *
	     * If a final callback is specified, the task results are similarly injected,
	     * specified as named parameters after the initial error parameter.
	     *
	     * The autoInject function is purely syntactic sugar and its semantics are
	     * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
	     *
	     * @name autoInject
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.auto]{@link module:ControlFlow.auto}
	     * @category Control Flow
	     * @param {Object} tasks - An object, each of whose properties is an {@link AsyncFunction} of
	     * the form 'func([dependencies...], callback). The object's key of a property
	     * serves as the name of the task defined by that property, i.e. can be used
	     * when specifying requirements for other tasks.
	     * * The `callback` parameter is a `callback(err, result)` which must be called
	     *   when finished, passing an `error` (which can be `null`) and the result of
	     *   the function's execution. The remaining parameters name other tasks on
	     *   which the task is dependent, and the results from those tasks are the
	     *   arguments of those parameters.
	     * @param {Function} [callback] - An optional callback which is called when all
	     * the tasks have been completed. It receives the `err` argument if any `tasks`
	     * pass an error to their callback, and a `results` object with any completed
	     * task results, similar to `auto`.
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * //  The example from `auto` can be rewritten as follows:
	     * async.autoInject({
	     *     get_data: function(callback) {
	     *         // async code to get some data
	     *         callback(null, 'data', 'converted to array');
	     *     },
	     *     make_folder: function(callback) {
	     *         // async code to create a directory to store a file in
	     *         // this is run at the same time as getting the data
	     *         callback(null, 'folder');
	     *     },
	     *     write_file: function(get_data, make_folder, callback) {
	     *         // once there is some data and the directory exists,
	     *         // write the data to a file in the directory
	     *         callback(null, 'filename');
	     *     },
	     *     email_link: function(write_file, callback) {
	     *         // once the file is written let's email a link to it...
	     *         // write_file contains the filename returned by write_file.
	     *         callback(null, {'file':write_file, 'email':'user@example.com'});
	     *     }
	     * }, function(err, results) {
	     *     console.log('err = ', err);
	     *     console.log('email_link = ', results.email_link);
	     * });
	     *
	     * // If you are using a JS minifier that mangles parameter names, `autoInject`
	     * // will not work with plain functions, since the parameter names will be
	     * // collapsed to a single letter identifier.  To work around this, you can
	     * // explicitly specify the names of the parameters your task function needs
	     * // in an array, similar to Angular.js dependency injection.
	     *
	     * // This still has an advantage over plain `auto`, since the results a task
	     * // depends on are still spread into arguments.
	     * async.autoInject({
	     *     //...
	     *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
	     *         callback(null, 'filename');
	     *     }],
	     *     email_link: ['write_file', function(write_file, callback) {
	     *         callback(null, {'file':write_file, 'email':'user@example.com'});
	     *     }]
	     *     //...
	     * }, function(err, results) {
	     *     console.log('err = ', err);
	     *     console.log('email_link = ', results.email_link);
	     * });
	     */
	    function autoInject(tasks, callback) {
	        var newTasks = {};

	        Object.keys(tasks).forEach(key => {
	            var taskFn = tasks[key];
	            var params;
	            var fnIsAsync = isAsync(taskFn);
	            var hasNoDeps =
	                (!fnIsAsync && taskFn.length === 1) ||
	                (fnIsAsync && taskFn.length === 0);

	            if (Array.isArray(taskFn)) {
	                params = [...taskFn];
	                taskFn = params.pop();

	                newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
	            } else if (hasNoDeps) {
	                // no dependencies, use the function as-is
	                newTasks[key] = taskFn;
	            } else {
	                params = parseParams(taskFn);
	                if ((taskFn.length === 0 && !fnIsAsync) && params.length === 0) {
	                    throw new Error("autoInject task functions require explicit parameters.");
	                }

	                // remove callback param
	                if (!fnIsAsync) params.pop();

	                newTasks[key] = params.concat(newTask);
	            }

	            function newTask(results, taskCb) {
	                var newArgs = params.map(name => results[name]);
	                newArgs.push(taskCb);
	                wrapAsync(taskFn)(...newArgs);
	            }
	        });

	        return auto(newTasks, callback);
	    }

	    // Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
	    // used for queues. This implementation assumes that the node provided by the user can be modified
	    // to adjust the next and last properties. We implement only the minimal functionality
	    // for queue support.
	    class DLL {
	        constructor() {
	            this.head = this.tail = null;
	            this.length = 0;
	        }

	        removeLink(node) {
	            if (node.prev) node.prev.next = node.next;
	            else this.head = node.next;
	            if (node.next) node.next.prev = node.prev;
	            else this.tail = node.prev;

	            node.prev = node.next = null;
	            this.length -= 1;
	            return node;
	        }

	        empty () {
	            while(this.head) this.shift();
	            return this;
	        }

	        insertAfter(node, newNode) {
	            newNode.prev = node;
	            newNode.next = node.next;
	            if (node.next) node.next.prev = newNode;
	            else this.tail = newNode;
	            node.next = newNode;
	            this.length += 1;
	        }

	        insertBefore(node, newNode) {
	            newNode.prev = node.prev;
	            newNode.next = node;
	            if (node.prev) node.prev.next = newNode;
	            else this.head = newNode;
	            node.prev = newNode;
	            this.length += 1;
	        }

	        unshift(node) {
	            if (this.head) this.insertBefore(this.head, node);
	            else setInitial(this, node);
	        }

	        push(node) {
	            if (this.tail) this.insertAfter(this.tail, node);
	            else setInitial(this, node);
	        }

	        shift() {
	            return this.head && this.removeLink(this.head);
	        }

	        pop() {
	            return this.tail && this.removeLink(this.tail);
	        }

	        toArray() {
	            return [...this]
	        }

	        *[Symbol.iterator] () {
	            var cur = this.head;
	            while (cur) {
	                yield cur.data;
	                cur = cur.next;
	            }
	        }

	        remove (testFn) {
	            var curr = this.head;
	            while(curr) {
	                var {next} = curr;
	                if (testFn(curr)) {
	                    this.removeLink(curr);
	                }
	                curr = next;
	            }
	            return this;
	        }
	    }

	    function setInitial(dll, node) {
	        dll.length = 1;
	        dll.head = dll.tail = node;
	    }

	    function queue(worker, concurrency, payload) {
	        if (concurrency == null) {
	            concurrency = 1;
	        }
	        else if(concurrency === 0) {
	            throw new RangeError('Concurrency must not be zero');
	        }

	        var _worker = wrapAsync(worker);
	        var numRunning = 0;
	        var workersList = [];
	        const events = {
	            error: [],
	            drain: [],
	            saturated: [],
	            unsaturated: [],
	            empty: []
	        };

	        function on (event, handler) {
	            events[event].push(handler);
	        }

	        function once (event, handler) {
	            const handleAndRemove = (...args) => {
	                off(event, handleAndRemove);
	                handler(...args);
	            };
	            events[event].push(handleAndRemove);
	        }

	        function off (event, handler) {
	            if (!event) return Object.keys(events).forEach(ev => events[ev] = [])
	            if (!handler) return events[event] = []
	            events[event] = events[event].filter(ev => ev !== handler);
	        }

	        function trigger (event, ...args) {
	            events[event].forEach(handler => handler(...args));
	        }

	        var processingScheduled = false;
	        function _insert(data, insertAtFront, rejectOnError, callback) {
	            if (callback != null && typeof callback !== 'function') {
	                throw new Error('task callback must be a function');
	            }
	            q.started = true;

	            var res, rej;
	            function promiseCallback (err, ...args) {
	                // we don't care about the error, let the global error handler
	                // deal with it
	                if (err) return rejectOnError ? rej(err) : res()
	                if (args.length <= 1) return res(args[0])
	                res(args);
	            }

	            var item = {
	                data,
	                callback: rejectOnError ?
	                    promiseCallback :
	                    (callback || promiseCallback)
	            };

	            if (insertAtFront) {
	                q._tasks.unshift(item);
	            } else {
	                q._tasks.push(item);
	            }

	            if (!processingScheduled) {
	                processingScheduled = true;
	                setImmediate$1(() => {
	                    processingScheduled = false;
	                    q.process();
	                });
	            }

	            if (rejectOnError || !callback) {
	                return new Promise((resolve, reject) => {
	                    res = resolve;
	                    rej = reject;
	                })
	            }
	        }

	        function _createCB(tasks) {
	            return function (err, ...args) {
	                numRunning -= 1;

	                for (var i = 0, l = tasks.length; i < l; i++) {
	                    var task = tasks[i];

	                    var index = workersList.indexOf(task);
	                    if (index === 0) {
	                        workersList.shift();
	                    } else if (index > 0) {
	                        workersList.splice(index, 1);
	                    }

	                    task.callback(err, ...args);

	                    if (err != null) {
	                        trigger('error', err, task.data);
	                    }
	                }

	                if (numRunning <= (q.concurrency - q.buffer) ) {
	                    trigger('unsaturated');
	                }

	                if (q.idle()) {
	                    trigger('drain');
	                }
	                q.process();
	            };
	        }

	        function _maybeDrain(data) {
	            if (data.length === 0 && q.idle()) {
	                // call drain immediately if there are no tasks
	                setImmediate$1(() => trigger('drain'));
	                return true
	            }
	            return false
	        }

	        const eventMethod = (name) => (handler) => {
	            if (!handler) {
	                return new Promise((resolve, reject) => {
	                    once(name, (err, data) => {
	                        if (err) return reject(err)
	                        resolve(data);
	                    });
	                })
	            }
	            off(name);
	            on(name, handler);

	        };

	        var isProcessing = false;
	        var q = {
	            _tasks: new DLL(),
	            *[Symbol.iterator] () {
	                yield* q._tasks[Symbol.iterator]();
	            },
	            concurrency,
	            payload,
	            buffer: concurrency / 4,
	            started: false,
	            paused: false,
	            push (data, callback) {
	                if (Array.isArray(data)) {
	                    if (_maybeDrain(data)) return
	                    return data.map(datum => _insert(datum, false, false, callback))
	                }
	                return _insert(data, false, false, callback);
	            },
	            pushAsync (data, callback) {
	                if (Array.isArray(data)) {
	                    if (_maybeDrain(data)) return
	                    return data.map(datum => _insert(datum, false, true, callback))
	                }
	                return _insert(data, false, true, callback);
	            },
	            kill () {
	                off();
	                q._tasks.empty();
	            },
	            unshift (data, callback) {
	                if (Array.isArray(data)) {
	                    if (_maybeDrain(data)) return
	                    return data.map(datum => _insert(datum, true, false, callback))
	                }
	                return _insert(data, true, false, callback);
	            },
	            unshiftAsync (data, callback) {
	                if (Array.isArray(data)) {
	                    if (_maybeDrain(data)) return
	                    return data.map(datum => _insert(datum, true, true, callback))
	                }
	                return _insert(data, true, true, callback);
	            },
	            remove (testFn) {
	                q._tasks.remove(testFn);
	            },
	            process () {
	                // Avoid trying to start too many processing operations. This can occur
	                // when callbacks resolve synchronously (#1267).
	                if (isProcessing) {
	                    return;
	                }
	                isProcessing = true;
	                while(!q.paused && numRunning < q.concurrency && q._tasks.length){
	                    var tasks = [], data = [];
	                    var l = q._tasks.length;
	                    if (q.payload) l = Math.min(l, q.payload);
	                    for (var i = 0; i < l; i++) {
	                        var node = q._tasks.shift();
	                        tasks.push(node);
	                        workersList.push(node);
	                        data.push(node.data);
	                    }

	                    numRunning += 1;

	                    if (q._tasks.length === 0) {
	                        trigger('empty');
	                    }

	                    if (numRunning === q.concurrency) {
	                        trigger('saturated');
	                    }

	                    var cb = onlyOnce(_createCB(tasks));
	                    _worker(data, cb);
	                }
	                isProcessing = false;
	            },
	            length () {
	                return q._tasks.length;
	            },
	            running () {
	                return numRunning;
	            },
	            workersList () {
	                return workersList;
	            },
	            idle() {
	                return q._tasks.length + numRunning === 0;
	            },
	            pause () {
	                q.paused = true;
	            },
	            resume () {
	                if (q.paused === false) { return; }
	                q.paused = false;
	                setImmediate$1(q.process);
	            }
	        };
	        // define these as fixed properties, so people get useful errors when updating
	        Object.defineProperties(q, {
	            saturated: {
	                writable: false,
	                value: eventMethod('saturated')
	            },
	            unsaturated: {
	                writable: false,
	                value: eventMethod('unsaturated')
	            },
	            empty: {
	                writable: false,
	                value: eventMethod('empty')
	            },
	            drain: {
	                writable: false,
	                value: eventMethod('drain')
	            },
	            error: {
	                writable: false,
	                value: eventMethod('error')
	            },
	        });
	        return q;
	    }

	    /**
	     * Creates a `cargo` object with the specified payload. Tasks added to the
	     * cargo will be processed altogether (up to the `payload` limit). If the
	     * `worker` is in progress, the task is queued until it becomes available. Once
	     * the `worker` has completed some tasks, each callback of those tasks is
	     * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
	     * for how `cargo` and `queue` work.
	     *
	     * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
	     * at a time, cargo passes an array of tasks to a single worker, repeating
	     * when the worker is finished.
	     *
	     * @name cargo
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.queue]{@link module:ControlFlow.queue}
	     * @category Control Flow
	     * @param {AsyncFunction} worker - An asynchronous function for processing an array
	     * of queued tasks. Invoked with `(tasks, callback)`.
	     * @param {number} [payload=Infinity] - An optional `integer` for determining
	     * how many tasks should be processed per round; if omitted, the default is
	     * unlimited.
	     * @returns {module:ControlFlow.QueueObject} A cargo object to manage the tasks. Callbacks can
	     * attached as certain properties to listen for specific events during the
	     * lifecycle of the cargo and inner queue.
	     * @example
	     *
	     * // create a cargo object with payload 2
	     * var cargo = async.cargo(function(tasks, callback) {
	     *     for (var i=0; i<tasks.length; i++) {
	     *         console.log('hello ' + tasks[i].name);
	     *     }
	     *     callback();
	     * }, 2);
	     *
	     * // add some items
	     * cargo.push({name: 'foo'}, function(err) {
	     *     console.log('finished processing foo');
	     * });
	     * cargo.push({name: 'bar'}, function(err) {
	     *     console.log('finished processing bar');
	     * });
	     * await cargo.push({name: 'baz'});
	     * console.log('finished processing baz');
	     */
	    function cargo(worker, payload) {
	        return queue(worker, 1, payload);
	    }

	    /**
	     * Creates a `cargoQueue` object with the specified payload. Tasks added to the
	     * cargoQueue will be processed together (up to the `payload` limit) in `concurrency` parallel workers.
	     * If the all `workers` are in progress, the task is queued until one becomes available. Once
	     * a `worker` has completed some tasks, each callback of those tasks is
	     * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
	     * for how `cargo` and `queue` work.
	     *
	     * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
	     * at a time, and [`cargo`]{@link module:ControlFlow.cargo} passes an array of tasks to a single worker,
	     * the cargoQueue passes an array of tasks to multiple parallel workers.
	     *
	     * @name cargoQueue
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.queue]{@link module:ControlFlow.queue}
	     * @see [async.cargo]{@link module:ControlFLow.cargo}
	     * @category Control Flow
	     * @param {AsyncFunction} worker - An asynchronous function for processing an array
	     * of queued tasks. Invoked with `(tasks, callback)`.
	     * @param {number} [concurrency=1] - An `integer` for determining how many
	     * `worker` functions should be run in parallel.  If omitted, the concurrency
	     * defaults to `1`.  If the concurrency is `0`, an error is thrown.
	     * @param {number} [payload=Infinity] - An optional `integer` for determining
	     * how many tasks should be processed per round; if omitted, the default is
	     * unlimited.
	     * @returns {module:ControlFlow.CargoObject} A cargoQueue object to manage the tasks. Callbacks can
	     * attached as certain properties to listen for specific events during the
	     * lifecycle of the cargoQueue and inner queue.
	     * @example
	     *
	     * // create a cargoQueue object with payload 2 and concurrency 2
	     * var cargoQueue = async.cargoQueue(function(tasks, callback) {
	     *     for (var i=0; i<tasks.length; i++) {
	     *         console.log('hello ' + tasks[i].name);
	     *     }
	     *     callback();
	     * }, 2, 2);
	     *
	     * // add some items
	     * cargoQueue.push({name: 'foo'}, function(err) {
	     *     console.log('finished processing foo');
	     * });
	     * cargoQueue.push({name: 'bar'}, function(err) {
	     *     console.log('finished processing bar');
	     * });
	     * cargoQueue.push({name: 'baz'}, function(err) {
	     *     console.log('finished processing baz');
	     * });
	     * cargoQueue.push({name: 'boo'}, function(err) {
	     *     console.log('finished processing boo');
	     * });
	     */
	    function cargo$1(worker, concurrency, payload) {
	        return queue(worker, concurrency, payload);
	    }

	    /**
	     * Reduces `coll` into a single value using an async `iteratee` to return each
	     * successive step. `memo` is the initial state of the reduction. This function
	     * only operates in series.
	     *
	     * For performance reasons, it may make sense to split a call to this function
	     * into a parallel map, and then use the normal `Array.prototype.reduce` on the
	     * results. This function is for situations where each step in the reduction
	     * needs to be async; if you can get the data before reducing it, then it's
	     * probably a good idea to do so.
	     *
	     * @name reduce
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias inject
	     * @alias foldl
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {*} memo - The initial state of the reduction.
	     * @param {AsyncFunction} iteratee - A function applied to each item in the
	     * array to produce the next step in the reduction.
	     * The `iteratee` should complete with the next state of the reduction.
	     * If the iteratee complete with an error, the reduction is stopped and the
	     * main `callback` is immediately called with the error.
	     * Invoked with (memo, item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Result is the reduced value. Invoked with
	     * (err, result).
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * async.reduce([1,2,3], 0, function(memo, item, callback) {
	     *     // pointless async:
	     *     process.nextTick(function() {
	     *         callback(null, memo + item)
	     *     });
	     * }, function(err, result) {
	     *     // result is now equal to the last value of memo, which is 6
	     * });
	     */
	    function reduce(coll, memo, iteratee, callback) {
	        callback = once(callback);
	        var _iteratee = wrapAsync(iteratee);
	        return eachOfSeries$1(coll, (x, i, iterCb) => {
	            _iteratee(memo, x, (err, v) => {
	                memo = v;
	                iterCb(err);
	            });
	        }, err => callback(err, memo));
	    }
	    var reduce$1 = awaitify(reduce, 4);

	    /**
	     * Version of the compose function that is more natural to read. Each function
	     * consumes the return value of the previous function. It is the equivalent of
	     * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
	     *
	     * Each function is executed with the `this` binding of the composed function.
	     *
	     * @name seq
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.compose]{@link module:ControlFlow.compose}
	     * @category Control Flow
	     * @param {...AsyncFunction} functions - the asynchronous functions to compose
	     * @returns {Function} a function that composes the `functions` in order
	     * @example
	     *
	     * // Requires lodash (or underscore), express3 and dresende's orm2.
	     * // Part of an app, that fetches cats of the logged user.
	     * // This example uses `seq` function to avoid overnesting and error
	     * // handling clutter.
	     * app.get('/cats', function(request, response) {
	     *     var User = request.models.User;
	     *     async.seq(
	     *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
	     *         function(user, fn) {
	     *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
	     *         }
	     *     )(req.session.user_id, function (err, cats) {
	     *         if (err) {
	     *             console.error(err);
	     *             response.json({ status: 'error', message: err.message });
	     *         } else {
	     *             response.json({ status: 'ok', message: 'Cats found', data: cats });
	     *         }
	     *     });
	     * });
	     */
	    function seq(...functions) {
	        var _functions = functions.map(wrapAsync);
	        return function (...args) {
	            var that = this;

	            var cb = args[args.length - 1];
	            if (typeof cb == 'function') {
	                args.pop();
	            } else {
	                cb = promiseCallback();
	            }

	            reduce$1(_functions, args, (newargs, fn, iterCb) => {
	                fn.apply(that, newargs.concat((err, ...nextargs) => {
	                    iterCb(err, nextargs);
	                }));
	            },
	            (err, results) => cb(err, ...results));

	            return cb[PROMISE_SYMBOL]
	        };
	    }

	    /**
	     * Creates a function which is a composition of the passed asynchronous
	     * functions. Each function consumes the return value of the function that
	     * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
	     * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
	     *
	     * If the last argument to the composed function is not a function, a promise
	     * is returned when you call it.
	     *
	     * Each function is executed with the `this` binding of the composed function.
	     *
	     * @name compose
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {...AsyncFunction} functions - the asynchronous functions to compose
	     * @returns {Function} an asynchronous function that is the composed
	     * asynchronous `functions`
	     * @example
	     *
	     * function add1(n, callback) {
	     *     setTimeout(function () {
	     *         callback(null, n + 1);
	     *     }, 10);
	     * }
	     *
	     * function mul3(n, callback) {
	     *     setTimeout(function () {
	     *         callback(null, n * 3);
	     *     }, 10);
	     * }
	     *
	     * var add1mul3 = async.compose(mul3, add1);
	     * add1mul3(4, function (err, result) {
	     *     // result now equals 15
	     * });
	     */
	    function compose(...args) {
	        return seq(...args.reverse());
	    }

	    /**
	     * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
	     *
	     * @name mapLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.map]{@link module:Collections.map}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with the transformed item.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Results is an array of the
	     * transformed items from the `coll`. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function mapLimit (coll, limit, iteratee, callback) {
	        return _asyncMap(eachOfLimit(limit), coll, iteratee, callback)
	    }
	    var mapLimit$1 = awaitify(mapLimit, 4);

	    /**
	     * The same as [`concat`]{@link module:Collections.concat} but runs a maximum of `limit` async operations at a time.
	     *
	     * @name concatLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.concat]{@link module:Collections.concat}
	     * @category Collection
	     * @alias flatMapLimit
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
	     * which should use an array as its result. Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished, or an error occurs. Results is an array
	     * containing the concatenated results of the `iteratee` function. Invoked with
	     * (err, results).
	     * @returns A Promise, if no callback is passed
	     */
	    function concatLimit(coll, limit, iteratee, callback) {
	        var _iteratee = wrapAsync(iteratee);
	        return mapLimit$1(coll, limit, (val, iterCb) => {
	            _iteratee(val, (err, ...args) => {
	                if (err) return iterCb(err);
	                return iterCb(err, args);
	            });
	        }, (err, mapResults) => {
	            var result = [];
	            for (var i = 0; i < mapResults.length; i++) {
	                if (mapResults[i]) {
	                    result = result.concat(...mapResults[i]);
	                }
	            }

	            return callback(err, result);
	        });
	    }
	    var concatLimit$1 = awaitify(concatLimit, 4);

	    /**
	     * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
	     * the concatenated list. The `iteratee`s are called in parallel, and the
	     * results are concatenated as they return. The results array will be returned in
	     * the original order of `coll` passed to the `iteratee` function.
	     *
	     * @name concat
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @category Collection
	     * @alias flatMap
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`,
	     * which should use an array as its result. Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished, or an error occurs. Results is an array
	     * containing the concatenated results of the `iteratee` function. Invoked with
	     * (err, results).
	     * @returns A Promise, if no callback is passed
	     * @example
	     *
	     * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
	     *     // files is now a list of filenames that exist in the 3 directories
	     * });
	     */
	    function concat(coll, iteratee, callback) {
	        return concatLimit$1(coll, Infinity, iteratee, callback)
	    }
	    var concat$1 = awaitify(concat, 3);

	    /**
	     * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
	     *
	     * @name concatSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.concat]{@link module:Collections.concat}
	     * @category Collection
	     * @alias flatMapSeries
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A function to apply to each item in `coll`.
	     * The iteratee should complete with an array an array of results.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished, or an error occurs. Results is an array
	     * containing the concatenated results of the `iteratee` function. Invoked with
	     * (err, results).
	     * @returns A Promise, if no callback is passed
	     */
	    function concatSeries(coll, iteratee, callback) {
	        return concatLimit$1(coll, 1, iteratee, callback)
	    }
	    var concatSeries$1 = awaitify(concatSeries, 3);

	    /**
	     * Returns a function that when called, calls-back with the values provided.
	     * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
	     * [`auto`]{@link module:ControlFlow.auto}.
	     *
	     * @name constant
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {...*} arguments... - Any number of arguments to automatically invoke
	     * callback with.
	     * @returns {AsyncFunction} Returns a function that when invoked, automatically
	     * invokes the callback with the previous given arguments.
	     * @example
	     *
	     * async.waterfall([
	     *     async.constant(42),
	     *     function (value, next) {
	     *         // value === 42
	     *     },
	     *     //...
	     * ], callback);
	     *
	     * async.waterfall([
	     *     async.constant(filename, "utf8"),
	     *     fs.readFile,
	     *     function (fileData, next) {
	     *         //...
	     *     }
	     *     //...
	     * ], callback);
	     *
	     * async.auto({
	     *     hostname: async.constant("https://server.net/"),
	     *     port: findFreePort,
	     *     launchServer: ["hostname", "port", function (options, cb) {
	     *         startServer(options, cb);
	     *     }],
	     *     //...
	     * }, callback);
	     */
	    function constant(...args) {
	        return function (...ignoredArgs/*, callback*/) {
	            var callback = ignoredArgs.pop();
	            return callback(null, ...args);
	        };
	    }

	    function _createTester(check, getResult) {
	        return (eachfn, arr, _iteratee, cb) => {
	            var testPassed = false;
	            var testResult;
	            const iteratee = wrapAsync(_iteratee);
	            eachfn(arr, (value, _, callback) => {
	                iteratee(value, (err, result) => {
	                    if (err || err === false) return callback(err);

	                    if (check(result) && !testResult) {
	                        testPassed = true;
	                        testResult = getResult(true, value);
	                        return callback(null, breakLoop);
	                    }
	                    callback();
	                });
	            }, err => {
	                if (err) return cb(err);
	                cb(null, testPassed ? testResult : getResult(false));
	            });
	        };
	    }

	    /**
	     * Returns the first value in `coll` that passes an async truth test. The
	     * `iteratee` is applied in parallel, meaning the first iteratee to return
	     * `true` will fire the detect `callback` with that result. That means the
	     * result might not be the first item in the original `coll` (in terms of order)
	     * that passes the test.

	     * If order within the original `coll` is important, then look at
	     * [`detectSeries`]{@link module:Collections.detectSeries}.
	     *
	     * @name detect
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias find
	     * @category Collections
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	     * The iteratee must complete with a boolean value as its result.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called as soon as any
	     * iteratee returns `true`, or after all the `iteratee` functions have finished.
	     * Result will be the first item in the array that passes the truth test
	     * (iteratee) or the value `undefined` if none passed. Invoked with
	     * (err, result).
	     * @returns A Promise, if no callback is passed
	     * @example
	     *
	     * async.detect(['file1','file2','file3'], function(filePath, callback) {
	     *     fs.access(filePath, function(err) {
	     *         callback(null, !err)
	     *     });
	     * }, function(err, result) {
	     *     // result now equals the first file in the list that exists
	     * });
	     */
	    function detect(coll, iteratee, callback) {
	        return _createTester(bool => bool, (res, item) => item)(eachOf$1, coll, iteratee, callback)
	    }
	    var detect$1 = awaitify(detect, 3);

	    /**
	     * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name detectLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.detect]{@link module:Collections.detect}
	     * @alias findLimit
	     * @category Collections
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	     * The iteratee must complete with a boolean value as its result.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called as soon as any
	     * iteratee returns `true`, or after all the `iteratee` functions have finished.
	     * Result will be the first item in the array that passes the truth test
	     * (iteratee) or the value `undefined` if none passed. Invoked with
	     * (err, result).
	     * @returns a Promise if no callback is passed
	     */
	    function detectLimit(coll, limit, iteratee, callback) {
	        return _createTester(bool => bool, (res, item) => item)(eachOfLimit(limit), coll, iteratee, callback)
	    }
	    var detectLimit$1 = awaitify(detectLimit, 4);

	    /**
	     * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
	     *
	     * @name detectSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.detect]{@link module:Collections.detect}
	     * @alias findSeries
	     * @category Collections
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A truth test to apply to each item in `coll`.
	     * The iteratee must complete with a boolean value as its result.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called as soon as any
	     * iteratee returns `true`, or after all the `iteratee` functions have finished.
	     * Result will be the first item in the array that passes the truth test
	     * (iteratee) or the value `undefined` if none passed. Invoked with
	     * (err, result).
	     * @returns a Promise if no callback is passed
	     */
	    function detectSeries(coll, iteratee, callback) {
	        return _createTester(bool => bool, (res, item) => item)(eachOfLimit(1), coll, iteratee, callback)
	    }

	    var detectSeries$1 = awaitify(detectSeries, 3);

	    function consoleFunc(name) {
	        return (fn, ...args) => wrapAsync(fn)(...args, (err, ...resultArgs) => {
	            if (typeof console === 'object') {
	                if (err) {
	                    if (console.error) {
	                        console.error(err);
	                    }
	                } else if (console[name]) {
	                    resultArgs.forEach(x => console[name](x));
	                }
	            }
	        })
	    }

	    /**
	     * Logs the result of an [`async` function]{@link AsyncFunction} to the
	     * `console` using `console.dir` to display the properties of the resulting object.
	     * Only works in Node.js or in browsers that support `console.dir` and
	     * `console.error` (such as FF and Chrome).
	     * If multiple arguments are returned from the async function,
	     * `console.dir` is called on each argument in order.
	     *
	     * @name dir
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {AsyncFunction} function - The function you want to eventually apply
	     * all arguments to.
	     * @param {...*} arguments... - Any number of arguments to apply to the function.
	     * @example
	     *
	     * // in a module
	     * var hello = function(name, callback) {
	     *     setTimeout(function() {
	     *         callback(null, {hello: name});
	     *     }, 1000);
	     * };
	     *
	     * // in the node repl
	     * node> async.dir(hello, 'world');
	     * {hello: 'world'}
	     */
	    var dir = consoleFunc('dir');

	    /**
	     * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
	     * the order of operations, the arguments `test` and `iteratee` are switched.
	     *
	     * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
	     *
	     * @name doWhilst
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.whilst]{@link module:ControlFlow.whilst}
	     * @category Control Flow
	     * @param {AsyncFunction} iteratee - A function which is called each time `test`
	     * passes. Invoked with (callback).
	     * @param {AsyncFunction} test - asynchronous truth test to perform after each
	     * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
	     * non-error args from the previous callback of `iteratee`.
	     * @param {Function} [callback] - A callback which is called after the test
	     * function has failed and repeated execution of `iteratee` has stopped.
	     * `callback` will be passed an error and any arguments passed to the final
	     * `iteratee`'s callback. Invoked with (err, [results]);
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function doWhilst(iteratee, test, callback) {
	        callback = onlyOnce(callback);
	        var _fn = wrapAsync(iteratee);
	        var _test = wrapAsync(test);
	        var results;

	        function next(err, ...args) {
	            if (err) return callback(err);
	            if (err === false) return;
	            results = args;
	            _test(...args, check);
	        }

	        function check(err, truth) {
	            if (err) return callback(err);
	            if (err === false) return;
	            if (!truth) return callback(null, ...results);
	            _fn(next);
	        }

	        return check(null, true);
	    }

	    var doWhilst$1 = awaitify(doWhilst, 3);

	    /**
	     * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
	     * argument ordering differs from `until`.
	     *
	     * @name doUntil
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
	     * @category Control Flow
	     * @param {AsyncFunction} iteratee - An async function which is called each time
	     * `test` fails. Invoked with (callback).
	     * @param {AsyncFunction} test - asynchronous truth test to perform after each
	     * execution of `iteratee`. Invoked with (...args, callback), where `...args` are the
	     * non-error args from the previous callback of `iteratee`
	     * @param {Function} [callback] - A callback which is called after the test
	     * function has passed and repeated execution of `iteratee` has stopped. `callback`
	     * will be passed an error and any arguments passed to the final `iteratee`'s
	     * callback. Invoked with (err, [results]);
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function doUntil(iteratee, test, callback) {
	        const _test = wrapAsync(test);
	        return doWhilst$1(iteratee, (...args) => {
	            const cb = args.pop();
	            _test(...args, (err, truth) => cb (err, !truth));
	        }, callback);
	    }

	    function _withoutIndex(iteratee) {
	        return (value, index, callback) => iteratee(value, callback);
	    }

	    /**
	     * Applies the function `iteratee` to each item in `coll`, in parallel.
	     * The `iteratee` is called with an item from the list, and a callback for when
	     * it has finished. If the `iteratee` passes an error to its `callback`, the
	     * main `callback` (for the `each` function) is immediately called with the
	     * error.
	     *
	     * Note, that since this function applies `iteratee` to each item in parallel,
	     * there is no guarantee that the iteratee functions will complete in order.
	     *
	     * @name each
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias forEach
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to
	     * each item in `coll`. Invoked with (item, callback).
	     * The array index is not passed to the iteratee.
	     * If you need the index, use `eachOf`.
	     * @param {Function} [callback] - A callback which is called when all
	     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	     * @returns {Promise} a promise, if a callback is omitted
	     * @example
	     *
	     * // assuming openFiles is an array of file names and saveFile is a function
	     * // to save the modified contents of that file:
	     *
	     * async.each(openFiles, saveFile, function(err){
	     *   // if any of the saves produced an error, err would equal that error
	     * });
	     *
	     * // assuming openFiles is an array of file names
	     * async.each(openFiles, function(file, callback) {
	     *
	     *     // Perform operation on file here.
	     *     console.log('Processing file ' + file);
	     *
	     *     if( file.length > 32 ) {
	     *       console.log('This file name is too long');
	     *       callback('File name too long');
	     *     } else {
	     *       // Do work to process file here
	     *       console.log('File processed');
	     *       callback();
	     *     }
	     * }, function(err) {
	     *     // if any of the file processing produced an error, err would equal that error
	     *     if( err ) {
	     *       // One of the iterations produced an error.
	     *       // All processing will now stop.
	     *       console.log('A file failed to process');
	     *     } else {
	     *       console.log('All files have been processed successfully');
	     *     }
	     * });
	     */
	    function eachLimit(coll, iteratee, callback) {
	        return eachOf$1(coll, _withoutIndex(wrapAsync(iteratee)), callback);
	    }

	    var each = awaitify(eachLimit, 3);

	    /**
	     * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
	     *
	     * @name eachLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.each]{@link module:Collections.each}
	     * @alias forEachLimit
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The array index is not passed to the iteratee.
	     * If you need the index, use `eachOfLimit`.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called when all
	     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	     * @returns {Promise} a promise, if a callback is omitted
	     */
	    function eachLimit$1(coll, limit, iteratee, callback) {
	        return eachOfLimit(limit)(coll, _withoutIndex(wrapAsync(iteratee)), callback);
	    }
	    var eachLimit$2 = awaitify(eachLimit$1, 4);

	    /**
	     * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
	     *
	     * Note, that unlike [`each`]{@link module:Collections.each}, this function applies iteratee to each item
	     * in series and therefore the iteratee functions will complete in order.

	     * @name eachSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.each]{@link module:Collections.each}
	     * @alias forEachSeries
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each
	     * item in `coll`.
	     * The array index is not passed to the iteratee.
	     * If you need the index, use `eachOfSeries`.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called when all
	     * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	     * @returns {Promise} a promise, if a callback is omitted
	     */
	    function eachSeries(coll, iteratee, callback) {
	        return eachLimit$2(coll, 1, iteratee, callback)
	    }
	    var eachSeries$1 = awaitify(eachSeries, 3);

	    /**
	     * Wrap an async function and ensure it calls its callback on a later tick of
	     * the event loop.  If the function already calls its callback on a next tick,
	     * no extra deferral is added. This is useful for preventing stack overflows
	     * (`RangeError: Maximum call stack size exceeded`) and generally keeping
	     * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
	     * contained. ES2017 `async` functions are returned as-is -- they are immune
	     * to Zalgo's corrupting influences, as they always resolve on a later tick.
	     *
	     * @name ensureAsync
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {AsyncFunction} fn - an async function, one that expects a node-style
	     * callback as its last argument.
	     * @returns {AsyncFunction} Returns a wrapped function with the exact same call
	     * signature as the function passed in.
	     * @example
	     *
	     * function sometimesAsync(arg, callback) {
	     *     if (cache[arg]) {
	     *         return callback(null, cache[arg]); // this would be synchronous!!
	     *     } else {
	     *         doSomeIO(arg, callback); // this IO would be asynchronous
	     *     }
	     * }
	     *
	     * // this has a risk of stack overflows if many results are cached in a row
	     * async.mapSeries(args, sometimesAsync, done);
	     *
	     * // this will defer sometimesAsync's callback if necessary,
	     * // preventing stack overflows
	     * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
	     */
	    function ensureAsync(fn) {
	        if (isAsync(fn)) return fn;
	        return function (...args/*, callback*/) {
	            var callback = args.pop();
	            var sync = true;
	            args.push((...innerArgs) => {
	                if (sync) {
	                    setImmediate$1(() => callback(...innerArgs));
	                } else {
	                    callback(...innerArgs);
	                }
	            });
	            fn.apply(this, args);
	            sync = false;
	        };
	    }

	    /**
	     * Returns `true` if every element in `coll` satisfies an async test. If any
	     * iteratee call returns `false`, the main `callback` is immediately called.
	     *
	     * @name every
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias all
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	     * in the collection in parallel.
	     * The iteratee must complete with a boolean result value.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Result will be either `true` or `false`
	     * depending on the values of the async tests. Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     * @example
	     *
	     * async.every(['file1','file2','file3'], function(filePath, callback) {
	     *     fs.access(filePath, function(err) {
	     *         callback(null, !err)
	     *     });
	     * }, function(err, result) {
	     *     // if result is true then every file exists
	     * });
	     */
	    function every(coll, iteratee, callback) {
	        return _createTester(bool => !bool, res => !res)(eachOf$1, coll, iteratee, callback)
	    }
	    var every$1 = awaitify(every, 3);

	    /**
	     * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
	     *
	     * @name everyLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.every]{@link module:Collections.every}
	     * @alias allLimit
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	     * in the collection in parallel.
	     * The iteratee must complete with a boolean result value.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Result will be either `true` or `false`
	     * depending on the values of the async tests. Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     */
	    function everyLimit(coll, limit, iteratee, callback) {
	        return _createTester(bool => !bool, res => !res)(eachOfLimit(limit), coll, iteratee, callback)
	    }
	    var everyLimit$1 = awaitify(everyLimit, 4);

	    /**
	     * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
	     *
	     * @name everySeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.every]{@link module:Collections.every}
	     * @alias allSeries
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	     * in the collection in series.
	     * The iteratee must complete with a boolean result value.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Result will be either `true` or `false`
	     * depending on the values of the async tests. Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     */
	    function everySeries(coll, iteratee, callback) {
	        return _createTester(bool => !bool, res => !res)(eachOfSeries$1, coll, iteratee, callback)
	    }
	    var everySeries$1 = awaitify(everySeries, 3);

	    function filterArray(eachfn, arr, iteratee, callback) {
	        var truthValues = new Array(arr.length);
	        eachfn(arr, (x, index, iterCb) => {
	            iteratee(x, (err, v) => {
	                truthValues[index] = !!v;
	                iterCb(err);
	            });
	        }, err => {
	            if (err) return callback(err);
	            var results = [];
	            for (var i = 0; i < arr.length; i++) {
	                if (truthValues[i]) results.push(arr[i]);
	            }
	            callback(null, results);
	        });
	    }

	    function filterGeneric(eachfn, coll, iteratee, callback) {
	        var results = [];
	        eachfn(coll, (x, index, iterCb) => {
	            iteratee(x, (err, v) => {
	                if (err) return iterCb(err);
	                if (v) {
	                    results.push({index, value: x});
	                }
	                iterCb(err);
	            });
	        }, err => {
	            if (err) return callback(err);
	            callback(null, results
	                .sort((a, b) => a.index - b.index)
	                .map(v => v.value));
	        });
	    }

	    function _filter(eachfn, coll, iteratee, callback) {
	        var filter = isArrayLike(coll) ? filterArray : filterGeneric;
	        return filter(eachfn, coll, wrapAsync(iteratee), callback);
	    }

	    /**
	     * Returns a new array of all the values in `coll` which pass an async truth
	     * test. This operation is performed in parallel, but the results array will be
	     * in the same order as the original.
	     *
	     * @name filter
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias select
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	     * with a boolean argument once it has completed. Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback provided
	     * @example
	     *
	     * async.filter(['file1','file2','file3'], function(filePath, callback) {
	     *     fs.access(filePath, function(err) {
	     *         callback(null, !err)
	     *     });
	     * }, function(err, results) {
	     *     // results now equals an array of the existing files
	     * });
	     */
	    function filter (coll, iteratee, callback) {
	        return _filter(eachOf$1, coll, iteratee, callback)
	    }
	    var filter$1 = awaitify(filter, 3);

	    /**
	     * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name filterLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.filter]{@link module:Collections.filter}
	     * @alias selectLimit
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	     * with a boolean argument once it has completed. Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback provided
	     */
	    function filterLimit (coll, limit, iteratee, callback) {
	        return _filter(eachOfLimit(limit), coll, iteratee, callback)
	    }
	    var filterLimit$1 = awaitify(filterLimit, 4);

	    /**
	     * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
	     *
	     * @name filterSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.filter]{@link module:Collections.filter}
	     * @alias selectSeries
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	     * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	     * with a boolean argument once it has completed. Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Invoked with (err, results)
	     * @returns {Promise} a promise, if no callback provided
	     */
	    function filterSeries (coll, iteratee, callback) {
	        return _filter(eachOfSeries$1, coll, iteratee, callback)
	    }
	    var filterSeries$1 = awaitify(filterSeries, 3);

	    /**
	     * Calls the asynchronous function `fn` with a callback parameter that allows it
	     * to call itself again, in series, indefinitely.

	     * If an error is passed to the callback then `errback` is called with the
	     * error, and execution stops, otherwise it will never be called.
	     *
	     * @name forever
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {AsyncFunction} fn - an async function to call repeatedly.
	     * Invoked with (next).
	     * @param {Function} [errback] - when `fn` passes an error to it's callback,
	     * this function will be called, and execution stops. Invoked with (err).
	     * @returns {Promise} a promise that rejects if an error occurs and an errback
	     * is not passed
	     * @example
	     *
	     * async.forever(
	     *     function(next) {
	     *         // next is suitable for passing to things that need a callback(err [, whatever]);
	     *         // it will result in this function being called again.
	     *     },
	     *     function(err) {
	     *         // if next is called with a value in its first parameter, it will appear
	     *         // in here as 'err', and execution will stop.
	     *     }
	     * );
	     */
	    function forever(fn, errback) {
	        var done = onlyOnce(errback);
	        var task = wrapAsync(ensureAsync(fn));

	        function next(err) {
	            if (err) return done(err);
	            if (err === false) return;
	            task(next);
	        }
	        return next();
	    }
	    var forever$1 = awaitify(forever, 2);

	    /**
	     * The same as [`groupBy`]{@link module:Collections.groupBy} but runs a maximum of `limit` async operations at a time.
	     *
	     * @name groupByLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.groupBy]{@link module:Collections.groupBy}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with a `key` to group the value under.
	     * Invoked with (value, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Result is an `Object` whoses
	     * properties are arrays of values which returned the corresponding key.
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function groupByLimit(coll, limit, iteratee, callback) {
	        var _iteratee = wrapAsync(iteratee);
	        return mapLimit$1(coll, limit, (val, iterCb) => {
	            _iteratee(val, (err, key) => {
	                if (err) return iterCb(err);
	                return iterCb(err, {key, val});
	            });
	        }, (err, mapResults) => {
	            var result = {};
	            // from MDN, handle object having an `hasOwnProperty` prop
	            var {hasOwnProperty} = Object.prototype;

	            for (var i = 0; i < mapResults.length; i++) {
	                if (mapResults[i]) {
	                    var {key} = mapResults[i];
	                    var {val} = mapResults[i];

	                    if (hasOwnProperty.call(result, key)) {
	                        result[key].push(val);
	                    } else {
	                        result[key] = [val];
	                    }
	                }
	            }

	            return callback(err, result);
	        });
	    }

	    var groupByLimit$1 = awaitify(groupByLimit, 4);

	    /**
	     * Returns a new object, where each value corresponds to an array of items, from
	     * `coll`, that returned the corresponding key. That is, the keys of the object
	     * correspond to the values passed to the `iteratee` callback.
	     *
	     * Note: Since this function applies the `iteratee` to each item in parallel,
	     * there is no guarantee that the `iteratee` functions will complete in order.
	     * However, the values for each key in the `result` will be in the same order as
	     * the original `coll`. For Objects, the values will roughly be in the order of
	     * the original Objects' keys (but this can vary across JavaScript engines).
	     *
	     * @name groupBy
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with a `key` to group the value under.
	     * Invoked with (value, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Result is an `Object` whoses
	     * properties are arrays of values which returned the corresponding key.
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * async.groupBy(['userId1', 'userId2', 'userId3'], function(userId, callback) {
	     *     db.findById(userId, function(err, user) {
	     *         if (err) return callback(err);
	     *         return callback(null, user.age);
	     *     });
	     * }, function(err, result) {
	     *     // result is object containing the userIds grouped by age
	     *     // e.g. { 30: ['userId1', 'userId3'], 42: ['userId2']};
	     * });
	     */
	    function groupBy (coll, iteratee, callback) {
	        return groupByLimit$1(coll, Infinity, iteratee, callback)
	    }

	    /**
	     * The same as [`groupBy`]{@link module:Collections.groupBy} but runs only a single async operation at a time.
	     *
	     * @name groupBySeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.groupBy]{@link module:Collections.groupBy}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with a `key` to group the value under.
	     * Invoked with (value, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. Result is an `Object` whoses
	     * properties are arrays of values which returned the corresponding key.
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function groupBySeries (coll, iteratee, callback) {
	        return groupByLimit$1(coll, 1, iteratee, callback)
	    }

	    /**
	     * Logs the result of an `async` function to the `console`. Only works in
	     * Node.js or in browsers that support `console.log` and `console.error` (such
	     * as FF and Chrome). If multiple arguments are returned from the async
	     * function, `console.log` is called on each argument in order.
	     *
	     * @name log
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {AsyncFunction} function - The function you want to eventually apply
	     * all arguments to.
	     * @param {...*} arguments... - Any number of arguments to apply to the function.
	     * @example
	     *
	     * // in a module
	     * var hello = function(name, callback) {
	     *     setTimeout(function() {
	     *         callback(null, 'hello ' + name);
	     *     }, 1000);
	     * };
	     *
	     * // in the node repl
	     * node> async.log(hello, 'world');
	     * 'hello world'
	     */
	    var log = consoleFunc('log');

	    /**
	     * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name mapValuesLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.mapValues]{@link module:Collections.mapValues}
	     * @category Collection
	     * @param {Object} obj - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - A function to apply to each value and key
	     * in `coll`.
	     * The iteratee should complete with the transformed value as its result.
	     * Invoked with (value, key, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. `result` is a new object consisting
	     * of each key from `obj`, with each transformed value on the right-hand side.
	     * Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function mapValuesLimit(obj, limit, iteratee, callback) {
	        callback = once(callback);
	        var newObj = {};
	        var _iteratee = wrapAsync(iteratee);
	        return eachOfLimit(limit)(obj, (val, key, next) => {
	            _iteratee(val, key, (err, result) => {
	                if (err) return next(err);
	                newObj[key] = result;
	                next(err);
	            });
	        }, err => callback(err, newObj));
	    }

	    var mapValuesLimit$1 = awaitify(mapValuesLimit, 4);

	    /**
	     * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
	     *
	     * Produces a new Object by mapping each value of `obj` through the `iteratee`
	     * function. The `iteratee` is called each `value` and `key` from `obj` and a
	     * callback for when it has finished processing. Each of these callbacks takes
	     * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
	     * passes an error to its callback, the main `callback` (for the `mapValues`
	     * function) is immediately called with the error.
	     *
	     * Note, the order of the keys in the result is not guaranteed.  The keys will
	     * be roughly in the order they complete, (but this is very engine-specific)
	     *
	     * @name mapValues
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @category Collection
	     * @param {Object} obj - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A function to apply to each value and key
	     * in `coll`.
	     * The iteratee should complete with the transformed value as its result.
	     * Invoked with (value, key, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. `result` is a new object consisting
	     * of each key from `obj`, with each transformed value on the right-hand side.
	     * Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * async.mapValues({
	     *     f1: 'file1',
	     *     f2: 'file2',
	     *     f3: 'file3'
	     * }, function (file, key, callback) {
	     *   fs.stat(file, callback);
	     * }, function(err, result) {
	     *     // result is now a map of stats for each file, e.g.
	     *     // {
	     *     //     f1: [stats for file1],
	     *     //     f2: [stats for file2],
	     *     //     f3: [stats for file3]
	     *     // }
	     * });
	     */
	    function mapValues(obj, iteratee, callback) {
	        return mapValuesLimit$1(obj, Infinity, iteratee, callback)
	    }

	    /**
	     * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
	     *
	     * @name mapValuesSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.mapValues]{@link module:Collections.mapValues}
	     * @category Collection
	     * @param {Object} obj - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - A function to apply to each value and key
	     * in `coll`.
	     * The iteratee should complete with the transformed value as its result.
	     * Invoked with (value, key, callback).
	     * @param {Function} [callback] - A callback which is called when all `iteratee`
	     * functions have finished, or an error occurs. `result` is a new object consisting
	     * of each key from `obj`, with each transformed value on the right-hand side.
	     * Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function mapValuesSeries(obj, iteratee, callback) {
	        return mapValuesLimit$1(obj, 1, iteratee, callback)
	    }

	    /**
	     * Caches the results of an async function. When creating a hash to store
	     * function results against, the callback is omitted from the hash and an
	     * optional hash function can be used.
	     *
	     * **Note: if the async function errs, the result will not be cached and
	     * subsequent calls will call the wrapped function.**
	     *
	     * If no hash function is specified, the first argument is used as a hash key,
	     * which may work reasonably if it is a string or a data type that converts to a
	     * distinct string. Note that objects and arrays will not behave reasonably.
	     * Neither will cases where the other arguments are significant. In such cases,
	     * specify your own hash function.
	     *
	     * The cache of results is exposed as the `memo` property of the function
	     * returned by `memoize`.
	     *
	     * @name memoize
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {AsyncFunction} fn - The async function to proxy and cache results from.
	     * @param {Function} hasher - An optional function for generating a custom hash
	     * for storing results. It has all the arguments applied to it apart from the
	     * callback, and must be synchronous.
	     * @returns {AsyncFunction} a memoized version of `fn`
	     * @example
	     *
	     * var slow_fn = function(name, callback) {
	     *     // do something
	     *     callback(null, result);
	     * };
	     * var fn = async.memoize(slow_fn);
	     *
	     * // fn can now be used as if it were slow_fn
	     * fn('some name', function() {
	     *     // callback
	     * });
	     */
	    function memoize(fn, hasher = v => v) {
	        var memo = Object.create(null);
	        var queues = Object.create(null);
	        var _fn = wrapAsync(fn);
	        var memoized = initialParams((args, callback) => {
	            var key = hasher(...args);
	            if (key in memo) {
	                setImmediate$1(() => callback(null, ...memo[key]));
	            } else if (key in queues) {
	                queues[key].push(callback);
	            } else {
	                queues[key] = [callback];
	                _fn(...args, (err, ...resultArgs) => {
	                    // #1465 don't memoize if an error occurred
	                    if (!err) {
	                        memo[key] = resultArgs;
	                    }
	                    var q = queues[key];
	                    delete queues[key];
	                    for (var i = 0, l = q.length; i < l; i++) {
	                        q[i](err, ...resultArgs);
	                    }
	                });
	            }
	        });
	        memoized.memo = memo;
	        memoized.unmemoized = fn;
	        return memoized;
	    }

	    /**
	     * Calls `callback` on a later loop around the event loop. In Node.js this just
	     * calls `process.nextTick`.  In the browser it will use `setImmediate` if
	     * available, otherwise `setTimeout(callback, 0)`, which means other higher
	     * priority events may precede the execution of `callback`.
	     *
	     * This is used internally for browser-compatibility purposes.
	     *
	     * @name nextTick
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @see [async.setImmediate]{@link module:Utils.setImmediate}
	     * @category Util
	     * @param {Function} callback - The function to call on a later loop around
	     * the event loop. Invoked with (args...).
	     * @param {...*} args... - any number of additional arguments to pass to the
	     * callback on the next tick.
	     * @example
	     *
	     * var call_order = [];
	     * async.nextTick(function() {
	     *     call_order.push('two');
	     *     // call_order now equals ['one','two']
	     * });
	     * call_order.push('one');
	     *
	     * async.setImmediate(function (a, b, c) {
	     *     // a, b, and c equal 1, 2, and 3
	     * }, 1, 2, 3);
	     */
	    var _defer$1;

	    if (hasNextTick) {
	        _defer$1 = process.nextTick;
	    } else if (hasSetImmediate) {
	        _defer$1 = setImmediate;
	    } else {
	        _defer$1 = fallback;
	    }

	    var nextTick = wrap(_defer$1);

	    var _parallel = awaitify((eachfn, tasks, callback) => {
	        var results = isArrayLike(tasks) ? [] : {};

	        eachfn(tasks, (task, key, taskCb) => {
	            wrapAsync(task)((err, ...result) => {
	                if (result.length < 2) {
	                    [result] = result;
	                }
	                results[key] = result;
	                taskCb(err);
	            });
	        }, err => callback(err, results));
	    }, 3);

	    /**
	     * Run the `tasks` collection of functions in parallel, without waiting until
	     * the previous function has completed. If any of the functions pass an error to
	     * its callback, the main `callback` is immediately called with the value of the
	     * error. Once the `tasks` have completed, the results are passed to the final
	     * `callback` as an array.
	     *
	     * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
	     * parallel execution of code.  If your tasks do not use any timers or perform
	     * any I/O, they will actually be executed in series.  Any synchronous setup
	     * sections for each task will happen one after the other.  JavaScript remains
	     * single-threaded.
	     *
	     * **Hint:** Use [`reflect`]{@link module:Utils.reflect} to continue the
	     * execution of other tasks when a task fails.
	     *
	     * It is also possible to use an object instead of an array. Each property will
	     * be run as a function and the results will be passed to the final `callback`
	     * as an object instead of an array. This can be a more readable way of handling
	     * results from {@link async.parallel}.
	     *
	     * @name parallel
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
	     * [async functions]{@link AsyncFunction} to run.
	     * Each async function can complete with any number of optional `result` values.
	     * @param {Function} [callback] - An optional callback to run once all the
	     * functions have completed successfully. This function gets a results array
	     * (or object) containing all the result arguments passed to the task callbacks.
	     * Invoked with (err, results).
	     * @returns {Promise} a promise, if a callback is not passed
	     *
	     * @example
	     * async.parallel([
	     *     function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'one');
	     *         }, 200);
	     *     },
	     *     function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'two');
	     *         }, 100);
	     *     }
	     * ],
	     * // optional callback
	     * function(err, results) {
	     *     // the results array will equal ['one','two'] even though
	     *     // the second function had a shorter timeout.
	     * });
	     *
	     * // an example using an object instead of an array
	     * async.parallel({
	     *     one: function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 1);
	     *         }, 200);
	     *     },
	     *     two: function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 2);
	     *         }, 100);
	     *     }
	     * }, function(err, results) {
	     *     // results is now equals to: {one: 1, two: 2}
	     * });
	     */
	    function parallel(tasks, callback) {
	        return _parallel(eachOf$1, tasks, callback);
	    }

	    /**
	     * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name parallelLimit
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.parallel]{@link module:ControlFlow.parallel}
	     * @category Control Flow
	     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection of
	     * [async functions]{@link AsyncFunction} to run.
	     * Each async function can complete with any number of optional `result` values.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {Function} [callback] - An optional callback to run once all the
	     * functions have completed successfully. This function gets a results array
	     * (or object) containing all the result arguments passed to the task callbacks.
	     * Invoked with (err, results).
	     * @returns {Promise} a promise, if a callback is not passed
	     */
	    function parallelLimit(tasks, limit, callback) {
	        return _parallel(eachOfLimit(limit), tasks, callback);
	    }

	    /**
	     * A queue of tasks for the worker function to complete.
	     * @typedef {Iterable} QueueObject
	     * @memberOf module:ControlFlow
	     * @property {Function} length - a function returning the number of items
	     * waiting to be processed. Invoke with `queue.length()`.
	     * @property {boolean} started - a boolean indicating whether or not any
	     * items have been pushed and processed by the queue.
	     * @property {Function} running - a function returning the number of items
	     * currently being processed. Invoke with `queue.running()`.
	     * @property {Function} workersList - a function returning the array of items
	     * currently being processed. Invoke with `queue.workersList()`.
	     * @property {Function} idle - a function returning false if there are items
	     * waiting or being processed, or true if not. Invoke with `queue.idle()`.
	     * @property {number} concurrency - an integer for determining how many `worker`
	     * functions should be run in parallel. This property can be changed after a
	     * `queue` is created to alter the concurrency on-the-fly.
	     * @property {number} payload - an integer that specifies how many items are
	     * passed to the worker function at a time. only applies if this is a
	     * [cargo]{@link module:ControlFlow.cargo} object
	     * @property {AsyncFunction} push - add a new task to the `queue`. Calls `callback`
	     * once the `worker` has finished processing the task. Instead of a single task,
	     * a `tasks` array can be submitted. The respective callback is used for every
	     * task in the list. Invoke with `queue.push(task, [callback])`,
	     * @property {AsyncFunction} unshift - add a new task to the front of the `queue`.
	     * Invoke with `queue.unshift(task, [callback])`.
	     * @property {AsyncFunction} pushAsync - the same as `q.push`, except this returns
	     * a promise that rejects if an error occurs.
	     * @property {AsyncFunction} unshirtAsync - the same as `q.unshift`, except this returns
	     * a promise that rejects if an error occurs.
	     * @property {Function} remove - remove items from the queue that match a test
	     * function.  The test function will be passed an object with a `data` property,
	     * and a `priority` property, if this is a
	     * [priorityQueue]{@link module:ControlFlow.priorityQueue} object.
	     * Invoked with `queue.remove(testFn)`, where `testFn` is of the form
	     * `function ({data, priority}) {}` and returns a Boolean.
	     * @property {Function} saturated - a function that sets a callback that is
	     * called when the number of running workers hits the `concurrency` limit, and
	     * further tasks will be queued.  If the callback is omitted, `q.saturated()`
	     * returns a promise for the next occurrence.
	     * @property {Function} unsaturated - a function that sets a callback that is
	     * called when the number of running workers is less than the `concurrency` &
	     * `buffer` limits, and further tasks will not be queued. If the callback is
	     * omitted, `q.unsaturated()` returns a promise for the next occurrence.
	     * @property {number} buffer - A minimum threshold buffer in order to say that
	     * the `queue` is `unsaturated`.
	     * @property {Function} empty - a function that sets a callback that is called
	     * when the last item from the `queue` is given to a `worker`. If the callback
	     * is omitted, `q.empty()` returns a promise for the next occurrence.
	     * @property {Function} drain - a function that sets a callback that is called
	     * when the last item from the `queue` has returned from the `worker`. If the
	     * callback is omitted, `q.drain()` returns a promise for the next occurrence.
	     * @property {Function} error - a function that sets a callback that is called
	     * when a task errors. Has the signature `function(error, task)`. If the
	     * callback is omitted, `error()` returns a promise that rejects on the next
	     * error.
	     * @property {boolean} paused - a boolean for determining whether the queue is
	     * in a paused state.
	     * @property {Function} pause - a function that pauses the processing of tasks
	     * until `resume()` is called. Invoke with `queue.pause()`.
	     * @property {Function} resume - a function that resumes the processing of
	     * queued tasks when the queue is paused. Invoke with `queue.resume()`.
	     * @property {Function} kill - a function that removes the `drain` callback and
	     * empties remaining tasks from the queue forcing it to go idle. No more tasks
	     * should be pushed to the queue after calling this function. Invoke with `queue.kill()`.
	     *
	     * @example
	     * const q = aync.queue(worker, 2)
	     * q.push(item1)
	     * q.push(item2)
	     * q.push(item3)
	     * // queues are iterable, spread into an array to inspect
	     * const items = [...q] // [item1, item2, item3]
	     * // or use for of
	     * for (let item of q) {
	     *     console.log(item)
	     * }
	     *
	     * q.drain(() => {
	     *     console.log('all done')
	     * })
	     * // or
	     * await q.drain()
	     */

	    /**
	     * Creates a `queue` object with the specified `concurrency`. Tasks added to the
	     * `queue` are processed in parallel (up to the `concurrency` limit). If all
	     * `worker`s are in progress, the task is queued until one becomes available.
	     * Once a `worker` completes a `task`, that `task`'s callback is called.
	     *
	     * @name queue
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {AsyncFunction} worker - An async function for processing a queued task.
	     * If you want to handle errors from an individual task, pass a callback to
	     * `q.push()`. Invoked with (task, callback).
	     * @param {number} [concurrency=1] - An `integer` for determining how many
	     * `worker` functions should be run in parallel.  If omitted, the concurrency
	     * defaults to `1`.  If the concurrency is `0`, an error is thrown.
	     * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can be
	     * attached as certain properties to listen for specific events during the
	     * lifecycle of the queue.
	     * @example
	     *
	     * // create a queue object with concurrency 2
	     * var q = async.queue(function(task, callback) {
	     *     console.log('hello ' + task.name);
	     *     callback();
	     * }, 2);
	     *
	     * // assign a callback
	     * q.drain(function() {
	     *     console.log('all items have been processed');
	     * });
	     * // or await the end
	     * await q.drain()
	     *
	     * // assign an error callback
	     * q.error(function(err, task) {
	     *     console.error('task experienced an error');
	     * });
	     *
	     * // add some items to the queue
	     * q.push({name: 'foo'}, function(err) {
	     *     console.log('finished processing foo');
	     * });
	     * // callback is optional
	     * q.push({name: 'bar'});
	     *
	     * // add some items to the queue (batch-wise)
	     * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
	     *     console.log('finished processing item');
	     * });
	     *
	     * // add some items to the front of the queue
	     * q.unshift({name: 'bar'}, function (err) {
	     *     console.log('finished processing bar');
	     * });
	     */
	    function queue$1 (worker, concurrency) {
	        var _worker = wrapAsync(worker);
	        return queue((items, cb) => {
	            _worker(items[0], cb);
	        }, concurrency, 1);
	    }

	    // Binary min-heap implementation used for priority queue.
	    // Implementation is stable, i.e. push time is considered for equal priorities
	    class Heap {
	        constructor() {
	            this.heap = [];
	            this.pushCount = Number.MIN_SAFE_INTEGER;
	        }

	        get length() {
	            return this.heap.length;
	        }

	        empty () {
	            this.heap = [];
	            return this;
	        }

	        percUp(index) {
	            let p;

	            while (index > 0 && smaller(this.heap[index], this.heap[p=parent(index)])) {
	                let t = this.heap[index];
	                this.heap[index] = this.heap[p];
	                this.heap[p] = t;

	                index = p;
	            }
	        }

	        percDown(index) {
	            let l;

	            while ((l=leftChi(index)) < this.heap.length) {
	                if (l+1 < this.heap.length && smaller(this.heap[l+1], this.heap[l])) {
	                    l = l+1;
	                }

	                if (smaller(this.heap[index], this.heap[l])) {
	                    break;
	                }

	                let t = this.heap[index];
	                this.heap[index] = this.heap[l];
	                this.heap[l] = t;

	                index = l;
	            }
	        }

	        push(node) {
	            node.pushCount = ++this.pushCount;
	            this.heap.push(node);
	            this.percUp(this.heap.length-1);
	        }

	        unshift(node) {
	            return this.heap.push(node);
	        }

	        shift() {
	            let [top] = this.heap;

	            this.heap[0] = this.heap[this.heap.length-1];
	            this.heap.pop();
	            this.percDown(0);

	            return top;
	        }

	        toArray() {
	            return [...this];
	        }

	        *[Symbol.iterator] () {
	            for (let i = 0; i < this.heap.length; i++) {
	                yield this.heap[i].data;
	            }
	        }

	        remove (testFn) {
	            let j = 0;
	            for (let i = 0; i < this.heap.length; i++) {
	                if (!testFn(this.heap[i])) {
	                    this.heap[j] = this.heap[i];
	                    j++;
	                }
	            }

	            this.heap.splice(j);

	            for (let i = parent(this.heap.length-1); i >= 0; i--) {
	                this.percDown(i);
	            }

	            return this;
	        }
	    }

	    function leftChi(i) {
	        return (i<<1)+1;
	    }

	    function parent(i) {
	        return ((i+1)>>1)-1;
	    }

	    function smaller(x, y) {
	        if (x.priority !== y.priority) {
	            return x.priority < y.priority;
	        }
	        else {
	            return x.pushCount < y.pushCount;
	        }
	    }

	    /**
	     * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
	     * completed in ascending priority order.
	     *
	     * @name priorityQueue
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.queue]{@link module:ControlFlow.queue}
	     * @category Control Flow
	     * @param {AsyncFunction} worker - An async function for processing a queued task.
	     * If you want to handle errors from an individual task, pass a callback to
	     * `q.push()`.
	     * Invoked with (task, callback).
	     * @param {number} concurrency - An `integer` for determining how many `worker`
	     * functions should be run in parallel.  If omitted, the concurrency defaults to
	     * `1`.  If the concurrency is `0`, an error is thrown.
	     * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
	     * differences between `queue` and `priorityQueue` objects:
	     * * `push(task, priority, [callback])` - `priority` should be a number. If an
	     *   array of `tasks` is given, all tasks will be assigned the same priority.
	     * * The `unshift` method was removed.
	     */
	    function priorityQueue(worker, concurrency) {
	        // Start with a normal queue
	        var q = queue$1(worker, concurrency);

	        q._tasks = new Heap();

	        // Override push to accept second parameter representing priority
	        q.push = function(data, priority = 0, callback = () => {}) {
	            if (typeof callback !== 'function') {
	                throw new Error('task callback must be a function');
	            }
	            q.started = true;
	            if (!Array.isArray(data)) {
	                data = [data];
	            }
	            if (data.length === 0 && q.idle()) {
	                // call drain immediately if there are no tasks
	                return setImmediate$1(() => q.drain());
	            }

	            for (var i = 0, l = data.length; i < l; i++) {
	                var item = {
	                    data: data[i],
	                    priority,
	                    callback
	                };

	                q._tasks.push(item);
	            }

	            setImmediate$1(q.process);
	        };

	        // Remove unshift function
	        delete q.unshift;

	        return q;
	    }

	    /**
	     * Runs the `tasks` array of functions in parallel, without waiting until the
	     * previous function has completed. Once any of the `tasks` complete or pass an
	     * error to its callback, the main `callback` is immediately called. It's
	     * equivalent to `Promise.race()`.
	     *
	     * @name race
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Array} tasks - An array containing [async functions]{@link AsyncFunction}
	     * to run. Each function can complete with an optional `result` value.
	     * @param {Function} callback - A callback to run once any of the functions have
	     * completed. This function gets an error or result from the first function that
	     * completed. Invoked with (err, result).
	     * @returns undefined
	     * @example
	     *
	     * async.race([
	     *     function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'one');
	     *         }, 200);
	     *     },
	     *     function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'two');
	     *         }, 100);
	     *     }
	     * ],
	     * // main callback
	     * function(err, result) {
	     *     // the result will be equal to 'two' as it finishes earlier
	     * });
	     */
	    function race(tasks, callback) {
	        callback = once(callback);
	        if (!Array.isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
	        if (!tasks.length) return callback();
	        for (var i = 0, l = tasks.length; i < l; i++) {
	            wrapAsync(tasks[i])(callback);
	        }
	    }

	    var race$1 = awaitify(race, 2);

	    /**
	     * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
	     *
	     * @name reduceRight
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.reduce]{@link module:Collections.reduce}
	     * @alias foldr
	     * @category Collection
	     * @param {Array} array - A collection to iterate over.
	     * @param {*} memo - The initial state of the reduction.
	     * @param {AsyncFunction} iteratee - A function applied to each item in the
	     * array to produce the next step in the reduction.
	     * The `iteratee` should complete with the next state of the reduction.
	     * If the iteratee complete with an error, the reduction is stopped and the
	     * main `callback` is immediately called with the error.
	     * Invoked with (memo, item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Result is the reduced value. Invoked with
	     * (err, result).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function reduceRight (array, memo, iteratee, callback) {
	        var reversed = [...array].reverse();
	        return reduce$1(reversed, memo, iteratee, callback);
	    }

	    /**
	     * Wraps the async function in another function that always completes with a
	     * result object, even when it errors.
	     *
	     * The result object has either the property `error` or `value`.
	     *
	     * @name reflect
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {AsyncFunction} fn - The async function you want to wrap
	     * @returns {Function} - A function that always passes null to it's callback as
	     * the error. The second argument to the callback will be an `object` with
	     * either an `error` or a `value` property.
	     * @example
	     *
	     * async.parallel([
	     *     async.reflect(function(callback) {
	     *         // do some stuff ...
	     *         callback(null, 'one');
	     *     }),
	     *     async.reflect(function(callback) {
	     *         // do some more stuff but error ...
	     *         callback('bad stuff happened');
	     *     }),
	     *     async.reflect(function(callback) {
	     *         // do some more stuff ...
	     *         callback(null, 'two');
	     *     })
	     * ],
	     * // optional callback
	     * function(err, results) {
	     *     // values
	     *     // results[0].value = 'one'
	     *     // results[1].error = 'bad stuff happened'
	     *     // results[2].value = 'two'
	     * });
	     */
	    function reflect(fn) {
	        var _fn = wrapAsync(fn);
	        return initialParams(function reflectOn(args, reflectCallback) {
	            args.push((error, ...cbArgs) => {
	                let retVal = {};
	                if (error) {
	                    retVal.error = error;
	                }
	                if (cbArgs.length > 0){
	                    var value = cbArgs;
	                    if (cbArgs.length <= 1) {
	                        [value] = cbArgs;
	                    }
	                    retVal.value = value;
	                }
	                reflectCallback(null, retVal);
	            });

	            return _fn.apply(this, args);
	        });
	    }

	    /**
	     * A helper function that wraps an array or an object of functions with `reflect`.
	     *
	     * @name reflectAll
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @see [async.reflect]{@link module:Utils.reflect}
	     * @category Util
	     * @param {Array|Object|Iterable} tasks - The collection of
	     * [async functions]{@link AsyncFunction} to wrap in `async.reflect`.
	     * @returns {Array} Returns an array of async functions, each wrapped in
	     * `async.reflect`
	     * @example
	     *
	     * let tasks = [
	     *     function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'one');
	     *         }, 200);
	     *     },
	     *     function(callback) {
	     *         // do some more stuff but error ...
	     *         callback(new Error('bad stuff happened'));
	     *     },
	     *     function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'two');
	     *         }, 100);
	     *     }
	     * ];
	     *
	     * async.parallel(async.reflectAll(tasks),
	     * // optional callback
	     * function(err, results) {
	     *     // values
	     *     // results[0].value = 'one'
	     *     // results[1].error = Error('bad stuff happened')
	     *     // results[2].value = 'two'
	     * });
	     *
	     * // an example using an object instead of an array
	     * let tasks = {
	     *     one: function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'one');
	     *         }, 200);
	     *     },
	     *     two: function(callback) {
	     *         callback('two');
	     *     },
	     *     three: function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 'three');
	     *         }, 100);
	     *     }
	     * };
	     *
	     * async.parallel(async.reflectAll(tasks),
	     * // optional callback
	     * function(err, results) {
	     *     // values
	     *     // results.one.value = 'one'
	     *     // results.two.error = 'two'
	     *     // results.three.value = 'three'
	     * });
	     */
	    function reflectAll(tasks) {
	        var results;
	        if (Array.isArray(tasks)) {
	            results = tasks.map(reflect);
	        } else {
	            results = {};
	            Object.keys(tasks).forEach(key => {
	                results[key] = reflect.call(this, tasks[key]);
	            });
	        }
	        return results;
	    }

	    function reject(eachfn, arr, _iteratee, callback) {
	        const iteratee = wrapAsync(_iteratee);
	        return _filter(eachfn, arr, (value, cb) => {
	            iteratee(value, (err, v) => {
	                cb(err, !v);
	            });
	        }, callback);
	    }

	    /**
	     * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
	     *
	     * @name reject
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.filter]{@link module:Collections.filter}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {Function} iteratee - An async truth test to apply to each item in
	     * `coll`.
	     * The should complete with a boolean value as its `result`.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * async.reject(['file1','file2','file3'], function(filePath, callback) {
	     *     fs.access(filePath, function(err) {
	     *         callback(null, !err)
	     *     });
	     * }, function(err, results) {
	     *     // results now equals an array of missing files
	     *     createFiles(results);
	     * });
	     */
	    function reject$1 (coll, iteratee, callback) {
	        return reject(eachOf$1, coll, iteratee, callback)
	    }
	    var reject$2 = awaitify(reject$1, 3);

	    /**
	     * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name rejectLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.reject]{@link module:Collections.reject}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {Function} iteratee - An async truth test to apply to each item in
	     * `coll`.
	     * The should complete with a boolean value as its `result`.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function rejectLimit (coll, limit, iteratee, callback) {
	        return reject(eachOfLimit(limit), coll, iteratee, callback)
	    }
	    var rejectLimit$1 = awaitify(rejectLimit, 4);

	    /**
	     * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
	     *
	     * @name rejectSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.reject]{@link module:Collections.reject}
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {Function} iteratee - An async truth test to apply to each item in
	     * `coll`.
	     * The should complete with a boolean value as its `result`.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     */
	    function rejectSeries (coll, iteratee, callback) {
	        return reject(eachOfSeries$1, coll, iteratee, callback)
	    }
	    var rejectSeries$1 = awaitify(rejectSeries, 3);

	    function constant$1(value) {
	        return function () {
	            return value;
	        }
	    }

	    /**
	     * Attempts to get a successful response from `task` no more than `times` times
	     * before returning an error. If the task is successful, the `callback` will be
	     * passed the result of the successful task. If all attempts fail, the callback
	     * will be passed the error and result (if any) of the final attempt.
	     *
	     * @name retry
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @see [async.retryable]{@link module:ControlFlow.retryable}
	     * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
	     * object with `times` and `interval` or a number.
	     * * `times` - The number of attempts to make before giving up.  The default
	     *   is `5`.
	     * * `interval` - The time to wait between retries, in milliseconds.  The
	     *   default is `0`. The interval may also be specified as a function of the
	     *   retry count (see example).
	     * * `errorFilter` - An optional synchronous function that is invoked on
	     *   erroneous result. If it returns `true` the retry attempts will continue;
	     *   if the function returns `false` the retry flow is aborted with the current
	     *   attempt's error and result being returned to the final callback.
	     *   Invoked with (err).
	     * * If `opts` is a number, the number specifies the number of times to retry,
	     *   with the default interval of `0`.
	     * @param {AsyncFunction} task - An async function to retry.
	     * Invoked with (callback).
	     * @param {Function} [callback] - An optional callback which is called when the
	     * task has succeeded, or after the final failed attempt. It receives the `err`
	     * and `result` arguments of the last attempt at completing the `task`. Invoked
	     * with (err, results).
	     * @returns {Promise} a promise if no callback provided
	     *
	     * @example
	     *
	     * // The `retry` function can be used as a stand-alone control flow by passing
	     * // a callback, as shown below:
	     *
	     * // try calling apiMethod 3 times
	     * async.retry(3, apiMethod, function(err, result) {
	     *     // do something with the result
	     * });
	     *
	     * // try calling apiMethod 3 times, waiting 200 ms between each retry
	     * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
	     *     // do something with the result
	     * });
	     *
	     * // try calling apiMethod 10 times with exponential backoff
	     * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
	     * async.retry({
	     *   times: 10,
	     *   interval: function(retryCount) {
	     *     return 50 * Math.pow(2, retryCount);
	     *   }
	     * }, apiMethod, function(err, result) {
	     *     // do something with the result
	     * });
	     *
	     * // try calling apiMethod the default 5 times no delay between each retry
	     * async.retry(apiMethod, function(err, result) {
	     *     // do something with the result
	     * });
	     *
	     * // try calling apiMethod only when error condition satisfies, all other
	     * // errors will abort the retry control flow and return to final callback
	     * async.retry({
	     *   errorFilter: function(err) {
	     *     return err.message === 'Temporary error'; // only retry on a specific error
	     *   }
	     * }, apiMethod, function(err, result) {
	     *     // do something with the result
	     * });
	     *
	     * // to retry individual methods that are not as reliable within other
	     * // control flow functions, use the `retryable` wrapper:
	     * async.auto({
	     *     users: api.getUsers.bind(api),
	     *     payments: async.retryable(3, api.getPayments.bind(api))
	     * }, function(err, results) {
	     *     // do something with the results
	     * });
	     *
	     */
	    const DEFAULT_TIMES = 5;
	    const DEFAULT_INTERVAL = 0;

	    function retry(opts, task, callback) {
	        var options = {
	            times: DEFAULT_TIMES,
	            intervalFunc: constant$1(DEFAULT_INTERVAL)
	        };

	        if (arguments.length < 3 && typeof opts === 'function') {
	            callback = task || promiseCallback();
	            task = opts;
	        } else {
	            parseTimes(options, opts);
	            callback = callback || promiseCallback();
	        }

	        if (typeof task !== 'function') {
	            throw new Error("Invalid arguments for async.retry");
	        }

	        var _task = wrapAsync(task);

	        var attempt = 1;
	        function retryAttempt() {
	            _task((err, ...args) => {
	                if (err === false) return
	                if (err && attempt++ < options.times &&
	                    (typeof options.errorFilter != 'function' ||
	                        options.errorFilter(err))) {
	                    setTimeout(retryAttempt, options.intervalFunc(attempt - 1));
	                } else {
	                    callback(err, ...args);
	                }
	            });
	        }

	        retryAttempt();
	        return callback[PROMISE_SYMBOL]
	    }

	    function parseTimes(acc, t) {
	        if (typeof t === 'object') {
	            acc.times = +t.times || DEFAULT_TIMES;

	            acc.intervalFunc = typeof t.interval === 'function' ?
	                t.interval :
	                constant$1(+t.interval || DEFAULT_INTERVAL);

	            acc.errorFilter = t.errorFilter;
	        } else if (typeof t === 'number' || typeof t === 'string') {
	            acc.times = +t || DEFAULT_TIMES;
	        } else {
	            throw new Error("Invalid arguments for async.retry");
	        }
	    }

	    /**
	     * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method
	     * wraps a task and makes it retryable, rather than immediately calling it
	     * with retries.
	     *
	     * @name retryable
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.retry]{@link module:ControlFlow.retry}
	     * @category Control Flow
	     * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
	     * options, exactly the same as from `retry`, except for a `opts.arity` that
	     * is the arity of the `task` function, defaulting to `task.length`
	     * @param {AsyncFunction} task - the asynchronous function to wrap.
	     * This function will be passed any arguments passed to the returned wrapper.
	     * Invoked with (...args, callback).
	     * @returns {AsyncFunction} The wrapped function, which when invoked, will
	     * retry on an error, based on the parameters specified in `opts`.
	     * This function will accept the same parameters as `task`.
	     * @example
	     *
	     * async.auto({
	     *     dep1: async.retryable(3, getFromFlakyService),
	     *     process: ["dep1", async.retryable(3, function (results, cb) {
	     *         maybeProcessData(results.dep1, cb);
	     *     })]
	     * }, callback);
	     */
	    function retryable (opts, task) {
	        if (!task) {
	            task = opts;
	            opts = null;
	        }
	        let arity = (opts && opts.arity) || task.length;
	        if (isAsync(task)) {
	            arity += 1;
	        }
	        var _task = wrapAsync(task);
	        return initialParams((args, callback) => {
	            if (args.length < arity - 1 || callback == null) {
	                args.push(callback);
	                callback = promiseCallback();
	            }
	            function taskFn(cb) {
	                _task(...args, cb);
	            }

	            if (opts) retry(opts, taskFn, callback);
	            else retry(taskFn, callback);

	            return callback[PROMISE_SYMBOL]
	        });
	    }

	    /**
	     * Run the functions in the `tasks` collection in series, each one running once
	     * the previous function has completed. If any functions in the series pass an
	     * error to its callback, no more functions are run, and `callback` is
	     * immediately called with the value of the error. Otherwise, `callback`
	     * receives an array of results when `tasks` have completed.
	     *
	     * It is also possible to use an object instead of an array. Each property will
	     * be run as a function, and the results will be passed to the final `callback`
	     * as an object instead of an array. This can be a more readable way of handling
	     *  results from {@link async.series}.
	     *
	     * **Note** that while many implementations preserve the order of object
	     * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
	     * explicitly states that
	     *
	     * > The mechanics and order of enumerating the properties is not specified.
	     *
	     * So if you rely on the order in which your series of functions are executed,
	     * and want this to work on all platforms, consider using an array.
	     *
	     * @name series
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing
	     * [async functions]{@link AsyncFunction} to run in series.
	     * Each function can complete with any number of optional `result` values.
	     * @param {Function} [callback] - An optional callback to run once all the
	     * functions have completed. This function gets a results array (or object)
	     * containing all the result arguments passed to the `task` callbacks. Invoked
	     * with (err, result).
	     * @return {Promise} a promise, if no callback is passed
	     * @example
	     * async.series([
	     *     function(callback) {
	     *         // do some stuff ...
	     *         callback(null, 'one');
	     *     },
	     *     function(callback) {
	     *         // do some more stuff ...
	     *         callback(null, 'two');
	     *     }
	     * ],
	     * // optional callback
	     * function(err, results) {
	     *     // results is now equal to ['one', 'two']
	     * });
	     *
	     * async.series({
	     *     one: function(callback) {
	     *         setTimeout(function() {
	     *             callback(null, 1);
	     *         }, 200);
	     *     },
	     *     two: function(callback){
	     *         setTimeout(function() {
	     *             callback(null, 2);
	     *         }, 100);
	     *     }
	     * }, function(err, results) {
	     *     // results is now equal to: {one: 1, two: 2}
	     * });
	     */
	    function series(tasks, callback) {
	        return _parallel(eachOfSeries$1, tasks, callback);
	    }

	    /**
	     * Returns `true` if at least one element in the `coll` satisfies an async test.
	     * If any iteratee call returns `true`, the main `callback` is immediately
	     * called.
	     *
	     * @name some
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @alias any
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	     * in the collections in parallel.
	     * The iteratee should complete with a boolean `result` value.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called as soon as any
	     * iteratee returns `true`, or after all the iteratee functions have finished.
	     * Result will be either `true` or `false` depending on the values of the async
	     * tests. Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     * @example
	     *
	     * async.some(['file1','file2','file3'], function(filePath, callback) {
	     *     fs.access(filePath, function(err) {
	     *         callback(null, !err)
	     *     });
	     * }, function(err, result) {
	     *     // if result is true then at least one of the files exists
	     * });
	     */
	    function some(coll, iteratee, callback) {
	        return _createTester(Boolean, res => res)(eachOf$1, coll, iteratee, callback)
	    }
	    var some$1 = awaitify(some, 3);

	    /**
	     * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
	     *
	     * @name someLimit
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.some]{@link module:Collections.some}
	     * @alias anyLimit
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	     * in the collections in parallel.
	     * The iteratee should complete with a boolean `result` value.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called as soon as any
	     * iteratee returns `true`, or after all the iteratee functions have finished.
	     * Result will be either `true` or `false` depending on the values of the async
	     * tests. Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     */
	    function someLimit(coll, limit, iteratee, callback) {
	        return _createTester(Boolean, res => res)(eachOfLimit(limit), coll, iteratee, callback)
	    }
	    var someLimit$1 = awaitify(someLimit, 4);

	    /**
	     * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
	     *
	     * @name someSeries
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @see [async.some]{@link module:Collections.some}
	     * @alias anySeries
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async truth test to apply to each item
	     * in the collections in series.
	     * The iteratee should complete with a boolean `result` value.
	     * Invoked with (item, callback).
	     * @param {Function} [callback] - A callback which is called as soon as any
	     * iteratee returns `true`, or after all the iteratee functions have finished.
	     * Result will be either `true` or `false` depending on the values of the async
	     * tests. Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     */
	    function someSeries(coll, iteratee, callback) {
	        return _createTester(Boolean, res => res)(eachOfSeries$1, coll, iteratee, callback)
	    }
	    var someSeries$1 = awaitify(someSeries, 3);

	    /**
	     * Sorts a list by the results of running each `coll` value through an async
	     * `iteratee`.
	     *
	     * @name sortBy
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {AsyncFunction} iteratee - An async function to apply to each item in
	     * `coll`.
	     * The iteratee should complete with a value to use as the sort criteria as
	     * its `result`.
	     * Invoked with (item, callback).
	     * @param {Function} callback - A callback which is called after all the
	     * `iteratee` functions have finished, or an error occurs. Results is the items
	     * from the original `coll` sorted by the values returned by the `iteratee`
	     * calls. Invoked with (err, results).
	     * @returns {Promise} a promise, if no callback passed
	     * @example
	     *
	     * async.sortBy(['file1','file2','file3'], function(file, callback) {
	     *     fs.stat(file, function(err, stats) {
	     *         callback(err, stats.mtime);
	     *     });
	     * }, function(err, results) {
	     *     // results is now the original array of files sorted by
	     *     // modified date
	     * });
	     *
	     * // By modifying the callback parameter the
	     * // sorting order can be influenced:
	     *
	     * // ascending order
	     * async.sortBy([1,9,3,5], function(x, callback) {
	     *     callback(null, x);
	     * }, function(err,result) {
	     *     // result callback
	     * });
	     *
	     * // descending order
	     * async.sortBy([1,9,3,5], function(x, callback) {
	     *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
	     * }, function(err,result) {
	     *     // result callback
	     * });
	     */
	    function sortBy (coll, iteratee, callback) {
	        var _iteratee = wrapAsync(iteratee);
	        return map$1(coll, (x, iterCb) => {
	            _iteratee(x, (err, criteria) => {
	                if (err) return iterCb(err);
	                iterCb(err, {value: x, criteria});
	            });
	        }, (err, results) => {
	            if (err) return callback(err);
	            callback(null, results.sort(comparator).map(v => v.value));
	        });

	        function comparator(left, right) {
	            var a = left.criteria, b = right.criteria;
	            return a < b ? -1 : a > b ? 1 : 0;
	        }
	    }
	    var sortBy$1 = awaitify(sortBy, 3);

	    /**
	     * Sets a time limit on an asynchronous function. If the function does not call
	     * its callback within the specified milliseconds, it will be called with a
	     * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
	     *
	     * @name timeout
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @category Util
	     * @param {AsyncFunction} asyncFn - The async function to limit in time.
	     * @param {number} milliseconds - The specified time limit.
	     * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
	     * to timeout Error for more information..
	     * @returns {AsyncFunction} Returns a wrapped function that can be used with any
	     * of the control flow functions.
	     * Invoke this function with the same parameters as you would `asyncFunc`.
	     * @example
	     *
	     * function myFunction(foo, callback) {
	     *     doAsyncTask(foo, function(err, data) {
	     *         // handle errors
	     *         if (err) return callback(err);
	     *
	     *         // do some stuff ...
	     *
	     *         // return processed data
	     *         return callback(null, data);
	     *     });
	     * }
	     *
	     * var wrapped = async.timeout(myFunction, 1000);
	     *
	     * // call `wrapped` as you would `myFunction`
	     * wrapped({ bar: 'bar' }, function(err, data) {
	     *     // if `myFunction` takes < 1000 ms to execute, `err`
	     *     // and `data` will have their expected values
	     *
	     *     // else `err` will be an Error with the code 'ETIMEDOUT'
	     * });
	     */
	    function timeout(asyncFn, milliseconds, info) {
	        var fn = wrapAsync(asyncFn);

	        return initialParams((args, callback) => {
	            var timedOut = false;
	            var timer;

	            function timeoutCallback() {
	                var name = asyncFn.name || 'anonymous';
	                var error  = new Error('Callback function "' + name + '" timed out.');
	                error.code = 'ETIMEDOUT';
	                if (info) {
	                    error.info = info;
	                }
	                timedOut = true;
	                callback(error);
	            }

	            args.push((...cbArgs) => {
	                if (!timedOut) {
	                    callback(...cbArgs);
	                    clearTimeout(timer);
	                }
	            });

	            // setup timer and call original function
	            timer = setTimeout(timeoutCallback, milliseconds);
	            fn(...args);
	        });
	    }

	    function range(size) {
	        var result = Array(size);
	        while (size--) {
	            result[size] = size;
	        }
	        return result;
	    }

	    /**
	     * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
	     * time.
	     *
	     * @name timesLimit
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.times]{@link module:ControlFlow.times}
	     * @category Control Flow
	     * @param {number} count - The number of times to run the function.
	     * @param {number} limit - The maximum number of async operations at a time.
	     * @param {AsyncFunction} iteratee - The async function to call `n` times.
	     * Invoked with the iteration index and a callback: (n, next).
	     * @param {Function} callback - see [async.map]{@link module:Collections.map}.
	     * @returns {Promise} a promise, if no callback is provided
	     */
	    function timesLimit(count, limit, iteratee, callback) {
	        var _iteratee = wrapAsync(iteratee);
	        return mapLimit$1(range(count), limit, _iteratee, callback);
	    }

	    /**
	     * Calls the `iteratee` function `n` times, and accumulates results in the same
	     * manner you would use with [map]{@link module:Collections.map}.
	     *
	     * @name times
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.map]{@link module:Collections.map}
	     * @category Control Flow
	     * @param {number} n - The number of times to run the function.
	     * @param {AsyncFunction} iteratee - The async function to call `n` times.
	     * Invoked with the iteration index and a callback: (n, next).
	     * @param {Function} callback - see {@link module:Collections.map}.
	     * @returns {Promise} a promise, if no callback is provided
	     * @example
	     *
	     * // Pretend this is some complicated async factory
	     * var createUser = function(id, callback) {
	     *     callback(null, {
	     *         id: 'user' + id
	     *     });
	     * };
	     *
	     * // generate 5 users
	     * async.times(5, function(n, next) {
	     *     createUser(n, function(err, user) {
	     *         next(err, user);
	     *     });
	     * }, function(err, users) {
	     *     // we should now have 5 users
	     * });
	     */
	    function times (n, iteratee, callback) {
	        return timesLimit(n, Infinity, iteratee, callback)
	    }

	    /**
	     * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
	     *
	     * @name timesSeries
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.times]{@link module:ControlFlow.times}
	     * @category Control Flow
	     * @param {number} n - The number of times to run the function.
	     * @param {AsyncFunction} iteratee - The async function to call `n` times.
	     * Invoked with the iteration index and a callback: (n, next).
	     * @param {Function} callback - see {@link module:Collections.map}.
	     * @returns {Promise} a promise, if no callback is provided
	     */
	    function timesSeries (n, iteratee, callback) {
	        return timesLimit(n, 1, iteratee, callback)
	    }

	    /**
	     * A relative of `reduce`.  Takes an Object or Array, and iterates over each
	     * element in parallel, each step potentially mutating an `accumulator` value.
	     * The type of the accumulator defaults to the type of collection passed in.
	     *
	     * @name transform
	     * @static
	     * @memberOf module:Collections
	     * @method
	     * @category Collection
	     * @param {Array|Iterable|AsyncIterable|Object} coll - A collection to iterate over.
	     * @param {*} [accumulator] - The initial state of the transform.  If omitted,
	     * it will default to an empty Object or Array, depending on the type of `coll`
	     * @param {AsyncFunction} iteratee - A function applied to each item in the
	     * collection that potentially modifies the accumulator.
	     * Invoked with (accumulator, item, key, callback).
	     * @param {Function} [callback] - A callback which is called after all the
	     * `iteratee` functions have finished. Result is the transformed accumulator.
	     * Invoked with (err, result).
	     * @returns {Promise} a promise, if no callback provided
	     * @example
	     *
	     * async.transform([1,2,3], function(acc, item, index, callback) {
	     *     // pointless async:
	     *     process.nextTick(function() {
	     *         acc[index] = item * 2
	     *         callback(null)
	     *     });
	     * }, function(err, result) {
	     *     // result is now equal to [2, 4, 6]
	     * });
	     *
	     * @example
	     *
	     * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
	     *     setImmediate(function () {
	     *         obj[key] = val * 2;
	     *         callback();
	     *     })
	     * }, function (err, result) {
	     *     // result is equal to {a: 2, b: 4, c: 6}
	     * })
	     */
	    function transform (coll, accumulator, iteratee, callback) {
	        if (arguments.length <= 3 && typeof accumulator === 'function') {
	            callback = iteratee;
	            iteratee = accumulator;
	            accumulator = Array.isArray(coll) ? [] : {};
	        }
	        callback = once(callback || promiseCallback());
	        var _iteratee = wrapAsync(iteratee);

	        eachOf$1(coll, (v, k, cb) => {
	            _iteratee(accumulator, v, k, cb);
	        }, err => callback(err, accumulator));
	        return callback[PROMISE_SYMBOL]
	    }

	    /**
	     * It runs each task in series but stops whenever any of the functions were
	     * successful. If one of the tasks were successful, the `callback` will be
	     * passed the result of the successful task. If all tasks fail, the callback
	     * will be passed the error and result (if any) of the final attempt.
	     *
	     * @name tryEach
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Array|Iterable|AsyncIterable|Object} tasks - A collection containing functions to
	     * run, each function is passed a `callback(err, result)` it must call on
	     * completion with an error `err` (which can be `null`) and an optional `result`
	     * value.
	     * @param {Function} [callback] - An optional callback which is called when one
	     * of the tasks has succeeded, or all have failed. It receives the `err` and
	     * `result` arguments of the last attempt at completing the `task`. Invoked with
	     * (err, results).
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     * async.tryEach([
	     *     function getDataFromFirstWebsite(callback) {
	     *         // Try getting the data from the first website
	     *         callback(err, data);
	     *     },
	     *     function getDataFromSecondWebsite(callback) {
	     *         // First website failed,
	     *         // Try getting the data from the backup website
	     *         callback(err, data);
	     *     }
	     * ],
	     * // optional callback
	     * function(err, results) {
	     *     Now do something with the data.
	     * });
	     *
	     */
	    function tryEach(tasks, callback) {
	        var error = null;
	        var result;
	        return eachSeries$1(tasks, (task, taskCb) => {
	            wrapAsync(task)((err, ...args) => {
	                if (err === false) return taskCb(err);

	                if (args.length < 2) {
	                    [result] = args;
	                } else {
	                    result = args;
	                }
	                error = err;
	                taskCb(err ? null : {});
	            });
	        }, () => callback(error, result));
	    }

	    var tryEach$1 = awaitify(tryEach);

	    /**
	     * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
	     * unmemoized form. Handy for testing.
	     *
	     * @name unmemoize
	     * @static
	     * @memberOf module:Utils
	     * @method
	     * @see [async.memoize]{@link module:Utils.memoize}
	     * @category Util
	     * @param {AsyncFunction} fn - the memoized function
	     * @returns {AsyncFunction} a function that calls the original unmemoized function
	     */
	    function unmemoize(fn) {
	        return (...args) => {
	            return (fn.unmemoized || fn)(...args);
	        };
	    }

	    /**
	     * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
	     * stopped, or an error occurs.
	     *
	     * @name whilst
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {AsyncFunction} test - asynchronous truth test to perform before each
	     * execution of `iteratee`. Invoked with ().
	     * @param {AsyncFunction} iteratee - An async function which is called each time
	     * `test` passes. Invoked with (callback).
	     * @param {Function} [callback] - A callback which is called after the test
	     * function has failed and repeated execution of `iteratee` has stopped. `callback`
	     * will be passed an error and any arguments passed to the final `iteratee`'s
	     * callback. Invoked with (err, [results]);
	     * @returns {Promise} a promise, if no callback is passed
	     * @example
	     *
	     * var count = 0;
	     * async.whilst(
	     *     function test(cb) { cb(null, count < 5;) },
	     *     function iter(callback) {
	     *         count++;
	     *         setTimeout(function() {
	     *             callback(null, count);
	     *         }, 1000);
	     *     },
	     *     function (err, n) {
	     *         // 5 seconds have passed, n = 5
	     *     }
	     * );
	     */
	    function whilst(test, iteratee, callback) {
	        callback = onlyOnce(callback);
	        var _fn = wrapAsync(iteratee);
	        var _test = wrapAsync(test);
	        var results = [];

	        function next(err, ...rest) {
	            if (err) return callback(err);
	            results = rest;
	            if (err === false) return;
	            _test(check);
	        }

	        function check(err, truth) {
	            if (err) return callback(err);
	            if (err === false) return;
	            if (!truth) return callback(null, ...results);
	            _fn(next);
	        }

	        return _test(check);
	    }
	    var whilst$1 = awaitify(whilst, 3);

	    /**
	     * Repeatedly call `iteratee` until `test` returns `true`. Calls `callback` when
	     * stopped, or an error occurs. `callback` will be passed an error and any
	     * arguments passed to the final `iteratee`'s callback.
	     *
	     * The inverse of [whilst]{@link module:ControlFlow.whilst}.
	     *
	     * @name until
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @see [async.whilst]{@link module:ControlFlow.whilst}
	     * @category Control Flow
	     * @param {AsyncFunction} test - asynchronous truth test to perform before each
	     * execution of `iteratee`. Invoked with (callback).
	     * @param {AsyncFunction} iteratee - An async function which is called each time
	     * `test` fails. Invoked with (callback).
	     * @param {Function} [callback] - A callback which is called after the test
	     * function has passed and repeated execution of `iteratee` has stopped. `callback`
	     * will be passed an error and any arguments passed to the final `iteratee`'s
	     * callback. Invoked with (err, [results]);
	     * @returns {Promise} a promise, if a callback is not passed
	     *
	     * @example
	     * const results = []
	     * async.until(function test(page, cb) {
	     *     cb(null, page.next == null)
	     * }, function iter(next) {
	     *     fetchPage(url, (err, body) => {
	     *         if (err) return next(err)
	     *         results = results.concat(body.objects)
	     *         next(err, body)
	     *     })
	     * }, function done (err) {
	     *     // all pages have been fetched
	     * })
	     */
	    function until(test, iteratee, callback) {
	        const _test = wrapAsync(test);
	        return whilst$1((cb) => _test((err, truth) => cb (err, !truth)), iteratee, callback);
	    }

	    /**
	     * Runs the `tasks` array of functions in series, each passing their results to
	     * the next in the array. However, if any of the `tasks` pass an error to their
	     * own callback, the next function is not executed, and the main `callback` is
	     * immediately called with the error.
	     *
	     * @name waterfall
	     * @static
	     * @memberOf module:ControlFlow
	     * @method
	     * @category Control Flow
	     * @param {Array} tasks - An array of [async functions]{@link AsyncFunction}
	     * to run.
	     * Each function should complete with any number of `result` values.
	     * The `result` values will be passed as arguments, in order, to the next task.
	     * @param {Function} [callback] - An optional callback to run once all the
	     * functions have completed. This will be passed the results of the last task's
	     * callback. Invoked with (err, [results]).
	     * @returns undefined
	     * @example
	     *
	     * async.waterfall([
	     *     function(callback) {
	     *         callback(null, 'one', 'two');
	     *     },
	     *     function(arg1, arg2, callback) {
	     *         // arg1 now equals 'one' and arg2 now equals 'two'
	     *         callback(null, 'three');
	     *     },
	     *     function(arg1, callback) {
	     *         // arg1 now equals 'three'
	     *         callback(null, 'done');
	     *     }
	     * ], function (err, result) {
	     *     // result now equals 'done'
	     * });
	     *
	     * // Or, with named functions:
	     * async.waterfall([
	     *     myFirstFunction,
	     *     mySecondFunction,
	     *     myLastFunction,
	     * ], function (err, result) {
	     *     // result now equals 'done'
	     * });
	     * function myFirstFunction(callback) {
	     *     callback(null, 'one', 'two');
	     * }
	     * function mySecondFunction(arg1, arg2, callback) {
	     *     // arg1 now equals 'one' and arg2 now equals 'two'
	     *     callback(null, 'three');
	     * }
	     * function myLastFunction(arg1, callback) {
	     *     // arg1 now equals 'three'
	     *     callback(null, 'done');
	     * }
	     */
	    function waterfall (tasks, callback) {
	        callback = once(callback);
	        if (!Array.isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
	        if (!tasks.length) return callback();
	        var taskIndex = 0;

	        function nextTask(args) {
	            var task = wrapAsync(tasks[taskIndex++]);
	            task(...args, onlyOnce(next));
	        }

	        function next(err, ...args) {
	            if (err === false) return
	            if (err || taskIndex === tasks.length) {
	                return callback(err, ...args);
	            }
	            nextTask(args);
	        }

	        nextTask([]);
	    }

	    var waterfall$1 = awaitify(waterfall);

	    /**
	     * An "async function" in the context of Async is an asynchronous function with
	     * a variable number of parameters, with the final parameter being a callback.
	     * (`function (arg1, arg2, ..., callback) {}`)
	     * The final callback is of the form `callback(err, results...)`, which must be
	     * called once the function is completed.  The callback should be called with a
	     * Error as its first argument to signal that an error occurred.
	     * Otherwise, if no error occurred, it should be called with `null` as the first
	     * argument, and any additional `result` arguments that may apply, to signal
	     * successful completion.
	     * The callback must be called exactly once, ideally on a later tick of the
	     * JavaScript event loop.
	     *
	     * This type of function is also referred to as a "Node-style async function",
	     * or a "continuation passing-style function" (CPS). Most of the methods of this
	     * library are themselves CPS/Node-style async functions, or functions that
	     * return CPS/Node-style async functions.
	     *
	     * Wherever we accept a Node-style async function, we also directly accept an
	     * [ES2017 `async` function]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/async_function}.
	     * In this case, the `async` function will not be passed a final callback
	     * argument, and any thrown error will be used as the `err` argument of the
	     * implicit callback, and the return value will be used as the `result` value.
	     * (i.e. a `rejected` of the returned Promise becomes the `err` callback
	     * argument, and a `resolved` value becomes the `result`.)
	     *
	     * Note, due to JavaScript limitations, we can only detect native `async`
	     * functions and not transpilied implementations.
	     * Your environment must have `async`/`await` support for this to work.
	     * (e.g. Node > v7.6, or a recent version of a modern browser).
	     * If you are using `async` functions through a transpiler (e.g. Babel), you
	     * must still wrap the function with [asyncify]{@link module:Utils.asyncify},
	     * because the `async function` will be compiled to an ordinary function that
	     * returns a promise.
	     *
	     * @typedef {Function} AsyncFunction
	     * @static
	     */

	    var index = {
	        apply,
	        applyEach: applyEach$1,
	        applyEachSeries,
	        asyncify,
	        auto,
	        autoInject,
	        cargo,
	        cargoQueue: cargo$1,
	        compose,
	        concat: concat$1,
	        concatLimit: concatLimit$1,
	        concatSeries: concatSeries$1,
	        constant,
	        detect: detect$1,
	        detectLimit: detectLimit$1,
	        detectSeries: detectSeries$1,
	        dir,
	        doUntil,
	        doWhilst: doWhilst$1,
	        each,
	        eachLimit: eachLimit$2,
	        eachOf: eachOf$1,
	        eachOfLimit: eachOfLimit$2,
	        eachOfSeries: eachOfSeries$1,
	        eachSeries: eachSeries$1,
	        ensureAsync,
	        every: every$1,
	        everyLimit: everyLimit$1,
	        everySeries: everySeries$1,
	        filter: filter$1,
	        filterLimit: filterLimit$1,
	        filterSeries: filterSeries$1,
	        forever: forever$1,
	        groupBy,
	        groupByLimit: groupByLimit$1,
	        groupBySeries,
	        log,
	        map: map$1,
	        mapLimit: mapLimit$1,
	        mapSeries: mapSeries$1,
	        mapValues,
	        mapValuesLimit: mapValuesLimit$1,
	        mapValuesSeries,
	        memoize,
	        nextTick,
	        parallel,
	        parallelLimit,
	        priorityQueue,
	        queue: queue$1,
	        race: race$1,
	        reduce: reduce$1,
	        reduceRight,
	        reflect,
	        reflectAll,
	        reject: reject$2,
	        rejectLimit: rejectLimit$1,
	        rejectSeries: rejectSeries$1,
	        retry,
	        retryable,
	        seq,
	        series,
	        setImmediate: setImmediate$1,
	        some: some$1,
	        someLimit: someLimit$1,
	        someSeries: someSeries$1,
	        sortBy: sortBy$1,
	        timeout,
	        times,
	        timesLimit,
	        timesSeries,
	        transform,
	        tryEach: tryEach$1,
	        unmemoize,
	        until,
	        waterfall: waterfall$1,
	        whilst: whilst$1,

	        // aliases
	        all: every$1,
	        allLimit: everyLimit$1,
	        allSeries: everySeries$1,
	        any: some$1,
	        anyLimit: someLimit$1,
	        anySeries: someSeries$1,
	        find: detect$1,
	        findLimit: detectLimit$1,
	        findSeries: detectSeries$1,
	        flatMap: concat$1,
	        flatMapLimit: concatLimit$1,
	        flatMapSeries: concatSeries$1,
	        forEach: each,
	        forEachSeries: eachSeries$1,
	        forEachLimit: eachLimit$2,
	        forEachOf: eachOf$1,
	        forEachOfSeries: eachOfSeries$1,
	        forEachOfLimit: eachOfLimit$2,
	        inject: reduce$1,
	        foldl: reduce$1,
	        foldr: reduceRight,
	        select: filter$1,
	        selectLimit: filterLimit$1,
	        selectSeries: filterSeries$1,
	        wrapSync: asyncify,
	        during: whilst$1,
	        doDuring: doWhilst$1
	    };

	    exports.default = index;
	    exports.apply = apply;
	    exports.applyEach = applyEach$1;
	    exports.applyEachSeries = applyEachSeries;
	    exports.asyncify = asyncify;
	    exports.auto = auto;
	    exports.autoInject = autoInject;
	    exports.cargo = cargo;
	    exports.cargoQueue = cargo$1;
	    exports.compose = compose;
	    exports.concat = concat$1;
	    exports.concatLimit = concatLimit$1;
	    exports.concatSeries = concatSeries$1;
	    exports.constant = constant;
	    exports.detect = detect$1;
	    exports.detectLimit = detectLimit$1;
	    exports.detectSeries = detectSeries$1;
	    exports.dir = dir;
	    exports.doUntil = doUntil;
	    exports.doWhilst = doWhilst$1;
	    exports.each = each;
	    exports.eachLimit = eachLimit$2;
	    exports.eachOf = eachOf$1;
	    exports.eachOfLimit = eachOfLimit$2;
	    exports.eachOfSeries = eachOfSeries$1;
	    exports.eachSeries = eachSeries$1;
	    exports.ensureAsync = ensureAsync;
	    exports.every = every$1;
	    exports.everyLimit = everyLimit$1;
	    exports.everySeries = everySeries$1;
	    exports.filter = filter$1;
	    exports.filterLimit = filterLimit$1;
	    exports.filterSeries = filterSeries$1;
	    exports.forever = forever$1;
	    exports.groupBy = groupBy;
	    exports.groupByLimit = groupByLimit$1;
	    exports.groupBySeries = groupBySeries;
	    exports.log = log;
	    exports.map = map$1;
	    exports.mapLimit = mapLimit$1;
	    exports.mapSeries = mapSeries$1;
	    exports.mapValues = mapValues;
	    exports.mapValuesLimit = mapValuesLimit$1;
	    exports.mapValuesSeries = mapValuesSeries;
	    exports.memoize = memoize;
	    exports.nextTick = nextTick;
	    exports.parallel = parallel;
	    exports.parallelLimit = parallelLimit;
	    exports.priorityQueue = priorityQueue;
	    exports.queue = queue$1;
	    exports.race = race$1;
	    exports.reduce = reduce$1;
	    exports.reduceRight = reduceRight;
	    exports.reflect = reflect;
	    exports.reflectAll = reflectAll;
	    exports.reject = reject$2;
	    exports.rejectLimit = rejectLimit$1;
	    exports.rejectSeries = rejectSeries$1;
	    exports.retry = retry;
	    exports.retryable = retryable;
	    exports.seq = seq;
	    exports.series = series;
	    exports.setImmediate = setImmediate$1;
	    exports.some = some$1;
	    exports.someLimit = someLimit$1;
	    exports.someSeries = someSeries$1;
	    exports.sortBy = sortBy$1;
	    exports.timeout = timeout;
	    exports.times = times;
	    exports.timesLimit = timesLimit;
	    exports.timesSeries = timesSeries;
	    exports.transform = transform;
	    exports.tryEach = tryEach$1;
	    exports.unmemoize = unmemoize;
	    exports.until = until;
	    exports.waterfall = waterfall$1;
	    exports.whilst = whilst$1;
	    exports.all = every$1;
	    exports.allLimit = everyLimit$1;
	    exports.allSeries = everySeries$1;
	    exports.any = some$1;
	    exports.anyLimit = someLimit$1;
	    exports.anySeries = someSeries$1;
	    exports.find = detect$1;
	    exports.findLimit = detectLimit$1;
	    exports.findSeries = detectSeries$1;
	    exports.flatMap = concat$1;
	    exports.flatMapLimit = concatLimit$1;
	    exports.flatMapSeries = concatSeries$1;
	    exports.forEach = each;
	    exports.forEachSeries = eachSeries$1;
	    exports.forEachLimit = eachLimit$2;
	    exports.forEachOf = eachOf$1;
	    exports.forEachOfSeries = eachOfSeries$1;
	    exports.forEachOfLimit = eachOfLimit$2;
	    exports.inject = reduce$1;
	    exports.foldl = reduce$1;
	    exports.foldr = reduceRight;
	    exports.select = filter$1;
	    exports.selectLimit = filterLimit$1;
	    exports.selectSeries = filterSeries$1;
	    exports.wrapSync = asyncify;
	    exports.during = whilst$1;
	    exports.doDuring = doWhilst$1;

	    Object.defineProperty(exports, '__esModule', { value: true });

	})));

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177).setImmediate, __webpack_require__(179)))

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(178);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(179)))

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupsHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GroupsHelperService = exports.GroupsHelperService = function () {
	  GroupsHelperService.$inject = ["$rootScope", "$filter", "$translate", "App", "GroupsService", "StaticListService"];
	  function GroupsHelperService($rootScope, $filter, $translate, App, GroupsService, StaticListService) {
	    'ngInject';

	    _classCallCheck(this, GroupsHelperService);

	    this.App = App;
	    this.GroupsService = GroupsService;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.countryCodes = StaticListService.getCountryCodes();
	    $rootScope.GroupsHelper = this;
	    this.isNotEmpty = this.isNotEmpty.bind(this);
	    this.defaultEnergy = {
	      is_green_energy: false,
	      sources: [],
	      environmental_impact: [],
	      supplier_name: '',
	      energy_product_name: ''
	    };
	    this.defaultOpeningTimes = {
	      regular_hours: [],
	      twentyfourseven: true
	    };
	  }

	  _createClass(GroupsHelperService, [{
	    key: 'hasChargepoints',
	    value: function hasChargepoints(group) {
	      return !!(group && _lodash2.default.isArray(group.chargepoints) && group.chargepoints.length > 0);
	    }
	  }, {
	    key: 'hasEnergy',
	    value: function hasEnergy(group) {
	      return !!(group && _lodash2.default.isObject(group.energy_mix) && !_lodash2.default.isEmpty(group.energy_mix, true));
	    }
	  }, {
	    key: 'hasOpeningTimes',
	    value: function hasOpeningTimes(group) {
	      return !!(group && _lodash2.default.isObject(group.opening_times) && !_lodash2.default.isEmpty(group.opening_times, true));
	    }
	  }, {
	    key: 'hasRegularHours',
	    value: function hasRegularHours(group) {
	      return !!(this.hasOpeningTimes(group) && !_lodash2.default.isEmpty(group.opening_times.regular_hours, true));
	    }
	  }, {
	    key: 'isEmpty',
	    value: function isEmpty(group) {
	      return group && _lodash2.default.isArray(group.groups) && group.groups.length === 0 && _lodash2.default.isArray(group.chargepoints) && group.chargepoints.length === 0;
	    }
	  }, {
	    key: 'isNotEmpty',
	    value: function isNotEmpty(group) {
	      return !this.isEmpty(group);
	    }
	  }, {
	    key: 'getEditableLocation',
	    value: function getEditableLocation(group) {
	      if (group && group.location) {
	        return _lodash2.default.cloneDeep(group.location);
	      }
	      return {
	        address: null,
	        postalCode: null,
	        city: null,
	        country: null,
	        latitude: null,
	        longitude: null
	      };
	    }
	  }, {
	    key: 'flatten',
	    value: function flatten(groups, tabName) {
	      var flattened = [];

	      function withGroups(_groups, level) {
	        _lodash2.default.each(_groups, function (group) {
	          if (tabName) {
	            for (var i = 0; i < level; i++) {
	              group.name = String.fromCharCode(160) + group.name;
	            }
	          }
	          flattened.push(group);
	          if (_lodash2.default.isArray(group.groups) && group.groups.length > 0) {
	            withGroups(group.groups, level + 1);
	          }
	        });
	      }

	      withGroups(groups, 0);
	      return flattened;
	    }
	  }, {
	    key: 'hasPosition',
	    value: function hasPosition(group) {
	      return group && group.location && (group.location.latitude || group.location.longitude);
	    }
	  }, {
	    key: 'hasAddress',
	    value: function hasAddress(group) {
	      return group && group.location && (group.location.address || group.location.city || group.location.country || group.location.postalCode);
	    }
	  }, {
	    key: 'hasParent',
	    value: function hasParent(group) {
	      return !!group.parentGroupId;
	    }
	  }, {
	    key: 'hasChildren',
	    value: function hasChildren(group) {
	      return group.groups && group.groups.length != 0;
	    }
	  }, {
	    key: 'editLocation',
	    value: function editLocation($scope, group, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          group: group,
	          location: _this.getEditableLocation(group),
	          map: _lodash2.default.defaultsDeep({}, { pick: null }, _this.App.getMap()),
	          isValid: function isValid(modal) {
	            return modal.location.latitude && modal.location.longitude;
	          },
	          done: function done() {
	            return resolve(_this.setGroupLocation(group, $scope.modal.location, options));
	          }
	        };
	        $scope.modal.map.pick = $scope.modal.location;
	        _this.App.openModal($scope, 'edit-location.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'setGroupLocation',
	    value: function setGroupLocation(group, location, options) {
	      var _this2 = this;

	      options = angular.merge({}, options, { notifications: true });
	      return this.GroupsService.setGroupLocation(group, location, options).then(function () {
	        return _this2.App.closeModal();
	      });
	    }
	  }, {
	    key: 'filterBy',
	    value: function filterBy(groups, field, value) {
	      var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

	      return _lodash2.default.filter(groups, function (group) {
	        var response = group[field] === value;
	        if (!response && _lodash2.default.isArray(value)) {
	          response = value.includes(group[field]);
	        } else if (_lodash2.default.isObject(value)) {
	          response = value[field] === group[field];
	        }
	        return option ? response : !response;
	      });
	    }
	  }, {
	    key: 'askToEditEnergy',
	    value: function askToEditEnergy($scope) {
	      var _this3 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          group: options.group,
	          conflict: _this3._getDefaultConflict(),
	          isEnergy: true,
	          sourcesOptions: _this3._getSourcesOptions(),
	          impactOptions: _this3._getImpactOptions(),
	          energy: _this3.hasEnergy(options.group) ? _lodash2.default.cloneDeep(options.group.energy_mix) : _lodash2.default.cloneDeep(_this3.defaultEnergy),
	          validateSelect: function validateSelect() {
	            return _this3._validateSelect($scope);
	          },
	          validateInput: function validateInput(data) {
	            return _this3._validateInput(data, $scope);
	          },
	          validateIsGreenEnergy: function validateIsGreenEnergy(data) {
	            $scope.modal.energy.is_green_energy = data;
	            _this3._validateIsGreenEnergy(data, $scope);
	          },
	          isValid: function isValid(modal) {
	            return _this3._isEnergyValid(modal);
	          },
	          done: function done() {
	            var data = { energy_mix: null };
	            if ($scope.modal.isEnergy) {
	              data.energy_mix = $scope.modal.energy;
	            }
	            var aux = {
	              organization: options.organization,
	              notifications: true
	            };
	            resolve(_this3.GroupsService.editGroup(options.group, data, aux).then(function () {
	              _this3.App.closeModal();
	            }));
	          }
	        };
	        _this3.App.openModal($scope, 'edit-energy.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'askToAddSubGroup',
	    value: function askToAddSubGroup($scope) {
	      var _this4 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          conflict: _this4._getDefaultConflict(),
	          group: { name: null, desc: null, isAtomic: false },
	          parentGroup: options.parentGroup || null,
	          location: _this4.getEditableLocation(null),
	          countryCodes: _this4.countryCodes,
	          selectedCountry: null,
	          isEnergy: false,
	          sourcesOptions: _this4._getSourcesOptions(),
	          impactOptions: _this4._getImpactOptions(),
	          energy: _lodash2.default.cloneDeep(_this4.defaultEnergy),
	          map: _lodash2.default.defaultsDeep({}, { pick: null }, _this4.App.getMap()),
	          wizard: {
	            step: 0,
	            steps: [],
	            setSteps: function setSteps(modal) {
	              var steps = [{
	                id: 'name',
	                title: _this4.$translate.instant('NAME'),
	                intro: options.parentGroup ? _this4.$translate.instant('GROUPS_ADD_GROUP_TO_CREATE_SUBGROUP_INTRO', {
	                  name: '<strong>' + options.parentGroup.name + '</strong>'
	                }) : _this4.$translate.instant('GROUPS_ADD_GROUP_TO_CREATE_GROUP_INTRO')
	              }, {
	                id: 'location',
	                title: _this4.$translate.instant('GROUPS_ADD_GROUP_LOCATION'),
	                intro: _this4.$translate.instant('ASSIGN_COORDINATES_TO_LOCATION')
	              }, {
	                id: 'address',
	                title: _this4.$translate.instant('ADDRESS'),
	                intro: _this4.$translate.instant('ASSIGN_ADDRESS_TO_GROUP')
	              }, {
	                id: 'energy',
	                title: _this4.$translate.instant('GROUPS_ENERGY'),
	                intro: _this4.$translate.instant('GROUPS_ENERGY_INTRO')
	              }, {
	                id: 'summary',
	                title: _this4.$translate.instant('GROUPS_ADD_GROUP_SUMMARY'),
	                intro: _this4.$translate.instant('GROUPS_ADD_GROUP_SUMMARY_INTRO')
	              }];
	              modal.wizard.steps = _lodash2.default.filter(steps, function (step) {
	                switch (step.id) {
	                  case 'address':
	                    return modal.group.isAtomic;
	                  case 'location':
	                    return modal.group.isAtomic;
	                  default:
	                    return true;
	                }
	              });
	            }
	          },
	          reviewSteps: function reviewSteps(switchValue, which) {
	            switch (which) {
	              case 'address':
	                $scope.modal.group.isAtomic = switchValue;
	                break;
	              case 'location':
	                $scope.modal.group.isAtomic = switchValue;
	                break;
	            }
	            $scope.modal.wizard.setSteps($scope.modal);
	          },
	          validateSelect: function validateSelect() {
	            return _this4._validateSelect($scope);
	          },
	          validateInput: function validateInput(data) {
	            return _this4._validateInput(data, $scope);
	          },
	          validateIsGreenEnergy: function validateIsGreenEnergy(data) {
	            $scope.modal.energy.is_green_energy = data;
	            _this4._validateIsGreenEnergy(data, $scope);
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'name') {
	              return modal.group.name && modal.group.name.length > 0;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	              return modal.location.latitude && modal.location.longitude;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'energy') {
	              return _this4._isEnergyValid(modal);
	            }
	            return true;
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            modal.conflict = _this4._getDefaultConflict();
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.conflict = _this4._getDefaultConflict();
	            modal.wizard.step = step - 1;
	          },
	          done: function done() {
	            if ($scope.modal.group.isAtomic) {
	              $scope.modal.group.location = $scope.modal.location;
	              $scope.modal.group.location.country = $scope.modal.selectedCountry ? $scope.modal.selectedCountry.value : null;
	            }
	            if ($scope.modal.isEnergy) {
	              $scope.modal.group.energy_mix = $scope.modal.energy;
	            }
	            var aux = {
	              organization: options.organization,
	              notifications: true
	            };
	            resolve(_this4.GroupsService.addGroup($scope.modal.group, aux).then(function () {
	              _this4.App.closeModal();
	            }));
	          }
	        };
	        if (options.parentGroup) {
	          $scope.modal.group.parentGroupId = options.parentGroup.id;
	        }
	        $scope.modal.map.pick = $scope.modal.location;
	        $scope.modal.wizard.setSteps($scope.modal);
	        _this4.App.openModal($scope, 'add-group.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'askToEditOpeningHours',
	    value: function askToEditOpeningHours($scope) {
	      var _this5 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          group: options.group,
	          conflict: _this5._getDefaultOpeningHoursConflict(),
	          dayOptions: _this5._getDayOptions(),
	          openingTimes: _this5.hasOpeningTimes(options.group) ? _lodash2.default.cloneDeep(options.group.opening_times) : _lodash2.default.cloneDeep(_this5.defaultOpeningTimes),
	          validateSelect: function validateSelect(data) {
	            return _this5._validateRegularHours(data, $scope);
	          },
	          validateInput: function validateInput(data) {
	            return _this5._validateRegularHours(data, $scope);
	          },
	          isValid: function isValid(modal) {
	            return _this5._isOpeningHoursValid(modal);
	          },
	          done: function done() {
	            var openingTimes = _lodash2.default.cloneDeep($scope.modal.openingTimes);
	            var data = { opening_times: openingTimes };
	            if (openingTimes.twentyfourseven) {
	              delete data.opening_times.regular_hours;
	            } else {
	              data.opening_times.regular_hours = _this5._changeDateToString(openingTimes.regular_hours);
	            }
	            var aux = {
	              organization: options.organization,
	              notifications: true
	            };
	            resolve(_this5.GroupsService.editGroup(options.group, data, aux).then(function () {
	              _this5.App.closeModal();
	            }));
	          }
	        };
	        if (!_this5.hasRegularHours(options.group)) {
	          $scope.modal.openingTimes.regular_hours = [];
	        } else {
	          $scope.modal.openingTimes.regular_hours = _this5._changeStringToDate($scope.modal.openingTimes.regular_hours);
	        }
	        _this5.App.openModal($scope, 'edit-opening-hours.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'assignMaintainer',
	    value: function assignMaintainer($scope, options) {
	      var _this6 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          maintainers: [],
	          maintainer: {},
	          wizard: {
	            step: 0,
	            steps: [{ id: "maintainers", title: _this6.$translate.instant("MAINTAINERS"), intro: _this6.$translate.instant("SEARCH_THE_MAINTAINER") }, { id: "summary", title: _this6.$translate.instant("SUMMARY"), intro: _this6.$translate.instant("REVIEW_THE_SUMMARY") }]
	          },
	          displayForMaintainers: function displayForMaintainers(maintainer) {
	            return maintainer.companyName;
	          },
	          filters: _this6.App.getTableFilters("maintainers"),
	          onSearch: function onSearch(term, pagination) {
	            $scope.modal.filters[0].value = term;
	            $scope.modal.filters[0].scope = $scope.modal.filters[0].combo[0];
	            var aux = {
	              filters: $scope.modal.filters,
	              pagination: pagination,
	              sorting: _this6.App.getSorting(['companyName'], 'companyName', 'asc'),
	              organizationId: options.organizationId,
	              params: {
	                'all': true
	              }
	            };
	            _this6.GroupsService.getMaintainers(options.groupId, aux, true).then(function (data) {
	              $scope.modal.maintainers = $scope.modal.maintainers.concat(data.docs);
	              pagination.totalItems = data.totalItems;
	            });
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'maintainers') {
	              return !!modal.maintainer;
	            }
	            return true;
	          },
	          done: function done() {
	            resolve(_this6.GroupsService.assignMaintainer($scope.modal.maintainer.id, options).then(function () {
	              _this6.App.closeModal();
	            }));
	          }
	        };
	        _this6.App.openModal($scope, 'assign-maintainer.html', { 'size': 'lg' });
	      });
	    }
	  }, {
	    key: 'unassignMaintainer',
	    value: function unassignMaintainer($scope, maintainer, options) {
	      var _this7 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          maintainer: maintainer,
	          done: function done() {
	            resolve(_this7.GroupsService.unassignMaintainer(maintainer.id, options).then(function () {
	              _this7.App.closeModal();
	            }));
	          }
	        };
	        _this7.App.openModal($scope, 'unassign-maintainer.html');
	      });
	    }
	  }, {
	    key: 'askToRemoveGroup',
	    value: function askToRemoveGroup($scope, group, options) {
	      var _this8 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          group: group,
	          done: function done() {
	            resolve(_this8.GroupsService.removeGroup(group, options).then(function () {
	              _this8.App.closeModal();
	            }));
	          }
	        };
	        _this8.App.openModal($scope, 'remove-group.html', { 'size': 'sm' });
	      });
	    }
	  }, {
	    key: '_allSumHundred',
	    value: function _allSumHundred(list, field) {
	      var sum = _lodash2.default.reduce(list, function (acc, item) {
	        return acc + item[field];
	      }, 0);
	      return sum === 100;
	    }
	  }, {
	    key: '_getSourcesOptions',
	    value: function _getSourcesOptions() {
	      return [{ id: 'GENERAL_FOSSIL', display: this.$translate.instant('GENERAL_FOSSIL') }, { id: 'GENERAL_GREEN', display: this.$translate.instant('GENERAL_GREEN') }, { id: 'NUCLEAR', display: this.$translate.instant('NUCLEAR') }, { id: 'COAL', display: this.$translate.instant('COAL') }, { id: 'GAS', display: this.$translate.instant('GAS') }, { id: 'SOLAR', display: this.$translate.instant('SOLAR') }, { id: 'WIND', display: this.$translate.instant('WIND') }, { id: 'WATER', display: this.$translate.instant('WATER') }, { id: 'GEOTHERMAL', display: this.$translate.instant('GEOTHERMAL') }, { id: 'PETROLEUM', display: this.$translate.instant('PETROLEUM') }, { id: 'BIOMASS', display: this.$translate.instant('BIOMASS') }];
	    }
	  }, {
	    key: '_getImpactOptions',
	    value: function _getImpactOptions() {
	      return [{ id: 'NUCLEAR_WASTE', display: this.$translate.instant('NUCLEAR_WASTE') }, { id: 'CARBON_DIOXIDE', display: this.$translate.instant('CARBON_DIOXIDE') }];
	    }
	  }, {
	    key: '_getDefaultConflict',
	    value: function _getDefaultConflict() {
	      return {
	        repeat: false,
	        counter: false,
	        green: false,
	        counterText: 'CONFLICT_ENERGY_COUNTER',
	        repeatText: 'CONFLICT_ENERGY_REPEAT',
	        greenText: 'CONFLICT_ENERGY_GREEN'
	      };
	    }
	  }, {
	    key: '_getDayOptions',
	    value: function _getDayOptions() {
	      return [{ id: 1, display: this.$translate.instant('MONDAY') }, { id: 2, display: this.$translate.instant('TUESDAY') }, { id: 3, display: this.$translate.instant('WEDNESDAY') }, { id: 4, display: this.$translate.instant('THURSDAY') }, { id: 5, display: this.$translate.instant('FRIDAY') }, { id: 6, display: this.$translate.instant('SATURDAY') }, { id: 7, display: this.$translate.instant('SUNDAY') }];
	    }
	  }, {
	    key: '_getDefaultOpeningHoursConflict',
	    value: function _getDefaultOpeningHoursConflict() {
	      return {
	        hour: false,
	        hourText: 'CONFLICT_HOUR'
	      };
	    }
	  }, {
	    key: '_validateSelect',
	    value: function _validateSelect(scope) {
	      var environmentalImpactCloned = _lodash2.default.cloneDeep(scope.modal.energy.environmental_impact);
	      var sourcesCloned = _lodash2.default.cloneDeep(scope.modal.energy.sources);
	      var repeat = false;
	      var aux = [];
	      _lodash2.default.forEach([].concat(_toConsumableArray(environmentalImpactCloned), _toConsumableArray(sourcesCloned)), function (item) {
	        var values = Object.values(item);
	        if (!aux.includes(values[0])) {
	          aux.push(values[0]);
	        } else {
	          repeat = true;
	        }
	      });
	      if (repeat) {
	        scope.modal.conflict.repeat = true;
	      } else if (scope.modal.conflict || scope.modal.conflict.repeat) {
	        scope.modal.conflict.repeat = false;
	      }
	      this._validateIsGreenEnergy(scope.modal.energy.is_green_energy, scope);
	    }
	  }, {
	    key: '_validateInput',
	    value: function _validateInput(data, scope) {
	      var cloned = _lodash2.default.cloneDeep(data);
	      if (cloned.length > 0) {
	        var counter = 0;
	        _lodash2.default.forEach(cloned, function (item) {
	          var values = Object.values(item);
	          counter += values[1];
	        });
	        if (counter !== 100) {
	          scope.modal.conflict.counter = true;
	        } else if (scope.modal.conflict || scope.modal.conflict.counter) {
	          scope.modal.conflict.counter = false;
	        }
	      } else {
	        scope.modal.conflict.counter = false;
	      }
	    }
	  }, {
	    key: '_validateIsGreenEnergy',
	    value: function _validateIsGreenEnergy(data, scope) {
	      if (data) {
	        var environmentalImpactCloned = _lodash2.default.cloneDeep(scope.modal.energy.environmental_impact);
	        var sourcesCloned = _lodash2.default.cloneDeep(scope.modal.energy.sources);
	        var isGreenSource = !sourcesCloned.some(function (item) {
	          return ['GENERAL_FOSSIL', 'NUCLEAR', 'COAL', 'GAS', 'PETROLEUM'].includes(item.source);
	        });
	        var isGreenImpact = !environmentalImpactCloned.length > 0;
	        scope.modal.conflict.green = !(isGreenSource && isGreenImpact);
	      } else {
	        scope.modal.conflict.green = false;
	      }
	    }
	  }, {
	    key: '_validateRegularHours',
	    value: function _validateRegularHours(data, scope) {
	      var list = this._changeDateToString(scope.modal.openingTimes.regular_hours);
	      if (data.item) {
	        var candidate = this._changeDateToString([data.item])[0];
	        if (candidate) {
	          candidate.current = true;
	          list[data.index] = candidate;
	        }
	      }
	      for (var i = 0; i < list.length; i++) {
	        var periodBeginSplit = list[i].period_begin.split(':');
	        var periodEndSplit = list[i].period_end.split(':');
	        list[i].periodBeginSeconds = list[i].weekday * 24 * 60 * 60 + Number(periodBeginSplit[0]) * 60 * 60 + Number(periodBeginSplit[1]) * 60;
	        list[i].periodEndSeconds = list[i].weekday * 24 * 60 * 60 + Number(periodEndSplit[0]) * 60 * 60 + Number(periodEndSplit[1]) * 60;
	      }
	      list = _lodash2.default.orderBy(list, ['periodBeginSeconds']);
	      var conflict = this._getDefaultOpeningHoursConflict();
	      for (var _i = 0; _i < list.length; _i++) {
	        var item = list[_i];
	        if (item.periodEndSeconds <= item.periodBeginSeconds) {
	          conflict.hour = true;
	          conflict.hourText = 'CONFLICT_END_DATE_LESS_START_DATE';
	          break;
	        }
	        if (_i > 0) {
	          if (item.periodBeginSeconds <= list[_i - 1].periodEndSeconds) {
	            var aux = item.current ? _i - 1 : _i;
	            conflict.hour = true;
	            conflict.hourText = this._getRechargingScheduleText(list[aux].weekday, list[aux].period_begin, list[aux].period_end);
	            break;
	          }
	        }
	      }
	      scope.modal.conflict = conflict;
	    }
	  }, {
	    key: '_isEnergyValid',
	    value: function _isEnergyValid(modal) {
	      return !modal.conflict.repeat && !modal.conflict.counter && !modal.conflict.green;
	    }
	  }, {
	    key: '_isOpeningHoursValid',
	    value: function _isOpeningHoursValid(modal) {
	      return !modal.conflict.hour && (modal.openingTimes.twentyfourseven || !modal.openingTimes.twentyfourseven && modal.openingTimes.regular_hours.length > 0);
	    }
	  }, {
	    key: '_changeDateToString',
	    value: function _changeDateToString(list) {
	      var _this9 = this;

	      var attr1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'period_begin';
	      var attr2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'period_end';

	      var aux = _lodash2.default.cloneDeep(list);
	      return _lodash2.default.map(aux, function (item) {
	        item[attr1] = _this9._dateToString(item[attr1]);
	        item[attr2] = _this9._dateToString(item[attr2]);
	        return item;
	      });
	    }
	  }, {
	    key: '_dateToString',
	    value: function _dateToString(date) {
	      var aux = date.toTimeString().split(' ')[0].split(':');
	      return aux.slice(0, aux.length - 1).join(':');
	    }
	  }, {
	    key: '_changeStringToDate',
	    value: function _changeStringToDate(list) {
	      var _this10 = this;

	      var attr1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'period_begin';
	      var attr2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'period_end';

	      var aux = _lodash2.default.cloneDeep(list);
	      return _lodash2.default.map(aux, function (item) {
	        item[attr1] = _this10._stringToDate(item[attr1]);
	        item[attr2] = _this10._stringToDate(item[attr2]);
	        return item;
	      });
	    }
	  }, {
	    key: '_stringToDate',
	    value: function _stringToDate(data) {
	      var date = new Date(0);
	      var aux = data.split(':');
	      date.setHours(parseInt(aux[0]), parseInt(aux[1]));
	      return date;
	    }
	  }, {
	    key: '_getRechargingScheduleText',
	    value: function _getRechargingScheduleText(startDayOfWeek, startTime, endTime) {
	      return this.$filter('toDayOcpi')(startDayOfWeek) + ' (' + startTime + ' - ' + endTime + ')';
	    }
	  }]);

	  return GroupsHelperService;
	}();

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AlarmsService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AlarmsService = exports.AlarmsService = function () {
	    AlarmsService.$inject = ["$rootScope", "App", "ItttService", "$state", "$translate", "LocalStorage"];
	    function AlarmsService($rootScope, App, ItttService, $state, $translate, LocalStorage) {
	        'ngInject';

	        _classCallCheck(this, AlarmsService);

	        var Alarms = this;
	        $rootScope.Alarms = Alarms;

	        this.App = App;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.LocalStorage = LocalStorage;
	        this.Ittt = ItttService;

	        this.user = LocalStorage.getUser();

	        this.availableEvents = ['disconnected',
	        /*'inactiveDuring',*/
	        'errorStateDuring', 'noEffectiveChargeDuring', 'cableNotChargingDuring', 'lastBootAt'];

	        this.event = {
	            'disconnected': {
	                'if': ['ocppConnection.connected', 'is not', 'true'],
	                'label': this.$translate.instant('CH.ALARMS.ON_DISCONNECTED.LABEL'),
	                'desc': this.$translate.instant('CH.ALARMS.ON_DISCONNECTED.HELP'),
	                'subject': this.$translate.instant('CH.ALARMS.ON_DISCONNECTED.SUBJECT', { name: '$THING' }),
	                'body': this.$translate.instant('CH.ALARMS.ON_DISCONNECTED.BODY', { name: '$THING' })
	            },
	            'inactiveDuring': {
	                'if': ['$THING', 'inactive during', 300],
	                'label': this.$translate.instant('CH.ALARMS.ON_INACTIVE.LABEL'),
	                'desc': this.$translate.instant('CH.ALARMS.ON_INACTIVE.HELP'),
	                'subject': this.$translate.instant('CH.ALARMS.ON_INACTIVE.SUBJECT', { name: '$THING' }),
	                'body': this.$translate.instant('CH.ALARMS.ON_INACTIVE.BODY', { name: '$THING' })
	            },
	            'errorStateDuring': {
	                'if': ['$THING', 'error state during', 120],
	                'label': this.$translate.instant('CH.ALARMS.ON_ERROR.LABEL'),
	                'desc': this.$translate.instant('CH.ALARMS.ON_ERROR.HELP'),
	                'subject': this.$translate.instant('CH.ALARMS.ON_ERROR.SUBJECT', { name: '$THING' }),
	                'body': this.$translate.instant('CH.ALARMS.ON_ERROR.BODY', { name: '$THING' })
	            },
	            'noEffectiveChargeDuring': {
	                'if': ['$THING', 'no effective charge during', 600],
	                'label': this.$translate.instant('CH.ALARMS.ON_NOT_EFFECTIVE_CHARGING.LABEL'),
	                'desc': this.$translate.instant('CH.ALARMS.ON_NOT_EFFECTIVE_CHARGING.HELP'),
	                'subject': this.$translate.instant('CH.ALARMS.ON_NOT_EFFECTIVE_CHARGING.SUBJECT', { name: '$THING' }),
	                'body': this.$translate.instant('CH.ALARMS.ON_NOT_EFFECTIVE_CHARGING.BODY', { name: '$THING' })
	            },
	            'cableNotChargingDuring': {
	                'if': ['$THING', 'cable not charging during', 300],
	                'label': this.$translate.instant('CH.ALARMS.ON_CABLE_NOT_CHARGING.LABEL'),
	                'desc': this.$translate.instant('CH.ALARMS.ON_CABLE_NOT_CHARGING.HELP'),
	                'subject': this.$translate.instant('CH.ALARMS.ON_CABLE_NOT_CHARGING.SUBJECT', { name: '$THING' }),
	                'body': this.$translate.instant('CH.ALARMS.ON_CABLE_NOT_CHARGING.BODY', { name: '$THING' })
	            },
	            'lastBootAt': {
	                'if': ['lastBootAt', 'is not', ''],
	                'label': this.$translate.instant('CH.ALARMS.ON_REBOOT.LABEL'),
	                'desc': this.$translate.instant('CH.ALARMS.ON_REBOOT.HELP'),
	                'subject': this.$translate.instant('CH.ALARMS.ON_REBOOT.SUBJECT', { name: '$THING' }),
	                'body': this.$translate.instant('CH.ALARMS.ON_REBOOT.BODY', { name: '$THING' })
	            }
	        };

	        this.availableActions = ['sendEmail'];

	        this.action = {
	            'sendEmail': { short: 'Email', display: this.$translate.instant('CH.ALARMS.SEND_EMAIL') }
	        };
	    }

	    _createClass(AlarmsService, [{
	        key: 'isAlarmMine',
	        value: function isAlarmMine(rule) {
	            // Is a recognized action
	            if (_lodash2.default.isArray(rule.then) && rule.then.length >= 3 && this.availableActions.indexOf(rule.then[0]) >= 0) {
	                // Is for me
	                if (rule.then[2] === this.user.username) {
	                    // Is a recognized event
	                    for (var i in this.availableEvents) {
	                        var event = this.availableEvents[i];
	                        if (this.event[event].if[0] === rule.if[0] && this.event[event].if[1] === rule.if[1] && this.event[event].if[2] === rule.if[2]) {
	                            return event;
	                        }
	                    }
	                }
	            }
	            return null;
	        }
	    }, {
	        key: 'getForChargepoint',
	        value: function getForChargepoint(id, options) {
	            var _this = this;

	            var alarms = {};
	            _lodash2.default.each(this.availableEvents, function (event) {
	                return alarms[event] = { event: event, value: false, rule: null };
	            });

	            return this.Ittt.getChargepointRules(id, options).then(function (rules) {
	                _lodash2.default.each(rules, function (rule) {
	                    var event = _this.isAlarmMine(rule);
	                    if (event) {
	                        alarms[event].value = true;
	                        alarms[event].rule = rule;
	                    }
	                });
	                return alarms;
	            }).catch(function () {
	                return Promise.resolve(alarms);
	            });
	        }
	    }, {
	        key: 'getChargepointLink',
	        value: function getChargepointLink(chargepoint, organization) {
	            return '<a href="' + this.$state.href('efimob.chargepoints.at.item', { id: chargepoint, organization: organization, tab: null }, { absolute: true }) + '">$THING</a>';
	        }
	    }, {
	        key: 'getThen',
	        value: function getThen(action, event, chargepoint, organization) {
	            var subject = this.event[event] && this.event[event].subject ? this.event[event].subject : this.$translate.instant('CH.ALARMS.SOMETHING_NASTY_HAPPENED', { name: '$THING' });
	            var body = '';
	            // Event details
	            body += this.event[event] && this.event[event].body ? this.event[event].body : this.$translate.instant('CH.ALARMS.EVENT_DETECTED_FOR', { event: '<i>' + event + '</i>', name: '$THING' });
	            //Replace $THING for its link
	            body = _lodash2.default.replace(body, '$THING', this.getChargepointLink(chargepoint, organization));
	            // Link to alarms settings
	            body += '<br><span style="font-size: 12px;opacity:0.6;">' + this.$translate.instant('CH.ALARMS.NOTIFICATIONS_CAN_BE_CHANGED_FROM') + '<a href="' + this.$state.href('efimob.chargepoints.at.item', { id: chargepoint, organization: organization, tab: 'alarmas' }, { absolute: true }) + '">' + this.$translate.instant('CH.ALARMS.HERE') + '</a></span>';
	            // Signed by
	            body += this.App.config.email.signature;

	            switch (action) {
	                case 'sendEmail':
	                default:
	                    return ['sendEmail', this.App.config.email.from, this.user.username, subject, body];
	            }
	        }
	    }, {
	        key: 'setForChargepoint',
	        value: function setForChargepoint(id, alarm, options) {
	            // Remove an existing rule
	            if (alarm.value === false && alarm.rule && alarm.rule.id) {
	                return this.Ittt.removeChargepointRule(id, alarm.rule.id, options);
	            }
	            // Create a new rule
	            if (alarm.value === true) {
	                var rule = {
	                    'if': this.event[alarm.event]['if'],
	                    'then': this.getThen(this.availableActions[0], alarm.event, id, options.organization)
	                };
	                return this.Ittt.addChargepointRule(id, rule, options);
	            }
	        }
	    }, {
	        key: 'addChargepointDisconnected',
	        value: function addChargepointDisconnected(id, options) {
	            options = options || {};
	            var rule = {
	                'if': ['ocppConnection.connected', 'is not', 'true'],
	                'then': ['sendEmail', this.App.config.email.from, this.user.username, this.$translate.instant('CH.ALARMS.ON_DISCONNECTED.SUBJECT', { name: '$THING' }), this.$translate.instant('CH.ALARMS.ON_DISCONNECTED.BODY', { name: '$THING' })]
	            };
	            return this.Ittt.addChargepointRule(id, rule, options);
	        }
	    }]);

	    return AlarmsService;
	}();

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserKeyHelper = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _async = __webpack_require__(176);

	var _async2 = _interopRequireDefault(_async);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UserKeyHelper = exports.UserKeyHelper = function () {
	  UserKeyHelper.$inject = ["$rootScope", "$translate", "App", "GroupsHelper", "moment", "GroupsService", "Organization", "UsersService", "CustomersService"];
	  function UserKeyHelper($rootScope, $translate, App, GroupsHelper, moment, GroupsService, Organization, UsersService, CustomersService) {
	    'ngInject';

	    _classCallCheck(this, UserKeyHelper);

	    $rootScope.UserkeyHelper = this;

	    this.$translate = $translate;
	    this.App = App;
	    this.GroupsHelper = GroupsHelper;
	    this.GroupsService = GroupsService;
	    this.Organization = Organization;
	    this.UsersService = UsersService;
	    this.CustomersService = CustomersService;

	    this.moment = moment;
	    this.async = _async2.default;

	    this.defaultUserKey = {
	      idToken: null,
	      activeFrom: null,
	      activeTo: null,
	      blocked: false,
	      master: false,
	      priority: 'Standard'
	    };
	  }

	  _createClass(UserKeyHelper, [{
	    key: 'isBlocked',
	    value: function isBlocked(userkey) {
	      return userkey.blocked;
	    }
	  }, {
	    key: 'isInActivePeriod',
	    value: function isInActivePeriod(userkey) {
	      var now = this.moment();
	      var from = this.moment(userkey.activeFrom);
	      var to = this.moment(userkey.activeTo);
	      if (to && from && now.isBetween(from, to)) return true;
	      return false;
	    }
	  }, {
	    key: 'askToAssignToOrganization',
	    value: function askToAssignToOrganization($scope, userkeys) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        var isValid = function isValid(modal) {
	          if (modal.wizard.steps[modal.wizard.step].id === 'organization') {
	            return modal.organization;
	          }
	          return true;
	        };

	        $scope.modal = {
	          userkeys: userkeys,
	          organization: null,
	          organizations: null,
	          organizationsLoading: true,
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'organization',
	              title: _this.$translate.instant('USERKEYS.ATO.ORGANIZATION'),
	              intro: userkeys.length > 1 ? _this.$translate.instant('USERKEYS.ATO.ENTER_ORGANIZATION_SEVERAL') : _this.$translate.instant('USERKEYS.ATO.ENTER_ORGANIZATION_ONE')
	            }, {
	              id: 'summary',
	              title: _this.$translate.instant('USERKEYS.ATO.RECAP'),
	              intro: _this.$translate.instant('USERKEYS.ATO.RECAP_CONFIRM')
	            }]
	          },
	          isValid: isValid,
	          done: function done() {
	            return resolve(_this.assignToOrganization($scope.modal.userkeys, $scope.modal.organization));
	          }
	        };

	        _this.Organization.getOrganizations().then(function (organizations) {
	          $scope.modal.organizations = organizations;
	          $scope.modal.organization = organizations.length > 0 ? organizations[0] : null;
	          $scope.modal.organizationsLoading = false;
	        }).catch(function () {
	          $scope.modal.organizationsLoading = false;
	        });

	        _this.App.openModal($scope, 'assign-userkey.html', { 'size': 'lg' });
	      });
	    }
	  }, {
	    key: 'assignToOrganization',
	    value: function assignToOrganization(userkeys, organization) {
	      var _this2 = this;

	      this.async.eachLimit(userkeys, 20, function (userKeyId, callback) {
	        return _this2.UsersService.assignUserkey(userKeyId, { organization: organization.id }).then(callback());
	      }, function (err) {
	        _this2.App.closeModal();
	        if (err) {
	          _this2.App.showNotification(_this2.$translate.instant('USERKEYS.ATO.FAILED'), 'error');
	          throw err;
	        } else {
	          if (userkeys.length == 1) _this2.App.showNotification(_this2.$translate.instant('USERKEYS.ATO.OK_ONE', { id: '<b>' + userkeys[0] + '</b>' }));
	          if (userkeys.length > 1) _this2.App.showNotification(_this2.$translate.instant('USERKEYS.ATO.OK_SEVERAL', { total: userkeys.length }));
	          return { organization: organization.id };
	        }
	      });
	    }
	  }, {
	    key: 'askToBindToCustomer',
	    value: function askToBindToCustomer($scope, userkeys, options) {
	      var _this3 = this;

	      return new Promise(function (resolve) {
	        var isValid = function isValid(modal) {
	          if (modal.wizard.steps[modal.wizard.step].id === 'customer') {
	            return modal.customer && modal.customer.name && modal.customer.name.length > 0;
	          }
	          return true;
	        };

	        $scope.modal = {
	          userkeys: userkeys,
	          // organization: options.organization,
	          customer: null,
	          customers: [],
	          filters: _this3.App.getTableFilters("customer"),
	          addingCustomer: false,
	          searchByList: [{ display: _this3.$translate.instant('NAME'), value: { id: 'name.ilike', label: 'Name', url: 'nombre' } }, { display: _this3.$translate.instant('EMAIL'), value: { id: 'userId.ilike', label: 'Email', url: 'email' } }],
	          searchBy: null,
	          updateSearchBy: function updateSearchBy(option) {
	            $scope.modal.filters[0].scope = option.value;
	          },
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'customer',
	              title: _this3.$translate.instant('USERKEYS.ATC.CUSTOMER'),
	              intro: _this3.$translate.instant('USERKEYS.ATC.ENTER_CUSTOMER')
	            }, {
	              id: 'summary',
	              title: _this3.$translate.instant('USERKEYS.ATC.RECAP'),
	              intro: _this3.$translate.instant('USERKEYS.ATC.RECAP_CONFIRM')
	            }]
	          },
	          onAddCustomer: function onAddCustomer(modal, isAdding) {
	            modal.addingCustomer = !!isAdding;
	            if (isAdding) {
	              _lodash2.default.find(modal.wizard.steps, { id: 'customer' })['intro'] = _this3.$translate.instant('USERKEYS.ATC.ADDING_NEW_CUSTOMER');
	              modal.customer = { name: null };
	            } else {
	              _lodash2.default.find(modal.wizard.steps, { id: 'customer' })['intro'] = _this3.$translate.instant('USERKEYS.ATC.SELECT_CUSTOMER');
	              modal.customer = modal.customers.length > 0 ? modal.customers[0] : null;
	            }
	          },
	          displayForCustomers: function displayForCustomers(customer) {
	            var display = '';
	            if (customer.userId) {
	              display += customer.userId;
	            }
	            if (customer.displayName) {
	              display += ' - ' + customer.displayName;
	            } else if (customer.name) {
	              display += ' - ' + customer.name;
	            }
	            return display;
	          },
	          onSearch: function onSearch(term, pagination) {
	            $scope.modal.filters[0].value = term;
	            var aux = {
	              filters: $scope.modal.filters,
	              pagination: pagination,
	              sorting: _this3.App.getSorting(['name'], 'name', 'asc'),
	              organization: options.organization
	            };
	            _this3.CustomersService.getCustomers(aux, true).then(function (data) {
	              $scope.modal.customers = $scope.modal.customers.concat(data.docs);
	              pagination.totalItems = data.totalItems;
	            });
	          },
	          isValid: isValid,
	          done: function done() {
	            return resolve(_this3.bindToCustomer($scope.modal.userkeys, $scope.modal.customer, options));
	          }
	        };
	        $scope.modal.searchBy = $scope.modal.searchByList[0];
	        $scope.modal.updateSearchBy($scope.modal.searchBy);
	        _this3.App.openModal($scope, 'bind-userkey-to-customer.html', { 'size': 'lg' });
	      });
	    }
	  }, {
	    key: 'bindToCustomer',
	    value: function bindToCustomer(userkeys, customer, options) {
	      var _this4 = this;

	      var doTheBind = function doTheBind(userkeys, customer, options) {
	        return _this4.async.eachLimit(userkeys, 20, _this4.async.asyncify(function (userKeyId) {
	          return _this4.UsersService.bindUserkeyToCustomer(userKeyId, customer.id, options);
	        }), function (err) {
	          if (err) {
	            _this4.App.closeModal();
	            _this4.App.showNotification(_this4.$translate.instant('USERKEYS.ATC.FAILED'), 'error');
	            throw err;
	          } else {
	            _this4.App.closeModal();
	            if (userkeys.length == 1) _this4.App.showNotification(_this4.$translate.instant('USERKEYS.ATC.OK_ONE', { id: '<b>' + userkeys[0] + '</b>' }));
	            if (userkeys.length > 1) _this4.App.showNotification(_this4.$translate.instant('USERKEYS.ATC.OK_SEVERAL', { total: userkeys.length }));
	          }
	        });
	      };
	      if (customer.name && !customer.id) {
	        return this.CustomersService.addCustomer(customer, options).then(function (newCustomer) {
	          return doTheBind(userkeys, newCustomer, options);
	        }).catch(function () {
	          _this4.App.closeModal();
	          _this4.App.showNotification(_this4.$translate.instant('USERKEYS.ATC.FAILED_ADDING_NEW_CUSTOMER', { name: '<accent>' + customer.name + '</accent>' }), 'error');
	        });
	      } else {
	        return doTheBind(userkeys, customer, options);
	      }
	    }
	  }, {
	    key: 'addLocation',
	    value: function addLocation($scope, data, options) {
	      var _this5 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          userkey: data.userkey,
	          organizationId: options.organizationId,
	          location: null,
	          locationView: {
	            locationTableData: {
	              organizationId: options.organizationId,
	              table: {
	                keys: ['name | locationName:item'],
	                selected: [],
	                selectable: 'one'
	              },
	              filters: _this5.App.getTableFilters('locations', { context: _this5, modify: { purpose: { hide: true, value: 'General' } } })
	            },
	            locationTableApi: {},
	            unsubscribeSelectedEvent: null,
	            unsubscribe: null,
	            subscribe: function subscribe() {
	              return $scope.$watch(function () {
	                return $scope.modal.locationView.locationTableApi.on;
	              }, function (onFn) {
	                if (!onFn) return;
	                $scope.modal.locationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                  if (_lodash2.default.isArray(selected)) {
	                    $scope.modal.location = selected[0];
	                  }
	                });
	              });
	            }
	          },
	          isValid: function isValid(modal) {
	            return !!modal.location;
	          },
	          close: function close() {
	            if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	              $scope.modal.locationView.unsubscribeSelectedEvent();
	              $scope.modal.locationView.unsubscribe();
	            }
	            $scope.App.closeModal();
	          },
	          done: function done() {
	            if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	              $scope.modal.locationView.unsubscribeSelectedEvent();
	              $scope.modal.locationView.unsubscribe();
	            }
	            var locationId = $scope.modal.location.id;
	            return resolve(_this5.UsersService.addUserkeyToGroup($scope.modal.userkey.userKeyId, locationId, { organization: $scope.modal.organizationId }).then(function () {
	              return locationId;
	            }).catch(function () {
	              return Promise.reject(locationId);
	            }));
	          }
	        };
	        $scope.modal.locationView.unsubscribe = $scope.modal.locationView.subscribe();
	        _this5.App.openModal($scope, 'add-userkey-group.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'addUserKey',
	    value: function addUserKey($scope, data, options) {
	      var _this6 = this;

	      var groupId = options.group ? options.group.id : null;
	      return new Promise(function (resolve) {
	        $scope.modal = {
	          userKey: _lodash2.default.cloneDeep(_this6.defaultUserKey),
	          organizationId: options.organizationId,
	          groupId: groupId,
	          userkeyBound: true,
	          addingCustomer: false,
	          customer: null,
	          customers: [],
	          filters: _this6.App.getTableFilters("customer"),
	          searchByList: [{ display: _this6.$translate.instant('NAME'), value: { id: 'name.ilike', label: 'Name', url: 'nombre' } }, { display: _this6.$translate.instant('EMAIL'), value: { id: 'userId.ilike', label: 'Email', url: 'email' } }],
	          searchBy: null,
	          withLocation: true,
	          location: null,
	          locationView: {
	            locationTableData: {
	              organizationId: options.organizationId,
	              table: {
	                keys: ['name | locationName:item'],
	                selected: [],
	                selectable: 'one'
	              },
	              filters: _this6.App.getTableFilters('locations', { context: _this6, modify: { purpose: { hide: true, value: 'General' } } })
	            },
	            locationTableApi: {},
	            unsubscribeSelectedEvent: null,
	            unsubscribe: null,
	            subscribe: function subscribe() {
	              return $scope.$watch(function () {
	                return $scope.modal.locationView.locationTableApi.on;
	              }, function (onFn) {
	                if (!onFn) return;
	                $scope.modal.locationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                  if (_lodash2.default.isArray(selected)) {
	                    $scope.modal.location = selected[0];
	                  }
	                });
	              });
	            }
	          },
	          userkeyExpirationPeriod: null,
	          userkeyExpirationPeriods: [{ display: '1 ' + _this6.$translate.instant('YEARS'), toAdd: [1, 'years'] }, { display: '2 ' + _this6.$translate.instant('YEARS'), toAdd: [2, 'years'] }, { display: '3 ' + _this6.$translate.instant('YEARS'), toAdd: [3, 'years'] }, { display: '4 ' + _this6.$translate.instant('YEARS'), toAdd: [4, 'years'] }, { display: '5 ' + _this6.$translate.instant('YEARS'), toAdd: [5, 'years'] }, { display: '10 ' + _this6.$translate.instant('YEARS'), toAdd: [10, 'years'] }],
	          userkeyActive: true,
	          userkeyActivationDate: new Date(),
	          userkeyActivationDateConf: {
	            open: false,
	            options: {}
	          },
	          priorities: [{ display: _this6.$translate.instant('STANDARD'), value: "Standard" }, { display: _this6.$translate.instant('HIGH'), value: "High" }],
	          priority: null,
	          wizard: {
	            step: 0,
	            steps: [],
	            setSteps: function setSteps(modal) {
	              var steps = [{ id: 'id', title: _this6.$translate.instant('ID'), intro: _this6.$translate.instant('ENTER_RFID_ID') }, { id: 'customer', title: _this6.$translate.instant('CUSTOMER'), intro: _this6.$translate.instant('WHO_USES_THIS_KEY') }, { id: 'location', title: _this6.$translate.instant('GROUP'), intro: _this6.$translate.instant('WHO_USES_THIS_GROUP') }, { id: 'config', title: _this6.$translate.instant('CONFIG'), intro: _this6.$translate.instant('CHANGE_KEY_PARAMETER') }, { id: 'recap', title: _this6.$translate.instant('SUMMARY'), intro: _this6.$translate.instant('CONFIRM_ADD_KEY') }];
	              steps = _lodash2.default.filter(steps, function (step) {
	                return !(step.id === 'location' && data.group);
	              });
	              modal.wizard.steps = steps;
	            }
	          },
	          updateSearchBy: function updateSearchBy(option) {
	            $scope.modal.filters[0].scope = option.value;
	          },
	          displayForCustomers: function displayForCustomers(customer) {
	            var display = '';
	            if (customer.userId) {
	              display += customer.userId;
	            }
	            if (customer.displayName) {
	              display += ' - ' + customer.displayName;
	            } else if (customer.name) {
	              display += ' - ' + customer.name;
	            }
	            return display;
	          },
	          onAddCustomer: function onAddCustomer(modal, isAdding) {
	            modal.addingCustomer = !!isAdding;
	            if (isAdding) {
	              modal.customer = { name: null };
	            } else {
	              modal.customer = modal.customers.length > 0 ? modal.customers[0] : null;
	            }
	          },
	          onSearch: function onSearch(term, pagination) {
	            $scope.modal.filters[0].value = term;
	            var aux = {
	              filters: $scope.modal.filters,
	              pagination: pagination,
	              sorting: _this6.App.getSorting(['name'], 'name', 'asc'),
	              organization: $scope.modal.organizationId
	            };
	            _this6.CustomersService.getCustomers(aux, true).then(function (data) {
	              $scope.modal.customers = $scope.modal.customers.concat(data.docs);
	              pagination.totalItems = data.totalItems;
	            });
	          },
	          onUserKeyBoundChanged: function onUserKeyBoundChanged(value) {
	            if (!value) {
	              $scope.modal.customer = null;
	            }
	            $scope.modal.userkeyBound = value;
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'id') {
	              return modal.userKey.idToken && modal.userKey.idToken.length > 0;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'customer') {
	              return modal.customer != null && modal.userkeyBound || modal.customer == null && !modal.userkeyBound;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	              return !modal.withLocation || modal.withLocation && modal.location;
	            }
	            return true;
	          },
	          close: function close() {
	            if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	              $scope.modal.locationView.unsubscribeSelectedEvent();
	              $scope.modal.locationView.unsubscribe();
	            }
	            $scope.App.closeModal();
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            if (modal.wizard.steps[step].id === 'customer') {
	              if (!modal.userkeyBound) {
	                modal.customer = null;
	              }
	              if (data.group) {
	                modal.location = data.group;
	              }
	            }
	            if (modal.wizard.steps[step].id === 'location') {
	              if (!modal.withLocation) {
	                modal.location = null;
	              }
	            }
	            if (modal.wizard.steps[step].id === 'config') {
	              modal.userKey.blocked = !modal.userkeyActive;
	              var now = _this6.moment(modal.userkeyActivationDate);
	              modal.userKey.activeFrom = now.toISOString();
	              modal.userKey.activeTo = now.add(modal.userkeyExpirationPeriod.toAdd[0], modal.userkeyExpirationPeriod.toAdd[1]).toISOString();
	              modal.userKey.priority = modal.priority.value;
	            }
	            modal.conflict = null;
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.conflict = null;
	            modal.wizard.step = step - 1;
	          },
	          done: function done() {
	            if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	              $scope.modal.locationView.unsubscribeSelectedEvent();
	              $scope.modal.locationView.unsubscribe();
	            }
	            $scope.modal.state = 'working';
	            var data = _lodash2.default.omit($scope.modal.userKey, ['userKeyId']);
	            if ($scope.modal.withLocation) {
	              data.locationId = $scope.modal.location.id;
	            }
	            if ($scope.modal.userkeyBound) {
	              data.customerId = $scope.modal.customer.id;
	            }
	            data.organizationId = $scope.modal.organizationId;
	            return resolve(_this6.UsersService.addUserkeyV0(data).catch(function () {
	              return Promise.reject(_this6.$translate.instant('ADD_USER_KEY_FAILED', { id: '<accent>' + $scope.modal.userKey.idToken + '</accent>' }));
	            }));
	          }
	        };
	        $scope.modal.locationView.unsubscribe = $scope.modal.locationView.subscribe();
	        if (groupId) {
	          $scope.modal.locationView.locationTableData.initLocations = [{ id: options.group.id, name: options.group.name, organizationId: options.organizationId, purpose: 'General' }];
	        }
	        $scope.modal.userkeyExpirationPeriod = $scope.modal.userkeyExpirationPeriods[$scope.modal.userkeyExpirationPeriods.length - 1];
	        $scope.modal.priority = $scope.modal.priorities[0];
	        $scope.modal.wizard.setSteps($scope.modal);
	        $scope.modal.searchBy = $scope.modal.searchByList[0];
	        $scope.modal.updateSearchBy($scope.modal.searchBy);
	        _this6.App.openModal($scope, 'add-userkey.html', { size: 'lg' });
	      });
	    }
	  }]);

	  return UserKeyHelper;
	}();

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UsersService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _async = __webpack_require__(176);

	var _async2 = _interopRequireDefault(_async);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersService = exports.UsersService = function () {
	    UsersService.$inject = ["$http", "ENV", "LocalStorage", "$rootScope", "Organization", "Utils", "RequestService"];
	    function UsersService($http, ENV, LocalStorage, $rootScope, Organization, Utils, RequestService) {
	        'ngInject';

	        _classCallCheck(this, UsersService);

	        this.$http = $http;
	        this.async = _async2.default;
	        this.$rootScope = $rootScope;
	        this.LocalStorage = LocalStorage;
	        this.Organization = Organization;
	        this.ENV = ENV;
	        this.Utils = Utils;

	        this.role = LocalStorage.getRole() || undefined;
	        this.roles = [];
	        this.RequestService = RequestService;
	        this._notifications = {};
	        this._initializeNotifications();
	    }

	    _createClass(UsersService, [{
	        key: 'getUserByAdminProvider',
	        value: function getUserByAdminProvider(username) {
	            var _this = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var notifications = this.RequestService.getNotifications(options, this._notifications["getUserByAdminProvider"]);
	            var url = this.ENV.URL + '/users/' + username;
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: 'getUserByAdminOrganization',
	        value: function getUserByAdminOrganization(username) {
	            var _this2 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organizationId = _lodash2.default.get(options, 'organizationId', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getUserByAdminOrganization"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/users/' + username;
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this2.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: 'getUserByAdminGroup',
	        value: function getUserByAdminGroup(username) {
	            var _this3 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organizationId = _lodash2.default.get(options, 'organizationId', null);
	            var groupId = _lodash2.default.get(options, 'groupId', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getUserByAdminGroup"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/groups/' + groupId + '/users/' + username;
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this3.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: 'createUser',
	        value: function createUser(username, password, options) {
	            var payload = { 'username': username, 'password': password };
	            if (options && options.extra) payload['extra'] = options.extra;

	            return this.$http.post(this.ENV.URL + '/signup', payload).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getUserkey',
	        value: function getUserkey(keyId, options) {
	            var _this4 = this;

	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            //THIS CALL /admin MIGHT BE DEPRECATED
	            if (organization) {
	                options.extend = {
	                    'admin': {
	                        beforehandHref: function beforehandHref() {
	                            return _this4.ENV.URL + '/providers/' + _this4.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/userkeys/' + keyId + '/admin';
	                        }
	                    }
	                };
	            }
	            return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/userkeys/' + keyId, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getUserKeys',
	        value: function getUserKeys() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            var _this5 = this;

	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	            var isExport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	            options = this.Utils.setParams(options, isPaginated);
	            var organization = _lodash2.default.get(options, 'organization', null);
	            var group = _lodash2.default.get(options, 'group', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getUserKeys"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + (group ? '/groups/' + group : '') + '/userkeys';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this5.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : isExport ? _this5.Utils.parseExportCsvResponse(res) : res.data;
	            });
	        }
	    }, {
	        key: 'getGroupUserkeys',
	        value: function getGroupUserkeys(group) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var csv = arguments[2];

	            if (csv) options['params'] = { 'output': 'csv' };
	            options = this.Utils.setParams(options);
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/groups/' + group + '/userkeys', options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'addUserkey',
	        value: function addUserkey(userkey, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);

	            return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/userkeys', userkey, options).then(function (res) {
	                return res.data;
	            });
	            // .then(() => this.editUserKey(keyId, userkey, options))
	        }
	    }, {
	        key: 'addUserkeyV0',
	        value: function addUserkeyV0(userkey, options) {
	            var _this6 = this;

	            options = options || {};
	            var notifications = this.RequestService.getNotifications(options, this._notifications['addUserkeyV0']);
	            var url = this.ENV.URL + '/v0/tokens';
	            return this.RequestService.post(url, userkey, {}, notifications).then(function (res) {
	                return _this6.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'assignUserkey',
	        value: function assignUserkey(keyId, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            var payload = { organizationId: organization };
	            return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/userkeys/' + keyId + '/assign', payload).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'editUserkey',
	        value: function editUserkey(keyId, changed, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.put(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/userkeys/' + keyId, changed, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'putUserkey',
	        value: function putUserkey(keyId, changed, options) {
	            var _this7 = this;

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["editUserKey"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/userkeys/' + keyId;
	            return this.RequestService.put(url, changed, options, notifications).then(function (res) {
	                return _this7.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'removeUserkey',
	        value: function removeUserkey(keyId, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.delete(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/userkeys/' + keyId, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'addUserkeyToGroup',
	        value: function addUserkeyToGroup(keyId, group, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + (group ? '/groups/' + group : '') + '/userkeys/' + keyId, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'removeUserkeyFromGroup',
	        value: function removeUserkeyFromGroup(keyId, group, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.delete(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + (group ? '/groups/' + group : '') + '/userkeys/' + keyId, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'bindUserkeyToCustomer',
	        value: function bindUserkeyToCustomer(keyId, customerId, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/userkeys/' + keyId + '/admin/customer/' + customerId, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'unbindUserkeyToCustomer',
	        value: function unbindUserkeyToCustomer(keyId, customerId, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.delete(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/userkeys/' + keyId + '/admin/customer/' + customerId, options).then(function (res) {
	                return res.data;
	            });
	        }

	        //         function getHttpConfig(options) {
	        //     httpConfig = {};
	        //     if (_.get(options, 'params.output') == 'csv') {
	        //         httpConfig['responseType'] = 'blob';
	        //     }
	        //     return httpConfig;
	        // }

	    }, {
	        key: 'getRoles',
	        value: function getRoles() {
	            var _this8 = this;

	            return this.$http.get(this.ENV.URL + '/users/me/settings/roles').then(function (res) {
	                return res.data;
	            }).then(function (roles) {
	                _this8.setRoles(roles);
	                if (_lodash2.default.find(_this8.roles, { 'entity': 'provider', 'id': _this8.ENV.PROVIDER })) {
	                    return _this8.Organization.getOrganizations().then(function (organizations) {
	                        if (organizations && organizations.length > 0) {
	                            if (!_this8.$rootScope.providerOrganization) {
	                                var providerOrganization = _this8.LocalStorage.getProviderOrganization();
	                                if (providerOrganization && _lodash2.default.find(organizations, { id: providerOrganization })) {
	                                    _this8.$rootScope.providerOrganization = providerOrganization;
	                                    return;
	                                } else {
	                                    _this8.$rootScope.providerOrganization = undefined;
	                                    _this8.LocalStorage.deleteProviderOrganization();
	                                }
	                            }
	                        }
	                    });
	                } else {
	                    var organizationIds = _lodash2.default.uniq(_lodash2.default.map(_this8.roles, 'organization'));
	                    if (organizationIds && organizationIds.length > 0) {
	                        _this8.async.eachLimit(organizationIds, 10, function (organizationId) {
	                            if (_lodash2.default.find(_this8.roles, { 'entity': 'organization', 'role': 'admin', 'id': organizationId })) {
	                                _this8.Organization.getOrganization(organizationId);
	                            }
	                        }, function () {
	                            return roles;
	                        });
	                    }
	                }
	                return roles;
	            });
	        }
	    }, {
	        key: 'setRoles',
	        value: function setRoles(roles) {
	            var rolesWeight = ['admin', 'doer'];
	            var entitiesWeight = ['entity', 'organization', 'group'];
	            this.$rootScope.isPlatform = _lodash2.default.findIndex(roles, function (item) {
	                return item.entity === 'platform';
	            }) > -1;
	            this.roles = _lodash2.default.sortBy(_lodash2.default.filter(roles, { provider: this.ENV.PROVIDER }), [function (role) {
	                return entitiesWeight.indexOf(role.entity);
	            }, function (role) {
	                return rolesWeight.indexOf(role.role);
	            }]);
	            this.$rootScope.roles = this.roles;
	            if (!this.role || !_lodash2.default.find(this.roles, this.role)) {
	                this.setRole(this.roles.length > 0 ? this.roles[0] : null);
	            }
	        }
	    }, {
	        key: 'setRole',
	        value: function setRole(role) {
	            var changed = this.role && role && (role.id != this.role.id || role.entity != this.role.entity);
	            this.role = role;
	            if (role) this.LocalStorage.setRole(role);else this.LocalStorage.deleteRole();

	            this.$rootScope.role = this.role;
	            if (changed) this.$rootScope.$broadcast('role-changed');
	        }
	    }, {
	        key: '_initializeNotifications',
	        value: function _initializeNotifications() {
	            this._notifications = {
	                editUserKey: { success: "UPDATE_USERKEY_OK", error: "UPDATE_USERKEY_FAILED" },
	                getUserKeys: null,
	                getUserByAdminProvider: null,
	                getUserByAdminOrganization: null,
	                getUserByAdminGroup: null,
	                addUserkeyV0: null
	            };
	        }
	    }]);

	    return UsersService;
	}();

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UsersHelper = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UsersHelper = exports.UsersHelper = function () {
	    UsersHelper.$inject = ["App", "$state", "$translate", "ProvidersService", "Organization", "GroupsService", "UsersService"];
	    function UsersHelper(App, $state, $translate, ProvidersService, Organization, GroupsService, UsersService) {
	        'ngInject';

	        _classCallCheck(this, UsersHelper);

	        this.$state = $state;
	        this.$translate = $translate;
	        this.App = App;
	        this.ProvidersService = ProvidersService;
	        this.Organization = Organization;
	        this.GroupsService = GroupsService;
	        this.UsersService = UsersService;
	    }

	    // Set a role


	    _createClass(UsersHelper, [{
	        key: '_addUserRole',
	        value: function _addUserRole(user, provider, organization, group, options) {
	            var _this = this;

	            if (provider) {
	                return this.ProvidersService.addProviderRole(user).then(function () {
	                    if (!options || !options.avoidNotifications) _this.App.showNotification(_this.$translate.instant('ACTION.ADD_USER.ADD_TO_STAFF_SUCCESS', { name: '<strong>' + user.username + '</strong>', id: '<strong>' + provider.name + '</strong>' }), 'ok', null, 700);
	                    _this.App.closeModal();
	                }).catch(function () {
	                    if (!options || !options.avoidNotifications) _this.App.showNotification(_this.$translate.instant('ACTION.ADD_USER.ADD_TO_STAFF_FAILED', { name: '<strong>' + user.username + '</strong>', id: '<strong>' + provider.name + '</strong>' }), 'error');
	                    _this.App.closeModal();
	                });
	            }
	            if (organization) {
	                return this.Organization.addOrganizationRole(organization.id, user).then(function () {
	                    if (!options || !options.avoidNotifications) _this.App.showNotification(_this.$translate.instant('ACTION.ADD_USER.ADD_TO_STAFF_SUCCESS', { name: '<strong>' + user.username + '</strong>', id: '<strong>' + organization.name + '</strong>' }), 'ok', null, 700);
	                    _this.App.closeModal();
	                }).catch(function () {
	                    if (!options || !options.avoidNotifications) _this.App.showNotification(_this.$translate.instant('ACTION.ADD_USER.ADD_TO_STAFF_FAILED', { name: '<strong>' + user.username + '</strong>', id: '<strong>' + organization.name + '</strong>' }), 'error');
	                    _this.App.closeModal();
	                });
	            }
	            if (group) {
	                var model = { name: '<strong>' + user.username + '</strong>', id: '<strong>' + group.name + '</strong>' };
	                var notifications = { success: { value: "ADD_PROFILE_SUCCESS", model: model }, error: { value: "ADD_PROFILE_FAILED", model: model } };
	                return this.GroupsService.addGroupRole(group, user, { organization: options.organization, notifications: notifications }).then(function () {
	                    return _this.App.closeModal();
	                });
	            }
	        }

	        // Create a user

	    }, {
	        key: '_createUser',
	        value: function _createUser(user, lang, provider, organization, group, options) {
	            var _this2 = this;

	            var userOptions = {
	                extra: { displayName: user.username.substr(0, user.username.indexOf('@')), lang: lang }
	            };
	            return this.UsersService.createUser(user.username, this.App.getRandomString(12) + 'aA1', userOptions).then(function (newUser) {
	                if (options && options.skipSetUserRole) {
	                    return newUser;
	                } else {
	                    return _this2._addUserRole(user, provider, organization, group, options);
	                }
	            }).catch(function () {
	                if (!options || !options.avoidNotifications) {
	                    _this2.App.showNotification(_this2.$translate.instant('ACTION.ADD_USER.SIGNUP_FAILED', { name: '<strong>' + user.username + '</strong>' }), 'error');
	                    _this2.App.closeModal();
	                }
	            });
	        }
	    }, {
	        key: 'getExistingUser',
	        value: function getExistingUser(username) {
	            var organizationId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var groupId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	            if (!username) {
	                return Promise.resolve(false);
	            }
	            if (organizationId && groupId) {
	                return this.UsersService.getUserByAdminGroup(username, { organizationId: organizationId, groupId: groupId });
	            } else if (organizationId) {
	                return this.UsersService.getUserByAdminOrganization(username, { organizationId: organizationId });
	            }
	            return this.UsersService.getUserByAdminProvider(username);
	        }
	        // Create user if needed and then set a role

	    }, {
	        key: '_addUser',
	        value: function _addUser(modal, options) {
	            var _this3 = this;

	            // If user doesn't exist, create it first
	            var organizationId = modal.organization ? modal.organization.id : modal.organizationId ? modal.organizationId : null;
	            var groupId = modal.group ? modal.group.id : modal.groupId ? modal.groupId : null;
	            return this.getExistingUser(modal.user.username, organizationId, groupId).then(function (aux) {
	                if (aux) {
	                    return _this3._addUserRole(modal.user, modal.provider, modal.organization, modal.group, options);
	                }
	                return _this3._createUser(modal.user, modal.lang.option, modal.provider, modal.organization, modal.group, options);
	            });
	        }
	    }, {
	        key: '_changeUserRole',
	        value: function _changeUserRole(user, provider, organization, group, options) {
	            var _this4 = this;

	            if (provider) {
	                return this.ProvidersService.addProviderRole(user).then(function () {
	                    if (!options || !options.avoidNotifications) _this4.App.showNotification(_this4.$translate.instant('ACTION.EDIT_ROLE.SUCCESS', { name: '<strong>' + user.username + '</strong>' }), 'ok', null, 700);
	                    _this4.App.closeModal();
	                }).catch(function () {
	                    if (!options || !options.avoidNotifications) _this4.App.showNotification(_this4.$translate.instant('ACTION.EDIT_ROLE.STAFF_FAILED', { name: '<strong>' + user.username + '</strong>', id: '<strong>' + provider.name + '</strong>' }), 'error');
	                    _this4.App.closeModal();
	                });
	            }
	            if (organization) {
	                return this.Organization.addOrganizationRole(organization.id, user).then(function () {
	                    if (!options || !options.avoidNotifications) _this4.App.showNotification(_this4.$translate.instant('ACTION.EDIT_ROLE.SUCCESS', { name: '<strong>' + user.username + '</strong>' }), 'ok', null, 700);
	                    _this4.App.closeModal();
	                }).catch(function () {
	                    if (!options || !options.avoidNotifications) _this4.App.showNotification(_this4.$translate.instant('ACTION.EDIT_ROLE.STAFF_FAILED', { name: '<strong>' + user.username + '</strong>', id: '<strong>' + organization.name + '</strong>' }), 'error');
	                    _this4.App.closeModal();
	                });
	            }
	            if (group) {
	                var model = { name: '<strong>' + user.username + '</strong>', id: '<strong>' + group.name + '</strong>' };
	                var notifications = { success: { value: "EDIT_PROFILE_SUCCESS", model: model }, error: { value: "EDIT_PROFILE_FAILED", model: model } };
	                return this.GroupsService.addGroupRole(group, user, { organization: options.organization, notifications: notifications }).then(function () {
	                    return _this4.App.closeModal();
	                });
	            }
	        }
	    }, {
	        key: '_removeUserRole',
	        value: function _removeUserRole(user, provider, organization, group, options) {
	            var _this5 = this;

	            if (provider) {
	                return this.ProvidersService.removeProviderRole(user.username).then(this.App.closeModal()).catch(function () {
	                    if (!options || !options.avoidNotifications) _this5.App.showNotification(_this5.$translate.instant('ACTION.REMOVE_ROLE.FAILED', { name: '<strong>' + user.username + '</strong>' }), 'error');
	                    _this5.App.closeModal();
	                });
	            }
	            if (organization) {
	                return this.Organization.removeOrganizationRole(organization.id, user.username).then(this.App.closeModal()).catch(function () {
	                    if (!options || !options.avoidNotifications) _this5.App.showNotification(_this5.$translate.instant('ACTION.REMOVE_ROLE.FAILED', { name: '<strong>' + user.username + '</strong>' }), 'error');
	                    _this5.App.closeModal();
	                });
	            }
	            if (group) {
	                var model = { name: '<strong>' + user.username + '</strong>', id: '<strong>' + group.name + '</strong>' };
	                var notifications = { success: { value: "REMOVE_PROFILE_SUCCESS", model: model }, error: { value: "REMOVE_PROFILE_FAILED", model: model } };
	                return this.GroupsService.removeGroupRole(group, user.username, { organization: options.organization, notifications: notifications }).then(function () {
	                    return _this5.App.closeModal();
	                });
	            }
	        }
	    }, {
	        key: '_unblockUser',
	        value: function _unblockUser(user, options) {
	            var _this6 = this;

	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.Organization.unblockOrganizationUser(organization, user, options).then(function () {
	                _this6.App.showNotification(_this6.$translate.instant('ACTION.UNBLOCK.OK', { name: user }), 'ok', null, 1000);
	                _this6.App.closeModal();
	            }).catch(function () {
	                _this6.App.showNotification(_this6.$translate.instant('ACTION.UNBLOCK.FAILED'), 'error');
	                _this6.App.closeModal();
	            });
	        }
	    }, {
	        key: 'createUserIfNeeded',
	        value: function createUserIfNeeded(user, organization) {
	            var _this7 = this;

	            var organizationId = organization ? organization.id : null;
	            return this.getExistingUser(user.username, organizationId).then(function (aux) {
	                if (aux) {
	                    return null;
	                }
	                return _this7._createUser(user, "es", null, organization, null, { 'avoidNotifications': true, 'skipSetUserRole': true });
	            });
	        }
	    }, {
	        key: 'checkUsername',
	        value: function checkUsername(username, modal) {
	            modal.existingUser = undefined;
	            modal.userLoading = true;
	            var organizationId = modal.organization ? modal.organization.id : modal.organizationId ? modal.organizationId : null;
	            var groupId = modal.group ? modal.group.id : modal.groupId ? modal.groupId : null;
	            return this.getExistingUser(username, organizationId, groupId).then(function (user) {
	                if (user) {
	                    modal.existingUser = user;
	                } else {
	                    modal.existingUser = null;
	                }
	                modal.userLoading = false;
	            });
	        }
	    }, {
	        key: 'addRole',
	        value: function addRole($scope, at) {
	            var _this8 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var isValid = function isValid(modal, scope) {
	                switch (modal.wizard.steps[modal.wizard.step].id) {
	                    case 'email':
	                        return !!modal.user.username && scope.form.username.$valid;
	                    // case 'group':
	                    //   return (modal.group)
	                }
	                return true;
	            };
	            var next = function next(modal) {
	                switch (modal.wizard.steps[modal.wizard.step + 1].id) {
	                    // case 'group': {
	                    //   modal.groupsLoading = true;
	                    //   API.getGroups({organization: modal.organization.id}, function(err, groups){
	                    //     if (!err && groups) {
	                    //       modal.groups = groups;
	                    //     }
	                    //     modal.groupsLoading = false;
	                    //   });
	                    //
	                    // }
	                    // break;
	                    case 'role':
	                        break;
	                }
	            };
	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    user: { 'username': null, 'role': 'doer' },
	                    lang: {
	                        option: "es",
	                        options: [{ 'display': _this8.$translate.instant('COMMON.LANG_ES'), 'id': 'es' }, { 'display': _this8.$translate.instant('COMMON.LANG_EN'), 'id': 'en' }, { 'display': _this8.$translate.instant('COMMON.LANG_GL'), 'id': 'gl' }, { 'display': _this8.$translate.instant('COMMON.LANG_PT'), 'id': 'pt' }]
	                    },
	                    existingUser: undefined,
	                    provider: at.provider,
	                    organization: at.organization,
	                    group: at.group,
	                    entity: at.provider ? 'provider' : at.organization ? 'organization' : 'group',
	                    organizationId: options.organization,
	                    onUsernameChanged: _lodash2.default.throttle(_this8.checkUsername.bind(_this8), 1200, { 'leading': true, 'trailing': true }),
	                    availableRoles: ['admin', 'doer'],
	                    // tree: {
	                    //   'id': 'id',
	                    //   'title': 'name',
	                    //   'subtitle': 'desc',
	                    //   'nodes': 'groups',
	                    //   'selected': [],
	                    //   'selectable': true,
	                    //   'custom': App.getGroupsTreeCustom(),
	                    //   'zeroResults': 'No hay ninguna zona todavía',
	                    // },
	                    // onGroupClick: function(group) {
	                    //   $scope.modal.group = group;
	                    // },
	                    wizard: {
	                        step: 0,
	                        steps: [{ 'id': 'email', 'title': _this8.$translate.instant('ACTION.ADD_USER.EMAIL'), 'intro': _this8.$translate.instant('ACTION.ADD_USER.ENTER_EMAIL') }, { 'id': 'role', 'title': _this8.$translate.instant('ACTION.ADD_USER.ROLE'), 'intro': at.group ? _this8.$translate.instant('ACTION.ADD_USER.ENTER_GROUP_ROLE') : _this8.$translate.instant('ACTION.ADD_USER.ENTER_ORGANIZATION_ROLE') }, { 'id': 'lang', 'title': _this8.$translate.instant('COMMON.LANG'), 'intro': _this8.$translate.instant('ACTION.ADD_USER.ENTER_LANG') },
	                        // {'id': 'group', 'title': 'Zona', 'intro': 'Permisos adicionales para una zona'},
	                        { 'id': 'summary', 'title': _this8.$translate.instant('ACTION.ADD_USER.SUMMARY'), 'intro': _this8.$translate.instant('ACTION.ADD_USER.ENTER_SUMMARY') }]
	                    },
	                    isValid: isValid,
	                    next: next,
	                    done: function done() {
	                        return resolve(_this8._addUser($scope.modal, options));
	                    }
	                };
	                _this8.App.openModal($scope, 'add-user.html', { 'size': 'lg' });
	            });
	        }
	    }, {
	        key: 'editRole',
	        value: function editRole($scope, user, at) {
	            var _this9 = this;

	            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    user: { 'username': user.username, 'role': user.role },
	                    provider: at.provider,
	                    organization: at.organization,
	                    group: at.group,
	                    entity: at.provider ? 'provider' : at.organization ? 'organization' : 'group',
	                    organizationId: options.organization,
	                    availableRoles: ['admin', 'doer'],
	                    wizard: {
	                        step: 0,
	                        steps: [{ 'id': 'role', 'title': _this9.$translate.instant('ACTION.EDIT_ROLE.ROLE'), 'intro': at.group ? _this9.$translate.instant('ACTION.EDIT_ROLE.ENTER_GROUP_ROLE') : _this9.$translate.instant('ACTION.EDIT_ROLE.ENTER_ORGANIZATION_ROLE') }, { 'id': 'summary', 'title': _this9.$translate.instant('ACTION.EDIT_ROLE.SUMMARY'), 'intro': _this9.$translate.instant('ACTION.EDIT_ROLE.ENTER_SUMMARY') }]
	                    },
	                    isValid: function isValid() {
	                        return true;
	                    },
	                    next: function next() {},
	                    done: function done() {
	                        return resolve(_this9._changeUserRole($scope.modal.user, $scope.modal.provider, $scope.modal.organization, $scope.modal.group, options));
	                    }
	                };

	                _this9.App.openModal($scope, 'edit-user.html', { 'size': 'lg' });
	            });
	        }
	    }, {
	        key: 'removeRole',
	        value: function removeRole($scope, user, at) {
	            var _this10 = this;

	            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    user: { 'username': user.username, 'role': user.role },
	                    provider: at.provider,
	                    organization: at.organization,
	                    group: at.group,
	                    entity: at.provider ? 'provider' : at.organization ? 'organization' : 'group',
	                    organizationId: options.organization,
	                    done: function done() {
	                        return resolve(_this10._removeUserRole($scope.modal.user, $scope.modal.provider, $scope.modal.organization, $scope.modal.group, options));
	                    }
	                };

	                _this10.App.openModal($scope, 'remove-user.html');
	            });
	        }
	    }, {
	        key: 'unblockUser',
	        value: function unblockUser($scope, user) {
	            var _this11 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            return new Promise(function (resolve) {
	                $scope.modal = {
	                    user: user.userId || user.username,
	                    done: function done() {
	                        return resolve(_this11._unblockUser($scope.modal.user, options));
	                    }
	                };
	                _this11.App.openModal($scope, 'unblock-user.html');
	            });
	        }
	    }]);

	    return UsersHelper;
	}();

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChargePointsService = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargePointsService = exports.ChargePointsService = function () {
	    ChargePointsService.$inject = ["$http", "ENV", "$timeout", "Utils", "LocalStorage", "SocketService", "RequestService"];
	    function ChargePointsService($http, ENV, $timeout, Utils, LocalStorage, SocketService, RequestService) {
	        'ngInject';

	        _classCallCheck(this, ChargePointsService);

	        this.$http = $http;
	        this.ENV = ENV;
	        this.$timeout = $timeout;
	        this.Utils = Utils;
	        this.LocalStorage = LocalStorage;
	        this.SocketService = SocketService;
	        this.RequestService = RequestService;
	        this.BASE_URL = this.ENV.URL + '/providers/' + this.ENV.PROVIDER;
	        this.NEW_BASE_URL = this.ENV.URL + '/v0';
	        this._notifications = {};
	        this._initializeNotifications();
	    }

	    _createClass(ChargePointsService, [{
	        key: 'getChargePoints',
	        value: function getChargePoints() {
	            var _this = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	            options = this.Utils.setParams(options, isPaginated, true);
	            var organizationId = _lodash2.default.get(options, 'organizationId', null);
	            if (organizationId) {
	                options.params.organizationId = organizationId;
	            }
	            var locationId = _lodash2.default.get(options, 'locationId', null);
	            if (locationId) {
	                options.params.locationId = locationId;
	            }
	            var notifications = this.RequestService.getNotifications(options, this._notifications['getChargePoints']);
	            var url = this.ENV.URL + '/v1/admin/charge-points';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this.Utils.parsePaginationResponseForV1(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'getChargepoints',
	        value: function getChargepoints() {
	            var _this2 = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	            options = this.Utils.setParams(options, isPaginated);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargepoints"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + this.Utils.getGroupQuery(options.group) + '/chargepoints';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this2.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'getProviderChargepoints',
	        value: function getProviderChargepoints() {
	            var _this3 = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getProviderChargepoints"]);
	            var url = this.BASE_URL + '/chargepoints';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this3.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : _this3.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getProviderChargepointsBySerialOCPP',
	        value: function getProviderChargepointsBySerialOCPP(serialOCPP) {
	            var _this4 = this;

	            return this.RequestService.get(this.BASE_URL + '/chargepoints/' + encodeURIComponent(serialOCPP)).then(function (res) {
	                return _this4.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'exportChargepoints',
	        value: function exportChargepoints() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options['params'] = { output: 'csv' };
	            return this.getChargepoints(options, false);
	        }
	    }, {
	        key: 'exportChargePointsToJson',
	        value: function exportChargePointsToJson() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            var notifications = this.RequestService.getNotifications(options, this._notifications["exportChargePointsToJson"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + this.Utils.getGroupQuery(options.group) + '/export-json';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'exportProviderChargepoints',
	        value: function exportProviderChargepoints() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options['params'] = { output: 'csv' };
	            return this.getProviderChargepoints(options);
	        }
	    }, {
	        key: 'getChargepoint',
	        value: function getChargepoint(id, options) {
	            if (!options || !options.organization) {
	                return this.$http.get(this.NEW_BASE_URL + '/chargepoints/' + id).then(function (res) {
	                    return res.data;
	                });
	            }
	            return this.$http.get('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'registerChargepointListener',
	        value: function registerChargepointListener(id, listener) {
	            this.SocketService.chargepointListeners[id] = this.SocketService.chargepointListeners[id] || [];
	            this.SocketService.chargepointListeners[id].push(listener);
	        }
	    }, {
	        key: 'unregisterChargepointListener',
	        value: function unregisterChargepointListener(id, listener) {
	            if (this.SocketService.chargepointListeners[id]) {
	                _lodash2.default.pull(this.SocketService.chargepointListeners[id], listener);
	            }
	        }
	    }, {
	        key: 'subscribeToChargepoints',
	        value: function subscribeToChargepoints(chargepoints, options) {
	            var _this5 = this;

	            if (angular.isUndefined(this.SocketService.id)) {
	                return this.SocketService.openChannel().then(function () {
	                    return _this5.subscribeToChargepoints(chargepoints, options);
	                });
	            }
	            var notifications = this.RequestService.getNotifications(options, this._notifications["subscribeToChargepoints"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/events';
	            var data = _lodash2.default.assign({}, { channel: this.SocketService.id, chargepoints: chargepoints });
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this5.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'unsubscribeToChargepoint',
	        value: function unsubscribeToChargepoint(id, options, listener) {
	            if (listener) this.unregisterChargepointListener(id, listener);
	        }
	    }, {
	        key: 'addChargepoint',
	        value: function addChargepoint(serialOCPP, group) {
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var payload = {
	                serialOCPP: serialOCPP,
	                name: _lodash2.default.get(options, 'name', serialOCPP),
	                ownership: _lodash2.default.get(options, 'ownership', 'public'),
	                vehicleType: _lodash2.default.get(options, 'vehicleType', 'AllVehicles')
	            };
	            if (group) payload['groupId'] = group;
	            return this.$http.post('' + this.BASE_URL + this.Utils.getOrganizationQuery(organization) + '/chargepoints', payload).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'assignChargepoint',
	        value: function assignChargepoint(id) {
	            var _this6 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var firstReassign = this.$http.post(this.BASE_URL + '/unassigned/chargepoints/' + id + '/assign', { organizationId: options.organization }).then(function (res) {
	                return res.data;
	            });
	            var thenAddToGroup = firstReassign.then(function (data) {
	                return _this6.addChargepointToGroup(data.id, options.group, options);
	            });
	            /* eslint-disable no-unused-vars */
	            return Promise.all([firstReassign, thenAddToGroup]).then(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    reassignData = _ref2[0],
	                    addToGroupData = _ref2[1];

	                return reassignData;
	            });
	            /* eslint-enable no-unused-vars */
	        }
	    }, {
	        key: 'reassignChargepoint',
	        value: function reassignChargepoint(id) {
	            var _this7 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var firstReassign = this.$http.post(this.BASE_URL + '/organizations/' + options.leavingOrganization + '/chargepoints/' + id + '/manage/changeorganization', { organizationId: options.organization }).then(function (res) {
	                return res.data;
	            });
	            var thenAddToGroup = firstReassign.then(function (data) {
	                return _this7.addChargepointToGroup(data.id, options.group, options);
	            });
	            /* eslint-disable no-unused-vars */
	            return Promise.all([firstReassign, thenAddToGroup]).then(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    reassignData = _ref4[0],
	                    addToGroupData = _ref4[1];

	                return reassignData;
	            });
	            /* eslint-enable no-unused-vars */
	        }
	    }, {
	        key: 'addChargepointToGroup',
	        value: function addChargepointToGroup(id, group) {
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            return this.$http.post('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + this.Utils.getGroupQuery(group) + '/chargepoints/' + id).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'editChargepoint',
	        value: function editChargepoint(id, changed) {
	            var _this8 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var notifications = this.RequestService.getNotifications(options, this._notifications["editChargepoint"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id;
	            return this.RequestService.put(url, changed, options, notifications).then(function (res) {
	                return _this8.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: 'editProtectedChargepoint',
	        value: function editProtectedChargepoint(id, changed) {
	            var _this9 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var notifications = this.RequestService.getNotifications(options, this._notifications["editProtectedChargepoint"]);
	            var url = this.ENV.URL + '/chargepoints/' + id + '/admin';
	            return this.RequestService.put(url, changed, options, notifications).then(function (res) {
	                return _this9.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: 'removeChargepoint',
	        value: function removeChargepoint(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return this.$http.delete('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getChargepointOCPPMessages',
	        value: function getChargepointOCPPMessages(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            options = this.Utils.setParams(options);

	            return this.$http.get('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/ocppmessages', options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'exportChargepointOCPPMessages',
	        value: function exportChargepointOCPPMessages(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            options['params'] = { output: 'csv' };
	            return this.getChargepointOCPPMessages(id, options, false);
	        }
	    }, {
	        key: 'getChargepointDiagnostics',
	        value: function getChargepointDiagnostics() {
	            //TODO
	        }
	    }, {
	        key: 'getChargepointStatusValues',
	        value: function getChargepointStatusValues(id) {
	            var _this10 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargepointStatusValues"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/statusvalues';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this10.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'resetChargepoint',
	        value: function resetChargepoint(id, type) {
	            var _this11 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["resetChargepoint"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/reset';
	            var data = { type: type, channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this11.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'clearChargepointCache',
	        value: function clearChargepointCache(id) {
	            var _this12 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["clearChargepointCache"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/clearcache';
	            var data = { channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this12.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'clearLocalAuthorizationList',
	        value: function clearLocalAuthorizationList(id) {
	            var _this13 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["clearLocalAuthorizationList"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/sendlocallist';
	            var data = { listVersion: 1, updateType: 'Full', localAuthorizationList: [], channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this13.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'triggerMessage',
	        value: function triggerMessage(id, message) {
	            var _this14 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["triggerMessage"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/triggermessage';
	            var data = _lodash2.default.assign({}, message, { channel: this.SocketService.id });
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this14.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getChargepointProgramReboot',
	        value: function getChargepointProgramReboot(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return this.$http.get('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/programmedtasks').then(function (res) {
	                return res.data;
	            }).then(function (tasks) {
	                return _lodash2.default.filter(tasks, function (item) {
	                    return item["type"] == "reboot";
	                });
	            }).catch(function () {
	                //Pending definition of the request handlers
	            });
	        }
	    }, {
	        key: 'programChargepointReboot',
	        value: function programChargepointReboot(id, programedReboot) {
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var method = "post";
	            var programedRebootId = "";
	            var payload = _lodash2.default.pick(programedReboot, ['type', 'period', 'windowStart', 'windowEnd']);
	            if (programedReboot.id) {
	                method = "put";
	                programedRebootId = "/" + programedReboot.id;
	            }
	            return this.$http[method]('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/programmedtasks' + programedRebootId, payload).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'removeChargepointProgramReboot',
	        value: function removeChargepointProgramReboot(id, task) {
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            return this.$http.delete('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/programmedtasks/' + task.id).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getChargepointConfigurationKey',
	        value: function getChargepointConfigurationKey(id, key) {
	            var _this15 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargepointConfigurationKey"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/getconfiguration';
	            var data = { key: [key], channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this15.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getChargepointConfiguration',
	        value: function getChargepointConfiguration(id) {
	            var _this16 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargepointConfiguration"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/getconfiguration';
	            var data = { key: [], channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this16.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'setChargepointConfiguration',
	        value: function setChargepointConfiguration(id, changed) {
	            var _this17 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var apiCalls = Object.keys(changed).map(function (key) {
	                var payload = {
	                    key: key,
	                    value: changed[key],
	                    channel: _this17.SocketService.id
	                };
	                return _this17.changeChargepointConfiguration(options, id, payload).then(function (res) {
	                    return res.data;
	                });
	            });

	            return Promise.all(apiCalls);
	        }
	    }, {
	        key: 'changeChargepointConfiguration',
	        value: function changeChargepointConfiguration(options, id, payload) {
	            return this.$http.post('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/changeconfiguration', payload).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'changeChargepointStatus',
	        value: function changeChargepointStatus(id, status) {
	            var _this18 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var payload = status ? { status: status } : {};
	            var notifications = this.RequestService.getNotifications(options, this._notifications["changeChargepointStatus"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id;
	            return this.RequestService.put(url, payload, options, notifications).then(function (res) {
	                return _this18.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: 'changeChargepointOwnership',
	        value: function changeChargepointOwnership(id, ownership) {
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var payload = ownership ? { ownership: ownership } : {};

	            return this.$http.put('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id, payload).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'changeChargepointAvailability',
	        value: function changeChargepointAvailability(id, availability, options) {
	            return this.changeChargepointConnectorAvailability(id, '0', availability, options);
	        }
	    }, {
	        key: '_asInt',
	        value: function _asInt(value) {
	            if (angular.isNumber(value)) return value;
	            return parseInt(value, 10);
	        }
	    }, {
	        key: 'changeChargepointConnectorAvailability',
	        value: function changeChargepointConnectorAvailability(id, connectorId, availability) {
	            var _this19 = this;

	            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["changeChargepointConnectorAvailability"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/changeavailability';
	            var data = { connectorId: this._asInt(connectorId), type: availability, channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this19.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'startChargepointConnectorRemoteTransaction',
	        value: function startChargepointConnectorRemoteTransaction(id, connectorId, idTag) {
	            var _this20 = this;

	            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["startChargepointConnectorRemoteTransaction"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/remotestarttransaction';
	            var data = { connectorId: this._asInt(connectorId), idTag: idTag };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this20.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'stopChargepointConnectorRemoteTransaction',
	        value: function stopChargepointConnectorRemoteTransaction(id, transactionId) {
	            var _this21 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["stopChargepointConnectorRemoteTransaction"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/remotestoptransaction';
	            var data = { transactionId: this._asInt(transactionId), channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this21.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'unlockChargepointConnector',
	        value: function unlockChargepointConnector(id, connectorId) {
	            var _this22 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["unlockChargepointConnector"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/unlockconnector';
	            var data = { connectorId: this._asInt(connectorId), channel: this.SocketService.id };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this22.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'editChargepointConnector',
	        value: function editChargepointConnector(id, connectorId, changed) {
	            var _this23 = this;

	            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	            var notifications = this.RequestService.getNotifications(options, this._notifications["editChargepointConnector"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/connectors/' + connectorId;
	            var data = changed || {};
	            return this.RequestService.put(url, data, options, notifications).then(function (res) {
	                return _this23.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getChargepointDiagnostic',
	        value: function getChargepointDiagnostic(id, diagnostic) {
	            var _this24 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargepointDiagnostic"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/getdiagnostics';
	            var data = _lodash2.default.assign(diagnostic, { channel: this.SocketService.id });
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this24.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'updateChargepointFirmware',
	        value: function updateChargepointFirmware(id, firmware) {
	            var _this25 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            options["params"] = { wait: true };
	            var notifications = this.RequestService.getNotifications(options, this._notifications["updateChargepointFirmware"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/chargepoints/' + id + '/admin/updatefirmware';
	            var data = _lodash2.default.assign(firmware, { channel: this.SocketService.id });
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this25.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'setSharedForChargepoint',
	        value: function setSharedForChargepoint(chargepoint, shared) {
	            var _this26 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, "organization", null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["setSharedForChargepoint"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(organization) + '/chargepoints/' + chargepoint["id"] + '/admin/protectedsettings';
	            var data = { shared: shared };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this26.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getRechargingSchedule',
	        value: function getRechargingSchedule(id) {
	            var _this27 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getRechargingSchedule"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(organization) + '/chargepoints/' + id + '/admin/chargeintervals';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this27.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'setRechargingSchedule',
	        value: function setRechargingSchedule(id, data) {
	            var _this28 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["setRechargingSchedule"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(organization) + '/chargepoints/' + id + '/admin/chargeintervals';
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this28.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getProxies',
	        value: function getProxies() {
	            var _this29 = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options = this.Utils.setParams(options);
	            var notifications = this.RequestService.getNotifications(options, this._notifications.getProxies);
	            var url = this.ENV.URL + '/proxies';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this29.RequestService.getResponse(res, false);
	            });
	        }
	    }, {
	        key: '_initializeNotifications',
	        value: function _initializeNotifications() {
	            this._notifications = {
	                getChargepointOCPPMessages: null,
	                setSharedForChargepoint: null,
	                startChargepointConnectorRemoteTransaction: { error: "START_REMOTE_COMMAND_FAILED" },
	                stopChargepointConnectorRemoteTransaction: { error: "STOP_REMOTE_COMMAND_FAILED" },
	                unlockChargepointConnector: { error: "UNLOCK_COMMAND_FAILED" },
	                getChargepointDiagnostic: { error: "DIAGNOSTIC_COMMAND_FAILED" },
	                updateChargepointFirmware: { error: "UPDATE_COMMAND_FAILED" },
	                changeChargepointConnectorAvailability: { error: "CONNECTOR_AVAILABILITY_COMMAND_FAILED" },
	                getChargepointConfiguration: { error: "CONFIGURATION_COMMAND_FAILED" },
	                getChargepointConfigurationKey: { error: "CONFIGURATION_KEY_COMMAND_FAILED" },
	                triggerMessage: { error: "TRIGGER_MESSAGE_COMMAND_FAILED" },
	                clearChargepointCache: { error: "CLEAR_CACHE_COMMAND_FAILED" },
	                resetChargepoint: { error: "RESET_COMMAND_FAILED" },
	                clearLocalAuthorizationList: { error: "CLEAR_AUTHORIZATION_LIST_COMMAND_FAILED" },
	                getRechargingSchedule: null,
	                setRechargingSchedule: { success: "", error: "UPDATE_RECHARGE_SCHEDULES_FAILED" },
	                subscribeToChargepoints: null,
	                getProxies: null,
	                editChargepoint: null,
	                editProtectedChargepoint: null,
	                editChargepointConnector: null,
	                getChargepoints: null,
	                exportChargePointsToJson: { success: "", error: "GROUP_CHARGEPOINTS_EXPORT_FAILED" },
	                changeChargepointStatus: { success: "CH.ACTIONS.OPERATIONAL_STATUS.SUCCESS" },
	                getChargepointStatusValues: null,
	                getProviderChargepoints: null,
	                getChargePoints: null
	            };
	        }
	    }]);

	    return ChargePointsService;
	}();

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChargePointsHelper = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _async = __webpack_require__(176);

	var _async2 = _interopRequireDefault(_async);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargePointsHelper = exports.ChargePointsHelper = function () {
	    ChargePointsHelper.$inject = ["$rootScope", "$filter", "$translate", "App", "OCPP", "GroupsHelper", "GroupsService", "Organization", "ChargePointsService", "moment"];
	    function ChargePointsHelper($rootScope, $filter, $translate, App, OCPP, GroupsHelper, GroupsService, Organization, ChargePointsService, moment) {
	        'ngInject';

	        _classCallCheck(this, ChargePointsHelper);

	        this.$filter = $filter;
	        this.$translate = $translate;
	        this.async = _async2.default;
	        this.App = App;
	        this.OCPP = OCPP;
	        this.GroupsHelper = GroupsHelper;
	        this.GroupsService = GroupsService;
	        this.Organization = Organization;
	        this.ChargePointsService = ChargePointsService;
	        this.moment = moment;

	        $rootScope.ChargepointsHelper = this;
	        this.performSearchByName = _lodash2.default.throttle(this.throttledPerformSearchByName.bind(this), 500, { 'leading': false, 'trailing': true });
	        this.performSearchById = _lodash2.default.throttle(this.throttledPerformSearchById.bind(this), 500, { 'leading': false, 'trailing': true });
	        this.performSearchByIdList = _lodash2.default.throttle(this.throttledPerformSearchByIdList.bind(this), 500, { 'leading': false, 'trailing': true });
	    }

	    _createClass(ChargePointsHelper, [{
	        key: 'throttledPerformSearchByName',
	        value: function throttledPerformSearchByName(term, $scope) {
	            var _this = this;

	            $scope.pickChargepointModal.state = 'loading';
	            var options = {
	                'params': { 'name.ilike': term }
	            };
	            this.ChargePointsService.getProviderChargepoints(options).then(function (chargepoints) {
	                $scope.pickChargepointModal.state = '';
	                return _this.$scope.pickChargepointModal.results = chargepoints;
	            });
	        }
	    }, {
	        key: 'searchByOrganization',
	        value: function searchByOrganization(organizationId, $scope) {
	            var _this2 = this;

	            if (!organizationId) return;
	            $scope.pickChargepointModal.state = 'loading';
	            var options = {
	                organization: organizationId
	                // WARNING: This is not a good way to do it. Must be paginated.
	            };this.ChargePointsService.getChargepoints(options, false).then(function (chargepoints) {
	                $scope.pickChargepointModal.state = '';
	                return _this2.$scope.pickChargepointModal.results = chargepoints;
	            });
	        }
	    }, {
	        key: 'searchByGroup',
	        value: function searchByGroup(groupId, organizationId, $scope) {
	            var _this3 = this;

	            if (!groupId || !organizationId) return;
	            $scope.pickChargepointModal.state = 'loading';
	            var options = {
	                organization: organizationId,
	                group: groupId
	                // WARNING: This is not a good way to do it. Must be paginated.
	            };this.ChargePointsService.getChargepoints(options, false).then(function (chargepoints) {
	                $scope.pickChargepointModal.state = '';
	                return _this3.$scope.pickChargepointModal.results = chargepoints;
	            });
	        }
	    }, {
	        key: 'getGroups',
	        value: function getGroups(organizationIds, $scope) {
	            var _this4 = this;

	            var pending = 0;
	            _lodash2.default.each(organizationIds, function (organizationId) {
	                if (organizationId) {
	                    if (!$scope.pickChargepointModal.groups[organizationId]) {
	                        pending++;
	                        $scope.pickChargepointModal.state = 'loading';
	                        _this4.GroupsService.getGroups({ 'organization': organizationId }).then(function (groups) {
	                            pending--;
	                            var flattenedGroups = _this4.GroupsHelper.flatten(groups, true);
	                            $scope.pickChargepointModal.groups[organizationId] = flattenedGroups;
	                            if (pending <= 0) $scope.pickChargepointModal.state = 'normal';
	                        });
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'throttledPerformSearchById',
	        value: function throttledPerformSearchById(term, $scope) {
	            var _this5 = this;

	            $scope.pickChargepointModal.state = 'loading';
	            var options = {
	                'params': { 'id.ilike': term }
	            };
	            this.ChargePointsService.getProviderChargepoints(options).then(function (chargepoints) {
	                $scope.pickChargepointModal.state = '';
	                return _this5.$scope.pickChargepointModal.results = chargepoints;
	            });
	        }
	    }, {
	        key: 'throttledPerformSearchByIdList',
	        value: function throttledPerformSearchByIdList(ids, $scope) {
	            var _this6 = this;

	            $scope.pickChargepointModal.state = 'loading';
	            var options = {
	                'params': { 'ids': ids.join(',') }
	            };
	            this.ChargePointsService.getProviderChargepoints(options).then(function (chargepoints) {
	                $scope.pickChargepointModal.state = '';
	                return _this6.$scope.pickChargepointModal.results = chargepoints;
	            });
	        }
	    }, {
	        key: 'extractFromIdList',
	        value: function extractFromIdList(term) {
	            if (!term) return [];
	            var tmp = term;
	            tmp = tmp.replaceAll(',', ' ');
	            tmp = tmp.replaceAll(';', ' ');
	            tmp = tmp.replace(/\s/g, ' ');
	            var tokens = tmp.split(' ');
	            tokens = _lodash2.default.filter(tokens, function (token) {
	                return token.length > 0;
	            });
	            return tokens;
	        }
	    }, {
	        key: 'pickChargepoint',
	        value: function pickChargepoint($scope) {
	            var _this7 = this;

	            this.$scope = $scope;
	            return new Promise(function (resolve) {
	                $scope["pickChargepointModal"] = {
	                    results: null,
	                    filter: {
	                        by: 'name',
	                        name: null,
	                        organization: null,
	                        group: null,
	                        id: null,
	                        idList: null
	                    },
	                    byOptions: [{ id: 'name', display: _this7.$translate.instant('ACTION.PICK_CHARGEPOINTS.SEARCH_BY_NAME') }, { id: 'group', display: _this7.$translate.instant('ACTION.PICK_CHARGEPOINTS.SEARCH_BY_GROUP') }, { id: 'id', display: _this7.$translate.instant('ACTION.PICK_CHARGEPOINTS.SEARCH_BY_ID') }, { id: 'idList', display: _this7.$translate.instant('ACTION.PICK_CHARGEPOINTS.SEARCH_BY_ID_LIST') }],
	                    organizations: null,
	                    groups: {},
	                    state: '',
	                    table: _this7.App.getTable('chargepointSearch'),
	                    reloadResults: function reloadResults() {
	                        $scope.pickChargepointModal.results = null;
	                        $scope.pickChargepointModal.table.selected = [];
	                        switch ($scope.pickChargepointModal.filter.by) {
	                            case 'name':
	                                $scope.pickChargepointModal.doSearchByName();
	                                break;
	                            case 'group':
	                                $scope.pickChargepointModal.doSearchByGroup();
	                                break;
	                            case 'id':
	                                $scope.pickChargepointModal.doSearchById();
	                                break;
	                            case 'idList':
	                                $scope.pickChargepointModal.doSearchByIdList();
	                                break;
	                        }
	                    },
	                    onOrganizationChanged: function onOrganizationChanged() {
	                        $scope.pickChargepointModal.filter.group = null;
	                        _this7.getGroups([$scope.pickChargepointModal.filter.organization], $scope);
	                        $scope.pickChargepointModal.reloadResults();
	                    },
	                    doSearchByName: function doSearchByName() {
	                        if ($scope.pickChargepointModal.filter.name && $scope.pickChargepointModal.filter.name.length > 2) {
	                            _this7.performSearchByName($scope.pickChargepointModal.filter.name, $scope);
	                        }
	                    },
	                    doSearchByGroup: function doSearchByGroup() {
	                        if ($scope.pickChargepointModal.filter.group && $scope.pickChargepointModal.filter.organization) {
	                            _this7.searchByGroup($scope.pickChargepointModal.filter.group, $scope.pickChargepointModal.filter.organization, $scope);
	                        } else if ($scope.pickChargepointModal.filter.organization) {
	                            _this7.searchByOrganization($scope.pickChargepointModal.filter.organization, $scope);
	                        }
	                    },
	                    doSearchById: function doSearchById() {
	                        if ($scope.pickChargepointModal.filter.id && $scope.pickChargepointModal.filter.id.length > 2) {
	                            _this7.performSearchById($scope.pickChargepointModal.filter.id, $scope);
	                        }
	                    },
	                    doSearchByIdList: function doSearchByIdList() {
	                        var ids = _this7.extractFromIdList($scope.pickChargepointModal.filter.idList);
	                        if (ids.length > 0) {
	                            _this7.performSearchByIdList(ids, $scope);
	                        }
	                    },
	                    done: function done() {
	                        _this7.App.closeModal(undefined, { 'name': 'pickChargepointModal' });
	                        var chargepoints = _lodash2.default.map($scope.pickChargepointModal.table.selected, function (id) {
	                            return _lodash2.default.find($scope.pickChargepointModal.results, { 'id': id });
	                        });
	                        resolve(chargepoints);
	                    },
	                    close: function close() {
	                        _this7.App.closeModal(undefined, { 'name': 'pickChargepointModal' });
	                        resolve([]);
	                    }
	                };
	                _this7.App.openModal($scope, 'pick-chargepoint.html', { 'size': 'lg', 'name': 'pickChargepointModal' });
	            });
	        }
	    }]);

	    return ChargePointsHelper;
	}();

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargeSessionsService = exports.ChargeSessionsService = function () {
	    ChargeSessionsService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	    function ChargeSessionsService($http, ENV, Utils, RequestService) {
	        'ngInject';

	        _classCallCheck(this, ChargeSessionsService);

	        this.$http = $http;
	        this.Utils = Utils;
	        this.RequestService = RequestService;
	        this.ENV = ENV;
	        this.BASE_URL = ENV.URL + "/providers/" + ENV.PROVIDER;
	        this._notifications = {};
	        this._initializeNotifications();
	    }

	    _createClass(ChargeSessionsService, [{
	        key: "getCharge",
	        value: function getCharge(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            if (options.chargepointId) {
	                return this.$http.get("" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + "/chargepoints/" + options.chargepointId + "/chargingsessions/" + id, options).then(function (res) {
	                    return res.data;
	                });
	            } else {
	                return this.$http.get("" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + "/chargingsessions/" + id, options).then(function (res) {
	                    return res.data;
	                });
	            }
	        }
	    }, {
	        key: "getCharges",
	        value: function getCharges() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            var _this = this;

	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	            var isExport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getCharges"]);
	            var url = "" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + this.Utils.getGroupQuery(options.group) + "/chargingsessions";
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : isExport ? _this.Utils.parseExportCsvResponse(res) : res.data;
	            });
	        }
	    }, {
	        key: "getDashboardCharges",
	        value: function getDashboardCharges() {
	            var _this2 = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options = this.Utils.setParams(options, true);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getDashboardCharges"]);
	            var url = "" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + this.Utils.getGroupQuery(options.group) + "/chargingsessions/dashboard";
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this2.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage);
	            });
	        }
	    }, {
	        key: "exportCharges",
	        value: function exportCharges() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options['params'] = { 'output': 'csv' };
	            return this.getCharges(options, false);
	        }
	    }, {
	        key: "getChargesByChargepoint",
	        value: function getChargesByChargepoint(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var _this3 = this;

	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	            var isExport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var url = "" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + "/chargepoints/" + id + "/chargingsessions";
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargesByChargepoint"]);
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this3.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : isExport ? _this3.Utils.parseExportCsvResponse(res) : res.data;
	            });
	        }
	    }, {
	        key: "getChargesByUserkey",
	        value: function getChargesByUserkey(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var _this4 = this;

	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	            var isExport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var url = "" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + "/userkeys/" + id + "/chargingsessions";
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargesByUserkey"]);
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this4.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : isExport ? _this4.Utils.parseExportCsvResponse(res) : res.data;
	            });
	        }
	    }, {
	        key: "getChargeMeterValues",
	        value: function getChargeMeterValues(id) {
	            var _this5 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getChargeMeterValues"]);
	            var url = "" + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + "/chargingsessions/" + id + "/metervalues";
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this5.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: "closeTransaction",
	        value: function closeTransaction(id, payload) {
	            var _this6 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var notifications = this.RequestService.getNotifications(options, this._notifications["closeTransaction"]);
	            var url = this.ENV.URL + "/chargingsessions/" + id + "/close";
	            var data = payload;
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this6.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: "_initializeNotifications",
	        value: function _initializeNotifications() {
	            this._notifications = {
	                closeTransaction: { error: "CLOSE_FAILED" },
	                getDashboardCharges: null,
	                getCharges: { error: "EXPORT_CHARGES_FAILED" },
	                getChargeMeterValues: null,
	                getChargesByUserkey: null,
	                getChargesByChargepoint: null
	            };
	        }
	    }]);

	    return ChargeSessionsService;
	}();

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CustomersService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CustomersService = exports.CustomersService = function () {
	    CustomersService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	    function CustomersService($http, ENV, Utils, RequestService) {
	        'ngInject';

	        _classCallCheck(this, CustomersService);

	        this.$http = $http;
	        this.ENV = ENV;
	        this.Utils = Utils;
	        this.BASE_URL = ENV.URL + '/providers/' + ENV.PROVIDER;
	        this.RequestService = RequestService;
	        this._notifications = {};
	        this._initializeNotifications();
	    }

	    _createClass(CustomersService, [{
	        key: 'getCustomer',
	        value: function getCustomer(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return this.$http.get('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/customers/' + id, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getCustomers',
	        value: function getCustomers() {
	            var _this = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            return this.$http.get('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/customers', options).then(function (res) {
	                return isPaginated ? _this.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'exportCustomers',
	        value: function exportCustomers() {
	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options['params'] = { 'output': 'csv' };
	            return this.getCustomers(options);
	        }
	    }, {
	        key: 'addCustomer',
	        value: function addCustomer(customer) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return this.$http.post('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/customer', customer, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getUserkeysByCustomer',
	        value: function getUserkeysByCustomer(id) {
	            var _this2 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	            options = this.Utils.setParams(options, isPaginated);
	            var notifications = this.RequestService.getNotifications(options, this._notifications.getUserkeysByCustomer);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/customers/' + id + '/userkeys';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this2.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'getPaymentsByCustomer',
	        value: function getPaymentsByCustomer(id) {
	            var _this3 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getPaymentsByCustomer"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(organization) + '/customers/' + id + '/payments';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this3.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'editCustomer',
	        value: function editCustomer(id, changed) {
	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            return this.$http.put('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/customers/' + id, changed, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'removeCustomer',
	        value: function removeCustomer(id) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            return this.$http.delete('' + this.BASE_URL + this.Utils.getOrganizationQuery(options.organization) + '/customers/' + id, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'getCustomerConsents',
	        value: function getCustomerConsents(id, options) {
	            var _this4 = this;

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getCustomerConsents"]);
	            var url = '' + this.BASE_URL + this.Utils.getOrganizationQuery(organization) + '/customers/' + id + '/consents';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this4.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: '_initializeNotifications',
	        value: function _initializeNotifications() {
	            this._notifications = {
	                getPaymentsByCustomer: null,
	                getCustomerConsents: null,
	                getUserkeysByCustomer: null
	            };
	        }
	    }]);

	    return CustomersService;
	}();

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupsService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GroupsService = exports.GroupsService = function () {
	    GroupsService.$inject = ["$http", "ENV", "RequestService", "Utils"];
	    function GroupsService($http, ENV, RequestService, Utils) {
	        'ngInject';

	        _classCallCheck(this, GroupsService);

	        this.$http = $http;
	        this.ENV = ENV;
	        this.RequestService = RequestService;
	        this.Utils = Utils;
	        this._notifications = {};
	        this._initializeNotifications();
	    }

	    _createClass(GroupsService, [{
	        key: 'getGroups',
	        value: function getGroups() {
	            var _this = this;

	            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	            options['forceArray'] = true;
	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getGroups"]);
	            var group = _lodash2.default.get(options, 'group', null);
	            var groupURL = group ? '/' + group + '/admin' : '';
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups' + groupURL;
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                var data = _this.RequestService.getResponse(res, []);
	                return group ? data.groups : data;
	            }).then(this._setGroupsTotal);
	        }
	    }, {
	        key: 'getGroup',
	        value: function getGroup(id) {
	            var _this2 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getGroup"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + id;
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this2.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getGroupDetail',
	        value: function getGroupDetail(id, options) {
	            var _this3 = this;

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getGroupDetail"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + id + '/detail';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return _this3.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'getPrivateDataGroup',
	        value: function getPrivateDataGroup(id, options) {
	            var _this4 = this;

	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	            options = this.Utils.setParams(options, isPaginated);
	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getPrivateDataGroup"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + id + '/admin';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this4.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'addGroup',
	        value: function addGroup(group) {
	            var _this5 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["addGroup"]);
	            var data = _lodash2.default.pick(group, ['name', 'desc', 'parentGroupId', 'location', 'energy_mix', 'isAtomic']);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups';
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this5.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'moveGroup',
	        value: function moveGroup(id, newParentId) {
	            var _this6 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["moveGroup"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + id + '/admin/move';
	            var data = { 'into': newParentId };
	            return this.RequestService.post(url, data, options, notifications).then(function (res) {
	                return _this6.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'setGroupLocation',
	        value: function setGroupLocation(group, location) {
	            var _this7 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["setGroupLocation"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + group.id + '/admin/location';
	            return this.RequestService.post(url, location, options, notifications).then(function (res) {
	                return _this7.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'addGroupRole',
	        value: function addGroupRole(group, role) {
	            var _this8 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["addGroupRole"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + group.id + '/admin/roles';
	            return this.RequestService.post(url, role, options, notifications).then(function (res) {
	                return _this8.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'editGroupProtectedSettings',
	        value: function editGroupProtectedSettings(group, changed) {
	            var _this9 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["editGroupProtectedSettings"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + group.id + '/admin/protectedsettings';
	            return this.RequestService.post(url, changed, options, notifications).then(function (res) {
	                return _this9.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'removeGroup',
	        value: function removeGroup(group) {
	            var _this10 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["removeGroup"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + group.id;
	            return this.RequestService.delete(url, options, notifications).then(function (res) {
	                return _this10.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'editGroup',
	        value: function editGroup(group, changed) {
	            var _this11 = this;

	            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	            var organization = _lodash2.default.get(options, 'organization', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["editGroup"]);
	            var data = _lodash2.default.pick(changed, ['name', 'desc', 'energy_mix', 'noManagedInfo', 'opening_times', 'ownerId', 'isPublic', 'externalId', 'centerId', 'parkingType', 'manualActivation']);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organization + '/groups/' + group.id;
	            return this.RequestService.put(url, data, options, notifications).then(function (res) {
	                return _this11.RequestService.getResponse(res);
	            });
	        }
	    }, {
	        key: 'removeGroupRole',
	        value: function removeGroupRole(group, username, options) {
	            return this.addGroupRole(group, { username: username, role: null }, options);
	        }
	    }, {
	        key: 'checkPurpose',
	        value: function checkPurpose(type, group) {
	            var result = false;
	            if (group) {
	                var purpose = group["purpose"] ? group["purpose"] : "General";
	                switch (type) {
	                    case "roaming":
	                        result = ['RoamingChargepointsParent', 'RoamingChargepointsGroup', 'RoamingChargepoints', 'RoamingOperatorGroup', 'RoamingCountryGroup', 'RoamingSegmentGroup'].includes(purpose);
	                        break;
	                    default:
	                        result = purpose === "General";
	                        break;
	                }
	            }
	            return result;
	        }
	    }, {
	        key: 'checkPurposeInList',
	        value: function checkPurposeInList(list, group) {
	            var result = false;
	            if (group) {
	                var purpose = group["purpose"] ? group["purpose"] : "General";
	                result = list.includes(purpose);
	            }
	            return result;
	        }
	    }, {
	        key: 'getMaintainers',
	        value: function getMaintainers(groupId) {
	            var _this12 = this;

	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var isPaginated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	            options = this.Utils.setParams(options, isPaginated);
	            var organizationId = _lodash2.default.get(options, 'organizationId', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["getMaintainers"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/groups/' + groupId + '/maintainers';
	            return this.RequestService.get(url, options, notifications).then(function (res) {
	                return isPaginated ? _this12.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	            });
	        }
	    }, {
	        key: 'assignMaintainer',
	        value: function assignMaintainer(maintainerId) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organizationId = _lodash2.default.get(options, 'organizationId', null);
	            var groupId = _lodash2.default.get(options, 'groupId', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["assignMaintainer"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/groups/' + groupId + '/maintainers/' + maintainerId;
	            return this.RequestService.post(url, {}, options, notifications).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'unassignMaintainer',
	        value: function unassignMaintainer(maintainerId) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	            var organizationId = _lodash2.default.get(options, 'organizationId', null);
	            var groupId = _lodash2.default.get(options, 'groupId', null);
	            var notifications = this.RequestService.getNotifications(options, this._notifications["unassignMaintainer"]);
	            var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/organizations/' + organizationId + '/groups/' + groupId + '/maintainers/' + maintainerId;
	            return this.RequestService.delete(url, options, notifications).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: '_initializeNotifications',
	        value: function _initializeNotifications() {
	            this._notifications = {
	                getGroups: null,
	                getGroup: null,
	                getGroupDetail: null,
	                getPrivateDataGroup: null,
	                addGroup: { success: "ADD_GROUP_SUCCESS", error: "ADD_GROUP_FAILED" },
	                moveGroup: { success: "MOVE_GROUP_SUCCESS", error: "MOVE_GROUP_FAILED" },
	                setGroupLocation: { success: "SET_LOCATION_SUCCESS", error: "SET_LOCATION_FAILED" },
	                addGroupRole: null,
	                editGroupProtectedSettings: { success: "SET_RESERVATION_QUEUE_SUCCESS", error: "SET_RESERVATION_QUEUE_FAILED" },
	                removeGroup: { success: "REMOVE_GROUP_SUCCESS", error: "REMOVE_GROUP_FAILED" },
	                editGroup: { success: "UPDATE_GROUP_SUCCESS", error: "UPDATE_GROUP_FAILED" },
	                removeGroupRole: null,
	                getMaintainers: null,
	                assignMaintainer: null,
	                unassignMaintainer: null
	            };
	        }
	    }, {
	        key: '_setGroupsTotal',
	        value: function _setGroupsTotal(groups) {
	            function getTotalOfChildren(_groups) {
	                var total = {
	                    chargepoints: 0
	                };
	                for (var i in _groups) {
	                    var group = _groups[i];
	                    group._total = {
	                        chargepoints: group.chargepoints ? group.chargepoints.length : 0
	                    };
	                    if (_lodash2.default.isArray(group.groups) && group.groups.length > 0) {
	                        var totalChildren = getTotalOfChildren(group.groups);
	                        group._total.chargepoints += totalChildren.chargepoints;
	                    }
	                    total.chargepoints += group._total.chargepoints;
	                }
	                return total;
	            }
	            getTotalOfChildren(groups);

	            return groups;
	        }
	    }]);

	    return GroupsService;
	}();

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ItttService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ItttService = exports.ItttService = function () {
	    ItttService.$inject = ["$http", "ENV"];
	    function ItttService($http, ENV) {
	        'ngInject';

	        _classCallCheck(this, ItttService);

	        this.$http = $http;
	        this.ENV = ENV;
	    }

	    _createClass(ItttService, [{
	        key: 'getChargepointRules',
	        value: function getChargepointRules(id, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/chargepoints/' + id + '/rules', options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'addChargepointRule',
	        value: function addChargepointRule(id, rule, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/chargepoints/' + id + '/rules', rule, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }, {
	        key: 'removeChargepointRule',
	        value: function removeChargepointRule(id, ruleId, options) {
	            options = options || {};
	            var organization = _lodash2.default.get(options, 'organization', null);
	            return this.$http.delete(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + (organization ? '/organizations/' + organization : '') + '/chargepoints/' + id + '/rules/' + ruleId, options).then(function (res) {
	                return res.data;
	            });
	        }
	    }]);

	    return ItttService;
	}();

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProvidersService = exports.ProvidersService = function () {
	  ProvidersService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	  function ProvidersService($http, ENV, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, ProvidersService);

	    this.ENV = ENV;
	    this.$http = $http;
	    this.Utils = Utils;
	    this.RequestService = RequestService;
	    this._notifications = {};
	    this._initializeNotifications();
	  }

	  _createClass(ProvidersService, [{
	    key: 'getProvider',
	    value: function getProvider(options) {
	      options = options || {};
	      return this.$http.get(this.ENV.URL + '/providers/' + this.ENV.PROVIDER, options).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'getProviderPrivate',
	    value: function getProviderPrivate(options) {
	      var _this = this;

	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options, isPaginated);
	      var notifications = this.RequestService.getNotifications(options, this._notifications['getProviderPrivate']);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/admin';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'addProviderRole',
	    value: function addProviderRole(role, options) {
	      options = options || {};
	      return this.$http.post(this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/admin/roles', role).then(function (res) {
	        return res.data;
	      });
	    }
	  }, {
	    key: 'removeProviderRole',
	    value: function removeProviderRole(username, options) {
	      return this.addProviderRole({ username: username, role: null }, options);
	    }
	  }, {
	    key: 'getReportBilling',
	    value: function getReportBilling() {
	      var _this2 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.getAuthorizationExpire);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/chargepoints/billingreport';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this2.RequestService.getResponse(res, false);
	      });
	    }
	  }, {
	    key: 'getProxies',
	    value: function getProxies() {
	      var _this3 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.getProxies);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/proxies';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this3.RequestService.getResponse(res, false);
	      });
	    }
	  }, {
	    key: 'createProxy',
	    value: function createProxy(proxy) {
	      var _this4 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.createProxy);
	      var data = proxy;
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/proxies';
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this4.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateProxy',
	    value: function updateProxy(proxy) {
	      var _this5 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.updateProxy);
	      var data = proxy;
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/proxies/' + proxy.id;
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this5.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeProxy',
	    value: function removeProxy(proxy) {
	      var _this6 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.removeProxy);
	      var url = this.ENV.URL + '/providers/' + this.ENV.PROVIDER + '/proxies/' + proxy.id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this6.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'getHolidays',
	    value: function getHolidays() {
	      var _this7 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options, isPaginated);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.getHolidays);
	      var url = this.ENV.URL + '/v0/holidays';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this7.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'createHoliday',
	    value: function createHoliday(holiday) {
	      var _this8 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.createHoliday);
	      var data = holiday;
	      var url = this.ENV.URL + '/v0/holidays';
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this8.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateHoliday',
	    value: function updateHoliday(holiday) {
	      var _this9 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.updateHoliday);
	      var data = holiday;
	      var url = this.ENV.URL + '/v0/holidays/' + holiday.id;
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this9.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'deleteHoliday',
	    value: function deleteHoliday(holiday) {
	      var _this10 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      options = this.Utils.setParams(options);
	      var notifications = this.RequestService.getNotifications(options, this._notifications.deleteHoliday);
	      var url = this.ENV.URL + '/v0/holidays/' + holiday.id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this10.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        getAuthorizationExpire: { error: 'GET_BILLING_REPORT_FAILED' },
	        getProxies: null,
	        createProxy: null,
	        updateProxy: null,
	        removeProxy: null,
	        getHolidays: null,
	        createHoliday: null,
	        updateHoliday: null,
	        deleteHoliday: null
	      };
	    }
	  }]);

	  return ProvidersService;
	}();

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProvidersHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProvidersHelperService = exports.ProvidersHelperService = function () {
	  ProvidersHelperService.$inject = ["App", "ProvidersService", "$translate", "moment", "StaticListService"];
	  function ProvidersHelperService(App, ProvidersService, $translate, moment, StaticListService) {
	    'ngInject';

	    _classCallCheck(this, ProvidersHelperService);

	    this.App = App;
	    this.ProvidersService = ProvidersService;
	    this.$translate = $translate;
	    this.moment = moment;
	    this._defaultProxy = {
	      name: '',
	      url: ''
	    };
	    this._defaultHoliday = {
	      country: 'ESP',
	      date: new Date()
	    };
	    this.countryCodes = StaticListService.getCountryCodes();
	  }

	  _createClass(ProvidersHelperService, [{
	    key: 'addProxy',
	    value: function addProxy($scope, options) {
	      return this._editProxy($scope, null, options);
	    }
	  }, {
	    key: 'editProxy',
	    value: function editProxy($scope, data, options) {
	      return this._editProxy($scope, data, options);
	    }
	  }, {
	    key: 'removeProxy',
	    value: function removeProxy($scope, data, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          proxies: _lodash2.default.cloneDeep(options.proxies) || [],
	          index: options.index,
	          data: data,
	          done: function done() {
	            var data = $scope.modal.data;
	            resolve(_this.ProvidersService.removeProxy(data, { notifications: true }).then(function () {
	              _this.App.closeModal();
	            }));
	          }
	        };
	        _this.App.openModal($scope, 'remove-proxy.html');
	      });
	    }
	  }, {
	    key: '_editProxy',
	    value: function _editProxy($scope, data, options) {
	      var _this2 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          proxies: _lodash2.default.cloneDeep(options.proxies) || [],
	          isEdit: !!data,
	          index: options.index,
	          data: data ? _lodash2.default.cloneDeep(data) : _lodash2.default.cloneDeep(_this2._defaultProxy),
	          conflict: _this2._getDefaultConflict(),
	          validateName: function validateName() {
	            _this2._validateDuplicates($scope.modal, 'name');
	          },
	          validateUrl: function validateUrl() {
	            _this2._validateUrl($scope.modal);
	            _this2._validateDuplicates($scope.modal, 'url');
	          },
	          isValid: function isValid(modal) {
	            return !modal.conflict.name && !modal.conflict.url && !modal.conflict.format && modal.data.name !== '' && modal.data.url !== '';
	          },
	          done: function done() {
	            var data = $scope.modal.data;
	            resolve($scope.modal.isEdit ? _this2.ProvidersService.updateProxy(data, { notifications: true }).then(function () {
	              _this2.App.closeModal();
	            }) : _this2.ProvidersService.createProxy(data, { notifications: true }).then(function () {
	              _this2.App.closeModal();
	            }));
	          }
	        };
	        _this2.App.openModal($scope, 'edit-proxy.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'addHoliday',
	    value: function addHoliday($scope, options) {
	      return this._editHoliday($scope, null, options);
	    }
	  }, {
	    key: 'editHoliday',
	    value: function editHoliday($scope, data, options) {
	      return this._editHoliday($scope, data, options);
	    }
	  }, {
	    key: 'removeHoliday',
	    value: function removeHoliday($scope, data) {
	      var _this3 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          data: data,
	          done: function done() {
	            var data = $scope.modal.data;
	            resolve(_this3.ProvidersService.deleteHoliday(data).then(function () {
	              _this3.App.closeModal();
	            }));
	          }
	        };
	        _this3.App.openModal($scope, 'remove-holiday.html');
	      });
	    }
	  }, {
	    key: '_editHoliday',
	    value: function _editHoliday($scope, data, options) {
	      var _this4 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          holidays: _lodash2.default.cloneDeep(options.holidays) || [],
	          isEdit: !!data,
	          index: options.index,
	          data: data ? _lodash2.default.cloneDeep(data) : _lodash2.default.cloneDeep(_this4._defaultHoliday),
	          date: data ? new Date(data.date) : new Date(),
	          countryCode: data ? _this4.countryCodes.find(function (item) {
	            return item.value === data.country;
	          }) : { display: _this4.$translate.instant('COUNTRY_CODE_ESP'), value: 'ESP' },
	          countryCodes: _lodash2.default.cloneDeep(_this4.countryCodes),
	          datePickerIsOpen: false,
	          datePickerOptions: {
	            open: false,
	            options: {}
	          },
	          isValid: function isValid(modal) {
	            return modal.countryCode && modal.date;
	          },
	          done: function done() {
	            var data = $scope.modal.data;
	            data.country = $scope.modal.countryCode.value;
	            data.date = _this4.moment($scope.modal.date).format('YYYY-MM-DD');
	            resolve($scope.modal.isEdit ? _this4.ProvidersService.updateHoliday(data, { notifications: true }).then(function () {
	              _this4.App.closeModal();
	            }) : _this4.ProvidersService.createHoliday(data, { notifications: true }).then(function () {
	              _this4.App.closeModal();
	            }));
	          }
	        };
	        _this4.App.openModal($scope, 'edit-holiday.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: '_getDefaultConflict',
	    value: function _getDefaultConflict() {
	      return {
	        name: false,
	        url: false,
	        format: false,
	        nameText: 'CONFLICT_PROXY_NAME_REPEAT',
	        urlText: 'CONFLICT_PROXY_URL_REPEAT',
	        urlFormat: 'CONFLICT_PROXY_URL_FORMAT'
	      };
	    }
	  }, {
	    key: '_validateDuplicates',
	    value: function _validateDuplicates(modal, type) {
	      var cloned = _lodash2.default.cloneDeep(modal.proxies);
	      var repeat = false;
	      for (var i = 0; i < cloned.length; i++) {
	        var value = cloned[i][type];
	        if (value === modal.data[type] && i !== modal.index && !repeat) {
	          repeat = true;
	        }
	      }
	      modal.conflict[type] = repeat;
	    }
	  }, {
	    key: '_validateUrl',
	    value: function _validateUrl(modal) {
	      var regexp = new RegExp('^(ws||http)s?:\\/\\/(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)$');
	      var res = !!regexp.exec(modal.data.url);
	      modal.conflict.format = !res;
	    }
	  }]);

	  return ProvidersHelperService;
	}();

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SocketService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _socket = __webpack_require__(194);

	var _socket2 = _interopRequireDefault(_socket);

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SocketService = exports.SocketService = function () {
	    SocketService.$inject = ["$log", "$rootScope", "$timeout", "ENV", "LocalStorage"];
	    function SocketService($log, $rootScope, $timeout, ENV, LocalStorage) {
	        'ngInject';

	        _classCallCheck(this, SocketService);

	        this.ENV = ENV;
	        this.$log = $log;
	        this.$timeout = $timeout;
	        this.$rootScope = $rootScope;
	        this.LocalStorage = LocalStorage;

	        this.chargepointListeners = {};
	        this.commandListeners = {};
	        this.socket = undefined;
	        this.id = undefined;
	    }

	    _createClass(SocketService, [{
	        key: 'openChannel',
	        value: function openChannel() {
	            var _this = this;

	            var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

	            return new Promise(function (resolve) {
	                _this.socket = (0, _socket2.default)(_this.ENV.WEBSOCKET, {
	                    path: _this.ENV.WEBSOCKET_PATH || '/socket.io',
	                    query: 'access_token=' + (user ? user : _this.LocalStorage.getUser().token),
	                    transports: ['websocket']
	                });

	                _this.socket.on('connect_error', function (err) {
	                    _this.$log.log('Websocket connection error:' + err);
	                });

	                _this.socket.on('error', function (err) {
	                    _this.$log.log('Websocket error:' + err);
	                });

	                _this.socket.on('connect', function () {
	                    if (!_this.socket) return;
	                    _this.id = _this.socket.id;
	                    _this.socket.on('chargepointChanged', function (data) {
	                        if (data && data.id && _this.chargepointListeners[data.id]) {
	                            _lodash2.default.each(_this.chargepointListeners[data.id], function (listener) {
	                                return listener(data);
	                            });
	                        }
	                        _this.$rootScope.$broadcast('chargepointChanged', data);
	                    });
	                    _this.socket.on('disconnect', function () {
	                        _this.id = undefined;
	                        if (!user) _this.socket = undefined;
	                    });
	                    return resolve();
	                });
	            });
	        }
	    }, {
	        key: 'onCommandResult',
	        value: function onCommandResult(request) {
	            var _this2 = this;

	            return new Promise(function (resolve, reject) {
	                _this2.socket.on('commandResult', function (data) {
	                    return resolve(data.result);
	                });
	                _this2.$timeout(function () {
	                    return reject({ 'error': { 'msg': 'Sorry, stop waiting for response' } });
	                }, 15000);
	                if (request) request().then(function () {}).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'disconnect',
	        value: function disconnect() {
	            //TODO
	        }
	    }]);

	    return SocketService;
	}();

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */

	var url = __webpack_require__(195);
	var parser = __webpack_require__(200);
	var Manager = __webpack_require__(209);
	var debug = __webpack_require__(197)('socket.io-client');

	/**
	 * Module exports.
	 */

	module.exports = exports = lookup;

	/**
	 * Managers cache.
	 */

	var cache = exports.managers = {};

	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */

	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }

	  opts = opts || {};

	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;

	  var io;

	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  }
	  return io.socket(parsed.path, opts);
	}

	/**
	 * Protocol version.
	 *
	 * @api public
	 */

	exports.protocol = parser.protocol;

	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */

	exports.connect = lookup;

	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */

	exports.Manager = __webpack_require__(209);
	exports.Socket = __webpack_require__(238);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */

	var parseuri = __webpack_require__(196);
	var debug = __webpack_require__(197)('socket.io-client:url');

	/**
	 * Module exports.
	 */

	module.exports = url;

	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */

	function url (uri, loc) {
	  var obj = uri;

	  // default to window.location
	  loc = loc || (typeof location !== 'undefined' && location);
	  if (null == uri) uri = loc.protocol + '//' + loc.host;

	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }

	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }

	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }

	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }

	  obj.path = obj.path || '/';

	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

	  return obj;
	}


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */

	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];

	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');

	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }

	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;

	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }

	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }

	    uri.pathNames = pathNames(uri, uri['path']);
	    uri.queryKey = queryKey(uri, uri['query']);

	    return uri;
	};

	function pathNames(obj, path) {
	    var regx = /\/{2,9}/g,
	        names = path.replace(regx, "/").split("/");

	    if (path.substr(0, 1) == '/' || path.length === 0) {
	        names.splice(0, 1);
	    }
	    if (path.substr(path.length - 1, 1) == '/') {
	        names.splice(names.length - 1, 1);
	    }

	    return names;
	}

	function queryKey(uri, query) {
	    var data = {};

	    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
	        if ($1) {
	            data[$1] = $2;
	        }
	    });

	    return data;
	}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = __webpack_require__(198);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();

	/**
	 * Colors.
	 */

	exports.colors = [
	  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
	  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
	  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
	  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
	  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
	  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
	  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
	  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
	  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
	  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
	  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
	];

	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */

	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }

	  // Internet Explorer and Edge do not support colors.
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  }

	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}

	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */

	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};


	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */

	function formatArgs(args) {
	  var useColors = this.useColors;

	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);

	  if (!useColors) return;

	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')

	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });

	  args.splice(lastC, 0, c);
	}

	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */

	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}

	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */

	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}

	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */

	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}

	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }

	  return r;
	}

	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */

	exports.enable(load());

	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */

	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(199);

	/**
	 * Active `debug` instances.
	 */
	exports.instances = [];

	/**
	 * The currently active debug mode names, and names to skip.
	 */

	exports.names = [];
	exports.skips = [];

	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */

	exports.formatters = {};

	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */

	function selectColor(namespace) {
	  var hash = 0, i;

	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }

	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}

	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */

	function createDebug(namespace) {

	  var prevTime;

	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;

	    var self = debug;

	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;

	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    args[0] = exports.coerce(args[0]);

	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }

	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);

	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });

	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);

	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }

	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	  debug.destroy = destroy;

	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }

	  exports.instances.push(debug);

	  return debug;
	}

	function destroy () {
	  var index = exports.instances.indexOf(this);
	  if (index !== -1) {
	    exports.instances.splice(index, 1);
	    return true;
	  } else {
	    return false;
	  }
	}

	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */

	function enable(namespaces) {
	  exports.save(namespaces);

	  exports.names = [];
	  exports.skips = [];

	  var i;
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;

	  for (i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }

	  for (i = 0; i < exports.instances.length; i++) {
	    var instance = exports.instances[i];
	    instance.enabled = exports.enabled(instance.namespace);
	  }
	}

	/**
	 * Disable debug output.
	 *
	 * @api public
	 */

	function disable() {
	  exports.enable('');
	}

	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */

	function enabled(name) {
	  if (name[name.length - 1] === '*') {
	    return true;
	  }
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */

	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 199 */
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */

	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;

	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */

	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};

	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */

	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}

	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}

	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */

	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}

	/**
	 * Pluralization helper.
	 */

	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */

	var debug = __webpack_require__(197)('socket.io-parser');
	var Emitter = __webpack_require__(201);
	var binary = __webpack_require__(202);
	var isArray = __webpack_require__(203);
	var isBuf = __webpack_require__(204);

	/**
	 * Protocol version.
	 *
	 * @api public
	 */

	exports.protocol = 4;

	/**
	 * Packet types.
	 *
	 * @api public
	 */

	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];

	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */

	exports.CONNECT = 0;

	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */

	exports.DISCONNECT = 1;

	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */

	exports.EVENT = 2;

	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */

	exports.ACK = 3;

	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */

	exports.ERROR = 4;

	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */

	exports.BINARY_EVENT = 5;

	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */

	exports.BINARY_ACK = 6;

	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */

	exports.Encoder = Encoder;

	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */

	exports.Decoder = Decoder;

	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */

	function Encoder() {}

	var ERROR_PACKET = exports.ERROR + '"encode error"';

	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */

	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);

	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    encodeAsBinary(obj, callback);
	  } else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};

	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */

	function encodeAsString(obj) {

	  // first is type
	  var str = '' + obj.type;

	  // attachments if we have them
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    str += obj.attachments + '-';
	  }

	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' !== obj.nsp) {
	    str += obj.nsp + ',';
	  }

	  // immediately followed by the id
	  if (null != obj.id) {
	    str += obj.id;
	  }

	  // json data
	  if (null != obj.data) {
	    var payload = tryStringify(obj.data);
	    if (payload !== false) {
	      str += payload;
	    } else {
	      return ERROR_PACKET;
	    }
	  }

	  debug('encoded %j as %s', obj, str);
	  return str;
	}

	function tryStringify(str) {
	  try {
	    return JSON.stringify(str);
	  } catch(e){
	    return false;
	  }
	}

	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */

	function encodeAsBinary(obj, callback) {

	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;

	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }

	  binary.removeBlobs(obj, writeEncoding);
	}

	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */

	function Decoder() {
	  this.reconstructor = null;
	}

	/**
	 * Mix in `Emitter` with Decoder.
	 */

	Emitter(Decoder.prototype);

	/**
	 * Decodes an encoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */

	Decoder.prototype.add = function(obj) {
	  var packet;
	  if (typeof obj === 'string') {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);

	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  } else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  } else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};

	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */

	function decodeString(str) {
	  var i = 0;
	  // look up type
	  var p = {
	    type: Number(str.charAt(0))
	  };

	  if (null == exports.types[p.type]) {
	    return error('unknown packet type ' + p.type);
	  }

	  // look up attachments if type binary
	  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
	    var start = i + 1;
	    while (str.charAt(++i) !== '-' && i != str.length) {}
	    var buf = str.substring(start, i);
	    if (buf != Number(buf) || str.charAt(i) !== '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }

	  // look up namespace (if any)
	  if ('/' === str.charAt(i + 1)) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' === c) break;
	      if (i === str.length) break;
	    }
	    p.nsp = str.substring(start, i);
	  } else {
	    p.nsp = '/';
	  }

	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      if (i === str.length) break;
	    }
	    p.id = Number(str.substring(start, i + 1));
	  }

	  // look up json data
	  if (str.charAt(++i)) {
	    var payload = tryParse(str.substr(i));
	    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
	    if (isPayloadValid) {
	      p.data = payload;
	    } else {
	      return error('invalid payload');
	    }
	  }

	  debug('decoded %s as %j', str, p);
	  return p;
	}

	function tryParse(str) {
	  try {
	    return JSON.parse(str);
	  } catch(e){
	    return false;
	  }
	}

	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */

	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};

	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */

	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}

	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */

	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};

	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */

	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};

	function error(msg) {
	  return {
	    type: exports.ERROR,
	    data: 'parser error: ' + msg
	  };
	}


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */

	if (true) {
	  module.exports = Emitter;
	}

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};

	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }

	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;

	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }

	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }

	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};

	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];

	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }

	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/*global Blob,File*/

	/**
	 * Module requirements
	 */

	var isArray = __webpack_require__(203);
	var isBuf = __webpack_require__(204);
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
	var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */

	exports.deconstructPacket = function(packet) {
	  var buffers = [];
	  var packetData = packet.data;
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData, buffers);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};

	function _deconstructPacket(data, buffers) {
	  if (!data) return data;

	  if (isBuf(data)) {
	    var placeholder = { _placeholder: true, num: buffers.length };
	    buffers.push(data);
	    return placeholder;
	  } else if (isArray(data)) {
	    var newData = new Array(data.length);
	    for (var i = 0; i < data.length; i++) {
	      newData[i] = _deconstructPacket(data[i], buffers);
	    }
	    return newData;
	  } else if (typeof data === 'object' && !(data instanceof Date)) {
	    var newData = {};
	    for (var key in data) {
	      newData[key] = _deconstructPacket(data[key], buffers);
	    }
	    return newData;
	  }
	  return data;
	}

	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */

	exports.reconstructPacket = function(packet, buffers) {
	  packet.data = _reconstructPacket(packet.data, buffers);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};

	function _reconstructPacket(data, buffers) {
	  if (!data) return data;

	  if (data && data._placeholder) {
	    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	  } else if (isArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      data[i] = _reconstructPacket(data[i], buffers);
	    }
	  } else if (typeof data === 'object') {
	    for (var key in data) {
	      data[key] = _reconstructPacket(data[key], buffers);
	    }
	  }

	  return data;
	}

	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */

	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;

	    // convert any blob
	    if ((withNativeBlob && obj instanceof Blob) ||
	        (withNativeFile && obj instanceof File)) {
	      pendingBlobs++;

	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }

	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };

	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }

	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = isBuf;

	var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
	var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

	var isView = function (obj) {
	  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
	};

	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */

	function isBuf(obj) {
	  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
	          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */

	'use strict'

	var base64 = __webpack_require__(206)
	var ieee754 = __webpack_require__(207)
	var isArray = __webpack_require__(208)

	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50

	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.

	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()

	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()

	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}

	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}

	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }

	  return that
	}

	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */

	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }

	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}

	Buffer.poolSize = 8192 // not used by this implementation

	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}

	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }

	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }

	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }

	  return fromObject(that, value)
	}

	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}

	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}

	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}

	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}

	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}

	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}

	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}

	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }

	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }

	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)

	  var actual = that.write(string, encoding)

	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }

	  return that
	}

	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer

	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }

	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }

	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }

	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}

	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)

	    if (that.length === 0) {
	      return that
	    }

	    obj.copy(that, 0, 0, len)
	    return that
	  }

	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }

	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }

	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}

	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}

	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}

	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}

	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }

	  if (a === b) return 0

	  var x = a.length
	  var y = b.length

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}

	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }

	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }

	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }

	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}

	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }

	  var len = string.length
	  if (len === 0) return 0

	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength

	function slowToString (encoding, start, end) {
	  var loweredCase = false

	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.

	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }

	  if (end === undefined || end > this.length) {
	    end = this.length
	  }

	  if (end <= 0) {
	    return ''
	  }

	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0

	  if (end <= start) {
	    return ''
	  }

	  if (!encoding) encoding = 'utf8'

	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)

	      case 'ascii':
	        return asciiSlice(this, start, end)

	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)

	      case 'base64':
	        return base64Slice(this, start, end)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true

	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}

	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}

	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}

	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}

	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}

	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}

	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}

	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }

	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }

	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }

	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }

	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0

	  if (this === target) return 0

	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)

	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)

	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1

	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }

	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }

	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }

	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }

	  throw new TypeError('val must be string, number or Buffer')
	}

	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length

	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }

	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }

	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }

	  return -1
	}

	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}

	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}

	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}

	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }

	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}

	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}

	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}

	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}

	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}

	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}

	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }

	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining

	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }

	  if (!encoding) encoding = 'utf8'

	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)

	      case 'ascii':
	        return asciiWrite(this, string, offset, length)

	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)

	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}

	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}

	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []

	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1

	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint

	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }

	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }

	    res.push(codePoint)
	    i += bytesPerSequence
	  }

	  return decodeCodePointsArray(res)
	}

	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000

	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }

	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}

	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}

	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}

	function hexSlice (buf, start, end) {
	  var len = buf.length

	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len

	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}

	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}

	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end

	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }

	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }

	  if (end < start) end = start

	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }

	  return newBuf
	}

	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}

	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }

	  return val
	}

	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }

	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }

	  return val
	}

	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}

	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}

	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}

	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}

	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}

	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}

	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}

	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}

	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}

	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}

	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}

	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}

	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}

	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}

	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}

	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}

	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}

	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}

	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}

	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}

	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start

	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0

	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')

	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }

	  var len = end - start
	  var i

	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }

	  return len
	}

	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }

	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }

	  if (end <= start) {
	    return this
	  }

	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0

	  if (!val) val = 0

	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }

	  return this
	}

	// HELPER FUNCTIONS
	// ================

	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}

	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}

	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}

	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []

	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)

	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }

	        // valid lead
	        leadSurrogate = codePoint

	        continue
	      }

	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }

	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }

	    leadSurrogate = null

	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }

	  return bytes
	}

	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}

	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break

	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }

	  return byteArray
	}

	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}

	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}

	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict'

	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray

	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}

	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63

	function getLens (b64) {
	  var len = b64.length

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len

	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)

	  return [validLen, placeHoldersLen]
	}

	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]

	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

	  var curByte = 0

	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen

	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }

	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }

	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }

	  return parts.join('')
	}


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]

	  i += d

	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}

	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

	  value = Math.abs(value)

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }

	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */

	var eio = __webpack_require__(210);
	var Socket = __webpack_require__(238);
	var Emitter = __webpack_require__(201);
	var parser = __webpack_require__(200);
	var on = __webpack_require__(240);
	var bind = __webpack_require__(241);
	var debug = __webpack_require__(197)('socket.io-client:manager');
	var indexOf = __webpack_require__(236);
	var Backoff = __webpack_require__(243);

	/**
	 * IE6+ hasOwnProperty
	 */

	var has = Object.prototype.hasOwnProperty;

	/**
	 * Module exports
	 */

	module.exports = Manager;

	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */

	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};

	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  var _parser = opts.parser || parser;
	  this.encoder = new _parser.Encoder();
	  this.decoder = new _parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}

	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */

	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};

	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */

	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.generateId(nsp);
	    }
	  }
	};

	/**
	 * generate `socket.id` for the given `nsp`
	 *
	 * @param {String} nsp
	 * @return {String}
	 * @api private
	 */

	Manager.prototype.generateId = function (nsp) {
	  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
	};

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Manager.prototype);

	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};

	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};

	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};

	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};

	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};

	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */

	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};

	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */

	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};

	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */

	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;

	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;

	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });

	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });

	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);

	    if (timeout === 0) {
	      openSub.destroy(); // prevents a race condition with the 'open' event
	    }

	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);

	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }

	  this.subs.push(openSub);
	  this.subs.push(errorSub);

	  return this;
	};

	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */

	Manager.prototype.onopen = function () {
	  debug('open');

	  // clear old subs
	  this.cleanup();

	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');

	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};

	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */

	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};

	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */

	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};

	/**
	 * Called with data.
	 *
	 * @api private
	 */

	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};

	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */

	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};

	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */

	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};

	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */

	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.generateId(nsp);
	    });

	    if (this.autoConnect) {
	      // manually call here since connecting event is fired before listening
	      onConnecting();
	    }
	  }

	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }

	  return socket;
	};

	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */

	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;

	  this.close();
	};

	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};

	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */

	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};

	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */

	Manager.prototype.cleanup = function () {
	  debug('cleanup');

	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }

	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;

	  this.decoder.destroy();
	};

	/**
	 * Close the current socket.
	 *
	 * @api private
	 */

	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};

	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */

	Manager.prototype.onclose = function (reason) {
	  debug('onclose');

	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);

	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};

	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */

	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;

	  var self = this;

	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);

	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;

	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);

	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;

	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);

	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};

	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */

	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(211);

	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(219);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */

	var transports = __webpack_require__(212);
	var Emitter = __webpack_require__(201);
	var debug = __webpack_require__(231)('engine.io-client:socket');
	var index = __webpack_require__(236);
	var parser = __webpack_require__(219);
	var parseuri = __webpack_require__(237);
	var parseqs = __webpack_require__(228);

	/**
	 * Module exports.
	 */

	module.exports = Socket;

	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */

	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);

	  opts = opts || {};

	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }

	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }

	  this.secure = null != opts.secure ? opts.secure
	    : (typeof location !== 'undefined' && 'https:' === location.protocol);

	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }

	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (typeof location !== 'undefined' ? location.hostname : 'localhost');
	  this.port = opts.port || (typeof location !== 'undefined' && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.withCredentials = false !== opts.withCredentials;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.transportOptions = opts.transportOptions || {};
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }

	  // SSL options for Node.js client
	  this.pfx = opts.pfx || undefined;
	  this.key = opts.key || undefined;
	  this.passphrase = opts.passphrase || undefined;
	  this.cert = opts.cert || undefined;
	  this.ca = opts.ca || undefined;
	  this.ciphers = opts.ciphers || undefined;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;

	  // detect ReactNative environment
	  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

	  // other options for Node.js or ReactNative client
	  if (typeof self === 'undefined' || this.isReactNative) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }

	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }

	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;

	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;

	  this.open();
	}

	Socket.priorWebsocketSuccess = false;

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Socket.prototype);

	/**
	 * Protocol version.
	 *
	 * @api public
	 */

	Socket.protocol = parser.protocol; // this is an int

	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */

	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(218);
	Socket.transports = __webpack_require__(212);
	Socket.parser = __webpack_require__(219);

	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */

	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);

	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;

	  // transport name
	  query.transport = name;

	  // per-transport options
	  var options = this.transportOptions[name] || {};

	  // session id if we already have one
	  if (this.id) query.sid = this.id;

	  var transport = new transports[name]({
	    query: query,
	    socket: this,
	    agent: options.agent || this.agent,
	    hostname: options.hostname || this.hostname,
	    port: options.port || this.port,
	    secure: options.secure || this.secure,
	    path: options.path || this.path,
	    forceJSONP: options.forceJSONP || this.forceJSONP,
	    jsonp: options.jsonp || this.jsonp,
	    forceBase64: options.forceBase64 || this.forceBase64,
	    enablesXDR: options.enablesXDR || this.enablesXDR,
	    withCredentials: options.withCredentials || this.withCredentials,
	    timestampRequests: options.timestampRequests || this.timestampRequests,
	    timestampParam: options.timestampParam || this.timestampParam,
	    policyPort: options.policyPort || this.policyPort,
	    pfx: options.pfx || this.pfx,
	    key: options.key || this.key,
	    passphrase: options.passphrase || this.passphrase,
	    cert: options.cert || this.cert,
	    ca: options.ca || this.ca,
	    ciphers: options.ciphers || this.ciphers,
	    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
	    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
	    extraHeaders: options.extraHeaders || this.extraHeaders,
	    forceNode: options.forceNode || this.forceNode,
	    localAddress: options.localAddress || this.localAddress,
	    requestTimeout: options.requestTimeout || this.requestTimeout,
	    protocols: options.protocols || void (0),
	    isReactNative: this.isReactNative
	  });

	  return transport;
	};

	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}

	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';

	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }

	  transport.open();
	  this.setTransport(transport);
	};

	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */

	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;

	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }

	  // set up transport
	  this.transport = transport;

	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};

	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */

	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;

	  Socket.priorWebsocketSuccess = false;

	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;

	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');

	          cleanup();

	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }

	  function freezeTransport () {
	    if (failed) return;

	    // Any callback called by transport should be ignored since now
	    failed = true;

	    cleanup();

	    transport.close();
	    transport = null;
	  }

	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;

	    freezeTransport();

	    debug('probe transport "%s" failed because of error: %s', name, err);

	    self.emit('upgradeError', error);
	  }

	  function onTransportClose () {
	    onerror('transport closed');
	  }

	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }

	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }

	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }

	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);

	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);

	  transport.open();
	};

	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */

	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();

	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};

	/**
	 * Handles a packet.
	 *
	 * @api private
	 */

	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

	    this.emit('packet', packet);

	    // Socket is live - any packet counts
	    this.emit('heartbeat');

	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(JSON.parse(packet.data));
	        break;

	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;

	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;

	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};

	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */

	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();

	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};

	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */

	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};

	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */

	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};

	/**
	* Sends a ping packet.
	*
	* @api private
	*/

	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};

	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */

	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);

	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;

	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};

	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */

	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};

	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */

	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};

	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */

	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }

	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }

	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }

	  options = options || {};
	  options.compress = false !== options.compress;

	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};

	/**
	 * Closes the connection.
	 *
	 * @api private
	 */

	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';

	    var self = this;

	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }

	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }

	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }

	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }

	  return this;
	};

	/**
	 * Called upon transport error
	 *
	 * @api private
	 */

	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};

	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */

	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;

	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);

	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');

	    // ensure transport won't stay open
	    this.transport.close();

	    // ignore further transport communication
	    this.transport.removeAllListeners();

	    // set ready state
	    this.readyState = 'closed';

	    // clear session id
	    this.id = null;

	    // emit close event
	    this.emit('close', reason, desc);

	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};

	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */

	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */

	var XMLHttpRequest = __webpack_require__(213);
	var XHR = __webpack_require__(216);
	var JSONP = __webpack_require__(233);
	var websocket = __webpack_require__(234);

	/**
	 * Export transports.
	 */

	exports.polling = polling;
	exports.websocket = websocket;

	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */

	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;

	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;

	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }

	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }

	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);

	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// browser shim for xmlhttprequest module

	var hasCORS = __webpack_require__(214);
	var globalThis = __webpack_require__(215);

	module.exports = function (opts) {
	  var xdomain = opts.xdomain;

	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;

	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;

	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }

	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }

	  if (!xdomain) {
	    try {
	      return new globalThis[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */

	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = (function () {
	  if (typeof self !== 'undefined') {
	    return self;
	  } else if (typeof window !== 'undefined') {
	    return window;
	  } else {
	    return Function('return this')(); // eslint-disable-line no-new-func
	  }
	})();


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* global attachEvent */

	/**
	 * Module requirements.
	 */

	var XMLHttpRequest = __webpack_require__(213);
	var Polling = __webpack_require__(217);
	var Emitter = __webpack_require__(201);
	var inherit = __webpack_require__(229);
	var debug = __webpack_require__(231)('engine.io-client:polling-xhr');
	var globalThis = __webpack_require__(215);

	/**
	 * Module exports.
	 */

	module.exports = XHR;
	module.exports.Request = Request;

	/**
	 * Empty function
	 */

	function empty () {}

	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */

	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	  this.extraHeaders = opts.extraHeaders;

	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;

	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }

	    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  }
	}

	/**
	 * Inherits from Polling.
	 */

	inherit(XHR, Polling);

	/**
	 * XHR supports binary
	 */

	XHR.prototype.supportsBinary = true;

	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */

	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	  opts.withCredentials = this.withCredentials;

	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;

	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;

	  return new Request(opts);
	};

	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */

	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};

	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */

	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};

	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */

	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;
	  this.requestTimeout = opts.requestTimeout;

	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;

	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;

	  this.create();
	}

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Request.prototype);

	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */

	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;

	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;

	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}

	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }

	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}

	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = this.withCredentials;
	    }

	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }

	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 2) {
	          try {
	            var contentType = xhr.getResponseHeader('Content-Type');
	            if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	              xhr.responseType = 'arraybuffer';
	            }
	          } catch (e) {}
	        }
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
	          }, 0);
	        }
	      };
	    }

	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }

	  if (typeof document !== 'undefined') {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};

	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */

	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};

	/**
	 * Called if we have data.
	 *
	 * @api private
	 */

	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};

	/**
	 * Called upon error.
	 *
	 * @api private
	 */

	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};

	/**
	 * Cleans up house.
	 *
	 * @api private
	 */

	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }

	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }

	  if (typeof document !== 'undefined') {
	    delete Request.requests[this.index];
	  }

	  this.xhr = null;
	};

	/**
	 * Called upon load.
	 *
	 * @api private
	 */

	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type');
	    } catch (e) {}
	    if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      data = this.xhr.responseText;
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};

	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */

	Request.prototype.hasXDR = function () {
	  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
	};

	/**
	 * Aborts the request.
	 *
	 * @api public
	 */

	Request.prototype.abort = function () {
	  this.cleanup();
	};

	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */

	Request.requestsCount = 0;
	Request.requests = {};

	if (typeof document !== 'undefined') {
	  if (typeof attachEvent === 'function') {
	    attachEvent('onunload', unloadHandler);
	  } else if (typeof addEventListener === 'function') {
	    var terminationEvent = 'onpagehide' in globalThis ? 'pagehide' : 'unload';
	    addEventListener(terminationEvent, unloadHandler, false);
	  }
	}

	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */

	var Transport = __webpack_require__(218);
	var parseqs = __webpack_require__(228);
	var parser = __webpack_require__(219);
	var inherit = __webpack_require__(229);
	var yeast = __webpack_require__(230);
	var debug = __webpack_require__(231)('engine.io-client:polling');

	/**
	 * Module exports.
	 */

	module.exports = Polling;

	/**
	 * Is XHR2 supported?
	 */

	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(213);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();

	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */

	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}

	/**
	 * Inherits from Transport.
	 */

	inherit(Polling, Transport);

	/**
	 * Transport name.
	 */

	Polling.prototype.name = 'polling';

	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */

	Polling.prototype.doOpen = function () {
	  this.poll();
	};

	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */

	Polling.prototype.pause = function (onPause) {
	  var self = this;

	  this.readyState = 'pausing';

	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }

	  if (this.polling || !this.writable) {
	    var total = 0;

	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }

	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};

	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */

	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};

	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */

	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState && packet.type === 'open') {
	      self.onOpen();
	    }

	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }

	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };

	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);

	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');

	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};

	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */

	Polling.prototype.doClose = function () {
	  var self = this;

	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }

	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};

	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */

	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };

	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};

	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */

	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';

	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }

	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }

	  query = parseqs.encode(query);

	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }

	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }

	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */

	var parser = __webpack_require__(219);
	var Emitter = __webpack_require__(201);

	/**
	 * Module exports.
	 */

	module.exports = Transport;

	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */

	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;

	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;

	  // results of ReactNative environment detection
	  this.isReactNative = opts.isReactNative;

	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Transport.prototype);

	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */

	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};

	/**
	 * Opens the transport.
	 *
	 * @api public
	 */

	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }

	  return this;
	};

	/**
	 * Closes the transport.
	 *
	 * @api private
	 */

	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }

	  return this;
	};

	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */

	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};

	/**
	 * Called upon open
	 *
	 * @api private
	 */

	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};

	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */

	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};

	/**
	 * Called with a decoded packet.
	 */

	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};

	/**
	 * Called upon close.
	 *
	 * @api private
	 */

	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */

	var keys = __webpack_require__(220);
	var hasBinary = __webpack_require__(221);
	var sliceBuffer = __webpack_require__(223);
	var after = __webpack_require__(224);
	var utf8 = __webpack_require__(225);

	var base64encoder;
	if (typeof ArrayBuffer !== 'undefined') {
	  base64encoder = __webpack_require__(226);
	}

	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */

	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;

	/**
	 * Current protocol version.
	 */

	exports.protocol = 3;

	/**
	 * Packet types.
	 */

	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};

	var packetslist = keys(packets);

	/**
	 * Premade error packet.
	 */

	var err = { type: 'error', data: 'parser error' };

	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */

	var Blob = __webpack_require__(227);

	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */

	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }

	  if (typeof utf8encode === 'function') {
	    callback = utf8encode;
	    utf8encode = null;
	  }

	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;

	  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }

	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }

	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];

	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
	  }

	  return callback('' + encoded);

	};

	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}

	/**
	 * Encode packet helpers for binary types
	 */

	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }

	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);

	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }

	  return callback(resultBuffer.buffer);
	}

	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }

	  var fr = new FileReader();
	  fr.onload = function() {
	    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}

	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }

	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }

	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);

	  return callback(blob);
	}

	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */

	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }

	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += btoa(b64data);
	  return callback(message);
	};

	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */

	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data === 'string') {
	    if (data.charAt(0) === 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }

	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);

	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }

	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }

	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};

	function tryDecode(data) {
	  try {
	    data = utf8.decode(data, { strict: false });
	  } catch (e) {
	    return false;
	  }
	  return data;
	}

	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */

	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }

	  var data = base64encoder.decode(msg.substr(1));

	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }

	  return { type: type, data: data };
	};

	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */

	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }

	  var isBinary = hasBinary(packets);

	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }

	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }

	  if (!packets.length) {
	    return callback('0:');
	  }

	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }

	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }

	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};

	/**
	 * Async array map using after
	 */

	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);

	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };

	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}

	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */

	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data !== 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }

	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }

	  var packet;
	  if (data === '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }

	  var length = '', n, msg;

	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);

	    if (chr !== ':') {
	      length += chr;
	      continue;
	    }

	    if (length === '' || (length != (n = Number(length)))) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }

	    msg = data.substr(i + 1, n);

	    if (length != msg.length) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }

	    if (msg.length) {
	      packet = exports.decodePacket(msg, binaryType, false);

	      if (err.type === packet.type && err.data === packet.data) {
	        // parser error in individual packet - ignoring payload
	        return callback(err, 0, 1);
	      }

	      var ret = callback(packet, i + n, l);
	      if (false === ret) return;
	    }

	    // advance cursor
	    i += n;
	    length = '';
	  }

	  if (length !== '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }

	};

	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */

	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }

	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }

	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);

	    var resultArray = new Uint8Array(totalLength);

	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }

	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }

	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;

	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });

	    return callback(resultArray.buffer);
	  });
	};

	/**
	 * Encode as Blob
	 */

	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }

	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;

	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;

	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }

	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};

	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */

	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }

	  var bufferTail = data;
	  var buffers = [];

	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';

	    for (var i = 1; ; i++) {
	      if (tailArray[i] === 255) break;

	      // 310 = char length of Number.MAX_VALUE
	      if (msgLength.length > 310) {
	        return callback(err, 0, 1);
	      }

	      msgLength += tailArray[i];
	    }

	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);

	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }

	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }

	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */

	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;

	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */

	/*
	 * Module requirements.
	 */

	var isArray = __webpack_require__(222);

	var toString = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' ||
	                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof File === 'function' ||
	                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

	/**
	 * Module exports.
	 */

	module.exports = hasBinary;

	/**
	 * Checks for binary data.
	 *
	 * Supports Buffer, ArrayBuffer, Blob and File.
	 *
	 * @param {Object} anything
	 * @api public
	 */

	function hasBinary (obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }

	  if (isArray(obj)) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      if (hasBinary(obj[i])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
	    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
	    (withNativeBlob && obj instanceof Blob) ||
	    (withNativeFile && obj instanceof File)
	  ) {
	    return true;
	  }

	  // see: https://github.com/Automattic/has-binary/pull/4
	  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
	    return hasBinary(obj.toJSON(), true);
	  }

	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	      return true;
	    }
	  }

	  return false;
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */

	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;

	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }

	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }

	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports = after

	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count

	    return (count === 0) ? callback() : proxy

	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count

	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}

	function noop() {}


/***/ }),
/* 225 */
/***/ (function(module, exports) {

	/*! https://mths.be/utf8js v2.1.2 by @mathias */

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;

		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	module.exports = {
		version: '2.1.2',
		encode: utf8encode,
		decode: utf8decode
	};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(chars){
	  "use strict";

	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";

	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }

	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }

	    return base64;
	  };

	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;

	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }

	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);

	    for (i = 0; i < len; i+=4) {
	      encoded1 = chars.indexOf(base64[i]);
	      encoded2 = chars.indexOf(base64[i+1]);
	      encoded3 = chars.indexOf(base64[i+2]);
	      encoded4 = chars.indexOf(base64[i+3]);

	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }

	    return arraybuffer;
	  };
	})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/**
	 * Create a blob builder even when vendor prefixes exist
	 */

	var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
	  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
	  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
	  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
	  false;

	/**
	 * Check if Blob constructor is supported
	 */

	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();

	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */

	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();

	/**
	 * Check if BlobBuilder is supported
	 */

	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;

	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */

	function mapArrayBufferViews(ary) {
	  return ary.map(function(chunk) {
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;

	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }

	      return buf;
	    }

	    return chunk;
	  });
	}

	function BlobBuilderConstructor(ary, options) {
	  options = options || {};

	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary).forEach(function(part) {
	    bb.append(part);
	  });

	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};

	function BlobConstructor(ary, options) {
	  return new Blob(mapArrayBufferViews(ary), options || {});
	};

	if (typeof Blob !== 'undefined') {
	  BlobBuilderConstructor.prototype = Blob.prototype;
	  BlobConstructor.prototype = Blob.prototype;
	}

	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();


/***/ }),
/* 228 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */

	exports.encode = function (obj) {
	  var str = '';

	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }

	  return str;
	};

	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */

	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';

	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;

	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';

	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);

	  return encoded;
	}

	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;

	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }

	  return decoded;
	}

	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());

	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}

	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;

	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = __webpack_require__(232);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();

	/**
	 * Colors.
	 */

	exports.colors = [
	  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
	  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
	  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
	  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
	  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
	  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
	  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
	  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
	  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
	  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
	  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
	];

	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */

	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }

	  // Internet Explorer and Edge do not support colors.
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  }

	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}

	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */

	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};


	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */

	function formatArgs(args) {
	  var useColors = this.useColors;

	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);

	  if (!useColors) return;

	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')

	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });

	  args.splice(lastC, 0, c);
	}

	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */

	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}

	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */

	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}

	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */

	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}

	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = process.env.DEBUG;
	  }

	  return r;
	}

	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */

	exports.enable(load());

	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */

	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)))

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */

	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(199);

	/**
	 * Active `debug` instances.
	 */
	exports.instances = [];

	/**
	 * The currently active debug mode names, and names to skip.
	 */

	exports.names = [];
	exports.skips = [];

	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */

	exports.formatters = {};

	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */

	function selectColor(namespace) {
	  var hash = 0, i;

	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }

	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}

	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */

	function createDebug(namespace) {

	  var prevTime;

	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;

	    var self = debug;

	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;

	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }

	    args[0] = exports.coerce(args[0]);

	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }

	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);

	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });

	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);

	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }

	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	  debug.destroy = destroy;

	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }

	  exports.instances.push(debug);

	  return debug;
	}

	function destroy () {
	  var index = exports.instances.indexOf(this);
	  if (index !== -1) {
	    exports.instances.splice(index, 1);
	    return true;
	  } else {
	    return false;
	  }
	}

	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */

	function enable(namespaces) {
	  exports.save(namespaces);

	  exports.names = [];
	  exports.skips = [];

	  var i;
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;

	  for (i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }

	  for (i = 0; i < exports.instances.length; i++) {
	    var instance = exports.instances[i];
	    instance.enabled = exports.enabled(instance.namespace);
	  }
	}

	/**
	 * Disable debug output.
	 *
	 * @api public
	 */

	function disable() {
	  exports.enable('');
	}

	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */

	function enabled(name) {
	  if (name[name.length - 1] === '*') {
	    return true;
	  }
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}

	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */

	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module requirements.
	 */

	var Polling = __webpack_require__(217);
	var inherit = __webpack_require__(229);
	var globalThis = __webpack_require__(215);

	/**
	 * Module exports.
	 */

	module.exports = JSONPPolling;

	/**
	 * Cached regular expressions.
	 */

	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;

	/**
	 * Global JSONP callbacks.
	 */

	var callbacks;

	/**
	 * Noop.
	 */

	function empty () { }

	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */

	function JSONPPolling (opts) {
	  Polling.call(this, opts);

	  this.query = this.query || {};

	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    callbacks = globalThis.___eio = (globalThis.___eio || []);
	  }

	  // callback identifier
	  this.index = callbacks.length;

	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });

	  // append to query string
	  this.query.j = this.index;

	  // prevent spurious errors from being emitted when the window is unloaded
	  if (typeof addEventListener === 'function') {
	    addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}

	/**
	 * Inherits from Polling.
	 */

	inherit(JSONPPolling, Polling);

	/*
	 * JSONP only supports binary as base64 encoded strings
	 */

	JSONPPolling.prototype.supportsBinary = false;

	/**
	 * Closes the socket.
	 *
	 * @api private
	 */

	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }

	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }

	  Polling.prototype.doClose.call(this);
	};

	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */

	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');

	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }

	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };

	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;

	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};

	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */

	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;

	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;

	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);

	    this.form = form;
	    this.area = area;
	  }

	  this.form.action = this.uri();

	  function complete () {
	    initIframe();
	    fn();
	  }

	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }

	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }

	    iframe.id = self.iframeId;

	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }

	  initIframe();

	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');

	  try {
	    this.form.submit();
	  } catch (e) {}

	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * Module dependencies.
	 */

	var Transport = __webpack_require__(218);
	var parser = __webpack_require__(219);
	var parseqs = __webpack_require__(228);
	var inherit = __webpack_require__(229);
	var yeast = __webpack_require__(230);
	var debug = __webpack_require__(231)('engine.io-client:websocket');

	var BrowserWebSocket, NodeWebSocket;

	if (typeof WebSocket !== 'undefined') {
	  BrowserWebSocket = WebSocket;
	} else if (typeof self !== 'undefined') {
	  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
	}

	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(235);
	  } catch (e) { }
	}

	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */

	var WebSocketImpl = BrowserWebSocket || NodeWebSocket;

	/**
	 * Module exports.
	 */

	module.exports = WS;

	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */

	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  this.protocols = opts.protocols;
	  if (!this.usingBrowserWebSocket) {
	    WebSocketImpl = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}

	/**
	 * Inherits from Transport.
	 */

	inherit(WS, Transport);

	/**
	 * Transport name.
	 *
	 * @api public
	 */

	WS.prototype.name = 'websocket';

	/*
	 * WebSockets support binary
	 */

	WS.prototype.supportsBinary = true;

	/**
	 * Opens socket.
	 *
	 * @api private
	 */

	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }

	  var uri = this.uri();
	  var protocols = this.protocols;

	  var opts = {};

	  if (!this.isReactNative) {
	    opts.agent = this.agent;
	    opts.perMessageDeflate = this.perMessageDeflate;

	    // SSL options for Node.js client
	    opts.pfx = this.pfx;
	    opts.key = this.key;
	    opts.passphrase = this.passphrase;
	    opts.cert = this.cert;
	    opts.ca = this.ca;
	    opts.ciphers = this.ciphers;
	    opts.rejectUnauthorized = this.rejectUnauthorized;
	  }

	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }

	  try {
	    this.ws =
	      this.usingBrowserWebSocket && !this.isReactNative
	        ? protocols
	          ? new WebSocketImpl(uri, protocols)
	          : new WebSocketImpl(uri)
	        : new WebSocketImpl(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }

	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }

	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }

	  this.addEventListeners();
	};

	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */

	WS.prototype.addEventListeners = function () {
	  var self = this;

	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};

	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */

	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;

	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }

	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }

	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }

	        --total || done();
	      });
	    })(packets[i]);
	  }

	  function done () {
	    self.emit('flush');

	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};

	/**
	 * Called upon close
	 *
	 * @api private
	 */

	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};

	/**
	 * Closes socket.
	 *
	 * @api private
	 */

	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};

	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */

	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';

	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }

	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }

	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }

	  query = parseqs.encode(query);

	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }

	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};

	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */

	WS.prototype.check = function () {
	  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;

	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */

	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];

	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');

	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }

	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;

	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }

	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }

	    uri.pathNames = pathNames(uri, uri['path']);
	    uri.queryKey = queryKey(uri, uri['query']);

	    return uri;
	};

	function pathNames(obj, path) {
	    var regx = /\/{2,9}/g,
	        names = path.replace(regx, "/").split("/");

	    if (path.substr(0, 1) == '/' || path.length === 0) {
	        names.splice(0, 1);
	    }
	    if (path.substr(path.length - 1, 1) == '/') {
	        names.splice(names.length - 1, 1);
	    }

	    return names;
	}

	function queryKey(uri, query) {
	    var data = {};

	    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
	        if ($1) {
	            data[$1] = $2;
	        }
	    });

	    return data;
	}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */

	var parser = __webpack_require__(200);
	var Emitter = __webpack_require__(201);
	var toArray = __webpack_require__(239);
	var on = __webpack_require__(240);
	var bind = __webpack_require__(241);
	var debug = __webpack_require__(197)('socket.io-client:socket');
	var parseqs = __webpack_require__(242);
	var hasBin = __webpack_require__(221);

	/**
	 * Module exports.
	 */

	module.exports = exports = Socket;

	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */

	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};

	/**
	 * Shortcut to `Emitter#emit`.
	 */

	var emit = Emitter.prototype.emit;

	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */

	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  this.flags = {};
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}

	/**
	 * Mix in `Emitter`.
	 */

	Emitter(Socket.prototype);

	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */

	Socket.prototype.subEvents = function () {
	  if (this.subs) return;

	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};

	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */

	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;

	  this.subEvents();
	  if (!this.io.reconnecting) this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};

	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};

	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }

	  var args = toArray(arguments);
	  var packet = {
	    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
	    data: args
	  };

	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;

	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }

	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }

	  this.flags = {};

	  return this;
	};

	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};

	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */

	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');

	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
	      debug('sending connect packet with query %s', query);
	      this.packet({type: parser.CONNECT, query: query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};

	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */

	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};

	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.onpacket = function (packet) {
	  var sameNamespace = packet.nsp === this.nsp;
	  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

	  if (!sameNamespace && !rootNamespaceError) return;

	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;

	    case parser.EVENT:
	      this.onevent(packet);
	      break;

	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;

	    case parser.ACK:
	      this.onack(packet);
	      break;

	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;

	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;

	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};

	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);

	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }

	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};

	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */

	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);

	    self.packet({
	      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
	      id: id,
	      data: args
	    });
	  };
	};

	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */

	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};

	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */

	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};

	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */

	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];

	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};

	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */

	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};

	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */

	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }

	  this.io.destroy(this);
	};

	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }

	  // remove socket from pool
	  this.destroy();

	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};

	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.compress = function (compress) {
	  this.flags.compress = compress;
	  return this;
	};

	/**
	 * Sets the binary flag
	 *
	 * @param {Boolean} whether the emitted data contains binary
	 * @return {Socket} self
	 * @api public
	 */

	Socket.prototype.binary = function (binary) {
	  this.flags.binary = binary;
	  return this;
	};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = toArray

	function toArray(list, index) {
	    var array = []

	    index = index || 0

	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }

	    return array
	}


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */

	module.exports = on;

	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */

	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */

	var slice = [].slice;

	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */

	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */

	exports.encode = function (obj) {
	  var str = '';

	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }

	  return str;
	};

	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */

	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */

	module.exports = Backoff;

	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */

	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}

	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */

	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};

	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */

	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};

	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */

	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};

	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */

	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};

	/**
	 * Set the jitter
	 *
	 * @api public
	 */

	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};



/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RequestService = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var RequestService = exports.RequestService = function () {
	    RequestService.$inject = ["$http", "$translate", "$log", "App"];
	    function RequestService($http, $translate, $log, App) {
	        'ngInject';

	        _classCallCheck(this, RequestService);

	        this.$http = $http;
	        this.$translate = $translate;
	        this.$log = $log;
	        this.App = App;
	        this.defaultNotifications = {
	            success: "REQUEST_SUCCESS",
	            error: "REQUEST_FAILED"
	        };
	    }

	    _createClass(RequestService, [{
	        key: 'post',
	        value: function post(url, data, config, notifications) {
	            return this._requestWithData("post", url, data, config, notifications);
	        }
	    }, {
	        key: 'put',
	        value: function put(url, data, config, notifications) {
	            return this._requestWithData("put", url, data, config, notifications);
	        }
	    }, {
	        key: 'get',
	        value: function get(url, config, notifications) {
	            return this._requestWithoutData("get", url, config, notifications);
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(url, config, notifications) {
	            return this._requestWithoutData("delete", url, config, notifications);
	        }
	    }, {
	        key: 'getResponse',
	        value: function getResponse(data) {
	            var emptyValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            var complete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	            this.$log.log("Response", data);
	            var response = data;
	            if (!complete) {
	                response = data["status"] ? data["data"] : emptyValue;
	            }
	            return response;
	        }
	    }, {
	        key: 'getNotifications',
	        value: function getNotifications(data, serviceNotifications) {
	            var response = false;
	            var aux = data["notifications"] || false;
	            serviceNotifications = serviceNotifications || this.defaultNotifications;
	            if (aux === true) {
	                response = serviceNotifications;
	            } else if (angular.isObject(aux)) {
	                response = angular.merge({}, serviceNotifications, aux);
	            }
	            return response;
	        }
	    }, {
	        key: '_requestWithData',
	        value: function _requestWithData(method, url, data, config, notifications) {
	            var _this2 = this;

	            var _this = this;
	            this.$log.log("Resquest", method, url, data, notifications);
	            this._setLoading(true, config);
	            return this.$http[method](url, data, this._getClearConfig(config)).then(function (response) {
	                _this2._setLoading(false, config);
	                _this._showSuccess(notifications, response["data"]);
	                return _this._getSucessResponse(response["data"], response["headers"]);
	            }, function (error) {
	                _this2._setLoading(false, config);
	                _this._showError(notifications, error["data"]);
	                return _this._getErrorResponse(error["data"]);
	            });
	        }
	    }, {
	        key: '_requestWithoutData',
	        value: function _requestWithoutData(method, url, config, notifications) {
	            var _this3 = this;

	            var _this = this;
	            this.$log.log("Resquest", method, url, notifications);
	            this._setLoading(true, config);
	            return this.$http[method](url, this._getClearConfig(config)).then(function (response) {
	                _this3._setLoading(false, config);
	                _this._showSuccess(notifications, response["data"]);
	                return _this._getSucessResponse(response["data"], response["headers"]);
	            }, function (error) {
	                _this3._setLoading(false, config);
	                _this._showError(notifications, error["data"]);
	                return _this._getErrorResponse(error["data"]);
	            });
	        }
	    }, {
	        key: '_showSuccess',
	        value: function _showSuccess(notifications, data) {
	            if (angular.isObject(notifications) && notifications["success"]) {
	                var notification = this._getNotification(notifications["success"], 'ok', data);
	                var message = this.$translate.instant(notification.value, notification.model);
	                this.App.showNotification(message, notification.style, null, 700);
	            }
	        }
	    }, {
	        key: '_showError',
	        value: function _showError(notifications, data) {
	            if (angular.isObject(notifications) && notifications["error"]) {
	                var notification = this._getNotification(notifications["error"], 'error', data);
	                var message = this.$translate.instant(notification.value, notification.model);
	                this.App.showNotification(message, notification.style);
	            }
	        }
	    }, {
	        key: '_setLoading',
	        value: function _setLoading(option, config) {
	            if (config && config.UiReload != undefined) {
	                if (config.UiReload) {
	                    this.App.setLoading(option);
	                }
	            } else {
	                this.App.setLoading(option);
	            }
	        }
	    }, {
	        key: '_getClearConfig',
	        value: function _getClearConfig(config) {
	            return _lodash2.default.omit(config, ['notifications', 'UiReload']);
	        }
	    }, {
	        key: '_getNotification',
	        value: function _getNotification(notification, style, data) {
	            switch (typeof notification === 'undefined' ? 'undefined' : _typeof(notification)) {
	                case 'string':
	                    return { value: notification, model: {}, style: style };
	                case 'object':
	                    return { value: notification.value, model: notification.model, style: style };
	                case 'function':
	                    return notification(data);
	            }
	        }
	    }, {
	        key: '_getSucessResponse',
	        value: function _getSucessResponse(data, headers) {
	            return { status: true, data: data, headers: headers };
	        }
	    }, {
	        key: '_getErrorResponse',
	        value: function _getErrorResponse(data) {
	            return { status: false, error: data };
	        }
	    }]);

	    return RequestService;
	}();

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var StaticListService = exports.StaticListService = function () {
	  StaticListService.$inject = ["$translate"];
	  function StaticListService($translate) {
	    'ngInject';

	    _classCallCheck(this, StaticListService);

	    this.$translate = $translate;
	  }

	  _createClass(StaticListService, [{
	    key: 'getCountryCodes',
	    value: function getCountryCodes() {
	      return [{ display: this.$translate.instant('COUNTRY_CODE_AFG'), value: 'AFG' }, { display: this.$translate.instant('COUNTRY_CODE_ALB'), value: 'ALB' }, { display: this.$translate.instant('COUNTRY_CODE_DZA'), value: 'DZA' }, { display: this.$translate.instant('COUNTRY_CODE_ASM'), value: 'ASM' }, { display: this.$translate.instant('COUNTRY_CODE_AND'), value: 'AND' }, { display: this.$translate.instant('COUNTRY_CODE_AGO'), value: 'AGO' }, { display: this.$translate.instant('COUNTRY_CODE_AIA'), value: 'AIA' }, { display: this.$translate.instant('COUNTRY_CODE_ATA'), value: 'ATA' }, { display: this.$translate.instant('COUNTRY_CODE_ATG'), value: 'ATG' }, { display: this.$translate.instant('COUNTRY_CODE_ARG'), value: 'ARG' }, { display: this.$translate.instant('COUNTRY_CODE_ARM'), value: 'ARM' }, { display: this.$translate.instant('COUNTRY_CODE_ABW'), value: 'ABW' }, { display: this.$translate.instant('COUNTRY_CODE_AUS'), value: 'AUS' }, { display: this.$translate.instant('COUNTRY_CODE_AUT'), value: 'AUT' }, { display: this.$translate.instant('COUNTRY_CODE_AZE'), value: 'AZE' }, { display: this.$translate.instant('COUNTRY_CODE_BHS'), value: 'BHS' }, { display: this.$translate.instant('COUNTRY_CODE_BHR'), value: 'BHR' }, { display: this.$translate.instant('COUNTRY_CODE_BGD'), value: 'BGD' }, { display: this.$translate.instant('COUNTRY_CODE_BRB'), value: 'BRB' }, { display: this.$translate.instant('COUNTRY_CODE_BLR'), value: 'BLR' }, { display: this.$translate.instant('COUNTRY_CODE_BEL'), value: 'BEL' }, { display: this.$translate.instant('COUNTRY_CODE_BLZ'), value: 'BLZ' }, { display: this.$translate.instant('COUNTRY_CODE_BEN'), value: 'BEN' }, { display: this.$translate.instant('COUNTRY_CODE_BMU'), value: 'BMU' }, { display: this.$translate.instant('COUNTRY_CODE_BTN'), value: 'BTN' }, { display: this.$translate.instant('COUNTRY_CODE_BOL'), value: 'BOL' }, { display: this.$translate.instant('COUNTRY_CODE_BES'), value: 'BES' }, { display: this.$translate.instant('COUNTRY_CODE_BIH'), value: 'BIH' }, { display: this.$translate.instant('COUNTRY_CODE_BWA'), value: 'BWA' }, { display: this.$translate.instant('COUNTRY_CODE_BVT'), value: 'BVT' }, { display: this.$translate.instant('COUNTRY_CODE_BRA'), value: 'BRA' }, { display: this.$translate.instant('COUNTRY_CODE_IOT'), value: 'IOT' }, { display: this.$translate.instant('COUNTRY_CODE_BRN'), value: 'BRN' }, { display: this.$translate.instant('COUNTRY_CODE_BGR'), value: 'BGR' }, { display: this.$translate.instant('COUNTRY_CODE_BFA'), value: 'BFA' }, { display: this.$translate.instant('COUNTRY_CODE_BDI'), value: 'BDI' }, { display: this.$translate.instant('COUNTRY_CODE_CPV'), value: 'CPV' }, { display: this.$translate.instant('COUNTRY_CODE_KHM'), value: 'KHM' }, { display: this.$translate.instant('COUNTRY_CODE_CMR'), value: 'CMR' }, { display: this.$translate.instant('COUNTRY_CODE_CAN'), value: 'CAN' }, { display: this.$translate.instant('COUNTRY_CODE_CYM'), value: 'CYM' }, { display: this.$translate.instant('COUNTRY_CODE_CAF'), value: 'CAF' }, { display: this.$translate.instant('COUNTRY_CODE_TCD'), value: 'TCD' }, { display: this.$translate.instant('COUNTRY_CODE_CHL'), value: 'CHL' }, { display: this.$translate.instant('COUNTRY_CODE_CHN'), value: 'CHN' }, { display: this.$translate.instant('COUNTRY_CODE_CXR'), value: 'CXR' }, { display: this.$translate.instant('COUNTRY_CODE_CCK'), value: 'CCK' }, { display: this.$translate.instant('COUNTRY_CODE_COL'), value: 'COL' }, { display: this.$translate.instant('COUNTRY_CODE_COM'), value: 'COM' }, { display: this.$translate.instant('COUNTRY_CODE_COD'), value: 'COD' }, { display: this.$translate.instant('COUNTRY_CODE_COG'), value: 'COG' }, { display: this.$translate.instant('COUNTRY_CODE_COK'), value: 'COK' }, { display: this.$translate.instant('COUNTRY_CODE_CRI'), value: 'CRI' }, { display: this.$translate.instant('COUNTRY_CODE_HRV'), value: 'HRV' }, { display: this.$translate.instant('COUNTRY_CODE_CUB'), value: 'CUB' }, { display: this.$translate.instant('COUNTRY_CODE_CUW'), value: 'CUW' }, { display: this.$translate.instant('COUNTRY_CODE_CYP'), value: 'CYP' }, { display: this.$translate.instant('COUNTRY_CODE_CZE'), value: 'CZE' }, { display: this.$translate.instant('COUNTRY_CODE_CIV'), value: 'CIV' }, { display: this.$translate.instant('COUNTRY_CODE_DNK'), value: 'DNK' }, { display: this.$translate.instant('COUNTRY_CODE_DJI'), value: 'DJI' }, { display: this.$translate.instant('COUNTRY_CODE_DMA'), value: 'DMA' }, { display: this.$translate.instant('COUNTRY_CODE_DOM'), value: 'DOM' }, { display: this.$translate.instant('COUNTRY_CODE_ECU'), value: 'ECU' }, { display: this.$translate.instant('COUNTRY_CODE_EGY'), value: 'EGY' }, { display: this.$translate.instant('COUNTRY_CODE_SLV'), value: 'SLV' }, { display: this.$translate.instant('COUNTRY_CODE_GNQ'), value: 'GNQ' }, { display: this.$translate.instant('COUNTRY_CODE_ERI'), value: 'ERI' }, { display: this.$translate.instant('COUNTRY_CODE_EST'), value: 'EST' }, { display: this.$translate.instant('COUNTRY_CODE_SWZ'), value: 'SWZ' }, { display: this.$translate.instant('COUNTRY_CODE_ETH'), value: 'ETH' }, { display: this.$translate.instant('COUNTRY_CODE_FLK'), value: 'FLK' }, { display: this.$translate.instant('COUNTRY_CODE_FRO'), value: 'FRO' }, { display: this.$translate.instant('COUNTRY_CODE_FJI'), value: 'FJI' }, { display: this.$translate.instant('COUNTRY_CODE_FIN'), value: 'FIN' }, { display: this.$translate.instant('COUNTRY_CODE_FRA'), value: 'FRA' }, { display: this.$translate.instant('COUNTRY_CODE_GUF'), value: 'GUF' }, { display: this.$translate.instant('COUNTRY_CODE_PYF'), value: 'PYF' }, { display: this.$translate.instant('COUNTRY_CODE_ATF'), value: 'ATF' }, { display: this.$translate.instant('COUNTRY_CODE_GAB'), value: 'GAB' }, { display: this.$translate.instant('COUNTRY_CODE_GMB'), value: 'GMB' }, { display: this.$translate.instant('COUNTRY_CODE_GEO'), value: 'GEO' }, { display: this.$translate.instant('COUNTRY_CODE_DEU'), value: 'DEU' }, { display: this.$translate.instant('COUNTRY_CODE_GHA'), value: 'GHA' }, { display: this.$translate.instant('COUNTRY_CODE_GIB'), value: 'GIB' }, { display: this.$translate.instant('COUNTRY_CODE_GRC'), value: 'GRC' }, { display: this.$translate.instant('COUNTRY_CODE_GRL'), value: 'GRL' }, { display: this.$translate.instant('COUNTRY_CODE_GRD'), value: 'GRD' }, { display: this.$translate.instant('COUNTRY_CODE_GLP'), value: 'GLP' }, { display: this.$translate.instant('COUNTRY_CODE_GUM'), value: 'GUM' }, { display: this.$translate.instant('COUNTRY_CODE_GTM'), value: 'GTM' }, { display: this.$translate.instant('COUNTRY_CODE_GGY'), value: 'GGY' }, { display: this.$translate.instant('COUNTRY_CODE_GIN'), value: 'GIN' }, { display: this.$translate.instant('COUNTRY_CODE_GNB'), value: 'GNB' }, { display: this.$translate.instant('COUNTRY_CODE_GUY'), value: 'GUY' }, { display: this.$translate.instant('COUNTRY_CODE_HTI'), value: 'HTI' }, { display: this.$translate.instant('COUNTRY_CODE_HMD'), value: 'HMD' }, { display: this.$translate.instant('COUNTRY_CODE_VAT'), value: 'VAT' }, { display: this.$translate.instant('COUNTRY_CODE_HND'), value: 'HND' }, { display: this.$translate.instant('COUNTRY_CODE_HKG'), value: 'HKG' }, { display: this.$translate.instant('COUNTRY_CODE_HUN'), value: 'HUN' }, { display: this.$translate.instant('COUNTRY_CODE_ISL'), value: 'ISL' }, { display: this.$translate.instant('COUNTRY_CODE_IND'), value: 'IND' }, { display: this.$translate.instant('COUNTRY_CODE_IDN'), value: 'IDN' }, { display: this.$translate.instant('COUNTRY_CODE_IRN'), value: 'IRN' }, { display: this.$translate.instant('COUNTRY_CODE_IRQ'), value: 'IRQ' }, { display: this.$translate.instant('COUNTRY_CODE_IRL'), value: 'IRL' }, { display: this.$translate.instant('COUNTRY_CODE_IMN'), value: 'IMN' }, { display: this.$translate.instant('COUNTRY_CODE_ISR'), value: 'ISR' }, { display: this.$translate.instant('COUNTRY_CODE_ITA'), value: 'ITA' }, { display: this.$translate.instant('COUNTRY_CODE_JAM'), value: 'JAM' }, { display: this.$translate.instant('COUNTRY_CODE_JPN'), value: 'JPN' }, { display: this.$translate.instant('COUNTRY_CODE_JEY'), value: 'JEY' }, { display: this.$translate.instant('COUNTRY_CODE_JOR'), value: 'JOR' }, { display: this.$translate.instant('COUNTRY_CODE_KAZ'), value: 'KAZ' }, { display: this.$translate.instant('COUNTRY_CODE_KEN'), value: 'KEN' }, { display: this.$translate.instant('COUNTRY_CODE_KIR'), value: 'KIR' }, { display: this.$translate.instant('COUNTRY_CODE_PRK'), value: 'PRK' }, { display: this.$translate.instant('COUNTRY_CODE_KOR'), value: 'KOR' }, { display: this.$translate.instant('COUNTRY_CODE_KWT'), value: 'KWT' }, { display: this.$translate.instant('COUNTRY_CODE_KGZ'), value: 'KGZ' }, { display: this.$translate.instant('COUNTRY_CODE_LAO'), value: 'LAO' }, { display: this.$translate.instant('COUNTRY_CODE_LVA'), value: 'LVA' }, { display: this.$translate.instant('COUNTRY_CODE_LBN'), value: 'LBN' }, { display: this.$translate.instant('COUNTRY_CODE_LSO'), value: 'LSO' }, { display: this.$translate.instant('COUNTRY_CODE_LBR'), value: 'LBR' }, { display: this.$translate.instant('COUNTRY_CODE_LBY'), value: 'LBY' }, { display: this.$translate.instant('COUNTRY_CODE_LIE'), value: 'LIE' }, { display: this.$translate.instant('COUNTRY_CODE_LTU'), value: 'LTU' }, { display: this.$translate.instant('COUNTRY_CODE_LUX'), value: 'LUX' }, { display: this.$translate.instant('COUNTRY_CODE_MAC'), value: 'MAC' }, { display: this.$translate.instant('COUNTRY_CODE_MDG'), value: 'MDG' }, { display: this.$translate.instant('COUNTRY_CODE_MWI'), value: 'MWI' }, { display: this.$translate.instant('COUNTRY_CODE_MYS'), value: 'MYS' }, { display: this.$translate.instant('COUNTRY_CODE_MDV'), value: 'MDV' }, { display: this.$translate.instant('COUNTRY_CODE_MLI'), value: 'MLI' }, { display: this.$translate.instant('COUNTRY_CODE_MLT'), value: 'MLT' }, { display: this.$translate.instant('COUNTRY_CODE_MHL'), value: 'MHL' }, { display: this.$translate.instant('COUNTRY_CODE_MTQ'), value: 'MTQ' }, { display: this.$translate.instant('COUNTRY_CODE_MRT'), value: 'MRT' }, { display: this.$translate.instant('COUNTRY_CODE_MUS'), value: 'MUS' }, { display: this.$translate.instant('COUNTRY_CODE_MYT'), value: 'MYT' }, { display: this.$translate.instant('COUNTRY_CODE_MEX'), value: 'MEX' }, { display: this.$translate.instant('COUNTRY_CODE_FSM'), value: 'FSM' }, { display: this.$translate.instant('COUNTRY_CODE_MDA'), value: 'MDA' }, { display: this.$translate.instant('COUNTRY_CODE_MCO'), value: 'MCO' }, { display: this.$translate.instant('COUNTRY_CODE_MNG'), value: 'MNG' }, { display: this.$translate.instant('COUNTRY_CODE_MNE'), value: 'MNE' }, { display: this.$translate.instant('COUNTRY_CODE_MSR'), value: 'MSR' }, { display: this.$translate.instant('COUNTRY_CODE_MAR'), value: 'MAR' }, { display: this.$translate.instant('COUNTRY_CODE_MOZ'), value: 'MOZ' }, { display: this.$translate.instant('COUNTRY_CODE_MMR'), value: 'MMR' }, { display: this.$translate.instant('COUNTRY_CODE_NAM'), value: 'NAM' }, { display: this.$translate.instant('COUNTRY_CODE_NRU'), value: 'NRU' }, { display: this.$translate.instant('COUNTRY_CODE_NPL'), value: 'NPL' }, { display: this.$translate.instant('COUNTRY_CODE_NLD'), value: 'NLD' }, { display: this.$translate.instant('COUNTRY_CODE_NCL'), value: 'NCL' }, { display: this.$translate.instant('COUNTRY_CODE_NZL'), value: 'NZL' }, { display: this.$translate.instant('COUNTRY_CODE_NIC'), value: 'NIC' }, { display: this.$translate.instant('COUNTRY_CODE_NER'), value: 'NER' }, { display: this.$translate.instant('COUNTRY_CODE_NGA'), value: 'NGA' }, { display: this.$translate.instant('COUNTRY_CODE_NIU'), value: 'NIU' }, { display: this.$translate.instant('COUNTRY_CODE_NFK'), value: 'NFK' }, { display: this.$translate.instant('COUNTRY_CODE_MNP'), value: 'MNP' }, { display: this.$translate.instant('COUNTRY_CODE_NOR'), value: 'NOR' }, { display: this.$translate.instant('COUNTRY_CODE_OMN'), value: 'OMN' }, { display: this.$translate.instant('COUNTRY_CODE_PAK'), value: 'PAK' }, { display: this.$translate.instant('COUNTRY_CODE_PLW'), value: 'PLW' }, { display: this.$translate.instant('COUNTRY_CODE_PSE'), value: 'PSE' }, { display: this.$translate.instant('COUNTRY_CODE_PAN'), value: 'PAN' }, { display: this.$translate.instant('COUNTRY_CODE_PNG'), value: 'PNG' }, { display: this.$translate.instant('COUNTRY_CODE_PRY'), value: 'PRY' }, { display: this.$translate.instant('COUNTRY_CODE_PER'), value: 'PER' }, { display: this.$translate.instant('COUNTRY_CODE_PHL'), value: 'PHL' }, { display: this.$translate.instant('COUNTRY_CODE_PCN'), value: 'PCN' }, { display: this.$translate.instant('COUNTRY_CODE_POL'), value: 'POL' }, { display: this.$translate.instant('COUNTRY_CODE_PRT'), value: 'PRT' }, { display: this.$translate.instant('COUNTRY_CODE_PRI'), value: 'PRI' }, { display: this.$translate.instant('COUNTRY_CODE_QAT'), value: 'QAT' }, { display: this.$translate.instant('COUNTRY_CODE_MKD'), value: 'MKD' }, { display: this.$translate.instant('COUNTRY_CODE_ROU'), value: 'ROU' }, { display: this.$translate.instant('COUNTRY_CODE_RUS'), value: 'RUS' }, { display: this.$translate.instant('COUNTRY_CODE_RWA'), value: 'RWA' }, { display: this.$translate.instant('COUNTRY_CODE_REU'), value: 'REU' }, { display: this.$translate.instant('COUNTRY_CODE_BLM'), value: 'BLM' }, { display: this.$translate.instant('COUNTRY_CODE_SHN'), value: 'SHN' }, { display: this.$translate.instant('COUNTRY_CODE_KNA'), value: 'KNA' }, { display: this.$translate.instant('COUNTRY_CODE_LCA'), value: 'LCA' }, { display: this.$translate.instant('COUNTRY_CODE_MAF'), value: 'MAF' }, { display: this.$translate.instant('COUNTRY_CODE_SPM'), value: 'SPM' }, { display: this.$translate.instant('COUNTRY_CODE_VCT'), value: 'VCT' }, { display: this.$translate.instant('COUNTRY_CODE_WSM'), value: 'WSM' }, { display: this.$translate.instant('COUNTRY_CODE_SMR'), value: 'SMR' }, { display: this.$translate.instant('COUNTRY_CODE_STP'), value: 'STP' }, { display: this.$translate.instant('COUNTRY_CODE_SAU'), value: 'SAU' }, { display: this.$translate.instant('COUNTRY_CODE_SEN'), value: 'SEN' }, { display: this.$translate.instant('COUNTRY_CODE_SRB'), value: 'SRB' }, { display: this.$translate.instant('COUNTRY_CODE_SYC'), value: 'SYC' }, { display: this.$translate.instant('COUNTRY_CODE_SLE'), value: 'SLE' }, { display: this.$translate.instant('COUNTRY_CODE_SGP'), value: 'SGP' }, { display: this.$translate.instant('COUNTRY_CODE_SXM'), value: 'SXM' }, { display: this.$translate.instant('COUNTRY_CODE_SVK'), value: 'SVK' }, { display: this.$translate.instant('COUNTRY_CODE_SVN'), value: 'SVN' }, { display: this.$translate.instant('COUNTRY_CODE_SLB'), value: 'SLB' }, { display: this.$translate.instant('COUNTRY_CODE_SOM'), value: 'SOM' }, { display: this.$translate.instant('COUNTRY_CODE_ZAF'), value: 'ZAF' }, { display: this.$translate.instant('COUNTRY_CODE_SGS'), value: 'SGS' }, { display: this.$translate.instant('COUNTRY_CODE_SSD'), value: 'SSD' }, { display: this.$translate.instant('COUNTRY_CODE_ESP'), value: 'ESP' }, { display: this.$translate.instant('COUNTRY_CODE_LKA'), value: 'LKA' }, { display: this.$translate.instant('COUNTRY_CODE_SDN'), value: 'SDN' }, { display: this.$translate.instant('COUNTRY_CODE_SUR'), value: 'SUR' }, { display: this.$translate.instant('COUNTRY_CODE_SJM'), value: 'SJM' }, { display: this.$translate.instant('COUNTRY_CODE_SWE'), value: 'SWE' }, { display: this.$translate.instant('COUNTRY_CODE_CHE'), value: 'CHE' }, { display: this.$translate.instant('COUNTRY_CODE_SYR'), value: 'SYR' }, { display: this.$translate.instant('COUNTRY_CODE_TWN'), value: 'TWN' }, { display: this.$translate.instant('COUNTRY_CODE_TJK'), value: 'TJK' }, { display: this.$translate.instant('COUNTRY_CODE_TZA'), value: 'TZA' }, { display: this.$translate.instant('COUNTRY_CODE_THA'), value: 'THA' }, { display: this.$translate.instant('COUNTRY_CODE_TLS'), value: 'TLS' }, { display: this.$translate.instant('COUNTRY_CODE_TGO'), value: 'TGO' }, { display: this.$translate.instant('COUNTRY_CODE_TKL'), value: 'TKL' }, { display: this.$translate.instant('COUNTRY_CODE_TON'), value: 'TON' }, { display: this.$translate.instant('COUNTRY_CODE_TTO'), value: 'TTO' }, { display: this.$translate.instant('COUNTRY_CODE_TUN'), value: 'TUN' }, { display: this.$translate.instant('COUNTRY_CODE_TUR'), value: 'TUR' }, { display: this.$translate.instant('COUNTRY_CODE_TKM'), value: 'TKM' }, { display: this.$translate.instant('COUNTRY_CODE_TCA'), value: 'TCA' }, { display: this.$translate.instant('COUNTRY_CODE_TUV'), value: 'TUV' }, { display: this.$translate.instant('COUNTRY_CODE_UGA'), value: 'UGA' }, { display: this.$translate.instant('COUNTRY_CODE_UKR'), value: 'UKR' }, { display: this.$translate.instant('COUNTRY_CODE_ARE'), value: 'ARE' }, { display: this.$translate.instant('COUNTRY_CODE_GBR'), value: 'GBR' }, { display: this.$translate.instant('COUNTRY_CODE_UMI'), value: 'UMI' }, { display: this.$translate.instant('COUNTRY_CODE_USA'), value: 'USA' }, { display: this.$translate.instant('COUNTRY_CODE_URY'), value: 'URY' }, { display: this.$translate.instant('COUNTRY_CODE_UZB'), value: 'UZB' }, { display: this.$translate.instant('COUNTRY_CODE_VUT'), value: 'VUT' }, { display: this.$translate.instant('COUNTRY_CODE_VEN'), value: 'VEN' }, { display: this.$translate.instant('COUNTRY_CODE_VNM'), value: 'VNM' }, { display: this.$translate.instant('COUNTRY_CODE_VGB'), value: 'VGB' }, { display: this.$translate.instant('COUNTRY_CODE_VIR'), value: 'VIR' }, { display: this.$translate.instant('COUNTRY_CODE_WLF'), value: 'WLF' }, { display: this.$translate.instant('COUNTRY_CODE_ESH'), value: 'ESH' }, { display: this.$translate.instant('COUNTRY_CODE_YEM'), value: 'YEM' }, { display: this.$translate.instant('COUNTRY_CODE_ZMB'), value: 'ZMB' }, { display: this.$translate.instant('COUNTRY_CODE_ZWE'), value: 'ZWE' }, { display: this.$translate.instant('COUNTRY_CODE_ALA'), value: 'ALA' }];
	    }
	  }]);

	  return StaticListService;
	}();

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AgreementService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgreementService = exports.AgreementService = function () {
	  AgreementService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	  function AgreementService($http, ENV, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, AgreementService);

	    this.$http = $http;
	    this.ENV = ENV;
	    this.Utils = Utils;
	    this.BASE_URL = ENV.URL + '/providers/' + ENV.PROVIDER;
	    this.RequestService = RequestService;
	    this._notifications = {};
	    this._initializeNotifications();
	  }

	  _createClass(AgreementService, [{
	    key: 'getAgreements',
	    value: function getAgreements() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	      options = this.Utils.setParams(options, isPaginated);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      var notifications = this.RequestService.getNotifications(options, this._notifications['getAgreements']);
	      var url = this.BASE_URL + (organizationId ? '/organizations/' + organizationId : '') + '/agreements';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'addOperations',
	    value: function addOperations(agreement, operationIds) {
	      var _this2 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['addOperations']);
	      var url = this.ENV.URL + '/v1/admin/agreements/' + agreement.code + '/operations';
	      var data = { operations: operationIds };
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this2.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeOperations',
	    value: function removeOperations(agreement, operationId) {
	      var _this3 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['removeOperations']);
	      var url = this.ENV.URL + '/v1/admin/agreements/' + agreement.code + '/operations/' + operationId;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this3.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        getAgreements: null,
	        addOperations: null,
	        removeOperations: null
	      };
	    }
	  }]);

	  return AgreementService;
	}();

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TariffsService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TariffsService = exports.TariffsService = function () {
	  TariffsService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	  function TariffsService($http, ENV, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, TariffsService);

	    this.$http = $http;
	    this.ENV = ENV;
	    this.Utils = Utils;
	    this.RequestService = RequestService;
	    this._notifications = {};
	    this._initializeNotifications();
	  }

	  _createClass(TariffsService, [{
	    key: 'getTariffs',
	    value: function getTariffs() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options, isPaginated, true);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      if (organizationId) {
	        options.params.organizationId = organizationId;
	      }
	      var locationId = _lodash2.default.get(options, 'locationId', null);
	      if (locationId) {
	        options.params.locationId = locationId;
	      }
	      var notifications = this.RequestService.getNotifications(options, this._notifications["getTariffs"]);
	      var url = this.ENV.URL + '/v1/admin/tariffs';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this.Utils.parsePaginationResponseForV1(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'getTariff',
	    value: function getTariff() {
	      var _this2 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var id = _lodash2.default.get(options, 'id', null);
	      var url = this.ENV.URL + '/v1/admin/tariffs/' + id;
	      var notifications = this.RequestService.getNotifications(options, this._notifications["getTariff"]);
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return _this2.RequestService.getResponse(res, false);
	      });
	    }
	  }, {
	    key: 'createTariff',
	    value: function createTariff(data) {
	      var _this3 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications["post"]);
	      var url = this.ENV.URL + '/v1/admin/tariffs';
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this3.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateTariff',
	    value: function updateTariff(data) {
	      var _this4 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications["put"]);
	      var url = this.ENV.URL + '/v1/admin/tariffs/' + options.id;
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this4.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var _this5 = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var id = _lodash2.default.get(options, 'id', null);
	      var url = this.ENV.URL + '/v1/admin/tariffs/' + id;
	      var notifications = this.RequestService.getNotifications(options, this._notifications["remove"]);
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this5.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        getTariffs: null,
	        getTariff: null,
	        post: { success: "ADD_TARIFF_SUCCESS", error: "ADD_TARIFF_FAILED" },
	        put: { success: "UPDATE_TARIFF_SUCCESS", error: "UPDATE_TARIFF_FAILED" },
	        remove: { success: "REMOVE_TARIFF_SUCCESS", error: "REMOVE_TARIFF_FAILED" }
	      };
	    }
	  }]);

	  return TariffsService;
	}();

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TariffsHelperService = undefined;

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TariffsHelperService = exports.TariffsHelperService = function () {
	  TariffsHelperService.$inject = ["App", "$translate", "$filter", "moment", "$stateParams", "GroupsService"];
	  function TariffsHelperService(App, $translate, $filter, moment, $stateParams, GroupsService) {
	    'ngInject';

	    _classCallCheck(this, TariffsHelperService);

	    this.GroupsService = GroupsService;

	    this.defaultPriceComponent = {
	      price: 0,
	      stepSize: 1,
	      vat: 0,
	      type: 'ENERGY',
	      priceWithVat: 0
	    };

	    this.defaultRestriction = {
	      startTime: '00:00',
	      endTime: '24:00',
	      daysOfWeek: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'],
	      isHoliday: false,
	      priceComponents: [this.defaultPriceComponent]
	    };

	    this.daysOfWeekOptions = [{ display: $translate.instant('MONDAY'), id: 'MONDAY' }, { display: $translate.instant('TUESDAY'), id: 'TUESDAY' }, { display: $translate.instant('WEDNESDAY'), id: 'WEDNESDAY' }, { display: $translate.instant('THURSDAY'), id: 'THURSDAY' }, { display: $translate.instant('FRIDAY'), id: 'FRIDAY' }, { display: $translate.instant('SATURDAY'), id: 'SATURDAY' }, { display: $translate.instant('SUNDAY'), id: 'SUNDAY' }];

	    this.priceComponentVatOptions = [{ value: 0, display: '0' }, { value: 7, display: '7' }, { value: 21, display: '21' }, { value: 23, display: '23' }, { value: null, display: $translate.instant('NO_TAXES') }];

	    this.priceComponentTypeOptions = [{ display: $translate.instant('ENERGY'), id: 'ENERGY' }, { display: $translate.instant('TIME'), id: 'TIME' },
	    // { display: $translate.instant('PARKING_TIME'), id: 'PARKING_TIME' },
	    { display: $translate.instant('FLAT'), id: 'FLAT' }];

	    this.App = App;
	    this.moment = moment;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.organization = $stateParams.organization;
	  }

	  _createClass(TariffsHelperService, [{
	    key: 'removeTariff',
	    value: function removeTariff($scope, tariff, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          tariff: tariff,
	          done: function done() {
	            resolve(options);
	            _this.App.closeModal();
	          }
	        };
	        _this.App.openModal($scope, 'remove-tariff.html');
	      });
	    }
	  }, {
	    key: 'hasGroup',
	    value: function hasGroup(tariff, groupId) {
	      return _lodash2.default.get(tariff, 'locations', []).some(function (location) {
	        return location.id === groupId;
	      });
	    }
	  }, {
	    key: 'upsertLocation',
	    value: function upsertLocation($scope, locations, options) {
	      return this._upsertLocation($scope, locations, options);
	    }
	  }, {
	    key: 'createRestriction',
	    value: function createRestriction($scope, options) {
	      return this._upsertRestriction($scope, null, options);
	    }
	  }, {
	    key: 'editRestriction',
	    value: function editRestriction($scope, restriction, options) {
	      return this._upsertRestriction($scope, restriction, options);
	    }
	  }, {
	    key: 'removeRestriction',
	    value: function removeRestriction($scope, restriction) {
	      var _this2 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          restriction: restriction,
	          done: function done() {
	            resolve(restriction);
	            _this2.App.closeModal();
	          }
	        };
	        _this2.App.openModal($scope, 'remove-restriction.html');
	      });
	    }
	  }, {
	    key: '_upsertRestriction',
	    value: function _upsertRestriction($scope, restriction, options) {
	      var _this3 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          restriction: _lodash2.default.cloneDeep(restriction || _this3.defaultRestriction),
	          restrictions: _lodash2.default.cloneDeep(options.restrictions || []).filter(function (r) {
	            return !_lodash2.default.isEqual(r, restriction);
	          }),
	          withDuration: false,
	          withEnergy: false,
	          daysOfWeek: [],
	          daysOfWeekOptions: _lodash2.default.cloneDeep(_this3.daysOfWeekOptions),
	          defaultPriceComponent: _lodash2.default.cloneDeep(_this3.defaultPriceComponent),
	          priceComponentTypeOptions: _lodash2.default.cloneDeep(_this3.priceComponentTypeOptions),
	          priceComponentVatOptions: _lodash2.default.cloneDeep(_this3.priceComponentVatOptions),
	          selectedMaxDuration: null,
	          maxDurationOptions: [{ value: null, display: _this3.$translate.instant('NO_LIMIT') }],
	          selectedMaxWh: null,
	          hasOverlapText: undefined,
	          maxWhOptions: [{ value: null, display: _this3.$translate.instant('NO_LIMIT') }],
	          wizard: {
	            step: 0,
	            steps: [],
	            setSteps: function setSteps(modal) {
	              var steps = [{ id: 'general', title: _this3.$translate.instant('GENERAL'), intro: _this3.$translate.instant('GENERAL') }, {
	                id: 'duration',
	                title: _this3.$translate.instant('TIME_STRETCH'),
	                intro: _this3.$translate.instant('TIME_STRETCH')
	              }, {
	                id: 'energy',
	                title: _this3.$translate.instant('ENERGY_STRETCH'),
	                intro: _this3.$translate.instant('ENERGY_STRETCH')
	              }, { id: 'cost', title: _this3.$translate.instant('COST'), intro: _this3.$translate.instant('COST') }, { id: 'summary', title: _this3.$translate.instant('SUMMARY'), intro: _this3.$translate.instant('SUMMARY') }];
	              modal.wizard.steps = _lodash2.default.filter(steps, function (step) {
	                switch (step.id) {
	                  case 'duration':
	                    return modal.withDuration;
	                  case 'energy':
	                    return modal.withEnergy;
	                  default:
	                    return true;
	                }
	              });
	            }
	          },
	          startEndTimeSlider: {
	            value: { min: 0, max: 24 },
	            options: {
	              floor: 0,
	              ceil: 24,
	              translate: function translate(value) {
	                if (value <= 0) return '00:00';
	                if (value >= 24) return '24:00';
	                return _this3.moment().startOf('day').add(_this3.moment.duration(value * 60, 'm')).format('HH:mm');
	              },
	              showTicksValues: true,
	              ticksArray: [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24]
	            },
	            onChange: function onChange() {
	              $scope.modal.restriction.startTime = $scope.modal.startEndTimeSlider.options.translate($scope.modal.startEndTimeSlider.value.min);
	              $scope.modal.restriction.endTime = $scope.modal.startEndTimeSlider.options.translate($scope.modal.startEndTimeSlider.value.max);
	            }
	          },
	          hasOverlap: function hasOverlap() {
	            var restrictions = _lodash2.default.cloneDeep($scope.modal.restrictions);
	            var restriction = _lodash2.default.cloneDeep($scope.modal.restriction);
	            var toMinutes = function toMinutes(t) {
	              var _t$split$map = t.split(':').map(Number),
	                  _t$split$map2 = _slicedToArray(_t$split$map, 2),
	                  h = _t$split$map2[0],
	                  m = _t$split$map2[1];

	              return h * 60 + m;
	            };

	            var start = toMinutes(restriction.startTime);
	            var end = toMinutes(restriction.endTime);

	            return restrictions.some(function (r) {
	              if (r.isHoliday !== restriction.isHoliday) return false;

	              var sameDays = r.daysOfWeek.some(function (day) {
	                return restriction.daysOfWeek.includes(day);
	              });
	              if (!sameDays) return false;

	              var rStart = toMinutes(r.startTime || '00:00');
	              var rEnd = toMinutes(r.endTime || '24:00');
	              return start < rEnd && end > rStart;
	            });
	          },
	          reviewSteps: function reviewSteps(switchValue, which) {
	            switch (which) {
	              case 'duration':
	                $scope.modal.withDuration = switchValue;
	                if (!switchValue) {
	                  delete $scope.modal.restriction.minDuration;
	                  delete $scope.modal.restriction.maxDuration;
	                }
	                break;
	              case 'energy':
	                $scope.modal.withEnergy = switchValue;
	                if (!switchValue) {
	                  delete $scope.modal.restriction.minWh;
	                  delete $scope.modal.restriction.maxWh;
	                }
	                break;
	            }
	            $scope.modal.wizard.setSteps($scope.modal);
	          },
	          next: function next() {
	            var step = $scope.modal.wizard.step;
	            if ($scope.modal.wizard.steps[step].id === 'general') {
	              $scope.modal.restriction.daysOfWeek = $scope.modal.daysOfWeek;
	              var _startTime = $scope.modal.restriction.startTime;
	              var _endTime = $scope.modal.restriction.endTime;
	              $scope.modal.hasOverlapText = $scope.modal.hasOverlap() ? _this3.$translate.instant('RESTRICTION_TIME_OVERLAP', { startTime: _startTime, endTime: _endTime }) : undefined;
	            }
	            $scope.modal.wizard.step = step + 1;
	          },
	          back: function back() {
	            var step = $scope.modal.wizard.step;
	            $scope.modal.wizard.step = step - 1;
	          },
	          done: function done() {
	            restriction = restriction || {};
	            _lodash2.default.assign(restriction, _this3._removeVatFromPriceComponents($scope.modal.restriction));
	            resolve(restriction);
	            _this3.App.closeModal();
	          }
	        };

	        $scope.modal.selectedMaxDuration = $scope.modal.restriction.maxDuration ? null : $scope.modal.maxDurationOptions[0];
	        $scope.modal.selectedMaxWh = $scope.modal.restriction.maxWh ? null : $scope.modal.maxWhOptions[0];
	        $scope.modal.daysOfWeek = $scope.modal.restriction.daysOfWeek;
	        $scope.modal.withDuration = _lodash2.default.isNumber($scope.modal.restriction.minDuration);
	        $scope.modal.withEnergy = _lodash2.default.isNumber($scope.modal.restriction.minWh);
	        $scope.modal.wizard.setSteps($scope.modal);

	        var startTime = $scope.modal.restriction.startTime || _this3.defaultRestriction.startTime;
	        var endTime = $scope.modal.restriction.endTime || _this3.defaultRestriction.endTime;
	        $scope.modal.startEndTimeSlider.value.min = startTime.split(':')[0];
	        $scope.modal.startEndTimeSlider.value.max = endTime.split(':')[0];
	        $scope.modal.startEndTimeSlider.onChange();
	        _this3.App.openModal($scope, 'upsert-restriction.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: '_removeVatFromPriceComponents',
	    value: function _removeVatFromPriceComponents(restriction) {
	      restriction.priceComponents = restriction.priceComponents.map(function (component) {
	        delete component.priceWithVat;
	        return component;
	      });
	      return restriction;
	    }
	  }, {
	    key: '_upsertLocation',
	    value: function _upsertLocation($scope, locations, options) {
	      var _this4 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          locations: _lodash2.default.cloneDeep(locations || []),
	          configurationView: {
	            locationTableData: {
	              organizationId: options.organizationId,
	              table: {
	                keys: ['name | locationName:item'],
	                selected: locations,
	                selectable: 'multi'
	              },
	              filters: _this4.App.getTableFilters('locations', {
	                context: _this4,
	                modify: { purpose: { hide: true, value: 'General' } }
	              })
	            },
	            locations: [],
	            locationTableApi: {},
	            unsubscribeSelectedEvent: null,
	            unsubscribe: null,
	            subscribe: function subscribe() {
	              return $scope.$watch(function () {
	                return $scope.modal.configurationView.locationTableApi.on;
	              }, function (onFn) {
	                if (!onFn) return;
	                $scope.modal.configurationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                  if (_lodash2.default.isArray(selected)) {
	                    $scope.modal.configurationView.locations = selected;
	                  }
	                });
	              });
	            }
	          },
	          locationView: {
	            locationTableData: {
	              enabledBreadcrumbs: false,
	              organizationId: options.organizationId,
	              filters: [],
	              table: {
	                keys: ['name | locationName:item'],
	                synchronous: true,
	                actions: [{
	                  tooltip: _this4.$translate.instant('REMOVE'),
	                  icon: 'times-hexagon',
	                  custom: 'danger',
	                  onClick: function onClick(location) {
	                    return $scope.modal.locationView.locationTableApi.removeLocation(location);
	                  }
	                }]
	              },
	              locations: []
	            },
	            locationTableApi: {}
	          },
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'configuration',
	              title: _this4.$translate.instant('CONFIGURATION'),
	              intro: _this4.$translate.instant('SELECT_LOCATIONS_MAKE_UP_OPERATION')
	            }, {
	              id: 'locations',
	              title: _this4.$translate.instant('LOCATIONS'),
	              intro: _this4.$translate.instant('CONFIRM_SELECTED_ATOMIC_LOCATIONS')
	            }, { id: 'summary', title: _this4.$translate.instant('SUMMARY'), intro: _this4.$translate.instant('SUMMARY') }]
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'configuration') {
	              return modal.configurationView.locations.length > 0;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'locations') {
	              return modal.locationView.locationTableData.locations.length > 0;
	            }
	            return true;
	          },
	          close: function close() {
	            if ($scope.modal.configurationView.unsubscribeSelectedEvent) {
	              $scope.modal.configurationView.unsubscribeSelectedEvent();
	              $scope.modal.configurationView.unsubscribe();
	            }
	            $scope.App.closeModal();
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            switch (modal.wizard.steps[step].id) {
	              case 'configuration':
	                {
	                  var _locations = modal.configurationView.locations;
	                  var parentIds = new Set(_locations.filter(function (location) {
	                    return location.parentGroupId;
	                  }).map(function (location) {
	                    return location.parentGroupId;
	                  }));
	                  modal.locationView.locationTableData.locations = _locations.filter(function (location) {
	                    return !parentIds.has(location.id);
	                  });
	                  break;
	                }
	              case 'locations':
	                modal.locations = modal.locationView.locationTableData.locations;
	                break;
	            }
	            modal.conflict = null;
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            if (modal.wizard.steps[step].id === 'locations') {
	              modal.configurationView.locationTableData.table.selected = modal.configurationView.locations;
	            }
	            modal.wizard.step = step - 1;
	          },
	          done: function done() {
	            if ($scope.modal.configurationView.unsubscribeSelectedEvent) {
	              $scope.modal.configurationView.unsubscribeSelectedEvent();
	              $scope.modal.configurationView.unsubscribe();
	            }
	            resolve($scope.modal.locations);
	            _this4.App.closeModal();
	          }
	        };
	        $scope.modal.configurationView.unsubscribe = $scope.modal.configurationView.subscribe();
	        _this4.App.openModal($scope, 'upsert-location-to-tariff.html', { size: 'lg' });
	      });
	    }
	  }]);

	  return TariffsHelperService;
	}();

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocationsService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LocationsService = exports.LocationsService = function () {
	  LocationsService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	  function LocationsService($http, ENV, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, LocationsService);

	    this.$http = $http;
	    this.ENV = ENV;
	    this.Utils = Utils;
	    this.RequestService = RequestService;
	    this._notifications = {};
	    this._initializeNotifications();
	  }

	  _createClass(LocationsService, [{
	    key: 'getLocations',
	    value: function getLocations() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options, isPaginated);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      if (organizationId) {
	        options.params.organizationId = organizationId;
	      }
	      var locationId = _lodash2.default.get(options, 'locationId', null);
	      if (locationId) {
	        options.params.locationId = locationId;
	      }
	      var notifications = this.RequestService.getNotifications(options, this._notifications['getLocations']);
	      var url = this.ENV.URL + '/v0/groups';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this.Utils.parsePaginationResponse(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'getAtomicLocations',
	    value: function getAtomicLocations(list) {
	      var _this2 = this;

	      var response = [];
	      var getAllPages = function getAllPages(location) {
	        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

	        var options = {
	          pagination: {
	            currentPage: page,
	            itemsPerPage: 10
	          },
	          params: {
	            locationId: location.id,
	            onlyAtomic: "true",
	            orderby: "name,asc",
	            organizationId: location.organizationId,
	            purpose: location.purpose
	          }
	        };
	        return _this2.getLocations(options).then(function (data) {
	          if (!data.docs || data.docs.length === 0) {
	            return [];
	          } else {
	            return getAllPages(location, page + 1).then(function (nextPages) {
	              return data.docs.concat(nextPages);
	            });
	          }
	        });
	      };
	      var promises = list.map(function (location) {
	        if (location.isAtomic) {
	          response.push(location);
	          return Promise.resolve();
	        } else {
	          return getAllPages(location).then(function (atomicLocations) {
	            response = _lodash2.default.concat(response, atomicLocations);
	          });
	        }
	      });
	      return Promise.all(promises).then(function () {
	        response = _lodash2.default.uniqBy(response, 'id');
	        return response;
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        getLocations: null
	      };
	    }
	  }]);

	  return LocationsService;
	}();

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OperationService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OperationService = exports.OperationService = function () {
	  OperationService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	  function OperationService($http, ENV, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, OperationService);

	    this.$http = $http;
	    this.ENV = ENV;
	    this.Utils = Utils;
	    this.RequestService = RequestService;
	    this._notifications = {};
	    this._initializeNotifications();
	  }

	  _createClass(OperationService, [{
	    key: 'getOperations',
	    value: function getOperations() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options, isPaginated, true);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      if (organizationId) {
	        options.params.organizationId = organizationId;
	      }
	      var locationId = _lodash2.default.get(options, 'locationId', null);
	      if (locationId) {
	        options.params.locationId = locationId;
	      }
	      var notifications = this.RequestService.getNotifications(options, this._notifications['getOperations']);
	      var url = this.ENV.URL + '/v1/admin/operations';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this.Utils.parsePaginationResponseForV1(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'createOperation',
	    value: function createOperation(operation) {
	      var _this2 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['createOperation']);
	      var url = this.ENV.URL + '/v1/admin/operations';
	      return this.RequestService.post(url, operation, options, notifications).then(function (res) {
	        return _this2.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateOperation',
	    value: function updateOperation(operation) {
	      var _this3 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['updateOperation']);
	      var url = this.ENV.URL + '/v1/admin/operations/' + operation.id;
	      var data = _lodash2.default.omit(operation, ['id', 'organizationId']);
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this3.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeOperation',
	    value: function removeOperation(operation) {
	      var _this4 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['removeOperation']);
	      var url = this.ENV.URL + '/v1/admin/operations/' + operation.id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this4.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'addOperationToLocation',
	    value: function addOperationToLocation(locationId, operationIds) {
	      var _this5 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['addOperationToLocation']);
	      var url = this.ENV.URL + '/v1/admin/locations/' + locationId + '/operations';
	      var data = { operations: operationIds };
	      return this.RequestService.post(url, data, options, notifications).then(function (res) {
	        return _this5.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeOperationFromLocation',
	    value: function removeOperationFromLocation(locationId, operationId) {
	      var _this6 = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['removeOperationFromLocation']);
	      var url = this.ENV.URL + '/v1/admin/locations/' + locationId + '/operations/' + operationId;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this6.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        getOperations: null,
	        createOperation: null,
	        updateOperation: null,
	        removeOperation: null,
	        addOperationToLocation: null,
	        removeOperationFromLocation: null
	      };
	    }
	  }]);

	  return OperationService;
	}();

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OperationsHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OperationsHelperService = exports.OperationsHelperService = function () {
	  OperationsHelperService.$inject = ["App", "$translate", "$filter", "$stateParams", "LocationsService", "AgreementService", "OperationService"];
	  function OperationsHelperService(App, $translate, $filter, $stateParams, LocationsService, AgreementService, OperationService) {
	    'ngInject';

	    _classCallCheck(this, OperationsHelperService);

	    this.App = App;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.LocationsService = LocationsService;
	    this.AgreementService = AgreementService;
	    this.OperationService = OperationService;

	    this.defaultOperation = {
	      name: '',
	      organizationId: '',
	      agreements: [],
	      locations: []
	    };
	  }

	  _createClass(OperationsHelperService, [{
	    key: 'addOperationToLocation',
	    value: function addOperationToLocation($scope, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          operation: null,
	          operations: [],
	          error: false,
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'operation',
	              title: _this.$translate.instant('OPERATION'),
	              intro: _this.$translate.instant('SELECT_OPERATION')
	            }, { id: 'summary', title: _this.$translate.instant('SUMMARY'), intro: _this.$translate.instant('SUMMARY') }]
	          },
	          display: function display(operation) {
	            return operation.name;
	          },
	          onSearch: function onSearch(term, pagination) {
	            var aux = {
	              params: {
	                operationName: term,
	                orderby: 'name,asc'
	              },
	              pagination: pagination,
	              organizationId: options.organizationId
	            };
	            if (term) {
	              aux.params.operationName = term;
	            }
	            _this.OperationService.getOperations(aux, true).then(function (data) {
	              $scope.modal.operations = $scope.modal.operations.concat(data.docs);
	              pagination.totalItems = data.totalItems;
	            });
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'operation') {
	              var alreadyAssigned = modal.operation ? _lodash2.default.some(options.operations, { id: modal.operation.id }) : false;
	              modal.error = alreadyAssigned;
	              return modal.operation != null && !alreadyAssigned;
	            }
	            return true;
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.wizard.step = step - 1;
	          },
	          done: function done(modal) {
	            return resolve(_this.OperationService.addOperationToLocation(options.locationId, [modal.operation.id], options).then(function () {
	              return _this.App.closeModal();
	            }));
	          }
	        };
	        _this.App.openModal($scope, 'add-operation-to-location.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'removeOperationFromLocation',
	    value: function removeOperationFromLocation($scope, operation, options) {
	      var _this2 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          operation: operation,
	          done: function done() {
	            return resolve(_this2.OperationService.removeOperationFromLocation(options.locationId, operation.id, options).then(function () {
	              return _this2.App.closeModal();
	            }));
	          }
	        };
	        _this2.App.openModal($scope, 'remove-operation.html');
	      });
	    }
	  }, {
	    key: 'removeOperation',
	    value: function removeOperation($scope, operation, options) {
	      var _this3 = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          operation: operation,
	          done: function done() {
	            resolve(_this3.OperationService.removeOperation(operation, options).then(function () {
	              return _this3.App.closeModal();
	            }));
	          }
	        };
	        _this3.App.openModal($scope, 'remove-operation.html');
	      });
	    }
	  }, {
	    key: 'createOperation',
	    value: function createOperation($scope, options) {
	      return this._upsertOperation($scope, null, options);
	    }
	  }, {
	    key: 'editOperation',
	    value: function editOperation($scope, operation, options) {
	      return this._upsertOperation($scope, operation, options);
	    }
	  }, {
	    key: '_upsertOperation',
	    value: function _upsertOperation($scope, operation, options) {
	      var _this4 = this;

	      var isEdit = !!operation;
	      return new Promise(function (resolve) {
	        $scope.modal = {
	          operation: _lodash2.default.cloneDeep(operation || _this4.defaultOperation),
	          isEdit: isEdit,
	          configurationView: {
	            locationTableData: {
	              organizationId: options.organizationId,
	              table: {
	                keys: ['name | locationName:item'],
	                selected: isEdit ? operation.locations : [],
	                selectable: 'multi'
	              },
	              filters: _this4.App.getTableFilters('locations', { context: _this4, modify: { purpose: { hide: true, value: 'General' } } })
	            },
	            locationTableApi: {}
	          },
	          atomicView: {
	            locationTableData: {
	              enabledBreadcrumbs: false,
	              organizationId: options.organizationId,
	              filters: [],
	              table: {
	                keys: ['name | locationName:item'],
	                synchronous: true,
	                actions: [{
	                  tooltip: _this4.$translate.instant('REMOVE'),
	                  icon: 'times-hexagon',
	                  custom: 'danger',
	                  onClick: function onClick(location) {
	                    return $scope.modal.atomicView.locationTableApi.removeLocation(location);
	                  }
	                }]
	              },
	              locations: []
	            },
	            locationTableApi: {}
	          },
	          agreementView: {
	            dualListData: {
	              available: [],
	              availableTitle: _this4.$translate.instant('CURRENT_AGREEMENTS'),
	              availableHelp: _this4.$translate.instant('HELP_LIST_OF_AGREEMENTS_ORGANIZATION_AS_CPO', {
	                name: '<accent>' + options.organizationId + '</accent>'
	              }),
	              trackBy: 'code',
	              assigned: isEdit ? operation.agreements : [],
	              assignedTitle: _this4.$translate.instant('AGREEMENTS_SELECTED_TO_ACTIVATE_SHARING'),
	              display: function display(item) {
	                return _this4.$filter('agreementName')(item.organizationName, item);
	              }
	            },
	            dualListApi: {}
	          },
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'name',
	              title: _this4.$translate.instant('NAME'),
	              intro: _this4.$translate.instant('ENTER_OPERATION_IDENTIFIER')
	            }, {
	              id: 'configuration',
	              title: _this4.$translate.instant('CONFIGURATION'),
	              intro: _this4.$translate.instant('SELECT_LOCATIONS_MAKE_UP_OPERATION')
	            }, {
	              id: 'locations',
	              title: _this4.$translate.instant('LOCATIONS'),
	              intro: _this4.$translate.instant('CONFIRM_SELECTED_ATOMIC_LOCATIONS')
	            }, {
	              id: 'agreements',
	              title: _this4.$translate.instant('AGREEMENTS'),
	              intro: _this4.$translate.instant('SELECT_AGREEMENTS_WHICH_RESOURCES_BELONGING_TO_OPERATION')
	            }, { id: 'summary', title: _this4.$translate.instant('SUMMARY'), intro: _this4.$translate.instant('SUMMARY') }]
	          },
	          getSelectedLocations: function getSelectedLocations() {
	            var getSelected = _lodash2.default.get($scope, 'modal.configurationView.locationTableApi.getSelectedLocations');
	            return _lodash2.default.isFunction(getSelected) ? getSelected() : [];
	          },
	          getAssignedAgreements: function getAssignedAgreements() {
	            var getSelected = _lodash2.default.get($scope, 'modal.agreementView.dualListApi.getAssigned');
	            return _lodash2.default.isFunction(getSelected) ? getSelected() : [];
	          },
	          getAgreements: function getAgreements() {
	            if ($scope.modal.agreementView.dualListData.available.length > 0) {
	              return;
	            }
	            var aux = {
	              organizationId: options.organizationId,
	              params: { organizationRole: 'cpo' }
	            };
	            _this4.AgreementService.getAgreements(aux).then(function (agreements) {
	              $scope.modal.agreementView.dualListData.available = agreements.filter(function (agreement) {
	                return agreement.role === 'emsp';
	              });
	            });
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'configuration') {
	              return modal.getSelectedLocations().length > 0;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'locations') {
	              return modal.atomicView.locationTableData.locations.length > 0;
	            }
	            return true;
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            var promises = [];
	            switch (modal.wizard.steps[step].id) {
	              case 'name':
	                modal.operation.organizationId = options.organizationId;
	                break;
	              case 'configuration':
	                modal.configurationView.locationTableData.table.selected = modal.getSelectedLocations();
	                promises.push(_this4.LocationsService.getAtomicLocations(modal.getSelectedLocations()).then(function (atomicLocations) {
	                  modal.atomicView.locationTableData.locations = atomicLocations;
	                }));
	                break;
	              case 'locations':
	                modal.getAgreements();
	                modal.operation.locations = modal.atomicView.locationTableData.locations.map(function (item) {
	                  return item.id;
	                });
	                break;
	              case 'agreements':
	                {
	                  var assignedAgreements = modal.getAssignedAgreements();
	                  modal.agreementView.dualListData.assigned = assignedAgreements;
	                  modal.operation.agreements = assignedAgreements.map(function (item) {
	                    return item.code;
	                  });
	                  break;
	                }
	            }
	            Promise.all(promises).then(function () {
	              $scope.$applyAsync(function () {
	                modal.wizard.step = step + 1;
	              });
	            });
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.wizard.step = step - 1;
	          },
	          done: function done(modal) {
	            var action = modal.isEdit ? _this4.OperationService.updateOperation : _this4.OperationService.createOperation;
	            return resolve(action.call(_this4.OperationService, modal.operation, options).then(function () {
	              return _this4.App.closeModal();
	            }));
	          }
	        };
	        _this4.App.openModal($scope, 'upsert-operation.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'seeOperation',
	    value: function seeOperation($scope, operation, options) {
	      var _this5 = this;

	      return new Promise(function () {
	        $scope.modal = {
	          locationTableData: {
	            enabledBreadcrumbs: false,
	            organizationId: options.organizationId,
	            filters: [],
	            table: {
	              synchronous: true,
	              actions: []
	            },
	            locations: operation.locations
	          },
	          locationTableApi: {}
	        };
	        _this5.App.openModal($scope, 'inspect-operation.html', { size: 'lg' });
	      });
	    }
	  }]);

	  return OperationsHelperService;
	}();

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AgreementsHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgreementsHelperService = exports.AgreementsHelperService = function () {
	  AgreementsHelperService.$inject = ["App", "$translate", "$filter", "$stateParams", "AgreementService", "OperationService"];
	  function AgreementsHelperService(App, $translate, $filter, $stateParams, AgreementService, OperationService) {
	    'ngInject';

	    _classCallCheck(this, AgreementsHelperService);

	    this.App = App;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.AgreementService = AgreementService;
	    this.OperationService = OperationService;
	  }

	  _createClass(AgreementsHelperService, [{
	    key: 'assignOperation',
	    value: function assignOperation($scope, agreement, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          operations: [],
	          operationsToAdd: [],
	          operationsToDelete: [],
	          dualListData: {
	            available: [],
	            availableTitle: _this.$translate.instant('AVAILABLE_OPERATIONS'),
	            assigned: [],
	            assignedTitle: _this.$translate.instant('ASSIGNED_OPERATIONS'),
	            assignedHelp: _this.$translate.instant('HELP_LIST_OF_OPERATIONS_ASSIGNED_TO_AGREEMENT'),
	            requestEnabled: true,
	            display: function display(item) {
	              return item.name;
	            }
	          },
	          dualListApi: {},
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'operations',
	              title: _this.$translate.instant('OPERATION'),
	              intro: _this.$translate.instant('REVIEW_OPERATIONS_ASSIGNED_TO_AGREEMENT')
	            }, { id: 'summary', title: _this.$translate.instant('SUMMARY'), intro: _this.$translate.instant('SUMMARY') }]
	          },
	          getAssignedOperations: function getAssignedOperations() {
	            var getSelected = _lodash2.default.get($scope, 'modal.dualListApi.getAssigned');
	            return _lodash2.default.isFunction(getSelected) ? getSelected() : [];
	          },
	          getOperations: function getOperations(type, page) {
	            if (type === 'available') {
	              return _this.getOperations(page, options.organizationId);
	            } else {
	              return _this.getOperations(page, options.organizationId, agreement.code).then(function (data) {
	                if (page === 1) {
	                  $scope.modal.operations = data;
	                }
	                return data;
	              });
	            }
	          },
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'operations') {
	              var assignedOperations = modal.getAssignedOperations();
	              return !_lodash2.default.isEqual(_lodash2.default.sortBy(_lodash2.default.map(assignedOperations, 'id')), _lodash2.default.sortBy(_lodash2.default.map(modal.operations, 'id')));
	            }
	            return true;
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            if (modal.wizard.steps[step].id === 'operations') {
	              var assignedOperations = modal.getAssignedOperations();
	              modal.dualListData.assigned = assignedOperations;
	              modal.operationsToAdd = _lodash2.default.differenceBy(assignedOperations, modal.operations, 'id').map(function (o) {
	                return o.id;
	              });
	              modal.operationsToDelete = _lodash2.default.differenceBy(modal.operations, assignedOperations, 'id').map(function (o) {
	                return o.id;
	              });
	            }
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.wizard.step = step - 1;
	          },
	          done: function done(modal) {
	            var promises = [];
	            if (modal.operationsToAdd.length) {
	              promises.push(_this.AgreementService.addOperations(agreement, modal.operationsToAdd, options));
	            }
	            if (modal.operationsToDelete.length) {
	              promises.push.apply(promises, _toConsumableArray(modal.operationsToDelete.map(function (operation) {
	                return _this.AgreementService.removeOperations(agreement, operation, options);
	              })));
	            }
	            return resolve(Promise.all(promises).then(function () {
	              _this.App.closeModal();
	            }));
	          }
	        };
	        _this.App.openModal($scope, 'assign-operation-to-agreement.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'getOperations',
	    value: function getOperations(page, organizationId, agreementCode) {
	      var _this2 = this;

	      var options = {
	        pagination: {
	          currentPage: page,
	          itemsPerPage: 10
	        },
	        params: {
	          orderby: 'id,asc',
	          organizationId: organizationId
	        }
	      };
	      if (agreementCode) {
	        options.params.agreementCode = agreementCode;
	      }
	      this.App.setLoading(true);
	      return this.OperationService.getOperations(options, true).then(function (data) {
	        _this2.App.setLoading(false);
	        return data.docs;
	      }).catch(function () {
	        _this2.operations = [];
	        _this2.App.setLoading(false);
	      });
	    }
	  }]);

	  return AgreementsHelperService;
	}();

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomerHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CustomerHelperService = exports.CustomerHelperService = function () {
	  CustomerHelperService.$inject = ["$rootScope", "$translate", "App", "moment", "GroupsService", "UsersService"];
	  function CustomerHelperService($rootScope, $translate, App, moment, GroupsService, UsersService) {
	    'ngInject';

	    _classCallCheck(this, CustomerHelperService);

	    $rootScope.CustomerHelperService = this;

	    this.$translate = $translate;
	    this.App = App;
	    this.GroupsService = GroupsService;
	    this.UsersService = UsersService;

	    this.moment = moment;

	    this.defaultUserKey = {
	      idToken: null,
	      activeFrom: null,
	      activeTo: null,
	      blocked: false,
	      master: false
	    };
	  }

	  _createClass(CustomerHelperService, [{
	    key: 'addUserKey',
	    value: function addUserKey($scope, data, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          customer: options.customer,
	          userkey: _lodash2.default.cloneDeep(_this.defaultUserKey),
	          organizationId: options.organizationId,
	          withLocation: true,
	          location: null,
	          locationView: {
	            locationTableData: {
	              organizationId: options.organizationId,
	              table: {
	                keys: ['name | locationName:item'],
	                selected: [],
	                selectable: 'one'
	              },
	              filters: _this.App.getTableFilters('locations', {
	                context: _this,
	                modify: { purpose: { hide: true, value: 'General' } }
	              })
	            },
	            locationTableApi: {},
	            unsubscribeSelectedEvent: null,
	            unsubscribe: null,
	            subscribe: function subscribe() {
	              return $scope.$watch(function () {
	                return $scope.modal.locationView.locationTableApi.on;
	              }, function (onFn) {
	                if (!onFn) return;
	                $scope.modal.locationView.unsubscribeSelectedEvent = onFn('selectedEvent', function (selected) {
	                  if (_lodash2.default.isArray(selected)) {
	                    $scope.modal.location = selected[0];
	                  }
	                });
	              });
	            }
	          },
	          userkeyExpirationPeriod: null,
	          userkeyExpirationPeriods: [{ display: '1 ' + _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.YEARS'), toAdd: [1, 'years'] }, { display: '2 ' + _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.YEARS'), toAdd: [2, 'years'] }, { display: '3 ' + _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.YEARS'), toAdd: [3, 'years'] }, { display: '4 ' + _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.YEARS'), toAdd: [4, 'years'] }, { display: '5 ' + _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.YEARS'), toAdd: [5, 'years'] }, { display: '10 ' + _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.YEARS'), toAdd: [10, 'years'] }],
	          userkeyActive: true,
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'id',
	              title: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.ID'),
	              intro: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.ENTER_ID')
	            }, {
	              id: 'location',
	              title: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.GROUP'),
	              intro: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.ENTER_GROUP')
	            }, {
	              id: 'config',
	              title: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.CONFIG'),
	              intro: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.ENTER_CONFIG')
	            }, {
	              id: 'recap',
	              title: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.RECAP'),
	              intro: _this.$translate.instant('CUSTOMER_VIEW.USERKEYS.MODAL.ENTER_RECAP')
	            }]
	          },
	          isValid: function isValid(modal) {
	            var step = modal.wizard.step;
	            if (modal.wizard.steps[step].id === 'id') {
	              return modal.userkey.idToken && modal.userkey.idToken.length > 0;
	            }
	            if (modal.wizard.steps[step].id === 'location') {
	              return !modal.withLocation || modal.withLocation && modal.location;
	            }
	            return true;
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            if (modal.wizard.steps[step].id === 'id') {
	              if (!modal.organizationId) {
	                modal.withLocation = false;
	              }
	            }
	            if (modal.wizard.steps[step].id === 'location') {
	              if (!modal.withLocation) {
	                modal.location = null;
	              }
	              modal.userkeyActive = true;
	              modal.userkeyActivationDate = new Date();
	              modal.userkeyActivationDateConf = {
	                open: false,
	                options: {}
	              };
	              modal.userkeyExpirationPeriod = modal.userkeyExpirationPeriods[modal.userkeyExpirationPeriods.length - 1];
	            }
	            if (modal.wizard.steps[step].id === 'config') {
	              modal.userkey.blocked = !modal.userkeyActive;
	              var now = _this.moment(modal.userkeyActivationDate);
	              modal.userkey.activeFrom = now.toISOString();
	              modal.userkey.activeTo = now.add(modal.userkeyExpirationPeriod.toAdd[0], modal.userkeyExpirationPeriod.toAdd[1]).toISOString();
	            }
	            modal.conflict = null;
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.conflict = null;
	            modal.wizard.step = step - 1;
	          },
	          close: function close() {
	            if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	              $scope.modal.locationView.unsubscribeSelectedEvent();
	              $scope.modal.locationView.unsubscribe();
	            }
	            $scope.App.closeModal();
	          },
	          done: function done() {
	            $scope.modal.state = 'working';
	            if ($scope.modal.locationView.unsubscribeSelectedEvent) {
	              $scope.modal.locationView.unsubscribeSelectedEvent();
	              $scope.modal.locationView.unsubscribe();
	            }
	            return resolve(_this._bindUserKeyToCustomer($scope.modal.userkey, $scope.modal.customer, $scope.modal.location, $scope.modal.organizationId));
	          }
	        };
	        $scope.modal.locationView.unsubscribe = $scope.modal.locationView.subscribe();
	        _this.App.openModal($scope, 'add-userkey-to-customer.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: '_bindUserKeyToCustomer',
	    value: function _bindUserKeyToCustomer(userkey, customer, location, organizationId) {
	      var _this2 = this;

	      var doTheBind = function doTheBind(userkey, customer) {
	        return _this2.UsersService.bindUserkeyToCustomer(userkey.userKeyId, customer.id, {
	          organization: organizationId
	        }).catch(function (err) {
	          _this2.App.showNotification(_this2.$translate.instant('CUSTOMER_VIEW.USERKEYS.ASSIGN_TO_CUSTOMER_FAILED', {
	            name: '<accent>' + customer.name + '</accent>'
	          }), 'warning');
	          _this2.App.closeModal();
	          return err;
	        });
	      };
	      var doTheAuthorization = function doTheAuthorization(userkey, location) {
	        return _this2.UsersService.addUserkeyToGroup(userkey.userKeyId, location.id, {
	          organization: organizationId
	        }).catch(function (err) {
	          _this2.App.showNotification(_this2.$translate.instant('USERKEYS.AUTH_GROUP_FAILED', { name: '<accent>' + location.name + '</accent>' }), 'warning');
	          _this2.App.closeModal();
	          return err;
	        });
	      };
	      var allDone = function allDone(pending) {
	        if (pending == 0) {
	          _this2.App.showNotification(_this2.$translate.instant('ADD_USER_KEY_SUCCESS'));
	          _this2.App.closeModal();
	        }
	      };

	      this.App.hideNotification();
	      return this.UsersService.addUserkey(_lodash2.default.omit(userkey, ['userKeyId']), { organization: organizationId }).then(function (newUserkey) {
	        var pending = 0;
	        doTheBind(newUserkey, customer).then(function () {
	          return allDone(--pending);
	        });
	        if (location) {
	          pending++;
	          doTheAuthorization(newUserkey, location).then(function () {
	            return allDone(--pending);
	          });
	        }
	        allDone(pending);
	      }).catch(function () {
	        _this2.App.showNotification(_this2.$translate.instant('ADD_USER_KEY_FAILED', {
	          id: '<accent>' + (userkey.userKeyId || userkey.idToken) + '</accent>'
	        }), 'error');
	        _this2.App.closeModal();
	      });
	    }
	  }]);

	  return CustomerHelperService;
	}();

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MarginService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MarginService = exports.MarginService = function () {
	  MarginService.$inject = ["$http", "ENV", "Utils", "RequestService"];
	  function MarginService($http, ENV, Utils, RequestService) {
	    'ngInject';

	    _classCallCheck(this, MarginService);

	    this.$http = $http;
	    this.ENV = ENV;
	    this.Utils = Utils;
	    this.RequestService = RequestService;
	    this._notifications = {};
	    this._initializeNotifications();
	  }

	  _createClass(MarginService, [{
	    key: 'getMargins',
	    value: function getMargins() {
	      var _this = this;

	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var isPaginated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	      options = this.Utils.setParams(options, isPaginated, true);
	      var organizationId = _lodash2.default.get(options, 'organizationId', null);
	      if (organizationId) {
	        options.params.organizationId = organizationId;
	      }
	      var locationId = _lodash2.default.get(options, 'locationId', null);
	      if (locationId) {
	        options.params.locationId = locationId;
	      }
	      var notifications = this.RequestService.getNotifications(options, this._notifications['getMargins']);
	      var url = this.ENV.URL + '/v1/admin/margins';
	      return this.RequestService.get(url, options, notifications).then(function (res) {
	        return isPaginated ? _this.Utils.parsePaginationResponseForV1(res, options.pagination.itemsPerPage) : res.data;
	      });
	    }
	  }, {
	    key: 'createMargin',
	    value: function createMargin(margin) {
	      var _this2 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['createMargin']);
	      var url = this.ENV.URL + '/v1/admin/margins';
	      return this.RequestService.post(url, margin, options, notifications).then(function (res) {
	        return _this2.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'updateMargin',
	    value: function updateMargin(margin) {
	      var _this3 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['updateMargin']);
	      var url = this.ENV.URL + '/v1/admin/margins/' + margin.id;
	      var data = _lodash2.default.omit(margin, ['id', 'locationId', 'organizationId']);
	      return this.RequestService.put(url, data, options, notifications).then(function (res) {
	        return _this3.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: 'removeMargin',
	    value: function removeMargin(margin) {
	      var _this4 = this;

	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	      var notifications = this.RequestService.getNotifications(options, this._notifications['removeMargin']);
	      var url = this.ENV.URL + '/v1/admin/margins/' + margin.id;
	      return this.RequestService.delete(url, options, notifications).then(function (res) {
	        return _this4.RequestService.getResponse(res);
	      });
	    }
	  }, {
	    key: '_initializeNotifications',
	    value: function _initializeNotifications() {
	      this._notifications = {
	        getMargins: null,
	        createMargin: null,
	        updateMargin: null,
	        removeMargin: null
	      };
	    }
	  }]);

	  return MarginService;
	}();

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MarginHelperService = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var MarginHelperService = exports.MarginHelperService = function () {
	  MarginHelperService.$inject = ["App", "$translate", "$filter", "$stateParams", "MarginService", "Utils"];
	  function MarginHelperService(App, $translate, $filter, $stateParams, MarginService, Utils) {
	    'ngInject';

	    _classCallCheck(this, MarginHelperService);

	    this.App = App;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.MarginService = MarginService;
	    this.Utils = Utils;

	    this.defaultMargin = {
	      name: '',
	      organizationId: '',
	      locationId: '',
	      percentage: 0,
	      flat: 0,
	      vat: 0
	    };

	    this.marginPercentageOptions = [{ value: 0, display: '0' }, { value: 10, display: '10' }, { value: 20, display: '20' }];

	    this.marginVatOptions = [{ value: 0, display: '0' }, { value: 7, display: '7' }, { value: 21, display: '21' }, { value: 23, display: '23' }];
	  }

	  _createClass(MarginHelperService, [{
	    key: 'removeMargin',
	    value: function removeMargin($scope, margin, options) {
	      var _this = this;

	      return new Promise(function (resolve) {
	        $scope.modal = {
	          margin: margin,
	          done: function done() {
	            resolve(_this.MarginService.removeMargin(margin, options).then(function () {
	              return _this.App.closeModal();
	            }));
	          }
	        };
	        _this.App.openModal($scope, 'remove-margin.html');
	      });
	    }
	  }, {
	    key: 'createMargin',
	    value: function createMargin($scope, options) {
	      return this._upsertMargin($scope, null, options);
	    }
	  }, {
	    key: 'editMargin',
	    value: function editMargin($scope, operation, options) {
	      return this._upsertMargin($scope, operation, options);
	    }
	  }, {
	    key: '_upsertMargin',
	    value: function _upsertMargin($scope, margin, options) {
	      var _this2 = this;

	      var isEdit = !!margin;
	      return new Promise(function (resolve) {
	        $scope.modal = {
	          margin: _lodash2.default.cloneDeep(margin || _this2.defaultMargin),
	          isEdit: isEdit,
	          marginPercentageOptions: _lodash2.default.cloneDeep(_this2.marginPercentageOptions),
	          marginVatOptions: _lodash2.default.cloneDeep(_this2.marginVatOptions),
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'configuration',
	              title: _this2.$translate.instant('CONFIGURATION'),
	              intro: _this2.$translate.instant('SET_PROFIT_MARGIN_ON_TARIFF')
	            }, { id: 'summary', title: _this2.$translate.instant('SUMMARY'), intro: _this2.$translate.instant('SUMMARY') }]
	          },
	          flatWithVat: 0,
	          isValid: function isValid(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'configuration') {
	              return modal.margin.name !== '';
	            }
	            return true;
	          },
	          next: function next(modal) {
	            var step = modal.wizard.step;
	            modal.wizard.step = step + 1;
	          },
	          back: function back(modal) {
	            var step = modal.wizard.step;
	            modal.wizard.step = step - 1;
	          },
	          done: function done(modal) {
	            var action = modal.isEdit ? _this2.MarginService.updateMargin : _this2.MarginService.createMargin;
	            var payload = _lodash2.default.merge(modal.margin, {
	              organizationId: options.organizationId,
	              locationId: options.locationId
	            });
	            delete payload.locationName;
	            return resolve(action.call(_this2.MarginService, payload, options).then(function () {
	              return _this2.App.closeModal();
	            }));
	          }
	        };
	        $scope.modal.flatWithVat = _this2.Utils.calculatePriceWithVat($scope.modal.margin.flat, $scope.modal.margin.vat, 1e3);
	        _this2.App.openModal($scope, 'upsert-margin.html', { size: 'lg' });
	      });
	    }
	  }]);

	  return MarginHelperService;
	}();

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _login = __webpack_require__(257);

	var _header = __webpack_require__(258);

	var _dashboard = __webpack_require__(259);

	var _resetPassword = __webpack_require__(260);

	var _forgotPassword = __webpack_require__(261);

	var _profile = __webpack_require__(262);

	var _signup = __webpack_require__(263);

	var _welcome = __webpack_require__(264);

	var _userKeys = __webpack_require__(265);

	var _userKey = __webpack_require__(266);

	var _settings = __webpack_require__(267);

	var _customers = __webpack_require__(268);

	var _customer = __webpack_require__(269);

	var _charge = __webpack_require__(270);

	var _charges = __webpack_require__(271);

	var _organization = __webpack_require__(272);

	var _organizations = __webpack_require__(273);

	var _group = __webpack_require__(274);

	var _groups = __webpack_require__(275);

	var _chargePoint = __webpack_require__(276);

	var _chargePoints = __webpack_require__(277);

	var _left = __webpack_require__(278);

	var _tariffs = __webpack_require__(279);

	var _tariff = __webpack_require__(280);

	var _agreements = __webpack_require__(281);

	var _locations = __webpack_require__(282);

	exports.default = angular.module('controllers', []).controller('LoginController', _login.LoginController).controller('LeftController', _left.LeftController).controller('HeaderController', _header.HeaderController).controller('DashboardController', _dashboard.DashboardController).controller('ResetPasswordController', _resetPassword.ResetPasswordController).controller('ForgotPasswordController', _forgotPassword.ForgotPasswordController).controller('SignUpController', _signup.SignUpController).controller('WelcomeController', _welcome.WelcomeController).controller('ProfileController', _profile.ProfileController).controller('UserKeysController', _userKeys.UserKeysController).controller('UserKeyController', _userKey.UserKeyController).controller('CustomersController', _customers.CustomersController).controller('CustomerController', _customer.CustomerController).controller('SettingsController', _settings.SettingsController).controller('ChargeController', _charge.ChargeController).controller('ChargesController', _charges.ChargesController).controller('OrganizationController', _organization.OrganizationController).controller('OrganizationsController', _organizations.OrganizationsController).controller('GroupController', _group.GroupController).controller('GroupsController', _groups.GroupsController).controller('ChargepointController', _chargePoint.ChargepointController).controller('ChargepointsController', _chargePoints.ChargePointsController).controller('TariffsController', _tariffs.TariffsController).controller('TariffController', _tariff.TariffController).controller('AgreementsController', _agreements.AgreementsController).controller('LocationsController', _locations.LocationsController).name;

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LoginController = exports.LoginController = function () {
	  LoginController.$inject = ["Auth", "App", "$state", "$translate", "ENV", "VERSION"];
	  function LoginController(Auth, App, $state, $translate, ENV, VERSION) {
	    'ngInject';

	    _classCallCheck(this, LoginController);

	    this.Auth = Auth;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.ENV = ENV;
	    this.App = App;
	    this.user = { username: '', password: '' };
	    this.captcha = { status: false, solution: null, data: null };
	    this.authcode = { status: false, value: '' };
	    this.frontVersion = VERSION;
	  }

	  _createClass(LoginController, [{
	    key: 'login',
	    value: function login() {
	      var _this = this;

	      this.Auth.login(this.user, this.captcha, this.authcode).then(function () {
	        return _this.$state.go('efimob.home');
	      }).catch(function (error) {
	        if (error["data"] && !('errors' in error["data"])) {
	          var data = 'error' in error["data"] ? error["data"]["error"] : error["data"];
	          switch (data['subcode']) {
	            case 'INVALID_AUTH_CODE':
	              _this.captcha["status"] = false;
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.AUTHCODE_FAILED'), 'error');
	            case 'CAPTCHA_REQUIRED':
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.CAPTCHA_REQUIRED'), 'error');
	            case 'WRONG_CAPTCHA':
	            case 'CAPTCHA_REQUEST':
	              _this.captcha = { status: true, solution: null, data: data["captcha"] };
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.CAPTCHA_REQUIRED'), 'error');
	            case 'BLOCKED':
	              _this.captcha["status"] = false;
	              _this.authcode.status = false;
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.USER_BLOCKED'), 'error');
	            case 'NO_AUTH_CODE':
	              _this.captcha["status"] = false;
	              _this.authcode.status = true;
	              return;
	            case 'SECRET_EXPIRED':
	              _this.captcha["status"] = false;
	              _this.authcode.status = false;
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.SECRET_EXPIRED'), 'error');
	            case 'MFA_REQUIRED':
	              _this.captcha["status"] = false;
	              _this.authcode.status = false;
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.MFA_REQUIRED'), 'error');
	            default:
	              _this.captcha["status"] = false;
	              return _this.App.showNotification(_this.$translate.instant('LOGIN.BAD_CREDENTIALS'), 'error');
	          }
	        }
	        return _this.App.showNotification(_this.$translate.instant('LOGIN.FAILED'), 'error');
	      });
	    }
	  }]);

	  return LoginController;
	}();

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var HeaderController = exports.HeaderController = function () {
	    HeaderController.$inject = ["App", "UsersService"];
	    function HeaderController(App, UsersService) {
	        'ngInject';

	        _classCallCheck(this, HeaderController);

	        this.App = App;
	        this.UsersService = UsersService;
	        this.userMenu = { 'open': false };
	    }

	    _createClass(HeaderController, [{
	        key: 'setchangeCurrentRole',
	        value: function setchangeCurrentRole(role) {
	            this.UsersService.setRole(role);
	        }
	    }, {
	        key: 'closeUserMenu',
	        value: function closeUserMenu() {
	            this.userMenu.open = false;
	        }
	    }]);

	    return HeaderController;
	}();

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DashboardController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var DashboardController = exports.DashboardController = function () {
	    DashboardController.$inject = ["$state", "$scope", "$stateParams", "$timeout", "$translate", "Cache", "App", "GroupsHelper", "$interval", "ChargeHelper", "moment", "GroupsService", "ChargePointsService", "ChargeSessionsService", "Utils"];
	    function DashboardController($state, $scope, $stateParams, $timeout, $translate, Cache, App, GroupsHelper, $interval, ChargeHelper, moment, GroupsService, ChargePointsService, ChargeSessionsService, Utils) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, DashboardController);

	        this.App = App;
	        this.$state = $state;
	        this.Utils = Utils;
	        this.$timeout = $timeout;
	        this.$translate = $translate;
	        this.$scope = $scope;
	        this.Cache = Cache;
	        this.ChargeHelper = ChargeHelper;
	        this.ChargePointsService = ChargePointsService;
	        this.GroupsService = GroupsService;
	        this.GroupsHelper = GroupsHelper;
	        this.moment = moment;
	        this.ChargeSessionsService = ChargeSessionsService;

	        this.organization = $stateParams.organization || null;
	        this.group = $stateParams.group || null;
	        this.summary = null;
	        this.state = {
	            chargepointsProviderView: 'organizations',
	            chargesPeriod: 'last7Days',
	            autoReload: {
	                timer: null,
	                currentIdx: 0, // TODO Temporarily disable autoreload option
	                options: [{ seconds: 0, display: 'no' }, { seconds: 60, display: this.$translate.instant('DASHBOARD.AUTORELOAD.MINUTE', { n: 1 }) }, { seconds: 300, display: this.$translate.instant('DASHBOARD.AUTORELOAD.MINUTES', { n: 5 }) }, { seconds: 900, display: this.$translate.instant('DASHBOARD.AUTORELOAD.MINUTES', { n: 15 }) }]
	            }
	        };

	        this.chargepointsProviderViewSelector = {
	            list: [{ id: 'organizations', display: this.$translate.instant('DASHBOARD.CHARGEPOINTS.ORGANIZATIONS') }, { id: 'all', display: this.$translate.instant('DASHBOARD.CHARGEPOINTS.ALL') }]
	        };

	        this.chargesPeriodSelector = {
	            list: [{ id: 'today', display: this.$translate.instant('DASHBOARD.CHARGES.TODAY') }, { id: 'yesterday', display: this.$translate.instant('DASHBOARD.CHARGES.YESTERDAY') }, { id: 'last7Days', display: this.$translate.instant('DASHBOARD.CHARGES.LAST_7_DAYS') }, { id: 'currentWeek', display: this.$translate.instant('DASHBOARD.CHARGES.CURRENT_WEEK') }, { id: 'previousWeek', display: this.$translate.instant('DASHBOARD.CHARGES.PREVIOUS_WEEK') }, { id: 'currentMonth', display: this.$translate.instant('DASHBOARD.CHARGES.CURRENT_MONTH') }, { id: 'previousMonth', display: this.$translate.instant('DASHBOARD.CHARGES.PREVIOUS_MONTH') }, { id: 'currentYear', display: this.$translate.instant('DASHBOARD.CHARGES.CURRENT_YEAR') }, { id: 'previousYear', display: this.$translate.instant('DASHBOARD.CHARGES.PREVIOUS_YEAR') }, { id: 'ever', display: this.$translate.instant('DASHBOARD.CHARGES.ALL') }]
	        };

	        this.data = {
	            cards: {
	                totalOrganizations: '--',
	                totalChargepoints: '--',
	                totalCharges: '--',
	                totalMeter: '--',
	                totalActiveCharges: '--',
	                totalChargesInPeriod: '--'
	            },
	            charts: {
	                chargepointsByOrganizationPie: {
	                    series: []
	                },
	                chargepointsConnectedPie: {
	                    series: []
	                },
	                connectorsStatusPie: {
	                    series: []
	                }
	            },
	            tables: {
	                disconnectedChargepoints: null,
	                unavailableChargepoints: null,
	                lastCharges: null
	            },
	            flattenedGroups: null
	        };

	        this.charts = {
	            chargepointsByOrganizationPie: {
	                zeroResults: this.$translate.instant('DASHBOARD.CHARTS.ZERO_RESULTS')
	            },
	            chargepointsConnectedPie: {
	                labels: [this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTED_STATUS.CONNECTED'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTED_STATUS.DISCONNECTED')],
	                colors: ['#729233', '#E74C3C'],
	                zeroResults: this.$translate.instant('DASHBOARD.CHARTS.ZERO_RESULTS')
	            },
	            connectorsStatusPie: {
	                labels: [this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.AVAILABLE'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.PREPARING'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.CHARGING'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.RESERVED'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.NOT_AVAILABLE'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.OUT_OF_SERVICE'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.OTHERS'), this.$translate.instant('DASHBOARD.CHARGEPOINTS.CONNECTOR_STATUS.DISCONNECTED')],
	                colors: ['#729233', '#DD4477', '#668CD3', '#954B97', '#E67300', '#E74C3C', '#AAAA11', '#9CC2CB'],
	                zeroResults: this.$translate.instant('DASHBOARD.CHARTS.ZERO_RESULTS')
	            }
	        };

	        if (this.organization) {
	            this.charts['chargepointsConnectedPie']['onClick'] = function (index) {
	                var queryValues = ['true', 'false'];
	                $state.go('efimob.chargepoints.at.list', { 'organization': _this.organization, 'conectado': queryValues[index] });
	            };
	            this.charts['connectorsStatusPie']['onClick'] = function (index) {
	                var queryValues = ['Available', 'Preparing', 'Charging,SuspendedEV,SuspendedEVSE,Finishing', 'Reserved', 'Unavailable', 'Faulted', 'Other', null];
	                if (queryValues[index] === null) {
	                    $state.go('efimob.chargepoints.at.list', { 'organization': _this.organization, 'conectado': 'false' });
	                } else {
	                    $state.go('efimob.chargepoints.at.list', { 'organization': _this.organization, 'conectado': 'true', 'status': queryValues[index] });
	                }
	            };
	        } else {
	            this.charts['chargepointsByOrganizationPie']['onClick'] = function (index) {
	                var organization = _this.data.charts.chargepointsByOrganizationPie.ids[index];
	                $state.go('efimob.chargepoints.at.list', { 'organization': organization });
	            };
	        }

	        this.tables = {
	            disconnectedChargepoints: _lodash2.default.defaults({}, App.getTable('disconnectedChargepoints', { omit: this.organization ? ['organizationId'] : [] })),
	            unavailableChargepoints: _lodash2.default.defaults({}, App.getTable('unavailableChargepoints', { omit: this.organization ? ['organizationId'] : [] })),
	            lastCharges: _lodash2.default.defaults({}, App.getTable('lastCharges'))
	        };

	        this.maps = {
	            'groups': App.getMap()
	        };

	        $scope.$watch('ctrl.state.autoReload.currentIdx', function () {
	            var current = _this.state.autoReload.options[_this.state.autoReload.currentIdx];
	            if (_this.state.autoReload.timer) {
	                $interval.cancel(_this.state.autoReload.timer);
	                _this.state.autoReload.timer = null;
	            }
	            if (current.seconds > 0) {
	                _this.state.autoReload.timer = $interval(function () {
	                    _this.reload();
	                }, current.seconds * 1000);
	            }
	        });

	        $scope.$watch('ctrl.state.chargepointsProviderView', function (now, before) {
	            if (now && before && now != before) {
	                _this.setCardsForProvider(_this.summary);
	                _this.setChartsForProvider(_this.summary);
	            }
	        });

	        $scope.$watch('ctrl.state.chargesPeriod', function (now, before) {
	            if (now && before && now != before) _this.reloadChargesInPeriod();
	        });

	        $scope.$on('$destroy', function () {
	            if (_this.state.autoReload.timer) {
	                $interval.cancel(_this.state.autoReload.timer);
	                _this.state.autoReload.timer = null;
	            }
	        });
	    }

	    _createClass(DashboardController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.reloadChargesInPeriod = this.reloadChargesInPeriod.bind(this);
	            this.toggleAutoReload = this._toggleAutoReload.bind(this);
	            this.reload = this._reload.bind(this);
	            this.search = this._search.bind(this);
	            this.onChargepointClick = this.onChargepointClick.bind(this);
	            this.onGroupClick = this.onGroupClick.bind(this);
	            this.onChargeClick = this.onChargeClick.bind(this);
	            this.reloadDisconnectedChargepoints = this.reloadDisconnectedChargepoints.bind(this);
	            this.reloadUnavailableChargepoints = this.reloadUnavailableChargepoints.bind(this);
	            this.reload();
	            this.setBreadcrums();
	        }
	    }, {
	        key: 'onGroupClick',
	        value: function onGroupClick(group) {
	            this.$state.go('efimob.groups.item', { 'id': group.id, 'organization': this.organization });
	        }
	    }, {
	        key: '_toggleAutoReload',
	        value: function _toggleAutoReload() {
	            this.state.autoReload.currentIdx = (this.state.autoReload.currentIdx + 1) % this.state.autoReload.options.length;
	        }
	    }, {
	        key: '_reload',
	        value: function _reload() {
	            this.reloadSummary();
	            this.reloadDisconnectedChargepoints();
	            this.reloadUnavailableChargepoints();
	            if (this.organization) {
	                this.reloadGroups();
	                this.reloadChargesInPeriod();
	            }
	        }
	    }, {
	        key: '_search',
	        value: function _search() {
	            var _this2 = this;

	            var filters = this.App.getTableFilters("chargepoint")[5];
	            this.$scope.modal = {
	                chargePoint: null,
	                chargePoints: [],
	                table: this.App.getTable('ocppSearch'),
	                filters: [filters],
	                searchByList: filters.combo,
	                searchBy: null,
	                updateSearchBy: function updateSearchBy(option) {
	                    _this2.$scope.modal.chargePoint = null;
	                    _this2.$scope.modal.chargePoints = [];
	                    _this2.$scope.modal.filters[0].scope = option;
	                },
	                onSearch: function onSearch(term, pagination) {
	                    _this2.$scope.modal.filters[0].value = term;
	                    var aux = {
	                        filters: _this2.$scope.modal.filters,
	                        pagination: pagination,
	                        sorting: _this2.App.getSorting(['name'], 'name', 'asc')
	                    };
	                    _this2.ChargePointsService.getProviderChargepoints(aux, true).then(function (data) {
	                        _this2.$scope.modal.chargePoints = _this2.$scope.modal.chargePoints.concat(data.docs);
	                        pagination.totalItems = data.totalItems;
	                    });
	                },
	                display: function display(chargepoint) {
	                    return chargepoint.name + ' - ' + chargepoint.serialOCPP + ' - ' + chargepoint.chargePointSerialNumber + '  - ' + chargepoint.organizationId;
	                },
	                done: function done() {
	                    return _this2.onChargepointClick(_this2.$scope.modal.chargePoint);
	                }
	            };
	            this.$scope.modal.searchBy = this.$scope.modal.searchByList[0];
	            this.$scope.modal.updateSearchBy(this.$scope.modal.searchBy);
	            this.App.openModal(this.$scope, 'chargepoint-search.html', { 'size': 'lg' });
	        }
	    }, {
	        key: 'getChargePeriodById',
	        value: function getChargePeriodById(id) {
	            return _lodash2.default.find(this.chargesPeriodSelector.list, { id: id });
	        }
	    }, {
	        key: 'setChartsForOrganization',
	        value: function setChartsForOrganization(summary) {
	            var chargepointsConnected = [0, 0];
	            if (angular.isDefined(summary.chargepoints.connected)) {
	                chargepointsConnected = [summary.chargepoints.connected.chargepoints, summary.chargepoints.total - summary.chargepoints.connected.chargepoints]; // connected, disconnected
	            } else if (angular.isDefined(summary.chargepoints.disconnected)) {
	                chargepointsConnected = [summary.chargepoints.total - summary.chargepoints.disconnected.chargepoints, summary.chargepoints.disconnected.chargepoints]; // connected, disconnected
	            }
	            var connectorsStatus = [0, 0, 0, 0, 0, 0, 0, 0];
	            this.addConnectorStatus(connectorsStatus, _lodash2.default.get(summary.chargepoints, 'connected.connectors', {}), _lodash2.default.get(summary.chargepoints, 'disconnected.connectors', {}));
	            this.data.charts.chargepointsConnectedPie.series = chargepointsConnected;
	            this.data.charts.connectorsStatusPie.series = connectorsStatus;
	        }
	    }, {
	        key: 'setCardsForProvider',
	        value: function setCardsForProvider(data) {
	            if (!data) return;
	            var total = {
	                chargepoints: 0,
	                chargingSessions: 0,
	                totalEffectiveDuration: { hours: 0, minutes: 0, seconds: 0 },
	                totalDuration: { hours: 0, minutes: 0, seconds: 0 },
	                meter: 0
	            };
	            if (_lodash2.default.isArray(data.organizations)) {
	                this.data.cards.totalOrganizations = data.organizations.length;
	                _lodash2.default.each(data.organizations, function (organization) {
	                    total.chargepoints += _lodash2.default.get(organization, 'summary.chargepoints.total', 0);
	                    total.chargingSessions += _lodash2.default.get(organization, 'summary.chargingSessions.total', 0);
	                    total.totalEffectiveDuration.hours += _lodash2.default.get(organization, 'summary.chargingSessions.totalEffectiveDuration.hours', 0);
	                    total.totalEffectiveDuration.minutes += _lodash2.default.get(organization, 'summary.chargingSessions.totalEffectiveDuration.minutes', 0);
	                    total.totalEffectiveDuration.seconds += _lodash2.default.get(organization, 'summary.chargingSessions.totalEffectiveDuration.seconds', 0);
	                    total.totalDuration.hours += _lodash2.default.get(organization, 'summary.chargingSessions.totalDuration.hours', 0);
	                    total.totalDuration.minutes += _lodash2.default.get(organization, 'summary.chargingSessions.totalDuration.minutes', 0);
	                    total.totalDuration.seconds += _lodash2.default.get(organization, 'summary.chargingSessions.totalDuration.seconds', 0);
	                    total.meter += _lodash2.default.get(organization, 'summary.chargingSessions.totalPower', 0);
	                });
	            }
	            this.data.cards.totalChargepoints = total.chargepoints;
	            this.data.cards.totalCharges = total.chargingSessions;
	            this.data.cards.totalEffectiveDuration = total.totalEffectiveDuration.hours + Math.floor((total.totalEffectiveDuration.minutes * 60 + total.totalEffectiveDuration.seconds) / 3600);
	            this.data.cards.totalDuration = total.totalDuration.hours + Math.floor((total.totalDuration.minutes * 60 + total.totalDuration.seconds) / 3600);
	            this.data.cards.totalMeter = total.meter;
	        }
	    }, {
	        key: 'reloadSummary',
	        value: function reloadSummary() {
	            var _this3 = this;

	            this.App.setLoading(true);
	            this.Utils.getSummary({ organization: this.organization, group: this.group }).then(function (summary) {
	                _this3.summary = summary;
	                if (_this3.organization) {
	                    _this3.setCardsForOrganization(summary);
	                    _this3.setChartsForOrganization(summary);
	                } else {
	                    _this3.setCardsForProvider(summary);
	                    _this3.setChartsForProvider(summary);
	                }
	                _this3.App.setLoading(false);
	            }).catch(function () {
	                _this3.App.showNotification(_this3.$translate.instant('DASHBOARD.FAILED'), 'error');
	                _this3.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'onChargepointClick',
	        value: function onChargepointClick(chargepoint) {
	            this.$state.go('efimob.chargepoints.at.item', { 'id': chargepoint.id, 'organization': chargepoint.organizationId });
	        }
	    }, {
	        key: 'onChargeClick',
	        value: function onChargeClick(charge) {
	            this.$state.go('efimob.charges.at.item', { 'id': charge.id, 'organization': this.organization });
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload),
	            // TODO Temporarily disable autoreload option
	            // { tooltip: this.$translate.instant('DASHBOARD.BREADCRUMBS.AUTORELOAD'), isOn: () => this.state.autoReload.timer, onClick: this.toggleAutoReload, icon: 'stopwatch' }
	            this.App.getActionSearch(this.search)]);
	            this.App.setBreadcrumsCurrentScope({
	                organizationId: this.organization,
	                groupId: this.group,
	                custom: !this.organization ? this.$translate.instant('DASHBOARD.BREADCRUMBS.ALL_ORGANIZATIONS') : this.organization,
	                title: this.$translate.instant('DASHBOARD.BREADCRUMBS.OF')
	            });
	        }
	    }, {
	        key: 'setCardsForOrganization',
	        value: function setCardsForOrganization(summary) {
	            this.data.cards.totalChargepoints = summary.chargepoints.total;
	            this.data.cards.totalCharges = summary.chargingSessions.total;
	            this.data.cards.totalEffectiveDuration = _lodash2.default.get(summary.chargingSessions, 'totalEffectiveDuration.hours', 0);
	            this.data.cards.totalDuration = _lodash2.default.get(summary.chargingSessions, 'totalDuration.hours', 0);
	            this.data.cards.totalMeter = summary.chargingSessions.totalPower;
	            this.data.cards.totalActiveCharges = summary.chargingSessions.active || 0;
	        }
	    }, {
	        key: 'addConnectorStatus',
	        value: function addConnectorStatus(connectorsStatus, connectors, disconnectedConnectors) {
	            _lodash2.default.each(connectors, function (total, status) {
	                switch (status) {
	                    case 'Available':
	                        connectorsStatus[0] += total;
	                        break;
	                    case 'Preparing':
	                        connectorsStatus[1] += total;
	                        break;
	                    case 'Charging':
	                    case 'SuspendedEVSE':
	                    case 'SuspendedEV':
	                    case 'Finishing':
	                        connectorsStatus[2] += total;
	                        break;
	                    case 'Reserved':
	                        connectorsStatus[3] += total;
	                        break;
	                    case 'Unavailable':
	                        connectorsStatus[4] += total;
	                        break;
	                    case 'Faulted':
	                        connectorsStatus[5] += total;
	                        break;
	                    default:
	                        connectorsStatus[6] += total;
	                        break;
	                }
	            });
	            connectorsStatus[7] += _lodash2.default.reduce(disconnectedConnectors, function (sum, totalByStatus) {
	                return sum + totalByStatus;
	            }, 0);
	        }
	    }, {
	        key: 'setChartsForProvider',
	        value: function setChartsForProvider(data) {
	            var _this4 = this;

	            if (!data) return;
	            var organizations = [];
	            var organizationIds = [];
	            var chargepointsByOrganization = [];
	            var chargepointsConnected = [0, 0];
	            var connectorsStatus = [0, 0, 0, 0, 0, 0, 0, 0];

	            if (_lodash2.default.isArray(data.organizations) && (this.state.chargepointsProviderView === 'organizations' || this.state.chargepointsProviderView === 'all')) {
	                _lodash2.default.each(data.organizations, function (organization) {
	                    organizations.push(_lodash2.default.get(_this4.Cache.organization, organization.organizationId + '.name', organization.organizationId));
	                    organizationIds.push(organization.organizationId);
	                    chargepointsByOrganization.push(_lodash2.default.get(organization, 'summary.chargepoints.total', 0));
	                    chargepointsConnected[0] += _lodash2.default.get(organization, 'summary.chargepoints.connected.chargepoints', 0);
	                    chargepointsConnected[1] += _lodash2.default.get(organization, 'summary.chargepoints.total', 0) - _lodash2.default.get(organization, 'summary.chargepoints.connected.chargepoints', 0);
	                    _this4.addConnectorStatus(connectorsStatus, _lodash2.default.get(organization, 'summary.chargepoints.connected.connectors', {}), _lodash2.default.get(organization, 'summary.chargepoints.disconnected.connectors', {}));
	                });
	            }

	            this.data.charts.chargepointsByOrganizationPie.series = chargepointsByOrganization;
	            this.data.charts.chargepointsByOrganizationPie.labels = organizations;
	            this.data.charts.chargepointsByOrganizationPie.ids = organizationIds;
	            this.data.charts.chargepointsConnectedPie.series = chargepointsConnected;
	            this.data.charts.connectorsStatusPie.series = connectorsStatus;
	        }
	    }, {
	        key: 'reloadDisconnectedChargepoints',
	        value: function reloadDisconnectedChargepoints() {
	            var _this5 = this;

	            var options = {
	                params: { 'ocppConnection.connected': false },
	                pagination: this.tables.disconnectedChargepoints.pagination,
	                sorting: this.tables.disconnectedChargepoints.sorting,
	                organization: this.organization,
	                group: this.group
	            };
	            this.ChargePointsService.getChargepoints(options).then(function (chargepoints) {
	                _this5.data.tables.disconnectedChargepoints = chargepoints.docs;
	                _this5.tables.disconnectedChargepoints.pagination.currentPage = chargepoints.currentPage;
	                _this5.tables.disconnectedChargepoints.pagination.totalItems = chargepoints.totalItems;
	            });
	        }
	    }, {
	        key: 'reloadUnavailableChargepoints',
	        value: function reloadUnavailableChargepoints() {
	            var _this6 = this;

	            var options = {
	                params: { chargepointConnectorStatus: 'Faulted' },
	                pagination: this.tables.unavailableChargepoints.pagination,
	                sorting: this.tables.unavailableChargepoints.sorting,
	                organization: this.organization,
	                group: this.group
	            };
	            this.ChargePointsService.getChargepoints(options).then(function (chargepoints) {
	                _this6.data.tables.unavailableChargepoints = chargepoints.docs;
	                _this6.tables.unavailableChargepoints.pagination.currentPage = chargepoints.currentPage;
	                _this6.tables.unavailableChargepoints.pagination.totalItems = chargepoints.totalItems;
	            });
	        }
	    }, {
	        key: 'reloadGroups',
	        value: function reloadGroups() {
	            var _this7 = this;

	            if (this.group) {
	                this.GroupsService.getGroupDetail(this.group, { "organization": this.organization }).then(function (group) {
	                    return _this7.data.flattenedGroups = _this7.GroupsHelper.flatten(group.groups);
	                });
	            } else {
	                this.GroupsService.getGroups({ "organization": this.organization, "group": this.group }).then(function (groups) {
	                    return _this7.data.flattenedGroups = _this7.GroupsHelper.flatten(groups);
	                });
	            }
	        }
	    }, {
	        key: 'reloadChargesInPeriod',
	        value: function reloadChargesInPeriod() {
	            var _this8 = this;

	            var from = null;
	            var to = null;

	            switch (this.state.chargesPeriod) {
	                case 'today':
	                    from = this.moment().startOf('day');
	                    break;
	                case 'yesterday':
	                    from = this.moment().subtract(1, 'days').startOf('day');
	                    to = this.moment(from).add(1, 'days');
	                    break;
	                case 'last7Days':
	                    from = this.moment().subtract(6, 'days').startOf('day');
	                    break;
	                case 'currentWeek':
	                    from = this.moment().startOf('week');
	                    break;
	                case 'previousWeek':
	                    from = this.moment().subtract(7, 'days').startOf('week');
	                    to = this.moment(from).add(7, 'days');
	                    break;
	                case 'currentMonth':
	                    from = this.moment().startOf('month');
	                    break;
	                case 'previousMonth':
	                    from = this.moment().subtract(1, 'months').startOf('month');
	                    to = this.moment(from).add(1, 'months');
	                    break;
	                case 'currentYear':
	                    from = this.moment().startOf('year');
	                    break;
	                case 'previousYear':
	                    from = this.moment().subtract(1, 'years').startOf('year');
	                    to = this.moment(from).add(1, 'years');
	                    break;
	                case 'ever':
	                default:
	                    from = null;
	                    to = null;
	            }

	            var params = {};
	            if (from) params['start.dateTime.from'] = from.toISOString();
	            if (to) params['start.dateTime.to'] = to.toISOString();
	            if (this.organization) {
	                var desde = from ? from.toISOString() : undefined;
	                var hasta = to ? to.subtract(1, 'days').toISOString() : undefined;
	                this.data.cards.hrefChargesInPeriod = this.$state.href('efimob.charges.at.list', { organization: this.organization, desde: desde, hasta: hasta }, { absolute: true });
	            }

	            this.ChargeSessionsService.getDashboardCharges({ 'params': params, 'pagination': this.tables.lastCharges.pagination, 'sorting': this.tables.lastCharges.sorting, 'organization': this.organization, 'group': this.group }).then(function (charges) {
	                _this8.tables.lastCharges.pagination.currentPage = charges.currentPage === 0 ? 1 : charges.currentPage;
	                _this8.tables.lastCharges.pagination.totalItems = charges.totalItems;
	                _this8.data.tables.lastCharges = charges.docs;
	                _this8.data.cards.totalChargesInPeriod = charges.totalItems; //this.tables.lastCharges.pagination.totalItems;
	            });
	        }
	    }]);

	    return DashboardController;
	}();

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResetPasswordController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ResetPasswordController = exports.ResetPasswordController = function () {
	    ResetPasswordController.$inject = ["$state", "$stateParams", "$translate", "Auth", "App", "ENV"];
	    function ResetPasswordController($state, $stateParams, $translate, Auth, App, ENV) {
	        'ngInject';

	        _classCallCheck(this, ResetPasswordController);

	        this.Auth = Auth;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        this.App = App;
	        this.ENV = ENV;
	        this.password = '';
	        this.user = {};
	    }

	    _createClass(ResetPasswordController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            if (!this.$stateParams.token) {
	                this.App.showNotification(this.$translate.instant('RESET_PWD.FAILED_ACCESS'), 'error');
	                return this.$state.go('login');
	            }
	            this.autologin(this.$stateParams.token);
	        }
	    }, {
	        key: 'setPassword',
	        value: function setPassword() {
	            var _this = this;

	            this.Auth.setRecoveryPassword(this.password, this.$stateParams.token).then(function () {
	                return _this.$state.go('login');
	            }).catch(function (error) {
	                var errorKey = 'RESET_PWD.FAILED_SAVE';
	                if (error && error.status === 422 && error.data && _lodash2.default.isArray(error.data.errors) && error.data.errors[0]) {
	                    if (error.data.errors[0].subcode === 'TOO_SHORT_PASSWORD') errorKey = 'RESET_PWD.SET_PASSWORD.FAILED_TOO_SHORT';
	                    if (error.data.errors[0].subcode === 'UNSECURE_PASSWORD') errorKey = 'RESET_PWD.SET_PASSWORD.FAILED_SPECIAL_CHARACTERS_MISSING';
	                }
	                _this.App.showNotification(_this.$translate.instant(errorKey), 'error');
	            });
	        }
	    }, {
	        key: 'autologin',
	        value: function autologin(token) {
	            var _this2 = this;

	            this.Auth.recoveryAutologin(token).then(function (user) {
	                return _this2.user = user;
	            }).catch(function () {
	                _this2.App.showNotification(_this2.$translate.instant('RESET_PWD.FAILED_ACCESS'), 'error');
	                _this2.$state.go('login');
	            });
	        }
	    }]);

	    return ResetPasswordController;
	}();

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ForgotPasswordController = exports.ForgotPasswordController = function () {
	    ForgotPasswordController.$inject = ["$state", "$translate", "App", "Auth", "ENV"];
	    function ForgotPasswordController($state, $translate, App, Auth, ENV) {
	        'ngInject';

	        _classCallCheck(this, ForgotPasswordController);

	        this.$state = $state;
	        this.$translate = $translate;
	        this.App = App;
	        this.Auth = Auth;
	        this.ENV = ENV;
	        this.username = '';
	    }

	    _createClass(ForgotPasswordController, [{
	        key: 'forgotPassword',
	        value: function forgotPassword() {
	            var _this = this;

	            // var email = {
	            //     callback: $state.href('reset-password', {}, { absolute: true }),
	            //     from: App.config.email.from,
	            //     subject: 'Recuperación de contraseña',
	            //     preLinkBody: 'Hola,<br><br>En este enlace puedes acceder a tu cuenta y establecer una nueva contraseña:<br>',
	            //     postLinkBody: '<br>Gracias.' + App.config.email.signature,
	            // };

	            this.App.hideNotification();
	            this.Auth.resetPassword(this.username).then(function () {
	                return _this.App.showNotification(_this.$translate.instant('FORGOT_PWD.SUCCESS'));
	            }).catch(function () {
	                _this.App.showNotification(_this.$translate.instant('FORGOT_PWD.FAILED'), 'error');
	                _this.$state.go('login');
	            });
	        }
	    }]);

	    return ForgotPasswordController;
	}();

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ProfileController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ProfileController = exports.ProfileController = function () {
	    ProfileController.$inject = ["App", "Auth", "$scope", "$rootScope", "$stateParams", "$translate"];
	    function ProfileController(App, Auth, $scope, $rootScope, $stateParams, $translate) {
	        'ngInject';

	        _classCallCheck(this, ProfileController);

	        this.App = App;
	        this.Auth = Auth;
	        this.$scope = $scope;
	        this.$translate = $translate;
	        this.rootScope = $rootScope;
	        this.isTfaEnabled = false;
	        this.tab = $stateParams.tab;
	        this.properties = {};
	        this.tabs = {
	            'active': null,
	            'list': [],
	            'left': true
	        };

	        this.tables = {
	            permissions: App.getTable('permissions')
	        };
	        this.passwordLength = this.Auth.getPasswordLength();
	    }

	    _createClass(ProfileController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.reload = this.reload.bind(this);
	            this.setBreadcrums = this.setBreadcrums.bind(this);
	            this.setProperties();
	            this.setBreadcrums();
	            this.setTabs();
	            this.reload();
	            this.checkTfaStatus();
	        }
	    }, {
	        key: 'editProfile',
	        value: function editProfile(changed) {
	            return this.Auth.editProfile(changed).then(this.reload);
	        }
	    }, {
	        key: 'askToChangePassword',
	        value: function askToChangePassword() {
	            var _this = this;

	            this.modal = {
	                currentPassword: null,
	                newPassword: null,
	                passwordLength: this.passwordLength,
	                done: function done() {
	                    return _this.changePassword(_this.modal.newPassword, _this.modal.currentPassword);
	                }
	            };
	            this.App.openModal(this.$scope, 'change-password.html', this.modal);
	        }
	    }, {
	        key: 'changePassword',
	        value: function changePassword(newPassword, currentPassword) {
	            var _this2 = this;

	            this.Auth.setPassword(newPassword, currentPassword).then(function () {
	                _this2.App.showNotification(_this2.$translate.instant('PROFILE.CHANGE_PWD.SUCCESS'), 'ok');
	                _this2.App.closeModal();
	            }).catch(function (error) {
	                var errorKey = 'PROFILE.CHANGE_PWD.FAILED';
	                if (error && error.status === 422 && error.data && _lodash2.default.isArray(error.data.errors) && error.data.errors[0]) {
	                    if (error.data.errors[0].subcode === 'TOO_SHORT_PASSWORD') errorKey = 'PROFILE.CHANGE_PWD.FAILED_TOO_SHORT';
	                    if (error.data.errors[0].subcode === 'UNSECURE_PASSWORD') errorKey = 'PROFILE.CHANGE_PWD.FAILED_SPECIAL_CHARACTERS_MISSING';
	                }
	                _this2.App.showNotification(_this2.$translate.instant(errorKey, { passwordlength: _this2.passwordLength }), 'error');
	                _this2.App.closeModal();
	            });
	        }
	    }, {
	        key: 'checkTfaStatus',
	        value: function checkTfaStatus() {
	            var _this3 = this;

	            var fakeValue = '000000';
	            this.Auth.checkAuthcode(fakeValue).then(function (res) {
	                if (!res["status"]) {
	                    if (angular.isArray(res["error"]["errors"])) {
	                        res["error"]["errors"].some(function () {
	                            return _this3.isTfaEnabled = false;
	                        });
	                    }
	                    if (res["error"]["error"]) {
	                        if (res["error"]["error"]["code"] == 403 && res["error"]["error"]["subcode"] == 'INVALID_AUTH_CODE') {
	                            if (_this3.rootScope.user.tfaRequired) {
	                                return _this3.isTfaEnabled = true;
	                            } else {
	                                return _this3.isTfaEnabled = false;
	                            }
	                        } else {
	                            return _this3.isTfaEnabled = false;
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'showTfaSetup',
	        value: function showTfaSetup() {
	            var _this4 = this;

	            this.Auth.setupTfa().then(function (res) {
	                if (res["status"]) {
	                    _this4.modal = {
	                        'tempSecret': res.data.tempSecret,
	                        'dataUrl': res.data.dataURL,
	                        'authcode': null,
	                        'done': function done() {
	                            return _this4.tfaSetup(_this4.modal.authcode);
	                        }
	                    };
	                    _this4.App.openModal(_this4.$scope, 'tfa-setup.html', _this4.modal);
	                } else {
	                    if (angular.isArray(res["error"]["errors"])) {
	                        res["error"]["errors"].some(function () {
	                            _this4.App.showNotification(_this4.$translate.instant('PROFILE.TFA.SETUP_FAILED'), 'error');
	                        });
	                        return false;
	                    }
	                    if (res["error"]["error"]) {
	                        _this4.App.showNotification(_this4.$translate.instant('PROFILE.TFA.SETUP_FAILED'), 'error');
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'tfaSetup',
	        value: function tfaSetup(authcode) {
	            var _this5 = this;

	            this.Auth.checkAuthcode(authcode).then(function (res) {
	                if (res["status"]) {
	                    _this5.enableTfa();
	                } else {
	                    if (angular.isArray(res["error"]["errors"])) {
	                        res["error"]["errors"].some(function (error) {
	                            if (error["code"] == 403) {
	                                _this5.App.showNotification(_this5.$translate.instant('PROFILE.TFA.FAILED'), 'error');
	                            } else {
	                                _this5.App.showNotification(_this5.$translate.instant('PROFILE.TFA.CHECK_FAILED'), 'error');
	                            }
	                        });
	                        return false;
	                    }
	                    if (res["error"]["error"]) {
	                        if (res["error"]["error"]["code"] == 403) {
	                            return _this5.App.showNotification(_this5.$translate.instant('PROFILE.TFA.FAILED'), 'error');
	                        } else {
	                            return _this5.App.showNotification(_this5.$translate.instant('PROFILE.TFA.CHECK_FAILED'), 'error');
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'enableTfa',
	        value: function enableTfa() {
	            var _this6 = this;

	            this.Auth.enableDisableTfa(this.rootScope.user, true).then(function (res) {
	                if (res["status"]) {
	                    _this6.App.showNotification(_this6.$translate.instant('PROFILE.TFA.SUCCESS'), 'ok');
	                    _this6.checkTfaStatus();
	                    _this6.App.closeModal();
	                } else {
	                    if (angular.isArray(res["error"]["errors"])) {
	                        res["error"]["errors"].some(function () {
	                            _this6.App.showNotification(_this6.$translate.instant('PROFILE.TFA.PROFILE_UPDATE_FAILED'), 'error');
	                        });
	                        return false;
	                    }
	                    if (res["error"]["error"]) {
	                        _this6.App.showNotification(_this6.$translate.instant('PROFILE.TFA.PROFILE_UPDATE_FAILED'), 'error');
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'disableTfa',
	        value: function disableTfa() {
	            var _this7 = this;

	            this.Auth.enableDisableTfa(this.rootScope.user, false).then(function (res) {
	                if (res["status"]) {
	                    _this7.checkTfaStatus();
	                    return _this7.App.showNotification(_this7.$translate.instant('PROFILE.TFA.DO_DISABLE'), 'ok');
	                } else {
	                    if (angular.isArray(res["error"]["errors"])) {
	                        res["error"]["errors"].some(function () {
	                            _this7.App.showNotification(_this7.$translate.instant('PROFILE.TFA.PROFILE_UPDATE_FAILED'), 'error');
	                        });
	                        return false;
	                    }
	                    if (res["error"]["error"]) {
	                        _this7.App.showNotification(_this7.$translate.instant('PROFILE.TFA.PROFILE_UPDATE_FAILED'), 'error');
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'setTabs',
	        value: function setTabs() {
	            var list = [];
	            list.push({ 'id': 'info', 'display': this.$translate.instant('PROFILE.TABS.INFO'), 'url': 'info' });
	            list.push({ 'id': 'permissions', 'display': this.$translate.instant('PROFILE.TABS.PERMISSIONS'), 'url': 'permisos' });
	            var active = list[0];
	            if (this.tab && _lodash2.default.findIndex(list, { 'url': this.tab }) >= 0) active = list[_lodash2.default.findIndex(list, { 'url': this.tab })];
	            this.tabs['active'] = this.tabs['active'] || active;
	            this.tabs['list'] = list;
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            this.App.setBreadcrumsTitle(this.rootScope.user.displayName);
	            this.App.setBreadcrumsSteps([{ display: this.$translate.instant('PROFILE.BREADCRUMBS.PROFILE') }]);
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	        }
	    }, {
	        key: 'setProperties',
	        value: function setProperties() {
	            var _this8 = this;

	            this.properties = {
	                'general': {
	                    keys: ['username', 'displayName | safe', 'validated | yesno', 'lang | displayLang'],
	                    headers: [this.$translate.instant('PROFILE.INFO.EMAIL'), this.$translate.instant('PROFILE.INFO.NAME'), this.$translate.instant('PROFILE.INFO.VERIFIED_ACCOUNT'), this.$translate.instant('PROFILE.INFO.LANG')],
	                    meta: {
	                        'lang': {
	                            type: 'select',
	                            options: [{ 'display': this.$translate.instant('COMMON.LANG_ES'), 'id': 'es' }, { 'display': this.$translate.instant('COMMON.LANG_EN'), 'id': 'en' }, { 'display': this.$translate.instant('COMMON.LANG_GL'), 'id': 'gl' }, { 'display': this.$translate.instant('COMMON.LANG_PT'), 'id': 'pt' }]
	                        }
	                    },
	                    editable: ['displayName', 'lang'],
	                    onSave: function onSave(changes) {
	                        return _this8.editProfile(changes.changed);
	                    }
	                },
	                'right': {
	                    keys: ['username', 'displayName | safe'],
	                    headers: [this.$translate.instant('PROFILE.INFO.EMAIL'), this.$translate.instant('PROFILE.INFO.NAME')]
	                }
	            };
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this9 = this;

	            this.setProperties();
	            this.setTabs();
	            this.App.setLoading(true);
	            this.Auth.me().then(function () {
	                _this9.App.setLoading(false);
	                _this9.setBreadcrums();
	            }).catch(function () {
	                return _this9.App.setLoading(false);
	            });
	        }
	    }]);

	    return ProfileController;
	}();

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SignUpController = exports.SignUpController = function () {
	    SignUpController.$inject = ["$state", "App", "Auth", "UsersService", "ENV"];
	    function SignUpController($state, App, Auth, UsersService, ENV) {
	        'ngInject';

	        _classCallCheck(this, SignUpController);

	        this.$state = $state;
	        this.App = App;
	        this.Auth = Auth;
	        this.UsersService = UsersService;
	        this.ENV = ENV;

	        this.username = '';
	        this.displayName = '';
	        this.password = '';
	    }

	    _createClass(SignUpController, [{
	        key: 'signup',
	        value: function signup() {
	            var _this = this;

	            this.App.hideNotification();
	            var extra = {
	                displayName: this.displayName
	            };

	            this.UsersService.createUser(this.username, this.password, { extra: extra }).then(function (user) {
	                return _this.Auth.setUser(user, true);
	            }).then(function () {
	                return _this.$state.go('efimob.home');
	            }).catch(function (err) {
	                if (err.code === 409) _this.App.showNotification('Este usuario ya existe', 'error');else _this.App.showNotification('No hemos podido registrarte', 'error');
	            });
	        }
	    }]);

	    return SignUpController;
	}();

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.WelcomeController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var WelcomeController = exports.WelcomeController = function () {
	    WelcomeController.$inject = ["$state", "$stateParams", "$translate", "$timeout", "App", "Auth", "ENV"];
	    function WelcomeController($state, $stateParams, $translate, $timeout, App, Auth, ENV) {
	        'ngInject';

	        _classCallCheck(this, WelcomeController);

	        this.$stateParams = $stateParams;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.$timeout = $timeout;

	        this.App = App;
	        this.Auth = Auth;
	        this.ENV = ENV;

	        this.input = { password: null };
	        this.result = parseInt($stateParams.result, 10);
	        this.user = undefined;
	    }

	    _createClass(WelcomeController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.autologin();
	        }
	    }, {
	        key: 'setPassword',
	        value: function setPassword() {
	            var _this = this;

	            this.Auth.setWelcomePassword(this.input.password, this.$stateParams.token).then(function () {
	                return _this.$state.go('efimob.home');
	            }).catch(function (error) {
	                var errorKey = 'WELCOME.FAILED_SAVE';
	                if (error && error.status === 422 && error.data && _lodash2.default.isArray(error.data.errors) && error.data.errors[0]) {
	                    if (error.data.errors[0].subcode === 'TOO_SHORT_PASSWORD') errorKey = 'WELCOME.SET_PASSWORD.FAILED_TOO_SHORT';
	                    if (error.data.errors[0].subcode === 'UNSECURE_PASSWORD') errorKey = 'WELCOME.SET_PASSWORD.FAILED_SPECIAL_CHARACTERS_MISSING';
	                }
	                _this.App.showNotification(_this.$translate.instant(errorKey), 'error');
	            });
	        }
	    }, {
	        key: 'autologin',
	        value: function autologin() {
	            var _this2 = this;

	            // Probably user has already changed his/her password so token is not valid anymore.
	            // Redirect to login page
	            if (this.result === 401 || this.result === 403) {
	                this.App.showNotification(this.$translate.instant('WELCOME.MAYBE_PASSWORD_CHANGED'), 'ok');
	                return this.$state.go('login');
	            }
	            // Another not contempled errors also redirect to login
	            if (this.result !== 200 || !this.$stateParams.token) {
	                this.App.showNotification(this.$translate.instant('WELCOME.FAILED_ACCESS'), 'error');
	                return this.$state.go('login');
	            }
	            // OK, do autologin using token passed as search parameter
	            // $timeout(function(){
	            this.Auth.welcomeAutologin(this.$stateParams.token).then(function (user) {
	                return _this2.user = user;
	            });
	            // }, 10000);
	        }
	    }]);

	    return WelcomeController;
	}();

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserKeysController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UserKeysController = exports.UserKeysController = function () {
	  UserKeysController.$inject = ["$scope", "$state", "$stateParams", "$translate", "moment", "App", "Auth", "UserKeyHelper", "UsersService", "GroupsService", "GroupsHelper"];
	  function UserKeysController($scope, $state, $stateParams, $translate, moment, App, Auth, UserKeyHelper, UsersService, GroupsService, GroupsHelper) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, UserKeysController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.moment = moment;
	    this.App = App;
	    this.Auth = Auth;
	    this.UserKeyHelper = UserKeyHelper;
	    this.UsersService = UsersService;
	    this.GroupsService = GroupsService;
	    this.GroupsHelper = GroupsHelper;

	    this.organization = $stateParams.organization || null;
	    this.group = {
	      id: angular.isDefined($stateParams.zona) ? null : $stateParams.group || null,
	      name: $stateParams.groupName || null
	    };
	    this.userkeys = null;

	    // Filters
	    var omit = [];
	    if (!this.organization) {
	      omit.push('master');
	      omit.push('group');
	    }
	    if (this.group.id && angular.isUndefined($stateParams.zona) && !omit.includes('group')) {
	      omit.push('group');
	    }
	    this.filters = App.getTableFilters('userKey', { context: this, omit: omit });
	    this.filterControls = {};

	    // Table settings
	    if (!this.group.id) {
	      // For organization
	      this.table = _lodash2.default.defaults({}, {
	        actions: [{
	          tooltip: this.$translate.instant('USERKEYS.ASSIGN_TO_CUSTOMER'),
	          icon: App.icon.customer,
	          onlyIf: function onlyIf(userkey) {
	            return userkey.customerId === null;
	          },
	          onClick: function onClick(userkey) {
	            return UserKeyHelper.askToBindToCustomer($scope, [userkey.userKeyId], {
	              organization: _this.organization
	            }).then(_this.reload);
	          }
	        }]
	      }, App.getTable('userkeys', { omit: ['organizationId', 'chargepointName'] }));
	    } else {
	      // For group
	      this.table = App.getTable('userkeys', { omit: ['organizationId', 'customerName'] });
	    }
	  }

	  _createClass(UserKeysController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.onUserkeyClick = this.onUserkeyClick.bind(this);
	      this.toggleAdvancedFilters = this.toggleAdvancedFilters.bind(this);
	      this.reload = this.reload.bind(this);

	      this.setBreadcrums();
	      this.reload();
	    }
	  }, {
	    key: 'isAdmin',
	    value: function isAdmin() {
	      return this.Auth.isAdmin();
	    }
	  }, {
	    key: 'onUserkeyClick',
	    value: function onUserkeyClick(userkey) {
	      this.$state.go('efimob.userkeys.at.item', { id: userkey.userKeyId, organization: this.organization });
	    }
	  }, {
	    key: 'toggleAdvancedFilters',
	    value: function toggleAdvancedFilters() {
	      if (this.filterControls.toggleAdvancedFilters) {
	        this.filterControls.toggleAdvancedFilters();
	      }
	    }
	  }, {
	    key: 'exportUserkeys',
	    value: function exportUserkeys() {
	      var _this2 = this;

	      var options = {
	        filters: this.filters,
	        params: { output: 'csv', count: this.table.pagination.totalItems },
	        sorting: this.table.sorting,
	        organization: this.organization
	      };
	      this.UsersService.getUserKeys(options, false, true).then(function ( /** @type {{docs: Blob, emailExport: boolean}} */userkeys) {
	        if (userkeys.emailExport) {
	          return _this2.App.showNotification(_this2.$translate.instant('EXPORT_BY_EMAIL'), 'ok');
	        }
	        _this2.App.downloadCSV(userkeys.docs, _this2.$translate.instant('USERKEYS.USERKEYS') + '-' + _this2.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      }).catch(function () {
	        return _this2.App.showNotification(_this2.$translate.instant('USERKEYS.EXPORT_FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'askToAddUserkey',
	    value: function askToAddUserkey() {
	      var _this3 = this;

	      return this.UserKeyHelper.addUserKey(this.$scope, {}, { organizationId: this.organization, group: this.group }).then(function () {
	        _this3.reload();
	        _this3.App.showNotification(_this3.$translate.instant('ADD_KEY_SUCCESS'));
	        _this3.App.closeModal();
	      }).catch(function (error) {
	        _this3.App.showNotification(error, 'error');
	        _this3.App.closeModal();
	      });
	    }
	  }, {
	    key: 'setBreadcrums',
	    value: function setBreadcrums() {
	      if (this.organization && this.group.id) {
	        this.App.setBreadcrumsTitle(this.$translate.instant('USERKEYS.AUTHORIZED_KEYS'));
	      }
	      this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	      if (this.organization) {
	        if (this.group.id) {
	          this.App.setBreadcrumsCurrentScope({
	            organizationId: this.organization,
	            groupId: this.group.id,
	            custom: undefined,
	            title: this.$translate.instant('USERKEYS.FOR')
	          });
	        } else {
	          this.App.setBreadcrumsCurrentScope({
	            organizationId: this.organization,
	            groupId: this.group.id,
	            custom: this.organization,
	            title: this.$translate.instant('USERKEYS.OF')
	          });
	        }
	      } else {
	        this.App.setBreadcrumsCurrentScope({
	          organizationId: this.organization,
	          groupId: this.group.id,
	          custom: this.$translate.instant('USERKEYS.NOT_ASSIGNED')
	        });
	      }
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      var _this4 = this;

	      var options = {
	        filters: this.filters,
	        pagination: this.table.pagination,
	        sorting: this.table.sorting,
	        organization: this.organization,
	        group: this.group.id
	      };

	      this.App.setLoading(true);

	      var group = this.filters.find(function (d) {
	        return d.id === 'group';
	      });
	      if (group && group.value !== 'all') {
	        if (group.value === group.valueName) {
	          return this.searchGroupByName(group.value).then(function (groupId) {
	            options.group = groupId;
	            return _this4.getUserKeys(options);
	          });
	        } else {
	          options.group = group.value;
	          return this.getUserKeys(options);
	        }
	      }

	      return this.getUserKeys(options);
	    }
	  }, {
	    key: 'searchGroupByName',
	    value: function searchGroupByName(name) {
	      var _this5 = this;

	      return this.GroupsService.getGroups({ organization: this.organization, group: this.group.id }).then(function (groups) {
	        var flattenedGroups = _this5.GroupsHelper.flatten(groups);
	        var currentGroup = flattenedGroups.find(function (d) {
	          return d.name === name;
	        });
	        if (currentGroup) {
	          return currentGroup.id;
	        }
	      });
	    }
	  }, {
	    key: 'getUserKeys',
	    value: function getUserKeys(options) {
	      var _this6 = this;

	      return this.UsersService.getUserKeys(options).then(function (data) {
	        var aux = data.docs;
	        //Warning: Exceptional case when filter 'group' is applied because response does not follow expected attributes
	        if (aux.length > 0 && aux[0].userKey && angular.isObject(aux[0].userKey)) {
	          aux = _lodash2.default.map(aux, 'userKey');
	        }
	        _this6.userkeys = aux;
	        _this6.table.pagination.currentPage = data.currentPage;
	        _this6.table.pagination.totalItems = data.totalItems;
	        _this6.App.setLoading(false);
	      }).catch(function () {
	        _this6.userkeys = [];
	        _this6.App.setLoading(false);
	      });
	    }
	  }]);

	  return UserKeysController;
	}();

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UserKeyController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var UserKeyController = exports.UserKeyController = function () {
	    UserKeyController.$inject = ["$scope", "$rootScope", "$state", "$stateParams", "$translate", "moment", "App", "UserKeyHelper", "ChargeHelper", "UsersService", "GroupsService", "ChargeSessionsService", "Auth"];
	    function UserKeyController($scope, $rootScope, $state, $stateParams, $translate, moment, App, UserKeyHelper, ChargeHelper, UsersService, GroupsService, ChargeSessionsService, Auth) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, UserKeyController);

	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$state = $state;
	        this.$translate = $translate;
	        this.moment = moment;
	        this.App = App;
	        this.UserKeyHelper = UserKeyHelper;
	        this.ChargeHelper = ChargeHelper;
	        this.UsersService = UsersService;
	        this.GroupsService = GroupsService;
	        this.ChargeSessionsService = ChargeSessionsService;
	        this.Auth = Auth;
	        this.id = $stateParams.id;
	        this.userkey = null;
	        this.organization = $stateParams.organization;
	        this.tab = $stateParams.tab;

	        // Properties panel settings
	        this.properties = {
	            'general': {
	                keys: ['userKeyId', 'activeFrom | toDate', 'activeTo | toDate', 'master | yesno', 'origin | capitalize', 'type', 'roamingInfo.roamingOrganizationName | empty', 'externalId', 'priority | uppercase | translate'],
	                headers: [this.$translate.instant('USERKEY.ID'), this.$translate.instant('USERKEY.ACTIVE_SINCE'), this.$translate.instant('USERKEY.EXPIRATION_DATE'), this.$translate.instant('USERKEY.MASTER'), this.$translate.instant('COMMON.ORIGIN'), this.$translate.instant('TYPE'), this.$translate.instant('ROAMING_ORGANIZATION'), this.$translate.instant('EXTERNAL_ID'), this.$translate.instant('PRIORITY')],
	                editable: ['activeTo'],
	                meta: {
	                    activeTo: {
	                        type: 'calendar',
	                        adaptFrom: function adaptFrom(data) {
	                            var slicedDate = new Date(data.slice(0, 16));
	                            var tzOffset = slicedDate.getTimezoneOffset();
	                            var offsetMillis = tzOffset * 60 * 1000;
	                            return new Date(slicedDate - offsetMillis);
	                        },
	                        adaptTo: function adaptTo(data) {
	                            return data.toISOString();
	                        },
	                        min: new Date(Date.now()).toISOString().slice(0, 16)
	                    },
	                    priority: {
	                        type: 'select',
	                        options: [{ display: this.$translate.instant('STANDARD'), id: 'Standard' }, { display: this.$translate.instant('HIGH'), id: 'High' }]
	                    }
	                },
	                isKeyRestricted: function isKeyRestricted(key) {
	                    var res = void 0;
	                    switch (key) {
	                        case 'priority':
	                            res = _this.Auth.isAdminOfOrganization() || _this.Auth.isProvider();
	                            break;
	                    }
	                    return res;
	                },
	                onSave: function onSave(changes) {
	                    return _this.editUserKey(changes.changed);
	                }
	            },
	            'right': {
	                keys: ['userKeyId', 'customerName | userkeyCustomer:ctrl.item', 'activeFrom | toDate', 'activeTo | toDate', 'blocked | not | yesno', 'master | yesno'],
	                headers: [this.$translate.instant('USERKEY.ID'), this.$translate.instant('USERKEY.CUSTOMER'), this.$translate.instant('USERKEY.ACTIVE_SINCE'), this.$translate.instant('USERKEY.EXPIRATION_DATE'), this.$translate.instant('USERKEY.ACTIVE'), this.$translate.instant('USERKEY.MASTER')]
	            },
	            'state': {
	                keys: ['blocked | not | yesno'],
	                headers: [this.$translate.instant('USERKEY.ACTIVE')]
	            },
	            'master': {
	                keys: ['master | yesno'],
	                headers: [this.$translate.instant('USERKEY.MASTER_KEY')]
	            },
	            'prepaid': {
	                keys: ['(maxAmountAllowed === 0) | not | yesno'],
	                headers: [this.$translate.instant('PREPAID')],
	                meta: {
	                    maxAmountAllowed: {
	                        type: 'number',
	                        required: true,
	                        step: 0,
	                        min: 0,
	                        conflict: {
	                            message: 'MAX_AMOUNT_ALLOWED_GREATER_THAN_CONSUMED_AMOUNT',
	                            data: null
	                        },
	                        onChange: function onChange(data, config, input) {
	                            var maxAmountAllowed = data.model.value;
	                            var consumedAmount = input.find(function (obj) {
	                                return obj.key === 'consumedAmount';
	                            }).value;
	                            var valid = maxAmountAllowed > consumedAmount && maxAmountAllowed > 0;
	                            config.conflict.data = valid ? null : true;
	                            return data;
	                        }
	                    }
	                },
	                onSave: function onSave(changes) {
	                    var payload = _lodash2.default.assign({}, changes.changed, {
	                        idToken: _this.userkey.idToken
	                    });
	                    return _this.editUserKey(payload);
	                }
	            }
	        };

	        // Tabs settings
	        this.tabs = {
	            'active': null,
	            'list': [],
	            'left': true

	            // Filters settings
	        };this.filters = {
	            charges: App.getTableFilters("charge", { 'omit': ['start.userKeyId.ilike'] })

	            // Tables settings
	        };this.tables = {
	            'groups': {
	                'keys': ['id | userkeyAdminGroup:item', ' enabled | yesno'],
	                'headers': [this.$translate.instant('USERKEY.GROUP'), this.$translate.instant('USERKEY.AUTHORIZED')],
	                'synchronous': true,
	                'compact': true,
	                'pagination': App.getPagination(10),
	                'sorting': App.getSorting(['id'], undefined, undefined, { 'types': { 'id': 'string' } }),
	                'actions': [{
	                    'tooltip': this.$translate.instant('USERKEY.REVOKE_AUTH'),
	                    'icon': 'ban',
	                    'onClick': function onClick(group) {
	                        return _this.removeGroup(group);
	                    }
	                }]
	            },
	            'charges': App.getTable('charges', { omit: ['start.userKeyId'] })
	        };
	    }

	    _createClass(UserKeyController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;

	            this.reload = this.reload.bind(this);
	            this.onGroupClick = this.onGroupClick.bind(this);
	            this.reloadCharges = this.reloadCharges.bind(this);

	            this.$scope.$watch('ctrl.userkey', function () {
	                if (_this2.userkey) {
	                    _this2.setTabs();
	                    _this2.enablePrepaidAmountFields();
	                }
	            });

	            this.$scope.$watch('ctrl.tabs.active', function () {
	                if (_this2.tabs.active) {
	                    switch (_this2.tabs.active.id) {
	                        case 'charges':
	                            _this2.reloadCharges();
	                            break;
	                    }
	                }
	            });
	            this.setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: 'showPrepaidSection',
	        value: function showPrepaidSection() {
	            if (!this.userkey) return false;
	            var isRFID = this.userkey.type === 'RFID';
	            var isAdminOfOrgAndProvider = this.Auth.isAdminOfOrganization() || this.Auth.isAdminOfProvider();

	            return isRFID && isAdminOfOrgAndProvider;
	        }
	    }, {
	        key: 'askToChangeOrganization',
	        value: function askToChangeOrganization() {
	            var _this3 = this;

	            this.UserKeyHelper.askToAssignToOrganization(this.$scope, [this.userkey.userKeyId]).then(function (newTarget) {
	                return _this3.$state.go('efimob.userkeys.at.item', { 'id': _this3.userkey.userKeyId, 'organization': newTarget.organization });
	            });
	        }
	    }, {
	        key: 'askToBindToCustomer',
	        value: function askToBindToCustomer() {
	            this.UserKeyHelper.askToBindToCustomer(this.$scope, [this.userkey.userKeyId], { organization: this.organization }).then(this.reload);
	        }
	    }, {
	        key: 'askToUnbind',
	        value: function askToUnbind() {
	            var _this4 = this;

	            return new Promise(function (resolve) {
	                _this4.$scope.modal = {
	                    userkey: _this4.userkey,
	                    done: function done() {
	                        return resolve(_this4.unbind());
	                    }
	                };
	                _this4.App.openModal(_this4.$scope, 'unbind-userkey.html');
	            });
	        }
	    }, {
	        key: 'unbind',
	        value: function unbind() {
	            var _this5 = this;

	            return this.UsersService.unbindUserkeyToCustomer(this.userkey.userKeyId, this.userkey.customerId, { organization: this.userkey.organizationId }).then(function () {
	                _this5.reload();
	                _this5.App.closeModal();
	            }).catch(function () {
	                _this5.App.showNotification(_this5.$translate.instant('USERKEY.UNBIND.FAILED', { id: '<strong>' + _this5.userkey.userKeyId + '</strong>' }), 'error');
	                _this5.App.closeModal();
	            });
	        }
	    }, {
	        key: 'askToToggleBlocked',
	        value: function askToToggleBlocked() {
	            var _this6 = this;

	            this.$scope.modal = {
	                userkey: this.userkey,
	                done: function done() {
	                    return _this6.toggleBlocked();
	                }
	            };
	            this.App.openModal(this.$scope, 'set-userkey-blocked.html');
	        }
	    }, {
	        key: 'toggleBlocked',
	        value: function toggleBlocked() {
	            var _this7 = this;

	            this.UsersService.editUserkey(this.userkey.userKeyId, { 'blocked': !this.userkey.blocked }, { organization: this.organization }).then(function () {
	                _this7.reload();
	                _this7.App.closeModal();
	            }).catch(function () {
	                _this7.App.showNotification(_this7.$translate.instant(_this7.userkey.blocked ? 'USERKEY.BLOCK.UNLOCK_FAILED' : 'USERKEY.BLOCK.LOCK_FAILED', { id: '<strong>' + _this7.userkey.userKeyId + '</strong>' }), 'error');
	                _this7.App.closeModal();
	            });
	        }
	    }, {
	        key: 'toggleMaster',
	        value: function toggleMaster() {
	            var _this8 = this;

	            this.UsersService.editUserkey(this.userkey.userKeyId, { 'master': !this.userkey.master }, { organization: this.organization }).then(function () {
	                _this8.reload();
	                _this8.App.closeModal();
	            }).catch(function () {
	                _this8.App.showNotification(_this8.$translate.instant(_this8.userkey.master ? 'USERKEY.UNSET_MASTER_FAILED' : 'USERKEY.SET_MASTER_FAILED', { id: '<strong>' + _this8.userkey.userKeyId + '</strong>' }), 'error');
	                _this8.App.closeModal();
	            });
	        }
	    }, {
	        key: 'canAdminUserkey',
	        value: function canAdminUserkey() {
	            return (this.$rootScope.role.entity === 'provider' || this.$rootScope.role.entity === 'organization' || this.$rootScope.role.entity === 'group') && this.$rootScope.role.role === 'admin';
	        }
	    }, {
	        key: 'askToRemoveUserkey',
	        value: function askToRemoveUserkey() {
	            this.$scope.modal = {
	                userkey: this.userkey
	            };
	            this.App.openModal(this.$scope, 'remove-userkey.html', { 'size': 'md' });
	        }
	    }, {
	        key: 'removeUserkey',
	        value: function removeUserkey() {
	            var _this9 = this;

	            this.UsersService.removeUserkey(this.userkey.userKeyId, { organization: this.organization }).then(function () {
	                _this9.App.showNotification(_this9.$translate.instant('USERKEY.REMOVE.OK', { id: '<accent>' + _this9.userkey.userKeyId + '</accent>' }), 'ok', null, 1000);
	                _this9.$state.go('efimob.userkeys.at.list', { organization: _this9.organization });
	                _this9.App.closeModal();
	            }).catch(function (res) {
	                var msg = void 0;
	                if (res.status === 403) {
	                    msg = _this9.$translate.instant('USERKEY.REMOVE.FAILED_403');
	                }
	                _this9.App.showNotification(msg || _this9.$translate.instant('USERKEY.REMOVE.FAILED'), 'error');
	                _this9.App.closeModal();
	            });
	        }
	    }, {
	        key: 'onGroupClick',
	        value: function onGroupClick(group) {
	            this.$state.go('efimob.groups.item', { 'id': group.id, 'organization': this.organization });
	        }
	    }, {
	        key: 'removeGroup',
	        value: function removeGroup(group) {
	            var _this10 = this;

	            this.UsersService.removeUserkeyFromGroup(this.userkey.userKeyId, group.id, { organization: this.organization }).then(function () {
	                return _this10.reload();
	            }).catch(function () {
	                return _this10.App.showNotification(_this10.$translate.instant('USERKEY.REMOVE_GROUP_FAILED', { name: '<strong>' + group.id + '</strong>' }), 'error');
	            });
	        }
	    }, {
	        key: 'askToAddGroup',
	        value: function askToAddGroup() {
	            var _this11 = this;

	            return this.UserKeyHelper.addLocation(this.$scope, { userkey: this.userkey }, { organizationId: this.organization }).then(function (locationId) {
	                _this11.reload();
	                _this11.App.showNotification(_this11.$translate.instant('USERKEY.ADD_GROUP_OK', { name: '<strong>' + locationId + '</strong>' }));
	                _this11.App.closeModal();
	            }).catch(function (locationId) {
	                _this11.App.showNotification(_this11.$translate.instant('USERKEY.ADD_GROUP_FAILED', { id: '<strong>' + _this11.userkey.userKeyId + '</strong>', name: '<strong>' + locationId + '</strong>' }), 'error');
	                _this11.App.closeModal();
	            });
	        }
	    }, {
	        key: 'onChargeClick',
	        value: function onChargeClick(charge) {
	            this.$state.go('efimob.charges.at.item', { 'id': charge.id, 'organization': this.organization });
	        }
	    }, {
	        key: 'exportCharges',
	        value: function exportCharges() {
	            var _this12 = this;

	            var options = {
	                filters: this.filters.charges,
	                sorting: this.tables.charges.sorting,
	                organization: this.organization,
	                params: { output: 'csv', count: this.tables.charges.pagination.totalItems }
	            };
	            this.ChargeSessionsService.getChargesByUserkey(this.userkey.userKeyId, options, false, true).then(function ( /** @type {{docs: Blob, emailExport: boolean}} */charges) {
	                if (charges.emailExport) {
	                    return _this12.App.showNotification(_this12.$translate.instant('EXPORT_BY_EMAIL'), 'ok');
	                }
	                _this12.App.downloadCSV(charges.docs, _this12.$translate.instant('USERKEY.EXPORT_CHARGES_FILE_PREFIX') + '-' + _this12.userkey.userKeyId + '-' + _this12.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	            });
	        }
	    }, {
	        key: 'reloadCharges',
	        value: function reloadCharges() {
	            var _this13 = this;

	            this.App.setLoading(true);
	            this.ChargeSessionsService.getChargesByUserkey(this.userkey.userKeyId, { filters: this.filters.charges, pagination: this.tables.charges.pagination, sorting: this.tables.charges.sorting, organization: this.organization }).then(function (charges) {
	                _this13.charges = charges.docs;
	                _this13.tables.charges.pagination.currentPage = charges.currentPage;
	                _this13.tables.charges.pagination.totalItems = charges.totalItems;
	                _this13.App.setLoading(false);
	            }).catch(function () {
	                return _this13.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'setTabs',
	        value: function setTabs() {
	            var _this14 = this;

	            var list = [];
	            list.push({ 'id': 'info', 'display': this.$translate.instant('USERKEY.TABS.INFO'), 'url': 'info' });
	            if (this.organization) {
	                list.push({
	                    'id': 'groups',
	                    'display': this.$translate.instant('USERKEY.TABS.GROUPS'),
	                    'url': 'zonas',
	                    count: function count() {
	                        return _this14.userkey.groups.length;
	                    }
	                });
	            }
	            list.push({
	                'id': 'charges',
	                'display': this.$translate.instant('USERKEY.TABS.CHARGES'),
	                'url': 'recargas',
	                count: function count() {
	                    return _this14.charges ? _this14.tables.charges.pagination.totalItems : '...';
	                }
	            });
	            var active = list[0];
	            var index = _lodash2.default.findIndex(list, { 'url': this.tab });
	            if (this.tab && index >= 0) active = list[index];
	            this.tabs['active'] = this.tabs['active'] || active;
	            this.tabs['list'] = list;
	        }
	    }, {
	        key: 'enablePrepaidAmountFields',
	        value: function enablePrepaidAmountFields() {
	            if (this.userkey.type !== 'RFID') return;
	            if (!this.userkey.maxAmountAllowed) return;
	            if (this.properties.prepaid.isEditableFlagOnly) return;

	            var prepaid = this.properties.prepaid;
	            prepaid.keys.push('consumedAmount | number', 'maxAmountAllowed | number');
	            prepaid.headers.push(this.$translate.instant('CONSUMED_AMOUNT'), this.$translate.instant('MAX_AMOUNT_ALLOWED'));
	            prepaid.editable = ['maxAmountAllowed'];
	            prepaid.isEditableFlagOnly = true;
	        }
	    }, {
	        key: 'getBreadcrumStatus',
	        value: function getBreadcrumStatus(userkey) {
	            if (!userkey) return [];
	            var status = [];
	            if (!this.UserKeyHelper.isBlocked(userkey)) {
	                if (this.UserKeyHelper.isInActivePeriod(userkey)) {
	                    status.push({ icon: 'check', tooltip: this.$translate.instant('USERKEY.STATUS.ACTIVE'), type: 'good' });
	                } else {
	                    status.push({ icon: 'calendar-exclamation', tooltip: this.$translate.instant('USERKEY.STATUS.NOT_ACTIVE'), type: 'warning' });
	                }
	            } else {
	                status.push({ icon: 'exclamation', tooltip: this.$translate.instant('USERKEY.STATUS.BLOCKED'), type: 'bad' });
	            }
	            if (userkey.master) {
	                status.push({ display: this.$translate.instant('USERKEY.STATUS.MASTER'), tooltip: this.$translate.instant('USERKEY.STATUS.MASTER_HINT'), type: 'neutral' });
	            }
	            return status;
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            if (this.userkey) this.App.setBreadcrumsTitle(this.$translate.instant('USERKEY.KEY', { id: this.userkey.idToken }));
	            var backHref = this.$state.href('efimob.userkeys.at.list', { organization: this.organization });
	            this.App.setBreadcrumsSteps([{ display: this.$translate.instant('USERKEY.KEYS'), href: backHref }]);
	            this.App.setBreadcrumsStatus(this.getBreadcrumStatus(this.userkey));
	            this.App.setBreadcrumsRightActions([this.App.getActionBack(backHref, this.$translate.instant('USERKEY.BACK_TO_KEYS')), this.App.getActionReload(this.reload)]);
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this15 = this;

	            this.App.setLoading(true);
	            this.UsersService.getUserkey(this.id, { organization: this.organization }).then(function (userkey) {
	                _this15.userkey = userkey;
	                _this15.userkey.groups = _lodash2.default.map(_this15.userkey.groups, function (group) {
	                    return {
	                        'id': group.id,
	                        'enabled': true,
	                        'name': group.name,
	                        'organizationId': _this15.userkey.organizationId
	                    };
	                });
	                _this15.setBreadcrums();
	                _this15.App.setLoading(false);
	            }).catch(function () {
	                _this15.setBreadcrums();
	                _this15.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'editUserKey',
	        value: function editUserKey(changed) {
	            var _this16 = this;

	            if (changed) {
	                return this.UsersService.putUserkey(this.userkey.userKeyId, changed, {
	                    organization: this.organization,
	                    notifications: true
	                }).then(function () {
	                    _this16.reload();
	                });
	            }
	        }
	    }]);

	    return UserKeyController;
	}();

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SettingsController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var SettingsController = exports.SettingsController = function () {
	    SettingsController.$inject = ["$scope", "$stateParams", "App", "UsersHelper", "$filter", "$translate", "ProvidersService", "ProvidersHelperService", "ChargePointsService", "Auth", "moment"];
	    function SettingsController($scope, $stateParams, App, UsersHelper, $filter, $translate, ProvidersService, ProvidersHelperService, ChargePointsService, Auth, moment) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, SettingsController);

	        this.App = App;
	        this.UsersHelper = UsersHelper;
	        this.$filter = $filter;
	        this.$translate = $translate;
	        this.$scope = $scope;
	        this.ProvidersService = ProvidersService;
	        this.ProvidersHelperService = ProvidersHelperService;
	        this.ChargePointsService = ChargePointsService;
	        this.Auth = Auth;
	        this.moment = moment;

	        this.provider = null;
	        this.privateData = null;
	        this.roles = null;
	        this.proxies = null;
	        this.holidays = null;
	        this.tab = $stateParams.tab;

	        // Properties panel settings
	        this.properties = {
	            general: {
	                keys: ['id', 'name'],
	                headers: [this.$translate.instant('SETTINGS.INFO.ID'), this.$translate.instant('SETTINGS.INFO.NAME')]
	            },
	            right: {
	                keys: ['id', 'name'],
	                headers: [this.$translate.instant('SETTINGS.INFO.ID'), this.$translate.instant('SETTINGS.INFO.NAME')]
	            },
	            contact: {
	                keys: ['general.owner'],
	                headers: [this.$translate.instant('SETTINGS.INFO.OWNER')]
	            }
	        };

	        // Tabs settings
	        this.tabs = {
	            active: null,
	            list: [],
	            left: true

	            // Tables settings
	        };this.tables = {
	            permissions: App.getTable('permissions'),
	            roles: _lodash2.default.defaults({}, App.getTable('roles'), {
	                actions: [{
	                    tooltip: this.$translate.instant('SETTINGS.USERS.CHANGE_PERMISSIONS'),
	                    icon: 'edit',
	                    onlyIf: function onlyIf(user) {
	                        return !_this.isOwner(user);
	                    },
	                    onClick: function onClick(user) {
	                        return _this.askToEditUser(user);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('SETTINGS.USERS.REMOVE_PERMISSIONS'),
	                    icon: 'ban',
	                    onlyIf: function onlyIf(user) {
	                        return !_this.isOwner(user);
	                    },
	                    onClick: function onClick(user) {
	                        return _this.askToRemoveUser(user);
	                    }
	                }]
	            }),
	            proxies: _lodash2.default.defaults({}, App.getTable('proxies'), {
	                actions: [{
	                    tooltip: this.$translate.instant('COMMON.EDIT'),
	                    icon: 'edit',
	                    onClick: function onClick(data, index) {
	                        return _this.askToEditProxy(data, index);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('COMMON.REMOVE'),
	                    icon: 'ban',
	                    onClick: function onClick(data, index) {
	                        return _this.askToRemoveProxy(data, index);
	                    }
	                }]
	            }),
	            holidays: _lodash2.default.defaults({}, App.getTable('holidays'), {
	                actions: [{
	                    tooltip: this.$translate.instant('COMMON.EDIT'),
	                    icon: 'edit',
	                    onClick: function onClick(data, index) {
	                        return _this.askToEditHoliday(data, index);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('COMMON.REMOVE'),
	                    icon: 'ban',
	                    onClick: function onClick(data) {
	                        return _this.askToRemoveHoliday(data);
	                    }
	                }]
	            })
	        };

	        this.filters = {
	            billing: App.getTableFilters("settings_billing", { context: this }),
	            holidays: App.getTableFilters("holidays", { context: this })
	        };

	        $scope.$watch('ctrl.provider', function () {
	            if (_this.provider) {
	                _this.setTabs();
	            }
	        });
	    }

	    _createClass(SettingsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;

	            this.reload = this.reload.bind(this);
	            this.setBreadcrums = this.setBreadcrums.bind(this);
	            this.askToAddUser = this.askToAddUser.bind(this);
	            this.askToAddProxy = this.askToAddProxy.bind(this);
	            this.getProxies = this.getProxies.bind(this);
	            this.askToAddHoliday = this.askToAddHoliday.bind(this);
	            this.getHolidays = this.getHolidays.bind(this);
	            this.getChargePointBilling = this.getChargePointBilling.bind(this);
	            this.getPrivate = this.getPrivate.bind(this);

	            this.$scope.$watch('ctrl.tabs.active', function () {
	                if (_this2.tabs.active) {
	                    switch (_this2.tabs.active.id) {
	                        case 'proxy':
	                            _this2.getProxies();
	                            break;
	                        case 'users':
	                            _this2.getPrivate();
	                            break;
	                        case 'holidays':
	                            _this2.getHolidays();
	                            break;
	                    }
	                }
	            });

	            this.setBreadcrums();
	            this.setTabs();
	            this.reload();
	        }
	    }, {
	        key: 'exportChargepoints',
	        value: function exportChargepoints() {
	            var _this3 = this;

	            this.ChargePointsService.exportProviderChargepoints()
	            // TODO Adapt translate names
	            .then(function (chargepoints) {
	                return _this3.App.downloadCSV(chargepoints, _this3.$translate.instant('CHARGEPOINTS_EXPORT_FILENAME') + '-' + _this3.provider.id + '-' + _this3.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	            }).catch(function () {
	                return _this3.App.showNotification(_this3.$translate.instant('CHARGEPOINTS_EXPORT_FAILED'), 'error');
	            });
	        }
	    }, {
	        key: 'isOwner',
	        value: function isOwner(user) {
	            return user && user.username && user.username && this.privateData && this.privateData.general && user.username === this.privateData.general.owner;
	        }
	    }, {
	        key: 'askToAddUser',
	        value: function askToAddUser() {
	            var _this4 = this;

	            this.UsersHelper.addRole(this.$scope, { provider: this.provider }).then(function () {
	                return _this4.getPrivate();
	            });
	        }
	    }, {
	        key: 'askToEditUser',
	        value: function askToEditUser(user) {
	            var _this5 = this;

	            this.UsersHelper.editRole(this.$scope, user, { provider: this.provider }).then(function () {
	                return _this5.getPrivate();
	            });
	        }
	    }, {
	        key: 'askToRemoveUser',
	        value: function askToRemoveUser(user) {
	            var _this6 = this;

	            this.UsersHelper.removeRole(this.$scope, user, { provider: this.provider }).then(function () {
	                return _this6.getPrivate();
	            });
	        }
	    }, {
	        key: 'askToEditProxy',
	        value: function askToEditProxy(data, index) {
	            var _this7 = this;

	            var options = { proxies: this.proxies, index: index };
	            this.ProvidersHelperService.editProxy(this.$scope, data, options).then(function () {
	                return _this7.getProxies();
	            });
	        }
	    }, {
	        key: 'askToRemoveProxy',
	        value: function askToRemoveProxy(data, index) {
	            var _this8 = this;

	            var options = { proxies: this.proxies, index: index };
	            this.ProvidersHelperService.removeProxy(this.$scope, data, options).then(function () {
	                return _this8.getProxies();
	            });
	        }
	    }, {
	        key: 'askToAddProxy',
	        value: function askToAddProxy() {
	            var _this9 = this;

	            var options = { proxies: this.proxies };
	            this.ProvidersHelperService.addProxy(this.$scope, options).then(function () {
	                return _this9.getProxies();
	            });
	        }
	    }, {
	        key: 'askToEditHoliday',
	        value: function askToEditHoliday(data, index) {
	            var _this10 = this;

	            var options = { holidays: this.holidays, index: index };
	            this.ProvidersHelperService.editHoliday(this.$scope, data, options).then(function () {
	                return _this10.getHolidays();
	            });
	        }
	    }, {
	        key: 'askToRemoveHoliday',
	        value: function askToRemoveHoliday(data) {
	            var _this11 = this;

	            this.ProvidersHelperService.removeHoliday(this.$scope, data).then(function () {
	                return _this11.getHolidays();
	            });
	        }
	    }, {
	        key: 'askToAddHoliday',
	        value: function askToAddHoliday() {
	            var _this12 = this;

	            var options = { holidays: this.holidays };
	            this.ProvidersHelperService.addHoliday(this.$scope, options).then(function () {
	                return _this12.getHolidays();
	            });
	        }
	    }, {
	        key: 'getPrivate',
	        value: function getPrivate() {
	            var _this13 = this;

	            var options = { pagination: this.tables.roles.pagination, sorting: this.tables.roles.sorting };
	            this.ProvidersService.getProviderPrivate(options, true).then(function (privateData) {
	                _this13.privateData = privateData.docs;
	                _this13.tables.roles.pagination.totalItems = privateData.totalItems;
	                _this13.tables.roles.pagination.currentPage = privateData.currentPage;
	                _this13.roles = privateData.docs.roles;
	            });
	        }
	    }, {
	        key: 'setTabs',
	        value: function setTabs() {
	            var _this14 = this;

	            var list = [{
	                id: 'info',
	                display: this.$translate.instant('SETTINGS.TABS.INFO'),
	                url: 'info'
	            }, {
	                id: 'users',
	                display: this.$translate.instant('SETTINGS.TABS.USERS'),
	                url: 'personal',
	                count: function count() {
	                    return _this14.tables.roles.pagination.totalItems ? _this14.tables.roles.pagination.totalItems : '...';
	                }
	            }, {
	                id: 'billing',
	                display: this.$translate.instant('BILLING'),
	                url: 'billing',
	                hide: !(this.isAdmin() && this.isProvider())
	            }, {
	                id: 'proxy',
	                display: this.$translate.instant('PROXY'),
	                url: 'proxy',
	                hide: !(this.isAdmin() && this.isProvider()),
	                count: function count() {
	                    return _this14.proxies ? _this14.proxies.length : '...';
	                }
	            }, {
	                id: 'holidays',
	                display: this.$translate.instant('HOLIDAY'),
	                url: 'holidays',
	                hide: !(this.isAdmin() && this.isProvider()),
	                count: function count() {
	                    return _this14.holidays ? _this14.holidays.length : '...';
	                }
	            }];

	            var active = list[0];

	            if (this.tab && _lodash2.default.findIndex(list, { 'url': this.tab }) >= 0) active = list[_lodash2.default.findIndex(list, { 'url': this.tab })];

	            this.tabs['active'] = this.tabs['active'] || active;
	            this.tabs['list'] = list;
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            this.App.setBreadcrumsTitle(this.$translate.instant('SETTINGS.BREADCRUMBS.PROVIDER'));
	            this.App.setBreadcrumsCurrentScope({
	                custom: this.provider ? this.provider.id : ''
	            });
	            this.App.setBreadcrumsCurrentScope({
	                custom: this.provider ? this.$filter('providerName')(this.provider.id) : ''
	            });
	            this.App.setBreadcrumsSteps([{ display: this.$translate.instant('SETTINGS.BREADCRUMBS.SETTINGS') }]);
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	        }
	    }, {
	        key: 'getChargePointBilling',
	        value: function getChargePointBilling() {
	            var _this15 = this;

	            var options = {
	                filters: this.filters.billing,
	                notifications: true,
	                params: { output: "csv" }
	            };
	            this.ProvidersService.getReportBilling(options).then(function (data) {
	                if (data) {
	                    var filename = _this15.$translate.instant('EXPORT_CHARGE_POINT_BILLING_REPORT_FILE_NAME') + '-' + _this15.moment().format('YYYY-MM-DD-HHmmss') + '.csv';
	                    _this15.App.downloadCSV(data, filename);
	                }
	            });
	        }
	    }, {
	        key: 'getProxies',
	        value: function getProxies() {
	            var _this16 = this;

	            this.ProvidersService.getProxies().then(function (data) {
	                _this16.proxies = data;
	            });
	        }
	    }, {
	        key: 'getHolidays',
	        value: function getHolidays() {
	            var _this17 = this;

	            var options = {
	                filters: this.filters.holidays,
	                sorting: this.tables.holidays.sorting,
	                pagination: this.tables.holidays.pagination
	            };
	            this.ProvidersService.getHolidays(options).then(function (data) {
	                _this17.holidays = data.docs;
	                _this17.tables.holidays.pagination.totalItems = data.totalItems;
	                _this17.tables.holidays.pagination.currentPage = data.currentPage;
	            });
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this18 = this;

	            this.App.setLoading(true);
	            this.ProvidersService.getProvider().then(function (provider) {
	                _this18.provider = provider;
	                _this18.setBreadcrums();
	                _this18.App.setLoading(false);
	            }).catch(function () {
	                _this18.App.showNotification(_this18.$translate.instant('SETTINGS.FAILED'), 'error');
	                _this18.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'isAdmin',
	        value: function isAdmin() {
	            return this.Auth.isAdmin();
	        }
	    }, {
	        key: 'isProvider',
	        value: function isProvider() {
	            return this.Auth.isProvider();
	        }
	    }]);

	    return SettingsController;
	}();

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CustomersController = exports.CustomersController = function () {
	    CustomersController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$translate", "App", "moment", "CustomersService"];
	    function CustomersController($rootScope, $scope, $state, $stateParams, $translate, App, moment, CustomersService) {
	        'ngInject';

	        _classCallCheck(this, CustomersController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.$translate = $translate;
	        this.App = App;
	        this.moment = moment;
	        this.CustomersService = CustomersService;

	        this.organization = $stateParams.organization || null;
	        this.customers = null;

	        this.filters = App.getTableFilters("customer");
	        this.filterControls = {};
	        this.table = App.getTable('customers', !this.canAdminCustomers() ? { omit: ['nif', 'userId', 'city'] } : null);
	    }

	    _createClass(CustomersController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.onCustomerClick = this._onCustomerClick.bind(this);
	            this.reload = this._reload.bind(this);

	            this.setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: '_onCustomerClick',
	        value: function _onCustomerClick(customer) {
	            this.$state.go('efimob.customers.item', { 'id': customer.id, 'organization': this.organization });
	        }
	    }, {
	        key: 'canAdminCustomers',
	        value: function canAdminCustomers() {
	            return (this.$rootScope.role.entity === 'provider' || this.$rootScope.role.entity === 'organization') && this.$rootScope.role.role === 'admin';
	        }
	    }, {
	        key: 'exportCustomers',
	        value: function exportCustomers() {
	            var _this = this;

	            this.CustomersService.exportCustomers({ 'filters': this.filters, 'sorting': this.table.sorting, 'organization': this.organization }).then(function (customers) {
	                return _this.App.downloadCSV(customers, _this.$translate.instant('CUSTOMERS.EXPORT_FILE_PREFIX') + '-' + _this.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	            }).catch(function () {
	                return _this.App.showNotification(_this.$translate.instant('CUSTOMERS.CANT_EXPORT'), 'error');
	            });
	        }
	    }, {
	        key: 'askToAddCustomer',
	        value: function askToAddCustomer() {
	            var _this2 = this;

	            function isValid(modal) {
	                if (modal.wizard.steps[modal.wizard.step].id === 'name') {
	                    return modal.customer.name && modal.customer.name.length > 0;
	                }
	                return true;
	            }
	            function next(modal) {
	                if (modal.wizard.steps[modal.wizard.step].id === 'name') {
	                    //TODO
	                }
	            }
	            this.$scope.modal = {
	                customer: { 'name': null },
	                organization: this.organization,
	                wizard: {
	                    step: 0,
	                    steps: [{ 'id': 'name', 'title': this.$translate.instant('CUSTOMERS.MODAL.NAME'), 'intro': this.$translate.instant('CUSTOMERS.MODAL.WHAT_NAME') }]
	                },
	                isValid: isValid,
	                next: next,
	                done: function done() {
	                    return _this2.addCustomer(_this2.$scope.modal.customer);
	                }
	            };
	            this.App.openModal(this.$scope, 'add-customer.html', { 'size': 'lg' });
	        }
	    }, {
	        key: 'addCustomer',
	        value: function addCustomer(customer) {
	            var _this3 = this;

	            this.App.hideNotification();
	            this.CustomersService.addCustomer(customer, { organization: this.organization }).then(function () {
	                _this3.reload();
	                _this3.App.showNotification(_this3.$translate.instant('CUSTOMERS.ADDED_OK'));
	                _this3.App.closeModal();
	            }).catch(function () {
	                _this3.App.showNotification(_this3.$translate.instant('CUSTOMERS.ADDED_FAILED') + ' <accent>' + customer.name + '</accent>', 'error');
	                _this3.App.closeModal();
	            });
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            this.App.setBreadcrumsTitle(this.$translate.instant('CUSTOMERS.CUSTOMERS'));
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	            this.App.setBreadcrumsCurrentScope({
	                organizationId: this.organization,
	                custom: this.organization,
	                title: this.$translate.instant('APP.BREADCRUMS.OF')
	            });
	        }
	    }, {
	        key: '_reload',
	        value: function _reload() {
	            var _this4 = this;

	            var options = {
	                'filters': this.filters,
	                'pagination': this.table.pagination,
	                'sorting': this.table.sorting,
	                'organization': this.organization
	            };
	            this.App.setLoading(true);
	            this.CustomersService.getCustomers(options, true).then(function (data) {
	                _this4.customers = data.docs;
	                _this4.table.pagination.currentPage = data.currentPage;
	                _this4.table.pagination.totalItems = data.totalItems;
	                _this4.App.setLoading(false);
	            }).catch(function () {
	                return _this4.App.setLoading(false);
	            });
	        }
	    }]);

	    return CustomersController;
	}();

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CustomerController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var CustomerController = exports.CustomerController = function () {
	    CustomerController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$translate", "$filter", "moment", "App", "ChargeSessionsService", "CustomersService", "CustomerHelperService", "UsersService", "UsersHelper", "GroupsService", "Organization"];
	    function CustomerController($rootScope, $scope, $state, $stateParams, $translate, $filter, moment, App, ChargeSessionsService, CustomersService, CustomerHelperService, UsersService, UsersHelper, GroupsService, Organization) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, CustomerController);

	        this.$rootScope = $rootScope;
	        this.$scope = $scope;
	        this.$state = $state;
	        this.App = App;
	        this.ChargeSessionsService = ChargeSessionsService;
	        this.CustomersService = CustomersService;
	        this.CustomerHelperService = CustomerHelperService;
	        this.UsersService = UsersService;
	        this.GroupsService = GroupsService;
	        this.Organization = Organization;
	        this.moment = moment;
	        this.UsersHelper = UsersHelper;
	        this.$translate = $translate;
	        this.$filter = $filter;

	        this.id = $stateParams.id;
	        this.customer = null;
	        this.charges = null;
	        this.userkeys = null;
	        this.organization = $stateParams.organization;
	        this.tab = $stateParams.tab;
	        this.consents = [];

	        // Properties panel settings
	        this.properties = {
	            'general': {
	                keys: ['personType | personType:item', 'name', 'registeredName', 'identifierNumber', 'id', 'organizationName | safe', 'acceptedConditions | yesno', 'allowedNotifications | yesno', 'chargeTarget | customerChargeTarget', 'lang | displayLang', 'externalId'],
	                headers: [this.$translate.instant('CUSTOMER_VIEW.PERSON_TYPE'), this.$translate.instant('CUSTOMER_VIEW.NAME'), this.$translate.instant('CUSTOMER_VIEW.REGISTERED_NAME'), this.$translate.instant('IDENTIFIER_NUMBER'), this.$translate.instant('CUSTOMER_VIEW.ID'), this.$translate.instant('CUSTOMER_VIEW.ORGANIZATION'), this.$translate.instant('CUSTOMER_VIEW.TERMS_ACCEPTED'), this.$translate.instant('CUSTOMER_VIEW.NOTIFICATIONS_ALLOWED'), this.$translate.instant('CUSTOMER_VIEW.CHARGE_TARGET'), this.$translate.instant('CUSTOMER_VIEW.LANG'), this.$translate.instant('EXTERNAL_ID')],
	                editable: ['name', 'registeredName', 'identifierNumber'],
	                meta: {
	                    chargeTarget: {
	                        info: this.$translate.instant('CUSTOMER_VIEW.CHARGE_TARGET_INFO')
	                    }
	                },
	                onlyAdmin: ['registeredName', 'identifierNumber'],
	                canAdmin: function canAdmin() {
	                    return _this.canAdminCustomer();
	                },
	                onSave: function onSave(changes) {
	                    if (changes.changed && changes.changed.identifierNumber) {
	                        changes.changed.identifierType = _this.$filter("identifierType")(changes.changed.identifierNumber, _this.customer.personType);
	                    }
	                    return _this.editCustomer(changes.changed);
	                }
	            },
	            'contact': {
	                keys: ['userId', 'phone', 'anotherPhone'],
	                headers: [this.$translate.instant('CUSTOMER_VIEW.CONTACT.EMAIL'), this.$translate.instant('CUSTOMER_VIEW.CONTACT.PHONE1'), this.$translate.instant('CUSTOMER_VIEW.CONTACT.PHONE2')],
	                editable: ['phone', 'anotherPhone'],
	                meta: {
	                    phone: {
	                        onChange: function onChange(change) {
	                            if (angular.isDefined(change.model.value) && (!change.model.value || change.model.value === '')) {
	                                change.model.value = null;
	                            }
	                        }
	                    },
	                    anotherPhone: {
	                        onChange: function onChange(change) {
	                            if (angular.isDefined(change.model.value) && (!change.model.value || change.model.value === '')) {
	                                change.model.value = null;
	                            }
	                        }
	                    }
	                },
	                onlyAdmin: true,
	                canAdmin: function canAdmin() {
	                    return _this.canAdminCustomer();
	                },
	                onSave: function onSave(changes) {
	                    return _this.editCustomer(changes.changed);
	                }
	            },
	            'address': {
	                keys: ['address', 'city', 'postalCode', 'province', 'country'],
	                headers: [this.$translate.instant('CUSTOMER_VIEW.ADDRESS.STREET'), this.$translate.instant('CUSTOMER_VIEW.ADDRESS.CITY'), this.$translate.instant('CUSTOMER_VIEW.ADDRESS.POSTAL_CODE'), this.$translate.instant('CUSTOMER_VIEW.ADDRESS.PROVINCE'), this.$translate.instant('CUSTOMER_VIEW.ADDRESS.COUNTRY')],
	                editable: ['address', 'city', 'postalCode', 'province', 'country'],
	                onlyAdmin: true,
	                canAdmin: function canAdmin() {
	                    return _this.canAdminCustomer();
	                },
	                onSave: function onSave(changes) {
	                    return _this.editCustomerAddress(changes.changed);
	                }
	            },
	            'right': {
	                keys: ['personType | personType:item', 'name', 'nif', 'userId', 'organizationName | safe'],
	                headers: [this.$translate.instant('CUSTOMER_VIEW.PERSON_TYPE'), this.$translate.instant('CUSTOMER_VIEW.NAME'), this.$translate.instant('IDENTIFIER_NUMBER'), this.$translate.instant('CUSTOMER_VIEW.CONTACT.EMAIL'), this.$translate.instant('CUSTOMER_VIEW.ORGANIZATION')],
	                onlyAdmin: ['nif'],
	                canAdmin: function canAdmin() {
	                    return _this.canAdminCustomer();
	                }
	            }
	        };

	        // Tabs settings
	        this.tabs = {
	            'active': null,
	            'list': [],
	            'left': true

	            // Filters settings
	        };this.filters = {
	            charges: [],
	            userkeys: [],
	            payments: []

	            // Tables settings
	        };this.tables = {
	            charges: App.getTable('charges', { 'omit': ['organizationId'] }),
	            userkeys: App.getTable('userkeys', { 'omit': ['organizationId', 'chargepointName'] }),
	            payments: App.getTable('payments'),
	            customerConsents: App.getTable('customerConsents')
	        };
	    }

	    _createClass(CustomerController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;

	            this.reload = this.reload.bind(this);
	            this.reloadCharges = this.reloadCharges.bind(this);
	            this.reloadUserkeys = this.reloadUserkeys.bind(this);
	            this.onChargeClick = this.onChargeClick.bind(this);
	            this.onUserkeyClick = this.onUserkeyClick.bind(this);

	            this.$scope.$watch('ctrl.customer', function () {
	                return _this2.customer && _this2.setTabs();
	            });
	            this.$scope.$watch('ctrl.tabs.active', function () {
	                if (_this2.tabs.active) {
	                    switch (_this2.tabs.active.id) {
	                        case 'charges':
	                            _this2.reloadCharges();
	                            break;
	                        case 'userkeys':
	                            _this2.reloadUserkeys();
	                            break;
	                        case 'payments':
	                            _this2.reloadPayments();
	                            break;
	                    }
	                }
	            });
	            this.setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: 'setTabs',
	        value: function setTabs() {
	            var _this3 = this;

	            var list = [{
	                id: 'info',
	                display: this.$translate.instant('CUSTOMER_VIEW.TAB.INFO'),
	                url: 'info'
	            }, {
	                id: 'charges',
	                display: this.$translate.instant('CUSTOMER_VIEW.TAB.CHARGES'),
	                url: 'recargas',
	                count: function count() {
	                    return _this3.charges ? _this3.tables.charges.pagination.totalItems : '...';
	                }
	            }, {
	                id: 'userkeys',
	                display: this.$translate.instant('CUSTOMER_VIEW.TAB.USERKEYS'),
	                url: 'llaves',
	                count: function count() {
	                    return _this3.userkeys ? _this3.tables.userkeys.pagination.totalItems : '...';
	                }
	            }, {
	                id: 'payments',
	                display: this.$translate.instant('CUSTOMER_VIEW.TAB.PAYMENTS'),
	                url: 'pagos',
	                count: function count() {
	                    return _this3.payments ? _this3.tables.payments.pagination.totalItems : '...';
	                }
	            }];

	            var active = list[0];
	            var index = _lodash2.default.findIndex(list, { 'url': this.tab });
	            if (this.tab && index >= 0) active = list[index];

	            this.tabs['active'] = this.tabs['active'] || active;
	            this.tabs['list'] = list;
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            if (this.customer) this.App.setBreadcrumsTitle(this.customer.name);
	            var backHref = this.$state.href('efimob.customers.list', { organization: this.organization });
	            this.App.setBreadcrumsSteps([{ display: this.$translate.instant('CUSTOMER_VIEW.CUSTOMERS'), href: backHref }]);
	            this.App.setBreadcrumsRightActions([this.App.getActionBack(backHref, this.$translate.instant('CUSTOMER_VIEW.BACK_TO_CUSTOMERS')), this.App.getActionReload(this.reload)]);
	        }
	    }, {
	        key: 'canAdminCustomer',
	        value: function canAdminCustomer() {
	            return (this.$rootScope.role.entity === 'provider' || this.$rootScope.role.entity === 'organization') && this.$rootScope.role.role === 'admin';
	        }
	    }, {
	        key: 'editCustomer',
	        value: function editCustomer(changed) {
	            if (changed) {
	                return this.CustomersService.editCustomer(this.customer.id, changed, { organization: this.organization }).then(this.reload);
	            }
	        }
	    }, {
	        key: 'editCustomerAddress',
	        value: function editCustomerAddress(changed) {
	            if (changed) {
	                return this.CustomersService.editCustomer(this.customer.id, { 'address': changed }, { organization: this.organization }).then(this.reload);
	            }
	        }
	    }, {
	        key: 'askToRemoveCustomer',
	        value: function askToRemoveCustomer() {
	            this.$scope.modal = { customer: this.customer };
	            this.App.openModal(this.$scope, 'remove-customer.html', { 'size': 'sm' });
	        }
	    }, {
	        key: 'removeCustomer',
	        value: function removeCustomer() {
	            var _this4 = this;

	            this.CustomersService.removeCustomer(this.customer.id, { organization: this.organization }).then(function () {
	                _this4.App.showNotification(_this4.$translate.instant('CUSTOMER_VIEW.REMOVE_OK', { name: '<accent>' + _this4.customer.name + '</accent>' }), 'ok', null, 1000);
	                _this4.$state.go('efimob.customers.list', { 'organization': _this4.organization });
	                _this4.App.closeModal();
	            }).catch(function () {
	                _this4.App.showNotification(_this4.$translate.instant('CUSTOMER_VIEW.REMOVE_FAILED'), 'error');
	                _this4.App.closeModal();
	            });
	        }
	    }, {
	        key: 'askToUnblockCustomer',
	        value: function askToUnblockCustomer() {
	            var _this5 = this;

	            this.UsersHelper.unblockUser(this.$scope, this.customer, { organization: this.organization }).then(function () {
	                return _this5.reload();
	            });
	        }
	    }, {
	        key: 'askToAddUserkey',
	        value: function askToAddUserkey() {
	            var _this6 = this;

	            this.CustomerHelperService.addUserKey(this.$scope, null, { customer: this.customer, organizationId: this.organization }).then(function () {
	                return _this6.reloadUserkeys();
	            });
	        }
	    }, {
	        key: 'onChargeClick',
	        value: function onChargeClick(charge) {
	            this.$state.go('efimob.charges.at.item', { 'id': charge.id, 'organization': this.organization });
	        }
	    }, {
	        key: 'reloadCharges',
	        value: function reloadCharges() {
	            var _this7 = this;

	            this.App.setLoading(true);
	            var options = {
	                filters: this.filters.charges,
	                pagination: this.tables.charges.pagination,
	                sorting: this.tables.charges.sorting,
	                params: { 'customerId.like': this.customer.id },
	                organization: this.organization
	            };
	            return this.ChargeSessionsService.getCharges(options).then(function (charges) {
	                _this7.charges = charges.docs;
	                _this7.tables.charges.pagination.currentPage = charges.currentPage;
	                _this7.tables.charges.pagination.totalItems = charges.totalItems;
	                _this7.App.setLoading(false);
	            }).catch(function () {
	                return _this7.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'onUserkeyClick',
	        value: function onUserkeyClick(userkey) {
	            this.$state.go('efimob.userkeys.at.item', { 'id': userkey.userKeyId, 'organization': userkey.organizationId });
	        }
	    }, {
	        key: 'reloadUserkeys',
	        value: function reloadUserkeys() {
	            var _this8 = this;

	            this.App.setLoading(true);
	            var options = {
	                filters: this.filters.userkeys,
	                pagination: this.tables.userkeys.pagination,
	                sorting: this.tables.userkeys.sorting,
	                organization: this.organization
	            };
	            return this.CustomersService.getUserkeysByCustomer(this.customer.id, options, true).then(function (data) {
	                _this8.userkeys = data.docs;
	                _this8.tables.userkeys.pagination.currentPage = data.currentPage;
	                _this8.tables.userkeys.pagination.totalItems = data.totalItems;
	                _this8.App.setLoading(false);
	            }).catch(function () {
	                return _this8.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'reloadPayments',
	        value: function reloadPayments() {
	            var _this9 = this;

	            this.App.setLoading(true);
	            var options = {
	                filters: this.filters.payments,
	                pagination: this.tables.payments.pagination,
	                sorting: this.tables.payments.sorting,
	                organization: this.organization
	            };
	            return this.CustomersService.getPaymentsByCustomer(this.customer.id, options).then(function (payments) {
	                _this9.payments = payments;
	                _this9.App.setLoading(false);
	            }).catch(function () {
	                return _this9.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'reloadCustomer',
	        value: function reloadCustomer() {
	            var _this10 = this;

	            this.App.setLoading(true);
	            return this.CustomersService.getCustomer(this.id, { organization: this.organization }).then(function (customer) {
	                if (customer && !customer.address) customer.address = {};
	                _this10.customer = customer;
	                _this10.setBreadcrums();
	                _this10.App.setLoading(false);
	            }).catch(function () {
	                _this10.setBreadcrums();
	                _this10.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'getConsents',
	        value: function getConsents() {
	            var _this11 = this;

	            return this.Organization.getConsents(this.organization).then(function (allConsents) {
	                return _this11.CustomersService.getCustomerConsents(_this11.id, { organization: _this11.organization }).then(function (customerConsents) {
	                    _this11.consents = [];
	                    _lodash2.default.forEachRight(allConsents.consents || [], function (item) {
	                        var aux = _lodash2.default.find(customerConsents, { organization_consent: item.id });
	                        _this11.consents.push(angular.merge(item, { accepted: !!aux }));
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this12 = this;

	            this.reloadCustomer().then(function () {
	                Promise.all([_this12.getConsents()]).then(function () {
	                    _this12.App.setLoading(false);
	                }).catch(function () {
	                    return _this12.App.setLoading(false);
	                });
	            }).catch(function () {
	                return _this12.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'exportCharges',
	        value: function exportCharges() {
	            var _this13 = this;

	            var options = {
	                notifications: true,
	                filters: this.filters.charges,
	                sorting: this.tables.charges.sorting,
	                organization: this.organization,
	                params: {
	                    'customerId.like': this.customer.id,
	                    'output': 'csv'
	                }
	            };

	            this.ChargeSessionsService.getCharges(options, false).then(function (charges) {
	                if (charges) {
	                    _this13.App.downloadCSV(charges, _this13.$translate.instant('CHARGES') + '-' + _this13.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	                }
	            });
	        }
	    }]);

	    return CustomerController;
	}();

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChargeController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _chart = __webpack_require__(31);

	var _chart2 = _interopRequireDefault(_chart);

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargeController = exports.ChargeController = function () {
	    ChargeController.$inject = ["$scope", "$state", "ChargePointsService", "$filter", "$stateParams", "$document", "$translate", "ChargeSessionsService", "moment", "App", "Auth", "OCPP", "ChargeHelper"];
	    function ChargeController($scope, $state, ChargePointsService, $filter, $stateParams, $document, $translate, ChargeSessionsService, moment, App, Auth, OCPP, ChargeHelper) {
	        'ngInject';

	        _classCallCheck(this, ChargeController);

	        this.ChargePointsService = ChargePointsService;
	        this.App = App;
	        this.Auth = Auth;
	        this.OCPP = OCPP;
	        this.$state = $state;
	        this.$scope = $scope;
	        this.$filter = $filter;
	        this.$document = $document;
	        this.$translate = $translate;
	        this.moment = moment;
	        this.ChargeHelper = ChargeHelper;
	        this.ChargeSessionsService = ChargeSessionsService;

	        this.id = $stateParams.id;
	        this.organization = $stateParams.organization || null;
	        this.chargepointId = $stateParams.chargepointId || null;
	        this.meterValues = null;
	        this.statusValues = null;
	        this.charge = null;
	        this.chargepoint = null;
	        this.tab = $stateParams.tab;
	        this.state = {
	            closeProcess: false,
	            loading: {}
	        };

	        this.properties = {
	            general: {
	                keys: ['id', 'chargepointId | chargepointLink:this:undefined:ctrl.item.chargepointName', 'connectorId', 'duration | chargeDuration:ctrl.item', 'start.dateTime | toDate', 'stop.dateTime | toDate', 'cost.totalCost | chargeCost:true', 'emsp | empty', 'cpo | empty', 'receiptCode', 'tariff | redirectToTariff'],
	                headers: [this.$translate.instant('CHARGE.ID'), this.$translate.instant('CHARGE.CHARGEPOINT'), this.$translate.instant('CHARGE.CONNECTOR'), this.$translate.instant('CHARGE.DURATION'), this.$translate.instant('CHARGE.START'), this.$translate.instant('CHARGE.END'), this.$translate.instant('CHARGE.COST'), this.$translate.instant('EMSP'), this.$translate.instant('CPO'), this.$translate.instant('RECEIPT_CODE'), this.$translate.instant('TARIFF')]
	            },
	            meter: {
	                keys: ['meter | chargeMeter:ctrl.item', 'SoC | chargeSoC', 'maxPower | number:3', 'effectiveDuration | chargeDuration', 'mainCharge.startDateTime | toDate', 'mainCharge.endDateTime | toDate'],
	                headers: [this.$translate.instant('CHARGE.CHARGED_IN_KWH'), this.$translate.instant('CHARGE.SOC'), this.$translate.instant('CHARGE.MAX_POWER'), this.$translate.instant('CHARGE.EFFECTIVE_DURATION'), this.$translate.instant('CHARGE.MAIN_CHARGE_START'), this.$translate.instant('CHARGE.MAIN_CHARGE_END')],
	                meta: {
	                    'SoC': {
	                        'info': this.$translate.instant('CHARGE.SOC_INFO')
	                    }
	                }
	            },
	            userkeys: {
	                keys: ['start.userKeyId', 'stop.userKeyId'],
	                headers: [this.$translate.instant('CHARGE.STARTED_BY'), this.$translate.instant('CHARGE.STOPPED_BY')]
	            },
	            right: {
	                keys: ['id', 'chargepointId | chargepointLink:this:undefined:ctrl.item.chargepointName', 'connectorId', 'cost.totalCost | chargeCost:true', 'meter | chargeMeter:ctrl.item', 'duration | chargeDuration:ctrl.item', 'start.dateTime | toDate', 'stop.dateTime | toDate'],
	                headers: [this.$translate.instant('CHARGE.ID'), this.$translate.instant('CHARGE.CHARGEPOINT'), this.$translate.instant('CHARGE.CONNECTOR'), this.$translate.instant('CHARGE.COST'), this.$translate.instant('CHARGE.CHARGED_IN_KWH'), this.$translate.instant('CHARGE.DURATION'), this.$translate.instant('CHARGE.START'), this.$translate.instant('CHARGE.END')]
	            }
	        };

	        this.tabs = {
	            active: null,
	            list: [],
	            left: true
	        };

	        this.tables = {
	            meterValues: {
	                'keys': ['timestamp | toDate', 'value | number', 'unit', 'phase', 'connectorId', 'measurand'],
	                'headers': [this.$translate.instant('CHARGE.TIMESTAMP'), this.$translate.instant('CHARGE.VALUE'), this.$translate.instant('CHARGE.UNIT'), this.$translate.instant('CHARGE.PHASE'), this.$translate.instant('CHARGE.CONNECTOR'), this.$translate.instant('CHARGE.MEASURE')],
	                'trackBy': 'timestamp',
	                'synchronous': true,
	                'compact': true,
	                'pagination': App.getPagination(10),
	                'sorting': App.getSorting(['timestamp'], 'timestamp', 'asc')
	            },
	            statusValues: {
	                'keys': ['timestamp | toDate', 'status', 'connectorId', 'errorCode'],
	                'headers': [this.$translate.instant('CHARGE.TIMESTAMP'), this.$translate.instant('CHARGE.STATUS'), this.$translate.instant('CHARGE.CONNECTOR'), this.$translate.instant('CHARGE.ERROR')],
	                'trackBy': 'timestamp',
	                'synchronous': true,
	                'compact': true,
	                'pagination': App.getPagination(10),
	                'sorting': App.getSorting(['timestamp'], 'timestamp', 'asc')
	            }

	            // $rootScope.$on('layoutChanged', () => {
	            //     if (this.chart) $timeout(() => this.chart.resize(), 500); // hack
	            // });


	        };
	    }

	    _createClass(ChargeController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            var _this = this;

	            this.reload = this._reload.bind(this);

	            this.$scope.$watch('ctrl.charge', function () {
	                if (_this.charge) {
	                    _this.setTabs();
	                }
	            });

	            this.$scope.$watch('ctrl.meterValues', function () {
	                _this.drawChart();
	            });

	            this.$scope.$watch('ctrl.statusValues', function () {
	                _this.drawChart();
	            });

	            this.$scope.$watchCollection('ctrl.state.loading', function () {
	                var loading = _lodash2.default.compact(_lodash2.default.values(_this.state.loading)).length > 0;
	                _this.App.setLoading(loading);
	            });

	            this.$scope.$watch('ctrl.tabs.active', function () {
	                if (_this.tabs.active) {
	                    switch (_this.tabs.active.id) {
	                        case 'meter':
	                            if (_this.chart) {
	                                _this.chart.destroy();
	                            }
	                            _this.reloadChargepoint();
	                            _this.reloadMeterValues(true);
	                            _this.reloadStatusValues();
	                            break;
	                        case 'values':
	                            _this.reloadMeterValues(false);
	                            _this.reloadStatusValues();
	                            break;
	                    }
	                }
	            });
	            this.setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: "stopCharge",
	        value: function stopCharge() {
	            var _this2 = this;

	            if (!this.chargepoint || !this.chargepoint.connectors) return;
	            var connector = _lodash2.default.find(this.chargepoint.connectors, { id: '' + this.charge.connectorId });
	            if (!_lodash2.default.get(connector, 'transaction.transactionId')) return;
	            var options = {
	                organization: this.organization,
	                notifications: true
	            };
	            this.ChargePointsService.stopChargepointConnectorRemoteTransaction(this.chargepoint.id, connector.transaction.transactionId, options).then(function (ocppResult) {
	                var result = _this2.OCPP.onCallResult('RemoteStopTransaction', ocppResult);
	                if (result && !result.error) _this2.reload();
	                if (result.notification) _this2.App.showNotification(result.notification.message, result.notification.style);
	            });
	        }
	    }, {
	        key: "asKWh",
	        value: function asKWh(meterValue) {
	            if (!meterValue) return 0;
	            if (meterValue.unit === 'kWh') return parseFloat(meterValue.value);
	            if (meterValue.unit === 'Wh') return parseFloat(meterValue.value) / 1000;
	            return 0;
	        }
	    }, {
	        key: "asKW",
	        value: function asKW(meterValue) {
	            if (!meterValue) return 0;
	            if (meterValue.unit === 'kW') return parseFloat(meterValue.value);
	            if (meterValue.unit === 'W') return parseFloat(meterValue.value) / 1000;
	            return 0;
	        }
	    }, {
	        key: "getChartEnergyData",
	        value: function getChartEnergyData() {
	            var _this3 = this;

	            var data = [];
	            var energyMeterValues = _lodash2.default.filter(this.meterValues, { 'measurand': 'Energy.Active.Import.Register', 'phase': null });
	            var firstEnergyMeterValue = energyMeterValues[0];
	            var lastEnergyMeterValue = energyMeterValues[energyMeterValues.length - 1];
	            _lodash2.default.each(energyMeterValues, function (meterValue) {
	                data.push({ t: meterValue.timestamp, y: _this3.asKWh(meterValue) - _this3.asKWh(firstEnergyMeterValue) });
	            });
	            // last fake point
	            if (this.charge.stop && this.charge.stop.dateTime && new Date(lastEnergyMeterValue.timestamp).getTime() < new Date(this.charge.stop.dateTime).getTime()) {
	                data.push({ t: this.charge.stop.dateTime, y: this.asKWh(lastEnergyMeterValue) - this.asKWh(firstEnergyMeterValue) });
	            }
	            return data;
	        }
	    }, {
	        key: "askForForcedClosure",
	        value: function askForForcedClosure() {
	            var _this4 = this;

	            var meterValue = null;
	            var timestamp = null;
	            if (this.meterValues && this.meterValues.length > 0) {
	                meterValue = this.asKWh(this.meterValues[this.meterValues.length - 1]);
	                timestamp = new Date(Date.parse(this.meterValues[this.meterValues.length - 1].timestamp));
	            }
	            if (this.charge && this.charge.meter) meterValue = this.charge.meter;
	            var options = {
	                organization: this.organization,
	                notifications: {
	                    success: this.$translate.instant("CHARGE.ADDED_OK"),
	                    error: this.$translate.instant("CHARGE.ADD_FAILED")
	                }
	            };
	            var params = {
	                id: this.id,
	                state: this.state,
	                meterValue: meterValue,
	                timestamp: timestamp
	            };
	            return this.ChargeHelper.askForForcedClosure(this.$scope, options, params).then(function () {
	                return _this4.reload();
	            });
	        }
	    }, {
	        key: "isChartPowerDataReal",
	        value: function isChartPowerDataReal() {
	            return _lodash2.default.find(this.meterValues, { 'measurand': 'Power.Active.Import' });
	        }
	    }, {
	        key: "getChartPowerData",
	        value: function getChartPowerData() {
	            var _this5 = this;

	            var data = [];
	            var powerMeterValues = _lodash2.default.filter(this.meterValues, { 'measurand': 'Power.Active.Import', 'phase': null });
	            if (powerMeterValues.length > 0) {
	                var lastEnergyMeterValue = powerMeterValues[powerMeterValues.length - 1];
	                // Get power data from proper meter values if present
	                _lodash2.default.each(powerMeterValues, function (meterValue) {
	                    data.push({ t: meterValue.timestamp, y: _this5.asKW(meterValue) });
	                });
	                // last fake point
	                if (this.charge.stop && this.charge.stop.dateTime && new Date(lastEnergyMeterValue.timestamp).getTime() < new Date(this.charge.stop.dateTime).getTime()) {
	                    data.push({ t: this.charge.stop.dateTime, y: 0.0 });
	                }
	            } else {
	                // Otherwise, get power data infered from energy meter values
	                var energyMeterValues = _lodash2.default.filter(this.meterValues, { 'measurand': 'Energy.Active.Import.Register', 'phase': null });
	                _lodash2.default.each(energyMeterValues, function (meterValue) {
	                    if (angular.isDefined(meterValue.power) && angular.isDefined(meterValue.power)) {
	                        // It is always W
	                        data.push({ t: meterValue.timestamp, y: parseFloat(meterValue.power) / 1000 });
	                    } else {
	                        data.push({ t: meterValue.timestamp, y: 0.0 });
	                    }
	                });
	            }
	            return data;
	        }
	    }, {
	        key: "getChartStatusData",
	        value: function getChartStatusData(onlyConnector) {
	            var data = [];
	            _lodash2.default.each(this.statusValues, function (statusValue) {
	                if (angular.isUndefined(onlyConnector) || statusValue.connectorId === onlyConnector) {
	                    data.push({ t: statusValue.timestamp, y: 0, status: statusValue.status });
	                }
	            });
	            return data;
	        }
	    }, {
	        key: "drawChart",
	        value: function drawChart() {
	            var _this6 = this;

	            if (!this.meterValues || !this.statusValues) return;

	            var ctx = this.$document[0].getElementById("chargeChart").getContext('2d');
	            // var color = Chart.helpers.color;
	            this.chart = new _chart2.default(ctx, {
	                type: 'line',
	                data: {
	                    // labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
	                    // labels: [moment($scope.charge.start.dateTime).toDate(), moment($scope.charge.stop.dateTime).toDate()],
	                    datasets: [{
	                        label: this.$translate.instant('CHARGE.CHART.POWER'),
	                        data: this.getChartPowerData(),
	                        yAxisID: 'power-axis',
	                        lineTension: 0.1,
	                        steppedLine: this.isChartPowerDataReal() ? false : 'after',
	                        backgroundColor: 'rgba(54, 162, 235, 0.2)',
	                        borderColor: 'rgba(54, 162, 235, 1)',
	                        borderWidth: 2,
	                        pointHitRadius: 3,
	                        pointRadius: this.meterValues.length > 20 ? 0 : 4,
	                        pointHoverRadius: this.meterValues.length > 20 ? 0 : 4
	                    }, {
	                        label: this.$translate.instant('CHARGE.CHART.CHARGE'),
	                        data: this.getChartEnergyData(),
	                        yAxisID: 'energy-axis',
	                        lineTension: 0.1,
	                        backgroundColor: 'rgba(149, 75, 151, 0.2)',
	                        borderColor: 'rgba(149, 75, 151, 1)',
	                        borderWidth: 2,
	                        pointHitRadius: 3,
	                        pointRadius: this.meterValues.length > 20 ? 0 : 4,
	                        pointHoverRadius: this.meterValues.length > 20 ? 0 : 4
	                    }, {
	                        label: this.$translate.instant('CHARGE.CHART.CONNECTOR_EVENTS'),
	                        data: this.getChartStatusData(this.charge.connectorId),
	                        fill: false,
	                        showLine: false,
	                        pointRadius: 10,
	                        pointHoverRadius: 10,
	                        pointStyle: 'triangle',
	                        backgroundColor: 'rgba(26, 187, 156, 1)',
	                        borderColor: 'rgba(26, 187, 156, 1)'
	                    }, {
	                        label: this.$translate.instant('CHARGE.CHART.CHARGEPOINT_EVENTS'),
	                        data: this.getChartStatusData(0),
	                        fill: false,
	                        showLine: false,
	                        pointRadius: 10,
	                        pointHoverRadius: 10,
	                        pointStyle: 'triangle',
	                        backgroundColor: '#9CC2CB',
	                        borderColor: '#9CC2CB'
	                    }]
	                },
	                options: {
	                    responsive: true,
	                    // maintainAspectRatio: false,
	                    scales: {
	                        xAxes: [{
	                            type: 'time',
	                            time: {
	                                // parser: 'MM/DD/YYYY HH:mm',
	                                // round: 'day'
	                                tooltipFormat: 'll HH:mm'
	                            },
	                            scaleLabel: {
	                                display: true,
	                                labelString: this.$translate.instant('CHARGE.CHART.STARTED_ON', { date: this.$filter('toDate')(this.charge.start.dateTime) })
	                            }
	                        }],
	                        yAxes: [{ id: 'power-axis', position: 'left', ticks: { min: 0 }, scaleLabel: { display: true, labelString: this.$translate.instant('CHARGE.CHART.POWER_KW') } }, { id: 'energy-axis', position: 'right', ticks: { min: 0 }, scaleLabel: { display: true, labelString: this.$translate.instant('CHARGE.CHART.CHARGE_KWH') }, gridLines: { drawOnChartArea: false } }]
	                    },
	                    tooltips: {
	                        mode: 'point',
	                        intersect: true,
	                        callbacks: {
	                            label: function label(tooltipItem, data) {
	                                if (tooltipItem.datasetIndex === 0) {
	                                    return _this6.$filter('number')(tooltipItem.yLabel, 3) + 'kW';
	                                }
	                                if (tooltipItem.datasetIndex === 1) {
	                                    return _this6.$filter('number')(tooltipItem.yLabel, 3) + 'kWh';
	                                }
	                                if (tooltipItem.datasetIndex === 2) {
	                                    return _this6.$translate.instant('CHARGE.CHART.CONNECTOR_STATUS', { status: data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].status });
	                                }
	                                if (tooltipItem.datasetIndex === 3) {
	                                    return _this6.$translate.instant('CHARGE.CHART.CHARGEPOINT_STATUS', { status: data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].status });
	                                }
	                            }
	                        }
	                    },
	                    legend: {
	                        labels: {
	                            filter: function filter(legendItem) {
	                                if (legendItem.datasetIndex >= 2) return null;
	                                return legendItem;
	                            }
	                        }
	                    }
	                }
	            });
	        }
	    }, {
	        key: "setTabs",
	        value: function setTabs() {
	            var list = [{
	                id: 'info',
	                display: this.$translate.instant('CHARGE.TABS.INFO'),
	                url: 'info'
	            }, {
	                id: 'meter',
	                display: this.$translate.instant('CHARGE.TABS.METER'),
	                url: 'consumo'
	            }, {
	                id: 'values',
	                display: this.$translate.instant('CHARGE.TABS.VALUES'),
	                url: 'auditoria'
	            }];
	            var active = list[0];
	            if (this.tab && _lodash2.default.findIndex(list, { 'url': this.tab }) >= 0) {
	                active = list[_lodash2.default.findIndex(list, { 'url': this.tab })];
	            }
	            this.tabs['active'] = this.tabs['active'] || active;
	            this.tabs['list'] = list;
	        }
	    }, {
	        key: "setBreadcrums",
	        value: function setBreadcrums() {
	            this.App.setBreadcrumsSteps([{ display: this.$translate.instant('CHARGE.CHARGES'), href: this.$state.href('efimob.charges.at.list', { organization: this.organization }) }]);
	            this.App.setBreadcrumsRightActions([this.App.getActionBack(this.$state.href('efimob.charges.at.list', { organization: this.organization }), this.$translate.instant('CHARGE.BACK_TO_CHARGES')), this.App.getActionReload(this.reload)]);
	            if (this.ChargeHelper.isCharging(this.charge)) this.App.setBreadcrumsStatus([{ display: this.$translate.instant('CHARGE.BADGE_STATUS.CHARGING'), tooltip: this.$translate.instant('CHARGE.BADGE_STATUS.CHARGING_HELP'), type: 'alive' }]);
	            if (this.ChargeHelper.isFinished(this.charge)) this.App.setBreadcrumsStatus([{ display: this.$translate.instant('CHARGE.BADGE_STATUS.FINISHED'), tooltip: this.$translate.instant('CHARGE.BADGE_STATUS.FINISHED_HELP'), type: 'neutral' }]);
	            if (this.ChargeHelper.isFinishedWithError(this.charge)) this.App.setBreadcrumsStatus([{ display: this.$translate.instant('CHARGE.BADGE_STATUS.NOT_CLOSED'), tooltip: this.$translate.instant('CHARGE.BADGE_STATUS.NOT_CLOSED_HELP'), type: 'warning' }]);
	        }
	    }, {
	        key: "reloadMeterValues",
	        value: function reloadMeterValues(withParams) {
	            var _this7 = this;

	            // TODO: Paginate in order to get all the measures
	            if (!this.charge) return;
	            this.state.loading['meterValues'] = true;
	            var options = {
	                organization: this.organization
	            };
	            if (withParams) {
	                options.params = {
	                    measurand: 'Energy.Active.Import.Register,Power.Active.Import',
	                    phase: 'null',
	                    location: 'Outlet,null',
	                    orderby: 'timestamp,asc'
	                };
	            }
	            this.meterValues = null;
	            this.ChargeSessionsService.getChargeMeterValues(this.id, options).then(function (meterValues) {
	                _this7.meterValues = meterValues;
	                if (!_this7.charge.meter) _this7.charge.currentMeter = _this7.ChargeHelper.getCurrentMeter(_this7.charge, _this7.meterValues);
	            });
	            this.state.loading['meterValues'] = false;
	        }
	    }, {
	        key: "reloadStatusValues",
	        value: function reloadStatusValues() {
	            var _this8 = this;

	            if (!this.charge || !this.charge.start || !this.charge.start.dateTime) return;
	            var start = this.moment(this.charge.start.dateTime).subtract(10, 'seconds');
	            var stop = this.charge.stop && this.charge.stop.dateTime ? this.moment(this.charge.stop.dateTime).add(10, 'seconds') : this.moment();
	            var options = {
	                params: { from: start.toISOString(), to: stop.toISOString(), orderby: 'timestamp,asc' },
	                organization: this.organization
	            };
	            this.state.loading['statusValues'] = true;
	            this.statusValues = null;
	            this.ChargePointsService.getChargepointStatusValues(this.charge.chargepointId, options).then(function (data) {
	                _this8.statusValues = _lodash2.default.filter(data, function (item) {
	                    return item["connectorId"] == _this8.charge.connectorId || item["connectorId"] == 0;
	                });
	            });
	            this.state.loading['statusValues'] = false;
	        }
	    }, {
	        key: "reloadChargepoint",
	        value: function reloadChargepoint() {
	            var _this9 = this;

	            if (!this.charge || !this.charge.chargepointId) return;
	            this.state.loading['chargepoint'] = true;
	            this.ChargePointsService.getChargepoint(this.charge.chargepointId, { 'organization': this.organization || undefined }).then(function (chargepoint) {
	                _this9.chargepoint = chargepoint;
	            });
	            this.state.loading['chargepoint'] = false;
	        }
	    }, {
	        key: "isProvider",
	        value: function isProvider() {
	            return this.Auth.isProvider();
	        }
	    }, {
	        key: "isOpen",
	        value: function isOpen() {
	            return this.charge && this.charge.status == "Active";
	        }
	    }, {
	        key: "_reload",
	        value: function _reload() {
	            var _this10 = this;

	            this.state.loading['charge'] = true;
	            this.ChargeSessionsService.getCharge(this.id, { organization: this.organization, chargepointId: this.chargepointId }).then(function (charge) {
	                _this10.charge = charge;
	                _this10.setBreadcrums();
	                _this10.state.loading['charge'] = false;
	            }).catch(function () {
	                _this10.App.showNotification(_this10.$translate.instant('CHARGE.GETTING_CHARGE_FAILED'), 'error');
	                _this10.state.loading['charge'] = false;
	            });
	        }
	    }]);

	    return ChargeController;
	}();

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargesController = exports.ChargesController = function () {
	  ChargesController.$inject = ["$scope", "$state", "$stateParams", "$timeout", "$interval", "$translate", "App", "moment", "ChargeSessionsService", "Auth"];
	  function ChargesController($scope, $state, $stateParams, $timeout, $interval, $translate, App, moment, ChargeSessionsService, Auth) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ChargesController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.$interval = $interval;
	    this.$translate = $translate;
	    this.App = App;
	    this.moment = moment;
	    this.ChargeSessionsService = ChargeSessionsService;
	    this.Auth = Auth;

	    this.charges = null;
	    this.organization = $stateParams.organization;
	    this.group = $stateParams.group;

	    // Filters
	    this.filters = App.getTableFilters('charge');

	    this.filterControls = {};

	    // Table settings
	    this.table = App.getTable('charges', this.getCustom());

	    this.timer = $interval(function () {
	      return $scope.$applyAsync();
	    }, 1000);

	    $scope.$on('$destroy', function () {
	      if (_this.timer) $interval.cancel(_this.timer);
	      _this.timer = null;
	    });
	  }

	  _createClass(ChargesController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.onChargeClick = this.onChargeClick.bind(this);
	      this.toggleAdvancedFilters = this.toggleAdvancedFilters.bind(this);
	      this.reload = this.reload.bind(this);

	      this.setBreadcrums();
	      this.reload();
	    }
	  }, {
	    key: 'getCustom',
	    value: function getCustom() {
	      return this.Auth.isAdminOfGroup() || this.Auth.isDoerOfGroup() ? { omit: ['start.customerName', 'chargeCustomerName'] } : undefined;
	    }
	  }, {
	    key: 'toggleAdvancedFilters',
	    value: function toggleAdvancedFilters() {
	      if (this.filterControls['toggleAdvancedFilters']) this.filterControls['toggleAdvancedFilters']();
	    }
	  }, {
	    key: 'onChargeClick',
	    value: function onChargeClick(charge) {
	      this.$state.go('efimob.charges.at.item', { id: charge.id, organization: this.organization });
	    }
	  }, {
	    key: 'exportCharges',
	    value: function exportCharges() {
	      var _this2 = this;

	      var filters = this.filters,
	          organization = this.organization,
	          group = this.group;
	      var sorting = this.table.sorting;

	      var params = { output: 'csv', count: this.table.pagination.totalItems };

	      var options = { filters: filters, sorting: sorting, organization: organization, group: group, params: params };

	      this.ChargeSessionsService.getCharges(options, false, true).then(function ( /** @type {{docs: Blob, emailExport: boolean}} */charges) {
	        if (charges.emailExport) {
	          return _this2.App.showNotification(_this2.$translate.instant('EXPORT_BY_EMAIL'), 'ok');
	        }
	        _this2.App.downloadCSV(charges.docs, _this2.$translate.instant('CHARGES') + '-' + _this2.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      });
	    }
	  }, {
	    key: 'setBreadcrums',
	    value: function setBreadcrums() {
	      this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	      this.App.setBreadcrumsCurrentScope({
	        organizationId: this.organization,
	        groupId: this.group,
	        custom: this.organization,
	        title: this.$translate.instant('VIEW_CHARGES.OF')
	      });
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      var _this3 = this;

	      var options = {
	        filters: this.filters,
	        pagination: this.table.pagination,
	        sorting: this.table.sorting,
	        organization: this.organization,
	        group: this.group
	      };

	      this.App.setLoading(true);

	      this.ChargeSessionsService.getCharges(options).then(function (charges) {
	        _this3.charges = charges.docs;
	        _this3.table.pagination.currentPage = charges.currentPage;
	        _this3.table.pagination.totalItems = charges.totalItems;
	        _this3.App.setLoading(false);
	      }).catch(function () {
	        return _this3.App.setLoading(false);
	      });
	    }
	  }]);

	  return ChargesController;
	}();

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrganizationController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationController = exports.OrganizationController = function () {
	    OrganizationController.$inject = ["$scope", "$rootScope", "$state", "$stateParams", "App", "Auth", "UsersHelper", "OrganizationsHelper", "$filter", "$translate", "moment", "Organization", "ChargeHelper", "Utils", "$window"];
	    function OrganizationController($scope, $rootScope, $state, $stateParams, App, Auth, UsersHelper, OrganizationsHelper, $filter, $translate, moment, Organization, ChargeHelper, Utils, $window) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, OrganizationController);

	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$state = $state;
	        this.$stateParams = $stateParams;
	        this.App = App;
	        this.Auth = Auth;
	        this.UsersHelper = UsersHelper;
	        this.OrganizationsHelper = OrganizationsHelper;
	        this.$filter = $filter;
	        this.$translate = $translate;
	        this.moment = moment;
	        this.Organization = Organization;
	        this.ChargeHelper = ChargeHelper;
	        this.Utils = Utils;
	        this.$window = $window;

	        this.id = $stateParams.id;
	        this.organization = null;
	        this.privateData = null;
	        this.appVersions = null;
	        this.roles = null;
	        this.tab = $stateParams.tab;
	        this.payments = {};
	        this.allConsents = {};
	        this.owners = null;
	        this.fiscalInformation = {};
	        this.maintainers = null;

	        this.group = null;

	        // Properties panel settings
	        this.properties = {
	            general: {
	                keys: ['id', 'name | safe', 'partyId | safe'],
	                headers: [this.$translate.instant('ORGANIZATION.ID'), this.$translate.instant('ORGANIZATION.NAME'), this.$translate.instant('PARTY_ID')],
	                editable: ['name', 'partyId'],
	                meta: {
	                    partyId: {
	                        min: 3,
	                        max: 3
	                    }
	                },
	                onSave: function onSave(changes) {
	                    return _this.editOrganization(changes.changed);
	                }
	            },
	            right: {
	                keys: ['id', 'name | safe', 'supportEmailAddress'],
	                headers: [this.$translate.instant('ORGANIZATION.ID'), this.$translate.instant('ORGANIZATION.NAME'), this.$translate.instant('ORGANIZATION.SUPPORT')]
	            },
	            contact: {
	                keys: ['owner', 'supportEmailAddress'],
	                headers: [this.$translate.instant('ORGANIZATION.OWNER'), this.$translate.instant('ORGANIZATION.SUPPORT')],
	                editable: ['supportEmailAddress'],
	                onSave: function onSave(changes) {
	                    return _this.editOrganization(changes.changed);
	                }
	            },
	            noManagedInfo: {
	                keys: ['title | language:this.$parent.ctrl.state.noManagedLanguage', 'body | language:this.$parent.ctrl.state.noManagedLanguage'],
	                headers: [this.$translate.instant('ACTION.EDIT_NO_MANAGED.TITLE'), this.$translate.instant('ACTION.EDIT_NO_MANAGED.BODY')]
	            },
	            misc: {
	                keys: ['timeZone', 'CO2Factor | number'],
	                headers: [this.$translate.instant('ORGANIZATION.TIME_ZONE'), this.$translate.instant('ORGANIZATION.CO2_FACTOR')],
	                editable: ['timeZone', 'CO2Factor'],
	                meta: {
	                    timeZone: {
	                        info: 'La zona horaria a la que pertenece la empresa',
	                        type: 'select',
	                        options: [{ 'display': 'Europe/Madrid', 'id': 'Europe/Madrid' }, { 'display': 'Europe/Lisbon', 'id': 'Europe/Lisbon' }]
	                    },
	                    CO2Factor: {
	                        info: 'Este factor se usa para convertir los kWh recargados a kilos de CO2 ahorrados a la atmósfera\nUn valor típico es ' + this.$filter('number')(this.ChargeHelper.CO2KG_PER_KWH),
	                        type: 'number'
	                    }
	                },
	                onSave: function onSave(changes) {
	                    return _this.editOrganization(changes.changed);
	                }
	            },
	            validation: {
	                keys: ['notifications.email.validation.from', 'notifications.email.validation.subject.es', 'notifications.email.validation.preCodeBody.es'],
	                headers: [this.$translate.instant('ORGANIZATION.VALIDATION.FROM'), this.$translate.instant('ORGANIZATION.VALIDATION.SUBJECT'), this.$translate.instant('ORGANIZATION.VALIDATION.BODY')],
	                editable: true,
	                meta: {
	                    'notifications.email.validation.from': { info: this.$translate.instant('ORGANIZATION.VALIDATION.FROM_INFO'), help: this.$translate.instant('ORGANIZATION.VALIDATION.FROM_HELP') },
	                    'notifications.email.validation.preCodeBody.es': {
	                        type: 'html',
	                        info: this.$translate.instant('ORGANIZATION.VALIDATION.BODY_INFO'), help: this.$translate.instant('ORGANIZATION.VALIDATION.BODY_HELP') }
	                },
	                onSave: function onSave(changes) {
	                    return _this.editOrganizationNotifications(changes.changed);
	                }
	            },
	            appReports: {
	                keys: ['notifications.email.appReports.from', 'notifications.email.appReports.subjects.problem.es', 'notifications.email.appReports.subjects.suggestion.es', 'notifications.email.appReports.subjects.congratulation.es'],
	                headers: [this.$translate.instant('ORGANIZATION.VALIDATION.FROM'), this.$translate.instant('ORGANIZATION.REPORTS.SUBJECT_ERRORS'), this.$translate.instant('ORGANIZATION.REPORTS.SUBJECT_SUGGESTIONS'), this.$translate.instant('ORGANIZATION.REPORTS.SUBJECT_KUDOS')],
	                editable: true,
	                meta: {
	                    'notifications.email.appReports.from': { info: this.$translate.instant('ORGANIZATION.VALIDATION.FROM_INFO'), help: this.$translate.instant('ORGANIZATION.VALIDATION.FROM_HELP') }
	                },
	                onSave: function onSave(changes) {
	                    return _this.editOrganizationNotifications(changes.changed);
	                }
	            },
	            reservationQueues: {
	                keys: ['notifications.push.queueTurnConfirmation.body.es', 'notifications.push.queueTurnExpiration.body.es', 'notifications.push.maxChargingTime.body.es'],
	                headers: [this.$translate.instant('ORGANIZATION.NOTIFICATION_SHIFT_CONFIRMATION'), this.$translate.instant('ORGANIZATION.NOTIFICATION_EXPIRATION'), this.$translate.instant('ORGANIZATION.NOTIFICATION_MAX_CHARGING_TIME')],
	                editable: true,
	                meta: {
	                    'notifications.push.queueTurnConfirmation.body.es': {
	                        help: this.$translate.instant('ORGANIZATION.NOTIFICATION_SHIFT_CONFIRMATION_EXP')
	                    },
	                    'notifications.push.maxChargingTime.body.es': {
	                        help: this.$translate.instant('ORGANIZATION.NOTIFICATION_MAX_CHARGING_TIME_EXP')
	                    }
	                },
	                onSave: function onSave(changes) {
	                    return _this.editOrganizationNotifications(changes.changed);
	                }
	            },
	            privateUsers: {
	                keys: ['privateUsers'],
	                headers: [this.$translate.instant('PRIVATE_USERS')],
	                editable: true,
	                meta: {
	                    privateUsers: {
	                        help: this.$translate.instant('PRIVATE_USERS_EXP'),
	                        type: 'chips',
	                        conflict: { message: "INVALID_WITH", data: null },
	                        validate: function validate(item, config, data) {
	                            var valid = _this.Utils.validateEmailOrDomain(item);
	                            if (valid) {
	                                config.conflict.data = item;
	                                data.pop();
	                            } else {
	                                config.conflict.data = null;
	                            }
	                        }
	                    }
	                },
	                onSave: function onSave(changes) {
	                    return _this.editOrganizationPrivateUsers(changes.changed);
	                }
	            },
	            payments: {
	                keys: ["platform | capitalize", "entity | capitalize", "environment | organizationEnvironment:ctrl.item", "appFlavour | organizationAppFlavour:ctrl.item", "from | capitalize"],
	                headers: [this.$translate.instant("PLATFORM"), this.$translate.instant("ENTITY"), this.$translate.instant("ENVIRONMENT"), this.$translate.instant("APPFLAVOUR"), this.$translate.instant("Type")],
	                editable: ["appFlavour", "environment"],
	                meta: {
	                    appFlavour: {
	                        type: 'select',
	                        options: [{ display: "Efimob", id: "EfimobApp" }, { display: "Naturgy", id: "NaturgyApp" }, { display: "Melib", id: "MelibApp" }, { display: "CabildoGC", id: "CabildoGCApp" }]
	                    },
	                    environment: {
	                        type: 'select',
	                        options: [{ display: this.$translate.instant("DEVELOPMENT"), id: "test" }, { display: this.$translate.instant("PRODUCTION"), id: "prod" }]
	                    }
	                },
	                onSave: function onSave(changes) {
	                    return _this._editPayments(changes.changed);
	                }
	            },
	            consentSummaryInfo: {
	                keys: ['consentSummary | language:this.$parent.ctrl.state.consentSummaryLanguage'],
	                headers: [this.$translate.instant('TEXT')]
	            },
	            fiscalInformation: {
	                keys: ["receiptPrefix", "businessName", "vatNumber", "fullAddress", "phoneNumber", "email"],
	                headers: [this.$translate.instant("RECEIPT_PREFIX"), this.$translate.instant("BUSINESS_NAME"), this.$translate.instant("VAT_NUMBER"), this.$translate.instant("FULL_ADDRESS"), this.$translate.instant("PHONE_NUMBER"), this.$translate.instant("EMAIL")],
	                editable: true,
	                meta: {
	                    receiptPrefix: {
	                        warn: this.$translate.instant('FILLING_FIELD_ACTIVATES_RECEIPTS'),
	                        help: this.$translate.instant('ACTIVATE_FIELD_OBLIGES_ALL_OTHERS'),
	                        type: 'text',
	                        conflict: { message: "LENGTH_BETWEEN", data: null },
	                        onChange: function onChange(change, config) {
	                            if (angular.isDefined(change.model.value)) {
	                                if (!change.model.value || change.model.value === '') {
	                                    change.model.value = null;
	                                    config.conflict.data = null;
	                                } else {
	                                    var valid = _this.Utils.validateStringBetween(change.model.value, 1, 7);
	                                    if (!valid) {
	                                        config.conflict.data = "1-7";
	                                    } else {
	                                        config.conflict.data = null;
	                                    }
	                                }
	                            }
	                        }
	                    },
	                    businessName: {
	                        type: 'text',
	                        conflict: { message: "LENGTH_BETWEEN", data: null },
	                        onChange: function onChange(change, config) {
	                            if (angular.isDefined(change.model.value)) {
	                                var valid = _this.Utils.validateStringBetween(change.model.value, 1, 64);
	                                if (!valid && change.model.value !== '') {
	                                    config.conflict.data = "1-64";
	                                } else {
	                                    config.conflict.data = null;
	                                }
	                            }
	                        }
	                    },
	                    vatNumber: {
	                        type: 'text',
	                        conflict: { message: "LENGTH_BETWEEN", data: null },
	                        onChange: function onChange(change, config) {
	                            if (angular.isDefined(change.model.value)) {
	                                var valid = _this.Utils.validateStringBetween(change.model.value, 8, 16);
	                                if (!valid && change.model.value !== '') {
	                                    config.conflict.data = "8-16";
	                                } else {
	                                    config.conflict.data = null;
	                                }
	                            }
	                        }
	                    },
	                    fullAddress: {
	                        type: 'text',
	                        conflict: { message: "LENGTH_BETWEEN", data: null },
	                        onChange: function onChange(change, config) {
	                            if (angular.isDefined(change.model.value)) {
	                                var valid = _this.Utils.validateStringBetween(change.model.value, 1, 150);
	                                if (!valid && change.model.value !== '') {
	                                    config.conflict.data = "1-150";
	                                } else {
	                                    config.conflict.data = null;
	                                }
	                            }
	                        }
	                    },
	                    phoneNumber: {
	                        type: 'text',
	                        conflict: { message: "LENGTH_BETWEEN", data: null },
	                        onChange: function onChange(change, config) {
	                            if (angular.isDefined(change.model.value)) {
	                                var valid = _this.Utils.validateStringBetween(change.model.value, 8, 20);
	                                if (!valid && change.model.value !== '') {
	                                    config.conflict.data = "8-20";
	                                } else {
	                                    config.conflict.data = null;
	                                }
	                            }
	                        }
	                    },
	                    email: {
	                        type: 'text',
	                        conflict: { message: "LENGTH_BETWEEN", data: null },
	                        onChange: function onChange(change, config) {
	                            if (angular.isDefined(change.model.value)) {
	                                if (change.model.value !== '') {
	                                    var isValidString = _this.Utils.validateStringBetween(change.model.value, 6, 256);
	                                    var isValidEmail = _this.Utils.validateEmailComplete(change.model.value);
	                                    if (!isValidString) {
	                                        config.conflict = { message: "LENGTH_BETWEEN", data: "6-256" };
	                                    } else if (!isValidEmail) {
	                                        config.conflict = { message: "INVALID_EMAIL", data: change.model.value };
	                                    } else {
	                                        config.conflict.data = null;
	                                    }
	                                } else {
	                                    config.conflict.data = null;
	                                }
	                            }
	                        }
	                    }
	                },
	                onSave: function onSave(changes) {
	                    return _this._editFiscalInformation(changes.changed);
	                }
	            }
	        };

	        // Tabs settings
	        this.tabs = {
	            'active': null,
	            'list': [],
	            'left': true
	        };

	        this.tables = {
	            banners: _lodash2.default.defaults({}, this.App.getTable('banners', { 'omit': ['entity'] }), {
	                'actions': [{
	                    'tooltip': this.$translate.instant('ORGANIZATION.BANNER.ACTION.EDIT'),
	                    'icon': 'edit',
	                    'onClick': function onClick(banner) {
	                        return _this.askToEditBanner(banner);
	                    }
	                }, {
	                    'tooltip': this.$translate.instant('ORGANIZATION.BANNER.ACTION.REMOVE'),
	                    'icon': 'times-hexagon',
	                    'custom': 'danger',
	                    'onClick': function onClick(banner) {
	                        return _this.askToRemoveBanner(banner);
	                    }
	                }]
	            }),
	            roles: _lodash2.default.defaults({}, this.App.getTable('roles'), {
	                'actions': [{
	                    'tooltip': this.$translate.instant('ORGANIZATION.ROLES.ACTION.EDIT'),
	                    'icon': 'edit',
	                    'onClick': function onClick(user) {
	                        return _this.askToEditUser(user);
	                    }
	                }, {
	                    'tooltip': this.$translate.instant('ORGANIZATION.UNBLOCK'),
	                    'icon': 'unlock',
	                    'onClick': function onClick(user) {
	                        return _this.askToUnblockUser(user);
	                    }
	                }, {
	                    'tooltip': this.$translate.instant('ORGANIZATION.ROLES.ACTION.REMOVE'),
	                    'icon': 'ban',
	                    'onClick': function onClick(user) {
	                        return _this.askToRemoveUser(user);
	                    }
	                }]
	            }),
	            consents: _lodash2.default.defaults({}, App.getTable('consents'), {
	                actions: [{
	                    tooltip: this.$translate.instant('COMMON.EDIT'),
	                    icon: 'edit',
	                    onClick: function onClick(data, index) {
	                        return _this.askToEditConsent(data, index);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('COMMON.REMOVE'),
	                    icon: 'times-hexagon',
	                    custom: 'danger',
	                    onClick: function onClick(data, index) {
	                        return _this.askToRemoveConsent(data, index);
	                    }
	                }]
	            }),
	            owners: _lodash2.default.defaults({}, App.getTable('owners'), {
	                actions: [{
	                    tooltip: this.$translate.instant('COMMON.EDIT'),
	                    icon: 'edit',
	                    onClick: function onClick(data, index) {
	                        return _this.askToEditOwner(data, index);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('COMMON.REMOVE'),
	                    icon: 'times-hexagon',
	                    custom: 'danger',
	                    onClick: function onClick(data, index) {
	                        return _this.askToRemoveOwner(data, index);
	                    }
	                }]
	            }),
	            maintainers: _lodash2.default.defaults({}, App.getTable('maintainers'), {
	                actions: [{
	                    tooltip: this.$translate.instant('COMMON.EDIT'),
	                    icon: 'edit',
	                    onClick: function onClick(data, index) {
	                        return _this.askToEditMaintainer(data, index);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('COMMON.REMOVE'),
	                    icon: 'ban',
	                    onClick: function onClick(data, index) {
	                        return _this.askToRemoveMaintainer(data, index);
	                    }
	                }]
	            })
	        };

	        this.filters = {
	            maintainers: this.App.getTableFilters("maintainers", { context: this })
	        };

	        this.state = {
	            denyFreeCharging: null,
	            reservationQueues: null,
	            proxyEnabled: null,
	            noManagedLanguage: "es",
	            consentSummaryLanguage: 'es',
	            loading: {}
	        };

	        this.languages = this.App.getLanguages();
	    }

	    _createClass(OrganizationController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;

	            this.onDenyFreeChargingChanged = this.onDenyFreeChargingChanged.bind(this);
	            this.onProxyEnabledChanged = this.onProxyEnabledChanged.bind(this);
	            this.onReservationQueuesEnabledChanged = this.onReservationQueuesEnabledChanged.bind(this);
	            this.askToAddConsent = this.askToAddConsent.bind(this);
	            this.getPrivate = this.getPrivate.bind(this);
	            this.getMaintainers = this.getMaintainers.bind(this);

	            this.$scope.$watch('ctrl.organization', function () {
	                if (_this2.organization) {
	                    _this2.setState();
	                    _this2.setTabs();
	                }
	            });
	            this.$scope.$watch('ctrl.tabs.active', function () {
	                if (_this2.tabs.active) {
	                    switch (_this2.tabs.active.id) {
	                        case 'payments':
	                            _this2._reloadPayments();
	                            break;
	                        case 'appVersions':
	                            _this2.reloadAppVersions();
	                            break;
	                        case 'banners':
	                            _this2.setBanners();
	                            break;
	                        case 'consents':
	                            _this2.getConsents();
	                            break;
	                        case 'users':
	                            _this2.getPrivate();
	                            break;
	                        case 'owners':
	                            _this2.getOwners();
	                            break;
	                        case 'fiscalInformation':
	                            _this2.getFiscalInformation();
	                            break;
	                        case 'maintainers':
	                            _this2.getMaintainers();
	                            break;
	                    }
	                }
	            });
	            this.setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: 'askToEditConsent',
	        value: function askToEditConsent(data, index) {
	            var _this3 = this;

	            var options = { consents: this.allConsents.consents, index: index, organization: this.organization };
	            this.OrganizationsHelper.editConsent(this.$scope, data, options).then(function () {
	                return _this3.getConsents();
	            });
	        }
	    }, {
	        key: 'askToRemoveConsent',
	        value: function askToRemoveConsent(data, index) {
	            var _this4 = this;

	            var options = { consents: this.allConsents.consents, index: index, organization: this.organization };
	            this.OrganizationsHelper.removeConsent(this.$scope, data, options).then(function () {
	                return _this4.getConsents();
	            });
	        }
	    }, {
	        key: 'askToAddConsent',
	        value: function askToAddConsent() {
	            var _this5 = this;

	            var options = { consents: this.allConsents.consents, organization: this.organization };
	            this.OrganizationsHelper.addConsent(this.$scope, options).then(function () {
	                return _this5.getConsents();
	            });
	        }
	    }, {
	        key: 'askToEditConsentSummary',
	        value: function askToEditConsentSummary() {
	            var _this6 = this;

	            var options = { organization: this.organization };
	            this.OrganizationsHelper.editConsentSummary(this.$scope, this.allConsents.consentSummary, options).then(function () {
	                return _this6.getConsents();
	            });
	        }
	    }, {
	        key: 'getOwners',
	        value: function getOwners() {
	            var _this7 = this;

	            var options = { organization: this.organization };
	            this.Organization.getOwners(options).then(function (data) {
	                _this7.owners = data;
	                _this7.owners = _this7.owners.map(function (owner) {
	                    owner.organizationName = _this7.organization.name;
	                    return owner;
	                });
	            });
	        }
	    }, {
	        key: 'askToEditOwner',
	        value: function askToEditOwner(data, index) {
	            var _this8 = this;

	            var options = { notifications: true, owners: this.owners, index: index, organization: this.organization };
	            this.OrganizationsHelper.editOwner(this.$scope, data, options).then(function () {
	                return _this8.getOwners();
	            });
	        }
	    }, {
	        key: 'askToRemoveOwner',
	        value: function askToRemoveOwner(data) {
	            var _this9 = this;

	            var options = { notifications: true, owners: this.owners, organization: this.organization };
	            this.OrganizationsHelper.removeOwner(this.$scope, data, options).then(function () {
	                return _this9.getOwners();
	            });
	        }
	    }, {
	        key: 'askToAddOwner',
	        value: function askToAddOwner() {
	            var _this10 = this;

	            var options = { notifications: true, owners: this.owners, organization: this.organization };
	            this.OrganizationsHelper.addOwner(this.$scope, options).then(function () {
	                return _this10.getOwners();
	            });
	        }
	    }, {
	        key: 'getFiscalInformation',
	        value: function getFiscalInformation() {
	            var _this11 = this;

	            var options = { organization: this.organization };
	            this.Organization.getFiscalInformation(options).then(function (data) {
	                _this11.fiscalInformation = data;
	            });
	        }
	    }, {
	        key: 'isOwner',
	        value: function isOwner(user) {
	            return user && user.username && user.username && this.privateData && this.privateData.general && user.username === this.privateData.general.owner;
	        }
	    }, {
	        key: 'isProvider',
	        value: function isProvider() {
	            return this.Auth.isProvider();
	        }
	    }, {
	        key: 'editOrganization',
	        value: function editOrganization(changed) {
	            var _this12 = this;

	            return this.Organization.editOrganization(this.organization.id, changed).then(function () {
	                return _this12.reload();
	            });
	        }
	    }, {
	        key: 'onDenyFreeChargingChanged',
	        value: function onDenyFreeChargingChanged(newValue) {
	            var _this13 = this;

	            this.state.loading['denyFreeCharging'] = true;
	            this.Organization.editOrganizationAsProvider(this.organization.id, { 'denyFreeCharging': newValue ? true : false }).then(function () {
	                _this13.state.loading['denyFreeCharging'] = false;
	                _this13.App.showNotification(_this13.$translate.instant('ORGANIZATION.DENY_FREE_CHARGING_OK'));
	                _this13.reload();
	            }).catch(function () {
	                _this13.state.loading['denyFreeCharging'] = false;
	                _this13.App.showNotification(_this13.$translate.instant('ORGANIZATION.DENY_FREE_CHARGING_FAILED'), 'error');
	            });
	        }
	    }, {
	        key: 'onProxyEnabledChanged',
	        value: function onProxyEnabledChanged(newValue) {
	            var _this14 = this;

	            var data = {
	                proxyEnabled: newValue ? true : false
	            };
	            var options = {
	                notifications: true,
	                UiReload: false
	            };
	            this.state.loading['proxyEnabled'] = true;
	            this.Organization.editOrganizationAsProvider(this.organization.id, data, options).then(function () {
	                _this14.state.loading['proxyEnabled'] = false;
	                _this14.reload();
	            });
	        }
	    }, {
	        key: 'onReservationQueuesEnabledChanged',
	        value: function onReservationQueuesEnabledChanged(newValue) {
	            var _this15 = this;

	            this.state.loading['reservationQueues'] = true;
	            this.Organization.editOrganizationAsProvider(this.organization.id, { 'reservationQueues': newValue ? true : false }).then(function () {
	                _this15.state.loading['reservationQueues'] = false;
	                _this15.App.showNotification(_this15.$translate.instant(newValue ? 'ORGANIZATION.RESERVATION_QUEUES_ENABLED_OK' : 'ORGANIZATION.RESERVATION_QUEUES_ENABLED_KO', { 'name': _this15.$filter('safe')(_this15.organization.name) }));
	                _this15.reload();
	            }).catch(function () {
	                _this15.state.loading['reservationQueues'] = false;
	                _this15.App.showNotification(_this15.$translate.instant('ORGANIZATION.REQUEST_FAILED'), 'error');
	            });
	        }
	    }, {
	        key: 'editOrganizationNotifications',
	        value: function editOrganizationNotifications(changed) {
	            var _this16 = this;

	            var payload = {
	                'notifications': _lodash2.default.get(this.organization, 'notifications', undefined)
	            };
	            _lodash2.default.each(changed, function (value, path) {
	                return _lodash2.default.set(payload, path, value === "" ? undefined : value);
	            });
	            return this.Organization.editOrganization(this.organization.id, payload).then(function () {
	                return _this16.reload();
	            });
	        }
	    }, {
	        key: 'editOrganizationPrivateUsers',
	        value: function editOrganizationPrivateUsers(changed) {
	            var _this17 = this;

	            var payload = {
	                'privateUsers': _lodash2.default.get(this.organization, 'privateUsers', undefined)
	            };
	            _lodash2.default.each(changed, function (value, path) {
	                return _lodash2.default.set(payload, path, value === "" ? undefined : value);
	            });
	            return this.Organization.editOrganization(this.organization.id, payload).then(function () {
	                return _this17.reload();
	            });
	        }
	    }, {
	        key: 'getNoManagedLanguagesSet',
	        value: function getNoManagedLanguagesSet() {
	            var _this18 = this;

	            var total = 0;
	            if (this.organization && this.organization.noManagedInfo && this.organization.noManagedInfo.title && this.organization.noManagedInfo.body) {
	                _lodash2.default.each(this.languages, function (lang) {
	                    if (_this18.organization.noManagedInfo.title[lang.id] && _this18.organization.noManagedInfo.body[lang.id]) total++;
	                });
	            }
	            return total;
	        }
	    }, {
	        key: 'askToEditNoManagedChargepoints',
	        value: function askToEditNoManagedChargepoints() {
	            var _this19 = this;

	            this.$scope.modal = {
	                lang: {
	                    option: this.state.noManagedLanguage,
	                    options: this.languages
	                },
	                noManagedInfo: _lodash2.default.cloneDeep(this.organization.noManagedInfo) || {},
	                isValid: function isValid() {
	                    return true;
	                },
	                done: function done() {
	                    _this19.doEditNoManagedChargepoints(_this19.$scope.modal.noManagedInfo, _this19.$scope.modal);
	                }
	            };
	            if (!this.$scope.modal.noManagedInfo.title) this.$scope.modal.noManagedInfo.title = {};
	            if (!this.$scope.modal.noManagedInfo.body) this.$scope.modal.noManagedInfo.body = {};
	            this.App.openModal(this.$scope, "edit-no-managed-chargers.html", { "size": "lg" });
	        }
	    }, {
	        key: 'doEditNoManagedChargepoints',
	        value: function doEditNoManagedChargepoints(noManagedInfo, modal) {
	            var _this20 = this;

	            modal.state = 'working';
	            var payload = { noManagedInfo: _lodash2.default.pick(noManagedInfo, ['title', 'body']) };
	            return this.Organization.editOrganization(this.organization.id, payload).then(function () {
	                _this20.App.showNotification(_this20.$translate.instant('ACTION.EDIT_NO_MANAGED.EDIT_OK'));
	                _this20.App.closeModal();
	                _this20.reload();
	            }).catch(function () {
	                _this20.App.showNotification(_this20.$translate.instant('ACTION.EDIT_NO_MANAGED.EDIT_FAILED'), 'error');
	                _this20.App.closeModal();
	            });
	        }
	    }, {
	        key: 'askToAddBanner',
	        value: function askToAddBanner() {
	            var _this21 = this;

	            return this.OrganizationsHelper.addBanner(this.$scope, { organization: this.organization, banners: this.banners }).then(function () {
	                return _this21.setBanners();
	            });
	        }
	    }, {
	        key: 'askToEditBanner',
	        value: function askToEditBanner(banner) {
	            var _this22 = this;

	            return this.OrganizationsHelper.editBanner(this.$scope, banner, { organization: this.organization, banners: this.banners }).then(function () {
	                return _this22.setBanners();
	            });
	        }
	    }, {
	        key: 'askToRemoveBanner',
	        value: function askToRemoveBanner(banner) {
	            var _this23 = this;

	            return this.OrganizationsHelper.removeBanner(this.$scope, banner, { organization: this.organization, banners: this.banners }).then(function () {
	                return _this23.setBanners();
	            });
	        }
	    }, {
	        key: 'askToAddUser',
	        value: function askToAddUser() {
	            var _this24 = this;

	            this.UsersHelper.addRole(this.$scope, { organization: this.organization }, { organization: this.organization.id }).then(function () {
	                return _this24.getPrivate();
	            });
	        }
	    }, {
	        key: 'askToEditUser',
	        value: function askToEditUser(user) {
	            var _this25 = this;

	            this.UsersHelper.editRole(this.$scope, user, { organization: this.organization }, { organization: this.organization.id }).then(function () {
	                if (_this25.Auth.isMe(user)) {
	                    _this25.$window.location.reload();
	                } else {
	                    _this25.getPrivate();
	                }
	            });
	        }
	    }, {
	        key: 'askToUnblockUser',
	        value: function askToUnblockUser(user) {
	            var _this26 = this;

	            this.UsersHelper.unblockUser(this.$scope, user, { organization: this.organization.id }).then(function () {
	                return _this26.reload();
	            });
	        }
	    }, {
	        key: 'askToRemoveUser',
	        value: function askToRemoveUser(user) {
	            var _this27 = this;

	            this.UsersHelper.removeRole(this.$scope, user, { organization: this.organization }, { organization: this.organization.id }).then(function () {
	                if (_this27.Auth.isMe(user)) {
	                    _this27.$window.location.reload();
	                } else {
	                    _this27.getPrivate();
	                }
	            });
	        }
	    }, {
	        key: 'getPrivate',
	        value: function getPrivate() {
	            var _this28 = this;

	            var options = {
	                pagination: this.tables.roles.pagination,
	                sorting: this.tables.roles.sorting
	            };
	            this.App.setLoading(true);
	            return this.Organization.getOrganizationPrivate(this.id, options, true).then(function (privateData) {
	                _this28.privateData = privateData.docs;
	                _this28.organization.owner = privateData.docs.general.owner;
	                _this28.tables.roles.pagination.currentPage = privateData.currentPage;
	                _this28.tables.roles.pagination.totalItems = privateData.totalItems;
	                _this28.roles = privateData.docs.roles;
	                _this28.App.setLoading(false);
	            });
	        }
	    }, {
	        key: 'setTabs',
	        value: function setTabs() {
	            var _this29 = this;

	            var list = [{
	                id: 'info',
	                display: this.$translate.instant('ORGANIZATION.TAB.INFO'),
	                url: 'info'
	            }, {
	                id: 'emails',
	                display: this.$translate.instant('ORGANIZATION.TAB.EMAILS'),
	                url: 'emails'
	            }, {
	                id: 'banners',
	                display: this.$translate.instant('ORGANIZATION.TAB.BANNERS'),
	                url: 'banners',
	                count: function count() {
	                    return _this29.banners ? _this29.banners.length : '...';
	                }
	            }, {
	                id: 'users',
	                display: this.$translate.instant('ORGANIZATION.TAB.USERS'),
	                url: 'personal',
	                hide: !(this.isAdmin() || this.isProvider()),
	                count: function count() {
	                    return _this29.tables.roles.pagination.totalItems ? _this29.tables.roles.pagination.totalItems : '...';
	                }
	            }, {
	                id: 'payments',
	                display: this.$translate.instant('PAYMENTS'),
	                url: 'payments',
	                hide: !this.isProvider()
	            }, {
	                id: 'consents',
	                display: this.$translate.instant('CONSENTS'),
	                url: 'consents',
	                hide: !(this.isAdmin() || this.isProvider()),
	                count: function count() {
	                    return _this29.allConsents.consents ? _this29.allConsents.consents.length : '...';
	                }
	            }, {
	                id: 'owners',
	                display: this.$translate.instant('OWNERS'),
	                url: 'owners',
	                hide: !(this.isAdmin() || this.isProvider()),
	                count: function count() {
	                    return _this29.owners ? _this29.owners.length : '...';
	                }
	            }, {
	                id: 'fiscalInformation',
	                display: this.$translate.instant('FISCAL_INFORMATION'),
	                url: 'fiscalInformation',
	                hide: !(this.isAdmin() || this.isProvider())
	            }, {
	                id: 'maintainers',
	                display: this.$translate.instant('MAINTAINERS'),
	                url: 'maintainers',
	                hide: !(this.isAdmin() || this.isProvider()),
	                count: function count() {
	                    return _this29.maintainers ? _this29.maintainers.length : '...';
	                }
	            }];
	            var active = list[0];
	            if (this.tab && _lodash2.default.findIndex(list, { url: this.tab }) >= 0) {
	                active = list[_lodash2.default.findIndex(list, { url: this.tab })];
	            }
	            this.tabs['active'] = this.tabs['active'] || active;
	            this.tabs['list'] = list;
	        }
	    }, {
	        key: 'isAdmin',
	        value: function isAdmin() {
	            return this.Auth.isAdmin();
	        }
	    }, {
	        key: 'setState',
	        value: function setState() {
	            if (this.organization) {
	                this.state.denyFreeCharging = !!this.organization.denyFreeCharging;
	                this.state.reservationQueues = !!this.organization.reservationQueues;
	                this.state.proxyEnabled = !!this.organization.proxyEnabled;
	            }
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            if (this.organization) this.App.setBreadcrumsTitle(this.organization.name);
	            this.App.setBreadcrumsSteps([{ display: this.$translate.instant('ORGANIZATION.ORGANIZATION') }]);
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload.bind(this))]);
	        }
	    }, {
	        key: 'setNoManagedInfo',
	        value: function setNoManagedInfo() {
	            if (this.organization && !this.organization.noManagedInfo) {
	                this.organization.noManagedInfo = {};
	            }
	        }
	    }, {
	        key: 'setBanners',
	        value: function setBanners() {
	            if (this.organization) {
	                this.banners = this.organization["appMessages"] || [];
	            }
	        }
	    }, {
	        key: 'reloadBanners',
	        value: function reloadBanners() {
	            var _this30 = this;

	            return this.Organization.getBanners({
	                pagination: this.tables.banners.pagination,
	                sorting: this.tables.banners.sorting,
	                organization: this.id
	            }).then(function (banners) {
	                return _this30.banners = banners;
	            });
	        }
	    }, {
	        key: 'reloadAppVersions',
	        value: function reloadAppVersions() {
	            var _this31 = this;

	            var options = {
	                pagination: this.tables.appVersions.pagination,
	                sorting: this.tables.appVersions.sorting,
	                organization: this.id
	            };
	            return this.Organization.getOrganizationAppVersions(this.id, options).then(function (appVersions) {
	                return _this31.appVersions = appVersions;
	            });
	        }
	    }, {
	        key: '_reloadPayments',
	        value: function _reloadPayments() {
	            var _this32 = this;

	            return this.Organization.getPayments(this.id).then(function (payments) {
	                return _this32.payments = payments;
	            });
	        }
	    }, {
	        key: '_editPayments',
	        value: function _editPayments(changed) {
	            var _this33 = this;

	            var payload = {
	                platform: _lodash2.default.get(this.payments, "platform", undefined),
	                entity: _lodash2.default.get(this.payments, "entity", undefined),
	                environment: _lodash2.default.get(this.payments, "environment", undefined),
	                appFlavour: _lodash2.default.get(this.payments, "appFlavour", undefined)
	            };
	            _lodash2.default.each(changed, function (value, path) {
	                return _lodash2.default.set(payload, path, value === "" ? undefined : value);
	            });
	            return this.Organization.editPayments(this.organization.id, payload).then(function () {
	                return _this33._reloadPayments();
	            });
	        }
	    }, {
	        key: 'getConsents',
	        value: function getConsents() {
	            var _this34 = this;

	            this.Organization.getConsents(this.organization.id).then(function (data) {
	                _this34.allConsents = {
	                    consentSummary: data.consentSummary || {},
	                    consents: data.consents || []
	                };
	            });
	        }
	    }, {
	        key: 'askToEditMaintainer',
	        value: function askToEditMaintainer(data, index) {
	            var _this35 = this;

	            var options = {
	                notifications: true,
	                maintainers: this.maintainers,
	                index: index,
	                organizationId: this.id
	            };
	            this.OrganizationsHelper.editMaintainer(this.$scope, data, options).then(function () {
	                return _this35.getMaintainers();
	            });
	        }
	    }, {
	        key: 'askToRemoveMaintainer',
	        value: function askToRemoveMaintainer(data) {
	            var _this36 = this;

	            var options = {
	                notifications: true,
	                organizationId: this.id
	            };
	            this.OrganizationsHelper.removeMaintainer(this.$scope, data, options).then(function () {
	                return _this36.getMaintainers();
	            });
	        }
	    }, {
	        key: 'askToAddMaintainer',
	        value: function askToAddMaintainer() {
	            var _this37 = this;

	            var options = {
	                notifications: true,
	                maintainers: this.maintainers,
	                organizationId: this.id
	            };
	            this.OrganizationsHelper.addMaintainer(this.$scope, options).then(function () {
	                return _this37.getMaintainers();
	            });
	        }
	    }, {
	        key: 'getMaintainers',
	        value: function getMaintainers() {
	            var _this38 = this;

	            var options = {
	                filters: this.filters.maintainers,
	                pagination: this.tables.maintainers.pagination,
	                sorting: this.tables.maintainers.sorting,
	                organizationId: this.id
	            };
	            this.Organization.getMaintainers(options).then(function (data) {
	                _this38.maintainers = data.docs;
	                _this38.tables.maintainers.pagination.currentPage = data.currentPage;
	                _this38.tables.maintainers.pagination.totalItems = data.totalItems;
	            });
	        }
	    }, {
	        key: 'isAdminProvider',
	        value: function isAdminProvider() {
	            return this.Auth.isAdmin() && this.Auth.isProvider();
	        }
	    }, {
	        key: 'isAdminOfOrganization',
	        value: function isAdminOfOrganization() {
	            return this.Auth.isAdminOfOrganization();
	        }
	    }, {
	        key: 'uploadCsvFile',
	        value: function uploadCsvFile() {
	            this.OrganizationsHelper.uploadUserkeysXlsx(this.$scope, { organizationId: this.organization.id });
	        }
	    }, {
	        key: '_editFiscalInformation',
	        value: function _editFiscalInformation(changed) {
	            var _this39 = this;

	            if (Object.keys(changed).length > 0) {
	                var options = {
	                    organization: this.organization,
	                    notifications: true
	                };
	                return this.Organization.editFiscalInformation(angular.merge({}, this.fiscalInformation, changed), options).then(function () {
	                    return _this39.getFiscalInformation();
	                });
	            }
	            return Promise.resolve();
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this40 = this;

	            this.App.setLoading(true);
	            this.Organization.getOrganization(this.id).then(function (organization) {
	                _this40.organization = organization;
	                _this40.setNoManagedInfo();
	                _this40.setState();
	                _this40.setBreadcrums();
	                _this40.App.setLoading(false);
	            }).catch(function () {
	                _this40.setState();
	                _this40.setBreadcrums();
	                _this40.App.setLoading(false);
	            });
	        }
	    }]);

	    return OrganizationController;
	}();

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OrganizationsController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var OrganizationsController = exports.OrganizationsController = function () {
	    OrganizationsController.$inject = ["$scope", "$state", "App", "UsersHelper", "$translate", "Organization"];
	    function OrganizationsController($scope, $state, App, UsersHelper, $translate, Organization) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, OrganizationsController);

	        this.$scope = $scope;
	        this.$state = $state;
	        this.App = App;
	        this.$translate = $translate;
	        this.UsersHelper = UsersHelper;
	        this.Organization = Organization;

	        this.organizations = null;
	        this.filterControls = {};
	        this.filters = App.getTableFilters("organization");
	        // Table settings
	        this.table = _lodash2.default.defaults({}, {
	            actions: [{
	                tooltip: this.$translate.instant('ORGANIZATIONS.REMOVE'),
	                icon: 'times-hexagon',
	                custom: 'danger',
	                onlyIf: function onlyIf(organization) {
	                    return _this.canOrganizationBeRemoved(organization);
	                },
	                onClick: function onClick(organization) {
	                    return _this.askToRemoveOrganization(organization);
	                }
	            }]
	        }, App.getTable('organizations'));
	    }

	    _createClass(OrganizationsController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.reload = this.reload.bind(this);
	            this.next = this.next.bind(this);
	            this.isValid = this.isValid.bind(this);
	            this.onOrganizationClick = this.onOrganizationClick.bind(this);
	            this.askToAddOrganization = this.askToAddOrganization.bind(this);

	            this.setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: "onOrganizationClick",
	        value: function onOrganizationClick(organization) {
	            this.$state.go('efimob.organizations.item', { 'id': organization.id });
	        }
	    }, {
	        key: "canOrganizationBeRemoved",
	        value: function canOrganizationBeRemoved(organization) {
	            return !!organization.removable;
	        }
	    }, {
	        key: "askToRemoveOrganization",
	        value: function askToRemoveOrganization(organization) {
	            this.$scope.modal = { organization: organization };
	            this.App.openModal(this.$scope, 'remove-organization.html', { 'size': 'sm' });
	        }
	    }, {
	        key: "removeOrganization",
	        value: function removeOrganization(organization) {
	            var _this2 = this;

	            this.Organization.removeOrganization(organization.id).then(function () {
	                _this2.reload();
	                _this2.App.closeModal();
	            }).catch(function () {
	                _this2.App.showNotification(_this2.$translate.instant('ORGANIZATIONS.REMOVE_FAILED'), 'error');
	                _this2.App.closeModal();
	            });
	        }
	    }, {
	        key: "isValid",
	        value: function isValid(modal, scope) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'id') {
	                return this.App.isValidId(this.$scope.modal.organization.id);
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'info') {
	                return scope.forms.modal.name.$valid;
	            }
	            if (modal.wizard.steps[modal.wizard.step].id === 'contact') {
	                return scope.forms.modal.contact.$valid;
	            }
	            return true;
	        }
	    }, {
	        key: "next",
	        value: function next(modal) {
	            if (modal.wizard.steps[modal.wizard.step].id === 'id') {
	                this.$scope.modal.organization.name = _lodash2.default.startCase(modal.organization.id);
	            }
	        }
	    }, {
	        key: "askToAddOrganization",
	        value: function askToAddOrganization() {
	            var _this3 = this;

	            this.$scope.modal = {
	                organization: { 'id': null, 'name': null, 'contact': null },
	                // alsoCreateAdminRole: true,
	                wizard: {
	                    step: 0,
	                    steps: [{ 'id': 'id', 'title': this.$translate.instant('ORGANIZATIONS.MODAL.ID'), 'intro': this.$translate.instant('ORGANIZATIONS.MODAL.ENTER_ID') }, { 'id': 'info', 'title': this.$translate.instant('ORGANIZATIONS.MODAL.INFO'), 'intro': this.$translate.instant('ORGANIZATIONS.MODAL.ENTER_INFO') }, { 'id': 'contact', 'title': this.$translate.instant('ORGANIZATIONS.MODAL.CONTACT'), 'intro': this.$translate.instant('ORGANIZATIONS.MODAL.ENTER_CONTACT') }, { 'id': 'recap', 'title': this.$translate.instant('ORGANIZATIONS.MODAL.RECAP'), 'intro': this.$translate.instant('ORGANIZATIONS.MODAL.CHECK_RECAP') }]
	                },
	                isValid: this.isValid,
	                next: this.next,
	                done: function done() {
	                    return _this3.addOrganization(_this3.$scope.modal.organization);
	                }
	            };
	            this.App.openModal(this.$scope, 'add-organization.html', { 'size': 'lg' });
	        }
	    }, {
	        key: "addOrganization",
	        value: function addOrganization(organization) {
	            var _this4 = this;

	            this.App.hideNotification();
	            return this.UsersHelper.createUserIfNeeded({ username: organization.contact, role: 'admin' }, organization).then(function (newUser) {
	                return _this4.Organization.addOrganization(organization.id, _lodash2.default.omit(organization, ['id'])).then(function () {
	                    _this4.reload();
	                    _this4.App.showNotification(newUser ? _this4.$translate.instant('ORGANIZATIONS.ADDED_ORGANIZATION_AND_USER') : _this4.$translate.instant('ORGANIZATIONS.ADDED_ORGANIZATION'));
	                    _this4.App.closeModal();
	                }).catch(function () {
	                    _this4.App.showNotification(_this4.$translate.instant('ORGANIZATIONS.ADD_ORGANIZATION_FAILED', { 'name': '<accent>' + organization.id + '</accent>' }), 'error');
	                    _this4.App.closeModal();
	                });
	            }).catch(function () {
	                _this4.App.showNotification(_this4.$translate.instant('ORGANIZATIONS.ADD_ORGANIZATION_FAILED_WHEN_USER'), 'error');
	                _this4.App.closeModal();
	            });
	        }
	    }, {
	        key: "setBreadcrums",
	        value: function setBreadcrums() {
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	        }
	    }, {
	        key: "reload",
	        value: function reload() {
	            var _this5 = this;

	            this.App.setLoading(true);
	            var options = {
	                filters: this.filters,
	                pagination: this.table.pagination,
	                sorting: this.table.sorting
	            };
	            return this.Organization.getOrganizations(options).then(function (organizations) {
	                _this5.organizations = organizations;
	                _this5.App.setLoading(false);
	            }).catch(function () {
	                return _this5.App.setLoading(false);
	            });
	        }
	    }]);

	    return OrganizationsController;
	}();

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GroupController = exports.GroupController = function () {
	  GroupController.$inject = ["$scope", "$state", "$stateParams", "moment", "$translate", "$filter", "$rootScope", "App", "Cache", "GroupsService", "ChargeSessionsService", "ChargePointsService", "UsersService", "GroupsHelper", "UsersHelper", "ChargeHelper", "ChargepointHelper", "UserKeyHelper", "Utils", "Auth", "Organization", "StaticListService", "TariffsHelperService", "TariffsService", "OperationService", "OperationsHelperService", "MarginService", "MarginHelperService"];
	  function GroupController($scope, $state, $stateParams, moment, $translate, $filter, $rootScope, App, Cache, GroupsService, ChargeSessionsService, ChargePointsService, UsersService, GroupsHelper, UsersHelper, ChargeHelper, ChargepointHelper, UserKeyHelper, Utils, Auth, Organization, StaticListService, TariffsHelperService, TariffsService, OperationService, OperationsHelperService, MarginService, MarginHelperService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, GroupController);

	    this.$scope = $scope;
	    this.$state = $state;
	    this.moment = moment;
	    this.$translate = $translate;
	    this.$filter = $filter;
	    this.$rootScope = $rootScope;
	    this.App = App;
	    this.Cache = Cache;
	    this.Utils = Utils;
	    this.Auth = Auth;

	    this.GroupsService = GroupsService;
	    this.ChargeSessionsService = ChargeSessionsService;
	    this.ChargePointsService = ChargePointsService;
	    this.UsersService = UsersService;
	    this.GroupsHelper = GroupsHelper;
	    this.UsersHelper = UsersHelper;
	    this.ChargeHelper = ChargeHelper;
	    this.ChargepointHelper = ChargepointHelper;
	    this.UserKeyHelper = UserKeyHelper;
	    this.Organization = Organization;
	    this.StaticListService = StaticListService;
	    this.TariffsHelperService = TariffsHelperService;
	    this.TariffsService = TariffsService;
	    this.OperationService = OperationService;
	    this.OperationsHelperService = OperationsHelperService;
	    this.MarginService = MarginService;
	    this.MarginHelperService = MarginHelperService;

	    this.tab = $stateParams.tab;
	    this.map = App.getMap();
	    this.id = $stateParams.id;
	    this.organization = $stateParams.organization;
	    this.group = null;
	    this.roles = null;
	    this.tariffs = null;
	    this.operations = null;
	    this.owners = [];
	    this.maintainers = [];
	    this.margins = null;

	    this.countryCodes = this.StaticListService.getCountryCodes();

	    // Properties panel settings
	    this.properties = this._getProperties();

	    // Tabs settings
	    this.tabs = {
	      'active': null,
	      'list': [],
	      'left': true

	      // Filters settings
	    };this.filters = {
	      charges: App.getTableFilters("charge"),
	      userkeys: App.getTableFilters("userKey", { context: this, omit: ["group"] }),
	      tariffs: App.getTableFilters("tariffs", { context: this, omit: ["groupId", "includeGroups", "search"] }),
	      margins: App.getTableFilters("margins")

	      // Tables settings
	    };this.tables = {
	      charges: App.getTable("charges", this.getCustom()),
	      chargepoints: App.getTable('chargepoints', { omit: ['organizationId', 'groupId', 'hash'] }),
	      chargepointsWithProgramedReboots: App.getTable('chargepointsWithProgramedReboots'),
	      userkeys: _lodash2.default.defaults({}, App.getTable('validUserkeys'), {
	        actions: [{
	          tooltip: this.$translate.instant('GROUP_ACTIONS_REMOVE_USERKEY_REVOKE_AUTH_FOR_THIS'),
	          icon: 'ban',
	          onlyIf: function onlyIf(userkey) {
	            return _this.canUserkeyBeRemoved(userkey);
	          },
	          onClick: function onClick(userkey) {
	            return _this.askToRemoveUserkey(userkey);
	          }
	        }]
	      }),
	      tariffs: _lodash2.default.defaults({}, App.getTable('tariffs'), {
	        actions: [{
	          tooltip: $translate.instant('REMOVE'),
	          icon: 'times-hexagon',
	          custom: 'danger',
	          onlyIf: function onlyIf(tariff) {
	            return _this.TariffsHelperService.hasGroup(tariff, _this.group.id);
	          },
	          onClick: function onClick(tariff) {
	            var options = {
	              id: tariff.id,
	              notifications: true
	            };

	            return TariffsHelperService.removeTariff($scope, tariff, options).then(function (options) {
	              if (options) {
	                _this.TariffsService.remove(options).then(function () {
	                  return _this.reloadTariffs();
	                });
	              }
	            });
	          }
	        }]
	      }),
	      roles: _lodash2.default.defaults({}, App.getTable('roles'), {
	        actions: [{
	          tooltip: this.$translate.instant('GROUP_ROLES_EDIT_ROLE'),
	          icon: 'edit',
	          onlyIf: function onlyIf(role) {
	            return _this.canRoleBeRemoved(role);
	          },
	          onClick: function onClick(role) {
	            return _this.askToEditRole(role);
	          }
	        }, {
	          tooltip: this.$translate.instant('GROUP_ROLES_REMOVE_ROLE'),
	          icon: 'ban',
	          onlyIf: function onlyIf(role) {
	            return _this.canRoleBeRemoved(role);
	          },
	          onClick: function onClick(role) {
	            return _this.askToRemoveRole(role);
	          }
	        }]
	      }),
	      maintainers: _lodash2.default.defaults({}, App.getTable('maintainers'), {
	        actions: [{
	          tooltip: this.$translate.instant('COMMON.REMOVE'),
	          icon: 'ban',
	          onlyIf: function onlyIf() {
	            return _this.isAdminOfOrganization() || _this.isProvider();
	          },
	          onClick: function onClick(data, index) {
	            return _this.askToUnassignMaintainer(data, index);
	          }
	        }]
	      }),
	      operations: _lodash2.default.defaults({}, App.getTable('operations', { omit: ['agreements', 'locations'] }), {
	        actions: [{
	          tooltip: $translate.instant('REMOVE'),
	          icon: 'times-hexagon',
	          custom: 'danger',
	          onlyIf: function onlyIf() {
	            return _this.Auth.isProvider();
	          },
	          onClick: function onClick(operation) {
	            var options = { locationId: _this.group.id, notifications: true };
	            _this.OperationsHelperService.removeOperationFromLocation(_this.$scope, operation, options).then(function () {
	              return _this.reloadOperations();
	            });
	          }
	        }]
	      }),
	      margins: _lodash2.default.defaults({}, App.getTable('margins'), {
	        actions: [{
	          tooltip: this.$translate.instant('EDIT_MARGIN'),
	          icon: 'edit',
	          onlyIf: function onlyIf() {
	            return _this.isAdmin();
	          },
	          onClick: function onClick(margin) {
	            return _this.editMargin(margin);
	          }
	        }, {
	          tooltip: this.$translate.instant('REMOVE_MARGIN'),
	          icon: 'ban',
	          onlyIf: function onlyIf() {
	            return _this.isAdmin();
	          },
	          onClick: function onClick(margin) {
	            return _this.removeMargin(margin);
	          }
	        }]
	      })
	    };

	    this.state = {
	      manualActivation: null,
	      reservationQueue: null,
	      noManagedLanguage: "es",
	      loading: {},
	      isPublic: false
	    };

	    this.languages = this.App.getLanguages();
	  }

	  _createClass(GroupController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;

	      this.reload = this.reload.bind(this);
	      this.onUserkeyClick = this.onUserkeyClick.bind(this);
	      this.onChargeClick = this.onChargeClick.bind(this);
	      this.onChargepointClick = this.onChargepointClick.bind(this);
	      this.reloadCharges = this.reloadCharges.bind(this);
	      this.reloadChargepoints = this.reloadChargepoints.bind(this);
	      this.reloadUserkeys = this.reloadUserkeys.bind(this);
	      this.reloadTariffs = this.reloadTariffs.bind(this);
	      this.reloadMaintainers = this.reloadMaintainers.bind(this);
	      this.reloadRoles = this.reloadRoles.bind(this);
	      this.askToAssignMaintainer = this.askToAssignMaintainer.bind(this);
	      this.onManualActivationChanged = this.onManualActivationChanged.bind(this);
	      this.onReservationQueueEnabledChanged = this.onReservationQueueEnabledChanged.bind(this);
	      this.onIsPublicChanged = this.onIsPublicChanged.bind(this);
	      this.askToAddChargepoint = this.askToAddChargepoint.bind(this);
	      this.upsertTariff = this.upsertTariff.bind(this);
	      this.reloadOperations = this.reloadOperations.bind(this);
	      this.addOperation = this.addOperation.bind(this);
	      this.isRoamingPurpose = this.isRoamingPurpose.bind(this);
	      this.reloadMargins = this.reloadMargins.bind(this);
	      this.createMargin = this.createMargin.bind(this);

	      this.$scope.$watch('ctrl.group', function () {
	        if (_this2.group) {
	          _this2.setState();
	          _this2.setTabs();
	        }
	      });

	      this.$scope.$watch('ctrl.tabs.active', function () {
	        if (_this2.tabs.active) {
	          switch (_this2.tabs.active.id) {
	            case 'charges':
	              _this2.reloadCharges();
	              break;
	            case 'chargepoints':
	              _this2.reloadChargepoints();
	              break;
	            case 'userkeys':
	              _this2.reloadUserkeys();
	              break;
	            case 'tariffs':
	              _this2.reloadTariffs();
	              break;
	            case 'margins':
	              _this2.reloadMargins();
	              break;
	            case 'operations':
	              _this2.reloadOperations();
	              break;
	          }
	        }
	      });
	      this.setBreadcrums();
	      this.reload();
	    }
	  }, {
	    key: 'isAdmin',
	    value: function isAdmin() {
	      return this.Auth.isAdmin();
	    }
	  }, {
	    key: 'isAdminOfOrganization',
	    value: function isAdminOfOrganization() {
	      return this.Auth.isAdminOfOrganization();
	    }
	  }, {
	    key: 'isProvider',
	    value: function isProvider() {
	      return this.Auth.isProvider();
	    }
	  }, {
	    key: 'hasParent',
	    value: function hasParent() {
	      return this.GroupsHelper.hasParent(this.group);
	    }
	  }, {
	    key: 'getCustom',
	    value: function getCustom() {
	      return this.Auth.isAdminOfGroup() || this.Auth.isDoerOfGroup() ? { omit: ["start.customerName", "chargeCustomerName"] } : undefined;
	    }
	  }, {
	    key: 'canUserkeyBeRemoved',
	    value: function canUserkeyBeRemoved(userkey) {
	      return this.group.id === userkey.groupLevel.id;
	    }
	  }, {
	    key: 'canRoleBeRemoved',
	    value: function canRoleBeRemoved(role) {
	      return role.entity === 'group' && this.group.id === role.id;
	    }
	  }, {
	    key: 'editGroup',
	    value: function editGroup(changed) {
	      var _this3 = this;

	      return this.GroupsService.editGroup(this.group, changed, { organization: this.organization, notifications: true }).then(function () {
	        return _this3.reload();
	      });
	    }
	  }, {
	    key: 'editLocation',
	    value: function editLocation() {
	      var _this4 = this;

	      return this.GroupsHelper.editLocation(this.$scope, this.group, { organization: this.organization }).then(function () {
	        return _this4.reload();
	      });
	    }
	  }, {
	    key: 'removeLocation',
	    value: function removeLocation() {
	      var _this5 = this;

	      if (this.group.location) {
	        var location = _lodash2.default.cloneDeep(this.group.location);
	        var options = { organization: this.organization, notifications: { error: "REMOVE_LOCATION_FAILED" } };
	        location.latitude = null;
	        location.longitude = null;
	        this.GroupsService.setGroupLocation(this.group, location, options).then(function () {
	          return _this5.reload();
	        });
	      }
	    }
	  }, {
	    key: 'addAddress',
	    value: function addAddress() {
	      if (!this.group.location) this.group.location = this.GroupsHelper.getEditableLocation();
	      if (angular.isUndefined(this.group.location.address)) this.group.location.address = null;
	      if (angular.isUndefined(this.group.location.postalCode)) this.group.location.postalCode = null;
	      if (angular.isUndefined(this.group.location.city)) this.group.location.city = null;
	      if (angular.isUndefined(this.group.location.country)) this.group.location.country = null;
	      this.properties.address.controls.enterEdition();
	    }
	  }, {
	    key: 'editAddress',
	    value: function editAddress(changed) {
	      var _this6 = this;

	      var newLocation = _lodash2.default.defaults(changed, this.group.location, this.GroupsHelper.getEditableLocation());
	      return this.GroupsService.setGroupLocation(this.group, newLocation, { organization: this.organization, notifications: true }).then(function () {
	        return _this6.reload();
	      });
	    }
	  }, {
	    key: 'onChargeClick',
	    value: function onChargeClick(charge) {
	      this.$state.go('efimob.charges.at.item', { 'id': charge.id, 'organization': this.organization });
	    }
	  }, {
	    key: 'exportCharges',
	    value: function exportCharges() {
	      var _this7 = this;

	      var options = {
	        filters: this.filters.charges,
	        sorting: this.tables.charges.sorting,
	        organization: this.organization,
	        group: this.id,
	        params: {
	          output: 'csv',
	          count: this.tables.charges.pagination.totalItems
	        }
	      };

	      this.ChargeSessionsService.getCharges(options, false, true).then(function ( /** @type {{docs: Blob, emailExport: boolean}} */charges) {
	        if (charges.emailExport) {
	          return _this7.App.showNotification(_this7.$translate.instant('EXPORT_BY_EMAIL'), 'ok');
	        }
	        _this7.App.downloadCSV(charges.docs, _this7.$translate.instant('GROUP_CHARGES_CHARGES_FILENAME') + '-' + _this7.id + '-' + _this7.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      });
	    }
	  }, {
	    key: 'reloadCharges',
	    value: function reloadCharges() {
	      var _this8 = this;

	      this.App.setLoading(true);
	      var options = {
	        filters: this.filters.charges,
	        pagination: this.tables.charges.pagination,
	        sorting: this.tables.charges.sorting,
	        organization: this.organization,
	        group: this.id
	      };
	      return this.ChargeSessionsService.getCharges(options).then(function (charges) {
	        _this8.charges = charges.docs;
	        _this8.tables.charges.pagination.currentPage = charges.currentPage;
	        _this8.tables.charges.pagination.totalItems = charges.totalItems;
	        _this8.App.setLoading(false);
	      }).catch(function () {
	        return _this8.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'onChargepointClick',
	    value: function onChargepointClick(chargepoint) {
	      this.$state.go('efimob.chargepoints.at.item', { 'id': chargepoint.id, 'organization': this.organization });
	    }
	  }, {
	    key: 'exportChargepoints',
	    value: function exportChargepoints() {
	      var _this9 = this;

	      var options = {
	        filters: this.filters.chargepoints,
	        sorting: this.tables.chargepoints.sorting,
	        organization: this.organization,
	        group: this.id
	      };
	      this.ChargePointsService.exportChargepoints(options).then(function (chargepoints) {
	        return _this9.App.downloadCSV(chargepoints, _this9.$translate.instant('GROUP_CHARGEPOINTS_FILENAME') + '-' + _this9.id + '-' + _this9.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      }).catch(function () {
	        return _this9.App.showNotification(_this9.$translate.instant('GROUP_CHARGEPOINTS_EXPORT_FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'exportChargePointsToJson',
	    value: function exportChargePointsToJson() {
	      var _this10 = this;

	      var options = {
	        notifications: true,
	        organization: this.organization,
	        group: this.id
	      };
	      this.ChargePointsService.exportChargePointsToJson(options).then(function (chargePoints) {
	        var filename = _this10.$translate.instant(_this10.id + '-' + _this10.moment().format('YYYY-MM-DD-HHmmss') + '.json');
	        _this10.App.downloadJSON(chargePoints, filename);
	      });
	    }
	  }, {
	    key: 'reloadChargepoints',
	    value: function reloadChargepoints() {
	      var _this11 = this;

	      var options = {
	        filters: this.filters.chargepoints,
	        pagination: this.tables.chargepoints.pagination,
	        sorting: this.tables.chargepoints.sorting,
	        organization: this.organization,
	        group: this.id
	      };
	      this.App.setLoading(true);
	      this.ChargePointsService.getChargepoints(options).then(function (chargepoints) {
	        _this11.chargepoints = chargepoints.docs;
	        _this11.tables.chargepoints.pagination.currentPage = chargepoints.currentPage;
	        _this11.tables.chargepoints.pagination.totalItems = chargepoints.totalItems;
	        _this11.chargepointsWithProgramedReboots = _this11._getChargepointsWithProgramedReboots(_this11.chargepoints);
	        _this11.App.setLoading(false);
	      }).catch(function () {
	        _this11.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'onUserkeyClick',
	    value: function onUserkeyClick(_userkey) {
	      this.$state.go('efimob.userkeys.at.item', { 'id': _userkey.userKeyId, 'organization': this.organization });
	    }
	  }, {
	    key: 'askToRemoveUserkey',
	    value: function askToRemoveUserkey(userkey) {
	      this.$scope.modal = { userkey: userkey };
	      this.App.openModal(this.$scope, 'remove-group-userkey.html', { 'size': 'sm' });
	    }
	  }, {
	    key: 'removeUserkey',
	    value: function removeUserkey(userkey) {
	      var _this12 = this;

	      this.UsersService.removeUserkeyFromGroup(userkey.userKeyId, this.group.id, { organization: this.organization }).then(function () {
	        _this12.reload();
	        _this12.App.closeModal();
	      }).catch(function () {
	        _this12.App.showNotification(_this12.$translate.instant('GROUP_ACTIONS_REMOVE_USERKEY_FAILED', { id: '<strong>' + userkey.userKeyId + '</strong>' }), 'error');
	        _this12.App.closeModal();
	      });
	    }
	  }, {
	    key: 'exportUserkeys',
	    value: function exportUserkeys() {
	      var _this13 = this;

	      var options = {
	        filters: this.filters.userkeys,
	        sorting: this.tables.userkeys.sorting,
	        params: { output: 'csv', count: this.tables.userkeys.pagination.totalItems },
	        organization: this.organization,
	        group: this.id
	      };
	      this.UsersService.getUserKeys(options, false, true).then(function ( /** @type {{docs: Blob, emailExport: boolean}} */userkeys) {
	        if (userkeys.emailExport) {
	          return _this13.App.showNotification(_this13.$translate.instant('EXPORT_BY_EMAIL'), 'ok');
	        }
	        _this13.App.downloadCSV(userkeys.docs, _this13.$translate.instant('GROUP_USERKEYS_USERKEYS_FILENAME') + '-' + _this13.id + '-' + _this13.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      }).catch(function () {
	        return _this13.App.showNotification(_this13.$translate.instant('GROUP_USERKEYS_EXPORT_FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'reloadUserkeys',
	    value: function reloadUserkeys() {
	      var _this14 = this;

	      var options = {
	        filters: this.filters.userkeys,
	        pagination: this.tables.userkeys.pagination,
	        sorting: this.tables.userkeys.sorting,
	        organization: this.organization,
	        group: this.id
	      };
	      this.App.setLoading(true);
	      return this.UsersService.getUserKeys(options).then(function (userkeys) {
	        _this14.userkeys = userkeys.docs.map(function (userkey) {
	          var groupLevel = userkey.groups.reduce(function (min, group) {
	            return group.length < min.length ? group : min;
	          }, userkey.groups[0]);
	          return Object.assign({}, userkey, { groupLevel: groupLevel });
	        });
	        _this14.tables.userkeys.pagination.currentPage = userkeys.currentPage;
	        _this14.tables.userkeys.pagination.totalItems = userkeys.totalItems;
	        _this14.App.setLoading(false);
	      }).catch(function () {
	        _this14.userkeys = [];
	        _this14.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'reloadTariffs',
	    value: function reloadTariffs() {
	      var _this15 = this;

	      var options = {
	        filters: this.filters.tariffs,
	        pagination: this.tables.tariffs.pagination,
	        sorting: this.tables.tariffs.sorting,
	        organizationId: this.organization,
	        locationId: this.id
	      };
	      this.App.setLoading(true);
	      return this.TariffsService.getTariffs(options).then(function (tariffs) {
	        _this15.tariffs = tariffs.docs;
	        _this15.tables.tariffs.pagination.currentPage = tariffs.currentPage;
	        _this15.tables.tariffs.pagination.totalItems = tariffs.totalItems;
	        _this15.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'upsertTariff',
	    value: function upsertTariff(tariff) {
	      var params = {
	        id: 'null',
	        organization: this.organization
	      };

	      if (tariff) {
	        params.id = tariff.id;
	      } else {
	        params.location = this.group;
	      }

	      this.$state.go('efimob.tariffs.item', params);
	    }
	  }, {
	    key: 'askToAddRole',
	    value: function askToAddRole() {
	      var _this16 = this;

	      this.UsersHelper.addRole(this.$scope, { group: this.group }, { organization: this.organization }).then(function () {
	        return _this16.reload();
	      });
	    }
	  }, {
	    key: 'askToEditRole',
	    value: function askToEditRole(role) {
	      var _this17 = this;

	      this.UsersHelper.editRole(this.$scope, role, { group: this.group }, { organization: this.organization }).then(function () {
	        return _this17.reload();
	      });
	    }
	  }, {
	    key: 'askToRemoveRole',
	    value: function askToRemoveRole(role) {
	      var _this18 = this;

	      this.UsersHelper.removeRole(this.$scope, role, { group: this.group }, { organization: this.organization }).then(function () {
	        return _this18.reload();
	      });
	    }
	  }, {
	    key: 'onManualActivationChanged',
	    value: function onManualActivationChanged(newValue) {
	      var _this19 = this;

	      this.state.loading['manualActivation'] = true;
	      this.GroupsService.editGroup(this.group, { manualActivation: newValue ? true : false }, { organization: this.organization, notifications: true }).then(function () {
	        _this19.state.loading['manualActivation'] = false;
	        _this19.reload();
	      });
	    }
	  }, {
	    key: 'onReservationQueueEnabledChanged',
	    value: function onReservationQueueEnabledChanged(newValue) {
	      var _this20 = this;

	      this.state.loading['reservationQueue'] = true;
	      this.GroupsService.editGroupProtectedSettings(this.group, { reservationQueue: { enabled: newValue ? true : false } }, { organization: this.organization, notifications: true }).then(function () {
	        _this20.state.loading['reservationQueue'] = false;
	        _this20.reload();
	      });
	    }
	  }, {
	    key: 'onIsPublicChanged',
	    value: function onIsPublicChanged(newValue) {
	      var _this21 = this;

	      this.state.loading['isPublic'] = true;
	      this.GroupsService.editGroup(this.group, { isPublic: newValue }, { organization: this.organization, notifications: true }).then(function () {
	        _this21.state.loading['isPublic'] = false;
	        _this21.reload();
	      });
	    }
	  }, {
	    key: 'editReservationQueueTimeout',
	    value: function editReservationQueueTimeout(changed) {
	      var _this22 = this;

	      var payload = {
	        'reservationQueue': _lodash2.default.get(this.group, 'reservationQueue', undefined)
	      };
	      _lodash2.default.each(changed, function (value, path) {
	        return _lodash2.default.set(payload, path, value === "" ? undefined : value);
	      });
	      return this.GroupsService.editGroupProtectedSettings(this.group, payload, { organization: this.organization }).then(function () {
	        return _this22.reload();
	      });
	    }
	  }, {
	    key: 'editGroupPrivateUsers',
	    value: function editGroupPrivateUsers(changed) {
	      var _this23 = this;

	      var payload = {
	        'privateUsers': _lodash2.default.get(this.group, 'privateUsers', undefined)
	      };
	      _lodash2.default.each(changed, function (value, path) {
	        return _lodash2.default.set(payload, path, value === "" ? undefined : value);
	      });
	      return this.GroupsService.editGroupProtectedSettings(this.group, payload, { organization: this.organization }).then(function () {
	        return _this23.reload();
	      });
	    }
	  }, {
	    key: 'getNoManagedLanguagesSet',
	    value: function getNoManagedLanguagesSet() {
	      var _this24 = this;

	      var total = 0;
	      if (this.group && this.group.noManagedInfo && this.group.noManagedInfo.title && this.group.noManagedInfo.body) {
	        _lodash2.default.each(this.languages, function (lang) {
	          if (_this24.group.noManagedInfo.title[lang.id] && _this24.group.noManagedInfo.body[lang.id]) total++;
	        });
	      }
	      return total;
	    }
	  }, {
	    key: 'askToEditNoManagedChargepoints',
	    value: function askToEditNoManagedChargepoints() {
	      var _this25 = this;

	      this.$scope.modal = {
	        lang: {
	          option: this.state.noManagedLanguage,
	          options: this.languages
	        },
	        noManagedInfo: _lodash2.default.cloneDeep(this.group.noManagedInfo) || {},
	        isValid: function isValid() {
	          return true;
	        },
	        done: function done() {
	          _this25.doEditNoManagedChargepoints(_this25.$scope.modal.noManagedInfo, _this25.$scope.modal);
	        }
	      };
	      if (!this.$scope.modal.noManagedInfo.title) this.$scope.modal.noManagedInfo.title = {};
	      if (!this.$scope.modal.noManagedInfo.body) this.$scope.modal.noManagedInfo.body = {};
	      this.App.openModal(this.$scope, "edit-no-managed-chargers.html", { "size": "lg" });
	    }
	  }, {
	    key: 'doEditNoManagedChargepoints',
	    value: function doEditNoManagedChargepoints(noManagedInfo, modal) {
	      var _this26 = this;

	      modal.state = 'working';
	      var payload = { noManagedInfo: _lodash2.default.pick(noManagedInfo, ['title', 'body']) };
	      return this.GroupsService.editGroup(this.group, payload, { organization: this.organization }).then(function () {
	        _this26.App.showNotification(_this26.$translate.instant('ACTION.EDIT_NO_MANAGED.EDIT_OK'));
	        _this26.App.closeModal();
	        _this26.reload();
	      }).catch(function () {
	        _this26.App.showNotification(_this26.$translate.instant('ACTION.EDIT_NO_MANAGED.EDIT_FAILED'), 'error');
	        _this26.App.closeModal();
	      });
	    }
	  }, {
	    key: 'setTabs',
	    value: function setTabs() {
	      var _this27 = this;

	      var list = [{
	        id: 'info',
	        display: this.$translate.instant('GROUP_TABS_INFO'),
	        url: 'info'
	      }, {
	        id: 'charges',
	        display: this.$translate.instant('GROUP_TABS_CHARGES'),
	        url: 'recargas',
	        count: function count() {
	          return _this27.charges ? _this27.tables.charges.pagination.totalItems : '...';
	        }
	      }, {
	        id: 'chargepoints',
	        display: this.$translate.instant('GROUP_TABS_CHARGEPOINTS'),
	        url: 'puntos',
	        count: function count() {
	          return _this27.chargepoints ? _this27.tables.chargepoints.pagination.totalItems : '...';
	        }
	      }, {
	        id: 'userkeys',
	        display: this.$translate.instant('GROUP_TABS_USERKEYS'),
	        url: 'llaves',
	        count: function count() {
	          return _this27.userkeys ? _this27.tables.userkeys.pagination.totalItems : '...';
	        }
	      }, {
	        id: 'tariffs',
	        display: this.$translate.instant('GROUP_TABS_TARIFFS'),
	        url: 'tarifas',
	        count: function count() {
	          return _this27.tariffs ? _this27.tariffs.length : '...';
	        }
	      }];

	      if (this.isRoamingPurpose(this.group)) {
	        list.push({
	          id: 'margins',
	          display: this.$translate.instant('DYNAMIC_TARIFFS'),
	          url: 'margins',
	          count: function count() {
	            return _this27.margins ? _this27.margins.length : '...';
	          }
	        });
	      }

	      if (this.group.isAtomic && !this.isRoamingPurpose(this.group)) {
	        list.push({
	          id: 'operations',
	          display: this.$translate.instant('OPERATIONS'),
	          url: 'operations',
	          count: function count() {
	            return _this27.operations ? _this27.operations.length : '...';
	          }
	        });
	      }

	      if (this.isAdmin()) {
	        list.push({
	          id: 'roles',
	          display: this.$translate.instant('GROUP_TABS_ROLES'),
	          url: 'perfiles',
	          count: function count() {
	            return _this27.tables.roles.pagination.totalItems ? _this27.tables.roles.pagination.totalItems : '...';
	          }
	        });
	      }

	      var active = list[0];
	      var index = _lodash2.default.findIndex(list, { 'url': this.tab });
	      if (this.tab && index >= 0) active = list[index];
	      this.tabs['active'] = this.tabs['active'] || active;
	      this.tabs['list'] = list;
	    }
	  }, {
	    key: 'setState',
	    value: function setState() {
	      if (this.group) {
	        this.state.manualActivation = this.group.manualActivation ? !!this.group.manualActivation : false;
	        this.state.reservationQueue = this.group.reservationQueue ? !!this.group.reservationQueue.enabled : false;
	        this.state.isPublic = this.group.isPublic ? !!this.group.isPublic : false;
	      }
	    }
	  }, {
	    key: 'setBreadcrums',
	    value: function setBreadcrums() {
	      if (this.group) {
	        this.App.setBreadcrumsTitle(this.group.name);
	      }
	      this.App.setBreadcrumsSteps([{ display: this.$translate.instant('GROUP_BREADCRUMBS_GROUPS'), href: this.$state.href('efimob.groups.list', { organization: this.organization }) }]);
	      this.App.setBreadcrumsRightActions([this.App.getActionBack(this.$state.href('efimob.groups.list', { organization: this.organization }), this.$translate.instant('GROUP_BREADCRUMBS_BACK_TO_GROUPS')), this.App.getActionReload(this.reload)]);
	    }
	  }, {
	    key: 'setNoManagedInfo',
	    value: function setNoManagedInfo() {
	      if (this.group && !this.group.noManagedInfo) {
	        this.group.noManagedInfo = {};
	      }
	    }
	  }, {
	    key: 'hasEnergy',
	    value: function hasEnergy(group) {
	      return this.GroupsHelper.hasEnergy(group);
	    }
	  }, {
	    key: 'editEnergy',
	    value: function editEnergy() {
	      var _this28 = this;

	      var options = {
	        group: this.group,
	        organization: this.organization
	      };
	      return this.GroupsHelper.askToEditEnergy(this.$scope, options).then(function () {
	        return _this28.reload();
	      });
	    }
	  }, {
	    key: 'hasOpeningTimes',
	    value: function hasOpeningTimes(group) {
	      return this.GroupsHelper.hasOpeningTimes(group);
	    }
	  }, {
	    key: 'editOpeningHours',
	    value: function editOpeningHours() {
	      var _this29 = this;

	      var options = {
	        group: this.group,
	        organization: this.organization
	      };
	      return this.GroupsHelper.askToEditOpeningHours(this.$scope, options).then(function () {
	        return _this29.reload();
	      });
	    }
	  }, {
	    key: '_getChargepointsWithProgramedReboots',
	    value: function _getChargepointsWithProgramedReboots(charegepoints) {
	      var response = [];
	      for (var i = 0; i < charegepoints.length; i++) {
	        var charegepoint = charegepoints[i];
	        if (charegepoint["programmedTasks"]) {
	          for (var o = 0; o < charegepoint["programmedTasks"].length; o++) {
	            var programmedTask = charegepoint["programmedTasks"][o];
	            var item = {
	              id: charegepoint["id"],
	              name: charegepoint["name"],
	              groupId: charegepoint["groupId"],
	              groupName: charegepoint["groupName"],
	              organizationId: charegepoint["organizationId"],
	              period: programmedTask["period"],
	              windowStart: programmedTask["windowStart"],
	              windowEnd: programmedTask["windowEnd"]
	            };
	            response.push(item);
	          }
	        }
	      }
	      return response;
	    }
	  }, {
	    key: 'getOwners',
	    value: function getOwners() {
	      var _this30 = this;

	      var options = { organization: { id: this.organization } };
	      this.Organization.getOwners(options).then(function (data) {
	        _this30.owners = data;
	        _this30.properties = _this30._getProperties(_this30.$filter("adaptToSelectOptions")(data));
	      });
	    }
	  }, {
	    key: 'askToAddChargepoint',
	    value: function askToAddChargepoint() {
	      var _this31 = this;

	      return this.ChargepointHelper.addChargePoint(this.$scope, { group: this.group }, { organizationId: this.organization, groupId: this.group.id }).then(function () {
	        _this31.reloadChargepoints();
	        _this31.App.showNotification(_this31.$translate.instant('NEW_CP_ADDED_OK'));
	        _this31.App.closeModal();
	      }).catch(function (error) {
	        _this31.App.showNotification(error, 'error');
	        _this31.App.closeModal();
	      });
	    }
	  }, {
	    key: 'reloadRoles',
	    value: function reloadRoles() {
	      var _this32 = this;

	      if (this.isAdmin()) {
	        var options = {
	          organization: this.organization,
	          pagination: this.tables.roles.pagination,
	          sorting: this.tables.roles.sorting
	        };
	        this.GroupsService.getPrivateDataGroup(this.id, options, true).then(function (privateData) {
	          _this32.roles = _lodash2.default.reject(privateData.docs.roles, { "entity": "provider" });
	          _this32.tables.roles.pagination.currentPage = privateData.currentPage;
	          _this32.tables.roles.pagination.totalItems = privateData.totalItems;
	        });
	      }
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      var _this33 = this;

	      this.App.setLoading(true);
	      this.GroupsService.getGroup(this.id, { organization: this.organization }).then(function (group) {
	        return _this33.group = group;
	      }).then(function () {
	        _this33.reloadRoles();
	        if (!_this33.isAdmin()) {
	          _this33.GroupsService.getGroupDetail(_this33.id, { organization: _this33.organization });
	        }
	        if (_this33.Auth.isAdminOfOrganization() || _this33.Auth.isProvider()) {
	          _this33.getOwners();
	        }
	        _this33.reloadMaintainers();
	        _this33.setBreadcrums();
	        _this33.setNoManagedInfo();
	        _this33.setState();
	        _this33.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'askToAddUserkey',
	    value: function askToAddUserkey() {
	      var _this34 = this;

	      return this.UserKeyHelper.addUserKey(this.$scope, { group: this.group }, { organizationId: this.organization, group: this.group }).then(function () {
	        _this34.reloadUserkeys();
	        _this34.App.showNotification(_this34.$translate.instant('ADD_KEY_SUCCESS'));
	        _this34.App.closeModal();
	      }).catch(function (error) {
	        _this34.App.showNotification(error, 'error');
	        _this34.App.closeModal();
	      });
	    }
	  }, {
	    key: 'reloadMaintainers',
	    value: function reloadMaintainers() {
	      var _this35 = this;

	      var options = {
	        pagination: this.tables.maintainers.pagination,
	        sorting: this.tables.maintainers.sorting,
	        organizationId: this.organization
	      };
	      this.App.setLoading(true);
	      return this.GroupsService.getMaintainers(this.group.id, options).then(function (data) {
	        _this35.maintainers = data.docs;
	        _this35.tables.maintainers.pagination.currentPage = data.currentPage;
	        _this35.tables.maintainers.pagination.totalItems = data.totalItems;
	        _this35.App.setLoading(false);
	      }).catch(function () {
	        return _this35.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'askToUnassignMaintainer',
	    value: function askToUnassignMaintainer(maintainer) {
	      var _this36 = this;

	      var options = {
	        organizationId: this.organization,
	        groupId: this.group.id
	      };
	      this.GroupsHelper.unassignMaintainer(this.$scope, maintainer, options).then(function () {
	        return _this36.reloadMaintainers();
	      });
	    }
	  }, {
	    key: 'askToAssignMaintainer',
	    value: function askToAssignMaintainer() {
	      var _this37 = this;

	      var options = {
	        organizationId: this.organization,
	        groupId: this.group.id
	      };
	      this.GroupsHelper.assignMaintainer(this.$scope, options).then(function () {
	        return _this37.reloadMaintainers();
	      });
	    }
	  }, {
	    key: 'reloadOperations',
	    value: function reloadOperations() {
	      var _this38 = this;

	      var options = {
	        params: {
	          orderby: 'id,asc',
	          locationName: this.group.name
	        },
	        pagination: this.tables.operations.pagination,
	        sorting: this.tables.operations.sorting,
	        organizationId: this.organization
	      };

	      this.App.setLoading(true);
	      return this.OperationService.getOperations(options, true).then(function (data) {
	        _this38.operations = data.docs;
	        _this38.tables.operations.pagination.currentPage = data.currentPage;
	        _this38.tables.operations.pagination.totalItems = data.totalItems;
	        _this38.App.setLoading(false);
	      }).catch(function () {
	        _this38.operations = [];
	        _this38.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'addOperation',
	    value: function addOperation() {
	      var _this39 = this;

	      var options = {
	        operations: this.operations,
	        locationId: this.group.id,
	        organizationId: this.organization,
	        notifications: true
	      };
	      this.OperationsHelperService.addOperationToLocation(this.$scope, options).then(function () {
	        return _this39.reloadOperations();
	      });
	    }
	  }, {
	    key: 'reloadMargins',
	    value: function reloadMargins() {
	      var _this40 = this;

	      var options = {
	        filters: this.filters.margins,
	        pagination: this.tables.operations.pagination,
	        sorting: this.tables.operations.sorting,
	        locationId: this.group.id,
	        organizationId: this.organization
	      };

	      this.App.setLoading(true);
	      return this.MarginService.getMargins(options, true).then(function (data) {
	        _this40.margins = data.docs;
	        _this40.tables.margins.pagination.currentPage = data.currentPage;
	        _this40.tables.margins.pagination.totalItems = data.totalItems;
	        _this40.App.setLoading(false);
	      }).catch(function () {
	        _this40.margins = [];
	        _this40.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'createMargin',
	    value: function createMargin() {
	      var _this41 = this;

	      var options = {
	        locationId: this.group.id,
	        organizationId: this.organization,
	        notifications: true
	      };
	      this.MarginHelperService.createMargin(this.$scope, options).then(function () {
	        return _this41.reloadMargins();
	      });
	    }
	  }, {
	    key: 'editMargin',
	    value: function editMargin(margin) {
	      var _this42 = this;

	      var options = {
	        locationId: this.group.id,
	        organizationId: this.organization,
	        notifications: true
	      };
	      this.MarginHelperService.editMargin(this.$scope, margin, options).then(function () {
	        return _this42.reloadMargins();
	      });
	    }
	  }, {
	    key: 'removeMargin',
	    value: function removeMargin(margin) {
	      var _this43 = this;

	      var options = {
	        locationId: this.group.id,
	        organizationId: this.organization,
	        notifications: true
	      };
	      this.MarginHelperService.removeMargin(this.$scope, margin, options).then(function () {
	        return _this43.reloadMargins();
	      });
	    }
	  }, {
	    key: 'isRoamingPurpose',
	    value: function isRoamingPurpose(location) {
	      var purpose = location ? location.purpose || 'General' : 'General';
	      return ['RoamingChargepointsParent', 'RoamingChargepointsGroup', 'RoamingChargepoints', 'RoamingOperatorGroup', 'RoamingCountryGroup', 'RoamingSegmentGroup'].includes(purpose);
	    }
	  }, {
	    key: '_getProperties',
	    value: function _getProperties() {
	      var _this44 = this;

	      var owners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	      owners = [{ display: this.$translate.instant('NONE'), id: null }].concat(owners);
	      var properties = {
	        general: {
	          keys: ['id', 'name | safe', 'desc | safe', 'externalId', 'centerId', 'parkingType | translate'],
	          headers: [this.$translate.instant('GROUP_PROPS_ID'), this.$translate.instant('GROUP_PROPS_NAME'), this.$translate.instant('GROUP_PROPS_DESC'), this.$translate.instant('EXTERNAL_ID'), this.$translate.instant('CENTER_ID'), this.$translate.instant('PARKING_TYPE')],
	          editable: ['name', 'desc', 'externalId', 'centerId', 'parkingType'],
	          meta: {
	            ownerId: {
	              type: 'select',
	              options: owners
	            },
	            parkingType: {
	              type: 'select',
	              options: [{ display: this.$translate.instant('NONE'), id: null }, { display: this.$translate.instant('ALONG_MOTORWAY'), id: 'ALONG_MOTORWAY' }, { display: this.$translate.instant('PARKING_GARAGE'), id: 'PARKING_GARAGE' }, { display: this.$translate.instant('PARKING_LOT'), id: 'PARKING_LOT' }, { display: this.$translate.instant('ON_DRIVEWAY'), id: 'ON_DRIVEWAY' }, { display: this.$translate.instant('ON_STREET'), id: 'ON_STREET' }, { display: this.$translate.instant('UNDERGROUND_GARAGE'), id: 'UNDERGROUND_GARAGE' }]
	            }
	          },
	          isKeyRestricted: function isKeyRestricted(key) {
	            var res = void 0;
	            switch (key) {
	              case 'externalId':
	              case 'centerId':
	                res = _this44.Auth.isAdminOfOrganization() || _this44.Auth.isProvider();
	                return res;
	              case 'parkingType':
	                res = (_this44.Auth.isAdminOfOrganization() || _this44.Auth.isProvider()) && !_this44.isRoamingPurpose(_this44.group);
	                return res;
	              case 'name':
	              case 'desc':
	                res = !_this44.isRoamingPurpose(_this44.group);
	                return res;
	            }
	          },
	          onSave: function onSave(changes) {
	            return _this44.editGroup(changes.changed);
	          }
	        },
	        location: {
	          keys: ['latitude', 'longitude'],
	          headers: [this.$translate.instant('GROUP_PROPS_LATITUDE'), this.$translate.instant('GROUP_PROPS_LONGITUDE')]
	        },
	        address: {
	          keys: ['address', 'city', 'postalCode', 'country | countryCodeToName'],
	          headers: [this.$translate.instant('GROUP_PROPS_ADDRESS'), this.$translate.instant('GROUP_PROPS_CITY'), this.$translate.instant('GROUP_PROPS_POSTAL_CODE'), this.$translate.instant('GROUP_PROPS_COUNTRY')],
	          editable: ['address', 'city', 'postalCode', 'country'],
	          meta: {
	            country: {
	              type: 'select-component',
	              adaptFrom: function adaptFrom(data) {
	                return _this44.countryCodes.find(function (item) {
	                  return item.value === data;
	                }) || { display: _this44.$translate.instant('COUNTRY_CODE_ESP'), value: 'ESP' };
	              },
	              adaptTo: function adaptTo(data) {
	                return data ? data.value : null;
	              },
	              options: this.countryCodes
	            }
	          },
	          onlyIf: function onlyIf(item) {
	            return !_this44.isRoamingPurpose(item);
	          },
	          onSave: function onSave(changes) {
	            return _this44.editAddress(changes.changed);
	          }
	        },
	        right: {
	          keys: ['id', 'name | safe', 'desc | safe'],
	          headers: [this.$translate.instant('GROUP_PROPS_ID'), this.$translate.instant('GROUP_PROPS_NAME'), this.$translate.instant('GROUP_PROPS_DESC')]
	        },
	        reservationQueue: {
	          keys: ['reservationQueue.acceptReservationTimeout | number', 'reservationQueue.startChargingTimeout | number', 'reservationQueue.maxChargingTime | number'],
	          headers: [this.$translate.instant('GROUP_INFO_ACCEPT_RESERVATION_TIMEOUT'), this.$translate.instant('GROUP_INFO_START_CHARGING_TIMEOUT'), this.$translate.instant('GROUP_INFO_MAX_CHARGING_TIME')],
	          editable: true,
	          meta: {
	            'reservationQueue.acceptReservationTimeout': {
	              help: this.$translate.instant('GROUP_INFO_IN_MINUTES_AND_ZERO_AS_DEFAULT'),
	              type: 'number',
	              min: 0,
	              step: 1,
	              onChange: function onChange(data) {
	                if (data["model"].value < 0 || data["model"].value == undefined) {
	                  data["model"].value = 0;
	                }
	              }
	            },
	            'reservationQueue.startChargingTimeout': {
	              help: this.$translate.instant('GROUP_INFO_IN_MINUTES_AND_ZERO_AS_DEFAULT'),
	              type: 'number',
	              min: 0,
	              step: 1,
	              onChange: function onChange(data) {
	                if (data["model"].value < 0 || data["model"].value == undefined) {
	                  data["model"].value = 0;
	                }
	              }
	            },
	            'reservationQueue.maxChargingTime': {
	              help: this.$translate.instant('GROUP_INFO_IN_MINUTES_AND_ZERO_AS_DEFAULT'),
	              type: 'number',
	              min: 0,
	              step: 1,
	              onChange: function onChange(data) {
	                if (data["model"].value < 0 || data["model"].value == undefined) {
	                  data["model"].value = 0;
	                }
	              }
	            }
	          },
	          onSave: function onSave(changes) {
	            return _this44.editReservationQueueTimeout(changes.changed);
	          }
	        },
	        privateUsers: {
	          keys: ['privateUsers'],
	          headers: [this.$translate.instant('PRIVATE_USERS')],
	          editable: true,
	          meta: {
	            privateUsers: {
	              help: this.$translate.instant('PRIVATE_USERS_EXP'),
	              type: 'chips',
	              conflict: { message: "INVALID_WITH", data: null },
	              validate: function validate(item, config, data) {
	                var valid = _this44.Utils.validateEmailOrDomain(item);
	                if (valid) {
	                  config.conflict.data = item;
	                  data.pop();
	                } else {
	                  config.conflict.data = null;
	                }
	              }
	            }
	          },
	          onSave: function onSave(changes) {
	            return _this44.editGroupPrivateUsers(changes.changed);
	          }
	        },
	        noManagedInfo: {
	          keys: ['title | language:this.$parent.ctrl.state.noManagedLanguage', 'body | language:this.$parent.ctrl.state.noManagedLanguage'],
	          headers: [this.$translate.instant('ACTION.EDIT_NO_MANAGED.TITLE'), this.$translate.instant('ACTION.EDIT_NO_MANAGED.BODY')]
	        }
	      };
	      if (this.Auth.isAdminOfOrganization() || this.Auth.isProvider()) {
	        properties.general.keys.push('ownerId | searchInArrayOfObjects:ctrl.$scope.$parent.ctrl.owners');
	        properties.general.headers.push(this.$translate.instant('OWNER'));
	        if (!this.isRoamingPurpose(this.group)) {
	          properties.general.editable.push('ownerId');
	        }
	      }
	      return properties;
	    }
	  }]);

	  return GroupController;
	}();

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var GroupsController = exports.GroupsController = function () {
	    GroupsController.$inject = ["$scope", "$state", "$filter", "$stateParams", "$translate", "App", "Auth", "GroupsHelper", "GroupsService", "$window"];
	    function GroupsController($scope, $state, $filter, $stateParams, $translate, App, Auth, GroupsHelper, GroupsService, $window) {
	        'ngInject';

	        _classCallCheck(this, GroupsController);

	        this.$scope = $scope;
	        this.$state = $state;
	        this.$filter = $filter;
	        this.$translate = $translate;
	        this.App = App;
	        this.Auth = Auth;
	        this.GroupsHelper = GroupsHelper;
	        this.GroupsService = GroupsService;
	        this.$window = $window;
	        this.groups = null;
	        this.flattenedGroups = null;
	        this.organization = $stateParams.organization;
	        this.group = $stateParams.group;
	    }

	    _createClass(GroupsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;

	            this.reload = this.reload.bind(this);
	            this.onGroupClick = this.onGroupClick.bind(this);
	            this.askToAddGroup = this.askToAddGroup.bind(this);

	            // Map settings
	            this.map = this.App.getMap();

	            this.setBreadcrums();
	            this.reload();

	            // Tree settings
	            this.tree = {
	                id: 'id',
	                title: 'name',
	                subtitle: 'desc',
	                nodes: 'groups',
	                custom: this.App.getGroupsTreeCustom(),
	                reorder: true,
	                preventMovingToRoot: true,
	                zeroResults: this.$translate.instant('GROUPS_NO_GROUPS_YET'),
	                onReorder: function onReorder(item, from, to) {
	                    return _this.askToMoveGroup(item, from, to);
	                },
	                actions: [{
	                    tooltip: this.$translate.instant('OPEN_IN_NEW_TAB'),
	                    icon: 'arrow-square-up',
	                    onClick: function onClick(item) {
	                        return _this.$window.open("/zonas/" + _this.organization + "/" + item.id, '_blank');
	                    }
	                }, {
	                    tooltip: this.$translate.instant('GROUPS_ADD_GEOLOCATION'),
	                    icon: 'map-marker-alt',
	                    onlyIf: function onlyIf(item) {
	                        return _this.GroupsService.checkPurpose("general", item);
	                    },
	                    disabled: function disabled() {
	                        return !_this.isAdmin();
	                    },
	                    onClick: function onClick(item) {
	                        return _this.editGroupLocation(item);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('GROUPS_ADD_GROUP_ADD_SUBGROUP'),
	                    tooltipDisabled: this.$translate.instant('ADD_SUBGROUP_FAILED_GROUP_WITH_CHARGERS'),
	                    icon: 'plus-square',
	                    onlyIf: function onlyIf(item) {
	                        return !_this.GroupsService.checkPurpose("roaming", item);
	                    },
	                    disabled: function disabled(item) {
	                        return !_this.canAddSubGroup(item);
	                    },
	                    onClick: function onClick(item) {
	                        return _this.askToAddSubGroup(item);
	                    }
	                }, {
	                    tooltip: this.$translate.instant('GROUPS_REMOVE_GROUP_REMOVE_THIS_GROUP'),
	                    tooltipDisabled: this.$translate.instant('GROUPS_REMOVE_GROUP_REMOVE_THIS_GROUP_HELP'),
	                    icon: 'times-hexagon',
	                    custom: 'danger',
	                    onlyIf: function onlyIf(item) {
	                        return !_this.GroupsService.checkPurpose("roaming", item);
	                    },
	                    disabled: function disabled(item) {
	                        return !_this.isAdmin() || _this.GroupsHelper.isNotEmpty(item);
	                    },
	                    onClick: function onClick(item) {
	                        return _this.askToRemoveGroup(item);
	                    }
	                }]
	            };
	        }
	    }, {
	        key: 'canAddSubGroup',
	        value: function canAddSubGroup(group) {
	            return this.Auth.isAdmin() && group.chargepoints.length === 0;
	        }
	    }, {
	        key: 'isAdmin',
	        value: function isAdmin() {
	            return this.Auth.isAdmin();
	        }
	    }, {
	        key: 'onGroupClick',
	        value: function onGroupClick(group) {
	            this.$state.go('efimob.groups.item', { 'id': group.id, 'organization': this.organization });
	        }
	    }, {
	        key: 'askToAddGroup',
	        value: function askToAddGroup() {
	            if (!this.isAdmin()) return;
	            var parentGroup = null;
	            if (this.group) {
	                parentGroup = {
	                    name: this.$filter("groupName")(this.group),
	                    id: this.group
	                };
	            }
	            this.askToAddSubGroup(parentGroup);
	        }
	    }, {
	        key: 'askToAddSubGroup',
	        value: function askToAddSubGroup(parentGroup) {
	            var _this2 = this;

	            if (!this.isAdmin()) return;
	            var options = {
	                parentGroup: parentGroup,
	                organization: this.organization
	            };
	            return this.GroupsHelper.askToAddSubGroup(this.$scope, options).then(function () {
	                return _this2.reload();
	            });
	        }
	    }, {
	        key: 'askToRemoveGroup',
	        value: function askToRemoveGroup(group) {
	            var _this3 = this;

	            if (!this.isAdmin() || this.GroupsHelper.isNotEmpty(group)) return;
	            var options = {
	                organization: this.organization,
	                notifications: true
	            };
	            return this.GroupsHelper.askToRemoveGroup(this.$scope, group, options).then(function () {
	                return _this3.reload();
	            });
	        }
	    }, {
	        key: 'askToMoveGroup',
	        value: function askToMoveGroup(group, from, to) {
	            if (from && to && from.id && to.id && from.id === to.id) {
	                return;
	            }
	            this.$scope.modal = { group: group, from: from, to: to };
	            this.App.openModal(this.$scope, 'move-group.html');
	        }
	    }, {
	        key: 'cancelMoveGroup',
	        value: function cancelMoveGroup() {
	            this.App.closeModal();
	            this.reload();
	        }
	    }, {
	        key: 'moveGroup',
	        value: function moveGroup(group, to) {
	            var _this4 = this;

	            if (!group || !to || !group.id || !to.id) return;
	            this.GroupsService.moveGroup(group.id, to.id, { organization: this.organization, notifications: true }).then(function () {
	                return _this4._closeAndReload();
	            });
	        }
	    }, {
	        key: 'editGroupLocation',
	        value: function editGroupLocation(group) {
	            var _this5 = this;

	            if (!this.isAdmin()) return;
	            this.GroupsHelper.editLocation(this.$scope, group, { organization: this.organization }).then(function () {
	                return _this5.reload();
	            });
	        }
	    }, {
	        key: 'setBreadcrums',
	        value: function setBreadcrums() {
	            var actions = [];
	            actions.push(this.App.getActionReload(this.reload));
	            this.App.setBreadcrumsRightActions(actions);
	            this.App.setBreadcrumsCurrentScope({
	                organizationId: this.organization,
	                groupId: this.group,
	                custom: this.organization,
	                title: 'de'
	            });
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this6 = this;

	            this.App.setLoading(true);
	            if (this.group) {
	                this.GroupsService.getGroupDetail(this.group, { organization: this.organization }).then(function (group) {
	                    _this6.groups = [group];
	                    _this6.flattenedGroups = _this6.GroupsHelper.flatten(_this6.groups);
	                    _this6.App.setLoading(false);
	                });
	            } else {
	                this.GroupsService.getGroups({ organization: this.organization, group: this.group }).then(function (groups) {
	                    _this6.groups = groups;
	                    _this6.flattenedGroups = _this6.GroupsHelper.flatten(groups);
	                    _this6.App.setLoading(false);
	                });
	            }
	        }
	    }, {
	        key: '_closeAndReload',
	        value: function _closeAndReload() {
	            this.App.closeModal();
	            this.reload();
	        }
	    }]);

	    return GroupsController;
	}();

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChargepointController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargepointController = exports.ChargepointController = function () {
	  ChargepointController.$inject = ["$scope", "$rootScope", "$state", "ENV", "$stateParams", "$translate", "GroupsService", "UsersService", "ChargeSessionsService", "ChargePointsService", "$filter", "$timeout", "App", "Auth", "OCPP", "ChargepointHelper", "GroupsHelper", "ChargeHelper", "Alarms", "moment"];
	  function ChargepointController($scope, $rootScope, $state, ENV, $stateParams, $translate, GroupsService, UsersService, ChargeSessionsService, ChargePointsService, $filter, $timeout, App, Auth, OCPP, ChargepointHelper, GroupsHelper, ChargeHelper, Alarms, moment) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, ChargepointController);

	    this.ChargepointHelper = ChargepointHelper;
	    this.UsersService = UsersService;
	    this.App = App;
	    this.Auth = Auth;
	    this.ChargePointsService = ChargePointsService;
	    this.OCPP = OCPP;
	    this.ChargeSessionsService = ChargeSessionsService;
	    this.ENV = ENV;
	    this.moment = moment;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$translate = $translate;
	    this.AlarmsService = Alarms;
	    this.$filter = $filter;
	    this.$timeout = $timeout;
	    this.GroupsService = GroupsService;
	    this.GroupsHelper = GroupsHelper;
	    this.$rootScope = $rootScope;

	    this.id = $stateParams.id;
	    this.organization = $stateParams.organization;
	    this.chargepoint = null;
	    this.connectorTariffs = null;
	    this.configuration = null;
	    this.charges = null;
	    this.ocppMessages = null;
	    this.diagnostics = null;
	    this.alarms = null;
	    this.programedReboots = null;
	    this.rechargingSchedule = [];

	    this.tab = $stateParams.tab;
	    this.groups = {
	      parent: null,
	      parentWithLocation: null
	    };
	    this.ocppMessagesPagination = {
	      items: 100,
	      page: 1
	    };
	    // Properties panel settings
	    this.properties = this._getProperties();

	    // Tabs settings
	    this.tabs = {
	      active: null,
	      list: [],
	      left: true
	    };

	    // Filters settings
	    this.filters = {
	      charges: App.getTableFilters('charge', {
	        omit: ['chargepointId.ilike', 'chargepointName.ilike']
	      }),
	      ocppMessages: App.getTableFilters('auditory'),
	      diagnostics: []
	    };

	    // Tables settings
	    this.tables = {
	      charges: App.getTable("charges", this.getCustom()),
	      ocppMessages: _lodash2.default.defaults({}, App.getTable('ocppMessages')),
	      diagnostics: _lodash2.default.defaults({}, App.getTable('diagnostics'), {
	        actions: [{
	          tooltip: this.$translate.instant('CH.DIAGNOSTICS.DOWNLOAD'),
	          icon: 'download',
	          onClick: function onClick() {}
	        }]
	      }),
	      programedReboots: _lodash2.default.defaults({}, App.getTable('programedReboots'), {
	        actions: [{
	          tooltip: this.$translate.instant('CH.ACTIONS.PROGRAM_REBOOT.EDIT_REBOOT'),
	          icon: 'edit',
	          onlyIf: function onlyIf() {
	            return !_this.isPooling();
	          },
	          onClick: function onClick(reboot) {
	            return _this.askToEditProgramedReboot(reboot);
	          }
	        }, {
	          tooltip: this.$translate.instant('CH.ACTIONS.PROGRAM_REBOOT.REMOVE_REBOOT'),
	          icon: 'times-hexagon',
	          custom: 'danger',
	          onlyIf: function onlyIf() {
	            return !_this.isPooling();
	          },
	          onClick: function onClick(reboot) {
	            return _this.askToRemoveProgramedReboot(reboot);
	          }
	        }]
	      }),
	      rechargingSchedule: _lodash2.default.defaults({}, App.getTable('rechargingSchedule'), {
	        actions: [{
	          tooltip: this.$translate.instant('EDIT'),
	          icon: 'edit',
	          onlyIf: function onlyIf() {
	            return !_this.isPooling();
	          },
	          onClick: function onClick(data, index) {
	            return _this.askToEditRechargingSchedule({
	              list: _this.rechargingSchedule,
	              current: data,
	              index: index
	            });
	          }
	        }, {
	          tooltip: this.$translate.instant('REMOVE'),
	          icon: 'times-hexagon',
	          custom: 'danger',
	          onlyIf: function onlyIf() {
	            return !_this.isPooling();
	          },
	          onClick: function onClick(data, index) {
	            return _this.askToRemoveRechargingSchedule({
	              list: _this.rechargingSchedule,
	              current: data,
	              index: index
	            });
	          }
	        }]
	      }),
	      connectorTariffs: _lodash2.default.defaults({}, App.getTable('connectorTariffs'), {})
	    };

	    this.state = {
	      chargepoint: {
	        status: null,
	        authMode: null,
	        allowedChargingIntervalStyle: null,
	        operative: null,
	        loading: {}
	      },
	      loading: {},
	      connector: {},
	      errors: [],
	      moreControlsOpen: false
	    };

	    this.map = App.getMap();

	    this.display = {
	      chargepoint: {
	        actions: []
	      },
	      connector: {
	        actions: [{
	          display: this.$translate.instant('CH.CONNECTORS.ACTIONS.SRT'),
	          tooltip: this.$translate.instant('CH.CONNECTORS.ACTIONS.SRT_HINT'),
	          icon: 'battery-bolt',
	          onlyIf: function onlyIf(connector) {
	            return !_this.isInActiveTransaction(connector) && !_this.isConnectedToProxy(_this.chargepoint);
	          },
	          onClick: function onClick(connector) {
	            return _this.askToStartRemoteTransaction(connector);
	          }
	        }, {
	          display: this.$translate.instant('CH.CONNECTORS.ACTIONS.STOP_RT'),
	          tooltip: this.$translate.instant('CH.CONNECTORS.ACTIONS.STOP_RT_HINT'),
	          icon: 'battery-bolt',
	          onlyIf: function onlyIf(connector) {
	            return _this.isInActiveTransaction(connector) && !_this.isConnectedToProxy(_this.chargepoint);
	          },
	          onClick: function onClick(connector) {
	            return _this.stopRemoteTransaction(connector);
	          }
	        }, {
	          display: this.$translate.instant('CH.CONNECTORS.ACTIONS.UNLOCK_CONNECTOR'),
	          tooltip: this.$translate.instant('CH.CONNECTORS.ACTIONS.UNLOCK_CONNECTOR_HINT'),
	          icon: 'unlock',
	          onlyIf: function onlyIf() {
	            return !_this.isRoaming();
	          },
	          onClick: function onClick(connector) {
	            return _this.askToUnlockConnector(connector);
	          }
	        }]
	      }
	    };
	  }

	  _createClass(ChargepointController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;

	      this.onChargeClick = this.onChargeClick.bind(this);
	      this.onUserkeyClick = this.onUserkeyClick.bind(this);
	      this.onAlarmChanged = this.onAlarmChanged.bind(this);
	      this.onSharedChanged = this.onSharedChanged.bind(this);
	      this.reloadChargepoint = this._reloadChargepoint.bind(this);
	      this.reload = this._reload.bind(this);
	      this.reloadOcppMessages = this.reloadOcppMessages.bind(this);
	      this.reloadCharges = this.reloadCharges.bind(this);
	      this.reloadChargepointProgramedReboot = this.reloadChargepointProgramedReboot.bind(this);
	      this.reloadRechargingSchedule = this.reloadRechargingSchedule.bind(this);
	      this.changeConnectorAvailability = this.changeConnectorAvailability.bind(this);
	      this.changeAvailability = this.changeAvailability.bind(this);
	      this.clearOcppPagination = this.clearOcppPagination.bind(this);

	      this.$scope.$watch('ctrl.chargepoint', function () {
	        if (_this2.chargepoint) {
	          _this2.setState();
	          _this2.setBreadcrums();
	          _this2.setTabs();
	          if (!_this2.groups.parent) {
	            _this2.ChargepointHelper.getParentGroups(_this2.chargepoint).then(function (parents) {
	              _this2.groups.parent = parents ? parents.parent : null;
	              _this2.groups.parentWithLocation = parents ? parents.parentWithLocation : null;
	            });
	          }
	        }
	      });

	      this.$scope.$watch('ctrl.tabs.active', function () {
	        _this2.reloadTabs();
	      });

	      this.$rootScope.$on('reloadEventsSocket', function () {
	        if (_this2.chargepoint) _this2.subscribeToChargepoint(_this2.chargepoint);
	      });

	      this.$rootScope.$on('chargepointChanged', function (event, changed) {
	        if (_this2.chargepoint && changed && changed.id === _this2.chargepoint.id) {
	          _this2.chargepoint = _this2.App.updateComplexDataObject(_this2.chargepoint, changed);
	          _this2._mapTariffs(_this2.chargepoint.connectors);
	          if (changed && changed.ocppConnection && ('connected' in changed.ocppConnection || 'websocketConnected' in changed.ocppConnection)) {
	            _this2.App.setBreadcrumsStatus(_this2.getBreadcrumStatus(_this2.chargepoint));
	          }
	        }
	        _this2.$scope.$apply();
	      });

	      this.setBreadcrums();
	      this.reload();
	    }
	  }, {
	    key: 'getConnectorType',
	    value: function getConnectorType(connector) {
	      var connectorTypeFiltered = this.$filter('connectorType')(connector.type);
	      var connectorTypeWithUnknown = this.$filter('unknown')(connectorTypeFiltered, this.$translate.instant('CH.CONNECTORS.UNDEFINED'));

	      var connectorModeFiltered = this.$filter('connectorMode')(connector.mode, connector);
	      var connectorModeWithUnknown = this.$filter('unknown')(connectorModeFiltered, this.$translate.instant('CH.CONNECTORS.UNDEFINED'));

	      var connectorPowerFiltered = this.$filter('connectorPower')(connector.power);
	      var connectorPowerWithUnknown = this.$filter('unknown')(connectorPowerFiltered, this.$translate.instant('CH.CONNECTORS.UNDEFINED'));

	      return this.$translate.instant('CH.CONNECTORS.CONNECTOR_TYPE') + ': ' + connectorTypeWithUnknown + '<br>' + this.$translate.instant('CH.CONNECTORS.CONNECTOR_MODE') + ': ' + connectorModeWithUnknown + '<br>' + this.$translate.instant('CH.CONNECTORS.POWER') + ': ' + connectorPowerWithUnknown;
	    }
	  }, {
	    key: 'getCustom',
	    value: function getCustom() {
	      return this.Auth.isAdminOfGroup() || this.Auth.isDoerOfGroup() ? { omit: ["start.customerName", "chargeCustomerName", "chargepointId"] } : { omit: ["chargepointId"] };
	    }
	  }, {
	    key: 'isWebsocket',
	    value: function isWebsocket() {
	      return this.chargepoint && this.ChargepointHelper.isWebsocket(this.chargepoint);
	    }
	  }, {
	    key: 'isConnected',
	    value: function isConnected() {
	      return this.chargepoint && this.ChargepointHelper.isConnected(this.chargepoint);
	    }
	  }, {
	    key: 'isDisconnected',
	    value: function isDisconnected() {
	      return this.chargepoint && this.ChargepointHelper.isDisconnected(this.chargepoint);
	    }
	  }, {
	    key: 'isRoaming',
	    value: function isRoaming() {
	      return this.chargepoint && this.ChargepointHelper.isRoaming(this.chargepoint);
	    }
	  }, {
	    key: 'isPooling',
	    value: function isPooling() {
	      return this.chargepoint && this.ChargepointHelper.isPooling(this.chargepoint);
	    }
	  }, {
	    key: 'isProxy',
	    value: function isProxy() {
	      return this.chargepoint && this.ChargepointHelper.isProxy(this.chargepoint);
	    }
	  }, {
	    key: 'isProvider',
	    value: function isProvider() {
	      return this.Auth.isProvider();
	    }
	  }, {
	    key: 'isAdmin',
	    value: function isAdmin() {
	      return this.Auth.isAdmin();
	    }
	  }, {
	    key: 'askToStartRemoteTransaction',
	    value: function askToStartRemoteTransaction(connector) {
	      return this.ChargepointHelper.askToStartRemoteTransaction(this.$scope, connector, {
	        chargepoint: this.chargepoint,
	        organization: this.organization
	      });
	    }
	  }, {
	    key: 'isInActiveTransaction',
	    value: function isInActiveTransaction(connector) {
	      return connector && connector.transaction && connector.transaction.transactionId && connector.transaction.active === 'true';
	    }
	  }, {
	    key: 'isConnectedToProxy',
	    value: function isConnectedToProxy(chargepoint) {
	      return chargepoint.proxyList && chargepoint.proxyList.length;
	    }
	  }, {
	    key: 'stopRemoteTransaction',
	    value: function stopRemoteTransaction(connector) {
	      var _this3 = this;

	      if (this.isInActiveTransaction(connector)) {
	        var options = {
	          organization: this.organization,
	          notifications: true
	        };
	        this.App.closeModal();
	        return this.ChargePointsService.stopChargepointConnectorRemoteTransaction(this.chargepoint.id, connector.transaction.transactionId, options).then(function (ocppResult) {
	          var result = _this3.OCPP.onCallResult('RemoteStopTransaction', ocppResult);
	          if (result.notification) {
	            _this3.App.showNotification(result.notification.message, result.notification.style);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'isConnectorReserved',
	    value: function isConnectorReserved(connector) {
	      return connector && connector.status && connector.status.status === 'Reserved';
	    }
	  }, {
	    key: 'isConnectorComplete',
	    value: function isConnectorComplete(connector) {
	      if (connector.id === '0') {
	        return true;
	      }
	      var CONNECTOR_REQUIRED_PROPERTIES = ['id', 'mode', 'type', 'power', 'current', 'voltage', 'status'];
	      return CONNECTOR_REQUIRED_PROPERTIES.every(function (requiredProperty) {
	        return requiredProperty in connector && connector[requiredProperty] !== null;
	      });
	    }
	  }, {
	    key: 'askToUnlockConnector',
	    value: function askToUnlockConnector(connector) {
	      var _this4 = this;

	      return new Promise(function (resolve) {
	        _this4.$scope.modal = {
	          chargepoint: _this4.chargepoint,
	          connector: connector,
	          done: function done() {
	            return resolve(_this4.unlockConnector(_this4.$scope.modal.connector));
	          }
	        };
	        _this4.App.openModal(_this4.$scope, 'unlock-chargepoint-connector.html');
	      });
	    }
	  }, {
	    key: 'unlockConnector',
	    value: function unlockConnector(connector) {
	      var _this5 = this;

	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      this.App.closeModal();
	      return this.ChargePointsService.unlockChargepointConnector(this.chargepoint.id, connector.id, options).then(function (ocppResult) {
	        var result = _this5.OCPP.onCallResult('UnlockConnector', ocppResult);
	        if (result.notification) {
	          _this5.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'changeConnectorAvailability',
	    value: function changeConnectorAvailability(operative, connector) {
	      var _this6 = this;

	      var value = operative ? 'Operative' : 'Inoperative';
	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.changeChargepointConnectorAvailability(this.chargepoint.id, connector.id, value, options).then(function (ocppResult) {
	        var result = _this6.OCPP.onCallResult('ChangeAvailability', ocppResult);
	        if (result.notification) {
	          _this6.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'editConnectorLabel',
	    value: function editConnectorLabel(connector, changed) {
	      var _this7 = this;

	      if (!connector || !changed || changed.label === null || angular.isUndefined(changed.label)) return;
	      return this.ChargePointsService.editChargepointConnector(this.chargepoint.id, connector.id, changed, {
	        organization: this.organization
	      }).then(function () {
	        return _this7.reloadChargepoint();
	      });
	    }
	  }, {
	    key: 'askToEditConnectorSettings',
	    value: function askToEditConnectorSettings(connector) {
	      var _this8 = this;

	      return this.ChargepointHelper.editConnectorSettings(this.$scope, connector, {
	        chargepoint: this.chargepoint,
	        organization: this.organization
	      }).then(function () {
	        return _this8.reloadChargepoint();
	      });
	    }
	  }, {
	    key: 'changeOperationalStatus',
	    value: function changeOperationalStatus(status) {
	      var _this9 = this;

	      var isNotComplete = !this.chargepoint.connectors.length || !this.chargepoint.connectors.every(this.isConnectorComplete);
	      return this.ChargePointsService.changeChargepointStatus(this.chargepoint.id, status, {
	        organization: this.organization,
	        notifications: {
	          error: isNotComplete && ['Operative', 'Private', 'SemiPublic'].includes(status) ? "UPDATE_CHARGEPOINT_STATUS_FAILED_INCOMPLETE" : "CH.ACTIONS.OPERATIONAL_STATUS.FAILED"
	        }
	      }).then(function () {
	        return _this9.reload();
	      });
	    }
	  }, {
	    key: 'changeOwnership',
	    value: function changeOwnership(ownership) {
	      var _this10 = this;

	      return this.ChargePointsService.changeChargepointOwnership(this.chargepoint.id, ownership, {
	        organization: this.organization
	      }).then(function () {
	        return _this10.App.showNotification(_this10.$translate.instant('CH.ACTIONS.CHANGE_OWNERSHIP.SUCCESS'));
	      }).catch(function () {
	        _this10.state.chargepoint.ownership = _this10.ChargepointHelper.getOwnership(_this10.chargepoint);
	        _this10.App.showNotification(_this10.$translate.instant('CH.ACTIONS.CHANGE_OWNERSHIP.FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'changeAvailability',
	    value: function changeAvailability(operative) {
	      var _this11 = this;

	      var value = operative ? 'Operative' : 'Inoperative';
	      this.state.chargepoint.loading['operative'] = true;
	      return this.ChargePointsService.changeChargepointAvailability(this.chargepoint.id, value, {
	        organization: this.organization
	      }).then(function (ocppResult) {
	        var result = _this11.OCPP.onCallResult('ChangeAvailability', ocppResult);
	        if (result.notification) _this11.App.showNotification(result.notification.message, result.notification.style);
	        _this11.state.chargepoint.loading['operative'] = false;
	      }).catch(function () {
	        _this11.state.chargepoint.loading['operative'] = false;
	        _this11.App.showNotification(_this11.$translate.instant('CH.ACTIONS.CHANGE_AVAILABILITY.FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'resetChargepoint',
	    value: function resetChargepoint(type) {
	      var _this12 = this;

	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.resetChargepoint(this.chargepoint.id, type, options).then(function (ocppResult) {
	        var result = _this12.OCPP.onCallResult('Reset', ocppResult);
	        if (result.notification) {
	          _this12.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'clearCache',
	    value: function clearCache() {
	      var _this13 = this;

	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.clearChargepointCache(this.chargepoint.id, options).then(function (ocppResult) {
	        var result = _this13.OCPP.onCallResult('ClearCache', ocppResult);
	        if (result.notification) {
	          _this13.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'clearLocalAuthorizationList',
	    value: function clearLocalAuthorizationList() {
	      var _this14 = this;

	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.clearLocalAuthorizationList(this.chargepoint.id, options).then(function (ocppResult) {
	        var result = _this14.OCPP.onCallResult('SendLocalList', ocppResult);
	        if (result.notification) {
	          _this14.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'triggerStatusNotification',
	    value: function triggerStatusNotification() {
	      var _this15 = this;

	      var message = { requestedMessage: 'StatusNotification' };
	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.triggerMessage(this.chargepoint.id, message, options).then(function (ocppResult) {
	        var result = _this15.OCPP.onCallResult('TriggerMessage', ocppResult);
	        if (result.notification) {
	          _this15.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'programReboot',
	    value: function programReboot(task) {
	      var _this16 = this;

	      return this.ChargePointsService.programChargepointReboot(this.chargepoint.id, task, {
	        organization: this.organization
	      }).then(function () {
	        _this16.App.closeModal();
	        _this16.App.showNotification(_this16.$translate.instant('CH.ACTIONS.PROGRAM_REBOOT.SUCCESS'));
	      }).catch(function () {
	        _this16.App.closeModal();
	        return _this16.App.showNotification(_this16.$translate.instant('CH.ACTIONS.PROGRAM_REBOOT.FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'removeProgramReboot',
	    value: function removeProgramReboot(task) {
	      var _this17 = this;

	      return this.ChargePointsService.removeChargepointProgramReboot(this.chargepoint.id, task, {
	        organization: this.organization
	      }).then(function () {
	        _this17.App.closeModal();
	        _this17.App.showNotification(_this17.$translate.instant('CH.ACTIONS.PROGRAM_REBOOT.REMOVE_SUCCESS'));
	      }).catch(function () {
	        _this17.App.closeModal();
	        _this17.App.showNotification(_this17.$translate.instant('CH.ACTIONS.PROGRAM_REBOOT.REMOVE_FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'triggerDiagnosticsStatusNotification',
	    value: function triggerDiagnosticsStatusNotification() {
	      var _this18 = this;

	      var message = { requestedMessage: 'DiagnosticsStatusNotification' };
	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.triggerMessage(this.chargepoint.id, message, options).then(function (ocppResult) {
	        var result = _this18.OCPP.onCallResult('TriggerMessage', ocppResult);
	        if (result.notification) {
	          _this18.App.showNotification(result.notification.message, result.notification.style);
	        }
	      });
	    }
	  }, {
	    key: 'setConfiguration',
	    value: function setConfiguration(changes) {
	      var _this19 = this;

	      if (changes.changed) {
	        return this.ChargePointsService.setChargepointConfiguration(this.chargepoint.id, changes.changed, {
	          organization: this.organization
	        }).then(function () {
	          return _this19.reload();
	        });
	      }
	    }
	  }, {
	    key: 'canAdminChargepoint',
	    value: function canAdminChargepoint() {
	      return (this.$rootScope.role.entity === 'provider' || this.$rootScope.role.entity === 'organization' || this.$rootScope.role.entity === 'group') && this.$rootScope.role.role === 'admin';
	    }
	  }, {
	    key: 'editChargepoint',
	    value: function editChargepoint(changed) {
	      var _this20 = this;

	      return new Promise(function (resolve) {
	        if (changed.hasOwnProperty('billable') || changed.hasOwnProperty('setTarget') || changed.hasOwnProperty('numberPhases') || changed.hasOwnProperty('maxPower')) {
	          var data = _lodash2.default.pick(changed, ['billable', 'setTarget', 'numberPhases', 'maxPower']);
	          var options = {
	            notifications: true
	          };
	          _this20.ChargePointsService.editProtectedChargepoint(_this20.chargepoint.id, data, options).then(function (chargepoint) {
	            if (chargepoint) {
	              _this20.chargepoint = chargepoint;
	              _this20._mapTariffs(chargepoint.connectors);
	            }
	            changed = _lodash2.default.omit(changed, ['billable', 'setTarget', 'numberPhases', 'maxPower']);
	            resolve(changed);
	          });
	        } else {
	          resolve(changed);
	        }
	      }).then(function (changed) {
	        if (!_lodash2.default.isEmpty(changed)) {
	          var options = {
	            notifications: true,
	            organization: _this20.organization
	          };
	          _this20.ChargePointsService.editChargepoint(_this20.chargepoint.id, changed, options).then(function (chargepoint) {
	            if (changed.hasOwnProperty('proxyList')) {
	              _this20.App.showNotification(_this20.$translate.instant('CH.NEED_REBOOT'), 'warning', null, 1000);
	            }
	            if (chargepoint) {
	              _this20.chargepoint = chargepoint;
	              _this20._mapTariffs(chargepoint.connectors);
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'askToRemoveChargepoint',
	    value: function askToRemoveChargepoint() {
	      this.$scope.modal = {
	        chargepoint: this.chargepoint
	      };
	      this.App.openModal(this.$scope, 'remove-chargepoint.html', { size: 'md' });
	    }
	  }, {
	    key: 'removeChargepoint',
	    value: function removeChargepoint() {
	      var _this21 = this;

	      return this.ChargePointsService.removeChargepoint(this.chargepoint.id, {
	        organization: this.organization
	      }).then(function () {
	        _this21.App.showNotification(_this21.$translate.instant('CH.ACTIONS.REMOVE_CHARGEPOINT.SUCCESS', {
	          name: '<accent>' + _this21.chargepoint.name + '</accent>'
	        }), 'ok', null, 1000);
	        _this21.$state.go('efimob.chargepoints.at.list', {
	          organization: _this21.organization
	        });
	        _this21.App.closeModal();
	      }).catch(function () {
	        _this21.App.showNotification(_this21.$translate.instant('CH.ACTIONS.REMOVE_CHARGEPOINT.FAILED'), 'error');
	        _this21.App.closeModal();
	      });
	    }
	  }, {
	    key: 'isValid',
	    value: function isValid(modal) {
	      return modal.group && this.GroupsHelper.hasPosition(modal.group);
	    }
	  }, {
	    key: 'askToChangeGroup',
	    value: function askToChangeGroup() {
	      var _this22 = this;

	      return this.ChargepointHelper.changeLocation(this.$scope, {
	        chargepoint: this.chargepoint
	      }, { organizationId: this.organization }).then(function () {
	        _this22.reload();
	        _this22.App.closeModal();
	      }).catch(function () {
	        _this22.App.closeModal();
	        _this22.App.showNotification(_this22.$translate.instant('CH.ACTIONS.CHANGE_GROUP.FAILED', {
	          name: '<strong>' + _this22.chargepoint.name + '</strong>'
	        }), 'error');
	      });
	    }
	  }, {
	    key: 'askToChangeOrganization',
	    value: function askToChangeOrganization() {
	      var _this23 = this;

	      return this.ChargepointHelper.askToAssignToOrganization(this.$scope, [this.chargepoint.id], {
	        leavingOrganization: this.organization
	      }).then(function (newTarget) {
	        return _this23.$state.go('efimob.chargepoints.at.item', {
	          id: newTarget.chargepoints[0].id,
	          organization: newTarget.organization
	        });
	      });
	    }
	  }, {
	    key: 'onChargeClick',
	    value: function onChargeClick(charge) {
	      this.$state.go('efimob.charges.at.item', {
	        id: charge.id,
	        organization: this.organization
	      });
	    }
	  }, {
	    key: 'exportCharges',
	    value: function exportCharges() {
	      var _this24 = this;

	      var options = {
	        filters: this.filters.charges,
	        sorting: this.tables.charges.sorting,
	        organization: this.organization,
	        params: { output: 'csv', count: this.tables.charges.pagination.totalItems }
	      };

	      return this.ChargeSessionsService.getChargesByChargepoint(this.chargepoint.id, options, false, true).then(function ( /** @type {{docs: Blob, emailExport: boolean}} */charges) {
	        if (charges.emailExport) {
	          return _this24.App.showNotification(_this24.$translate.instant('EXPORT_BY_EMAIL'), 'ok');
	        }
	        _this24.App.downloadCSV(charges.docs, _this24.$translate.instant('CH.CHARGES.EXPORT_FILENAME_CHARGES') + '-' + _this24.chargepoint.id + '-' + _this24.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      }).catch(function () {
	        return _this24.App.showNotification(_this24.$translate.instant('CH.CHARGES.EXPORT_FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'onUserkeyClick',
	    value: function onUserkeyClick(userkey) {
	      if (userkey) {
	        this.$state.go('efimob.userkeys.at.item', {
	          id: userkey.userKeyId,
	          organization: userkey.organizationId
	        });
	      }
	    }
	  }, {
	    key: 'exportOcppMessages',
	    value: function exportOcppMessages() {
	      var _this25 = this;

	      return this.ChargePointsService.exportChargepointOCPPMessages(this.chargepoint.id, {
	        filters: this.filters.ocppMessages,
	        sorting: this.tables.ocppMessages.sorting,
	        organization: this.organization
	      }).then(function (ocppMessages) {
	        return _this25.App.downloadCSV(ocppMessages, _this25.$translate.instant('CH.AUDITORY.EXPORT_FILENAME_AUDITORY') + '-' + _this25.chargepoint.id + '-' + _this25.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	      }).catch(function () {
	        return _this25.App.showNotification(_this25.$translate.instant('CH.AUDITORY.EXPORT_FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'askToRequestNewDiagnostic',
	    value: function askToRequestNewDiagnostic() {
	      var _this26 = this;

	      var isValid = function isValid(modal) {
	        if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	          return modal.diagnostic && modal.diagnostic.location;
	        }
	        return true;
	      };
	      var next = function next(modal) {
	        if (modal.wizard.steps[modal.wizard.step].id === 'range') {
	          if (modal.presetRange.id === 'custom') {
	            modal.diagnostic.startTime = _this26.moment(modal.inputs.from.value) ? _this26.moment(modal.inputs.from.value).startOf('day').toISOString() : undefined;
	            modal.diagnostic.stopTime = _this26.moment(modal.inputs.to.value) ? _this26.moment(modal.inputs.to.value).endOf('day').toISOString() : undefined;
	          } else if (modal.presetRange.id === 'ever') {
	            modal.diagnostic.startTime = undefined;
	            modal.diagnostic.stopTime = undefined;
	          } else {
	            var now = _this26.moment();
	            modal.diagnostic.stopTime = undefined;
	            // modal.diagnostic.stopTime = now.toISOString();
	            modal.diagnostic.startTime = now.subtract(modal.presetRange.duration[0], modal.presetRange.duration[1]).toISOString();
	          }
	        }
	        if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	          if (modal.retryPolicy.id === 'custom') {
	            modal.diagnostic.retries = modal.inputs.retries.value;
	            modal.diagnostic.retryInterval = modal.inputs.retryInterval.value;
	          } else {
	            modal.diagnostic.retries = undefined;
	            modal.diagnostic.retryInterval = undefined;
	          }
	        }
	      };
	      return new Promise(function (resolve) {
	        _this26.$scope.modal = {
	          chargepoint: _this26.chargepoint,
	          diagnostic: {
	            startTime: undefined,
	            stopTime: undefined,
	            location: 'ftp://user:pass@host:port/path',
	            // location: 'ftp://chargepoint:vizibles@192.168.0.157:21/chargepoint',
	            // location: 'ftp://vizibles:vizibles@192.168.0.26/home/vizibles/diagnostics',
	            retries: undefined,
	            retryInterval: undefined
	          },
	          presetRanges: [{
	            id: 'last24Hours',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LAST_HOURS', { h: 24 }),
	            duration: [24, 'hours']
	          }, {
	            id: 'last2Days',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LAST_DAYS', { d: 2 }),
	            duration: [2, 'days']
	          }, {
	            id: 'lastWeek',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LAST_WEEK'),
	            duration: [7, 'days']
	          }, {
	            id: 'lastMonth',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LAST_MONTH'),
	            duration: [1, 'month']
	          }, {
	            id: 'last3Months',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LAST_MONTHS', { m: 3 }),
	            duration: [3, 'months']
	          }, {
	            id: 'lastYear',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LAST_YEAR'),
	            duration: [1, 'years']
	          }, {
	            id: 'ever',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.ALL')
	          }, {
	            id: 'custom',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.CUSTOM')
	          }],
	          retryPolicies: [{
	            id: 'localPolicy',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.VENDOR_DEFAULTS')
	          }, {
	            id: 'custom',
	            display: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.CUSTOM')
	          }],
	          inputs: {
	            from: {
	              value: null,
	              format: 'dd MMM yyyy',
	              opened: false,
	              options: {
	                showWeeks: false,
	                startingDay: 1
	              }
	            },
	            to: {
	              value: null,
	              format: 'dd MMM yyyy',
	              opened: false,
	              options: {
	                showWeeks: false,
	                startingDay: 1
	              }
	            },
	            retries: { value: 3 },
	            retryInterval: { value: 60 }
	          },
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'range',
	              title: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.RANGE'),
	              intro: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.RANGE_INTRO')
	            }, {
	              id: 'location',
	              title: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LOCATION'),
	              intro: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.LOCATION_INTRO')
	            }, {
	              id: 'summary',
	              title: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.SUMMARY'),
	              intro: _this26.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.SUMMARY_INTRO')
	            }]
	          },
	          isValid: isValid,
	          next: next,
	          done: function done() {
	            return resolve(_this26.requestNewDiagnostic(_lodash2.default.omit(_this26.$scope.modal.diagnostic, _lodash2.default.isNil)));
	          }
	        };
	        _this26.$scope.modal.presetRange = _this26.$scope.modal.presetRanges[0];
	        _this26.$scope.modal.retryPolicy = _this26.$scope.modal.retryPolicies[0];
	        _this26.App.openModal(_this26.$scope, 'new-diagnostic.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'requestNewDiagnostic',
	    value: function requestNewDiagnostic(diagnostic) {
	      var _this27 = this;

	      this.fileName = null;
	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      this.App.closeModal();
	      return this.ChargePointsService.getChargepointDiagnostic(this.chargepoint.id, diagnostic, options).then(function (ocppResult) {
	        var fileName = _this27.OCPP.onCallResult('GetDiagnostics', ocppResult);
	        if (!fileName) _this27.App.showNotification(_this27.$translate.instant('CH.ACTIONS.GET_DIAGNOSTICS.NO_DATA'), 'warning');
	        if (fileName) _this27.fileName = fileName;
	      });
	    }
	  }, {
	    key: 'askToUpdateFirmware',
	    value: function askToUpdateFirmware() {
	      var _this28 = this;

	      var isValid = function isValid(modal) {
	        if (modal.wizard.steps[modal.wizard.step].id === 'retrieve') {
	          return _this28.moment(modal.inputs.from.value).isValid();
	        }
	        if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	          return modal.firmware && modal.firmware.location;
	        }
	        return true;
	      };
	      var next = function next(modal) {
	        if (modal.wizard.steps[modal.wizard.step].id === 'retrieve') {
	          modal.firmware.retrieveDate = _this28.moment(modal.inputs.from.value) ? _this28.moment(modal.inputs.from.value).startOf('day').toISOString() : undefined;
	        }
	        if (modal.wizard.steps[modal.wizard.step].id === 'location') {
	          if (modal.retryPolicy.id === 'custom') {
	            modal.firmware.retries = modal.inputs.retries.value;
	            modal.firmware.retryInterval = modal.inputs.retryInterval.value;
	          } else {
	            modal.firmware.retries = undefined;
	            modal.firmware.retryInterval = undefined;
	          }
	        }
	      };
	      return new Promise(function (resolve) {
	        _this28.$scope.modal = {
	          chargepoint: _this28.chargepoint,
	          firmware: {
	            retrieveDate: undefined,
	            location: 'ftp://user:pass@host:port/path',
	            // location: 'ftp://chargepoint:vizibles@192.168.0.157:21/chargepoint',
	            // location: 'ftp://vizibles:vizibles@192.168.0.26/home/vizibles/diagnostics',
	            retries: undefined,
	            retryInterval: undefined
	          },
	          retryPolicies: [{
	            id: 'localPolicy',
	            display: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.VENDOR_DEFAULTS')
	          }, {
	            id: 'custom',
	            display: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.CUSTOM')
	          }],
	          inputs: {
	            from: {
	              value: new Date(),
	              format: 'dd MMM yyyy',
	              opened: false,
	              options: {
	                showWeeks: false,
	                startingDay: 1
	              }
	            },
	            retries: { value: 3 },
	            retryInterval: { value: 60 }
	          },
	          wizard: {
	            step: 0,
	            steps: [{
	              id: 'location',
	              title: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.LOCATION'),
	              intro: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.LOCATION_INTRO')
	            }, {
	              id: 'retrieve',
	              title: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.RETRIEVE'),
	              intro: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.RETRIEVE_INTRO')
	            }, {
	              id: 'summary',
	              title: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.SUMMARY'),
	              intro: _this28.$translate.instant('CH.ACTIONS.UPDATE_FW.SUMMARY_INTRO')
	            }]
	          },
	          isValid: isValid,
	          next: next,
	          done: function done() {
	            return resolve(_this28.updateFirmware(_lodash2.default.omit(_this28.$scope.modal.firmware, _lodash2.default.isNil)));
	          }
	        };
	        _this28.$scope.modal.retryPolicy = _this28.$scope.modal.retryPolicies[0];
	        _this28.App.openModal(_this28.$scope, 'update-firmware.html', { size: 'lg' });
	      });
	    }
	  }, {
	    key: 'updateFirmware',
	    value: function updateFirmware(firmware) {
	      var _this29 = this;

	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      this.App.closeModal();
	      return this.ChargePointsService.updateChargepointFirmware(this.chargepoint.id, firmware, options).then(function () {
	        _this29.App.showNotification(_this29.$translate.instant('CH.ACTIONS.UPDATE_FW.SUCCESS'));
	      });
	    }
	  }, {
	    key: 'askToAddProgramedReboot',
	    value: function askToAddProgramedReboot() {
	      var _this30 = this;

	      return this.ChargepointHelper.addProgramReboot(this.$scope, {
	        organization: this.organization
	      }).then(function () {
	        return _this30.reload();
	      });
	    }
	  }, {
	    key: 'askToEditProgramedReboot',
	    value: function askToEditProgramedReboot(programedReboot) {
	      var _this31 = this;

	      return this.ChargepointHelper.editProgramReboot(this.$scope, programedReboot, {
	        organization: this.organization
	      }).then(function () {
	        return _this31.reload();
	      });
	    }
	  }, {
	    key: 'askToRemoveProgramedReboot',
	    value: function askToRemoveProgramedReboot(programedReboot) {
	      var _this32 = this;

	      return this.ChargepointHelper.removeProgramReboot(this.$scope, programedReboot, {
	        organization: this.organization
	      }).then(function () {
	        return _this32.reload();
	      });
	    }
	  }, {
	    key: 'askToAddRechargingSchedule',
	    value: function askToAddRechargingSchedule() {
	      var _this33 = this;

	      return this.ChargepointHelper.addRechargingSchedule(this.$scope, { list: this.rechargingSchedule, current: null }, { organization: this.organization }).then(function () {
	        return _this33.reload();
	      });
	    }
	  }, {
	    key: 'askToEditRechargingSchedule',
	    value: function askToEditRechargingSchedule(data) {
	      var _this34 = this;

	      return this.ChargepointHelper.editRechargingSchedule(this.$scope, data, {
	        organization: this.organization
	      }).then(function () {
	        return _this34.reload();
	      });
	    }
	  }, {
	    key: 'askToRemoveRechargingSchedule',
	    value: function askToRemoveRechargingSchedule(data) {
	      var _this35 = this;

	      return this.ChargepointHelper.removeRechargingSchedule(this.$scope, data, {
	        organization: this.organization
	      }).then(function () {
	        return _this35.reload();
	      });
	    }
	  }, {
	    key: 'onAlarmChanged',
	    value: function onAlarmChanged(value, event) {
	      var _this36 = this;

	      return this.AlarmsService.setForChargepoint(this.chargepoint.id, { event: event, value: value, rule: this.alarms[event].rule }, { organization: this.organization }).then(function () {
	        return _this36.reloadAlarms();
	      }).catch(function () {
	        return _this36.App.showNotification(_this36.$translate.instant('CH.ACTIONS.CHANGE_ALARM.FAILED'), 'error');
	      });
	    }
	  }, {
	    key: 'onSharedChanged',
	    value: function onSharedChanged(value) {
	      var _this37 = this;

	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      this.state.chargepoint.loading['shared'] = true;
	      return this.ChargePointsService.setSharedForChargepoint(this.chargepoint, value, options).then(function () {
	        _this37.state.chargepoint.loading['shared'] = false;
	        _this37.reloadChargepoint();
	      });
	    }
	  }, {
	    key: 'setTabs',
	    value: function setTabs() {
	      var _this38 = this;

	      var list = [{
	        id: 'control',
	        display: this.$translate.instant('CH.TABS.CONTROL'),
	        url: 'control'
	      }, {
	        id: 'info',
	        display: this.$translate.instant('CH.TABS.INFO'),
	        url: 'info'
	      }, {
	        id: 'charges',
	        display: this.$translate.instant('CH.TABS.CHARGES'),
	        url: 'recargas',
	        count: function count() {
	          return _this38.charges ? _this38.tables.charges.pagination.totalItems : '...';
	        }
	      }, {
	        id: 'tariffs',
	        display: this.$translate.instant('TARIFFS'),
	        url: 'tariffs',
	        count: function count() {
	          return _this38.connectorTariffs ? _this38.tables.connectorTariffs.pagination.totalItems : '...';
	        }
	      }];
	      var roaming = this.isRoaming();
	      var connected = this.isWebsocket();

	      if (connected && !roaming) list.push({
	        id: 'conf',
	        display: this.$translate.instant('CH.TABS.CONF'),
	        url: 'conf'
	      });
	      if (!roaming) list.push({
	        id: 'firmware',
	        display: this.$translate.instant('CH.TABS.FIRMWARE'),
	        url: 'firmware'
	      });
	      if (connected && !roaming) list.push({
	        id: 'diagnostics',
	        display: this.$translate.instant('CH.TABS.DIAGNOSTICS'),
	        url: 'diagnosticos'
	      });
	      if (!roaming) list.push({
	        id: 'ocppMessages',
	        display: this.$translate.instant('CH.TABS.AUDITORY'),
	        url: 'auditoria',
	        count: function count() {
	          return _this38.ocppMessages ? _this38.ocppMessages.length : '...';
	        }
	      });
	      if (!roaming) list.push({
	        id: 'alarms',
	        display: this.$translate.instant('CH.TABS.ALARMS'),
	        url: 'alarmas'
	      });
	      var active = list[0];
	      if (this.tab && _lodash2.default.findIndex(list, { url: this.tab }) >= 0) {
	        active = list[_lodash2.default.findIndex(list, { url: this.tab })];
	      }
	      this.tabs['active'] = this.tabs['active'] || active;
	      this.tabs['list'] = list;
	    }
	  }, {
	    key: 'reloadConfiguration',
	    value: function reloadConfiguration() {
	      var _this39 = this;

	      if (this.state.loading['configuration']) return;
	      var options = {
	        organization: this.organization,
	        notifications: true
	      };
	      return this.ChargePointsService.getChargepointConfiguration(this.chargepoint.id, options).then(function (ocppResult) {
	        var configuration = _this39.OCPP.onCallResult('GetConfiguration', ocppResult);
	        if (configuration) {
	          _this39.configuration = _lodash2.default.uniqBy(configuration, 'key');
	        }
	      });
	    }
	  }, {
	    key: 'reloadCharges',
	    value: function reloadCharges() {
	      var _this40 = this;

	      if (this.state.loading['charges']) return;
	      this.state.loading['charges'] = true;
	      this.App.setLoading(true);
	      return this.ChargeSessionsService.getChargesByChargepoint(this.chargepoint.id, {
	        filters: this.filters.charges,
	        pagination: this.tables.charges.pagination,
	        sorting: this.tables.charges.sorting,
	        organization: this.organization
	      }).then(function (charges) {
	        _this40.charges = charges.docs;
	        _this40.tables.charges.pagination.currentPage = charges.currentPage;
	        _this40.tables.charges.pagination.totalItems = charges.totalItems;
	        _this40.state.loading['charges'] = false;
	        _this40.App.setLoading(false);
	      }).catch(function () {
	        _this40.state.loading['charges'] = false;
	        _this40.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'reloadOcppMessages',
	    value: function reloadOcppMessages() {
	      var _this41 = this;

	      if (this.state.loading['ocppMessages']) return;
	      this.state.loading['ocppMessages'] = true;
	      this.App.setLoading(true);
	      return this.ChargePointsService.getChargepointOCPPMessages(this.chargepoint.id, {
	        filters: this.filters.ocppMessages,
	        params: {
	          page: this.ocppMessagesPagination.page,
	          items: this.ocppMessagesPagination.items
	        },
	        sorting: this.tables.ocppMessages.sorting,
	        organization: this.organization
	      }).then(function (ocppMessages) {
	        if (ocppMessages.length > 0) {
	          _this41.concatOcppMessages(ocppMessages);
	        } else {
	          if (_this41.ocppMessagesPagination.page === 1) _this41.ocppMessages = ocppMessages;else _this41.App.showNotification(_this41.$translate.instant('CH.CONNECTORS.AUDITORY.NO_MORE_MESSAGES'));
	          _this41.ocppMessagesPagination.page = -1;
	        }

	        _this41.state.loading['ocppMessages'] = false;
	        _this41.App.setLoading(false);
	      }).catch(function () {
	        _this41.state.loading['ocppMessages'] = false;
	        _this41.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'clearOcppPagination',
	    value: function clearOcppPagination() {
	      this.ocppMessagesPagination.page = 1;
	    }
	  }, {
	    key: 'concatOcppMessages',
	    value: function concatOcppMessages(newMessages) {
	      switch (this.ocppMessagesPagination.page) {
	        case 1:
	          this.ocppMessages = newMessages;
	          break;
	        case 2:
	          this.ocppMessages = this.ocppMessages.concat(newMessages);
	          break;
	        default:
	          if (newMessages.length > 0) {
	            this.ocppMessages.splice(0, 100);
	            this.ocppMessages = this.ocppMessages.concat(newMessages);
	          }
	          break;
	      }
	    }
	  }, {
	    key: 'loadMoreOcppMessages',
	    value: function loadMoreOcppMessages() {
	      this.ocppMessagesPagination.page++;
	      this.reloadOcppMessages();
	    }
	  }, {
	    key: 'reloadDiagnostics',
	    value: function reloadDiagnostics() {
	      var _this42 = this;

	      if (this.state.loading['diagnostics']) return;
	      this.state.loading['diagnostics'] = true;
	      return this.ChargePointsService.getChargepointDiagnostics(this.chargepoint.id, {
	        filters: this.filters.diagnostics,
	        pagination: this.tables.diagnostics.pagination,
	        sorting: this.tables.diagnostics.sorting,
	        organization: this.organization
	      }).then(function (diagnostics) {
	        _this42.diagnostics = diagnostics;
	        _this42.state.loading['diagnostics'] = false;
	      });
	    }
	  }, {
	    key: 'reloadAlarms',
	    value: function reloadAlarms() {
	      var _this43 = this;

	      if (this.state.loading['alarms']) return;
	      this.state.loading['alarms'] = true;
	      return this.AlarmsService.getForChargepoint(this.chargepoint.id, {
	        organization: this.organization
	      }).then(function (alarms) {
	        _this43.alarms = alarms;
	        _this43.state.loading['alarms'] = false;
	      });
	    }
	  }, {
	    key: 'setState',
	    value: function setState() {
	      var _this44 = this;

	      this.state.chargepoint.status = this.chargepoint.status || null;
	      this.state.chargepoint.operative = this.ChargepointHelper.isOperative(this.chargepoint);
	      this.state.chargepoint.ownership = this.ChargepointHelper.getOwnership(this.chargepoint);
	      _lodash2.default.each(this.chargepoint.connectors, function (connector) {
	        _this44.state.connector[connector.id] = _this44.state.connector[connector.id] || {};
	        _this44.state.connector[connector.id].operative = _this44.ChargepointHelper.isConnectorOperative(connector);
	        _this44.state.connector[connector.id].loading = _this44.state.connector[connector.id].loading || {};
	      });
	      this.state.errors = this.ChargepointHelper.getErrors(this.chargepoint);
	    }
	  }, {
	    key: 'getBreadcrumStatus',
	    value: function getBreadcrumStatus(chargepoint) {
	      if (!chargepoint) return [];
	      var status = [];
	      // Connection states (2): connected, disconnected
	      if (this.isConnected()) {
	        status.push({
	          icon: 'signal-alt',
	          tooltip: this.$translate.instant('CH.BREADCRUMBS.CONNECTED'),
	          type: 'good'
	        });
	      } else {
	        status.push({
	          icon: 'signal-alt-slash',
	          tooltip: this.$translate.instant('CH.BREADCRUMBS.NOT_CONNECTED'),
	          type: 'bad'
	        });
	      }
	      // General status states (3): w/o errors and operativo, w/o errorr and inoperative, with errors
	      if (this.state.errors.length == 0) {
	        if (this.ChargepointHelper.isOperative(chargepoint)) {
	          status.push({
	            icon: 'heart-rate',
	            tooltip: this.$translate.instant('CH.BREADCRUMBS.NO_ERRORS_AND_OPERATIVE'),
	            type: 'good'
	          });
	        } else {
	          status.push({
	            icon: 'heart-rate',
	            tooltip: this.$translate.instant('CH.BREADCRUMBS.NO_ERRORS_AND_NO_OPERATIVE'),
	            type: 'neutral'
	          });
	        }
	      } else {
	        status.push({
	          icon: 'exclamation',
	          tooltip: this.$translate.instant('CH.BREADCRUMBS.WITH_ERRORS', {
	            reason: this.state.errors.length == 1 ? this.state.errors[0].errorCode : this.$translate.instant('CH.BREADCRUMBS.SEVERAL_ERRORS')
	          }),
	          type: 'bad'
	        });
	      }
	      var type = this.ChargepointHelper.getType(chargepoint);
	      if (type != '') {
	        status.push({
	          display: type,
	          tooltip: this.$translate.instant('CH.BREADCRUMBS.IS_' + type),
	          type: 'neutral'
	        });
	      }
	      return status;
	    }
	  }, {
	    key: 'setBreadcrums',
	    value: function setBreadcrums() {
	      if (this.chargepoint) this.App.setBreadcrumsTitle(this.chargepoint.name);
	      var backHref = this.$state.href('efimob.chargepoints.at.list', {
	        organization: this.organization
	      });
	      this.App.setBreadcrumsSteps([{
	        display: this.$translate.instant('CH.BREADCRUMBS.CHARGEPOINTS'),
	        href: backHref
	      }]);
	      this.App.setBreadcrumsStatus(this.getBreadcrumStatus(this.chargepoint));
	      this.App.setBreadcrumsRightActions([this.App.getActionBack(backHref, this.$translate.instant('CH.BREADCRUMBS.BACK_TO_CHARGEPOINTS')), this.App.getActionReload(this.reload)]);
	    }
	  }, {
	    key: '_reloadChargepoint',
	    value: function _reloadChargepoint() {
	      var _this45 = this;

	      this.groups.parent = null;
	      this.App.setLoading(true);
	      return this.ChargePointsService.getChargepoint(this.id, {
	        organization: this.organization || undefined
	      }).then(function (chargepoint) {
	        return _this45.subscribeToChargepoint(chargepoint);
	      }).then(function (chargepoint) {
	        _this45.chargepoint = chargepoint;
	        _this45._mapTariffs(chargepoint.connectors);
	        if (!_this45.isRoaming()) {
	          if (_this45.isProvider()) {
	            _this45.reloadRechargingSchedule();
	          }
	          if (_this45.isProvider() || _this45.isAdmin()) {
	            return _this45.reloadChargepointProgramedReboot();
	          }
	        }
	      }).then(function () {
	        _this45.ChargePointsService.getProxies().then(function (data) {
	          var proxies = _this45._adaptProxiesForDisplay(data);
	          _this45.properties = _this45._getProperties(proxies);
	        }).then(function () {
	          _this45.setBreadcrums();
	          _this45.App.setLoading(false);
	        });
	      });
	    }
	  }, {
	    key: 'reloadChargepointProgramedReboot',
	    value: function reloadChargepointProgramedReboot() {
	      var _this46 = this;

	      return this.ChargePointsService.getChargepointProgramReboot(this.chargepoint.id, {
	        organization: this.organization
	      }).then(function (tasks) {
	        if (tasks) {
	          _this46.programedReboots = tasks;
	        } else {
	          _this46.programedReboots = [];
	        }
	      });
	    }
	  }, {
	    key: 'reloadRechargingSchedule',
	    value: function reloadRechargingSchedule() {
	      var _this47 = this;

	      return this.ChargePointsService.getRechargingSchedule(this.chargepoint.id, {
	        organization: this.organization
	      }).then(function (data) {
	        _this47.rechargingSchedule = data ? data : [];
	      });
	    }
	  }, {
	    key: 'subscribeToChargepoint',
	    value: function subscribeToChargepoint(chargepoint) {
	      var _this48 = this;

	      this.subscribed = false;
	      var options = {
	        organization: chargepoint.organizationId
	      };
	      return this.ChargePointsService.subscribeToChargepoints([chargepoint.id], options).then(function () {
	        return _this48.subscribed = true;
	      }).then(function () {
	        return chargepoint;
	      });
	    }
	  }, {
	    key: 'reloadTabs',
	    value: function reloadTabs() {
	      if (angular.isUndefined(this.subscribed)) {
	        this.$timeout(this.reloadTabs.bind(this), 250);
	        return;
	      }
	      if (this.tabs.active) {
	        switch (this.tabs.active.id) {
	          case 'charges':
	            this.reloadCharges();
	            break;
	          case 'conf':
	            if (this.subscribed) this.reloadConfiguration();
	            break;
	          case 'ocppMessages':
	            this.reloadOcppMessages();
	            break;
	          case 'alarms':
	            this.reloadAlarms();
	            break;
	        }
	      }
	    }
	  }, {
	    key: '_reload',
	    value: function _reload() {
	      var _this49 = this;

	      return this.reloadChargepoint().then(function () {
	        return _this49.reloadTabs();
	      });
	    }
	  }, {
	    key: '_mapTariffs',
	    value: function _mapTariffs(connectors) {
	      var _this50 = this;

	      var result = [];
	      if (!_lodash2.default.isArray(connectors)) {
	        return;
	      }
	      angular.forEach(connectors, function (connector) {
	        if (!connector.tariffs || !connector.tariffs.length) {
	          return;
	        }
	        angular.forEach(connector.tariffs, function (tariff) {
	          result.push({
	            connectorId: connector.id,
	            organizationId: _this50.organization,
	            id: tariff.id,
	            name: tariff.name,
	            type: tariff.type,
	            roamingAgreementId: tariff.roamingAgreementId
	          });
	        });
	      });
	      this.tables.connectorTariffs.pagination.currentPage = 1;
	      this.tables.connectorTariffs.pagination.totalItems = result.length;
	      this.connectorTariffs = result;
	    }
	  }, {
	    key: '_adaptProxiesForDisplay',
	    value: function _adaptProxiesForDisplay(data) {
	      var proxies = data ? data : [];
	      var aux = [];
	      _lodash2.default.forEach(proxies, function (item) {
	        var value = item['name'];
	        aux.push({ display: value, id: value });
	      });
	      return aux;
	    }
	  }, {
	    key: '_getProperties',
	    value: function _getProperties() {
	      var _this51 = this;

	      var proxies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	      var proxyOptions = [{ display: this.$translate.instant('CH.NONE'), id: null }].concat(proxies);
	      return {
	        general: {
	          keys: ['serialOCPP', 'name', 'connectors | getPhysicalReferenceFromConnectors', 'organizationName | chargepointOrganization:ctrl.item', 'groupId | chargepointGroup:ctrl.item', 'ownership | chargepointOwnership:ctrl.item', 'vehicleType | vehicleType:ctrl.item', 'proxyList | chargepointProxyList:ctrl.item', 'hash', 'status | chargepointOperationalStatus', 'ocppConnection.connected | chargepointConnected', 'connectors | chargepointStatus:ctrl.item:true', 'transactions', 'securityProfile | displaySecurityProfile', 'chargingSchedulerEnabled | displayBoolean', 'setTarget | displayBoolean', 'numberPhases', 'maxPower | withUnit:"kWh"', 'billable | displayBoolean', 'externalId', 'capabilities | capabilities:ctrl.item'],
	          headers: [this.$translate.instant('CH.SERIAL_OCPP'), this.$translate.instant('CH.NAME'), this.$translate.instant('PHYSICAL_REFERENCES'), this.$translate.instant('CH.ORGANIZATION'), this.$translate.instant('CH.GROUP'), this.$translate.instant('CH.OWNERSHIP'), this.$translate.instant('CH.VEHICLE_TYPE'), this.$translate.instant('CH.PROXY'), this.$translate.instant('CH.HASH'), this.$translate.instant('CH.OPERATIONAL_STATUS'), this.$translate.instant('CH.CONNECTED'), this.$translate.instant('CH.STATUS'), this.$translate.instant('CH.PROP.CHARGES'), this.$translate.instant('CH.SecurityProfile'), this.$translate.instant('SCHEDULE_RECHARGING'), this.$translate.instant('CH.CONNECTORS.ACTIONS.TARGET'), this.$translate.instant('CH.PROP.NUMBER_PHASES'), this.$translate.instant('CH.PROP.MAX_POWER'), this.$translate.instant('BILLABLE'), this.$translate.instant('EXTERNAL_ID'), this.$translate.instant('CAPABILITIES')],
	          editable: ['serialOCPP', 'name', 'vehicleType', 'proxyList', 'chargingSchedulerEnabled', 'setTarget', 'numberPhases', 'maxPower', 'billable', 'capabilities'],
	          removable: ['serialOCPP'],
	          removedValue: { serialOCPP: '' },
	          confirmationRequired: {
	            serialOCPP: {
	              onChanged: {
	                message: this.$translate.instant('CH.EDIT.SERIAL_OCPP_CHANGED_MESSAGE', {
	                  serial: '<accent>__NEW_VALUE__</accent>'
	                }),
	                warning: '<b>' + this.$translate.instant('CH.EDIT.WARNING') + ': </b>' + this.$translate.instant('CH.EDIT.SERIAL_OCPP_WARNING', {
	                  serial: '<b>__OLD_VALUE__</b>'
	                })
	              },
	              onRemoved: {
	                message: this.$translate.instant('CH.EDIT.SERIAL_OCPP_REMOVED_MESSAGE'),
	                warning: '<b>' + this.$translate.instant('CH.EDIT.WARNING') + ': </b>' + this.$translate.instant('CH.EDIT.SERIAL_OCPP_WARNING', {
	                  serial: '<b>__OLD_VALUE__</b>'
	                })
	              }
	            }
	          },
	          meta: {
	            capabilities: {
	              type: 'multi-select',
	              options: [{ display: this.$translate.instant('RFID_READER'), id: "RFID_READER" }, { display: this.$translate.instant('START_SESSION_CONNECTOR_REQUIRED'), id: "START_SESSION_CONNECTOR_REQUIRED" }, { display: this.$translate.instant('TOKEN_GROUP_CAPABLE'), id: "TOKEN_GROUP_CAPABLE" }, { display: this.$translate.instant('UNLOCK_CAPABLE'), id: "UNLOCK_CAPABLE" }, { display: this.$translate.instant('CHARGING_PROFILE_CAPABLE'), id: "CHARGING_PROFILE_CAPABLE" }, { display: this.$translate.instant('CHARGING_PREFERENCES_CAPABLE'), id: "CHARGING_PREFERENCES_CAPABLE" }, { display: this.$translate.instant('CHIP_CARD_SUPPORT'), id: "CHIP_CARD_SUPPORT" }, { display: this.$translate.instant('CONTACTLESS_CARD_SUPPORT'), id: "CONTACTLESS_CARD_SUPPORT" }, { display: this.$translate.instant('CREDIT_CARD_PAYABLE'), id: "CREDIT_CARD_PAYABLE" }, { display: this.$translate.instant('DEBIT_CARD_PAYABLE'), id: "DEBIT_CARD_PAYABLE" }, { display: this.$translate.instant('PED_TERMINAL'), id: "PED_TERMINAL" }, { display: this.$translate.instant('REMOTE_START_STOP_CAPABLE'), id: "REMOTE_START_STOP_CAPABLE" }, { display: this.$translate.instant('RESERVABLE'), id: "RESERVABLE" }],
	              help: this.$translate.instant('CHARGER_CAPABILITIES_DESCRIPTION')
	            },
	            serialOCPP: {
	              info: this.$translate.instant('CH.SERIAL_OCPP_INFO'),
	              help: this.$translate.instant('CH.SERIAL_OCPP_HELP')
	            },
	            vehicleType: {
	              type: 'select',
	              options: [{ display: this.$translate.instant('CH.VEHICLE_TYPES.ALL_VEHICLE'), id: 'AllVehicles' }, { display: this.$translate.instant('CH.VEHICLE_TYPES.MOTORCYCLE'), id: 'motorcycle' }]
	            },
	            proxyList: {
	              type: 'select',
	              adaptFrom: function adaptFrom(data) {
	                var response = null;
	                if (angular.isArray(data) && data.length > 0) {
	                  response = data[0];
	                }
	                return response;
	              },
	              adaptTo: function adaptTo(data) {
	                var response = [];
	                if (data) {
	                  response.push(data);
	                }
	                return response;
	              },
	              options: proxyOptions
	            },
	            chargingSchedulerEnabled: {
	              type: 'select',
	              options: [{ display: this.$translate.instant('ENABLED'), id: true }, { display: this.$translate.instant('DISABLED'), id: false }]
	            },
	            setTarget: {
	              info: this.$translate.instant('CH.CONNECTORS.ACTIONS.TARGET_HINT'),
	              type: 'select',
	              options: [{ display: this.$translate.instant('ENABLED'), id: true }, { display: this.$translate.instant('DISABLED'), id: false }]
	            },
	            numberPhases: {
	              info: this.$translate.instant('CH.PROP.NUMBER_PHASES_HINT'),
	              type: 'number'
	            },
	            maxPower: {
	              info: this.$translate.instant('CH.PROP.MAX_POWER_HINT'),
	              help: this.$translate.instant('CH.PROP.MAX_POWER_HELP'),
	              type: 'number'
	            },
	            billable: {
	              type: 'select',
	              options: [{ display: this.$translate.instant('ENABLED'), id: true }, { display: this.$translate.instant('DISABLED'), id: false }]
	            }
	          },
	          error: {
	            409: this.$translate.instant('CH.EDIT.ERROR_409')
	          },
	          isKeyRestricted: function isKeyRestricted(key) {
	            var res = void 0;
	            switch (key) {
	              case 'chargingSchedulerEnabled':
	              case 'setTarget':
	              case 'numberPhases':
	              case 'maxPower':
	              case 'billable':
	                res = _this51.isProvider();
	            }
	            return res;
	          },
	          onlyIf: function onlyIf() {
	            return !_this51.isRoaming();
	          },
	          onSave: function onSave(changes) {
	            return _this51.editChargepoint(changes.changed);
	          }
	        },
	        right: {
	          keys: ['serialOCPP', 'name', 'connectors | getPhysicalReferenceFromConnectors', 'organizationName | chargepointOrganization:ctrl.item', 'groupId | chargepointGroup:ctrl.item', 'ownership | chargepointOwnership:ctrl.item', 'hash', 'status | chargepointOperationalStatus', 'ocppConnection.connected | chargepointConnected', 'connectors | chargepointStatus:ctrl.item', 'chargePointVendor', 'chargePointModel'],
	          headers: [this.$translate.instant('CH.SERIAL_OCPP'), this.$translate.instant('CH.NAME'), this.$translate.instant('PHYSICAL_REFERENCES'), this.$translate.instant('CH.ORGANIZATION'), this.$translate.instant('CH.GROUP'), this.$translate.instant('CH.OWNERSHIP'), this.$translate.instant('CH.HASH'), this.$translate.instant('CH.OPERATIONAL_STATUS'), this.$translate.instant('CH.CONNECTED'), this.$translate.instant('CH.STATUS'), this.$translate.instant('CH.VENDOR'), this.$translate.instant('CH.MODEL')]
	        },
	        connectorStatus: {
	          keys: ['status.status', 'status.errorCode', 'status.info', 'status.vendorId', 'status.timestamp | toDate'],
	          headers: [this.$translate.instant('CH.CONNECTORS.STATUS.STATUS_PROP'), this.$translate.instant('CH.CONNECTORS.STATUS.ERROR_CODE'), this.$translate.instant('CH.CONNECTORS.STATUS.INFO'), this.$translate.instant('CH.CONNECTORS.STATUS.VENDOR_ID'), this.$translate.instant('CH.CONNECTORS.STATUS.UPDATED')],
	          flexible: true
	        },
	        connectorZeroStatus: {
	          keys: ['status.status', 'status.errorCode', 'status.info'],
	          headers: [this.$translate.instant('CH.STATUS_OCPP.STATUS'), this.$translate.instant('CH.STATUS_OCPP.ERROR_CODE'), this.$translate.instant('CH.STATUS_OCPP.INFO')]
	          // flexible: true
	        },
	        connectorDetails: {
	          keys: ['type | connectorType:item', 'mode | connectorMode:item', 'power | connectorPower:item', 'current | connectorCurrent:item', 'voltage | connectorVoltage:item', 'evseId | evseId:item', 'physicalReference'],
	          headers: [this.$translate.instant('CH.CONNECTORS.DETAILS.TYPE'), this.$translate.instant('CH.CONNECTORS.DETAILS.MODE'), this.$translate.instant('CH.CONNECTORS.DETAILS.POWER'), this.$translate.instant('CH.CONNECTORS.DETAILS.CURRENT'), this.$translate.instant('CH.CONNECTORS.DETAILS.VOLTAGE'), this.$translate.instant('CH.CONNECTORS.DETAILS.EVSE_ID'), this.$translate.instant('PHYSICAL_REFERENCE')],
	          flexible: true
	        },
	        connectorSettings: {
	          keys: ['label'],
	          headers: [this.$translate.instant('CH.CONNECTORS.SETTINGS.NAME')],
	          editable: ['label'],
	          onSave: function onSave(changes) {
	            return _this51.editConnectorLabel(changes.item, changes.changed);
	          }
	        },
	        configuration: {
	          key: 'key',
	          value: 'value',
	          isKeyEditable: function isKeyEditable(key, property) {
	            return !property.readonly;
	          },
	          editable: true,
	          addItems: true,
	          // removeItems: true,
	          onSave: function onSave(changes) {
	            return _this51.setConfiguration(changes);
	          }
	        },
	        firmware: {
	          keys: ['firmwareVersion'],
	          headers: [this.$translate.instant('CH.APP.VERSION')]
	        }
	      };
	    }
	  }]);

	  return ChargepointController;
	}();

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChargePointsController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _async = __webpack_require__(176);

	var _async2 = _interopRequireDefault(_async);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var ChargePointsController = exports.ChargePointsController = function () {
	    ChargePointsController.$inject = ["$scope", "$rootScope", "$state", "$translate", "moment", "ChargePointsService", "GroupsService", "$stateParams", "App", "Auth", "Cache", "ChargepointHelper", "GroupsHelper"];
	    function ChargePointsController($scope, $rootScope, $state, $translate, moment, ChargePointsService, GroupsService, $stateParams, App, Auth, Cache, ChargepointHelper, GroupsHelper) {
	        'ngInject';

	        var _this = this;

	        _classCallCheck(this, ChargePointsController);

	        this.App = App;
	        this.Auth = Auth;
	        this.Cache = Cache;
	        this.$rootScope = $rootScope;
	        this.async = _async2.default;
	        this.ChargePointsService = ChargePointsService;
	        this.$state = $state;
	        this.$scope = $scope;
	        this.$translate = $translate;
	        this.moment = moment;
	        this.GroupsHelper = GroupsHelper;
	        this.GroupsService = GroupsService;
	        this.ChargepointHelper = ChargepointHelper;

	        this.organization = $stateParams.organization || null;
	        this.group = $stateParams.group || null;
	        this.unassigned = !this.organization && !this.group;
	        this.chargepoints = null;
	        this.live = true;

	        // Filters
	        this.filters = App.getTableFilters("chargepoint");
	        this.filterControls = {};

	        // Table settings
	        if (!this.organization) {
	            var actions = [];
	            if (this.$rootScope.role.role === 'admin') {
	                actions.push({
	                    tooltip: this.$translate.instant('CPS.ASSIGN_TO_ORGANIZATION'),
	                    icon: App.icon['organization'],
	                    onClick: function onClick(chargepoint) {
	                        return ChargepointHelper.askToAssignToOrganization($scope, [chargepoint.id]).then(function () {
	                            return $scope.reload();
	                        });
	                    }
	                });
	            }
	            this.table = _lodash2.default.defaults({}, { actions: actions }, App.getTable('chargepoints', { omit: ['groupName'] }));
	        }
	        if (this.organization) {
	            this.table = App.getTable('chargepoints', { omit: ['organizationName', 'hash'] });
	        }

	        this.$scope.$applyThrottled = _lodash2.default.throttle(function () {
	            $scope.$apply();
	        }, 1000, { 'leading': true, 'trailing': true });

	        this.$rootScope.$on('chargepointChanged', function (event, changed) {
	            var index = _lodash2.default.findIndex(_this.chargepoints, function (item) {
	                return item.id === changed.id;
	            }, 0);
	            if (index !== -1) {
	                _this.chargepoints[index] = _this.App.updateComplexDataObject(_this.chargepoints[index], changed);
	            }
	            if (_this.table.controls && _this.table.controls.pulse) {
	                _this.table.controls.pulse(changed.id);
	            }
	            _this.$scope.$applyThrottled();
	        });

	        this.$scope.$on('$destroy', function () {
	            //  TODO - Evaluate if unsubscription is required
	        });
	    }

	    _createClass(ChargePointsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.toggleAdvancedFilters = this.toggleAdvancedFilters.bind(this);
	            this.askToAddChargepoint = this.askToAddChargepoint.bind(this);
	            this.onChargepointClick = this.onChargepointClick.bind(this);
	            this.onReloadPagination = this.onReloadPagination.bind(this);
	            this.reload = this.reload.bind(this);
	            this._setBreadcrums();
	            this.reload();
	        }
	    }, {
	        key: 'isAdmin',
	        value: function isAdmin() {
	            return this.Auth.isAdmin();
	        }
	    }, {
	        key: 'toggleAdvancedFilters',
	        value: function toggleAdvancedFilters() {
	            if (this.filterControls['toggleAdvancedFilters']) this.filterControls['toggleAdvancedFilters']();
	        }
	    }, {
	        key: 'exportChargepoints',
	        value: function exportChargepoints() {
	            var _this2 = this;

	            this.ChargePointsService.exportChargepoints({ 'filters': this.filters, 'sorting': this.table.sorting, 'unassigned': this.unassigned, 'organization': this.organization, 'group': this.group }).then(function (chargepoints) {
	                return _this2.App.downloadCSV(chargepoints, _this2.$translate.instant('CPS.EXPORT_FILE_NAME') + '-' + _this2.moment().format('YYYY-MM-DD-HHmmss') + '.csv');
	            }).catch(function () {
	                return _this2.App.showNotification(_this2.$translate.instant('CPS.EXPORT_FAILED'), 'error');
	            });
	        }
	    }, {
	        key: 'askToAddChargepoint',
	        value: function askToAddChargepoint() {
	            var _this3 = this;

	            return this.ChargepointHelper.addChargePoint(this.$scope, {}, { organizationId: this.organization, groupId: this.group }).then(function () {
	                _this3.reload();
	                _this3.App.showNotification(_this3.$translate.instant('NEW_CP_ADDED_OK'));
	                _this3.App.closeModal();
	            }).catch(function (error) {
	                _this3.App.showNotification(error, 'error');
	                _this3.App.closeModal();
	            });
	        }
	    }, {
	        key: 'onChargepointClick',
	        value: function onChargepointClick(chargepoint) {
	            if (chargepoint.organizationId) this.$state.go('efimob.chargepoints.at.item', { 'id': chargepoint.id, 'organization': chargepoint.organizationId });else this.$state.go('efimob.chargepoints.unassigned.item', { 'id': chargepoint.id });
	        }
	    }, {
	        key: 'onReloadPagination',
	        value: function onReloadPagination(items) {
	            if (this.live && items && _lodash2.default.isArray(items) && items.length != 0) {
	                this._subscribeToChargepoints(items);
	            }
	        }
	    }, {
	        key: 'reload',
	        value: function reload() {
	            var _this4 = this;

	            var options = {
	                filters: this.filters,
	                pagination: this.table.pagination,
	                sorting: this.table.sorting,
	                organization: this.organization,
	                group: this.group
	            };
	            this.App.setLoading(true);
	            this.ChargePointsService.getChargepoints(options).then(function (chargepoints) {
	                _this4.chargepoints = chargepoints.docs;
	                _this4.table.pagination.currentPage = chargepoints.currentPage;
	                _this4.table.pagination.totalItems = chargepoints.totalItems;
	                _this4.App.setLoading(false);
	            }).catch(function () {
	                _this4.App.showNotification(_this4.$translate.instant('CPS.RELOAD_FAILED'), 'error');
	                _this4.App.setLoading(false);
	            });
	        }
	    }, {
	        key: '_setBreadcrums',
	        value: function _setBreadcrums() {
	            if (this.live) {
	                this.App.setBreadcrumsStatus([{ display: '', tooltip: this.$translate.instant('CPS.ON_AIR'), type: 'live' }]);
	            }
	            this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reload)]);
	            if (this.organization) {
	                this.App.setBreadcrumsCurrentScope({
	                    organizationId: this.organization,
	                    groupId: this.group,
	                    custom: this.$translate.instant('CPS.OF')
	                });
	            } else {
	                this.App.setBreadcrumsCurrentScope({
	                    organizationId: this.organization,
	                    groupId: this.group,
	                    custom: this.$translate.instant('CPS.NOT_ASSIGNED')
	                });
	            }
	        }
	    }, {
	        key: '_subscribeToChargepoints',
	        value: function _subscribeToChargepoints(chargepoints) {
	            var options = {
	                organization: this.organization
	            };
	            return this.ChargePointsService.subscribeToChargepoints(chargepoints.map(function (x) {
	                return x.id;
	            }), options);
	        }
	    }]);

	    return ChargePointsController;
	}();

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LeftController = exports.LeftController = function () {
	  LeftController.$inject = ["$scope", "$translate", "App", "ENV", "VERSION", "Utils"];
	  function LeftController($scope, $translate, App, ENV, VERSION, Utils) {
	    "ngInject";

	    _classCallCheck(this, LeftController);

	    this.utilsService = Utils;
	    this.App = App;
	    this.ENV = ENV;
	    this.apiVersion = null;
	    this.frontVersion = VERSION;
	  }

	  _createClass(LeftController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      this.getVersionApi();
	    }
	  }, {
	    key: "getVersionApi",
	    value: function getVersionApi() {
	      var _this = this;

	      this.value = this.utilsService.getVersion().then(function (value) {
	        _this.apiVersion = value.data.version;
	      });
	    }
	  }]);

	  return LeftController;
	}();

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TariffsController = exports.TariffsController = function () {
	  TariffsController.$inject = ["App", "$translate", "$state", "$scope", "$stateParams", "TariffsService", "TariffsHelperService", "GroupsService", "GroupsHelper"];
	  function TariffsController(App, $translate, $state, $scope, $stateParams, TariffsService, TariffsHelperService, GroupsService, GroupsHelper) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, TariffsController);

	    this.App = App;
	    this.$translate = $translate;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.organization = $stateParams.organization;
	    this.TariffsService = TariffsService;
	    this.TariffsHelperService = TariffsHelperService;
	    this.GroupsService = GroupsService;
	    this.GroupsHelper = GroupsHelper;

	    this.tariffs = [];
	    this.filterControls = {};
	    this.filters = App.getTableFilters('tariffs', { context: this, omit: ['includeInherited', 'groupId'] });
	    this.table = App.getTable('tariffs');
	    this.table.actions = [{
	      tooltip: $translate.instant('REMOVE'),
	      icon: 'times-hexagon',
	      custom: 'danger',
	      onClick: function onClick(tariff) {
	        var options = {
	          id: tariff.id,
	          notifications: true
	        };

	        return _this.TariffsHelperService.removeTariff(_this.$scope, tariff, options).then(function (options) {
	          if (options) {
	            _this.TariffsService.remove(options).then(function () {
	              return _this.reload();
	            });
	          }
	        });
	      }
	    }];
	  }

	  _createClass(TariffsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.App.setBreadcrumsTitle(this.$translate.instant('TARIFFS'));
	      this.App.setBreadcrumsCurrentScope({
	        organizationId: this.organization,
	        custom: this.organization,
	        title: this.$translate.instant('APP.BREADCRUMS.OF')
	      });
	      this.reload = this.reload.bind(this);
	      this.upsertTariff = this.upsertTariff.bind(this);
	      this.reload();
	    }
	  }, {
	    key: 'upsertTariff',
	    value: function upsertTariff(tariff) {
	      this.$state.go('efimob.tariffs.item', { id: tariff ? tariff.id : 'null' });
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      var _this2 = this;

	      var options = {
	        filters: this.filters,
	        pagination: this.table.pagination,
	        sorting: this.table.sorting,
	        organizationId: this.organization
	      };

	      this.App.setLoading(true);
	      this.TariffsService.getTariffs(options, true).then(function (data) {
	        _this2.tariffs = data.docs;
	        _this2.table.pagination.currentPage = data.currentPage;
	        _this2.table.pagination.totalItems = data.totalItems;
	        _this2.App.setLoading(false);
	      }).catch(function () {
	        _this2.tariffs = [];
	        _this2.App.setLoading(false);
	      });
	    }
	  }]);

	  return TariffsController;
	}();

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TariffController = undefined;

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var TariffController = exports.TariffController = function () {
	  TariffController.$inject = ["App", "$translate", "$scope", "$stateParams", "$state", "$rootScope", "$timeout", "TariffsService", "TariffsHelperService", "GroupsService", "Utils", "StaticListService", "ChargePointsService"];
	  function TariffController(App, $translate, $scope, $stateParams, $state, $rootScope, $timeout, TariffsService, TariffsHelperService, GroupsService, Utils, StaticListService, ChargePointsService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, TariffController);

	    this.App = App;
	    this.$translate = $translate;
	    this.$scope = $scope;
	    this.$stateParams = $stateParams;
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.TariffsService = TariffsService;
	    this.TariffsHelperService = TariffsHelperService;
	    this.GroupsService = GroupsService;
	    this.Utils = Utils;
	    this.StaticListService = StaticListService;
	    this.ChargePointsService = ChargePointsService;

	    this.organization = $stateParams.organization;
	    this.openedInLocation = $stateParams.location;
	    this.isCreate = $stateParams.id === 'null';
	    this.tariffId = $stateParams.id !== 'null' ? $stateParams.id : null;
	    this.tariff = null;
	    this.inEditMode = false;
	    this.AgreementService = null;
	    this.withGracePeriod = false;
	    this.$timeout = $timeout;
	    this.$stateParams = $stateParams;
	    this.validateAndSetMultiLanguageError = this.validateAndSetMultiLanguageError.bind(this);
	    this.countryCodes = this.StaticListService.getCountryCodes();
	    this.tabs = this.createTabs();

	    this.chargePoints = [];
	    this.defaultTariff = {
	      name: [],
	      description: [],
	      restrictions: [],
	      scope: 'EMSP',
	      type: 'REGULAR',
	      connectorTypes: ['TYPE2', 'TYPE2_CABLE', 'TYPE1_CABLE', 'CHADEMO', 'CCS', 'SCHUKO'],
	      currency: 'EUR',
	      minPower: undefined,
	      maxPower: undefined,
	      users: [],
	      url: null,
	      roamingAgreementId: null,
	      locations: this.openedInLocation ? [this.openedInLocation] : [],
	      gracePeriods: [],
	      startDateTime: undefined,
	      endDateTime: undefined,
	      preAuthorizationAmount: null
	    };

	    this.tabs.active = this.tabs.list[0];

	    this.properties = {
	      controls: {
	        onEdition: this.inEditMode
	      },
	      keys: ['name | extractText', 'description | extractText', 'scope', 'connectorTypes', 'minPower | wToKw', 'maxPower | wToKw', 'users', 'country | countryCodeToName', 'startDateTime | toDate', 'endDateTime | toDate'],
	      headers: [$translate.instant('NAME'), $translate.instant('DESCRIPTION'), $translate.instant('TYPE'), $translate.instant('CONNECTOR_TYPES'), $translate.instant('MIN_POWER'), $translate.instant('MAX_POWER'), $translate.instant('USERS'), $translate.instant('COUNTRY'), $translate.instant('START_DATE_TIME'), $translate.instant('END_DATE_TIME')],
	      isEditableFlagOnly: true,
	      editable: this.isCreate ? ['name', 'description', 'scope', 'connectorTypes', 'minPower', 'maxPower', 'users', 'url', 'country', 'startDateTime', 'endDateTime'] : ['name', 'description', 'connectorTypes', 'minPower', 'maxPower', 'users', 'url', 'country', 'startDateTime', 'endDateTime'],
	      validateAndSetMultiLanguageError: this.validateAndSetMultiLanguageError,
	      meta: {
	        name: {
	          type: 'multi-language-input',
	          required: true,
	          conflict: { message: 'REQUIRED_FIELD', data: null },
	          onChange: function onChange(data, config) {
	            _this.properties.validateAndSetMultiLanguageError(data, config, _this.$translate.instant('NAME'));
	            return data;
	          },
	          help: this.$translate.instant('RECHARGE_QUICK_HINT')
	        },
	        description: {
	          type: 'multi-language-input',
	          required: true,
	          conflict: { message: 'REQUIRED_FIELD', data: null },
	          onChange: function onChange(data, config) {
	            _this.properties.validateAndSetMultiLanguageError(data, config, _this.$translate.instant('DESCRIPTION'));
	            return data;
	          }
	        },
	        scope: {
	          type: 'select',
	          options: [{ display: $translate.instant('EMSP'), id: 'EMSP' }, { display: $translate.instant('CPO'), id: 'CPO' }, { display: $translate.instant('QR'), id: 'QR' }]
	        },
	        type: {
	          type: 'select',
	          options: [{ display: $translate.instant('REGULAR'), id: 'REGULAR' }, { display: $translate.instant('AD_HOC_PAYMENT'), id: 'AD_HOC_PAYMENT' }, { display: $translate.instant('PROFILE_CHEAP'), id: 'PROFILE_CHEAP' }, { display: $translate.instant('PROFILE_FAST'), id: 'PROFILE_FAST' }, { display: $translate.instant('PROFILE_GREEN'), id: 'PROFILE_GREEN' }]
	        },
	        connectorTypes: {
	          type: 'multi-select',
	          options: [{ id: 'TYPE2', display: 'TYPE2' }, { id: 'TYPE2_CABLE', display: 'TYPE2_CABLE' }, { id: 'TYPE1_CABLE', display: 'TYPE1_CABLE' }, { id: 'CHADEMO', display: 'CHADEMO' }, { id: 'CCS', display: 'CCS' }, { id: 'SCHUKO', display: 'SCHUKO' }],
	          help: this.$translate.instant('APPLICABLE_TARIFF_TO_SELECTED_CONNECTORS')
	        },
	        minPower: {
	          type: 'energy',
	          required: false,
	          step: 0,
	          min: 0,
	          max: 10000,
	          help: this.$translate.instant('MINIMUM_ENERGY_KW'),
	          conflict: { message: 'MIN_POWER_GREATER_THAN_MAX_POWER', data: null },
	          onChange: function onChange(data, config, input) {
	            var maxPower = input.find(function (obj) {
	              return obj.key === 'maxPower';
	            }).value;
	            var minPower = data.model.value;
	            var valid = maxPower == null || _lodash2.default.isNumber(maxPower) && maxPower > minPower;
	            config.conflict.data = valid ? null : true;
	            return data;
	          }
	        },
	        maxPower: {
	          type: 'energy-nullable',
	          required: false,
	          step: 0,
	          min: 0,
	          max: 10000,
	          help: this.$translate.instant('MAXIMUM_ENERGY_KW')
	        },
	        currency: {
	          type: 'select',
	          required: true,
	          options: [{ id: 'EUR', display: 'EUR (€)' }]
	        },
	        users: {
	          type: 'chips',
	          help: this.$translate.instant('ENTER_USER_ACCOUNT_OR_DOMAIN'),
	          conflict: { message: 'INVALID_WITH', data: null },
	          validate: function validate(item, config, data) {
	            var valid = _this.Utils.validateEmailOrDomain(item);
	            if (valid) {
	              config.conflict.data = item;
	              data.pop();
	            } else {
	              config.conflict.data = null;
	            }
	          }
	        },
	        country: {
	          type: 'select-component',
	          adaptFrom: function adaptFrom(data) {
	            return _this.countryCodes.find(function (item) {
	              return item.value === data;
	            }) || {
	              display: _this.$translate.instant('COUNTRY_CODE_ESP'),
	              value: 'ESP'
	            };
	          },
	          adaptTo: function adaptTo(data) {
	            return data ? data.value : null;
	          },
	          options: this.countryCodes
	        },
	        startDateTime: {
	          type: 'calendar',
	          adaptFrom: this.adaptDateTimeFrom,
	          adaptTo: this.adaptDateTimeTo,
	          onChange: function onChange(data, config, input) {
	            _this.validateTariffDateRange(input);
	            return data;
	          },
	          conflict: { message: 'CONFLICT_END_DATE_LESS_START_DATE', data: null }
	        },
	        endDateTime: {
	          type: 'calendar',
	          adaptFrom: this.adaptDateTimeFrom,
	          adaptTo: this.adaptDateTimeTo,
	          onChange: function onChange(data, config, input) {
	            _this.validateTariffDateRange(input);
	            return data;
	          },
	          conflict: { message: 'CONFLICT_END_DATE_LESS_START_DATE', data: null }
	        }
	      },
	      onSave: function onSave(changes) {
	        return new Promise(function (resolve) {
	          _lodash2.default.assign(_this.tariff, changes.changed);
	          resolve(changes);
	        });
	      }
	    };

	    this.tables = {
	      restrictions: App.getTable('restrictions'),
	      chargePoints: App.getTable('chargePointsAssignedToTariff')
	    };
	    this.tables.restrictions.actions = [{
	      tooltip: $translate.instant('EDIT'),
	      icon: 'edit',
	      onlyIf: function onlyIf() {
	        return _this.canEdit();
	      },
	      onClick: function onClick(restriction) {
	        return TariffsHelperService.editRestriction($scope, restriction, {
	          restrictions: _this.tariff.restrictions
	        });
	      }
	    }, {
	      tooltip: $translate.instant('REMOVE'),
	      icon: 'times-hexagon',
	      custom: 'danger',
	      onlyIf: function onlyIf() {
	        return _this.canEdit();
	      },
	      onClick: function onClick(restriction) {
	        return TariffsHelperService.removeRestriction($scope, restriction, {}).then(function (restriction) {
	          _this.tariff.restrictions = _this.tariff.restrictions.filter(function (r) {
	            if (restriction.id) {
	              return r.id !== restriction.id;
	            } else {
	              return !_lodash2.default.isEqual(r, restriction);
	            }
	          });
	        });
	      }
	    }];

	    this.locationTable = App.getTable('locations', { modify: { synchronous: true } });
	  }

	  _createClass(TariffController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;

	      this.$scope.$watch('ctrl.tabs.active', function () {
	        if (_this2.tabs.active) {
	          switch (_this2.tabs.active.id) {
	            case 'general':
	              break;
	            case 'chargePoint':
	              _this2.reloadChargePoints();
	              break;
	          }
	        }
	      });

	      this.editionMode = this.editionMode.bind(this);
	      this.addNewRestriction = this.addNewRestriction.bind(this);
	      this.removeTariff = this.removeTariff.bind(this);
	      this.saveTariff = this.saveTariff.bind(this);
	      this.canEdit = this.canEdit.bind(this);
	      this.reload = this.reload.bind(this);
	      this.onAgreementChanged = this.onAgreementChanged.bind(this);
	      this.onWithGracePeriodChanged = this.onWithGracePeriodChanged.bind(this);
	      this.reloadChargePoints = this.reloadChargePoints.bind(this);

	      this.reload();
	    }
	  }, {
	    key: 'createTabs',
	    value: function createTabs() {
	      var tabs = {
	        active: null,
	        list: [{
	          id: 'general',
	          display: this.$translate.instant('GENERAL'),
	          url: 'general'
	        }],
	        left: true
	      };
	      if (!this.isCreate) {
	        tabs.list.push({
	          id: 'chargePoint',
	          display: this.$translate.instant('CHARGE_POINTS'),
	          url: 'charge-point'
	        });
	      }
	      return tabs;
	    }
	  }, {
	    key: 'editionMode',
	    value: function editionMode() {
	      this.inEditMode = !this.inEditMode;
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit() {
	      return this.inEditMode || this.isCreate;
	    }
	  }, {
	    key: 'upsertLocation',
	    value: function upsertLocation() {
	      var _this3 = this;

	      this.TariffsHelperService.upsertLocation(this.$scope, this.tariff.locations, {
	        organizationId: this.organization
	      }).then(function (locations) {
	        if (locations) {
	          _this3.tariff.locations = locations;
	        }
	      });
	    }
	  }, {
	    key: 'addNewRestriction',
	    value: function addNewRestriction() {
	      var _this4 = this;

	      this.TariffsHelperService.createRestriction(this.$scope, { restrictions: this.tariff.restrictions }).then(function (restricction) {
	        _this4.tariff.restrictions.push(restricction);
	      });
	    }
	  }, {
	    key: 'reload',
	    value: function reload() {
	      var _this5 = this;

	      if (this.isCreate) {
	        this.tariff = _lodash2.default.cloneDeep(this.defaultTariff);
	      } else {
	        this.App.setLoading(true);
	        this.TariffsService.getTariff({ id: this.tariffId }).then(function (data) {
	          _this5.tariff = data;
	          _this5.withGracePeriod = _this5.tariff.gracePeriods && _this5.tariff.gracePeriods.length > 0;
	        }).catch(function () {
	          _this5.tariff = null;
	          _this5.App.setLoading(false);
	        });
	      }
	    }
	  }, {
	    key: 'onWithGracePeriodChanged',
	    value: function onWithGracePeriodChanged(option) {
	      this.withGracePeriod = option;
	    }
	  }, {
	    key: 'removeIdsFromTariff',
	    value: function removeIdsFromTariff(tariff) {
	      var result = _lodash2.default.cloneDeep(tariff);

	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = (result.restrictions || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var restriction = _step.value;

	          if ('id' in restriction) {
	            delete restriction.id;
	          }

	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;

	          try {
	            for (var _iterator2 = (restriction.priceComponents || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var component = _step2.value;

	              if ('id' in component) {
	                delete component.id;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }

	      return result;
	    }
	  }, {
	    key: 'saveTariff',
	    value: function saveTariff() {
	      var _this6 = this;

	      this.App.setLoading(true);

	      var options = {
	        notifications: false,
	        id: this.tariffId
	      };

	      var data = _lodash2.default.cloneDeep(this.tariff);
	      this._removeExtraFieldsFromTariffDto(data);
	      var payload = _lodash2.default.merge(data, {
	        organizationId: this.organization,
	        gracePeriods: this.withGracePeriod ? this.tariff.gracePeriods : []
	      });
	      delete payload.id;
	      delete payload.locations;
	      payload.locationIds = this.tariff.locations.map(function (item) {
	        return item.id;
	      });

	      var errorMessage = this.$translate.instant(this.isCreate ? 'ADD_TARIFF_FAILED' : 'UPDATE_TARIFF_FAILED');
	      options.notifications = true;
	      var action = this.isCreate ? this.TariffsService.createTariff(payload, options) : this.TariffsService.updateTariff(payload, options);
	      action.then(function () {
	        _this6.App.goBack();
	      }).catch(function (err) {
	        var message = (err.error ? _this6.getFirstValidationMessage(err.error) : null) || errorMessage;
	        _this6.App.showNotification(message, 'error');
	      }).finally(function () {
	        _this6.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'getFirstValidationMessage',
	    value: function getFirstValidationMessage(response) {
	      if (!response.errors || !_lodash2.default.isArray(response.errors) || response.errors.length === 0) {
	        return null;
	      }

	      var firstError = response.errors[0];
	      var parts = firstError.split('-');
	      if (parts.length < 2) {
	        return null;
	      }

	      var subParts = parts[1].split(':');
	      if (subParts.length < 2) {
	        return null;
	      }
	      return _lodash2.default.capitalize(subParts[1].trim());
	    }
	  }, {
	    key: 'removeTariff',
	    value: function removeTariff() {
	      var _this7 = this;

	      this.TariffsHelperService.removeTariff(this.$scope, this.tariff, { id: this.tariffId }).then(function (data) {
	        if (data) {
	          var options = {
	            id: data.id,
	            notifications: true
	          };
	          if (_this7.isCreate) {
	            _this7.App.goBack();
	          } else {
	            _this7.TariffsService.remove(options).then(function () {
	              return _this7.App.goBack();
	            });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'onAgreementChanged',
	    value: function onAgreementChanged(agreement) {
	      this.tariff.roamingAgreementId = agreement.id;
	    }
	  }, {
	    key: 'adaptDateTimeFrom',
	    value: function adaptDateTimeFrom(value) {
	      if (!value) {
	        return value;
	      }

	      var raw = angular.isString(value) ? value : value.toISOString();
	      var trimmed = raw.slice(0, 16);
	      var parsed = new Date(trimmed);

	      if (_lodash2.default.isNaN(parsed.getTime())) {
	        return value;
	      }

	      var offsetMillis = parsed.getTimezoneOffset() * 60 * 1000;
	      return new Date(parsed.getTime() - offsetMillis);
	    }
	  }, {
	    key: 'adaptDateTimeTo',
	    value: function adaptDateTimeTo(value) {
	      if (!value) {
	        return value;
	      }

	      var parsed = value instanceof Date ? value : new Date(value);
	      if (_lodash2.default.isNaN(parsed.getTime())) {
	        return value;
	      }

	      return parsed.toISOString();
	    }
	  }, {
	    key: 'getDateFromInput',
	    value: function getDateFromInput(input, key) {
	      if (!_lodash2.default.isArray(input)) {
	        return null;
	      }

	      var property = input.find(function (item) {
	        return item.key === key;
	      });
	      return property ? property.value : null;
	    }
	  }, {
	    key: 'validateTariffDateRange',
	    value: function validateTariffDateRange(input) {
	      if (!this.properties || !this.properties.meta) {
	        return;
	      }

	      var start = this.getDateFromInput(input, 'startDateTime');
	      var end = this.getDateFromInput(input, 'endDateTime');

	      var startDate = start ? new Date(start) : null;
	      var endDate = end ? new Date(end) : null;

	      var hasConflict = startDate && endDate && startDate.getTime() > endDate.getTime();
	      var conflictValue = hasConflict ? true : null;

	      if (this.properties.meta.startDateTime && this.properties.meta.startDateTime.conflict) {
	        this.properties.meta.startDateTime.conflict.data = conflictValue;
	      }

	      if (this.properties.meta.endDateTime && this.properties.meta.endDateTime.conflict) {
	        this.properties.meta.endDateTime.conflict.data = conflictValue;
	      }
	    }
	  }, {
	    key: 'validateAndSetMultiLanguageError',
	    value: function validateAndSetMultiLanguageError(data, config, name) {
	      this.$timeout(function () {
	        var texts = data.model.value || [];
	        var requiredLanguage = texts.find(function (text) {
	          return text.language === 'es';
	        });
	        var isValid = requiredLanguage && requiredLanguage.text.length > 1;
	        config.conflict.data = isValid ? null : name;
	      });
	    }
	  }, {
	    key: 'reloadChargePoints',
	    value: function reloadChargePoints() {
	      var _this8 = this;

	      var options = {
	        pagination: this.tables.chargePoints.pagination,
	        sorting: this.tables.chargePoints.sorting,
	        organizationId: this.organization,
	        params: {
	          tariffId: this.tariffId
	        }
	      };

	      this.App.setLoading(true);
	      return this.ChargePointsService.getChargePoints(options, true).then(function (data) {
	        _this8.chargePoints = data.docs;
	        _this8.tables.chargePoints.pagination.currentPage = data.currentPage;
	        _this8.tables.chargePoints.pagination.totalItems = data.totalItems;
	        _this8.App.setLoading(false);
	      }).catch(function () {
	        _this8.chargePoints = [];
	        _this8.App.setLoading(false);
	      });
	    }
	  }, {
	    key: '_removeExtraFieldsFromTariffDto',
	    value: function _removeExtraFieldsFromTariffDto(tariff) {
	      delete tariff.locationName;
	    }
	  }]);

	  return TariffController;
	}();

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var AgreementsController = exports.AgreementsController = function () {
	  AgreementsController.$inject = ["App", "Auth", "$translate", "$state", "$scope", "$stateParams", "AgreementService", "AgreementsHelperService", "OperationService", "OperationsHelperService"];
	  function AgreementsController(App, Auth, $translate, $state, $scope, $stateParams, AgreementService, AgreementsHelperService, OperationService, OperationsHelperService) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, AgreementsController);

	    this.App = App;
	    this.Auth = Auth;
	    this.$translate = $translate;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.organizationId = $stateParams.organization;
	    this.AgreementService = AgreementService;
	    this.AgreementsHelperService = AgreementsHelperService;
	    this.OperationService = OperationService;
	    this.OperationsHelperService = OperationsHelperService;

	    this.AGREEMENTS = 'Agreements';
	    this.OPERATIONS = 'Operations';
	    this.modes = [{ id: this.AGREEMENTS, label: this.$translate.instant('AGREEMENTS') }, { id: this.OPERATIONS, label: this.$translate.instant('OPERATIONS') }];
	    this.mode = this.modes[0].id;
	    this.agreements = [];
	    this.agreementsControls = {};
	    this.operations = [];
	    this.operationsControls = {};
	    this.filters = {
	      agreements: App.getTableFilters('agreements'),
	      operations: App.getTableFilters('operations')
	    };
	    this.tables = {
	      agreements: App.getTable('agreements'),
	      operations: App.getTable('operations')
	    };
	    this.tables.agreements.actionsColumnName = 'OPERATIONS';
	    this.tables.agreements.actions = [{
	      tooltip: $translate.instant('ASSIGN'),
	      icon: 'crosshairs',
	      onlyIf: function onlyIf(agreement) {
	        return agreement.role === 'emsp';
	      },
	      onClick: function onClick(agreement) {
	        var options = { organizationId: _this.organizationId, notifications: true };
	        _this.AgreementsHelperService.assignOperation(_this.$scope, agreement, options).then(function () {
	          return _this.reloadAgreements();
	        });
	      }
	    }];
	    this.tables.operations.actions = [{
	      tooltip: $translate.instant('INSPECT'),
	      icon: 'eye',
	      onlyIf: function onlyIf() {
	        return _this.Auth.isProvider();
	      },
	      onClick: function onClick(operation) {
	        var options = { organizationId: _this.organizationId, notifications: true };
	        _this.OperationsHelperService.seeOperation(_this.$scope, operation, options).then(function () {
	          return _this.reloadOperations();
	        });
	      }
	    }, {
	      tooltip: $translate.instant('EDIT'),
	      icon: 'edit',
	      onlyIf: function onlyIf() {
	        return _this.Auth.isProvider();
	      },
	      onClick: function onClick(operation) {
	        var options = { organizationId: _this.organizationId, notifications: true };
	        _this.OperationsHelperService.editOperation(_this.$scope, operation, options).then(function () {
	          return _this.reloadOperations();
	        });
	      }
	    }, {
	      tooltip: $translate.instant('REMOVE'),
	      icon: 'times-hexagon',
	      custom: 'danger',
	      onlyIf: function onlyIf() {
	        return _this.Auth.isProvider();
	      },
	      onClick: function onClick(operation) {
	        var options = { notifications: true };
	        _this.OperationsHelperService.removeOperation(_this.$scope, operation, options).then(function () {
	          return _this.reloadOperations();
	        });
	      }
	    }];
	  }

	  _createClass(AgreementsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.onChangeMode = this.onChangeMode.bind(this);
	      this.addAgreement = this.addAgreement.bind(this);
	      this.addOperation = this.addOperation.bind(this);
	      this.reloadAgreements = this.reloadAgreements.bind(this);
	      this.reloadOperations = this.reloadOperations.bind(this);

	      this.App.setBreadcrumsTitle(this.$translate.instant('INTEROPERABILITY'));
	      this.App.setBreadcrumsCurrentScope({
	        custom: this.organizationId,
	        title: this.$translate.instant('APP.BREADCRUMS.OF')
	      });
	      this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reloadAgreements)]);

	      this.reloadAgreements();
	    }
	  }, {
	    key: 'onChangeMode',
	    value: function onChangeMode(mode) {
	      if (mode === this.AGREEMENTS) {
	        this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reloadAgreements)]);
	        this.reloadAgreements();
	      } else {
	        this.App.setBreadcrumsRightActions([this.App.getActionReload(this.reloadOperations)]);
	        this.reloadOperations();
	      }
	    }
	  }, {
	    key: 'addAgreement',
	    value: function addAgreement() {}
	  }, {
	    key: 'reloadAgreements',
	    value: function reloadAgreements() {
	      var _this2 = this;

	      var options = {
	        filters: this.filters.agreements,
	        organizationId: this.organizationId
	      };

	      this.App.setLoading(true);
	      return this.AgreementService.getAgreements(options, false).then(function (data) {
	        _this2.agreements = data;
	        _this2.App.setLoading(false);
	      }).catch(function () {
	        _this2.agreements = [];
	        _this2.App.setLoading(false);
	      });
	    }
	  }, {
	    key: 'addOperation',
	    value: function addOperation() {
	      var _this3 = this;

	      var options = { organizationId: this.organizationId, notifications: true };
	      this.OperationsHelperService.createOperation(this.$scope, options).then(function () {
	        return _this3.reloadOperations();
	      });
	    }
	  }, {
	    key: 'reloadOperations',
	    value: function reloadOperations() {
	      var _this4 = this;

	      var options = {
	        filters: this.filters.operations,
	        pagination: this.tables.operations.pagination,
	        sorting: this.tables.operations.sorting,
	        organizationId: this.organizationId
	      };

	      this.App.setLoading(true);
	      return this.OperationService.getOperations(options, true).then(function (data) {
	        _this4.operations = data.docs;
	        _this4.tables.operations.pagination.currentPage = data.currentPage;
	        _this4.tables.operations.pagination.totalItems = data.totalItems;
	        _this4.App.setLoading(false);
	      }).catch(function () {
	        _this4.operations = [];
	        _this4.App.setLoading(false);
	      });
	    }
	  }]);

	  return AgreementsController;
	}();

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var LocationsController = exports.LocationsController = function () {
	  LocationsController.$inject = ["App", "$translate", "$state", "$scope", "$stateParams", "$window", "LocationsService", "GroupsHelper", "Auth"];
	  function LocationsController(App, $translate, $state, $scope, $stateParams, $window, LocationsService, GroupsHelper, Auth) {
	    'ngInject';

	    var _this = this;

	    _classCallCheck(this, LocationsController);

	    this.App = App;
	    this.$translate = $translate;
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$window = $window;
	    this.organizationId = $stateParams.organization;
	    this.group = {
	      id: angular.isDefined($stateParams.zona) ? null : $stateParams.group || null,
	      name: $stateParams.groupName || null
	    };
	    this.LocationsService = LocationsService;
	    this.GroupsHelper = GroupsHelper;
	    this.Auth = Auth;

	    this.locationTableData = {
	      organizationId: this.organizationId,
	      table: {
	        actions: [{
	          tooltip: this.$translate.instant('OPEN_IN_NEW_TAB'),
	          icon: 'arrow-square-up',
	          onClick: function onClick(location) {
	            return _this.$window.open('/zonas/' + _this.organizationId + '/' + location.id, '_blank');
	          }
	        }, {
	          tooltip: this.$translate.instant('GROUPS_ADD_GROUP_ADD_SUBGROUP'),
	          tooltipDisabled: this.$translate.instant('ADD_SUBGROUP_FAILED_GROUP_WITH_CHARGERS'),
	          icon: 'plus-square',
	          onlyIf: function onlyIf(location) {
	            return _this.Auth.isAdmin() && !_this.isRoamingPurpose(location) && !location.isAtomic;
	          },
	          onClick: function onClick(location) {
	            return _this.askToAddLocation(location);
	          }
	        }, {
	          tooltip: $translate.instant('REMOVE'),
	          icon: 'times-hexagon',
	          custom: 'danger',
	          onlyIf: function onlyIf(location) {
	            return _this.Auth.isAdmin() && !_this.isRoamingPurpose(location);
	          },
	          onClick: function onClick(location) {
	            return _this.askToRemoveLocation(location);
	          }
	        }]
	      }
	    };
	    if (this.group.id) {
	      this.locationTableData.initLocations = [{ id: this.group.id, name: this.group.name, organizationId: this.organizationId, purpose: 'General' }];
	    }
	    this.locationTableApi = {};
	    this.map = null;

	    this.unsubscribeBreadcrumbs = null;
	    this.canAddLocation = true;
	  }

	  _createClass(LocationsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;

	      this.map = this.App.getMap();

	      this.onClickLocation = this.onClickLocation.bind(this);
	      this.addLocation = this.addLocation.bind(this);

	      this.App.setBreadcrumsTitle(this.$translate.instant('LOCATIONS'));
	      this.App.setBreadcrumsCurrentScope({
	        organizationId: this.organizationId,
	        groupId: this.group.id,
	        custom: this.organizationId,
	        title: this.$translate.instant('APP.BREADCRUMS.OF')
	      });
	      this.$scope.$watch(function () {
	        return _this2.locationTableApi.reloadCurrent;
	      }, function (onFn) {
	        _this2.App.setBreadcrumsRightActions([_this2.App.getActionReload(onFn)]);
	      });

	      this.$scope.$watch(function () {
	        return _this2.locationTableApi.on;
	      }, function (onFn) {
	        if (!onFn) return;
	        _this2.unsubscribeBreadcrumbs = onFn('breadcrumbChanged', function (location) {
	          _this2.canAddLocation = !location || !location.roamingId;
	        });
	      });

	      this.$scope.$on('$destroy', function () {
	        if (_this2.unsubscribeBreadcrumbs) {
	          _this2.unsubscribeBreadcrumbs();
	        }
	      });
	    }
	  }, {
	    key: 'onClickLocation',
	    value: function onClickLocation(location) {
	      this.$state.go('efimob.groups.item', { id: location.id, organization: this.organizationId });
	    }
	  }, {
	    key: 'addLocation',
	    value: function addLocation() {
	      var breadcrumbs = this.locationTableApi.getBreadcrumbs();
	      var locations = this.locationTableApi.getLocations();
	      var last = breadcrumbs[breadcrumbs.length - 1];
	      if (last && last.location) {
	        this.askToAddLocation(last.location);
	      } else if (locations.length > 0) {
	        this.askToAddLocation(locations[0]);
	      }
	    }
	  }, {
	    key: 'isRoamingPurpose',
	    value: function isRoamingPurpose(location) {
	      var purpose = location.purpose || 'General';
	      return ['RoamingChargepointsParent', 'RoamingChargepointsGroup', 'RoamingChargepoints', 'RoamingOperatorGroup', 'RoamingCountryGroup', 'RoamingSegmentGroup'].includes(purpose);
	    }
	  }, {
	    key: 'askToAddLocation',
	    value: function askToAddLocation(location) {
	      var _this3 = this;

	      var options = {
	        parentGroup: location,
	        organization: this.organizationId
	      };
	      return this.GroupsHelper.askToAddSubGroup(this.$scope, options).then(function () {
	        return _this3.locationTableApi.reloadCurrent();
	      });
	    }
	  }, {
	    key: 'askToRemoveLocation',
	    value: function askToRemoveLocation(location) {
	      var _this4 = this;

	      var options = {
	        organization: this.organizationId,
	        notifications: true
	      };
	      return this.GroupsHelper.askToRemoveGroup(this.$scope, location, options).then(function () {
	        return _this4.locationTableApi.reloadCurrent();
	      });
	    }
	  }]);

	  return LocationsController;
	}();

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _lodash = __webpack_require__(5);

	var _lodash2 = _interopRequireDefault(_lodash);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = angular.module('tariffUtilsFilters', []).filter('redirectToTariff', ["$state", "$stateParams", function ($state, $stateParams) {
	  return function (tariff) {
	    if (!tariff || !tariff.id) {
	      return '';
	    }
	    var href = $state.href('efimob.tariffs.item', {
	      id: tariff.id,
	      tab: null,
	      organization: $stateParams.organization
	    });
	    return '<a href="' + href + '">' + tariff.name + '</a>';
	  };
	}]).filter('restrictionDescription', ["$translate", "$filter", function ($translate, $filter) {
	  return function (_description, restriction) {
	    var detailKeys = [];

	    if (restriction.isHoliday) {
	      detailKeys.push($translate.instant('IS_HOLIDAY'));
	    }

	    if (_lodash2.default.isNumber(restriction.minDuration)) {
	      detailKeys.push($translate.instant('TIME_STRETCH') + ': ' + $filter('sToMin')(restriction.minDuration) + ' - ' + (restriction.maxDuration ? $filter('sToMin')(restriction.maxDuration) : $translate.instant('NO_LIMIT')));
	    }

	    if (_lodash2.default.isNumber(restriction.minWh)) {
	      detailKeys.push($translate.instant('ENERGY_STRETCH') + ': ' + $filter('wToKw')(restriction.minWh) + ' - ' + (restriction.maxWh ? $filter('wToKw')(restriction.maxWh) : $translate.instant('NO_LIMIT')));
	    }

	    detailKeys.push($filter('getDaysOfWeek')(restriction.daysOfWeek));

	    var details = detailKeys.join('<br/>');
	    var tariffValidFromTo = restriction.startTime && restriction.endTime ? $translate.instant('TARIFF_VALID_FROM_TO', {
	      startHour: restriction.startTime,
	      endHour: restriction.endTime
	    }) + '.<br/>' : '';
	    return $translate.instant('TARIFF_RESTRICTION_DESCRIPTION', {
	      costs: $filter('priceComponentDescription')(restriction.priceComponents),
	      tariffValidFromTo: tariffValidFromTo,
	      details: details
	    });
	  };
	}]).filter('getDaysOfWeek', ["$translate", function ($translate) {
	  return function (daysOfWeek) {
	    var orderedDaysOfWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
	    return daysOfWeek.sort(function (a, b) {
	      return orderedDaysOfWeek.indexOf(a) - orderedDaysOfWeek.indexOf(b);
	    }).map(function (day) {
	      return $translate.instant(day);
	    }).join(', ');
	  };
	}]).filter('priceComponentDescription', ["$translate", "$filter", function ($translate, $filter) {
	  return function (priceComponents) {
	    var orderedTypes = ['FLAT', 'ENERGY', 'TIME', 'PARKING_TIME'];
	    return priceComponents ? _lodash2.default.cloneDeep(priceComponents).sort(function (a, b) {
	      return orderedTypes.indexOf(a.type ? a.type.id : '') - orderedTypes.indexOf(b.type ? b.type.id : '');
	    }).map(function (priceComponent) {
	      var type = priceComponent.type ? priceComponent.type.id || priceComponent.type : null;
	      var basePrice = priceComponent.price,
	          vat = priceComponent.vat;

	      var converters = {
	        TIME: 'pricePerHourToMinute'
	      };
	      var converter = converters[type];
	      var convertedPrice = converter ? $filter(converter)(basePrice) : basePrice;
	      var priceWithVat = $filter('calculatePriceWithVat')(convertedPrice, vat);

	      var data = $translate.instant(type) + ': ' + priceWithVat;
	      data += $filter('priceComponentUnit')(type) + ' ';
	      data += '(' + ([$translate.instant('NO_TAXES'), null].includes(priceComponent.vat) ? $translate.instant('NO_TAXES') : $translate.instant('TAXES') + ' ' + priceComponent.vat + '%') + ')';

	      return data;
	    }).join('<br/> ') : '';
	  };
	}]).filter('priceComponentUnit', function () {
	  var unitMap = {
	    FLAT: '€',
	    ENERGY: '€/kWh',
	    TIME: '€/min',
	    PARKING_TIME: '€/min'
	  };
	  return function (type) {
	    return unitMap[type] || '';
	  };
	}).filter('pricePerHourToMinute', function () {
	  return function (price) {
	    return price / 60;
	  };
	}).filter('calculatePriceWithVat', ["Utils", function (Utils) {
	  return function (price, vat) {
	    return Utils.calculatePriceWithVat(price, vat, 1e3) || 0;
	  };
	}]).filter('connectorTariffNameToLink', ["$state", function ($state) {
	  return function (name, tariff) {
	    var href = $state.href('efimob.tariffs.item', { id: tariff.id, organization: tariff.organizationId });
	    return '<a href="' + href + '">' + name + '</a>';
	  };
	}]).name;

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('chargePointUtilsFilters', []).filter('evsesToConnectorsList', function () {
	  return function (evses) {
	    if (!evses || !evses.length) {
	      return '';
	    }
	    return evses.flatMap(function (evse) {
	      return evse.connectors || [];
	    }).map(function (connector) {
	      return connector.connectorNum;
	    }).join(', ');
	  };
	}).name;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('agreementsUtilsFilters', []).filter('agreementId', function () {
	  return function (countryCode, agreement) {
	    return countryCode + '/' + agreement.partyId;
	  };
	}).filter('agreementName', function () {
	  return function (organizationName, agreement) {
	    return agreement.name ? agreement.name : organizationName + ' (' + agreement.partyId + ')';
	  };
	}).filter('agreementsToNameList', ["$filter", function ($filter) {
	  return function (agreements) {
	    return agreements && agreements.length > 0 ? agreements.map(function (item) {
	      return item.name ? item.name : $filter('agreementName')(item.organizationName, item);
	    }).join(', ') : '--';
	  };
	}]).filter('operationsToNameList', function () {
	  return function (operations) {
	    return operations && operations.length > 0 ? operations.map(function (item) {
	      return item.name;
	    }).join(', ') : '--';
	  };
	}).filter('agreementProtocol', function () {
	  return function (protocol, agreement) {
	    return protocol ? agreement.protocolVersion ? protocol + ' (' + agreement.protocolVersion + ')' : protocol : '-';
	  };
	}).name;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('locationUtilsFilters', []).filter('locationName', function () {
	  return function (name, location) {
	    var icon = '';
	    if (location.isAtomic) {
	      icon += ' <i class="fal fa-charging-station"></i>';
	    }
	    if (location.purpose !== 'General') {
	      icon += ' <i class="fal fa-registered"></i>';
	    }
	    return '<span class="center gap-5">' + name + icon + '</span>';
	  };
	}).filter('locationNameLink', ["$state", function ($state) {
	  return function (name, location) {
	    var href = $state.href('efimob.groups.item', { id: location.id, organization: location.organizationId });
	    var icon = '';
	    if ('isAtomic' in location && location.isAtomic) {
	      icon += ' <i class="fal fa-charging-station"></i>';
	    }
	    if ('purpose' in location && location.purpose !== 'General') {
	      icon += ' <i class="fal fa-registered"></i>';
	    }
	    return '<a class="center" href="' + href + '">' + name + icon + '</a>';
	  };
	}]).filter('locationsToList', function () {
	  return function (agreements) {
	    return agreements ? agreements.map(function (i) {
	      return i.name;
	    }).join(', ') : '';
	  };
	}).filter('locationCountry', ["StaticListService", function (StaticListService) {
	  return function (location) {
	    if (location && location.country) {
	      var countryCodes = StaticListService.getCountryCodes();
	      var data = countryCodes.find(function (code) {
	        return code.value === location.country;
	      });
	      return data ? data.display : '--';
	    }
	    return '--';
	  };
	}]).name;

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = angular.module('groupUtilsFilters', []).filter('marginLocationNameLink', ["$state", function ($state) {
	  return function (name, margin) {
	    var href = $state.href('efimob.groups.item', { id: margin.locationId, organization: margin.organizationId });
	    return '<a class="center" href="' + href + '">' + name + '</a>';
	  };
	}]).name;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uuidFactory;

	var _nodeUuid = __webpack_require__(289);

	var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function uuidFactory() {
	  return {
	    generate: function generate() {
	      return _nodeUuid2.default.v4();
	    }
	  };
	}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer) {//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php

	/*global window, require, define */
	(function(_window) {
	  'use strict';

	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;

	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch(e) {}
	    }

	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var  _rnds = new Array(16);
	      _mathRNG = _rng = function() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }

	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }

	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(290).randomBytes;
	        _nodeRNG = _rng = _rb && function() {return _rb(16);};
	        _rng();
	      } catch(e) {}
	    }
	  }

	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }

	  // Buffer class to use
	  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }

	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = (buf && offset) || 0, ii = 0;

	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	      if (ii < 16) { // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });

	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }

	    return buf;
	  }

	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0, bth = _byteToHex;
	    return  bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] + '-' +
	            bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]] +
	            bth[buf[i++]] + bth[buf[i++]];
	  }

	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html

	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();

	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [
	    _seedBytes[0] | 0x01,
	    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	  ];

	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

	  // Previous uuid creation time
	  var _lastMSecs = 0, _lastNSecs = 0;

	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];

	    options = options || {};

	    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

	    // Time since last uuid creation (in msecs)
	    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }

	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }

	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }

	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;

	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;

	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;

	    // `time_mid`
	    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;

	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;

	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;

	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;

	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }

	    return buf ? buf : unparse(b);
	  }

	  // **`v4()` - Generate random UUID**

	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;

	    if (typeof(options) === 'string') {
	      buf = (options === 'binary') ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};

	    var rnds = options.random || (options.rng || _rng)();

	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = (rnds[6] & 0x0f) | 0x40;
	    rnds[8] = (rnds[8] & 0x3f) | 0x80;

	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }

	    return buf || unparse(rnds);
	  }

	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;

	  if (('undefined' !== typeof module) && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {return uuid;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;

	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function() {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };

	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(291)

	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}

	exports.createHash = __webpack_require__(293)

	exports.createHmac = __webpack_require__(305)

	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}

	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}

	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}

	var p = __webpack_require__(306)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(308)(exports, module.exports);

	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(292)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(205).Buffer))

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(294)

	var md5 = toConstructor(__webpack_require__(302))
	var rmd160 = toConstructor(__webpack_require__(304))

	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}

	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}

	var Buffer = __webpack_require__(205).Buffer
	var Hash   = __webpack_require__(295)(Buffer)

	exports.sha1 = __webpack_require__(296)(Buffer, Hash)
	exports.sha256 = __webpack_require__(300)(Buffer, Hash)
	exports.sha512 = __webpack_require__(301)(Buffer, Hash)


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {

	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }

	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }

	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }

	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block

	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)

	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }

	      s += ch
	      f += ch

	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s

	    return this
	  }

	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8

	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80

	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)

	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }

	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)

	    var hash = this._update(this._block) || this._hash()

	    return enc ? hash.toString(enc) : hash
	  }

	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }

	  return Hash
	}


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */

	var inherits = __webpack_require__(297).inherits

	module.exports = function (Buffer, Hash) {

	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0

	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)

	  var POOL = []

	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()

	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)

	    this._h = null
	    this.init()
	  }

	  inherits(Sha1, Hash)

	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0

	    Hash.prototype.init.call(this)
	    return this
	  }

	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {

	    var a, b, c, d, e, _a, _b, _c, _d, _e

	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e

	    var w = this._w

	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)

	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )

	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }

	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }

	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }

	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }

	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }

	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }

	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }

	  return Sha1
	}


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }

	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};


	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }

	  if (process.noDeprecation === true) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	};


	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};


	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;


	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};

	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};


	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];

	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}


	function stylizeNoColor(str, styleType) {
	  return str;
	}


	function arrayToHash(array) {
	  var hash = {};

	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });

	  return hash;
	}


	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }

	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }

	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);

	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }

	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }

	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }

	  var base = '', array = false, braces = ['{', '}'];

	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }

	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }

	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }

	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }

	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }

	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }

	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }

	  ctx.seen.push(value);

	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }

	  ctx.seen.pop();

	  return reduceToSingleString(output, base, braces);
	}


	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}


	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}


	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}


	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }

	  return name + ': ' + str;
	}


	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);

	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }

	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}


	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = __webpack_require__(298);

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}


	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];

	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}


	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};


	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(299);

	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;

	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};

	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(179)))

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */

	var inherits = __webpack_require__(297).inherits

	module.exports = function (Buffer, Hash) {

	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]

	  var W = new Array(64)

	  function Sha256() {
	    this.init()

	    this._w = W //new Array(64)

	    Hash.call(this, 16*4, 14*4)
	  }

	  inherits(Sha256, Hash)

	  Sha256.prototype.init = function () {

	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0

	    this._len = this._s = 0

	    return this
	  }

	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }

	  function R (X, n) {
	    return (X >>> n);
	  }

	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }

	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }

	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }

	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }

	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }

	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }

	  Sha256.prototype._update = function(M) {

	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2

	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0

	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]

	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w

	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }

	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0

	  };

	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)

	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)

	    return H
	  }

	  return Sha256

	}


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(297).inherits

	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]

	  var W = new Array(160)

	  function Sha512() {
	    this.init()
	    this._w = W

	    Hash.call(this, 128, 112)
	  }

	  inherits(Sha512, Hash)

	  Sha512.prototype.init = function () {

	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0

	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0

	    this._len = this._s = 0

	    return this
	  }

	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }

	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }

	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }

	  Sha512.prototype._update = function(M) {

	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl

	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0

	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0

	    for (var i = 0; i < 80; i++) {
	      var j = i * 2

	      var Wi, Wil

	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)

	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)

	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)

	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]

	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]

	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)

	        W[j] = Wi
	        W[j + 1] = Wil
	      }

	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)

	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)

	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]

	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)

	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)

	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)

	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }

	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0

	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }

	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)

	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }

	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)

	    return H
	  }

	  return Sha512

	}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */

	var helpers = __webpack_require__(303);

	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;

	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;

	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;

	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);

	}

	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}

	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}

	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}

	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;

	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }

	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}

	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}

	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}

	module.exports = { hash: hash };

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160



	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];

	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];

	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};

	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};

	var processBlock = function (H, M, offset) {

	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];

	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }

	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;

	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;

	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};

	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}

	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}

	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}

	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}

	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}

	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}

	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];

	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');

	  var m = bytesToWords(message);

	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;

	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );

	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }

	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];

	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }

	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}



	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(293)

	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)

	module.exports = Hmac

	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg

	  var blocksize = (alg === 'sha512') ? 128 : 64

	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key

	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }

	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)

	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }

	  this._hash = createHash(alg).update(ipad)
	}

	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}

	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}


	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(307)

	module.exports = function (crypto, exports) {
	  exports = exports || {}

	  var exported = pbkdf2Export(crypto)

	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync

	  return exports
	}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }

	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')

	    setTimeout(function() {
	      var result

	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }

	      callback(undefined, result)
	    })
	  }

	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')

	    if (iterations < 0)
	      throw new TypeError('Bad iterations')

	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')

	    if (keylen < 0)
	      throw new TypeError('Bad key length')

	    digest = digest || 'sha1'

	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)

	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)

	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)

	      var U = crypto.createHmac(digest, password).update(block1).digest()

	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen

	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }

	      U.copy(T, 0, 0, hLen)

	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()

	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }

	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }

	    return DK
	  }

	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(309)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(344)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(335);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};



/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(310);
	var Transform = __webpack_require__(311);
	var inherits = __webpack_require__(314);
	var modes = __webpack_require__(335);
	var ebtk = __webpack_require__(336);
	var StreamCipher = __webpack_require__(337);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};


	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};

	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);

	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(338),
	  CBC: __webpack_require__(339),
	  CFB: __webpack_require__(341),
	  OFB: __webpack_require__(342),
	  CTR: __webpack_require__(343)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}

	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}

	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};

	var G = new Global();


	AES.blockSize = 4 * 4;

	AES.prototype.blockSize = AES.blockSize;

	AES.keySize = 256 / 8;

	AES.prototype.keySize = AES.keySize;

	AES.ivSize = AES.blockSize;

	AES.prototype.ivSize = AES.ivSize;

	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}

	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};

	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};

	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};

	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};

	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;

	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];

	};




	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(312).Transform;
	var inherits = __webpack_require__(314);

	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	module.exports = Stream;

	var EE = __webpack_require__(313).EventEmitter;
	var inherits = __webpack_require__(314);

	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(315);
	Stream.Writable = __webpack_require__(331);
	Stream.Duplex = __webpack_require__(332);
	Stream.Transform = __webpack_require__(333);
	Stream.PassThrough = __webpack_require__(334);

	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;



	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.

	function Stream() {
	  EE.call(this);
	}

	Stream.prototype.pipe = function(dest, options) {
	  var source = this;

	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }

	  source.on('data', ondata);

	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }

	  dest.on('drain', ondrain);

	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }

	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    dest.end();
	  }


	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    if (typeof dest.destroy === 'function') dest.destroy();
	  }

	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }

	  source.on('error', onerror);
	  dest.on('error', onerror);

	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);

	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);

	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);

	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);

	    dest.removeListener('close', cleanup);
	  }

	  source.on('end', cleanup);
	  source.on('close', cleanup);

	  dest.on('close', cleanup);

	  dest.emit('pipe', source);

	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;

	  if (!this._events)
	    this._events = {};

	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }

	  handler = this._events[type];

	  if (isUndefined(handler))
	    return false;

	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }

	  return true;
	};

	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events)
	    this._events = {};

	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);

	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];

	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }

	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }

	  return this;
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  var fired = false;

	  function g() {
	    this.removeListener(type, g);

	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }

	  g.listener = listener;
	  this.on(type, g);

	  return this;
	};

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events || !this._events[type])
	    return this;

	  list = this._events[type];
	  length = list.length;
	  position = -1;

	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);

	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }

	    if (position < 0)
	      return this;

	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }

	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }

	  return this;
	};

	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;

	  if (!this._events)
	    return this;

	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }

	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }

	  listeners = this._events[type];

	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];

	  return this;
	};

	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};

	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];

	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};

	function isFunction(arg) {
	  return typeof arg === 'function';
	}

	function isNumber(arg) {
	  return typeof arg === 'number';
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 314 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(316);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(326);
	exports.Duplex = __webpack_require__(325);
	exports.Transform = __webpack_require__(329);
	exports.PassThrough = __webpack_require__(330);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(317);
	/*</replacement>*/

	module.exports = Readable;

	/*<replacement>*/
	var isArray = __webpack_require__(208);
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Readable.ReadableState = ReadableState;

	/*<replacement>*/
	var EE = __webpack_require__(313).EventEmitter;

	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = __webpack_require__(318);
	/*</replacement>*/

	/*<replacement>*/

	var Buffer = __webpack_require__(319).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*</replacement>*/

	/*<replacement>*/
	var util = __webpack_require__(320);
	util.inherits = __webpack_require__(314);
	/*</replacement>*/

	/*<replacement>*/
	var debugUtil = __webpack_require__(321);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/

	var BufferList = __webpack_require__(322);
	var destroyImpl = __webpack_require__(324);
	var StringDecoder;

	util.inherits(Readable, Stream);

	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}

	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(325);

	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;

	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;

	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;

	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;

	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;

	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;

	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(328).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}

	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(325);

	  if (!(this instanceof Readable)) return new Readable(options);

	  this._readableState = new ReadableState(options, this);

	  // legacy
	  this.readable = true;

	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }

	  Stream.call(this);
	}

	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});

	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};

	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;

	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }

	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};

	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};

	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }

	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }

	  return needMoreData(state);
	}

	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}

	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}

	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}

	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};

	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(328).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};

	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}

	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}

	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;

	  if (n !== 0) state.emittedReadable = false;

	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }

	  n = howMuchToRead(n, state);

	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }

	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.

	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);

	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }

	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }

	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;

	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }

	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;

	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }

	  if (ret !== null) this.emit('data', ret);

	  return ret;
	};

	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;

	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}

	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}

	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}

	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}

	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}

	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};

	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;

	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }

	  function onend() {
	    debug('onend');
	    dest.end();
	  }

	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);

	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);

	    cleanedUp = true;

	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }

	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }

	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }

	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);

	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);

	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }

	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);

	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }

	  return dest;
	};

	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}

	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };

	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;

	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;

	    if (!dest) dest = state.pipes;

	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }

	  // slow case. multiple pipe destinations.

	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;

	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }

	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;

	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];

	  dest.emit('unpipe', this, unpipeInfo);

	  return this;
	};

	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);

	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }

	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;

	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}

	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};

	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}

	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }

	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}

	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};

	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}

	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;

	  var state = this._readableState;
	  var paused = false;

	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }

	    _this.push(null);
	  });

	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);

	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });

	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }

	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }

	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };

	  return this;
	};

	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});

	// exposed for testing purposes only.
	Readable._fromList = fromList;

	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;

	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }

	  return ret;
	}

	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}

	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	function endReadable(stream) {
	  var state = stream._readableState;

	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}

	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}

	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(179)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';

	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}

	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}


	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(313).EventEmitter;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(205)
	var Buffer = buffer.Buffer

	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}

	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}

	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)

	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}

	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}

	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}

	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.

	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = Buffer.isBuffer;

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Buffer = __webpack_require__(319).Buffer;
	var util = __webpack_require__(323);

	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}

	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);

	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }

	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };

	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };

	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };

	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };

	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };

	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };

	  return BufferList;
	}();

	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(317);
	/*</replacement>*/

	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;

	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;

	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }

	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks

	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }

	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }

	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });

	  return this;
	}

	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }

	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}

	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}

	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(317);
	/*</replacement>*/

	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/

	module.exports = Duplex;

	/*<replacement>*/
	var util = __webpack_require__(320);
	util.inherits = __webpack_require__(314);
	/*</replacement>*/

	var Readable = __webpack_require__(316);
	var Writable = __webpack_require__(326);

	util.inherits(Duplex, Readable);

	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}

	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);

	  Readable.call(this, options);
	  Writable.call(this, options);

	  if (options && options.readable === false) this.readable = false;

	  if (options && options.writable === false) this.writable = false;

	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

	  this.once('end', onend);
	}

	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});

	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;

	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}

	function onEndNT(self) {
	  self.end();
	}

	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});

	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();

	  pna.nextTick(cb, err);
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.

	'use strict';

	/*<replacement>*/

	var pna = __webpack_require__(317);
	/*</replacement>*/

	module.exports = Writable;

	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}

	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;

	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */

	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Writable.WritableState = WritableState;

	/*<replacement>*/
	var util = __webpack_require__(320);
	util.inherits = __webpack_require__(314);
	/*</replacement>*/

	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(327)
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = __webpack_require__(318);
	/*</replacement>*/

	/*<replacement>*/

	var Buffer = __webpack_require__(319).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}

	/*</replacement>*/

	var destroyImpl = __webpack_require__(324);

	util.inherits(Writable, Stream);

	function nop() {}

	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(325);

	  options = options || {};

	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;

	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;

	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // if _final has been called
	  this.finalCalled = false;

	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;

	  // a flag to see when we're in the middle of a write.
	  this.writing = false;

	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;

	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };

	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;

	  // the amount that is being written when _write is called.
	  this.writelen = 0;

	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;

	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;

	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;

	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;

	  // count buffered requests
	  this.bufferedRequestCount = 0;

	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}

	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};

	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();

	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;

	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}

	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(325);

	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.

	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }

	  this._writableState = new WritableState(options, this);

	  // legacy.
	  this.writable = true;

	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;

	    if (typeof options.writev === 'function') this._writev = options.writev;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;

	    if (typeof options.final === 'function') this._final = options.final;
	  }

	  Stream.call(this);
	}

	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};

	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}

	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;

	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}

	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);

	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }

	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

	  if (typeof cb !== 'function') cb = nop;

	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }

	  return ret;
	};

	Writable.prototype.cork = function () {
	  var state = this._writableState;

	  state.corked++;
	};

	Writable.prototype.uncork = function () {
	  var state = this._writableState;

	  if (state.corked) {
	    state.corked--;

	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};

	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};

	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}

	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});

	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;

	  state.length += len;

	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;

	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }

	  return ret;
	}

	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}

	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;

	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}

	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}

	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;

	  onwriteStateUpdate(state);

	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);

	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }

	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}

	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}

	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}

	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;

	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;

	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;

	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;

	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }

	    if (entry === null) state.lastBufferedRequest = null;
	  }

	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}

	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};

	Writable.prototype._writev = null;

	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;

	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }

	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};

	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}

	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}

	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}

	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}

	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});

	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(179), __webpack_require__(177).setImmediate, (function() { return this; }())))

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */

	module.exports = deprecate;

	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */

	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	}

	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */

	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	/*<replacement>*/

	var Buffer = __webpack_require__(319).Buffer;
	/*</replacement>*/

	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};

	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};

	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}

	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}

	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};

	StringDecoder.prototype.end = utf8End;

	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;

	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};

	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}

	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}

	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}

	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}

	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}

	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}

	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}

	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}

	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}

	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}

	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}

	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.

	'use strict';

	module.exports = Transform;

	var Duplex = __webpack_require__(325);

	/*<replacement>*/
	var util = __webpack_require__(320);
	util.inherits = __webpack_require__(314);
	/*</replacement>*/

	util.inherits(Transform, Duplex);

	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;

	  var cb = ts.writecb;

	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }

	  ts.writechunk = null;
	  ts.writecb = null;

	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);

	  cb(er);

	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}

	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);

	  Duplex.call(this, options);

	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };

	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;

	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;

	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;

	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }

	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}

	function prefinish() {
	  var _this = this;

	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}

	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};

	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};

	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};

	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;

	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};

	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;

	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};

	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);

	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);

	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

	  return stream.push(null);
	}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.

	'use strict';

	module.exports = PassThrough;

	var Transform = __webpack_require__(329);

	/*<replacement>*/
	var util = __webpack_require__(320);
	util.inherits = __webpack_require__(314);
	/*</replacement>*/

	util.inherits(PassThrough, Transform);

	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);

	  Transform.call(this, options);
	}

	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(326);


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(325);


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(315).Transform


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(315).PassThrough


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(310);
	var Transform = __webpack_require__(311);
	var inherits = __webpack_require__(314);

	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(340);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(340);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(340);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(340);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(310);
	var Transform = __webpack_require__(311);
	var inherits = __webpack_require__(314);
	var modes = __webpack_require__(335);
	var StreamCipher = __webpack_require__(337);
	var ebtk = __webpack_require__(336);

	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }

	  this.push(unpad(this._mode.decrypt(this, chunk)));

	  next();
	};

	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};

	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}

	var modelist = {
	  ECB: __webpack_require__(338),
	  CBC: __webpack_require__(339),
	  CFB: __webpack_require__(341),
	  OFB: __webpack_require__(342),
	  CTR: __webpack_require__(343)
	};

	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }

	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205).Buffer))

/***/ })
/******/ ]);
angular.module("efimob").run(["$templateCache", function($templateCache) {$templateCache.put("app/directives/agreement-input-component/agreement-input-component.html","<md-select id=agreement-input-component-{{::$id}} ng-disabled=ctrl.disabled ng-model=ctrl.item md-on-close=ctrl._clearSearchTerm({{::$id}}) md-on-open=ctrl._focusSearchInput({{::$id}}) class=\"form-control deactivate\" ng-change=ctrl._onChange() data-md-container-class=selectHeader> <md-select-header ng-show=ctrl.search class=select-header> <input id=input-{{::$id}} type=search ng-model=ctrl.searchTerm ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{\'SEARCH_AGREEMENTS\' | translate}}\" class=\"header-searchbox md-text\"> </md-select-header> <md-option ng-value=item ng-repeat=\"item in ctrl.items | filter:ctrl.searchTerm\"> {{ctrl._getDisplay(item)}} </md-option> </md-select>");
$templateCache.put("app/directives/dual-list-component/dual-list-component.html","<div class=dual-list-container> <div> <h5 class=\"min-height-45 max-width-320\" ng-show=ctrl.availableState.title>{{ctrl.availableState.title}}</h5> <div class=list-box infinite-scroll=ctrl.requestMoreAvailableItems() infinite-scroll-disabled=\"!ctrl.availableState.enabled || !ctrl.availableState.hasMore\" infinite-scroll-distance=1> <ul> <li ng-repeat=\"item in ctrl.availableState.list\" ng-click=ctrl.selectAvailable(item) ng-class=\"{selected: ctrl.isSelected(item, \'available\')}\" ng-bind-html=ctrl.display(item)> </li> </ul> </div> <p class=help ng-show=ctrl.availableState.help ng-bind-html=ctrl.availableState.help></p> </div> <div class=list-buttons> <button class=\"btn btn-light active\" ng-click=ctrl.moveSelectedToRight()> &gt; </button> <button class=\"btn btn-light active\" ng-click=ctrl.moveSelectedToLeft()> &lt; </button> </div> <div> <h5 class=\"min-height-45 max-width-320\" ng-show=ctrl.assignedState.title>{{ctrl.assignedState.title}}</h5> <div class=list-box infinite-scroll=ctrl.requestMoreAssignedItems() infinite-scroll-disabled=\"!ctrl.assignedState.enabled || !ctrl.assignedState.hasMore\" infinite-scroll-distance=1> <ul> <li ng-repeat=\"item in ctrl.assignedState.list\" ng-click=ctrl.selectAssigned(item) ng-class=\"{selected: ctrl.isSelected(item, \'assigned\')}\" ng-bind-html=ctrl.display(item)></li> </ul> </div> <p class=help ng-show=ctrl.assignedState.help ng-bind-html=ctrl.assignedState.help></p> </div> </div>");
$templateCache.put("app/directives/locations-table-component/locations-table-component.html","<div class=\"filters-container top\" ng-show=\"ctrl.filters.length>0\"> <widget-filters params=ctrl.filters on-reload=ctrl.onChangedFilters controls=ctrl.filterControls> </widget-filters> </div> <widget-table params=ctrl.table items=ctrl.locations on-item-click=ctrl._onClickLocation on-reload=ctrl.reloadTable enabled-breadcrumbs=ctrl.enabledBreadcrumbs breadcrumbs=ctrl.breadcrumbs on-click-breadcrumb=ctrl.onClickBreadcrumb> </widget-table>");
$templateCache.put("app/directives/multi-language-input-component/multi-language-input-component.html","<div class=multi-language-input-component> <div> <select class=form-control ng-model=ctrl.lang.option ng-options=\"option.id as option.display for option in ctrl.lang.options\" ng-change=ctrl.onLanguageChange()> </select> <input name=description ng-model=ctrl.currentText ng-change=ctrl.onTextChange() ng-model-options=\"{ debounce: 300 }\" type=text class=\"form-control margin-top-5\" placeholder={{ctrl.placeholder}}> </div> <div class=preview ng-if=ctrl.showPreview> <h5>{{\'COMMON.PREVIEW\' | translate}}:</h5> <pre>{{ctrl.localizedTexts | json}}</pre> </div> </div>");
$templateCache.put("app/directives/multi-select-component/multi-select-component.html","<md-select id=multi-select-component-{{::$id}} ng-model=ctrl.auxItem md-on-close=ctrl._clearSearchTerm({{::$id}}) md-on-open=ctrl._focusSearchInput({{::$id}}) class=\"form-control deactivate multi-select\" ng-change=ctrl._syncSelectedItems() data-md-container-class=selectHeader multiple=multiple> <md-select-header ng-show=ctrl.search class=select-header> <input id=input-{{::$id}} type=search ng-model=ctrl.searchTerm ng-change=ctrl._onSearchAux() ng-model-options=\"{ debounce: 500 }\" placeholder={{ctrl.placeholder}} class=\"header-searchbox md-text\" aria-label=\"Search options\"> </md-select-header> <md-option ng-value=item ng-repeat=\"item in ctrl.auxItems | filter:ctrl.searchTerm\"> {{ctrl._getDisplay(item)}} </md-option> </md-select>");
$templateCache.put("app/directives/rich-text/rich-text-component.html","<textarea ui-tinymce=ctrl.tinymceOptions ng-model=ctrl.item ng-change=ctrl._onChange()></textarea>");
$templateCache.put("app/directives/select/select-component.html","<md-select id=select-{{::$id}} ng-model=ctrl.item md-on-close=ctrl._clearSearchTerm({{::$id}}) md-on-open=ctrl._focusSearchInput({{::$id}}) class=\"form-control deactivate\" ng-change=ctrl._onChange() data-md-container-class=selectHeader> <md-select-header ng-show=ctrl.search class=select-header> <input id=input-{{::$id}} type=search ng-model=ctrl.searchTerm ng-change=ctrl._onSearchAux() ng-model-options=\"{ debounce: 500 }\" placeholder=Search.. class=\"header-searchbox md-text\"> </md-select-header> <md-option ng-value=item ng-repeat=\"item in ctrl.items | filter:ctrl.searchTerm\"> {{ctrl._getDisplay(item)}} </md-option> </md-select>");
$templateCache.put("app/directives/select-with-input/select-with-input-component.html","<div> <div ng-repeat=\"item in ctrl.list\" class=\"inline-flex width-webkit margin-right-40 margin-top-5\"> <select name=select ng-model=item[ctrl.firstItem] class=form-control ng-options=\"option.id as option.display for option in ctrl.listOptions\" ng-change=ctrl.selectChanged(ctrl.list)> </select> <i class=\"fa fa-arrow-alt-right ml-s mr-s\"></i> <input min={{ctrl.getMin()}} max={{ctrl.getMax()}} name=input ng-model=item[ctrl.secondItem] ng-change=ctrl.inputChanged(item) type=number ng-pattern=/^\\d+$/ class=form-control> <i ng-show=\"ctrl.secondItemUnit == \'%\' || ctrl.secondItemUnit == \'percentage\'\" class=\"fa fa-percent ml-s mr-s\"></i> <span ng-show=\"ctrl.secondItemUnit && ctrl.secondItemUnit !== \'%\' && ctrl.secondItemUnit !== \'percentage\'\" class=\"ml-s mr-s font-weight-900\"> {{ ctrl.secondItemUnit }} </span> <a class=remover ng-click=ctrl.removeItem($index)> <i class=\"fa fa-times ml-s\"></i> </a> </div> <div class=margin-top-5> <a ng-if=\"ctrl.list.length < ctrl.listOptions.length\" ng-click=ctrl.addItem()> <i class=\"fal fa-plus mr\"></i> {{\'COMMON.ADD\' | translate}} </a> </div> </div>");
$templateCache.put("app/directives/select-with-time-input/select-with-time-input-component.html","<div> <div ng-repeat=\"item in ctrl.list\" class=\"inline-flex width-webkit margin-right-40 margin-top-5\"> <select name=select ng-model=item[ctrl.firstItem] class=form-control ng-options=\"option.id as option.display for option in ctrl.listOptions\" ng-change=\"ctrl.selectChanged(item, $index)\"> </select> <i class=\"fa fa-arrow-alt-right ml-s mr-s\"></i> <input name=inputStart ng-model=item[ctrl.secondItem] ng-change=\"ctrl.inputChanged(item, $index)\" type=time class=form-control> <i class=\"fa fa-minus ml-s mr-s\"></i> <input name=inputEnd ng-model=item[ctrl.thirdItem] ng-change=\"ctrl.inputChanged(item, $index)\" type=time class=form-control required> <a class=remover ng-click=ctrl.removeItem($index)> <i class=\"fa fa-times ml-s\"></i> </a> </div> <div class=margin-top-5> <a ng-if=\"ctrl.list.length < ctrl.listOptions.length\" ng-click=ctrl.addItem()> <i class=\"fal fa-plus mr\"></i> {{\'COMMON.ADD\' | translate}} </a> </div> </div>");
$templateCache.put("app/directives/upload-file/upload-file.html","<div class=\"upload-file-container full-width\"> <div class=upload-drop-zone ng-class=\"{\n             \'drag-over\': ctrl.isDragOver,\n             \'has-file\': ctrl.file,\n             \'disabled\': ctrl.disabled\n         }\" ng-disabled=ctrl.disabled> <input type=file style=\"display: none\" on-change=ctrl.onFileInputChange($event) accept=\"{{ctrl.allowedExtensions.join(\', \')}}\" ng-disabled=ctrl.disabled> <div class=\"upload-content full-width\" ng-if=!ctrl.file> <div class=upload-icon> <i class=\"fal fa-file\"></i> </div> <div class=upload-text> <h4>{{\'UPLOAD_FILE_DRAG_DROP_TITLE\' | translate}}</h4> </div> <div class=\"upload-info margin-top-20\"> <small class=text-muted> {{\'UPLOAD_FILE_ACCEPTED_FORMATS\' | translate}}: {{ctrl.allowedExtensions.join(\', \')}}<br> {{\'UPLOAD_FILE_MAX_SIZE\' | translate}}: {{ctrl._formatFileSize(ctrl.maxFileSize)}} </small> </div> </div> <div class=file-selected ng-if=ctrl.file> <div class=file-icon> <i class=\"fal fa-file\"></i> </div> <div class=file-info> <h5 class=file-name>{{ctrl.fileName}}</h5> <p class=file-size>{{ctrl._formatFileSize(ctrl.file.size)}}</p> </div> <div class=\"file-actions margin-left-20\"> <button type=button class=\"btn btn-sm btn-danger\" ng-click=ctrl.removeFile($event) ng-disabled=ctrl.disabled> <i class=\"fal fa-times\"></i> </button> </div> </div> </div> <div class=\"upload-messages margin-top-20\" ng-if=\"ctrl.errorMessage || ctrl.externalErrorMessage\"> <div class=\"alert alert-danger\"> <i class=\"fal fa-exclamation-triangle\"></i> {{ctrl.errorMessage || ctrl.externalErrorMessage}} </div> </div> </div>");
$templateCache.put("app/directives/widget-filters/widget-filters.html","<script type=text/ng-template id=filter.html><div class=\"form-group\" ng-hide=\"(filter.filterGroup.comboId && filterGroup.currentComboId!=filter.filterGroup.comboId) || filter.hide\" ng-class=\"{\'active\': ctrl._isActive(filter)}\">\n      <label ng-show=\"filter.label\" for=\"{{id}}-{{filter.id}}\">{{filter.label}}:</label>\n\n      <!-- INPUT TEXT -->\n      <input ng-if=\"filter.type==\'text\' && !filter.combo\" type=\"text\" class=\"form-control\" id=\"{{ctrl.id}}-{{filter.id}}\" ng-model=\"filter.value\" ng-change=\"ctrl._onChange(filter)\">\n\n      <!-- INPUT NUMBER -->\n      <input ng-if=\"filter.type==\'number\' && !filter.combo\" type=\"number\" class=\"form-control\" min=\"0\" id=\"{{ctrl.id}}-{{filter.id}}\" ng-model=\"filter.value\" ng-change=\"ctrl._onChange(filter)\">\n\n      <!-- COMBO INPUT TEXT -->\n      <div ng-if=\"filter.type==\'text\' && filter.combo\" class=\"input-group\" ng-init=\"filter.scope=filter.scope ? filter.scope : filter.combo[0]\">\n        <span class=\"input-group-prepend\" uib-dropdown is-open=\"status.isopen\">\n            <button id=\"single-button\" type=\"button\" class=\"btn btn-light active\" uib-dropdown-toggle ng-disabled=\"disabled\">{{filter.scope.label}} <span class=\"caret\"></span></button>\n            <div class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"single-button\">\n              <li class=\"dropdown-item\" ng-repeat=\"scope in filter.combo\"><a ng-click=\"ctrl.onComboChange(filter,scope)\">{{scope.label}}</a></li>\n            </div>\n        </span>\n        <input type=\"text\" class=\"form-control\" id=\"{{ctrl.id}}-{{filter.id}}\" ng-model=\"filter.value\" ng-change=\"ctrl._onChange(filter)\" style=\"width:280px\">\n      </div>\n\n      <!-- SELECT -->\n      <!-- <select ng-if=\"filter.type==\'select\'\" class=\"form-control\" id=\"{{id}}-{{filter.id}}\" ng-model=\"filter.value\" ng-change=\"_onChange(filter)\" ng-click=\"_onClick(filter)\" ng-options=\"item.id as item.label for item in filter.values\">\n      </select>-->\n\n      <!-- BUTTONS -->\n      <div ng-if=\"filter.type==\'buttons\'\" class=\"input-group\">\n        <div class=\"btn-group btn-group-toggle\">\n          <label class=\"btn btn-secondary\" ng-repeat=\"item in filter.values\" ng-model=\"filter.value\" ng-change=\"ctrl._onChange(filter)\" uib-btn-radio=\"\'{{item.id}}\'\">{{item.label}}</label>\n        </div>\n      </div>\n\n      <!-- MULTI SELECT -->\n      <div ng-if=\"filter.type==\'multi-select\'\" class=\"input-group\">\n        <multi-select-component\n          class=\"width-600\"\n          items=\"filter.values\"\n          item=\"filter.value\"\n          field=\"\'display\'\"\n          on-change=\"ctrl._onChange(filter)\"\n          search\n        >\n      </multi-select-component>\n      </div>\n\n      <!-- SELECT -->\n      <div ng-if=\"filter.type==\'select\'\" class=\"input-group\" uib-dropdown>\n        <button type=\"button\" class=\"btn btn-light active\" uib-dropdown-toggle ng-click=\"ctrl._openSelect(filter)\">{{ ctrl._asLabel(filter) }} <span class=\"caret\"></span></button>\n        <ul class=\"dropdown-menu\" uib-dropdown-menu>\n          <li class=\"dropdown-item\" ng-hide=\"(filter._valuesLoaded==\'loading\')\" ng-repeat=\"item in filter.values\"><a ng-click=\"ctrl.onSelectArea(filter, item)\">{{item.label}}</a></li>\n          <div ng-show=\"(filter._valuesLoaded==\'loading\')\" class=\"spinner\"><div></div></div>\n        </ul>\n      </div>\n\n      <!-- SELECT WITH SEARCH -->\n      <div ng-if=\"filter.type==\'select-search\'\" class=\"input-group\" uib-dropdown>\n        <select-component\n          class=\"filter\"\n          items=\"filter.values\"\n          item=\"filter.value\"\n          custom-display=\"filter.display\"\n          on-search=\"filter.onSearch\"\n          on-change=\"ctrl._onChange(filter)\"\n          search>\n        </select-component>\n      </div>\n\n      <!-- DATE -->\n      <div ng-if=\"filter.type==\'date\'\" class=\"input-group\">\n        <input id=\"{{ctrl.id}}-{{filter.id}}\" type=\"text\" class=\"form-control\" ng-model=\"filter.value\" uib-datepicker-popup=\"{{filter.format}}\" on-open-focus=false is-open=\"filter.opened\" datepicker-options=\"filter.options\"\n          show-button-bar=\"false\" ng-change=\"ctrl._onChange(filter)\"/>\n        <span class=\"input-group-append\">\n          <button type=\"button\" class=\"btn btn-light active\" ng-click=\"filter.opened=!filter.opened\"><i class=\"fal fa-calendar\"></i></button>\n        </span>\n      </div>\n\n      <!-- SLIDER RANGE -->\n      <div ng-if=\"filter.type==\'range\'\" class=\"input-group\">\n        <widget-slider range=\"filter.value\" params=\"filter.options\" on-change=\"ctrl._onChangeForced\"></widget-slider>\n      </div>\n\n      <a class=\"clear-filter\" ng-click=\"ctrl._clear(filter)\" ng-show=\"ctrl._isActive(filter)\"><i class=\"fa fa-times\"></i></a>\n\n    </div></script><!-- FILTERS --> <form class=filters><!-- MAIN FILTERS --> <div class=form-inline> <div ng-repeat=\"filter in ctrl.mainFilters\" ng-include=\"\'filter.html\'\" ng-class=\"{\'button-group\': filter.type === \'buttons\'}\"></div> <div ng-show=ctrl.displayButton class=\"form-group submit\"><!-- <button type=\"submit\" class=\"btn btn-info\" ng-click=\"_onSubmit()\"><i class=\"fal fa-sync mr\"></i> Recargar</button> --> <button type=submit class=\"btn btn-info\" ng-click=ctrl._onSubmit()><i class=\"fal fa-search\"></i></button> </div> <div class=form-group> <a ng-show=ctrl.withAdvancedFilters class=mr-s ng-click=\"ctrl.advancedFiltersOpen=!ctrl.advancedFiltersOpen\"> <i class=\"fal fa-sliders-h mr\"></i> {{\'W.FILTERS.ADVANCED_SEARCH\' | translate}} </a> </div> <div class=form-group> <a class=mr-s ng-click=ctrl._clearAll() ng-show=\"(ctrl._totalActive() > 0)\"> {{\'W.FILTERS.CLEAN_ALL\' | translate}} </a> </div> </div><!-- ADVANCED FILTERS --> <div class=advanced-filters-container> <div class=advanced-filters ng-class=\"{\'open\':ctrl.advancedFiltersOpen}\"> <a class=close-advanced-filters ng-click=\"ctrl.advancedFiltersOpen=false\"><i class=\"fa fa-chevron-up\"></i></a> <div ng-repeat=\"filterGroup in ctrl.filterGroups\" class=filter-group> <div class=filter-group-label> {{filterGroup.label}} <div ng-show=filterGroup.combo ng-init=\"filterGroup.currentComboId = filterGroup.currentComboId || filterGroup.combo[0].id\" class=label-combo> <select class=\"form-control btn-sm\" ng-model=filterGroup.currentComboId ng-change=ctrl._clearAllInFilterGroup(filterGroup) ng-options=\"item.id as item.label for item in filterGroup.combo\"></select> </div> </div> <div class=form-inline><!-- <div ng-show=\"filterGroup.combo\" ng-init=\"filterGroup.currentComboId=filterGroup.combo[0].id\" class=\"form-group\">\n            <select class=\"form-control\" ng-model=\"filterGroup.currentComboId\" ng-change=\"_crearAllInFilterGroup(filterGroup)\" ng-options=\"item.id as item.label for item in filterGroup.combo\"></select>\n          </div> --> <div ng-repeat=\"filter in filterGroup.filters\" ng-include=\"\'filter.html\'\"></div> </div> </div> </div> </div> </form>");
$templateCache.put("app/directives/widget-properties-editor/widget-properties-editor.html","<div class=properties-editor ng-class=\"{edit: ctrl.onEdition}\"> <div class=properties ng-class=\"{flexible: !!ctrl.properties.flexible}\"> <div ng-repeat=\"key in ctrl._keys\" class=property ng-class=\"{\'not-editable\': !ctrl._isKeyEditable(key, $index)}\"> <span class=label> <span ng-show=ctrl._isKeyOnlyAdmin(key) class=only-admin uib-tooltip=\"{{\'W.PROPS.ONLY_ADMIN\' | translate}}\" tooltip-placement=top-left>{{ctrl._getHeader(key, $index)}}</span> <span ng-show=!ctrl._isKeyOnlyAdmin(key) ng-attr-required=\"{{ctrl.onEdition && ctrl._getKeyRequired(key) ? true : undefined}}\">{{ctrl._getHeader(key, $index)}}</span> <span ng-show=ctrl._getKeyInfo(key) uib-tooltip={{ctrl._getKeyInfo(key)}} class=info-hint></span>: </span> <span ng-if=\"!ctrl.onEdition || !ctrl._isKeyEditable(key, $index)\" class=value ng-class=\"{\'framed\': ctrl._getKeyType(key)===\'html\'}\" bind-html-compile=\"ctrl._getValueForView(key, $index)\"></span> <div ng-show=\"!ctrl.onEdition && ctrl._getKeyWarn(key)\" class=help>{{ctrl._getKeyWarn(key)}}</div> <div ng-if=\"ctrl.onEdition && ctrl._isKeyEditable(key, $index)\"> <div class=form-group ng-show=!ctrl.removed[key]> <input ng-if=\"ctrl._getKeyType(key)===\'text\'\" type=text maxlength={{ctrl._getMax(key)}} class=form-control ng-model=ctrl.input[$index].value ng-change=\"{{ctrl._getOnChange(key, ctrl.input[$index])}}\" autofocus-on=\"(key===ctrl.keyToAdd)\">  <div ng-if=\"ctrl._getKeyType(key)===\'calendar\'\"> <div class=form-group> <input type=datetime-local ng-model=ctrl.input[$index].value min={{ctrl._getMin(key)}} ng-change=\"{{ctrl._getOnChange(key, ctrl.input[$index])}}\" class=form-control> </div> </div> <input ng-if=\"ctrl._getKeyType(key)===\'number\'\" type=number class=form-control min={{ctrl._getMin(key)}} step={{ctrl._getStep(key)}} ng-change=\"{{ctrl._getOnChange(key, ctrl.input[$index])}}\" ng-model=ctrl.input[$index].value autofocus-on=\"(key===ctrl.keyToAdd)\">  <input ng-if=\"ctrl._getKeyType(key)===\'energy\'\" type=number class=form-control min={{ctrl._getMin(key)}} max={{ctrl._getMax(key)}} step={{ctrl._getStep(key)}} ng-change=\"{{ctrl._getOnChange(key, ctrl.input[$index])}}\" ng-model=ctrl.input[$index].value autofocus-on=\"(key===ctrl.keyToAdd)\" wh-to-kwh only-numbers> <input ng-if=\"ctrl._getKeyType(key)===\'energy-nullable\'\" type=number class=form-control min={{ctrl._getMin(key)}} max={{ctrl._getMax(key)}} step={{ctrl._getStep(key)}} ng-change=\"{{ctrl._getOnChange(key, ctrl.input[$index])}}\" ng-model=ctrl.input[$index].value autofocus-on=\"(key===ctrl.keyToAdd)\" wh-to-kwh-nullable only-numbers>  <select ng-if=\"ctrl._getKeyType(key)===\'select\'\" class=form-control ng-model=ctrl.input[$index].value ng-options=\"option.id as option.display for option in ctrl._getKeyOptions(key)\"> </select> <select-component ng-if=\"ctrl._getKeyType(key)===\'select-component\'\" item=ctrl.input[$index].value items=ctrl._getKeyOptions(key) field=ctrl._getKeyOptionsField(key) search> </select-component> <multi-select-component ng-if=\"ctrl._getKeyType(key)===\'multi-select\'\" item=ctrl.input[$index].value items=ctrl._getKeyOptions(key) field=ctrl._getKeyOptionsField(key) placeholder=ctrl._getKeyOptionsPlaceholder(key) search> </multi-select-component> <multi-language-input-component ng-if=\"ctrl._getKeyType(key)===\'multi-language-input\'\" on-change=\"ctrl._getOnChange(key, ctrl.input[$index])\" value=ctrl.input[$index].value> </multi-language-input-component> <div ng-if=\"ctrl._getKeyType(key)===\'html\'\"> <textarea class=form-control rows=7 ng-model=ctrl.input[$index].value autofocus-on=\"(key===ctrl.keyToAdd)\"></textarea> <a ng-click=ctrl._showHTMLPreview(ctrl.input[$index].value) style=\"position: absolute; right: 0\">{{\'W.PROPS.PREVIEW\' | translate}}</a> </div> <md-chips ng-if=\"ctrl._getKeyType(key)===\'chips\'\" md-on-add=\"ctrl._getChipValidate(key, $chip)\" md-on-remove=ctrl._getChipDelete(key) ng-model=ctrl.input[$index].value placeholder=\"{{\'W.PROPS.ADD_ELEMENTS\' | translate}}\" ng-required=true class=form-control> </md-chips> <a ng-show=ctrl._isKeyRemovable(key) class=remove-item uib-tooltip=\"{{\'W.PROPS.DEL_PROPERTY\' | translate}}\" ng-click=ctrl._remove(key)><i class=\"fa fa-times\"></i></a> <div ng-show=ctrl._getKeyHelp(key) class=help>{{ctrl._getKeyHelp(key)}}</div> <div ng-show=ctrl._getConflictData(key) class=\"help colophon\"> <div class=danger> <i class=\"fal fa-ban mr\"></i> <span translate=\"{{\'W.PROPS.\' + ctrl._getConflictMessage(key)}}\" translate-value-name=\"<accent>{{ctrl._getConflictData(key)}}</accent>\"></span> </div> </div> </div> <div ng-show=ctrl.removed[key]><span class=removed>{{\'W.PROPS.PROPERTY_REMOVED\' | translate}}</span><a ng-click=ctrl._undoRemove(key)>{{\'W.PROPS.UNDO_DEL_PROPERTY\' | translate}}</a></div> </div> </div> <div class=form-inline ng-show=\"ctrl.onEdition && ctrl.properties.addItems\"> <a ng-show=!ctrl.addingProperty ng-click=ctrl._askToAdd()> <i class=\"fal fa-plus mr\"></i>{{\'W.PROPS.ADD_PROPERTY\' | translate}} </a> <div ng-show=ctrl.addingProperty class=form-group> <label>{{\'W.PROPS.NAME_OF_THE_NEW_PROPERTY\' | translate}}: </label> <input type=text class=\"form-control form-control\" ng-keyup=\"$event.keyCode == 13 && ctrl._add(ctrl.keyToAdd)\" ng-model=ctrl.keyToAdd placeholder=\"\" autofocus-on=ctrl.addingProperty> <button class=\"btn btn-success ml-s\" ng-disabled=!ctrl._isValidToAdd() ng-click=ctrl._add(ctrl.keyToAdd)><i class=\"fa fa-check mr\"></i>{{\'W.PROPS.ADD\' | translate}}</button> <a class=ml-s ng-click=ctrl._discardAdd()>{{\'W.PROPS.CANCEL\' | translate}}</a> </div> </div> </div> <div class=actions ng-show=ctrl._onlyIf()> <a ng-if=\"!ctrl.onEdition && ctrl._isEditable()\" href=# ng-click=ctrl._enterEdition()> <i class=\"fal fa-edit mr\"></i>{{\'W.PROPS.EDIT\' | translate}} </a> </div> <div ng-show=ctrl.onEdition class=editor-footer> <button class=\"btn btn-light active\" ng-click=ctrl._cancelEdition()>{{\'W.PROPS.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-disabled=!ctrl._isFromValid() ng-click=ctrl._confirmAndSaveEdition()>{{\'W.PROPS.SAVE\' | translate}}</button> </div> </div>");
$templateCache.put("app/directives/widget-search-autocomplete/widget-search-autocomplete.html","<div class=search-autocomplete> <div class=two-parts-line style=align-items:baseline> <div class=left-part> <label>{{ctrl.autocomplete.filter.label}}</label> </div> <div class=right-part> <div class=form-group> <input id={{ctrl.id}}-{{ctrl.autocomplete.filter.id}} ng-model=ctrl.autocomplete.filter.value ng-change=\"ctrl.autocomplete.isTyping = true; ctrl._onChange(ctrl.autocomplete.filter);\" ng-keyup=\"$event.keyCode == 40 && ctrl._onArrowDown()\" autofocus-on=\"ctrl.focused === 0\" ng-focus=\"ctrl.focused = 0\" type=text class=form-control> </div> <div class=autocomplete-result> <a href=# ng-repeat=\"item in ctrl.items | sorting:ctrl.autocomplete | pagination:ctrl.autocomplete\" ng-class=\"{\'selected\': ctrl._isSelected(item)}\" ng-click=\"ctrl._onItemClick(item, $index);\" ng-keyup=\"$event.keyCode == 40 && ctrl._onArrowDown() || $event.keyCode == 38 && ctrl._onArrowUp()\" autofocus-on=\"ctrl.focused === ($index + 1)\"> <span bind-html-compile=\"$eval(ctrl.autocomplete.key, item)\" stop-propagation-on-anchor></span> </a> </div> <div ng-show=\"ctrl.items.length===0 && !ctrl.autocomplete.error\" class=zero-results>{{ ctrl.autocomplete.zeroResults || \'No se han encontrado resultados\' }}</div> <div class=\"two-parts-line autocomplete-footer\" style=align-items:baseline> <div class=left-part> <span ng-show=\"ctrl.items.length > 0\" class=\"small-text muted\">Encontrados {{ctrl.autocomplete.pagination.totalItems}} resultados</span> </div> <div class=right-part> <span class=mr-s ng-show=\"ctrl.autocomplete.pagination.totalItems > 0\"> {{ctrl.start}}-{{ctrl.end}} de&nbsp;<strong>{{ctrl.autocomplete.pagination.totalItems}}</strong> </span> <span class=mr-s ng-show=\"ctrl.items.length===0\">0-0 de <strong>0</strong></span> <ul uib-pagination class=pagination ng-if=\"ctrl.autocomplete.pagination.totalItems > ctrl.autocomplete.pagination.itemsPerPage\" total-items=ctrl.autocomplete.pagination.totalItems ng-model=ctrl.autocomplete.pagination.currentPage ng-change=ctrl._onNewPagination() max-size=ctrl.autocomplete.pagination.maxPages items-per-page=ctrl.autocomplete.pagination.itemsPerPage direction-links=false boundary-link-numbers=true> </ul> </div> </div> </div> </div> </div>");
$templateCache.put("app/directives/widget-switch/widget-switch.html","<input id={{ctrl.id}} class=switch type=checkbox ng-model=ctrl._model ng-change=ctrl._onChange() ng-disabled=ctrl.disabled> <label for={{ctrl.id}} ng-class=\"{loading: ctrl._loading}\"> <span class=yes>{{\'W.SWITCH.YES\' | translate}}</span> <span class=no>{{\'W.SWITCH.NO\' | translate}}</span> </label>");
$templateCache.put("app/directives/widget-table/widget-table.html","<ol class=breadcrumb ng-show=ctrl.enabledBreadcrumbs> <li ng-repeat=\"bc in ctrl.breadcrumbs track by $index\" ng-class=\"{active: $last}\"> <a href=\"\" ng-if=!$last ng-click=ctrl._onClickBreadcrumb($index)> {{bc.label}} </a> <span ng-if=$last>{{bc.label}}</span> </li> </ol> <div class=table-responsive> <table class=\"table table-hover table-striped\" ng-class=\"{\'with-actions\': ctrl.table.actions.length>0, \'compact\': compact}\"> <thead> <tr> <th ng-if=\"ctrl.table.selectable == \'multi\'\"> <a class=multi-select-header ng-click=ctrl._onMultiSelectHeader() tooltip-placement=auto uib-tooltip={{ctrl._getMultiSelectHeaderTooltip()}}> <i class=\"fa fa-{{ctrl._getMultiSelectHeaderIcon()}}\"></i> </a> </th> <th ng-repeat=\"key in ctrl.table.keys\" ng-class=\"{\'sortable\': (ctrl.table.sorting.keys.indexOf(ctrl._keyId(key)) >= 0), \'column-center\': ctrl._isColumnCenter(key)}\" ng-click=ctrl._onNewSorting(ctrl._keyId(key))> <div ng-if=\"(ctrl.table.sorting.keys.indexOf(ctrl._keyId(key)) >= 0)\" legacy-uib-tooltip=\"{{ (\'W.TABLE.SORT_BY\' | translate) + \' \' + (ctrl.table.headers[$index] || _keyId(key)) }}\" data-tippy-placement=top-start class=nowrap> {{ctrl.table.headers[$index] || ctrl._keyId(key)}} <span ng-if=(ctrl.table.hints[ctrl._keyId(key)]) uib-tooltip={{ctrl.table.hints[ctrl._keyId(key)]}} class=info-hint></span> <span> <i class=\"fa fa-sort-down\" ng-show=\"(ctrl.table.sorting.key == ctrl._keyId(key) && ctrl.table.sorting.order==\'desc\')\"></i> <i class=\"fa fa-sort-up\" ng-show=\"(ctrl.table.sorting.key == ctrl._keyId(key) && ctrl.table.sorting.order==\'asc\')\"></i> <i class=\"fa fa-sort\" ng-show=\"ctrl.table.sorting.key != ctrl._keyId(key)\"></i> </span> </div> <div ng-if=\"!(ctrl.table.sorting.keys.indexOf(ctrl._keyId(key)) >= 0)\"> {{ctrl.table.headers[$index] || ctrl._keyId(key)}} <span ng-if=(ctrl.table.hints[ctrl._keyId(key)]) uib-tooltip={{ctrl.table.hints[ctrl._keyId(key)]}} class=info-hint></span> </div> </th> <th ng-if=\"ctrl.table.actions.length>0\"> <div ng-if=ctrl.table.actionsColumnName> {{ctrl.table.actionsColumnName | translate}} </div> </th> </tr> </thead><thead> <tbody> <tr ng-repeat=\"item in ctrl.items | sorting:ctrl.table | pagination:ctrl.table track by $index\" ng-click=ctrl._onItemClick(item); ng-mouseenter=ctrl._onItemMouseEnter(item) ng-mouseleave=ctrl._onItemMouseLeave(item) ng-class=\"{\'selected\': ctrl._isSelected(item), \'clickable\': ctrl.clickable, \'pulsing\': item._pulsing}\"> <td ng-if=\"ctrl.table.selectable == \'multi\' || ctrl.table.selectable == \'one\'\" class=checks ng-click=\"$event.stopPropagation(); ctrl._onSelectItem(item)\"> <input type=checkbox id=select-{{$index}} ng-checked=ctrl._isSelected(item)> <label for=select-{{$index}} ng-click=$event.stopPropagation()></label> </td> <td ng-repeat=\"key in ctrl.table.keys\" ng-class=\"{\'last-value\': $last, \'column-center\': ctrl._isColumnCenter(key), \'wrap-anywhere\': ctrl.table.wrapAnywhere}\"> <span class=name bind-html-compile=\"$eval(key, item)\" stop-propagation-on-anchor></span> </td> <td ng-if=\"ctrl.table.actions.length>0\" class=actions> <div> <span ng-repeat=\"action in ctrl.table.actions\" class=\"action {{action.custom? action.custom : \'\'}}\" uib-tooltip={{action.tooltip}} ng-show=\"(!action.onlyIf || action.onlyIf(item))\"> <a ng-click=\"action.onClick(item, $parent.$index); $event.stopPropagation();\" href=\"\"> <i class=\"fa fa-{{action.icon}}\"></i> </a> </span> </div> </td> </tr> </tbody> </thead></table> </div> <div ng-show=\"ctrl.items.length===0 && !ctrl.table.error\" class=zero-results> {{ ctrl.table.zeroResults || (\'W.TABLE.ZERO_RESULTS\' | translate) }}</div> <div ng-show=\"ctrl.items.length===0 && ctrl.table.error\" class=on-error> {{ ctrl.table.error || (\'W.TABLE.SOMETHING_FAILED\' | translate) }} </div> <div class=two-parts-line style=align-items:baseline> <div class=left-part> <span ng-if=\"!ctrl.table.hideItemsPerPageSelector && ctrl.table.pagination.itemsPerPage > 0\" class=\"form-inline total-items-info\"> {{\'W.TABLE.SHOW_ITEM\' | translate}}&nbsp; <select class=\"table-left-part-control form-control form-control-sm\" ng-model=ctrl.table.pagination.itemsPerPage ng-change=\"ctrl.table.pagination.currentPage=1\" ng-options=\"itemsPerPageOption as itemsPerPageOption for itemsPerPageOption in ctrl.itemsPerPageOptions\"></select> &nbsp;{{\'W.TABLE.PER_PAGE\' | translate}} </span> </div> <div class=right-part> <span class=mr-s ng-show=\"ctrl.table.pagination.totalItems > 0\"> {{ctrl.start}}-{{ctrl.end}} {{\'W.TABLE.OUT_OF\' | translate}}&nbsp;<strong>{{ctrl.table.pagination.totalItems}}</strong> </span> <span class=mr-s ng-show=\"ctrl.table.pagination.totalItems <= 0\">0-0 {{\'W.TABLE.OUT_OF\' | translate}} <strong>0</strong></span> <ul uib-pagination class=pagination ng-if=\"ctrl.table.pagination.totalItems > ctrl.table.pagination.itemsPerPage\" total-items=ctrl.table.pagination.totalItems ng-model=ctrl.table.pagination.currentPage ng-change=ctrl._onNewPagination() max-size=ctrl.table.pagination.maxPages items-per-page=ctrl.table.pagination.itemsPerPage direction-links=false boundary-link-numbers=true> </ul> </div> </div>");
$templateCache.put("app/directives/widget-tree/widget-tree.html","<script type=text/ng-template id=nodes-renderer.html><div ui-tree-handle class=\"tree-node tree-node-content\"\n    ng-class=\"{\'selected\': (ctrl.tree.selected.indexOf(node[ctrl.tree.id]) >= 0)}\"\n    ng-attr-data-nodrag=\"{{ctrl.tree.draggable? undefined : true}}\" ng-click=\"ctrl._onItemClick(node)\">\n    <div class=\"main\">\n      <span ng-if=\"node[ctrl.tree.nodes] && node[ctrl.tree.nodes].length > 0\"\n        ng-init=\"(this.depth() > 1 ? this.collapse() : this.expand())\"\n        ng-click=\"ctrl._toggle(this); $event.stopPropagation();\" data-nodrag class=\"action toggler center\"\n        uib-tooltip=\"{{collapsed? (\'W.TREE.EXPAND\' | translate) : (\'W.TREE.COLLAPSE\' | translate)}} {{$eval(ctrl.tree.title, node)}}\" tooltip-placement=\"auto\">\n        <a href=\"\"><i class=\"fa\" ng-class=\"{\'fa-chevron-right\': collapsed, \'fa-chevron-down\': !collapsed}\"></i></a>\n      </span>\n      <span class=\"titles\">\n        <span class=\"title\" bind-html-compile=\"($eval(ctrl.tree.title, node) | safe)\"></span>\n        <span class=\"subtitle\" bind-html-compile=\"($eval(ctrl.tree.subtitle, node) | safe) || \'...\'\"></span>\n      </span>\n      <span ng-if=\"ctrl.tree.custom\" class=\"custom\" bind-html-compile=\"ctrl.tree.custom\" trust-csti=\"true\"></span>\n    </div>\n    <div class=\"actions\">\n      <span ng-repeat=\"action in ctrl.tree.actions\" data-nodrag class=\"action {{action.custom? action.custom : \'\'}}\"\n        ng-show=\"(!action.onlyIf || action.onlyIf(node))\"\n        ng-class=\"{\'disabled\': action.disabled && action.disabled(node)}\"\n        uib-tooltip=\"{{ (action.tooltipDisabled && action.disabled && action.disabled(node))? action.tooltipDisabled : action.tooltip}}\">\n        <a ng-click=\"$event.stopPropagation(); action.onClick(node);\" href=\"\"><i class=\"fa fa-{{action.icon}}\"></i></a>\n      </span>\n    </div>\n\n  </div>\n  <ol ui-tree-nodes=\"\" ng-model=\"node[ctrl.tree.nodes]\" ng-if=\"!collapsed\">\n    <li ng-repeat=\"node in node[ctrl.tree.nodes]\" ui-tree-node ng-include=\"\'nodes-renderer.html\'\"></li>\n  </ol></script> <div ui-tree=ctrl._dragHandlers ng-class=\"{\'draggable\': ctrl.tree.draggable}\"> <ol ui-tree-nodes ng-model=ctrl.nodes> <li ng-repeat=\"node in ctrl.nodes\" ui-tree-node ng-include=\"\'nodes-renderer.html\'\"></li> </ol> <div ng-show=\"ctrl.nodes.length===0\" class=zero-results> {{ ctrl.tree.zeroResults || (\'W.TREE.ZERO_RESULTS\' | translate) }} </div> </div> <div class=align-right> <a ng-click=ctrl._expandAll()>{{\'W.TREE.EXPAND_ALL\' | translate}}</a> <span class=\"muted ml-s mr-s\">|</span> <a ng-click=ctrl._collapseAll()>{{\'W.TREE.COLLAPSE_ALL\' | translate}}</a> </div>");
$templateCache.put("app/views/agreements/agreements.html","<div id=state-app-agreements class=indented-fluid> <section> <div class=\"filters-container top\"> <div class=\"input-group padding-all-5\"> <div class=\"btn-group btn-group-toggle\"> <div class=\"btn btn-secondary\" ng-repeat=\"mode in ctrl.modes\" uib-btn-radio=mode.id ng-model=ctrl.mode ng-change=ctrl.onChangeMode(mode.id)> {{mode.label}} </div> </div> </div> <div ng-switch=ctrl.mode> <widget-filters ng-switch-when=Agreements params=ctrl.filters.agreements controls=ctrl.agreementsControls on-reload=ctrl.reloadAgreements> </widget-filters> <widget-filters ng-switch-when=Operations params=ctrl.filters.operations controls=ctrl.operationsControls on-reload=ctrl.reloadOperations> </widget-filters> </div> </div> <div ng-switch=ctrl.mode> <widget-table ng-switch-when=Agreements params=ctrl.tables.agreements items=ctrl.agreements on-item-click=ctrl.upsertAgreement on-reload=ctrl.reloadAgreements> </widget-table> <widget-table ng-switch-when=Operations params=ctrl.tables.operations items=ctrl.operations on-item-click=ctrl.upsertOperation on-reload=ctrl.reloadOperations> </widget-table> </div> <div class=buttons ng-show=ctrl.Auth.isProvider()> <div ng-switch=ctrl.mode> <button ng-switch-when=Agreements class=\"btn btn-primary\" ng-click=ctrl.addAgreement() ng-show=false> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate }} </button> <button ng-switch-when=Operations class=\"btn btn-primary\" ng-click=ctrl.addOperation()> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate }} </button> </div> </div> </section> </div>");
$templateCache.put("app/views/charge/charge.html","<div id=state-app-charge class=indented-fluid> <div class=panels> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=ctrl.charge></widget-properties-editor> </div> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=main-panel><!-- METER TAB --> <div ng-show=\"ctrl.tabs.active.id == \'meter\'\"> <section> <canvas id=chargeChart></canvas> </section> <section ng-show=ctrl.ChargeHelper.isCharging(ctrl.charge)> <span class=header>{{\'CHARGE.ACTIONS\' | translate}}</span> <div class=buttons> <button class=\"btn btn-warning\" ng-disabled=ctrl.ChargepointHelper.isPooling(ctrl.chargepoint) ng-click=ctrl.stopCharge()><i class=\"fal fa-battery-slash mr\"></i>{{\'CHARGE.STOP_CHARGE\' | translate}}</button> <button ng-show=ctrl.ChargeHelper.isAdminProvider() class=\"btn btn-danger\" ng-disabled=ctrl.ChargepointHelper.isPooling(ctrl.chargepoint) ng-click=ctrl.askForForcedClosure()><i class=\"fal fa-battery-slash mr\"></i>{{\'CHARGE.FORCE_CLOSURE_CHARGE\' | translate}}</button> </div> </section> </div><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'CHARGE.GENERAL_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.charge> </widget-properties-editor> </section> <section> <span class=header>{{\'CHARGE.CHARGED\' | translate}}</span> <widget-properties-editor params=ctrl.properties.meter item=ctrl.charge> </widget-properties-editor> </section> <section> <span class=header>{{\'CHARGE.USERKEYS\' | translate}}</span> <widget-properties-editor params=ctrl.properties.userkeys item=ctrl.charge> </widget-properties-editor> </section> </div><!-- METER VALUES TAB --> <div ng-show=\"ctrl.tabs.active.id == \'values\'\"> <section> <span class=header>{{\'CHARGE.MEASURES\' | translate}}</span> <widget-table params=ctrl.tables.meterValues items=ctrl.meterValues on-reload=ctrl.reloadMeterValues> </widget-table> </section> <section> <span class=header>{{\'CHARGE.STATUS_EVENTS\' | translate}}</span> <widget-table params=ctrl.tables.statusValues items=ctrl.statusValues on-reload=ctrl.reloadStatusValues> </widget-table> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/charge-point/charge-point.html","<div id=state-app-chargepoint class=indented-fluid> <div ng-show=!ctrl.isDisconnected() class=top-right-message translate=CH.LAST_TIME_SEEN_ON translate-value-date=\"{{ctrl.chargepoint.ocppConnection.lastTimeSeen | toDate}}\"></div> <div ng-show=ctrl.isDisconnected() class=\"top-right-message warning\" translate=CH.DISCONNECTED_LAST_TIME_SEEN_ON translate-value-date=\"{{ctrl.chargepoint.ocppConnection.lastTimeSeen | toDate}}\"> </div> <div class=panels> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=ctrl.chargepoint></widget-properties-editor> </div> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=main-panel><!-- CONTROL TAB --> <div ng-show=\"ctrl.tabs.active.id == \'control\'\"> <section ng-class=\"{\'disconnected\': ctrl.isDisconnected()}\"><!-- Errors --> <div class=\"section-card issues\" ng-show=\"ctrl.state.errors.length > 0\"> <div class=card-label translate=CH.ERRORS.ERRORS translate-value-total={{ctrl.state.errors.length}}></div> <div class=error-message ng-repeat=\"issue in ctrl.state.errors\"> {{\'CH.ERRORS.ERROR_AT\' | translate}} <strong ng-show=issue.isChargepoint translate=CH.ERRORS.CHARGEPOINT></strong><span ng-show=issue.isChargepoint>: </span> <strong ng-show=!issue.isChargepoint translate=CH.ERRORS.CONNECTOR translate-value-number={{issue.connectorId}}></strong><span ng-show=!issue.isChargepoint>: </span> <span class=badge type=bad>{{issue.errorCode}}</span> </div> </div><!-- Connectors --> <div class=\"section-card stripes\"> <div class=card-label translate=CH.CONNECTORS.CONNECTORS translate-value-total=\"{{ctrl.chargepoint.connectors | totalConnectors}}\"></div> <div class=\"connectors mt-s\"> <div ng-show=\"(ctrl.chargepoint && (!ctrl.chargepoint.connectors || ctrl.chargepoint.connectors.length <= 1))\" class=zero-results><i class=\"fal fa-exclamation-triangle mr\"></i>{{\'CH.CONNECTORS.ZERO_CONNECTORS\' | translate}}</div> <div class=connector ng-repeat=\"connector in ctrl.chargepoint.connectors | onlyConnectors | connectorsSorted track by connector.id\" ng-class=\"{\'expanded\': ctrl.state.connector[connector.id].expanded}\" ng-attr-connector-type={{connector.type}} ng-attr-connector-mode={{connector.mode}}> <div class=connector-brief ng-click=\"(ctrl.state.connector[connector.id].expanded = !ctrl.state.connector[connector.id].expanded)\"> <div class=connector-top> <span class=ellipsis-options><i class=\"fa fa-ellipsis-v\"></i></span> <h5 class=title><!--<i class=\"fas fa-plug mr\"></i>--> {{connector.label || (\'CH.CONNECTORS.CONNECTOR\' | translate)}} <accent>{{connector.id}} </accent> </h5> </div> <div ng-show=!ctrl.isDisconnected() class=connector-main> <div class=connector-type uib-tooltip-html=ctrl.getConnectorType(connector)> <span class=connector-mode bind-html-compile=\"connector.mode | connectorMode:connector:\'mini-badge\'\"></span> </div> <div class=status bind-html-compile=\"connector.status.status | status\"></div> <div class=error-code bind-html-compile=\"connector.status.errorCode | errorCode\"></div> </div> <div ng-show=ctrl.isDisconnected() class=connector-main uib-tooltip-html=\"\'{{\'CH.CONNECTORS.CHARGEPOINT_DISCONNECTED\' | translate}}<br>{{\'CH.CONNECTORS.LAST_KNOWN_STATUS\' | translate}}: {{connector.status.status}}<br>{{\'CH.CONNECTORS.LAST_TIME_SEEN\' | translate}}: {{ctrl.chargepoint.ocppConnection.lastTimeSeen | toDate}}\'\"> <div class=\"status warning\">{{\'CH.CONNECTORS.WITHOUT_CONNECTION\' | translate}}</div> <div class=\"error-code muted\">{{\'CH.CONNECTORS.UNKNOWN_STATUS\' | translate}}</div> </div> <div class=connector-bottom> <div ng-if=connector.transaction><a ui-sref=\"efimob.charges.at.item({id: connector.transaction.uuid, organization: ctrl.organization})\" ng-click=$event.stopPropagation()>{{\'CH.CONNECTORS.LAST_CHARGE\' | translate}}</a> </div> <div ng-if=\"!connector.transaction && connector.lastActiveTransaction\"><a ui-sref=\"efimob.charges.at.item({id: connector.lastActiveTransaction.uuid, organization: ctrl.organization})\" ng-click=$event.stopPropagation()>{{\'CH.CONNECTORS.LAST_CHARGE\' | translate}}</a> </div> </div> </div> <div class=connector-details ng-init=\"ctrl.state.connector[connector.id].tab = \'actions\'\"> <div class=connector-tabs> <a href=# ng-class=\"{\'active\': ctrl.state.connector[connector.id].tab === \'actions\'}\" ng-click=\"ctrl.state.connector[connector.id].tab = \'actions\'\"> {{\'CH.CONNECTORS.ACTIONS.CONTROLS\' | translate}} </a> <a href=# ng-class=\"{\'active\': ctrl.state.connector[connector.id].tab === \'details\'}\" ng-click=\"ctrl.state.connector[connector.id].tab = \'details\'\"> {{\'CH.CONNECTORS.DETAILS.DETAILS\' | translate}} </a> <a href=# ng-class=\"{\'active\': ctrl.state.connector[connector.id].tab === \'status\'}\" ng-click=\"ctrl.state.connector[connector.id].tab = \'status\'\"> {{\'CH.CONNECTORS.STATUS.STATUS\' | translate}} </a> <a ng-show=!ctrl.isRoaming() href=# ng-class=\"{\'active\': ctrl.state.connector[connector.id].tab === \'settings\'}\" ng-click=\"ctrl.state.connector[connector.id].tab = \'settings\'\"> {{\'CH.CONNECTORS.SETTINGS.SETTINGS\' | translate}} </a> </div> <div class=connector-tab ng-show=\"ctrl.state.connector[connector.id].tab === \'actions\'\"> <div class=connector-switches> <div ng-show=!ctrl.isRoaming() class=align-right><span>{{\'CH.CONNECTORS.ACTIONS.AVAILABLE\' | translate}}: <widget-switch model=ctrl.state.connector[connector.id].operative on-change=ctrl.changeConnectorAvailability on-change-arg=connector disabled=\"ctrl.isPooling() || ctrl.isRoaming()\" loading=ctrl.state.connector[connector.id].loading.operative></widget-switch></span></div> </div> <div class=buttons> <button ng-repeat=\"action in ctrl.display.connector.actions\" ng-show=\"(!action.onlyIf || action.onlyIf(connector))\" ng-disabled=ctrl.isPooling() class=\"btn btn-outline-secondary btn-sm\" ng-click=\"action.onClick(connector, action)\"><i class=\"fal fa-{{action.icon}} mr\"></i>{{action.display}}</button><!-- <button class=\"btn btn-outline-secondary btn-sm\" ng-disabled=\"true\">Más...</button> --> </div> </div> <div class=connector-tab ng-show=\"ctrl.state.connector[connector.id].tab === \'details\'\"> <widget-properties-editor params=ctrl.properties.connectorDetails item=connector> </widget-properties-editor> </div> <div class=connector-tab ng-show=\"ctrl.state.connector[connector.id].tab === \'status\'\"> <widget-properties-editor params=ctrl.properties.connectorStatus item=connector> </widget-properties-editor> </div> <div class=connector-tab ng-show=\"ctrl.state.connector[connector.id].tab === \'settings\'\"> <widget-properties-editor params=ctrl.properties.connectorSettings item=connector> </widget-properties-editor> <div class=mt-l> <a ng-click=ctrl.askToEditConnectorSettings(connector)><i class=\"fas fa-plug mr\"></i>{{\'CH.CONNECTORS.SETTINGS.CONFIGURE_CONNECTOR\' | translate}}</a> </div> </div> </div> </div> </div> </div><!-- Schedule recharging --> <div ng-show=\"ctrl.isProvider() && !ctrl.isRoaming()\" class=section-card ng-show=ctrl.chargepoint.chargingSchedulerEnabled> <div class=card-label>{{\'SCHEDULE_RECHARGING\' | translate}}</div> <div class=margin-top-20> <widget-table params=ctrl.tables.rechargingSchedule items=ctrl.rechargingSchedule on-reload=ctrl.reloadRechargingSchedule> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'COMMON.ADD\' | translate}}\" ng-click=ctrl.askToAddRechargingSchedule()><i class=\"fal fa-plus mr\"></i>{{\'ADD_PERIOD\' | translate}} </button> </div> </div> </div><!-- Controls --> <div ng-show=!ctrl.isRoaming() class=section-card> <div class=card-label>{{\'CH.QUICK.QUICK_CONTROLS\' | translate}}</div> <div class=two-parts-line> <div class=\"buttons left-part\"> <div class=inline-flex> <label class=\"nowrap mr-s bold\">{{\'CH.QUICK.OPERATIONAL_STATUS\' | translate}}: </label> <select name=operationalStatus ng-model=ctrl.state.chargepoint.status ng-change=ctrl.changeOperationalStatus(ctrl.state.chargepoint.status) class=form-control ng-disabled=!ctrl.canAdminChargepoint() ng-options=\"operationalStatus.id as operationalStatus.display for operationalStatus in ctrl.ChargepointHelper.operationalStatuses\"></select> </div> </div> <div class=\"right-part buttons\"> <button class=\"btn btn-warning\" ng-disabled=ctrl.isPooling() ng-click=\"ctrl.resetChargepoint(\'Soft\')\"> <i class=\"fal fa-sync-alt mr\"></i> {{\'CH.QUICK.SOFT_RESET\' | translate}} </button> <button class=\"btn btn-danger\" ng-disabled=ctrl.isPooling() ng-click=\"ctrl.resetChargepoint(\'Hard\')\"> <i class=\"fal fa-power-off mr\"></i>{{\'CH.QUICK.HARD_RESET\' | translate}} </button> <button class=\"btn btn-outline-secondary\" ng-click=\"ctrl.state.moreControlsOpen=!ctrl.state.moreControlsOpen\"> {{\'CH.QUICK.MORE\' | translate}} </button> </div> </div> <div class=more-controls ng-show=ctrl.state.moreControlsOpen> <div class=\"mt-s align-right\"> <span>{{\'CH.QUICK.AVAILABLE\' | translate}}: <widget-switch model=ctrl.state.chargepoint.operative on-change=ctrl.changeAvailability disabled=ctrl.isPooling() loading=ctrl.state.chargepoint.loading.operative></widget-switch> </span> </div> <div class=buttons> <button class=\"btn btn-outline-secondary\" ng-disabled=ctrl.isPooling() ng-click=ctrl.clearCache()> <i class=\"fal fa-broom mr\"></i> {{\'CH.QUICK.CLEAR_CACHE\' | translate}} </button> <div class=help translate=CH.QUICK.CLEAR_CACHE_HELP translate-value-action=\"<i>clear cache</i>\"></div> </div> <div class=buttons> <button class=\"btn btn-outline-secondary\" ng-disabled=ctrl.isPooling() ng-click=ctrl.clearLocalAuthorizationList()> <i class=\"fal fa-eraser mr\"></i> {{\'CH.QUICK.CLEAR_LOCAL_USERKEYS\' | translate}} </button> <div class=help translate=CH.QUICK.CLEAR_LOCAL_USERKEYS_HELP translate-value-action=\"<i>clear local authorization list</i>\"></div> </div> <div class=buttons> <button class=\"btn btn-outline-secondary\" ng-disabled=ctrl.isPooling() ng-click=ctrl.triggerStatusNotification()> <i class=\"fal fa-hand-point-right mr\"></i> {{\'CH.QUICK.TRIGGER_STATUS\' | translate}} </button> <div class=help translate=CH.QUICK.TRIGGER_STATUS_HELP translate-value-action=\"<i>trigger status notification</i>\"></div> </div> <section class=margin-top-20> <p>{{\'CH.QUICK.PROGRAM_REBOOT\' | translate}}:</p> <widget-table params=ctrl.tables.programedReboots items=ctrl.programedReboots on-reload=ctrl.reloadChargepointProgramedReboot> </widget-table> <div class=buttons ng-show=!ctrl.isPooling()> <button class=\"btn btn-primary\" ng-disabled=ctrl.isPooling() uib-tooltip=\"{{\'CH.QUICK.ADD_NEW_REBOOT\' | translate}}\" ng-click=ctrl.askToAddProgramedReboot()><i class=\"fal fa-plus mr\"></i>{{\'CH.QUICK.ADD_REBOOT\' | translate}}</button> </div> </section> </div> </div><!-- Chargepoint status --> <div ng-show=!ctrl.isRoaming() class=section-card> <div class=card-label>{{\'CH.STATUS_OCPP.STATUS_OCPP\' | translate}}</div> <div class=mt-s> <widget-properties-editor params=ctrl.properties.connectorZeroStatus item=ctrl.ChargepointHelper.getConnectorZero(ctrl.chargepoint)></widget-properties-editor> </div> </div> <div ng-show=\"ctrl.isProvider() && !ctrl.isRoaming() && !ctrl.isProxy()\" class=section-card> <div class=card-label>{{\'CH.ADMIN_CONTROLS\' | translate}}</div> <div class=mt-s> <label class=\"nowrap mr-s bold\">{{\'CH.SHARED\' | translate}}</label> <div> <widget-switch model=ctrl.chargepoint.shared on-change=ctrl.onSharedChanged loading=ctrl.state.chargepoint.loading.shared disabled=!ctrl.isProvider()> </widget-switch> </div> </div> </div> </section> </div><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'CH.INFO.GENERAL_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.chargepoint></widget-properties-editor> </section> <section> <span class=header>{{\'CH.INFO.LOCATION\' | translate}}</span> <div> <div ng-show=ctrl.groups.parentWithLocation style=\"height: 300px; margin-bottom: 10px\"> <widget-map params=ctrl.map items=[ctrl.groups.parentWithLocation]></widget-map> </div> <div ng-show=\"ctrl.chargepoint.organizationId && ctrl.chargepoint.groupId\"> <p>{{\'CH.INFO.CHARGEPOINT_IS_IN_GROUP\' | translate}}<a ui-sref=\"efimob.groups.item({id: ctrl.chargepoint.groupId, organization: ctrl.organization})\">{{ctrl.chargepoint.groupName}}</a> <span ng-show=\"ctrl.groups.parentWithLocation && ctrl.groups.parentWithLocation.id != ctrl.chargepoint.groupId\"> {{\'CH.INFO.OF_GROUP\' | translate}}<a ui-sref=\"efimob.groups.item({id: ctrl.groups.parentWithLocation.id, organization: ctrl.organization})\">{{ctrl.groups.parentWithLocation.name}}</a></span> </p> <button class=\"btn btn-light active\" ng-click=ctrl.askToChangeGroup() ng-show=!ctrl.isRoaming()><i class=\"fal fa-project-diagram mr\"></i>{{\'CH.INFO.CHANGE_GROUP\' | translate}}</button> </div> <div ng-show=\"ctrl.chargepoint.organizationId && ctrl.chargepoint.groupId===null\"> <p>{{\'CH.INFO.NO_LOCATION_YET\' | translate}}</p> <button class=\"btn btn-primary\" ng-click=ctrl.askToChangeGroup() ng-show=!ctrl.isRoaming()><i class=\"fal fa-project-diagram mr\"></i>{{\'CH.INFO.PLACE_AT_GROUP\' | translate}}</button> </div> <div ng-show=!ctrl.chargepoint.organizationId> <p>{{\'CH.INFO.NEITHER_ORGANIZATION_NOR_GROUP_YET\' | translate}}</p> </div> </div> </section> <section ng-show=!ctrl.isRoaming()> <span class=header>{{\'CH.INFO.OPERATIONAL_STATUS\' | translate}}</span> <div> <p>{{\'CH.INFO.OPERATIONAL_STATUS_DESC\' | translate}}</p> <select name=operationalStatus ng-model=ctrl.state.chargepoint.status ng-change=ctrl.changeOperationalStatus(ctrl.state.chargepoint.status) class=form-control ng-disabled=!ctrl.canAdminChargepoint() ng-options=\"operationalStatus.id as operationalStatus.display for operationalStatus in ctrl.ChargepointHelper.operationalStatuses\"></select> <span class=help ng-show=!ctrl.canAdminChargepoint()>{{\'CH.INFO.OPERATIONAL_STATUS_HELP\' | translate}}</span> </div> </section> <section ng-show=!ctrl.isRoaming()> <span class=header>{{\'CH.INFO.OWNERSHIP\' | translate}}</span> <div> <p>{{\'CH.INFO.OWNERSHIP_DESC\' | translate}}</p> <select name=ownership ng-model=ctrl.state.chargepoint.ownership ng-change=ctrl.changeOwnership(ctrl.state.chargepoint.ownership) class=form-control ng-disabled=!ctrl.canAdminChargepoint() ng-options=\"ownershipType.id as ownershipType.display for ownershipType in ctrl.ChargepointHelper.ownershipTypes\"></select> <span class=help ng-show=!ctrl.canAdminChargepoint()>{{\'CH.INFO.OWNERSHIP_HELP\' | translate}}</span> </div> </section> <section ng-show=\"role.entity === \'provider\' && !ctrl.isRoaming()\"> <span class=header>{{\'CH.INFO.ORGANIZATION\' | translate}}</span> <div> <div ng-show=ctrl.chargepoint.organizationId> <p>{{\'CH.INFO.CURRENTLY_ORGANIZATION_ASSIGNED\' | translate}}<a ui-sref=\"efimob.organizations.item({id: ctrl.chargepoint.organizationId})\">{{ctrl.chargepoint.organizationName}}</a> </p> <button class=\"btn btn-warning\" ng-click=ctrl.askToChangeOrganization() ng-show=\"role.role===\'admin\'\"><i class=\"fal fa-building mr\"></i>{{\'CH.INFO.REASSING\' | translate}}</button> </div> <div ng-show=\"ctrl.chargepoint.organizationId===null\"> <p>{{\'CH.INFO.NO_ORGANIZATION_YET\' | translate}}</p> <button class=\"btn btn-primary\" ng-click=ctrl.askToChangeOrganization() ng-show=\"role.role===\'admin\'\"><i class=\"fal fa-building mr\"></i>{{\'CH.INFO.ASSIGN\' | translate}}</button> </div> </div> </section> <section ng-show=\"ctrl.canAdminChargepoint() && !ctrl.isRoaming()\"> <span class=header>{{\'CH.INFO.REMOVE\' | translate}}</span> <div> <p>{{\'CH.INFO.REMOVE_DESC\' | translate}}</p> <div> <span ng-show=ctrl.isConnected() uib-tooltip=\"{{\'CH.INFO.DISCONNECT_CHARGEPOINT_FIRST\' | translate}}\"><button ng-disabled=true class=\"btn btn-danger\" type=button>{{\'CH.INFO.REMOVE_CHARGEPOINT\' | translate}}</button></span> <button ng-show=!ctrl.isConnected() class=\"btn btn-danger\" type=button ng-click=ctrl.askToRemoveChargepoint()>{{\'CH.INFO.REMOVE_CHARGEPOINT\' | translate}}</button> </div> <span class=help>{{\'CH.INFO.CHARGEPOINT_MUST_BE_DISCONNECTED\' | translate}}</span> </div> </section> </div><!-- CHARGES TAB --> <div ng-show=\"ctrl.tabs.active.id == \'charges\'\"> <section> <p>{{\'CH.CHARGES.CHARGES_DESC\' | translate}}<accent>{{ctrl.chargepoint.name}}</accent> </p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.charges on-reload=ctrl.reloadCharges></widget-filters> </div> <widget-table params=ctrl.tables.charges items=ctrl.charges on-item-click=ctrl.onChargeClick on-reload=ctrl.reloadCharges> </widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'CH.CHARGES.EXPORT_TO_CSV\' | translate}}\" ng-click=ctrl.exportCharges()><i class=\"fal fa-file-export mr\"></i>{{\'CH.CHARGES.EXPORT\' | translate}}</button> </div> </section> </div><!-- TARIFFS TAB --> <div ng-if=\"ctrl.tabs.active.id == \'tariffs\'\"> <section> <p translate=TARIFFS_AVAILABLE_AT_CONNECTORS> </p> <widget-table params=ctrl.tables.connectorTariffs items=ctrl.connectorTariffs> </widget-table> </section> </div><!-- CONF TAB --> <div ng-show=\"ctrl.tabs.active.id == \'conf\' && ctrl.isWebsocket() && !ctrl.isRoaming()\"> <section> <span class=header>{{\'CH.CONF.OCPP_CONFIGURATION\' | translate}}</span> <widget-properties-editor params=ctrl.properties.configuration item=ctrl.configuration> </widget-properties-editor> </section> </div><!-- OCPP MESSAGES TAB --> <div ng-show=\"ctrl.tabs.active.id == \'ocppMessages\' && !ctrl.isRoaming()\"> <section> <p>{{\'CH.AUDITORY.AUDITORY_DESC\' | translate}}<accent>{{ctrl.chargepoint.id}}</accent> </p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.ocppMessages on-reload=ctrl.reloadOcppMessages on-clear-ocpp-pagination=ctrl.clearOcppPagination></widget-filters> </div> <widget-table params=ctrl.tables.ocppMessages items=ctrl.ocppMessages on-reload=ctrl.reloadOcppMessages> </widget-table> <div class=\"text-center mt-m\"> <button class=\"btn btn-link\" ng-if=\"ctrl.ocppMessagesPagination.page>0\" ng-click=ctrl.loadMoreOcppMessages()> {{\'CH.AUDITORY.SEE_MORE\' | translate}} </button> </div> <div class=buttons> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'CH.AUDITORY.EXPORT_TO_CSV\' | translate}}\" ng-click=ctrl.exportOcppMessages()><i class=\"fal fa-file-export mr\"></i>{{\'CH.AUDITORY.EXPORT\' | translate}}</button> </div> </section> </div><!-- FIRMWARE TAB --> <div ng-show=\"ctrl.tabs.active.id == \'firmware\' && !ctrl.isRoaming()\"> <section> <span class=header>{{\'CH.FIRMWARE.CURRENT_VERSION\' | translate}}</span> <widget-properties-editor params=ctrl.properties.firmware item=ctrl.chargepoint> </widget-properties-editor> </section> <section> <p>{{\'CH.FIRMWARE.UPDATE_PROCESS_DESC\' | translate}}</p> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToUpdateFirmware()><i class=\"fal fa-box-alt mr\"></i>{{\'CH.FIRMWARE.UPDATE\' | translate}}</button> </div> <div class=\"result-card mt-m two-parts-line\" type=\"{{ctrl.chargepoint.firmware.updateStatus | asResultType}}\" ng-show=ctrl.chargepoint.firmware> <div class=left-part translate=CH.FIRMWARE.LAST_UPDATE_PROCESS translate-value-date=\"{{ctrl.chargepoint.firmware.lastUpdate | toDate}}\"></div> <div class=right-part> <div ng-show=\"ctrl.chargepoint.firmware.updateStatus===\'Downloading\'\" class=result> {{ctrl.chargepoint.firmware.updateStatus}}<span style=\"margin-right: 30px\" class=\"ml-s spinner\" ng-show=true> <div></div> </span></div> <div ng-show=\"ctrl.chargepoint.firmware.updateStatus===\'DownloadFailed\'\" class=\"result bad\"> {{ctrl.chargepoint.firmware.updateStatus}}</div> <div ng-show=\"ctrl.chargepoint.firmware.updateStatus===\'Downloaded\'\" class=\"result good\"> {{ctrl.chargepoint.firmware.updateStatus}}</div> </div> </div> </section> </div><!-- DIAGNOSTICS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'diagnostics\' && ctrl.isWebsocket() && !ctrl.isRoaming()\"> <section> <p translate=CH.DIAGNOSTICS.DIAGNOSTICS_DESC translate-value-diagnostics=\"<strong>{{\'CH.DIAGNOSTICS.DIAGNOSTICS\' | translate}}</strong>\"></p><!-- <widget-table params=\"tables.diagnostics\" items=\"diagnostics\" on-reload=\"reloadDiagnostics\"></widget-table> --> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToRequestNewDiagnostic()><i class=\"fal fa-file-medical-alt mr\"></i>{{\'CH.DIAGNOSTICS.NEW\' | translate}}</button> </div> <div class=\"result-card mt-m two-parts-line\" type=\"{{ctrl.chargepoint.diagnostics.status | asResultType}}\" ng-show=ctrl.fileName> <div class=left-part translate=DIAGNOSTIC_FILENAME translate-value-name=\"<accent-alt>{{ctrl.fileName}}</accent-alt>\"></div> <div class=right-part> <div ng-show=\"ctrl.chargepoint.diagnostics.status===\'Uploading\'\" class=result> {{ctrl.chargepoint.diagnostics.status}}<span style=\"margin-right: 30px\" class=\"ml-s spinner\" ng-show=true> <div></div> </span></div> <div ng-show=\"ctrl.chargepoint.diagnostics.status===\'UploadFailed\'\" class=\"result bad\"> {{ctrl.chargepoint.diagnostics.status}}</div> <div ng-show=\"ctrl.chargepoint.diagnostics.status===\'Uploaded\'\" class=\"result good\"> {{ctrl.chargepoint.diagnostics.status}}</div> </div> </div> </section> </div><!-- ALARMS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'alarms\' && !ctrl.isRoaming()\"> <section> <div class=wizard> <p translate=CH.ALARMS.ALARMS_DESC translate-value-alarms=\"<b>{{\'CH.ALARMS.ALARMS\'|translate}}</b>\" translate-value-email=\"<accent>{{user.username}}</accent>\"></p> <div class=mt-l> <div ng-repeat=\"(event, alarm) in ctrl.alarms\"> <div class=form-group> <label>{{ctrl.AlarmsService.event[event].label}}</label> <div> <widget-switch model=alarm.value on-change=ctrl.onAlarmChanged on-change-arg=event> </widget-switch> </div> </div> <p class=help>{{ctrl.AlarmsService.event[event].desc}}</p> </div> </div> </div> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/charge-points/charge-points.html","<div id=state-app-chargepoints class=indented-fluid> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters on-reload=ctrl.reload controls=ctrl.filterControls></widget-filters> </div> <widget-table params=ctrl.table items=ctrl.chargepoints on-item-click=ctrl.onChargepointClick on-reload=ctrl.reload on-reload-pagination=ctrl.onReloadPagination> </widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" tooltip-placement=auto uib-tooltip=\"{{\'CPS.EXPORT_AS_CSV\' | translate}}\" ng-click=ctrl.exportChargepoints()><i class=\"fal fa-file-export mr\"></i>{{\'CPS.EXPORT\' | translate}}</button> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'NEW_CP_CHARGEPOINT\' | translate}}\" ng-show=ctrl.isAdmin() ng-click=ctrl.askToAddChargepoint()><i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}}</button> </div> </section> </div>");
$templateCache.put("app/views/charges/charges.html","<div id=state-app-charges class=indented-fluid> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters on-reload=ctrl.reload controls=ctrl.filterControls> </widget-filters> </div> <widget-table params=ctrl.table items=ctrl.charges on-item-click=ctrl.onChargeClick on-reload=ctrl.reload></widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" tooltip-placement=auto uib-tooltip=\"{{\'VIEW_CHARGES.EXPORT_HINT\' | translate}}\" ng-click=ctrl.exportCharges()> <i class=\"fal fa-file-export mr\"></i>{{\'VIEW_CHARGES.EXPORT\' | translate}} </button> </div> </section> </div>");
$templateCache.put("app/views/customer/customer.html","<div id=state-app-customer class=indented-fluid> <div class=panels> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=ctrl.customer></widget-properties-editor> </div> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=main-panel><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'CUSTOMER_VIEW.GENERAL_INFORMATION\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.customer> </widget-properties-editor> </section> <section ng-show=ctrl.canAdminCustomer()> <span class=header>{{\'CONSENTS\' | translate}}</span> <widget-table params=ctrl.tables.customerConsents items=ctrl.consents></widget-table> </section> <section ng-show=ctrl.canAdminCustomer()> <span class=header>{{\'CUSTOMER_VIEW.CONTACT.CONTACT\' | translate}}</span> <widget-properties-editor params=ctrl.properties.contact item=ctrl.customer> </widget-properties-editor> </section> <section ng-show=ctrl.canAdminCustomer()> <span class=header>{{\'CUSTOMER_VIEW.ADDRESS.ADDRESS\' | translate}}</span> <widget-properties-editor params=ctrl.properties.address item=ctrl.customer.address> </widget-properties-editor> </section> <section ng-show=ctrl.canAdminCustomer()> <span class=header>{{\'CUSTOMER_VIEW.UNBLOCK_CUSTOMER\' | translate}}</span> <div> <p translate=CUSTOMER_VIEW.UNBLOCK_CUSTOMER_HOW translate-value-name=\"<accent>{{ctrl.customer.name}}</accent>\"></p> <button class=\"btn btn-warning\" type=button ng-click=ctrl.askToUnblockCustomer()> {{\'CUSTOMER_VIEW.UNBLOCK_DO\' | translate}} </button> </div> </section> <section ng-show=ctrl.canAdminCustomer()> <span class=header>{{\'CUSTOMER_VIEW.REMOVE_CUSTOMER\' | translate}}</span> <div> <p translate=CUSTOMER_VIEW.REMOVE_CUSTOMER_HOW translate-value-name=\"<accent>{{ctrl.customer.name}}</accent>\"></p> <button class=\"btn btn-danger\" type=button ng-click=ctrl.askToRemoveCustomer()> {{\'CUSTOMER_VIEW.REMOVE_CUSTOMER\' | translate}} </button> </div> </section> </div><!-- CHARGES --> <div ng-show=\"ctrl.tabs.active.id == \'charges\'\"> <section> <p translate=CUSTOMER_VIEW.CHARGES translate-value-name=\"<accent>{{ctrl.customer.name}}</accent>\"></p> <widget-table params=ctrl.tables.charges items=ctrl.charges on-item-click=ctrl.onChargeClick on-reload=ctrl.reloadCharges></widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" tooltip-placement=auto uib-tooltip=\"{{\'EXPORT_CHARGES_TO_FILE\' | translate}}\" ng-click=ctrl.exportCharges()> <i class=\"fal fa-file-export mr\"></i>{{\'EXPORT_CSV\' | translate}} </button> </div> </section> </div><!-- USERKEYS --> <div ng-show=\"ctrl.tabs.active.id == \'userkeys\'\"> <section> <p translate=CUSTOMER_VIEW.USERKEYS.ASSIGNED_USERKEYS translate-value-name=\"<accent>{{ctrl.customer.name}}</accent>\"></p> <widget-table params=ctrl.tables.userkeys items=ctrl.userkeys on-item-click=ctrl.onUserkeyClick on-reload=ctrl.reloadUserkeys></widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'CUSTOMER_VIEW.USERKEYS.NEW_KEY\' | translate }}\" ng-click=ctrl.askToAddUserkey()><i class=\"fal fa-plus mr\"></i>{{\'CUSTOMER_VIEW.USERKEYS.ADD\' | translate }}</button> </div> </section> </div><!-- PAYMENTS --> <div ng-show=\"ctrl.tabs.active.id == \'payments\'\"> <section> <p translate=CUSTOMER_VIEW.ASSIGNED_PAYMENTS translate-value-name=\"<accent>{{ctrl.customer.name}}</accent>\"></p> <widget-table params=ctrl.tables.payments items=ctrl.payments on-reload=ctrl.reloadPayments></widget-table> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/customers/customers.html","<div id=state-app-customers class=indented-fluid> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters on-reload=ctrl.reload controls=ctrl.filterControls></widget-filters> </div> <widget-table params=ctrl.table items=ctrl.customers on-item-click=ctrl.onCustomerClick on-reload=ctrl.reload> </widget-table> <div class=buttons><!-- <button class=\"btn btn-outline-primary\" uib-tooltip=\"Exportar clientes a un fichero .csv\" ng-click=\"exportCustomers()\"><i class=\"fal fa-file-export mr\"></i>Exportar</button> --> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'CUSTOMERS.NEW_CUSTOMER\' | translate}}\" ng-click=ctrl.askToAddCustomer()> <i class=\"fal fa-plus mr\"></i>{{\'CUSTOMERS.ADD\' | translate}} </button> </div> </section> </div>");
$templateCache.put("app/views/dashboard/dashboard.html","<div id=state-app-dashboard class=indented-fluid> <div class=top-right-message> <span ng-show=ctrl.state.autoReload.timer>{{\'DASHBOARD.AUTORELOAD.AUTORELOAD\' | translate}}: {{ctrl.state.autoReload.options[ctrl.state.autoReload.currentIdx].display}}</span> </div> <div class=cards><!-- GLOBAL MINI CARDS (organizations)--> <div class=cards-section ng-show=\"ctrl.organization!==null\"> <div class=cards-section-intro><i class=\"fal fa-boxes-alt\"></i><span>{{\'DASHBOARD.TOTAL.TOTAL_AGGREGATED\' | translate}}</span></div> <a ui-sref=\"efimob.chargepoints.at.list({\'organization\': ctrl.organization})\" class=mini-card> <div class=data>{{ctrl.data.cards.totalChargepoints | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-charging-station mr\"></i>{{\'DASHBOARD.TOTAL.CHARGEPOINTS\' | translate}}</div> </a> <a ui-sref=\"efimob.charges.at.list({\'organization\': ctrl.organization})\" class=mini-card> <div class=data>{{ctrl.data.cards.totalCharges | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-battery-bolt mr\"></i>{{\'DASHBOARD.TOTAL.CHARGES\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalDuration | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-user-clock mr\"></i>{{\'DASHBOARD.TOTAL.IN_USE_HOURS\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalMeter | kWh | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-bolt mr\"></i><span translate=DASHBOARD.TOTAL.KWH_CHARGED translate-value-kwh=kWh></span></div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalEffectiveDuration | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-stopwatch mr\"></i>{{\'DASHBOARD.TOTAL.CHARGING_HOURS\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalMeter | cO2Saved | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-leaf mr\"></i><span translate=DASHBOARD.TOTAL.KGCO2_SAVED translate-value-kgco2=\"kgCO<sub>2</sub>\"></span></div> </a> </div><!-- GLOBAL MINI CARDS (providers)--> <div class=cards-section ng-show=\"ctrl.organization===null\"> <div class=cards-section-intro><i class=\"fal fa-boxes-alt\"></i><span>{{\'DASHBOARD.TOTAL.TOTAL_AGGREGATED\' | translate}}</span></div> <a ui-sref=efimob.organizations.list class=mini-card> <div class=data>{{ctrl.data.cards.totalOrganizations | number}}</div> <div class=subtitle><i class=\"fal fa-{{App.icon[\'organization\']}} mr\"></i>{{\'DASHBOARD.TOTAL.ORGANIZATIONS\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalChargepoints | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-charging-station mr\"></i>{{\'DASHBOARD.TOTAL.CHARGEPOINTS\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalCharges | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-battery-bolt mr\"></i>{{\'DASHBOARD.TOTAL.CHARGES\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalDuration | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-user-clock mr\"></i>{{\'DASHBOARD.TOTAL.IN_USE_HOURS\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalMeter | kWh | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-bolt mr\"></i><span translate=DASHBOARD.TOTAL.KWH_CHARGED translate-value-kwh=kWh></span></div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalEffectiveDuration | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-stopwatch mr\"></i>{{\'DASHBOARD.TOTAL.CHARGING_HOURS\' | translate}}</div> </a> <a class=\"mini-card no-pointer\"> <div class=data>{{ctrl.data.cards.totalMeter | cO2Saved | bigNumber}}</div> <div class=subtitle><i class=\"fal fa-leaf mr\"></i><span translate=DASHBOARD.TOTAL.KGCO2_SAVED translate-value-kgco2=\"kgCO<sub>2</sub>\"></span></div> </a> </div><!-- CHARGEPOINTS --> <div class=cards-section> <div class=cards-section-intro> <i class=\"fal fa-{{App.icon[\'chargepoint\']}}\"></i> <span>{{\'DASHBOARD.CHARGEPOINTS.CHARGEPOINTS\' | translate}}</span> <div ng-show=\"ctrl.organization===null\" class=mt-m> <widget-selector model=ctrl.state.chargepointsProviderView params=ctrl.chargepointsProviderViewSelector> </widget-selector> </div> </div> <div ng-show=\"ctrl.organization===null\" class=chart-card> <span class=card-title>{{\'DASHBOARD.CHARGEPOINTS.BY_ORGANIZATION\' | translate}}</span> <div class=\"chart chart-300\"> <chart-pie data=ctrl.data.charts.chargepointsByOrganizationPie params=ctrl.charts.chargepointsByOrganizationPie></chart-pie> </div> </div> <div class=chart-card> <span class=card-title>{{\'DASHBOARD.CHARGEPOINTS.BY_CONNECTED_STATUS\' | translate}}</span> <div class=\"chart chart-300\"> <chart-pie data=ctrl.data.charts.chargepointsConnectedPie params=ctrl.charts.chargepointsConnectedPie> </chart-pie> </div> </div> <div class=chart-card> <span class=card-title>{{\'DASHBOARD.CHARGEPOINTS.BY_CONNECTORS_STATUS\' | translate}}</span> <div class=\"chart chart-300\"> <chart-pie data=ctrl.data.charts.connectorsStatusPie params=ctrl.charts.connectorsStatusPie> </chart-pie> </div> </div> <div ng-show=ctrl.organization class=chart-card> <span class=card-title>{{\'DASHBOARD.CHARGEPOINTS.BY_GEOLOCATION\' | translate}}</span> <div class=\"chart chart-300\"> <div style=\"width: 100%; height: 300px\"> <widget-map params=ctrl.maps.groups items=ctrl.data.flattenedGroups on-item-click=ctrl.onGroupClick> </widget-map> </div> </div> </div> </div><!-- CHARGES --> <div ng-show=ctrl.organization class=cards-section> <div class=cards-section-intro> <i class=\"fal fa-{{App.icon[\'charge\']}}\"></i> <span>{{\'DASHBOARD.CHARGES.CHARGES\' | translate}}</span> <div class=mt-m> <widget-selector model=ctrl.state.chargesPeriod params=ctrl.chargesPeriodSelector> </widget-selector> </div> </div> <div class=\"mini-card one-to-four\"><a href={{ctrl.data.cards.hrefChargesInPeriod}}> <div class=data>{{ctrl.data.cards.totalChargesInPeriod | number}}</div> <div class=subtitle><i class=\"fal fa-battery-bolt mr\"></i>{{\'DASHBOARD.CHARGES.CHARGES_DURING_PERIOD\' | translate}}<span style=\"text-transform: lowercase\">{{ctrl.getChargePeriodById(ctrl.state.chargesPeriod).display}}</span> </div> </a></div> <div class=\"chart-card two-to-four\"> <span class=card-title>{{ctrl.getChargePeriodById(ctrl.state.chargesPeriod).display}}</span> <div style=\"width: calc(100% + 10px)\"> <widget-table params=ctrl.tables.lastCharges items=ctrl.data.tables.lastCharges on-item-click=ctrl.onChargeClick on-reload=ctrl.reloadChargesInPeriod></widget-table> </div> </div> </div><!-- ALARMS CARDS --> <div class=cards-section> <div class=cards-section-intro><i class=\"fal fa-exclamation-square\"></i><span>{{\'DASHBOARD.ALARMS.ALARMS\' | translate}}</span></div> <div class=chart-card> <span class=card-title>{{\'DASHBOARD.ALARMS.LAST_DISCONNECTED_CHARGEPOINTS\' | translate}}</span> <widget-table params=ctrl.tables.disconnectedChargepoints items=ctrl.data.tables.disconnectedChargepoints on-item-click=ctrl.onChargepointClick on-reload=ctrl.reloadDisconnectedChargepoints></widget-table> </div> <div class=chart-card> <span class=card-title>{{\'DASHBOARD.ALARMS.LAST_CHARGEPOINTS_OUT_OF_SERVICE\' | translate}}</span> <widget-table params=ctrl.tables.unavailableChargepoints items=ctrl.data.tables.unavailableChargepoints on-item-click=ctrl.onChargepointClick on-reload=ctrl.reloadUnavailableChargepoints></widget-table> </div> </div> </div> </div>");
$templateCache.put("app/views/forgot-password/forgot-password.html","<div id=state-forgot-password class=\"fullscreen center\"> <div class=login-box> <div class=branding> <div class=branding-logo> <div></div> </div> <h2>{{ENV.APP.NAME}}</h2> </div> <h5>{{\'FORGOT_PWD.NO_PROBLEM\' | translate}}</h5> <p class=neutral>{{\'FORGOT_PWD.AN_EMAIL_WILL_BE_SENT\' | translate}}</p> <form novalidate> <div class=form-group> <label>{{\'FORGOT_PWD.EMAIL\' | translate}}</label> <input name=email type=text class=form-control ng-model=ctrl.username> <span class=help>{{\'FORGOT_PWD.EMAIL_HELP\' | translate}}</span> </div> <div class=\"buttons align-right\"> <button class=\"right-part btn btn-light active\" ng-click=ctrl.forgotPassword()><i class=\"fal fa-envelope mr\"></i>{{\'FORGOT_PWD.DO_RESET_PASSWORD\' | translate}}</button> </div> <div class=\"buttons align-right\"> <a ui-sref=login class=small-text><i class=\"fal fa-sign-in-alt mr\"></i>{{\'FORGOT_PWD.I_RECALL\' | translate}}</a> </div> </form> <div class=login-footer> <a href=https://www.efimob.com translate=FORGOT_PWD.DEVELOPED_BY translate-value-efimob=\"<strong>Efimob</strong>\"></a> </div> </div> </div>");
$templateCache.put("app/views/group/group.html","<div id=state-app-group class=indented-fluid> <div class=panels> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=ctrl.group></widget-properties-editor> </div> <div class=main-panel><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'GROUP_INFO_GENERAL_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.group> </widget-properties-editor> </section> <section> <span class=header>{{\'MAINTAINERS\' | translate}}</span> <div> <widget-table params=ctrl.tables.maintainers items=ctrl.maintainers on-reload=ctrl.reloadMaintainers> </widget-table> <div class=buttons ng-show=\"ctrl.isAdminOfOrganization() || ctrl.isProvider()\"> <button class=\"btn btn-primary\" ng-click=ctrl.askToAssignMaintainer()> <i class=\"fal fa-plus mr\"></i>{{\'ASSIGN\' | translate}} </button> </div> </div> </section> <section> <span class=header>{{\'GROUP_INFO_LOCATION\' | translate}}</span> <div> <div ng-hide=ctrl.GroupsHelper.hasPosition(ctrl.group)> <span>{{\'GROUP_INFO_GROUP_WITHOUT_LOCATION\' | translate}}</span> <div class=buttons ng-hide=\"ctrl.GroupsService.checkPurpose(\'roaming\', ctrl.group)\"> <button class=\"btn btn-primary\" ng-click=ctrl.editLocation()> <i class=\"fal fa-map-marker-alt mr\"></i>{{\'GROUP_INFO_ADD_LOCATION\' | translate}} </button> </div> <span class=help ng-hide=\"ctrl.GroupsService.checkPurpose(\'roaming\', ctrl.group)\"> {{\'GROUP_INFO_PLEASE_ADD_LOCATION_IF_ANY\' | translate}} </span> </div> <div ng-show=ctrl.GroupsHelper.hasPosition(ctrl.group)> <div ng-show=ctrl.GroupsHelper.hasPosition(ctrl.group) style=\"height: 300px\"> <widget-map params=ctrl.map items=[ctrl.group] options=ctrl.map></widget-map> </div> <div class=buttons ng-hide=\"ctrl.GroupsService.checkPurpose(\'roaming\', ctrl.group)\"> <button class=\"btn btn-outline-primary\" ng-click=ctrl.editLocation()> <i class=\"fal fa-map-marker-alt mr\"></i> {{\'GROUP_INFO_CHANGE_LOCATION\' | translate}} </button> <button class=\"btn btn-outline-danger\" ng-click=ctrl.removeLocation() ng-disabled=ctrl.GroupsHelper.hasChargepoints(ctrl.group)> <i class=\"fal fa-map-marker-times mr\"></i> {{\'GROUP_INFO_REMOVE_LOCATION\' | translate}} </button> </div> <span ng-show=ctrl.GroupsHelper.hasChargepoints(ctrl.group) class=\"help warning\"> {{\'GROUP_INFO_REMOVE_LOCATION_BANNED\' | translate}} </span> </div> </div> </section> <section ng-if=\"ctrl.group.isAtomic && !ctrl.group.roamingId\"> <span class=header>{{\'MANUAL_ACTIVATION\' | translate}}</span> <div class=section-switch> <div class=form-group> <label>{{\'ENABLE_MANUAL_ACTIVATION\' | translate}}<span uib-tooltip=\"{{\'MANUAL_ACTIVATION_HINT\' | translate}}\" class=info-hint></span></label> <div> <widget-switch model=ctrl.state.manualActivation disabled=ctrl.group.hasProxyChargepoint loading=ctrl.state.loading.manualActivation on-change=ctrl.onManualActivationChanged> </widget-switch> </div> </div> </div> </section> <section ng-show=ctrl.group.isAtomic> <span class=header>{{\'GROUP_INFO_RESERVATION_QUEUES\' | translate}}</span> <div class=section-switch> <div class=form-group> <label>{{\'GROUP_INFO_RESERVATION_QUEUES_ENABLED\' | translate}}<span uib-tooltip=\"{{\'GROUP_INFO_RESERVATION_QUEUES_ENABLED_HINT\' | translate}}\" class=info-hint></span></label> <div> <widget-switch model=ctrl.state.reservationQueue loading=ctrl.state.loading.reservationQueue on-change=ctrl.onReservationQueueEnabledChanged></widget-switch> </div> </div> </div> <div ng-show=ctrl.state.reservationQueue> <div class=\"form-group margin-left-40\"> <widget-properties-editor params=ctrl.properties.reservationQueue item=ctrl.group></widget-properties-editor> </div> </div> </section> <section> <span class=header>{{\'GROUP_VISIBILITY\' | translate}}</span> <div class=section-switch> <div class=form-group> <label>{{\'GROUP_VISIBILITY_ENABLED\' | translate}}<span uib-tooltip=\"{{\'GROUP_VISIBILITY_ENABLED_HINT\' | translate}}\" class=info-hint></span></label> <div> <widget-switch model=ctrl.state.isPublic loading=ctrl.state.loading.isPublic on-change=ctrl.onIsPublicChanged></widget-switch> </div> </div> </div> </section> <section> <span class=header>{{\'PRIVATE_USERS_MANAGEMENT\' | translate}}</span> <div class=section-switch> <div class=form-group> <widget-properties-editor params=ctrl.properties.privateUsers item=ctrl.group></widget-properties-editor> <span ng-show=ctrl.group.isAtomic class=\"help warning\"> {{\'PRIVATE_USERS_WARN\' | translate}} </span> </div> </div> </section> <section> <span class=header>{{\'ACTION.EDIT_NO_MANAGED.NO_MANAGED_CHARGERPOINTS\' | translate}}</span> <div> <div> <p>{{\'ACTION.EDIT_NO_MANAGED.INTRO\' | translate}}</p> <div class=subsection> <div class=subsection-left> <select class=form-control ng-model=ctrl.state.noManagedLanguage ng-options=\"lang.id as lang.display for lang in ctrl.languages\"></select> <div class=help> <span ng-show=\"ctrl.getNoManagedLanguagesSet() == 0\">{{\'ACTION.EDIT_NO_MANAGED.NO_SET_FOR_GROUP\' | translate}}</span> <span translate=ACTION.EDIT_NO_MANAGED.X_OUT_OF_Y_LANGS_SET ng-show=\"ctrl.getNoManagedLanguagesSet() > 0\" ng-class=\"{\'warning\': (ctrl.getNoManagedLanguagesSet() < ctrl.languages.length), \'good\': (ctrl.getNoManagedLanguagesSet() == ctrl.languages.length) }\" translate-value-x={{ctrl.getNoManagedLanguagesSet()}} translate-value-y={{ctrl.languages.length}}></span> </div> </div> <div class=subsection-right> <widget-properties-editor params=ctrl.properties.noManagedInfo item=ctrl.group.noManagedInfo></widget-properties-editor> <div class=buttons> <button class=\"btn btn-outline-primary\" ng-click=ctrl.askToEditNoManagedChargepoints()><i class=\"fal fa-edit mr\"></i>{{\'ACTION.EDIT_NO_MANAGED.EDIT\' | translate}} </button> </div> </div> </div> </div> </div> </section> <section ng-show=ctrl.group.isAtomic> <span class=header>{{\'GROUP_INFO_ADDRESS\' | translate}}</span> <div> <div ng-hide=\"ctrl.GroupsHelper.hasAddress(ctrl.group) || ctrl.properties.address.controls.onEdition\"> <span>{{\'GROUP_INFO_NO_ADDRESS_SUPPLIED\' | translate}}</span> <div class=buttons ng-hide=\"ctrl.GroupsService.checkPurpose(\'roaming\', ctrl.group)\"> <button class=\"btn btn-outline-secondary\" ng-click=ctrl.addAddress()> <i class=\"fal fa-map-signs mr\"></i> {{\'GROUP_INFO_ADD_ADDRESS\' | translate}} </button> </div> </div> <div ng-show=\"ctrl.GroupsHelper.hasAddress(ctrl.group) || ctrl.properties.address.controls.onEdition\"> <widget-properties-editor params=ctrl.properties.address item=ctrl.group.location> </widget-properties-editor> </div> </div> </section> <section ng-show=ctrl.group.isAtomic> <span class=header>{{\'GROUPS_ENERGY\' | translate}}</span> <div> <div ng-show=ctrl.hasEnergy(ctrl.group)> <div class=form-group> <label class=font-weight-700>{{\'GROUPS_GREEN_ENERGY\' | translate}}</label> <div> {{ctrl.group.energy_mix.is_green_energy ? (\'COMMON.YES\' | translate) : (\'COMMON.NO\' | translate)}} </div> </div> <div class=form-group> <label class=font-weight-700>{{\'GROUPS_SOURCES\' | translate}}</label> <div>{{ctrl.group.energy_mix.sources | objectArrayToString:\'source\':\'percentage\':\'%\'}}</div> </div> <div class=form-group> <label class=font-weight-700>{{\'GROUPS_ENVIRONMENTAL_IMPACT\' | translate}}</label> <div>{{ctrl.group.energy_mix.environmental_impact | objectArrayToString:\'category\':\'amount\'}}</div> </div> <div class=form-group> <label class=font-weight-700>{{\'GROUPS_SUPPLIER_NAME\' | translate}}</label> <div> {{ctrl.group.energy_mix.supplier_name}} <i ng-hide=ctrl.group.energy_mix.supplier_name class=muted>{{\'GROUPS_NO_DESCRIPTION\' | translate}}</i> </div> </div> <div class=form-group> <label class=font-weight-700>{{\'GROUPS_ENERGY_PRODUCT_NAME\' | translate}}</label> <div> {{ctrl.group.energy_mix.energy_product_name}} <i ng-hide=ctrl.group.energy_mix.energy_product_name class=muted>{{\'GROUPS_NO_DESCRIPTION\' | translate}}</i> </div> </div> <div> <button class=\"btn btn-outline-secondary\" ng-click=ctrl.editEnergy()> <i class=\"fal fa-edit mr\"></i> {{\'EDIT_ENERGY\' | translate}} </button> </div> </div> <div class=buttons ng-hide=ctrl.hasEnergy(ctrl.group)> <button class=\"btn btn-outline-secondary\" ng-click=ctrl.editEnergy()> <i class=\"fal fa-plus mr\"></i> {{\'ADD_ENERGY\' | translate}} </button> </div> </div> </section> <section ng-show=ctrl.group.isAtomic> <span class=header>{{\'OPENING_HOURS\' | translate}}</span> <div> <div ng-show=ctrl.hasOpeningTimes(ctrl.group)> <div class=form-group> <label class=font-weight-700>{{\'TWENTYFOURSEVEN\' | translate}}</label> <div> {{ctrl.group.opening_times.twentyfourseven ? (\'COMMON.YES\' | translate) : (\'COMMON.NO\' | translate)}} </div> </div> <div class=form-group ng-hide=ctrl.group.opening_times.twentyfourseven> <label class=font-weight-700>{{\'REGULAR_HOURS\' | translate}}</label> <div>{{ctrl.group.opening_times.regular_hours | toDateTimeOcpi}}</div> </div> <div> <button class=\"btn btn-outline-secondary\" ng-click=ctrl.editOpeningHours()> <i class=\"fal fa-edit mr\"></i> {{\'EDIT_REGULAR_HOURS\' | translate}} </button> </div> </div> <div class=buttons ng-hide=ctrl.hasOpeningTimes(ctrl.group)> <button class=\"btn btn-outline-secondary\" ng-click=ctrl.editOpeningHours()> <i class=\"fal fa-plus mr\"></i> {{\'ADD_OPENING_HOURS\' | translate}} </button> </div> </div> </section> </div><!-- CHARGES TAB --> <div ng-if=\"ctrl.tabs.active.id == \'charges\'\"> <section> <p translate=GROUP_CHARGES_CHARGES_AT_GROUP translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.charges on-reload=ctrl.reloadCharges></widget-filters> </div> <widget-table params=ctrl.tables.charges items=ctrl.charges on-item-click=ctrl.onChargeClick on-reload=ctrl.reloadCharges></widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'GROUP_CHARGES_EXPORT_TO_CSV\' | translate}}\" ng-click=ctrl.exportCharges()><i class=\"fal fa-file-export mr\"></i>{{\'GROUP_CHARGES_EXPORT\' | translate}} </button> </div> </section> </div><!-- CHARGEPOINTS TAB --> <div ng-if=\"ctrl.tabs.active.id == \'chargepoints\'\"> <section> <p translate=GROUP_CHARGEPOINTS_CHARGEPOINTS_AT_GROUP translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.chargepoints on-reload=ctrl.reloadChargepoints> </widget-filters> </div> <widget-table params=ctrl.tables.chargepoints items=ctrl.chargepoints on-item-click=ctrl.onChargepointClick on-reload=ctrl.reloadChargepoints></widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'NEW_CP_CHARGEPOINT\' | translate}}\" ng-show=\"ctrl.isAdmin() && ctrl.hasParent() && ctrl.group.isAtomic\" ng-click=ctrl.askToAddChargepoint()> <i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}} </button> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'EXPORT_TO_CSV\' | translate}}\" ng-click=ctrl.exportChargepoints()> <i class=\"fal fa-file-export mr\"></i>{{\'EXPORT_CSV\' | translate}} </button> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'EXPORT_TO_JSON\' | translate}}\" ng-click=ctrl.exportChargePointsToJson()> <i class=\"fal fa-file-export mr\"></i>{{\'EXPORT_JSON\' | translate}} </button> </div> </section> <section> <span class=header>{{\'GROUP_PROGRAM_REBOOT\' | translate}}</span> <widget-table class=margin-left-0 params=ctrl.tables.chargepointsWithProgramedReboots items=ctrl.chargepointsWithProgramedReboots> </widget-table> </section> </div><!-- USERKEYS TAB --> <div ng-if=\"ctrl.tabs.active.id == \'userkeys\'\"> <section> <p translate=GROUP_USERKEYS_USERKEYS_AT_GROUP translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.userkeys on-reload=ctrl.reloadUserkeys></widget-filters> </div> <widget-table params=ctrl.tables.userkeys items=ctrl.userkeys on-item-click=ctrl.onUserkeyClick on-reload=ctrl.reloadUserkeys></widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'EXPORT_KEYS_TO_CSV_FILE\' | translate}}\" ng-click=ctrl.exportUserkeys()> <i class=\"fal fa-file-export mr\"></i>{{\'EXPORT_CSV\' | translate}} </button> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'NEW_KEY\' | translate}}\" ng-show=ctrl.isAdmin() ng-click=ctrl.askToAddUserkey()> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate}} </button> </div> </section> </div><!-- TARIFFS TAB --> <div ng-if=\"ctrl.tabs.active.id == \'tariffs\'\"> <section> <p translate=GROUP_TARIFFS_TARIFFS_AT_GROUP translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.tariffs on-reload=ctrl.reloadTariffs></widget-filters> </div> <widget-table params=ctrl.tables.tariffs items=ctrl.tariffs on-reload=ctrl.reloadTariffs on-item-click=ctrl.upsertTariff> </widget-table> <div class=buttons> <button ng-show=ctrl.isAdmin() class=\"btn btn-primary\" uib-tooltip=\"{{\'GROUP_TARIFFS_ADD_NEW_TARIFF\' | translate}}\" ng-click=ctrl.upsertTariff()><i class=\"fal fa-plus mr\"></i>{{\'GROUP_TARIFFS_ADD_TARIFF\' | translate}} </button> </div> </section> </div><!-- MARGINS TAB --> <div ng-if=\"ctrl.tabs.active.id == \'margins\'\"> <section> <p translate=MARGINS_AVAILABLE_FOR translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.margins on-reload=ctrl.reloadMargins></widget-filters> </div> <widget-table params=ctrl.tables.margins items=ctrl.margins on-reload=ctrl.reloadMargins> </widget-table> <div class=buttons> <button ng-show=ctrl.isAdmin() class=\"btn btn-primary\" ng-click=ctrl.createMargin()> <i class=\"fal fa-plus mr\"></i>{{\'ADD_MARGIN\' | translate}} </button> </div> </section> </div><!-- ROLES TAB --> <div ng-if=\"ctrl.tabs.active.id == \'roles\'\"> <section> <p translate=GROUP_ROLES_ROLES_AT_GROUP translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <widget-table params=ctrl.tables.roles items=ctrl.roles on-reload=ctrl.reloadRoles> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{ctrl.$translate.instant(\'GROUP_ROLES_ADD_ROLE_FOR\', {name: ctrl.group.name})}}\" ng-click=ctrl.askToAddRole()><i class=\"fal fa-plus mr\"></i>{{\'GROUP_ROLES_ADD_ROLE\' | translate}} </button> </div> </section> </div><!-- OPERATIONS --> <div ng-if=\"ctrl.tabs.active.id == \'operations\'\"> <section> <p translate=LOCATION_OPERATIONS_IN translate-value-name=\"<accent>{{ctrl.group.name | safe}}</accent>\"></p> <widget-table params=ctrl.tables.operations items=ctrl.operations on-reload=ctrl.reloadOperations> </widget-table> <div class=buttons ng-show=ctrl.isProvider()> <button class=\"btn btn-primary\" ng-click=ctrl.addOperation()> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate}} </button> </div> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/groups/groups.html","<div id=state-app-groups class=indented-fluid> <p ng-if=!ctrl.group translate=GROUPS_GROUPS_ADMIN_BY_ORGANIZATION translate-value-organization=\"<accent>{{ctrl.organization | organizationName}}</accent>\"></p> <p ng-if=ctrl.group translate=GROUPS_GROUPS_ADMIN_BY_GROUP translate-value-organization=\"<accent>{{ctrl.organization | organizationName}}</accent>\" translate-value-group=\"<accent>{{ctrl.group | groupName}}</accent>\"></p> <div class=two-columns> <div class=\"a-column mr-s\"> <widget-tree params=ctrl.tree items=ctrl.groups on-item-click=ctrl.onGroupClick></widget-tree> </div> <div class=a-column> <widget-map params=ctrl.map items=ctrl.flattenedGroups on-item-click=ctrl.onGroupClick></widget-map> </div> </div> </div>");
$templateCache.put("app/views/header/header.html","<div class=\"two-parts-line vertical-center\"> <div class=\"left-part vertical-center\"> <a class=vertical-center ng-click=ctrl.App.toggleMenu() tooltip-placement=bottom-left uib-tooltip=\"{{(ctrl.App.menu.closed? (\'HEADER.SHOW_MENU\' | translate) : (\'HEADER.HIDE_MENU\' | translate))}}\"> <i class=\"fal fa-bars\"></i> </a> <a class=vertical-center ng-show=\"ctrl.App.back.stack.length > 0\" ng-click=$event.preventDefault();ctrl.App.goBack() href={{ctrl.App.back.stack[ctrl.App.back.stack.length-1].href}} uib-tooltip=\"{{(\'HEADER.BACK_TO_PAGE\' | translate) + ctrl.App.back.stack[ctrl.App.back.stack.length-1].data.display}}\"> <i class=\"fal fa-arrow-left\"></i><span>{{\'HEADER.BACK\'| translate}}</span> </a> </div> <div class=\"right-part vertical-center\"> <div ng-show=\"ENV.ID != \'production\'\" id=env><a tooltip-placement=bottom uib-tooltip=\"{{\'HEADER.YOU_ARE_WORKING_HERE\'| translate}}\" href={{ENV.URL}}/version target=_blank class=\"vertical-center mr-m\"><i class=\"fal fa-flask\"></i><span class=uppercase>{{ ENV.NAME }}</span></a></div> <a ng-if=\"roles.length > 1\" class=\"vertical-center chevron-down\" uib-popover-template=\"\'popover-role.html\'\" popover-placement=bottom-right popover-popup-delay=0 popover-is-open=ctrl.App.roleMenu.open popover-trigger=\"\'outsideClick\'\"><span bind-html-compile=\"role | identity\"></span></a> <a ng-if=\"roles.length==1\" class=\"vertical-center mr-m\"><span bind-html-compile=\"role | identity\"></span></a> <a class=\"vertical-center chevron-down\" uib-popover-template=\"\'popover-user.html\'\" popover-placement=bottom-right popover-popup-delay=0 popover-is-open=ctrl.userMenu.open popover-trigger=\"\'outsideClick\'\"><span><i class=\"fal fa-user\"></i>{{user.displayName}}</span></a> </div> </div> <script type=text/ng-template id=popover-role.html><ul id=\"role-menu\" class=\"popover-list\" ng-click=\"ctrl.App.closeRoleMenu()\">\n        <li ng-repeat=\"role in roles\" class=\"nowrap\">\n          <a ng-click=\"ctrl.setchangeCurrentRole(role);\" bind-html-compile=\"role | identity\"></a>\n        </li>\n    </ul></script> <script type=text/ng-template id=popover-user.html><ul id=\"user-menu\" class=\"popover-list\" ng-click=\"ctrl.closeUserMenu()\">\n      <li><a ui-sref=\"efimob.profile\" ui-sref-opts=\"{reload: \'efimob.profile\'}\" class=\"nowrap\"><i class=\"fal fa-user-cog mr\"></i>{{\'HEADER.MY_PROFILE\'| translate}}</a></li>\n      <li><a href=\"#\" ng-click=\"Auth.logout();\" class=\"nowrap\"><i class=\"fal fa-sign-out-alt mr\"></i>{{\'HEADER.LOGOUT\'| translate}}</a></li>\n    </ul></script>");
$templateCache.put("app/views/left/left.html","<div id=branding> <a ng-if=App.menu.closed class=logo-layers ui-sref=efimob.home ui-sref-opts=\"{reload: \'efimob.home\'}\" style=\"width: 60px;height: 60px;position: relative\"> <div class=close-layer></div> </a> <a ng-if=!App.menu.closed class=logo-layers ui-sref=efimob.home ui-sref-opts=\"{reload: \'efimob.home\'}\" style=\"width: 188px;height: 60px;position: relative\"> <div class=open-layer></div> </a> <a class=project-name ui-sref=efimob.home ui-sref-opts=\"{reload: \'efimob.home\'}\"> <h2>{{ENV.APP.NAME}}</h2> </a> </div><!-- FOR ORGANIZATIONS --> <ul id=menu ng-if=\"role.entity === \'organization\'\"><!-- DASHBOARD --> <li><a ui-sref=efimob.dashboard ui-sref-opts=\"{reload: \'efimob.dashboard\'}\" ui-sref-active-eq=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'dashboard\']}} mr\"></i>{{\'LEFT.DASHBOARD\' | translate}}</a> </li><!-- ZONAS --> <li><a ui-sref=\"efimob.groups({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.groups\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'group\']}} mr\"></i>{{\'LEFT.GROUPS\' | translate}}</a> </li><!-- LOCATIONS --> <li><a ui-sref=\"efimob.locations({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.locations\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'location\']}} mr\"></i>{{\'LOCATIONS\' | translate}}</a> </li><!-- PUNTOS --> <li><a ui-sref=\"efimob.chargepoints.at({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.chargepoints.at\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'chargepoint\']}} mr\"></i>{{\'LEFT.CHARGEPOINTS\' | translate}}</a></li><!-- RECARGAS --> <li><a ui-sref=\"efimob.charges.at({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.charges.at\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'charge\']}} mr\"></i>{{\'LEFT.CHARGES\' | translate}}</a> </li><!-- LLAVES --> <li><a ui-sref=\"efimob.userkeys.at({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.userkeys.at\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'userkey\']}} mr\"></i>{{\'LEFT.USERKEYS\' | translate}}</a> </li><!-- CLIENTES --> <li><a ui-sref=\"efimob.customers({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.customers\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'customer\']}} mr\"></i>{{\'LEFT.CUSTOMERS\' | translate}}</a></li><!-- TARIFFS --> <li><a ui-sref=\"efimob.tariffs({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.tariffs\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'tariff\']}} mr\"></i>{{\'TARIFFS\' | translate}}</a> </li><!-- AGREEMENTS --> <li><a ui-sref=\"efimob.agreements({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.agreements\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'agreement\']}} mr\"></i>{{\'INTEROPERABILITY\' | translate}}</a> </li><!-- EMPRESA --> <li><a ui-sref=\"efimob.organizations.item({id: role.organization})\" ui-sref-opts=\"{reload: \'efimob.organizations.item\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'organization\']}} mr\"></i>{{\'LEFT.ORGANIZATION\' | translate}}</a></li> </ul><!-- FOR GROUPS --> <ul id=menu ng-if=\"role.entity === \'group\'\"><!-- DASHBOARD --> <li><a ui-sref=efimob.dashboard ui-sref-opts=\"{reload: \'efimob.dashboard\'}\" ui-sref-active-eq=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'dashboard\']}} mr\"></i>{{\'LEFT.DASHBOARD\' | translate}}</a> </li><!-- ZONAS --> <li><a ui-sref=\"efimob.groups({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.groups\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'group\']}} mr\"></i>{{\'LEFT.GROUPS\' | translate}}</a> </li><!-- LOCATIONS --> <li><a ui-sref=\"efimob.locations({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.locations\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'location\']}} mr\"></i>{{\'LOCATIONS\' | translate}}</a> </li><!-- PUNTOS --> <li><a ui-sref=\"efimob.chargepoints.at({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.chargepoints.at\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'chargepoint\']}} mr\"></i>{{\'LEFT.CHARGEPOINTS\' | translate}}</a></li><!-- RECARGAS --> <li><a ui-sref=\"efimob.charges.at({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.charges.at\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'charge\']}} mr\"></i>{{\'LEFT.CHARGES\' | translate}}</a> </li><!-- LLAVES --> <li><a ui-sref=\"efimob.userkeys.at({organization: role.organization})\" ui-sref-opts=\"{reload: \'efimob.userkeys.at\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'userkey\']}} mr\"></i>{{\'LEFT.VALID_USERKEYS\' | translate}}</a></li> </ul><!-- FOR PROVIDER --> <ul id=menu ng-if=\"role.entity === \'provider\'\"><!-- DASHBOARD --> <li><a ui-sref=efimob.dashboard ui-sref-opts=\"{reload: \'efimob.dashboard\'}\" ui-sref-active-eq=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'dashboard\']}} mr\"></i>{{\'LEFT.DASHBOARD\' | translate}}</a> </li><!-- ZONAS --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.groups\'), \'active-submenu\':App.submenu.groups.open}\" open-submenu=groups uib-popover-template=\"\'submenu-groups.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.groups.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'group\']}} mr\"></i>{{\'LEFT.GROUPS\' | translate}}</a> </li> <script type=text/ng-template id=submenu-groups.html><ul class=\"popover-list\" submenu=\"groups\">\n      <li><a class=\"chevron-right\"\n             open-submenu=\"groups-organizations\"\n             uib-popover-template=\"\'submenu-groups-organizations.html\'\"\n             popover-append-to-body=\"true\"\n             popover-placement=\"auto right-top\"\n             popover-popup-delay=\"0\"\n             popover-is-open=\"App.submenu[\'groups-organizations\'].open\"\n             popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}</a></li>\n      <li ng-if=\"providerOrganization\"><a ui-sref=\"efimob.groups({\'organization\': providerOrganization})\"\n                                          ui-sref-opts=\"{reload: \'efimob.groups\'}\"\n                                          ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}</a>\n      </li>\n    </ul></script> <script type=text/ng-template id=submenu-groups-organizations.html><div class=\"popover-scroll\" submenu=\"groups-organizations\">\n      <ul class=\"popover-list\">\n        <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n          ui-sref=\"efimob.groups({\'organization\': organization.id})\"\n          ui-sref-opts=\"{reload: \'efimob.groups\'}\">{{organization.name}}</a></li>\n      </ul>\n    </div></script><!-- LOCATIONS --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.locations\'), \'active-submenu\':App.submenu.locations.open}\" open-submenu=locations uib-popover-template=\"\'submenu-locations.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.locations.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'location\']}} mr\"></i>{{\'LOCATIONS\' | translate}} </a> </li> <script type=text/ng-template id=submenu-locations.html><ul class=\"popover-list\" submenu=\"locations\">\n      <li>\n        <a class=\"chevron-right\"\n           open-submenu=\"locations-organizations\"\n           uib-popover-template=\"\'submenu-locations-organizations.html\'\"\n           popover-append-to-body=\"true\"\n           popover-placement=\"auto right-top\"\n           popover-popup-delay=\"0\"\n           popover-is-open=\"App.submenu[\'locations-organizations\'].open\"\n           popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}\n        </a>\n      </li>\n      <li ng-if=\"providerOrganization\">\n        <a ui-sref=\"efimob.locations({\'organization\': providerOrganization})\"\n           ui-sref-opts=\"{reload: \'efimob.locations\'}\"\n           ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}\n        </a>\n      </li>\n    </ul></script> <script type=text/ng-template id=submenu-locations-organizations.html><div class=\"popover-scroll\" submenu=\"locations-organizations\">\n      <ul class=\"popover-list\">\n        <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n          ui-sref=\"efimob.locations({\'organization\': organization.id})\"\n          ui-sref-opts=\"{reload: \'efimob.locations\'}\">{{organization.name}}</a></li>\n      </ul>\n    </div></script><!-- PUNTOS --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.chargepoints\'), \'active-submenu\':App.submenu.chargepoints.open}\" open-submenu=chargepoints uib-popover-template=\"\'submenu-chargepoints.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.chargepoints.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'chargepoint\']}} mr\"></i>{{\'LEFT.CHARGEPOINTS\' | translate}}</a> </li> <script type=text/ng-template id=submenu-chargepoints.html><ul class=\"popover-list\" submenu=\"chargepoints\">\n      <li><a class=\"chevron-right\"\n             open-submenu=\"chargepoints-organizations\"\n             uib-popover-template=\"\'submenu-chargepoints-organizations.html\'\"\n             popover-append-to-body=\"true\"\n             popover-placement=\"auto right-top\"\n             popover-popup-delay=\"0\"\n             popover-is-open=\"App.submenu[\'chargepoints-organizations\'].open\"\n             popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}</a></li>\n      <li ng-if=\"providerOrganization\"><a ui-sref=\"efimob.chargepoints.at({\'organization\': providerOrganization})\"\n                                          ui-sref-opts=\"{reload: \'efimob.chargepoints.at\'}\"\n                                          ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}</a>\n      </li>\n    </ul></script> <script type=text/ng-template id=submenu-chargepoints-organizations.html><div class=\"popover-scroll\" submenu=\"chargepoints-organizations\">\n      <ul class=\"popover-list\">\n        <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n          ui-sref=\"efimob.chargepoints.at({\'organization\': organization.id})\"\n          ui-sref-opts=\"{reload: \'efimob.chargepoints.at\'}\">{{organization.name}}</a></li>\n      </ul>\n    </div></script><!-- RECARGAS --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.charges\'), \'active-submenu\':App.submenu.charges.open}\" open-submenu=charges uib-popover-template=\"\'submenu-charges.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.charges.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'charge\']}} mr\"></i>{{\'LEFT.CHARGES\' | translate}}</a> </li> <script type=text/ng-template id=submenu-charges.html><ul class=\"popover-list\" submenu=\"charges\">\n      <li><a class=\"chevron-right\"\n             open-submenu=\"charges-organizations\"\n             uib-popover-template=\"\'submenu-charges-organizations.html\'\"\n             popover-append-to-body=\"true\"\n             popover-placement=\"auto right-top\"\n             popover-popup-delay=\"0\"\n             popover-is-open=\"App.submenu[\'charges-organizations\'].open\"\n             popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}</a></li>\n      <li ng-if=\"providerOrganization\"><a ui-sref=\"efimob.charges.at({\'organization\': providerOrganization})\"\n                                          ui-sref-opts=\"{reload: \'efimob.charges.at\'}\"\n                                          ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}</a>\n      </li>\n    </ul></script> <script type=text/ng-template id=submenu-charges-organizations.html><div class=\"popover-scroll\" submenu=\"charges-organizations\">\n      <ul class=\"popover-list\">\n        <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n          ui-sref=\"efimob.charges.at({\'organization\': organization.id})\"\n          ui-sref-opts=\"{reload: \'efimob.charges.at\'}\">{{organization.name}}</a></li>\n      </ul>\n    </div></script><!-- LLAVES --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.userkeys\'), \'active-submenu\':App.submenu.userkeys.open}\" open-submenu=userkeys uib-popover-template=\"\'submenu-userkeys.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.userkeys.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'userkey\']}} mr\"></i>{{\'LEFT.USERKEYS\' | translate}}</a> </li> <script type=text/ng-template id=submenu-userkeys.html><ul class=\"popover-list\" submenu=\"userkeys\">\n      <li><a class=\"chevron-right\"\n             open-submenu=\"userkeys-organizations\"\n             uib-popover-template=\"\'submenu-userkeys-organizations.html\'\"\n             popover-append-to-body=\"true\"\n             popover-placement=\"auto right-top\"\n             popover-popup-delay=\"0\"\n             popover-is-open=\"App.submenu[\'userkeys-organizations\'].open\"\n             popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}</a></li>\n      <li ng-if=\"providerOrganization\"><a ui-sref=\"efimob.userkeys.at({\'organization\': providerOrganization})\"\n                                          ui-sref-opts=\"{reload: \'efimob.userkeys.at\'}\"\n                                          ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}</a>\n      </li>\n    </ul></script> <script type=text/ng-template id=submenu-userkeys-organizations.html><div class=\"popover-scroll\" submenu=\"userkeys-organizations\">\n      <ul class=\"popover-list\">\n        <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n          ui-sref=\"efimob.userkeys.at({\'organization\': organization.id})\" ui-sref-opts=\"{reload: \'efimob.userkeys.at\'}\">{{organization.name}}</a>\n        </li>\n      </ul>\n    </div></script><!-- CLIENTES --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.customers\'), \'active-submenu\':App.submenu.customers.open}\" open-submenu=customers uib-popover-template=\"\'submenu-customers.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.customers.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'customer\']}} mr\"></i>{{\'LEFT.CUSTOMERS\' | translate}}</a> </li> <script type=text/ng-template id=submenu-customers.html><ul class=\"popover-list\" submenu=\"customers\">\n      <li><a class=\"chevron-right\"\n             open-submenu=\"customers-organizations\"\n             uib-popover-template=\"\'submenu-customers-organizations.html\'\"\n             popover-append-to-body=\"true\"\n             popover-placement=\"auto right-top\"\n             popover-popup-delay=\"0\"\n             popover-is-open=\"App.submenu[\'customers-organizations\'].open\"\n             popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}</a></li>\n      <li ng-if=\"providerOrganization\"><a ui-sref=\"efimob.customers({\'organization\': providerOrganization})\"\n                                          ui-sref-opts=\"{reload: \'efimob.customers\'}\"\n                                          ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}</a>\n      </li>\n    </ul></script> <script type=text/ng-template id=submenu-customers-organizations.html><div class=\"popover-scroll\" submenu=\"customers-organizations\">\n      <ul class=\"popover-list\">\n        <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n          ui-sref=\"efimob.customers({\'organization\': organization.id})\"\n          ui-sref-opts=\"{reload: \'efimob.customers\'}\">{{organization.name}}</a></li>\n      </ul>\n    </div></script><!-- TARIFFS --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.tariffs\'), \'active-submenu\':App.submenu.tariffs.open}\" open-submenu=tariffs uib-popover-template=\"\'submenu-tariffs.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.tariffs.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'tariff\']}} mr\"></i>{{\'TARIFFS\' | translate}} </a> </li> <script type=text/ng-template id=submenu-tariffs.html><ul class=\"popover-list\" submenu=\"tariffs\">\n    <li>\n      <a class=\"chevron-right\"\n        open-submenu=\"tariffs-organizations\"\n        uib-popover-template=\"\'submenu-tariffs-organizations.html\'\"\n        popover-append-to-body=\"true\"\n        popover-placement=\"auto right-top\"\n        popover-popup-delay=\"0\"\n        popover-is-open=\"App.submenu[\'tariffs-organizations\'].open\"\n        popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}\n      </a>\n    </li>\n    <li ng-if=\"providerOrganization\">\n      <a ui-sref=\"efimob.tariffs({\'organization\': providerOrganization})\"\n        ui-sref-opts=\"{reload: \'efimob.tariffs\'}\"\n        ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}\n      </a>\n    </li>\n  </ul></script><!-- AGREEMENTS --> <li> <a class=chevron-right ng-class=\"{\'active\': $state.includes(\'efimob.agreements\'), \'active-submenu\':App.submenu.agreements.open}\" open-submenu=agreements uib-popover-template=\"\'submenu-agreements.html\'\" popover-animation=false popover-class=submenu popover-append-to-body=true popover-placement=\"auto right\" popover-is-open=App.submenu.agreements.open popover-popup-delay=0 popover-trigger=\"\'outsideClick\'\"><i class=\"fal fa-{{App.icon[\'agreement\']}} mr\"></i>{{\'INTEROPERABILITY\' | translate}} </a> </li> <script type=text/ng-template id=submenu-agreements.html><ul class=\"popover-list\" submenu=\"agreements\">\n    <li>\n      <a class=\"chevron-right\"\n         open-submenu=\"agreements-organizations\"\n         uib-popover-template=\"\'submenu-agreements-organizations.html\'\"\n         popover-append-to-body=\"true\"\n         popover-placement=\"auto right-top\"\n         popover-popup-delay=\"0\"\n         popover-is-open=\"App.submenu[\'agreements-organizations\'].open\"\n         popover-trigger=\"\'outsideClick\'\">{{\'LEFT.BY_ORGANIZATION\' | translate}}\n      </a>\n    </li>\n    <li ng-if=\"providerOrganization\">\n      <a ui-sref=\"efimob.agreements({\'organization\': providerOrganization})\"\n         ui-sref-opts=\"{reload: \'efimob.agreements\'}\"\n         ui-sref-active=\"active\">{{Cache.organization[providerOrganization].name}}\n      </a>\n    </li>\n  </ul></script><!-- EMPRESAS --> <li> <a ui-sref=efimob.organizations ui-sref-opts=\"{reload: \'efimob.organizations\'}\" ui-sref-active=active data-toggle=collapse-anyway> <i class=\"fal fa-{{App.icon[\'organization\']}} mr\"></i>{{\'LEFT.ORGANIZATIONS\' | translate}} </a> </li> <script type=text/ng-template id=submenu-tariffs-organizations.html><div class=\"popover-scroll\" submenu=\"tariffs-organizations\">\n    <ul class=\"popover-list\">\n      <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n        ui-sref=\"efimob.tariffs({\'organization\': organization.id})\"\n        ui-sref-opts=\"{reload: \'efimob.tariffs\'}\">{{organization.name}}</a></li>\n    </ul>\n  </div></script> <script type=text/ng-template id=submenu-agreements-organizations.html><div class=\"popover-scroll\" submenu=\"agreements-organizations\">\n    <ul class=\"popover-list\">\n      <li ng-repeat=\"organization in Cache.organization | sortedOrganizations\" class=\"nowrap\"><a\n        ui-sref=\"efimob.agreements({\'organization\': organization.id})\"\n        ui-sref-opts=\"{reload: \'efimob.agreements\'}\">{{organization.name}}</a></li>\n    </ul>\n  </div></script><!-- SETTINGS --> <li><a ui-sref=efimob.settings ui-sref-opts=\"{reload: \'efimob.settings\'}\" ui-sref-active=active data-toggle=collapse-anyway><i class=\"fal fa-{{App.icon[\'settings\']}} mr\"></i>{{\'LEFT.SETTINGS\' | translate}}</a> </li> </ul> <div id=arrow-image></div> <div id=footer-version ng-if=!App.menu.closed> <span>Front: {{ctrl.frontVersion}} - API: {{ctrl.apiVersion}}</span> </div>");
$templateCache.put("app/views/locations/locations.html","<div id=state-app-locations class=indented-fluid> <section> <locations-table-component data=ctrl.locationTableData api=ctrl.locationTableApi on-click-location=ctrl.onClickLocation> </locations-table-component> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.addLocation() ng-show=ctrl.canAddLocation> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate }} </button> </div> </section> </div>");
$templateCache.put("app/views/login/login.html","<div id=state-login class=\"fullscreen center\"> <div class=login-box> <div class=branding> <div class=branding-logo> <div></div> </div> <h2>{{ENV.APP.NAME}}</h2> </div> <form novalidate> <div class=form-group> <input name=email type=text class=form-control ng-model=ctrl.user.username placeholder=email> </div> <div class=form-group> <input name=password type=password class=form-control ng-model=ctrl.user.password placeholder=contraseña autocomplete=password> <a ui-sref=forgot-password class=small-text>{{\'LOGIN.FORGOT_PASSWORD\' | translate}}</a> </div> <div class=form-group ng-show=ctrl.authcode.status> <input name=authcode type=text class=form-control ng-model=ctrl.authcode.value placeholder=\"{{\'LOGIN.AUTHCODE_PLACEHOLDER\' | translate}}\"> <span class=help>{{\'LOGIN.AUTHCODE_HELP\' | translate}}</span><br> <span class=help>{{\'LOGIN.AUTHCODE_HELP_EXTENDED\' | translate}}</span> </div> <div ng-show=ctrl.captcha.status class=mt-m> <span class=warning>{{\'LOGIN.ENTER_CAPTCHA\' | translate}}</span><img src={{ctrl.captcha.data}}> <div class=form-group> <input name=captcha type=text class=form-control ng-model=ctrl.captcha.solution> <span class=help>{{\'LOGIN.CAPTCHA_HELP\' | translate}}</span> </div> </div> <div class=\"buttons align-right\"> <button class=\"right-part btn btn-primary\" ng-click=ctrl.login()><i class=\"fal fa-sign-in-alt mr\"></i>{{\'LOGIN.DO_LOGIN\' | translate}}</button> </div> <div class=\"buttons align-right\"> </div> </form> <div class=login-footer> <p>{{\'LOGIN.VERSION\' | translate}}: {{ctrl.frontVersion}}</p> </div> </div> </div>");
$templateCache.put("app/views/modals/add-banner.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{modal.isEdit? (\'ACTION.ADD_BANNER.EDIT_BANNER\' | translate) : (\'ACTION.ADD_BANNER.ADD_BANNER\' | translate)}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form id=modal-tariffs novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'options\'\"> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.TYPE\' | translate}}</label> <select name=type ng-model=modal.banner.type class=form-control ng-options=\"type.id as type.display for type in modal.types\" ng-change=modal.updateType()> </select> </div> <div ng-show=!modal.isUndefined(modal.banner.url) class=form-group> <label>{{\'ACTION.ADD_BANNER.URL\' | translate}}</label> <input name=url ng-blur=modal.validateUrl(modal.banner.url) my-enter=modal.validateUrl(modal.banner.url) ng-model=modal.banner.url type=text class=form-control> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.DISMISS\' | translate}}</label> <div> <widget-switch model=modal.banner.dismiss></widget-switch> </div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.FROM\' | translate}}</label> <div class=input-group> <input id=input-fromDate type=text class=form-control ng-blur=\"modal.validateDate(\'fromDate\', modal.fromDate.date)\" my-enter=\"modal.validateDate(\'fromDate\', modal.fromDate.date)\" ng-model=modal.fromDate.date ng-model-options=\"{allowInvalid: false}\" uib-datepicker-popup=\"d MMM yyyy HH:mm\" on-open-focus=false is-open=modal.fromDate.open datepicker-options=modal.fromDate.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.fromDate.open=!modal.fromDate.open\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.TO\' | translate}}</label> <div class=input-group> <input id=input-toDate type=text class=form-control ng-blur=\"modal.validateDate(\'toDate\', modal.toDate.date)\" my-enter=\"modal.validateDate(\'toDate\', modal.toDate.date)\" ng-model=modal.toDate.date uib-datepicker-popup=\"d MMM yyyy HH:mm\" on-open-focus=false is-open=modal.toDate.open datepicker-options=modal.toDate.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.toDate.open=!modal.toDate.open\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <div ng-show=modal.conflict class=\"help colophon bottom-0\"> <div class=danger> <i class=\"fal fa-ban mr\"></i> <span translate=ACTION.ADD_BANNER.INVALID_OPTION translate-value-name=\"<accent>{{modal.conflict.name}}</accent>\"></span> </div> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'message\'\"> <div class=form-group> <label>{{\'COMMON.LANG\' | translate}}</label> <select class=form-control ng-model=modal.lang.option ng-options=\"option.id as option.display for option in modal.lang.options\"></select> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.TITLE\' | translate}}</label> <input name=title ng-model=modal.banner.title[modal.lang.option] type=text class=form-control> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.BODY\' | translate}}</label> <textarea rows=4 cols=50 name=body class=\"form-control margin-right-40\" ng-model=modal.banner.body[modal.lang.option]></textarea> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.TYPE\' | translate}}</label> <div>{{modal.banner.type | capitalize}}</div> </div> <div ng-show=!modal.isUndefined(modal.banner.url) class=form-group> <label>{{\'ACTION.ADD_BANNER.URL\' | translate}}</label> <div>{{modal.banner.url}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.DISMISS\' | translate}}</label> <div>{{modal.banner.dismiss | boolean}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.FROM\' | translate}}</label> <div>{{modal.banner.fromDate | toDate}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.TO\' | translate}}</label> <div>{{modal.banner.toDate | toDate}}</div> </div> <div class=form-group> <label>{{\'COMMON.LANGS\' | translate}}</label> <div>{{modal.banner.title | adaptLangsToString}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.TITLE\' | translate}}</label> <div>{{modal.banner.title.es}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_BANNER.BODY\' | translate}}</label> <div class=\"modal-resume-text pre-wrap\">{{modal.banner.body.es}}</div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=\"modal.unbindWatchers(); App.closeModal()\">{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);>{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);>{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i ng-hide=modal.isEdit class=\"fal fa-plus mr\"></i> <span>{{modal.isEdit? (\'ACTION.ADD_BANNER.DO_EDIT\' | translate) : (\'ACTION.ADD_BANNER.DO_ADD\' | translate)}}</span> </button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"> <div class=infinite-progress></div> </div> </div>");
$templateCache.put("app/views/modals/add-chargepoint.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'NEW_CP_CHARGEPOINT\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'ownership\'\"> <div class=form-group> <label>{{\'NEW_CP_OWNERSHIP_TYPE\' | translate}}</label> <select name=ownership ng-model=modal.chargepoint.ownership class=form-control ng-options=\"ownershipType.id as ownershipType.display for ownershipType in modal.ownershipTypes\"></select> </div> <p class=help ng-if=\"modal.chargepoint.ownership===\'public\'\">{{\'NEW_CP_OWNERSHIP_PUBLIC_HELP\' | translate}}</p> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'serialOCPP\'\"> <div class=form-group> <label>{{\'NEW_CP_SERIAL_OCPP\' | translate}}</label> <input name=serialOCPP ng-model=modal.chargepoint.serialOCPP type=text class=form-control> </div> <p class=help>{{\'NEW_CP_SERIAL_OCPP_HELP\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'NEW_CP_ASK_PROVIDER_FOR_MORE_INFO\' | translate}} </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'name\'\"> <div class=form-group> <label>{{\'NEW_CP_NAME\' | translate}}</label> <input name=name ng-model=modal.chargepoint.name type=text class=form-control auto-select-all autofocus> </div> <p class=help translate=NEW_CP_NAME_HELP translate-value-exampleone=\"<i>{{modal.organizationId}}_003</i>\" translate-value-exampletwo=\"<i>Alcalá 231</i>\" translate-value-examplethree=\"<i>Plaza 3A</i>\"></p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i> <span translate=NEW_CP_ADDING_CHARGEPOINT_WITH_SERIAL translate-value-serial=\"<accent>{{modal.chargepoint.serialOCPP}}</accent>\"></span> </div> <div class=form-group> <label>{{\'NEW_CP_VEHICLE_TYPE\' | translate}}</label> <select name=vehicleType ng-model=modal.chargepoint.vehicleType class=form-control ng-options=\"type as type.display for type in modal.vehicleTypes\"></select> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'NEW_CP_OWNERSHIP_TYPE\' | translate}}</label> <div>{{modal.chargepoint.ownership | chargepointOwnership}}</div> </div> <div class=form-group> <label>{{\'NEW_CP_SERIAL_OCPP\' | translate}}</label> <div>{{modal.chargepoint.serialOCPP}}</div> </div> <div class=form-group> <label>{{\'NEW_CP_NAME\' | translate}}</label> <div>{{modal.chargepoint.name}}</div> </div> <div class=form-group> <label>{{\'NEW_CP_VEHICLE_TYPE\' | translate}}</label> <div>{{modal.chargepoint.vehicleType.display}}</div> </div> <div class=form-group ng-show=modal.organizationId> <label>{{\'NEW_CP_GROUP\' | translate}}</label> <div> <a ng-show=!modal.createGroup ui-sref=\"efimob.groups.item({id: modal.chargepoint.group.id, organization: modal.organizationId})\">{{modal.chargepoint.group.name}}</a> <div ng-show=modal.createGroup>{{modal.chargepoint.group.name}} <span class=warning>{{\'NEW_CP_GROUP_WILL_BE_CREATED_DURING_OPERATION\' | translate}}</span> </div> </div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'NEW_CP_ADD_CHARGEPOINT\' | translate}} </button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"> <div class=infinite-progress></div> </div> </div>");
$templateCache.put("app/views/modals/add-customer.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'CUSTOMERS.NEW_CUSTOMER\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'name\'\"> <div class=form-group> <label>{{\'CUSTOMERS.NAME\' | translate}}</label> <input name=name ng-model=modal.customer.name type=text class=form-control> </div> <p class=help>{{\'CUSTOMERS.MODAL.NAME_HELP\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'CUSTOMERS.MODAL.BIND_LATER\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'recap\'\"> <div class=form-group> <label>{{\'CUSTOMERS.NAME\' | translate}}</label> <div>{{modal.customer.name}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!modal.isValid(modal) ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!modal.isValid(modal) ng-click=modal.done()><i class=\"fal fa-plus mr\"></i>{{\'CUSTOMERS.MODAL.ADD_CUSTOMER\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/add-forced-closure-data.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index + 1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'CHARGE.FORCE_CLOSURE_CHARGE\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'forceClosure\'\"> <div class=form-group> <label>{{\'CHARGE.MODAL.DATA.STOP_DATA_TIME\' | translate}}</label> <input type=datetime-local name=stopDateTime ng-model=modal.dataClose.stopDateTime class=form-control> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'forceClosure\'\"> <div class=form-group> <label>{{\'APP.HEADER.CHARGES.METER\' | translate}} (kW)</label> <input type=number name=meter ng-model=modal.dataClose.meter class=form-control> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'CHARGE.MODAL.BIND_LATER\' | translate}}</div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!modal.isValid(modal) ng-click=modal.done()><i class=\"fal fa-plus mr\"></i>{{\'CHARGE.MODAL.SEND_FORCE_CLOSURE_CHARGE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/add-group.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{modal.group.parentGroupId? (\'GROUPS_ADD_GROUP_NEW_SUBGROUP\' | translate) : (\'GROUPS_ADD_GROUP_NEW_GROUP\' | translate)}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form id=modal-add-group novalidate> <div class=intro bind-html-compile=modal.wizard.steps[modal.wizard.step].intro></div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'name\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <input name=name ng-model=modal.group.name type=text class=form-control autofocus> </div> <p class=help translate=GROUPS_ADD_GROUP_NAME_HELP translate-value-example1=\"<i>Parking Plaza Mayor</i>\" translate-value-example2=\"<i>Madrid ciudad</i>\" translate-value-example3=\"<i>Zona norte</i>\"></p> <div class=form-group> <label>{{\'GROUPS_ADD_GROUP_DESC\' | translate}}</label> <input name=desc ng-model=modal.group.desc type=text class=form-control> </div> <div class=form-group> <label>{{\'ATOMIC\' | translate}}</label> <widget-switch model=modal.group.isAtomic on-change=modal.reviewSteps on-change-arg=\"\'location\'\"> </widget-switch> </div> <div class=\"help colophon\"> <i class=\"fal fa-info mr\"></i> {{\'GROUPS_ADD_GROUP_A_GROUP_IS\' | translate}} </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <div> <div class=form-group> <div style=\"display: flex;margin-right: unset\"> <div style=\"flex: 1; min-height: 360px\"> <widget-map params=modal.map></widget-map> </div> </div> </div> <div class=form-group> <div style=\"display: inline-flex; align-items: baseline;margin-right: unset\"> <span class=mr-s>{{\'GROUPS_ADD_GROUP_LATITUDE\' | translate}}</span> <input name=latitude ng-model=modal.location.latitude type=number class=form-control> <span class=\"ml-m mr-s\">{{\'GROUPS_ADD_GROUP_LONGITUDE\' | translate}}</span> <input name=longitude ng-model=modal.location.longitude type=number class=form-control> </div> </div> </div> <div class=help><i class=\"fal fa-eye mr\"></i>{{\'GROUPS_ADD_GROUP_DRAG_POINTER\' | translate}} </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'address\'\"> <div class=form-group> <label>{{\'GROUP_PROPS_ADDRESS\' | translate}}</label> <input name=address ng-model=modal.location.address type=text class=form-control> </div> <div class=form-group> <label>{{\'GROUP_PROPS_CITY\' | translate}}</label> <input name=city ng-model=modal.location.city type=text class=form-control> </div> <div class=form-group> <label>{{\'GROUP_PROPS_POSTAL_CODE\' | translate}}</label> <input name=postalCode ng-model=modal.location.postalCode type=text class=form-control> </div> <div class=form-group> <label>{{\'GROUP_PROPS_COUNTRY\' | translate}}</label> <select-component item=modal.selectedCountry items=modal.countryCodes field=\"\'display\'\" style=\"width:calc(100% - 260px)\"> </select-component> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'energy\'\"> <div class=\"form-group mt-l\"> <label>{{\'GROUPS_ENERGY\' | translate}}</label> <div> <widget-switch model=modal.isEnergy></widget-switch> </div> </div> <div ng-show=modal.isEnergy> <div class=form-group> <label>{{\'GROUPS_GREEN_ENERGY\' | translate}}</label> <div> <widget-switch model=modal.energy.is_green_energy on-change=modal.validateIsGreenEnergy></widget-switch> </div> </div> <div class=form-group> <label>{{\'GROUPS_SOURCES\' | translate}}</label> <select-with-input-component list=modal.energy.sources list-options=modal.sourcesOptions first-item=\"\'source\'\" second-item=\"\'percentage\'\" second-item-unit=\"\'percentage\'\" on-select-change=modal.validateSelect on-input-change=modal.validateInput class=full-width> </select-with-input-component> </div> <div class=form-group> <label>{{\'GROUPS_ENVIRONMENTAL_IMPACT\' | translate}}</label> <select-with-input-component list=modal.energy.environmental_impact list-options=modal.impactOptions first-item=\"\'category\'\" second-item=\"\'amount\'\" second-item-unit=\"\'kg/MWh\'\" min=0 max=9999999999 on-select-change=modal.validateSelect class=full-width> </select-with-input-component> </div> <div class=form-group> <label>{{\'GROUPS_SUPPLIER_NAME\' | translate}}</label> <input name=supplierName ng-model=modal.energy.supplier_name type=text class=form-control> </div> <div class=form-group> <label>{{\'GROUPS_ENERGY_PRODUCT_NAME\' | translate}}</label> <input name=energyProductName ng-model=modal.energy.energy_product_name type=text class=form-control> </div> <div ng-show=\"modal.conflict.repeat || modal.conflict.counter || modal.conflict.green\" class=\"help colophon\"> <div ng-if=modal.conflict.repeat class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.repeatText | translate}}</span> </div> <div ng-if=\"!modal.conflict.repeat && modal.conflict.counter\" class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.counterText | translate}}</span> </div> <div ng-if=\"!modal.conflict.repeat && !modal.conflict.counter && modal.conflict.green\" class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.greenText | translate}}</span> </div> </div> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <div>{{modal.group.name}}</div> </div> <div class=form-group> <label>{{\'GROUPS_ADD_GROUP_DESC\' | translate}}</label> <div> {{modal.group.desc}} <i ng-hide=modal.group.desc class=muted>{{\'GROUPS_NO_DESCRIPTION\' | translate}}</i> </div> </div> <div class=form-group> <label>{{\'GROUPS_ADD_GROUP_GEOLOCATED\' | translate}}</label> <div>{{modal.group.isAtomic ? (\'COMMON.YES\' | translate) : (\'COMMON.NO\' | translate)}} <span class=\"ml-s small neutral\" ng-show=modal.group.isAtomic translate=GROUPS_ADD_GROUP_GEOLOCATION_SUMMARY translate-value-latitude=\"{{modal.location.latitude | number:16}}\" translate-value-longitude=\"{{modal.location.longitude | number:16}}\"></span> </div> </div><!-- Address --> <div ng-show=modal.group.isAtomic> <div class=form-group> <label>{{\'GROUP_PROPS_ADDRESS\' | translate}}</label> <div>{{modal.location.address ? modal.location.address : \'--\'}}</div> </div> <div class=form-group> <label>{{\'GROUP_PROPS_CITY\' | translate}}</label> <div>{{modal.location.city ? modal.location.city : \'--\'}}</div> </div> <div class=form-group> <label>{{\'GROUP_PROPS_POSTAL_CODE\' | translate}}</label> <div>{{modal.location.postalCode ? modal.location.postalCode : \'--\'}}</div> </div> <div class=form-group> <label>{{\'GROUP_PROPS_COUNTRY\' | translate}}</label> <div>{{modal.selectedCountry ? modal.selectedCountry.display : \'--\'}}</div> </div> </div><!-- !Address --> <div class=form-group> <label>{{\'GROUPS_ENERGY\' | translate}}</label> <div>{{modal.isEnergy? (\'COMMON.YES\' | translate) : (\'COMMON.NO\' | translate)}}</div> </div> <div ng-show=modal.isEnergy class=form-group> <label>{{\'GROUPS_GREEN_ENERGY\' | translate}}</label> <div>{{modal.energy.is_green_energy? (\'COMMON.YES\' | translate) : (\'COMMON.NO\' | translate)}}</div> </div> <div ng-show=modal.isEnergy class=form-group> <label>{{\'GROUPS_SOURCES\' | translate}}</label> <div>{{modal.energy.sources | objectArrayToString:\'source\':\'percentage\':\'%\'}}</div> </div> <div ng-show=modal.isEnergy class=form-group> <label>{{\'GROUPS_ENVIRONMENTAL_IMPACT\' | translate}}</label> <div>{{modal.energy.environmental_impact | objectArrayToString:\'category\':\'amount\'}}</div> </div> <div ng-show=modal.isEnergy class=form-group> <label>{{\'GROUPS_SUPPLIER_NAME\' | translate}}</label> <div> {{modal.energy.supplier_name}} <i ng-hide=modal.energy.supplier_name class=muted>{{\'GROUPS_NO_DESCRIPTION\' | translate}}</i> </div> </div> <div ng-show=modal.isEnergy class=form-group> <label>{{\'GROUPS_ENERGY_PRODUCT_NAME\' | translate}}</label> <div> {{modal.energy.energy_product_name}} <i ng-hide=modal.energy.energy_product_name class=muted>{{\'GROUPS_NO_DESCRIPTION\' | translate}}</i> </div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal)> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal)> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done();> <i class=\"fal fa-plus mr\"></i> <span>{{modal.group.parentGroupId? (\'GROUPS_ADD_GROUP_ADD_SUBGROUP\' | translate) : (\'GROUPS_ADD_GROUP_ADD_GROUP\' | translate)}}</span> </button> </div>");
$templateCache.put("app/views/modals/add-operation-to-location.html","<div class=modal-header> <h3 class=modal-title translate=ASSIGN_OPERATION> </h3> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'operation\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <select-component item=modal.operation items=modal.operations custom-display=modal.display on-search=modal.onSearch search style=\"min-width: 50%\"> </select-component> </div> <p class=help>{{\'LIST_OF_OPERATIONS\' | translate}}</p> <p class=\"help danger\" ng-show=modal.error> <i class=\"fal fa-ban mr\"></i> <span>{{\'OPERATION_ALREADY_ASSIGNED\' | translate}}</span> </p> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'OPERATION\' | translate}}</label> <div>{{modal.operation.name}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.done(modal)> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/add-organization.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'ORGANIZATIONS.NEW\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'id\'\"> <div class=form-group> <label>{{\'ORGANIZATIONS.MODAL.ID\' | translate}}</label> <input name=id ng-model=modal.organization.id type=text class=form-control required> </div> <p class=help> <span translate=ORGANIZATIONS.MODAL.ID_HELP_1 translate-value-separator=\"<i class=&quot;bold&quot;>-</i>\"></span> <br> <span translate=ORGANIZATIONS.MODAL.ID_HELP_2 translate-value-google=\"<i>google</i>\" translate-value-cocacola=\"<i>coca-cola</i>\" translate-value-amazon=\"<i>amazon</i>\"></span> </p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'ORGANIZATIONS.MODAL.SET_NAME_LATER\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'info\'\"> <div class=form-group> <label>{{\'ORGANIZATIONS.MODAL.NAME\' | translate}}</label> <input name=name ng-model=modal.organization.name type=text class=form-control auto-select-all autofocus required> </div> <p class=help>{{\'ORGANIZATIONS.MODAL.NAME_HELP\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=ORGANIZATIONS.MODAL.ADDING_WITH_ID translate-value-id=\"<accent>{{modal.organization.id}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'contact\'\"> <div class=form-group> <label>{{\'ORGANIZATIONS.MODAL.ADMIN\' | translate}}</label> <input name=contact ng-model=modal.organization.contact type=email class=form-control autofocus required> </div> <p class=help>{{\'ORGANIZATIONS.MODAL.ADMIN_HELP_1\' | translate}}<br>{{\'ORGANIZATIONS.MODAL.ADMIN_HELP_2\' | translate}}</p><!-- <div class=\"form-group\">\n          <label>¿Crear también usuario?</label>\n          <div><widget-switch model=\"modal.alsoCreateAdminRole\"></widget-switch></div>\n        </div>\n        <p class=\"help\">\n          <span ng-show=\"modal.alsoCreateAdminRole === true\">Enviaremos un email para avisarle<br>Tendrá permisos de administrador en <accent>{{modal.organization.name}}</accent></span>\n          <span ng-show=\"modal.alsoCreateAdminRole === false\">Podrá crear usuarios en <accent>{{modal.organization.name}}</accent> más adelante</span>\n        </p> --> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=ORGANIZATIONS.MODAL.ADDING_WITH_ID translate-value-id=\"<accent>{{modal.organization.id}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'recap\'\"> <div class=form-group> <label>{{\'ORGANIZATIONS.MODAL.ID\' | translate}}</label> <div>{{modal.organization.id}}</div> </div> <div class=form-group> <label>{{\'ORGANIZATIONS.MODAL.NAME\' | translate}}</label> <div>{{modal.organization.name}}</div> </div> <div class=form-group> <label>{{\'ORGANIZATIONS.MODAL.ADMIN\' | translate}}</label> <div>{{modal.organization.contact}}</div> </div><!-- <div class=\"form-group\">\n          <label>Crear usuario</label>\n          <div>{{modal.alsoCreateAdminRole | yesno}}</div>\n        </div> --> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()><i class=\"fal fa-plus mr\"></i>{{\'ORGANIZATIONS.MODAL.DO_ADD\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/add-programed_reboot.html","<div class=modal-header> <h3> <span class=modal-title>{{modal.isEdit? (\'ACTION.ADD_PROGRAMED_REBOOT.EDIT_PROGRAMED_REBOOT\' | translate) : (\'ACTION.ADD_PROGRAMED_REBOOT.ADD_PROGRAMED_REBOOT\' | translate)}}</span> </h3> </div> <div class=\"modal-body wizard\"> <form name=form novalidate> <div class=form-group> <label>{{\'ACTION.ADD_PROGRAMED_REBOOT.REBOOT_EACH\' | translate}}</label> <select name=period ng-model=modal.programedReboot.period class=form-control ng-options=\"period.id as period.display for period in modal.periods\"></select> </div> <div class=form-group> <label>{{\'ACTION.ADD_PROGRAMED_REBOOT.VALID_HOURS\' | translate}}</label> <widget-slider range=modal.slider.value params=modal.slider.options on-change=modal.slider.onChange></widget-slider> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'ACTION.ADD_PROGRAMED_REBOOT.VALID_HOURS_HELP\' | translate}}</div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=modal.done()> <i ng-hide=modal.isEdit class=\"fal fa-plus mr\"></i> <span>{{modal.isEdit? (\'ACTION.ADD_PROGRAMED_REBOOT.DO_EDIT\' | translate) : (\'ACTION.ADD_PROGRAMED_REBOOT.DO_ADD\' | translate)}}</span> </button> </div>");
$templateCache.put("app/views/modals/add-recharging-schedule.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number> {{$index+1}} </span> {{step.title}} </div> </div> <h3> <span class=modal-title>{{modal.isEdit? (\'EDIT_RECHARGING_SCHEDULE\' | translate) : (\'ADD_RECHARGING_SCHEDULE\' | translate)}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form id=modal-recharge-schedules novalidate> <div class=intro> {{modal.wizard.steps[modal.wizard.step].intro}} </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'config\'\"> <div class=form-group> <label>{{\'START\' | translate}}</label> <select name=end ng-model=modal.data.startDayOfWeek class=form-control ng-options=\"day.id as day.display for day in modal.days\" ng-change=modal.validateRechargeSchedule()> </select> </div> <div class=form-group> <label>{{\'END\' | translate}}</label> <select name=end ng-model=modal.data.endDayOfWeek class=form-control ng-options=\"day.id as day.display for day in modal.days\" ng-change=modal.validateRechargeSchedule()> </select> </div> <div class=form-group> <label>{{\'ACTION.ADD_PROGRAMED_REBOOT.VALID_HOURS\' | translate}}</label> <widget-slider range=modal.slider.value params=modal.slider.options on-change=modal.slider.onChange></widget-slider> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'TIME_IN_UTC\' | translate}}</div> <div class=form-group> <label>{{\'UNIT\' | translate}}</label> <select name=unit ng-model=modal.data.unit class=form-control ng-options=\"unit.id as unit.display for unit in modal.units\" ng-change=modal.validateRechargeSchedule()> </select> </div> <div class=form-group> <label>{{\'LIMIT\' | translate}}</label> <input name=limit ng-model=modal.data.limit type=number min=0 step=0.1 value=0.0 class=form-control> </div> <div ng-show=modal.conflict class=\"help colophon\"> <div ng-if=modal.conflict.name class=danger> <i class=\"fal fa-ban mr\"></i> <span translate=CONFLICT_WITH_RECHARGE_SCHEDULE translate-value-name=\"<accent>{{modal.conflict.name}}</accent>\"></span> </div> <div ng-if=modal.conflict.text class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.text}}</span> </div> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'START\' | translate}}</label> <div>{{modal.data.startDayOfWeek | toDay}}</div> </div> <div class=form-group> <label>{{\'START_TIME\' | translate}}</label> <div>{{modal.data.startTime}}</div> </div> <div class=form-group> <label>{{\'END\' | translate}}</label> <div>{{modal.data.endDayOfWeek | toDay}}</div> </div> <div class=form-group> <label>{{\'END_TIME\' | translate}}</label> <div>{{modal.data.endTime}}</div> </div> <div class=form-group> <label>{{\'UNIT\' | translate}}</label> <div>{{modal.data.unit}}</div> </div> <div class=form-group> <label>{{\'LIMIT\' | translate}}</label> <div>{{modal.data.limit}}</div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=\"modal.unbindWatchers(); App.closeModal()\">{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);>{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);>{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <span>{{\'FINISH\' | translate}}</span> </button> </div>");
$templateCache.put("app/views/modals/add-user.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{(modal.entity === \'provider\' || modal.entity === \'organization\')? (\'ACTION.ADD_USER.ADDING_STAFF\' | translate) : (\'ACTION.ADD_USER.ADDING_PROFILE\' | translate)}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'email\'\"> <div class=form-group> <label>{{\'ACTION.ADD_USER.EMAIL\' | translate}}</label> <input name=username ng-model=modal.user.username type=email ng-change=\"modal.onUsernameChanged(modal.user.username, modal)\" class=form-control> </div> <div class=form-group> <label></label> <span ng-show=modal.userLoading class=muted>{{\'ACTION.ADD_USER.CHECKING_IF_ALREADY_EXISTS\' | translate}} <span class=spinner><div></div></span></span> <div ng-show=!modal.userLoading> <span ng-show=\"modal.existingUser===null\"><i class=\"fal fa-user-plus mr accent\"></i>{{\'ACTION.ADD_USER.SEEMS_NEW\' | translate}}</span> <span ng-show=modal.existingUser><i class=\"fal fa-user mr accent\"></i><span translate=ACTION.ADD_USER.WE_KNOW_EACH_OTHER translate-value-name=\"<accent>{{modal.existingUser.displayName | safe}}</accent>\"></span></span> </div> </div> <div class=\"help colophon\" ng-show=\"modal.existingUser===null\"><i class=\"fal fa-info mr\"></i>{{\'ACTION.ADD_USER.AN_EMAIL_WILL_BE_SEND\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'role\'\"> <div class=form-group> <label>{{\'ACTION.ADD_USER.ROLE\' | translate}}</label> <select name=role ng-model=modal.user.role class=form-control ng-options=\"role as (role | role) for role in modal.availableRoles\"></select> </div> <p class=help ng-if=\"modal.user.role===\'admin\'\" translate=ACTION.ADD_USER.ROLE_ADMIN_HELP translate-value-admin=\"<b>{{\'ACTION.ADD_USER.ROLE_ADMIN\' | translate}}</b>\"></p> <p class=help ng-if=\"modal.user.role===\'doer\'\" translate=ACTION.ADD_USER.ROLE_DOER_HELP translate-value-doer=\"<b>{{\'ACTION.ADD_USER.ROLE_DOER\' | translate}}</b>\"></p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=ACTION.ADD_USER.WE_ARE_ADDING_USER translate-value-name=\"<accent>{{modal.user.username}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'lang\'\"> <div class=form-group> <label>{{\'COMMON.LANG\' | translate}}</label> <select class=form-control ng-model=modal.lang.option ng-options=\"option.id as option.display for option in modal.lang.options\"></select> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'ACTION.ADD_USER.EMAIL\' | translate}}</label> <div>{{modal.user.username}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_USER.ROLE\' | translate}}</label> <div>{{modal.user.role | role}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_USER.OF\' | translate}}</label> <div>{{modal.entity | roleEntity}}</div> </div> <div class=form-group> <label>{{\'ACTION.ADD_USER.AT\' | translate}}</label> <div> <a ng-if=\"modal.entity===\'provider\'\" ui-sref=\"efimob.settings({tab: null})\">{{modal.provider.id}}</a> <a ng-if=\"modal.entity===\'organization\'\" ui-sref=\"efimob.organizations.item({id: modal.organization.id, tab: null})\">{{modal.organization.id}}</a> <a ng-if=\"modal.entity===\'group\'\" ui-sref=\"efimob.groups.item({id: modal.group.id, organization: modal.organizationId, tab: null})\">{{modal.group.name}}</a> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i> <span ng-show=\"(modal.entity===\'provider\' || modal.entity===\'organization\')\">{{\'ACTION.ADD_USER.DO_ADD_TO_STAFF\' | translate}}</span> <span ng-show=\"modal.entity===\'group\'\">{{\'ACTION.ADD_USER.DO_ADD_PROFILE\' | translate}}</span> </button> </div>");
$templateCache.put("app/views/modals/add-userkey-group.html","<div class=modal-header> <h3 class=modal-title>{{\'USERKEY.ADD.AUTH_GROUP\' | translate}}</h3> </div> <div class=modal-body> <form name=forms.modal novalidate> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/add-userkey-to-customer.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'CUSTOMER_VIEW.USERKEYS.NEW_KEY\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'id\'\"> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ID\' | translate}}</label> <input name=id ng-model=modal.userkey.idToken type=text class=form-control> </div> <p class=help>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ID_HINT\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ID_HELP\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.INITIAL_AUTH\' | translate}}</label> <div> <widget-switch model=modal.withLocation disabled=!modal.organizationId></widget-switch> </div> </div> <p class=help ng-show=modal.organizationId>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.GROUP_HINT_1\' | translate}}</p> <p class=\"help warning\" ng-show=\"modal.organizationId===null\">{{\'CUSTOMER_VIEW.USERKEYS.MODAL.GROUP_HINT_2\' | translate}} </p> <div ng-show=modal.withLocation> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'config\'\"> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.EXPIRATION_PERIOD\' | translate}}</label> <select name=period ng-model=modal.userkeyExpirationPeriod class=form-control ng-options=\"period as period.display for period in modal.userkeyExpirationPeriods\"></select> </div> <p class=help>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.EXPIRATION_PERIOD_HINT\' | translate}}</p> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ACTIVATION_DATE\' | translate}}</label> <div class=input-group> <input type=text class=form-control ng-model=modal.userkeyActivationDate uib-datepicker-popup=\"d MMM yyyy\" on-open-focus=false is-open=modal.userkeyActivationDateConf.open datepicker-options=modal.userkeyActivationDateConf.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.userkeyActivationDateConf.open=!modal.userkeyActivationDateConf.open\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <p class=help>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ACTIVATION_DATE_HINT\' | translate}}</p> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ACTIVE\' | translate}}</label> <div> <widget-switch model=modal.userkeyActive></widget-switch> </div> </div> <p class=help>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ACTIVE_HINT\' | translate}}</p> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.MASTER\' | translate}}</label> <div> <widget-switch model=modal.userkey.master></widget-switch> </div> </div> <p class=help>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.MASTER_HINT\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CUSTOMER_VIEW.USERKEYS.MODAL.CREATING_USERKEY translate-value-id=\"<accent>{{modal.userkey.idToken}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'recap\'\"> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ID\' | translate}}</label> <div>{{modal.userkey.idToken}}</div> </div> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.CUSTOMER\' | translate}}</label> <div ng-show=modal.customer>{{modal.customer.name}}</div> </div> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.GROUP\' | translate}}</label> <div ng-show=modal.location><a ui-sref=\"efimob.groups.item({\'id\': modal.location.id, \'organization\': modal.organizationId})\">{{modal.location.name}}</a> </div> <div ng-show=!modal.location><span class=muted>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.NO_INITIAL_AUTH\' | translate}}</span> </div> </div> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.EXPIRATION_PERIOD\' | translate}}</label> <div>{{modal.userkeyExpirationPeriod.display}} (<span translate=CUSTOMER_VIEW.USERKEYS.MODAL.EXPIRES_BY translate-value-date=\"{{modal.userkey.activeTo | toDate}}\"></span>)</div> </div> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ACTIVATION_DATE\' | translate}}</label> <div>{{modal.userkey.activeFrom | toDate}}</div> </div> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.ACTIVE\' | translate}}</label> <div>{{!modal.userkey.blocked | yesno}}</div> </div> <div class=form-group> <label>{{\'CUSTOMER_VIEW.USERKEYS.MODAL.MASTER\' | translate}}</label> <div>{{modal.userkey.master | yesno}}</div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'CUSTOMER_VIEW.USERKEYS.ADD_KEY\' | translate}} </button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"> <div class=infinite-progress></div> </div> </div>");
$templateCache.put("app/views/modals/add-userkey-to-domestic-chargepoint.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'CH.ACTIONS.ADD_USERKEY.NEW_KEY\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'id\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.ID\' | translate}}</label> <input name=id ng-model=modal.userkey.idToken type=text class=form-control> </div> <p class=help>{{\'CH.ACTIONS.ADD_USERKEY.ID_HINT\' | translate}}</p> <div class=\"help colophon\"> <i class=\"fal fa-info mr\"></i>{{\'CH.ACTIONS.ADD_USERKEY.ID_HELP\' | translate}} </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'config\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.EXPIRATION_PERIOD\' | translate}}</label> <select name=period ng-model=modal.userkeyExpirationPeriod class=form-control ng-options=\"period as period.display for period in modal.userkeyExpirationPeriods\"></select> </div> <p class=help>{{\'CH.ACTIONS.ADD_USERKEY.EXPIRATION_PERIOD_HINT\' | translate}}</p> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.ACTIVATION_DATE\' | translate}}</label> <div class=input-group> <input type=text class=form-control ng-model=modal.userkeyActivationDate uib-datepicker-popup=\"d MMM yyyy\" on-open-focus=false is-open=modal.userkeyActivationDateConf.open datepicker-options=modal.userkeyActivationDateConf.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.userkeyActivationDateConf.open=!modal.userkeyActivationDateConf.open\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <p class=help>{{\'CH.ACTIONS.ADD_USERKEY.ACTIVATION_DATE_HINT\' | translate}}</p> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.ACTIVE\' | translate}}</label> <div><widget-switch model=modal.userkeyActive></widget-switch></div> </div> <p class=help>{{\'CH.ACTIONS.ADD_USERKEY.ACTIVE_HINT\' | translate}}</p> <div class=\"help colophon\"> <i class=\"fal fa-info mr\"></i> <span translate=CH.ACTIONS.ADD_USERKEY.CREATING_USERKEY translate-value-id=\"<accent>{{modal.userkey.idToken}}</accent>\"></span> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'recap\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.ID\' | translate}}</label> <div>{{modal.userkey.idToken}}</div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.EXPIRATION_PERIOD\' | translate}}</label> <div>{{modal.userkeyExpirationPeriod.display}} (<span translate=CH.ACTIONS.ADD_USERKEY.EXPIRES_BY translate-value-date=\"{{modal.userkey.activeTo | toDate}}\"></span>)</div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.ACTIVATION_DATE\' | translate}}</label> <div>{{modal.userkey.activeFrom | toDate}}</div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.ADD_USERKEY.ACTIVE\' | translate}}</label> <div>{{!modal.userkey.blocked | yesno}}</div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!modal.isValid(modal) ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!modal.isValid(modal) ng-click=modal.done()><i class=\"fal fa-plus mr\"></i>{{\'CH.ACTIONS.ADD_USERKEY.ADD_KEY\' | translate}}</button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"><div class=infinite-progress></div></div> </div>");
$templateCache.put("app/views/modals/add-userkey.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'ADD_KEY\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'id\'\"> <div class=form-group> <label>{{\'ID\' | translate}}</label> <input name=id ng-model=modal.userKey.idToken type=text class=form-control> </div> <p class=help>{{\'MUST_BE_SAME_ID_PROVIDED_PROVIDER\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'CHECK_WITH_PROVIDER_THE_ID\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'customer\'\"> <div class=form-group> <label>{{\'ASSIGN_TO_CUSTOMER\' | translate}}</label> <div> <widget-switch model=modal.userkeyBound on-change=modal.onUserKeyBoundChanged disabled=!modal.organizationId></widget-switch> </div> </div> <p class=help ng-show=modal.organizationId>{{\'UNCHECK_TO_UNASSING_TO_CUSTOMER\' | translate}}</p> <p class=\"help warning\" ng-show=\"modal.organizationId===null\">{{\'NO_ASSIGNMENT_TO_ORGANISATION_CANNOT_BE_ASSIGNED_TO_CUSTOMER\' | translate}} </p> <div ng-show=modal.userkeyBound> <div ng-show=!modal.addingCustomer> <div class=form-group> <label>{{\'SEARCH_BY\' | translate}}</label> <select-component item=modal.searchBy items=modal.searchByList field=\"\'display\'\" on-change=modal.updateSearchBy> </select-component> </div> <div class=form-group> <label>{{\'CUSTOMER\' | translate}}</label> <select-component items=modal.customers item=modal.customer custom-display=modal.displayForCustomers on-search=modal.onSearch search style=\"min-width: 50%\"> </select-component> </div> <p class=help>{{\'CUSTOMER_USE_THIS_KEY\' | translate}}</p> <div class=form-group> <label></label> <a ng-click=\"modal.onAddCustomer(modal, true)\"><i class=\"fal fa-{{ctrl.App.icon[\'customer\']}} mr\"></i>{{\'REGISTER_NEW_CUSTOMER\' | translate}}</a> </div> </div> <div ng-show=modal.addingCustomer> <div class=form-group> <label>{{\'NEW_USER_KEY_NAME\' | translate}}</label> <input name=name ng-model=modal.customer.name type=text class=form-control> </div> <p class=help>{{\'NAME_AND_SURNAME\' | translate}}</p> <div class=form-group ng-show=\"modal.customers.length>0\"> <label></label> <a ng-click=\"modal.onAddCustomer(modal, false)\">{{\'SELECT_EXISTING_CUSTOMER\' | translate}}</a> </div> </div> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CREATE_RFID_WITH_ID translate-value-id=\"<accent>{{modal.userKey.idToken}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <div class=form-group> <label>{{\'INITIAL_AUTHORIZATION\' | translate}}</label> <div> <widget-switch model=modal.withLocation disabled=!modal.organizationId></widget-switch> </div> </div> <p class=help ng-show=modal.organizationId>{{\'UNCHECK_TO_DONT_AUTHORIZE_ANY_ZONE\' | translate}}</p> <p class=\"help warning\" ng-show=\"modal.organizationId===null\">{{\'NO_ASSIGNMENT_TO_ORGANISATION_KEYS_CANNOT_HAVE_AUTHORIZATION\' | translate}} </p> <div ng-show=modal.withLocation> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'config\'\"> <div class=form-group> <label>{{\'VALIDITY_PERIOD\' | translate}}</label> <select name=period ng-model=modal.userkeyExpirationPeriod class=form-control ng-options=\"period as period.display for period in modal.userkeyExpirationPeriods\"></select> </div> <p class=help>{{\'RECOMMEN_LEAVE_DEFAULT_VALUE\' | translate}}</p> <div class=form-group> <label>{{\'PRIORITY\' | translate}}</label> <select name=priority ng-model=modal.priority class=form-control ng-options=\"priority as priority.display for priority in modal.priorities\"> </select> </div> <div class=form-group> <label>{{\'ACTIVATION_DATE\' | translate}}</label> <div class=input-group> <input type=text class=form-control ng-model=modal.userkeyActivationDate uib-datepicker-popup=\"d MMM yyyy\" on-open-focus=false is-open=modal.userkeyActivationDateConf.open datepicker-options=modal.userkeyActivationDateConf.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.userkeyActivationDateConf.open=!modal.userkeyActivationDateConf.open\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <p class=help>{{\'KEY_DEACTIVATE_UNTIL_DATE\' | translate}}</p> <div class=form-group> <label>{{\'ACTIVE\' | translate}}</label> <div> <widget-switch model=modal.userkeyActive></widget-switch> </div> </div> <p class=help>{{\'UNCHECK_TO_BLOCK_KEY\' | translate}}</p> <div class=form-group> <label>{{\'MASTER\' | translate}}</label> <div> <widget-switch model=modal.userKey.master></widget-switch> </div> </div> <p class=help>{{\'MASTER_KEY_CAN_STOP_ANY_CHARGE\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CREATE_RFID_WITH_ID translate-value-id=\"<accent>{{modal.userKey.idToken}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'recap\'\"> <div class=form-group> <label>{{\'ID\' | translate}}</label> <div>{{modal.userKey.idToken}}</div> </div> <div class=form-group> <label>{{\'CUSTOMER\' | translate}}</label> <div ng-show=modal.customer>{{modal.customer.name}} <span ng-show=modal.addingCustomer class=muted><i>({{\'NEW_CUSTOMER\' | translate}})</i></span></div> <div ng-show=!modal.customer><span class=muted>{{\'WITHOUT_ASSIGNED_CUSTOMER\' | translate}}</span></div> </div> <div class=form-group> <label>{{\'ZONE\' | translate}}</label> <div ng-show=modal.location><a ui-sref=\"efimob.groups.item({\'id\': modal.location.id, \'organization\': modal.organizationId})\">{{modal.location.name}}</a> </div> <div ng-show=!modal.location><span class=muted>{{\'WITHOUT_INITIAL_AUTHORIZATION\' | translate}}</span> </div> </div> <div class=form-group> <label>{{\'VALIDITY_PERIOD\' | translate}}</label> <div>{{modal.userkeyExpirationPeriod.display}} (<span translate=EXPIRES_AT translate-value-date=\"{{modal.userKey.activeTo | toDate}}\"></span>)</div> </div> <div class=form-group> <label>{{\'ACTIVATION_DATE\' | translate}}</label> <div>{{modal.userKey.activeFrom | toDate}}</div> </div> <div class=form-group> <label>{{\'ACTIVE\' | translate}}</label> <div>{{!modal.userKey.blocked | yesno}}</div> </div> <div class=form-group> <label>{{\'MASTER\' | translate}}</label> <div>{{modal.userKey.master | yesno}}</div> </div> <div class=form-group> <label>{{\'PRIORITY\' | translate}}</label> <div>{{modal.userKey.priority | uppercase | translate}}</div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}} </button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"> <div class=infinite-progress></div> </div> </div>");
$templateCache.put("app/views/modals/assign-chargepoint.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{(modal.chargepoints.length > 1? \'CPS.ATO.ASSIGN_CHARGEPOINTS\' : \'CPS.ATO.ASSIGN_CHARGEPOINT\') | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'organization\'\"> <div class=form-group> <label>{{\'CPS.ATO.ORGANIZATION\' | translate}}</label> <span ng-show=modal.organizationsLoading class=spinner><div></div></span> <select ng-hide=modal.organizationsLoading name=organization ng-model=modal.organization class=form-control ng-options=\"organization as (organization.name + \' (\' + organization.id + \')\') for organization in modal.organizations\"></select> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'CPS.ATO.HELP\' | translate}}</div> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'CPS.ATO.CHARGEPOINTS\' | translate}}</label> <div><span ng-show=\"modal.chargepoints.length==1\"><accent>{{modal.chargepoints[0]}}</accent></span><span ng-show=\"modal.chargepoints.length>1\">{{modal.chargepoints.length}}</span></div> </div> <div class=form-group> <label>{{\'CPS.ATO.ORGANIZATION\' | translate}}</label> <div>{{modal.organization.name}} (<accent>{{modal.organization.id}}</accent>)</div> </div> <div class=form-group> <label>{{\'CPS.ATO.GROUP\' | translate}}</label> <div>{{modal.location.name}} </div> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'CPS.ATO.ASSIGN_TO_ORGANIZATION\' | translate}} </button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"><div class=infinite-progress></div></div> </div>");
$templateCache.put("app/views/modals/assign-maintainer.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span> {{step.title}} </div> </div> <h3 class=modal-title translate=ASSIGN_MAINTAINER></h3> </div> <div class=\"modal-body wizard\"> <form name=assignMaintainer novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'maintainers\'\"> <div class=form-group> <label>{{\'MAINTAINERS\' | translate}}</label> <select-component item=modal.maintainer items=modal.maintainers custom-display=modal.displayForMaintainers on-search=modal.onSearch search style=\"min-width: 50%\"> </select-component> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group ng-show=modal.maintainer.companyName> <label>{{\'COMPANY\' | translate}}</label> <div>{{modal.maintainer.companyName}}</div> </div> <div class=form-group ng-show=modal.maintainer.name> <label>{{\'NAME\' | translate}}</label> <div>{{modal.maintainer.name}}</div> </div> <div class=form-group ng-show=modal.maintainer.contractNumber> <label>{{\'CONTRACT_NUMBER\' | translate}}</label> <div>{{modal.maintainer.contractNumber}}</div> </div> <div class=form-group ng-show=modal.maintainer.timetable> <label>{{\'TIMETABLE\' | translate}}</label> <div>{{modal.maintainer.timetable}}</div> </div> <div class=form-group ng-show=modal.maintainer.phone> <label>{{\'PHONE\' | translate}}</label> <div>{{modal.maintainer.phone}}</div> </div> <div class=form-group ng-show=modal.maintainer.email> <label>{{\'EMAIL\' | translate}}</label> <div>{{modal.maintainer.email}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\"> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"(modal.wizard.step=modal.wizard.step+1)\"> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-plus mr\"></i> {{\'ASSIGN\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/assign-operation-to-agreement.html","<div class=modal-header> <h3 class=modal-title translate=CONSULT_EDIT_OPERATION> </h3> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'operations\'\"> <dual-list-component data=modal.dualListData api=modal.dualListApi on-request=modal.getOperations></dual-list-component> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'OPERATIONS\' | translate}}</label> <div>{{modal.dualListData.assigned | operationsToNameList}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.done(modal)> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/assign-userkey.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{modal.userkeys.length > 1? (\'USERKEYS.ATO.ASSIGN_SEVERAL\' | translate) : (\'USERKEYS.ATO.ASSIGN_ONE\' | translate)}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'organization\'\"> <div class=form-group> <label>{{\'USERKEYS.ATO.ORGANIZATION\' | translate}}</label> <span ng-show=modal.organizationsLoading class=spinner><div></div></span> <select ng-hide=modal.organizationsLoading name=organization ng-model=modal.organization class=form-control ng-options=\"organization as (organization.name + \' (\' + organization.id + \')\') for organization in modal.organizations\"></select> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'USERKEYS.ATO.ASSIGN_HELP\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'USERKEYS.ATO.USERKEYS\' | translate}}</label> <div> <span ng-show=\"modal.userkeys.length==1\"><accent>{{modal.userkeys[0]}}</accent></span> <span ng-show=\"modal.userkeys.length>1\">{{modal.userkeys.length}}</span> </div> </div> <div class=form-group> <label>{{\'USERKEYS.ATO.ORGANIZATION\' | translate}}</label> <div>{{modal.organization.name}} (<accent>{{modal.organization.id}}</accent>)</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'USERKEYS.ATO.DO_ASSIGN\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/bind-userkey-to-customer.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{modal.userkeys.length > 1? (\'USERKEYS.ATC.ASSIGN_SEVERAL\' | translate) : (\'USERKEYS.ATC.ASSIGN_ONE\' | translate)}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'customer\'\"> <div ng-show=!modal.addingCustomer> <div class=form-group> <label>{{\'SEARCH_BY\' | translate}}</label> <select-component item=modal.searchBy items=modal.searchByList field=\"\'display\'\" on-change=modal.updateSearchBy> </select-component> </div> <div class=form-group> <label>{{\'USERKEYS.ATC.CUSTOMER\' | translate}}</label> <select-component item=modal.customer items=modal.customers custom-display=modal.displayForCustomers on-search=modal.onSearch search style=\"min-width: 50%\"> </select-component> </div> <div class=form-group> <label></label> <a ng-click=\"modal.onAddCustomer(modal, true)\"><i class=\"fal fa-{{App.icon[\'customer\']}} mr\"></i>{{\'USERKEYS.ATC.ADD_NEW_CUSTOMER\' | translate}}</a> </div> </div> <div ng-show=modal.addingCustomer> <div class=form-group> <label>{{\'USERKEYS.ATC.NAME\' | translate}}</label> <input name=name ng-model=modal.customer.name type=text class=form-control> </div> <p class=help>{{\'USERKEYS.ATC.NAME_HINT\' | translate}}</p> <div class=form-group ng-show=\"modal.customers.length>0\"> <label></label> <a ng-click=\"modal.onAddCustomer(modal, false)\">{{\'USERKEYS.ATC.SELECT\' | translate}}</a> </div> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i>{{\'USERKEYS.ATC.NAME_HELP\' | translate}}</div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'USERKEYS.ATC.USERKEYS\' | translate}}</label> <div><span ng-show=\"modal.userkeys.length==1\"><accent>{{modal.userkeys[0]}}</accent></span><span ng-show=\"modal.userkeys.length>1\">{{modal.userkeys.length}}</span></div> </div> <div class=form-group> <label>{{\'USERKEYS.ATC.CUSTOMER\' | translate}}</label> <div>{{modal.customer.name}} <span ng-show=modal.addingCustomer class=muted><i>({{\'USERKEYS.ATC.IS_NEW\' | translate}})</i></span></div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-{{App.icon[\'customer\']}} mr\"></i>{{\'USERKEYS.ATC.DO_ASSIGN\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/change-chargepoint-group.html","<div class=modal-header> <h3 class=modal-title translate=CH.ACTIONS.CHANGE_GROUP.CHANGING translate-value-name=\"<accent>{{modal.chargepoint.name}}</accent>\"></h3> </div> <div class=modal-body> <form name=forms.modal novalidate> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-plus mr\"></i>{{\'CH.ACTIONS.CHANGE_GROUP.DO_CHANGE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/change-password.html","<div class=modal-header> <h3 class=modal-title>{{\'PROFILE.CHANGE_PWD.PASSWORD_CHANGE\' | translate}}</h3> </div> <div class=modal-body> <form name=form novalidate> <div class=form-group> <label>{{\'PROFILE.CHANGE_PWD.CURRENT_PASSWORD\' | translate}}</label> <input name=currentPassword ng-model=ctrl.modal.currentPassword type=password class=form-control autocomplete=password> </div> <div class=form-group> <label>{{\'PROFILE.CHANGE_PWD.NEW_PASSWORD\' | translate}}</label> <input name=newPassword ng-model=ctrl.modal.newPassword type=password class=form-control> <p class=help> <t translate=PROFILE.CHANGE_PWD.HELP_CONSTRAINTS_1 translate-value-passwordlength={{ctrl.modal.passwordLength}}></t> <br> <t translate=PROFILE.CHANGE_PWD.HELP_CONSTRAINTS_2></t> </p> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-info\" type=button ng-click=ctrl.modal.done()><i class=\"fal fa-key mr\"></i>{{\'PROFILE.CHANGE_PWD.DO_CHANGE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/chargepoint-search.html","<div class=modal-header> <h3 class=modal-title>{{\'LOCATE_CHARGE_POINT\' | translate}}</h3> </div> <div class=modal-body> <form name=form novalidate> <div class=form-group> <label>{{\'FIELD\' | translate}}</label> <select-component item=modal.searchBy items=modal.searchByList field=\"\'label\'\" on-change=modal.updateSearchBy> </select-component> </div> <div class=form-group> <label>{{\'SEARCH\' | translate}}</label> <select-component items=modal.chargePoints item=modal.chargePoint custom-display=modal.display on-search=modal.onSearch search style=\"min-width: 50%\"> </select-component> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-disabled=!modal.chargePoint ng-click=modal.done()> {{\'SEARCH\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-chargepoint-connector-settings.html","<div class=modal-header> <h3 class=modal-title ng-show=modal.connector.label translate=CH.CONNECTORS.SETTINGS.SETTINGS_FOR translate-value-name=\"<accent>{{modal.connector.label}}</accent>\"></h3> <h3 class=modal-title ng-show=!modal.connector.label translate=CH.CONNECTORS.SETTINGS.SETTINGS_FOR_NO_LABEL translate-value-id={{modal.connector.id}}></h3> </div> <div class=modal-body> <form name=form novalidate> <div class=form-group> <label>{{\'CH.CONNECTORS.SETTINGS.TYPE\' | translate}}</label> <select name=type ng-model=modal.settings.type class=form-control ng-options=\"type.id as type.display for type in modal.types\"></select> </div> <div class=form-group> <label>{{\'CH.CONNECTORS.SETTINGS.MODE\' | translate}}</label> <select name=mode ng-model=modal.settings.mode class=form-control ng-options=\"mode.id as mode.display for mode in modal.modes\"></select> </div> <div class=form-group> <label>{{\'PHYSICAL_REFERENCE\' | translate}}</label> <input name=physicalReference ng-model=modal.settings.physicalReference type=text maxlength=16 class=form-control> </div> <div class=form-group> <label>{{\'CH.CONNECTORS.DETAILS.EVSE_ID\' | translate}}</label> <input name=evseId ng-model=modal.settings.evseId type=text maxlength=48 class=form-control> </div> <div class=\"form-inline mt-m mb-s\"> <div class=form-group> <label style=\"width:68px; justify-content:left\">{{\'CH.CONNECTORS.SETTINGS.POWER\' | translate}}</label> <input name=power ng-model=modal.settings.power style=width:120px type=number step=0.01 class=form-control> </div> <span>kW</span> </div> <div class=\"form-inline mb-s\"> <div class=form-group> <label style=\"width:68px; justify-content:left\">{{\'CH.CONNECTORS.SETTINGS.CURRENT\' | translate}}</label> <input name=current ng-model=modal.settings.current style=width:120px type=number class=form-control> </div> <span>A</span> </div> <div class=\"form-inline mb-s\"> <div class=form-group> <label style=\"width:68px; justify-content:left\">{{\'CH.CONNECTORS.SETTINGS.VOLTAGE\' | translate}}</label> <input name=voltage ng-model=modal.settings.voltage style=width:120px type=number class=form-control> </div> <span>V</span> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=modal.done()>{{\'CH.CONNECTORS.SETTINGS.SAVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/edit-consent-summary.html","<div class=modal-header> <h3> <span class=modal-title>{{\'SUMMARY\' | translate}}</span> </h3> </div> <div class=\"modal-body wizard\"> <form name=form novalidate> <div class=form-group> <label>{{\'COMMON.LANG\' | translate}}</label> <select class=form-control ng-model=modal.lang.option ng-options=\"option.id as option.display for option in modal.lang.options\"></select> </div> <div class=form-group> <label>{{\'TEXT\' | translate}}</label> <rich-text-component class=form-rich-text item=modal.data[modal.lang.option] on-change=modal.validateText></rich-text-component> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-consent.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3 class=modal-title translate=CONSENT></h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'options\'\"> <div class=form-group> <label>{{\'COMMON.LANG\' | translate}}</label> <select class=form-control ng-model=modal.lang.option ng-options=\"option.id as option.display for option in modal.lang.options\"></select> </div> <div class=form-group> <label>{{\'TITLE\' | translate}}</label> <input name=title ng-model=modal.data.title[modal.lang.option] type=text class=form-control ng-change=\"modal.validateTitle(modal.data.title, modal.lang.option)\"> </div> <div class=form-group> <label>{{\'MANDATORY\' | translate}}</label> <div> <widget-switch model=modal.data.mandatory></widget-switch> </div> </div> <div class=form-group> <label>{{\'URL\' | translate}}</label> <input type=url placeholder=https://example.com size=30 name=url ng-model=modal.data.url ng-change=modal.validateUrl() type=text class=form-control> </div> <div ng-show=\"modal.conflict.title || modal.conflict.format\" class=\"help colophon\"> <div ng-if=modal.conflict.title class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.titleText | translate}}</span> </div> <div ng-if=modal.conflict.format class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.urlFormat | translate}}</span> </div> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'TITLE\' | translate}}</label> <div>{{modal.data.title | adaptLangsToString}}</div> </div> <div class=form-group> <label>{{\'MANDATORY\' | translate}}</label> <div>{{modal.data.mandatory}}</div> </div> <div class=form-group> <label>{{\'URL\' | translate}}</label> <div>{{modal.data.url}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-energy.html","<div class=modal-header> <h3 class=modal-title translate=GROUP_NAME_ENERGY translate-value-name=\"<accent>{{modal.group.name}}</accent>\"></h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div class=\"form-group mt-l\"> <label>{{\'GROUPS_ENERGY\' | translate}}</label> <div> <widget-switch model=modal.isEnergy></widget-switch> </div> </div> <div ng-show=modal.isEnergy> <div class=form-group> <label>{{\'GROUPS_GREEN_ENERGY\' | translate}}</label> <div> <widget-switch model=modal.energy.is_green_energy on-change=modal.validateIsGreenEnergy></widget-switch> </div> </div> <div class=form-group> <label>{{\'GROUPS_SOURCES\' | translate}}</label> <select-with-input-component list=modal.energy.sources list-options=modal.sourcesOptions first-item=\"\'source\'\" second-item=\"\'percentage\'\" second-item-unit=\"\'percentage\'\" on-select-change=modal.validateSelect on-input-change=modal.validateInput class=full-width> </select-with-input-component> </div> <div class=form-group> <label>{{\'GROUPS_ENVIRONMENTAL_IMPACT\' | translate}}</label> <select-with-input-component list=modal.energy.environmental_impact list-options=modal.impactOptions first-item=\"\'category\'\" second-item=\"\'amount\'\" second-item-unit=\"\'kg/MWh\'\" min=0 max=9999999999 on-select-change=modal.validateSelect class=full-width> </select-with-input-component> </div> <div class=form-group> <label>{{\'GROUPS_SUPPLIER_NAME\' | translate}}</label> <input name=supplierName ng-model=modal.energy.supplier_name type=text class=form-control> </div> <div class=form-group> <label>{{\'GROUPS_ENERGY_PRODUCT_NAME\' | translate}}</label> <input name=energyProductName ng-model=modal.energy.energy_product_name type=text class=form-control> </div> <div ng-show=\"modal.conflict.repeat || modal.conflict.counter || modal.conflict.green\" class=\"help colophon\"> <div ng-if=modal.conflict.repeat class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.repeatText | translate}}</span> </div> <div ng-if=\"!modal.conflict.repeat && modal.conflict.counter\" class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.counterText | translate}}</span> </div> <div ng-if=\"!modal.conflict.repeat && !modal.conflict.counter && modal.conflict.green\" class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.greenText | translate}}</span> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-holiday.html","<div class=modal-header> <h3 class=modal-title translate=HOLIDAY></h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div class=form-group> <label>{{\'COUNTRY\' | translate}}</label> <select-component item=modal.countryCode items=modal.countryCodes field=\"\'display\'\" style=\"width:calc(100% - 260px)\"> </select-component> </div> <div class=form-group> <label>{{\'DATE\' | translate}}</label> <div class=input-group> <input type=text class=form-control ng-model=modal.date uib-datepicker-popup=dd/MM/yyyy on-open-focus=false is-open=modal.datePickerIsOpen datepicker-options=modal.datePickerOptions show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.datePickerIsOpen=!modal.datePickerIsOpen\"> <i class=\"fal fa-calendar\"></i> </button> </span> </div> </div> <div class=form-group> <label>{{\'DESCRIPTION\' | translate}}</label> <input type=text class=form-control ng-model=modal.data.description style=width:280px> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-location.html","<div class=modal-header> <h3 class=modal-title translate=ACTION.EDIT_LOCATION.EDITING_FOR translate-value-name=\"<accent>{{modal.group.name}}</accent>\"></h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div class=intro>{{\'ACTION.EDIT_LOCATION.ENTER_LOCATION\' | translate}}</div> <div class=two-columns> <div class=\"a-column mr-s\"> <div class=\"form-group margin-0\"> <label>{{\'ACTION.EDIT_LOCATION.LATITUDE\' | translate}}</label> <input name=latitude ng-model=modal.location.latitude type=number class=form-control> </div> <div class=\"form-group margin-0\"> <label>{{\'ACTION.EDIT_LOCATION.LONGITUDE\' | translate}}</label> <input name=longitude ng-model=modal.location.longitude type=number class=form-control> </div> <div class=\"help colophon2\"><i class=\"fal fa-eye mr\"></i>{{\'ACTION.EDIT_LOCATION.YOU_CAN_DRAG_MARKER\' | translate}}</div> <div class=\"help colophon2\"><i class=\"fal fa-exclamation-circle mr\"></i>{{\'ACTION.EDIT_LOCATION.WARNING\' | translate}}</div> </div> <div class=a-column style=\"min-height: 360px\"> <widget-map params=modal.map></widget-map> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"><i class=\"fal fa-map-marker-alt mr\"></i>{{\'ACTION.EDIT_LOCATION.DO_EDIT\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/edit-maintainer.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span> {{step.title}} </div> </div> <h3 class=modal-title>{{\'MAINTAINER\' | translate}}</h3> </div> <div class=\"modal-body wizard\"> <form name=editMaintainer novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'data\'\"> <div class=form-group> <label>{{\'COMPANY\' | translate}}</label> <input name=companyName ng-model=modal.maintainer.companyName type=text class=form-control maxlength=100 required> </div> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <input name=name ng-model=modal.maintainer.name type=text class=form-control maxlength=100> </div> <div class=form-group> <label>{{\'CONTRACT_NUMBER\' | translate}}</label> <input name=contractNumber ng-model=modal.maintainer.contractNumber type=text class=form-control maxlength=100> </div> <div class=form-group> <label>{{\'EMAIL\' | translate}}</label> <input name=email ng-model=modal.maintainer.email type=email class=form-control maxlength=100 email-validator> </div> <p class=\"help danger\" ng-show=editMaintainer.email.$error.emailValidator> <i class=\"fal fa-ban mr\"></i> <span>{{\'WRONG_EMAIL_FORMAT\' | translate}}</span> </p> <div class=form-group> <label>{{\'PHONE\' | translate}}</label> <input name=phone ng-model=modal.maintainer.phone type=text class=form-control maxlength=15> </div> <p class=\"help margin-bottom-0\">{{\'COUNTRY_CALLING_CODE\' | translate}}</p> <div class=form-group> <label>{{\'TIMETABLE\' | translate}}</label> <input name=timetable ng-model=modal.maintainer.timetable type=text timetable-validator class=form-control maxlength=11> </div> <p class=\"help margin-bottom-0\">{{\'TIMETABLE_FORMAT\' | translate}}</p> <p class=\"help danger\" ng-show=editMaintainer.timetable.$error.timetableValidator> <i class=\"fal fa-ban mr\"></i> <span>{{\'WRONG_TIMETABLE_FORMAT\' | translate}}</span> </p> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group ng-show=modal.maintainer.companyName> <label>{{\'COMPANY\' | translate}}</label> <div>{{modal.maintainer.companyName}}</div> </div> <div class=form-group ng-show=modal.maintainer.name> <label>{{\'Name\' | translate}}</label> <div>{{modal.maintainer.name}}</div> </div> <div class=form-group ng-show=modal.data.maintainer.contractNumber> <label>{{\'CONTRACT_NUMBER\' | translate}}</label> <div>{{modal.data.maintainer.contractNumber}}</div> </div> <div class=form-group ng-show=modal.maintainer.phone> <label>{{\'PHONE\' | translate}}</label> <div>{{modal.maintainer.phone}}</div> </div> <div class=form-group ng-show=modal.maintainer.email> <label>{{\'EMAIL\' | translate}}</label> <div>{{modal.maintainer.email}}</div> </div> <div class=form-group ng-show=modal.maintainer.timetable> <label>{{\'TIMETABLE\' | translate}}</label> <div>{{modal.maintainer.timetable}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\"> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!editMaintainer.$valid ng-click=\"(modal.wizard.step=modal.wizard.step+1)\"> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=!editMaintainer.$valid> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-no-managed-chargers.html","<div class=modal-header> <h3> <span class=modal-title>{{\'ACTION.EDIT_NO_MANAGED.EDIT_TITLE\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div> <div class=form-group> <label>{{\'COMMON.LANG\' | translate}}</label> <select class=form-control ng-model=modal.lang.option ng-options=\"option.id as option.display for option in modal.lang.options\"></select> </div> <div class=form-group> <label>{{\'ACTION.EDIT_NO_MANAGED.TITLE\' | translate}}</label> <input name=title ng-model=modal.noManagedInfo.title[modal.lang.option] type=text class=form-control> </div> <div class=form-group> <label>{{\'ACTION.EDIT_NO_MANAGED.BODY\' | translate}}</label> <textarea rows=4 cols=50 name=body class=\"form-control margin-right-40\" ng-model=modal.noManagedInfo.body[modal.lang.option]></textarea> </div> </div> </form> </div> <div class=modal-footer state={{modal.state}}> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-edit mr\"></i> <span>{{\'ACTION.EDIT_NO_MANAGED.DO_EDIT\' | translate}}</span> </button> <div class=working-bottom-line ng-show=\"modal.state==\'working\'\"> <div class=infinite-progress></div> </div> </div>");
$templateCache.put("app/views/modals/edit-opening-hours.html","<div class=modal-header> <h3 class=modal-title translate=GROUP_NAME_OPENING_HOURS translate-value-name=\"<accent>{{modal.group.name}}</accent>\"></h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div class=\"form-group mt-l\"> <label>{{\'TWENTYFOURSEVEN\' | translate}}</label> <div> <widget-switch model=modal.openingTimes.twentyfourseven></widget-switch> </div> </div> <div ng-show=!modal.openingTimes.twentyfourseven> <div class=form-group> <label>{{\'REGULAR_HOURS\' | translate}}</label> <select-with-time-input-component list=modal.openingTimes.regular_hours list-options=modal.dayOptions first-item=\"\'weekday\'\" second-item=\"\'period_begin\'\" third-item=\"\'period_end\'\" on-select-change=modal.validateSelect on-input-change=modal.validateInput class=full-width> </select-with-time-input-component> </div> <div ng-show=modal.conflict.hour class=\"help colophon\"> <div class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.hourText | translate}}</span> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-owner.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3 class=modal-title translate=OWNER></h3> </div> <div class=\"modal-body wizard\"> <form name=editOwner novalidate> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'data\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <input name=name ng-model=modal.data.name type=text class=form-control ng-change=modal.validateName(modal.data.name) required> </div> <div class=form-group> <label>{{\'IDENTIFIER_NUMBER\' | translate}}</label> <input name=nif ng-model=modal.data.identifierNumber type=text class=form-control> </div> <div class=form-group> <label>{{\'OWNER_CODE\' | translate}}</label> <input name=ownerCode ng-model=modal.data.ownerCode type=text class=form-control> </div> <div class=form-group> <label>{{\'EMAIL\' | translate}}</label> <input name=email ng-model=modal.data.email type=email class=form-control> </div> <div class=form-group> <label>{{\'PHONE\' | translate}}</label> <input name=phone ng-model=modal.data.phone type=text class=form-control> </div> <div class=\"help colophon\"> <div ng-show=editOwner.email.$error.email class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{\'WRONG_EMAIL_FORMAT\' | translate}}</span> </div> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'address\'\"> <div class=form-group> <label>{{\'STREET\' | translate}}</label> <input name=title ng-model=modal.data.address.address type=text class=form-control ng-change=modal.validateName(modal.data.name)> </div> <div class=form-group> <label>{{\'CITY\' | translate}}</label> <input name=title ng-model=modal.data.address.city type=text class=form-control> </div> <div class=form-group> <label>{{\'POSTAL_CODE\' | translate}}</label> <input name=title ng-model=modal.data.address.postalCode type=text class=form-control> </div> <div class=form-group> <label>{{\'PROVINCE\' | translate}}</label> <input name=title ng-model=modal.data.address.province type=text class=form-control> </div> <div class=form-group> <label>{{\'COUNTRY\' | translate}}</label> <input name=title ng-model=modal.data.address.country type=text class=form-control> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group ng-show=modal.data.name> <label>{{\'NAME\' | translate}}</label> <div>{{modal.data.name}}</div> </div> <div class=form-group ng-show=modal.data.identifierNumber> <label>{{\'IDENTIFIER_NUMBER\' | translate}}</label> <div>{{modal.data.identifierNumber}}</div> </div> <div class=form-group ng-show=modal.data.ownerCode> <label>{{\'OWNER_CODE\' | translate}}</label> <div>{{modal.data.ownerCode}}</div> </div> <div class=form-group ng-show=modal.data.email> <label>{{\'EMAIL\' | translate}}</label> <div>{{modal.data.email}}</div> </div> <div class=form-group ng-show=modal.data.phone> <label>{{\'PHONE\' | translate}}</label> <div>{{modal.data.phone}}</div> </div> <div class=form-group ng-show=modal.data.address> <label>{{\'PHONE\' | translate}}</label> <div>{{modal.data.address | addressDisplay}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=!editOwner.$valid ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=!editOwner.$valid> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-proxy.html","<div class=modal-header> <h3 class=modal-title translate=PROXY></h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <input name=name ng-model=modal.data.name ng-change=modal.validateName() type=text class=form-control autofocus> </div> <div class=form-group> <label>{{\'URL\' | translate}}</label> <input type=url placeholder=https://example.com size=30 name=url ng-model=modal.data.url ng-change=modal.validateUrl() type=text class=form-control> </div> <div ng-show=\"modal.conflict.name || modal.conflict.url || modal.conflict.format\" class=\"help colophon\"> <div ng-if=modal.conflict.name class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.nameText | translate}}</span> </div> <div ng-if=modal.conflict.url class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.urlText | translate}}</span> </div> <div ng-if=modal.conflict.format class=danger> <i class=\"fal fa-ban mr\"></i> <span>{{modal.conflict.urlFormat | translate}}</span> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-primary\" type=button ng-click=modal.done() ng-disabled=\"!modal.isValid(modal, this)\"> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/edit-user.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'ACTION.EDIT_ROLE.EDITING\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'role\'\"> <div class=form-group> <label>{{\'ACTION.EDIT_ROLE.ROLE\' | translate}}</label> <select name=role ng-model=modal.user.role class=form-control ng-options=\"role as (role | role) for role in modal.availableRoles\"></select> </div> <p class=help ng-if=\"modal.user.role===\'admin\'\" translate=ACTION.EDIT_ROLE.ROLE_ADMIN_HELP translate-value-admin=\"<b>{{\'ACTION.EDIT_ROLE.ROLE_ADMIN\' | translate}}</b>\"></p> <p class=help ng-if=\"modal.user.role===\'doer\'\" translate=ACTION.EDIT_ROLE.ROLE_DOER_HELP translate-value-doer=\"<b>{{\'ACTION.EDIT_ROLE.ROLE_DOER\' | translate}}</b>\"></p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=ACTION.EDIT_ROLE.WE_ARE_EDITING_USER translate-value-name=\"<accent>{{modal.user.username}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'ACTION.EDIT_ROLE.EMAIL\' | translate}}</label> <div>{{modal.user.username}}</div> </div> <div class=form-group> <label>{{\'ACTION.EDIT_ROLE.ROLE\' | translate}}</label> <div>{{modal.user.role | role}}</div> </div> <div class=form-group> <label>{{\'ACTION.EDIT_ROLE.OF\' | translate}}</label> <div>{{modal.entity | roleEntity}}</div> </div> <div class=form-group> <label>{{\'ACTION.EDIT_ROLE.AT\' | translate}}</label> <div> <a ng-if=\"modal.entity===\'provider\'\" ui-sref=\"efimob.settings({tab: null})\">{{modal.provider.id}}</a> <a ng-if=\"modal.entity===\'organization\'\" ui-sref=\"efimob.organizations.item({id: modal.organization.id, tab: null})\">{{modal.organization.id}}</a> <a ng-if=\"modal.entity===\'group\'\" ui-sref=\"efimob.groups.item({id: modal.group.id, organization: modal.organizationId, tab: null})\">{{modal.group.name}}</a> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-edit mr\"></i> <span>{{\'ACTION.EDIT_ROLE.DO_EDIT\' | translate}}</span> </button> </div>");
$templateCache.put("app/views/modals/inspect-operation.html","<div class=modal-header> <h3 class=modal-title translate=\"{{ \'INSPECT_OPERATION\' }}\"> </h3> </div> <div class=\"modal-body wizard\"> <form name=forms.modal novalidate> <div class=intro>{{\'LOCATIONS\' | translate}}</div> <locations-table-component data=modal.locationTableData api=modal.locationTableApi> </locations-table-component> </form> </div> <div class=modal-footer> <button class=\"btn btn-primary\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/move-group.html","<div class=modal-header> <h3 class=modal-title translate=GROUPS_MOVE_GROUP_MOVING_GROUP translate-value-name=\"<accent>{{modal.group.name}}</accent>\"></h3> </div> <div class=modal-body> <p class=\"text-center mt-md\"><span class=bold>{{\'GROUPS_MOVE_GROUP_FROM\' | translate}}:</span> <accent ng-show=modal.from>{{modal.from.name}}</accent><i ng-show=!modal.from>{{\'GROUPS_MOVE_GROUP_ORGANIZATION_ROOT\' | translate}}</i></p> <p class=text-center><span class=bold>{{\'GROUPS_MOVE_GROUP_TO\' | translate}}:</span> <accent ng-show=modal.to>{{modal.to.name}}</accent><i ng-show=!modal.to>{{\'GROUPS_MOVE_GROUP_ORGANIZATION_ROOT\' | translate}}</i></p> <div class=help translate=GROUPS_MOVE_GROUP_BY_DOING_THIS translate-value-name=\"<accent>{{modal.group.name}}</accent>\"></div> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.cancelMoveGroup()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=\"ctrl.moveGroup(modal.group, modal.to)\">{{\'GROUPS_MOVE_GROUP_MOVE_GROUP\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/new-diagnostic.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'CH.ACTIONS.GET_DIAGNOSTICS.NEW_DIAGNOSTIC\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'range\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.TIME_RANGE\' | translate}}</label> <select name=presetRange ng-model=modal.presetRange class=form-control ng-options=\"presetRange as presetRange.display for presetRange in modal.presetRanges\"></select> </div> <div ng-show=\"modal.presetRange.id===\'custom\'\" class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.FROM\' | translate}}</label> <div class=input-group> <input name=from type=text class=form-control style=width:120px ng-model=modal.inputs.from.value uib-datepicker-popup={{modal.inputs.from.format}} on-open-focus=false is-open=modal.inputs.from.opened datepicker-options=modal.inputs.from.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.inputs.from.opened=!modal.inputs.from.opened\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <div ng-show=\"modal.presetRange.id===\'custom\'\" class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.TO\' | translate}}</label> <div class=input-group> <input name=to type=text class=form-control style=width:120px ng-model=modal.inputs.to.value uib-datepicker-popup={{modal.inputs.to.format}} on-open-focus=false is-open=modal.inputs.to.opened datepicker-options=modal.inputs.to.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.inputs.to.opened=!modal.inputs.to.opened\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CH.ACTIONS.GET_DIAGNOSTICS.GETTING_NEW_DIAGNOSTICS_FOR translate-value-name=\"<accent>{{modal.chargepoint.name}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.FTP_DIRECTORY\' | translate}}</label> <input name=location ng-model=modal.diagnostic.location type=text class=form-control auto-select-all autofocus-on=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> </div> <p class=help>{{\'CH.ACTIONS.GET_DIAGNOSTICS.FTP_DIRECTORY_HELP\' | translate}}</p> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.RETRIES_POLICY\' | translate}}</label> <select name=retryPolicy ng-model=modal.retryPolicy class=form-control ng-options=\"retryPolicy as retryPolicy.display for retryPolicy in modal.retryPolicies\"></select> </div> <p class=help>{{\'CH.ACTIONS.GET_DIAGNOSTICS.RETRIES_POLICY_HELP\' | translate}}</p> <div ng-show=\"modal.retryPolicy.id===\'custom\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.RETRIES_NUMBER\' | translate}}</label> <input name=retries ng-model=modal.inputs.retries.value type=number class=form-control> </div> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.TIME_BETWEEN_RETRIES\' | translate}}</label> <input name=retryInterval ng-model=modal.inputs.retryInterval.value type=number class=form-control> </div> <p class=help>{{\'CH.ACTIONS.GET_DIAGNOSTICS.TIME_BETWEEN_RETRIES_HELP\' | translate}}</p> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CH.ACTIONS.GET_DIAGNOSTICS.GETTING_NEW_DIAGNOSTICS_FOR translate-value-name=\"<accent>{{modal.chargepoint.name}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\" class=close-to-edge> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.DIAGNOSTIC_TIME_RANGE\' | translate}}</label> <div ng-show=\"modal.presetRange.id!=\'custom\'\">{{modal.presetRange.display}}</div> <div ng-show=\"modal.presetRange.id===\'custom\'\"> <span ng-show=\"!modal.diagnostic.startTime && !modal.diagnostic.stopTime\">{{\'CH.ACTIONS.GET_DIAGNOSTICS.TIME_RANGE_ALL\' | translate}}</span> <span ng-show=\"modal.diagnostic.startTime && !modal.diagnostic.stopTime\"> <span translate=CH.ACTIONS.GET_DIAGNOSTICS.TIME_RANGE_FROM translate-value-start=\"<accent-alt>{{modal.diagnostic.startTime | toDate}}</accent-alt>\"></span> </span> <span ng-show=\"!modal.diagnostic.startTime && modal.diagnostic.stopTime\"> <span translate=CH.ACTIONS.GET_DIAGNOSTICS.TIME_RANGE_TO translate-value-end=\"<accent-alt>{{modal.diagnostic.stopTime | toDate}}</accent-alt>\"></span> </span> <span ng-show=\"modal.diagnostic.startTime && modal.diagnostic.stopTime\"> <span translate=CH.ACTIONS.GET_DIAGNOSTICS.TIME_RANGE_FROM_TO translate-value-start=\"<accent-alt>{{modal.diagnostic.startTime | toDate}}</accent-alt>\" translate-value-end=\"<accent-alt>{{modal.diagnostic.stopTime | toDate}}</accent-alt>\"></span> </span> </div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.FTP_DIRECTORY\' | translate}}</label> <div uib-tooltip={{modal.diagnostic.location}}>{{modal.diagnostic.location}}</div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.GET_DIAGNOSTICS.RETRIES_POLICY\' | translate}}</label> <div ng-show=\"modal.retryPolicy.id===\'localPolicy\'\">{{modal.retryPolicy.display}}</div> <div ng-show=\"modal.retryPolicy.id===\'custom\'\"> <span translate=CH.ACTIONS.GET_DIAGNOSTICS.CUSTOM_RETRIES translate-value-n={{modal.diagnostic.retries}} translate-value-s={{modal.diagnostic.retryInterval}}></span> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-file-medical-alt mr\"></i>{{\'CH.ACTIONS.GET_DIAGNOSTICS.DO_GET_DIAGNOSTICS\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/pick-chargepoint.html","<div class=modal-header> <h3> <span class=modal-title>{{\'ACTION.PICK_CHARGEPOINTS.TITLE\' | translate}}</span> <span class=spinner ng-show=\"pickChargepointModal.state==\'loading\'\"><div></div></span> </h3> </div> <div class=modal-body> <form name=form novalidate> <div class=\"inline-flex width-full\"> <select name=by ng-model=pickChargepointModal.filter.by ng-change=pickChargepointModal.reloadResults() class=\"form-control width-150 mr-s\" ng-options=\"byOption.id as byOption.display for byOption in pickChargepointModal.byOptions\"> </select> <div class=width-full> <div ng-show=\"pickChargepointModal.filter.by===\'name\'\"> <div class=form-group> <input autofocus-on=\"pickChargepointModal.filter.by===\'name\'\" name=byName type=text class=form-control ng-model=pickChargepointModal.filter.name ng-keyup=pickChargepointModal.reloadResults()> </div> </div> <div ng-show=\"pickChargepointModal.filter.by===\'group\'\" class=\"inline-flex width-full\"> <select ng-model=pickChargepointModal.filter.organization class=\"form-control width-200 mr-s\" ng-change=pickChargepointModal.onOrganizationChanged() ng-options=\"organization.id as ( organization.name ) for organization in Cache.organization | sortedOrganizations\"></select> <select ng-model=pickChargepointModal.filter.group class=form-control ng-change=pickChargepointModal.reloadResults() ng-options=\"group.id as group.name for group in pickChargepointModal.groups[pickChargepointModal.filter.organization]\"></select> </div> <div ng-show=\"pickChargepointModal.filter.by===\'id\'\"> <div class=form-group> <input autofocus-on=\"pickChargepointModal.filter.by===\'id\'\" name=byId type=text class=form-control ng-model=pickChargepointModal.filter.id ng-keyup=pickChargepointModal.reloadResults()> </div> </div> <div ng-show=\"pickChargepointModal.filter.by===\'idList\'\"> <div class=form-group> <textarea name=byIdList class=form-control rows=3 autofocus-on=\"pickChargepointModal.filter.by===\'idList\'\" ng-model=pickChargepointModal.filter.idList ng-keyup=pickChargepointModal.reloadResults()></textarea> </div> </div> </div> </div> </form> <div class=\"searchResults mt-m\" ng-show=pickChargepointModal.results state={{modal.state}}> <h4>{{\'ACTION.PICK_CHARGEPOINTS.RESULTS\' | translate}}</h4> <ul ng-show=\"pickChargepointModal.results.length > 0\"> <widget-table params=pickChargepointModal.table items=pickChargepointModal.results></widget-table> </ul> <span ng-show=\"pickChargepointModal.results.length < 1\">{{\'ACTION.PICK_CHARGEPOINTS.NO_ITEMS\' | translate}}</span> </div> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=pickChargepointModal.close()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary active\" type=button ng-disabled=\"!(pickChargepointModal.table.selected.length > 0)\" ng-click=pickChargepointModal.done()> <span ng-show=\"!(pickChargepointModal.table.selected.length > 0)\" translate=ACTION.PICK_CHARGEPOINTS.DO_OK_NONE></span> <span ng-show=\"(pickChargepointModal.table.selected.length > 0)\" translate=ACTION.PICK_CHARGEPOINTS.DO_OK translate-value-total={{pickChargepointModal.table.selected.length}}></span> </button> </div>");
$templateCache.put("app/views/modals/preview-html.html","<div class=modal-body> <div bind-html-compile=modal.content></div> </div> <div class=modal-footer> <button class=\"btn btn-primary active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'W.PROPS.PREVIEW_OK\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/property-changed-confirmation.html","<div class=modal-header> <h3 ng-if=!modal.remove class=modal-title translate=W.PROPS.CONFIRM_PROPERTY_CHANGE translate-value-property=\"<accent>{{modal.header}}</accent>\"></h3> <h3 ng-if=modal.remove class=modal-title translate=W.PROPS.CONFIRM_PROPERTY_DEL translate-value-property=\"<accent>{{modal.header}}</accent>\"></h3> </div> <div class=modal-body> <p ng-show=modal.message bind-html-compile=modal.message></p> <div ng-show=modal.warning class=warning bind-html-compile=modal.warning></div> </div> <div class=modal-footer> <button class=\"btn btn-light active\" ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=ctrl._confirmChangedKey(modal.key)>{{(modal.remove? (\'W.PROPS.DO_CONFIRM_DEL\' | translate) : (\'W.PROPS.DO_CONFIRM_CHANGE\' | translate))}}</button> </div>");
$templateCache.put("app/views/modals/remove-banner.html","<div class=modal-header> <h3 class=modal-title>{{\'ACTION.REMOVE_BANNER.DO_REMOVING\' | translate}}</h3> </div> <div class=modal-body> <p translate=ACTION.REMOVE_BANNER.REMOVE_BANNER translate-value-name=\"<accent>{{modal.banner.title.es}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'ACTION.REMOVE_BANNER.REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-chargepoint.html","<div class=modal-body> <h4 translate=CH.ACTIONS.REMOVE_CHARGEPOINT.REMOVING translate-value-name=\"<accent>{{modal.chargepoint.name}}</accent>\"></h4> <p class=help>{{\'CH.ACTIONS.REMOVE_CHARGEPOINT.REMOVING_HELP\' | translate}}</p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=ctrl.removeChargepoint(modal.chargepoint)>{{\'CH.ACTIONS.REMOVE_CHARGEPOINT.DO_REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-consent.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_CONSENT\' | translate}}</h3> </div> <div class=modal-body> <p translate=ASK_REMOVE_CONSENT translate-value-name=\"<accent>{{modal.data.id}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\"> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-danger\" type=button ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'COMMON.REMOVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/remove-customer.html","<div class=modal-body> <h4 class=text-center translate=CUSTOMER_VIEW.REMOVE_CUSTOMER_ARE_YOU_SURE translate-value-name=\"<accent>{{modal.customer.name}}</accent>\"></h4> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=ctrl.removeCustomer(modal.customer)>{{\'CUSTOMER_VIEW.REMOVE_CUSTOMER\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-group-userkey.html","<div class=modal-body> <h4 class=text-center>{{\'GROUP_ACTIONS_REMOVE_USERKEY_REMOVING\' | translate}}</h4> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=ctrl.removeUserkey(modal.userkey)>{{\'GROUP_ACTIONS_REMOVE_USERKEY_REVOKE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-group.html","<div class=modal-body> <h4 class=text-center translate=GROUPS_REMOVE_GROUP_REMOVING_GROUP translate-value-name=\"<accent>{{modal.group.name}}</accent>\"></h4> <p class=text-center>{{\'GROUPS_REMOVE_GROUP_DISCLAIMER\' | translate}}</p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=modal.done()>{{\'GROUPS_REMOVE_GROUP_REMOVE_GROUP\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-holiday.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_HOLIDAY\' | translate}}</h3> </div> <div class=modal-body> <p translate=REMOVE_HOLIDAY_ARE_YOU_SURE translate-value-country=\"<accent>{{modal.data.country | countryCodeToName}}</accent>\" translate-value-date=\"<accent>{{modal.data.date | date:\'dd/MM/yyyy\'}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\"> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-danger\" type=button ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'COMMON.REMOVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/remove-maintainer.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_MAINTAINER\' | translate}}</h3> </div> <div class=modal-body> <p translate=\"{{\'REMOVE_MAINTAINER_ARE_YOU_SURE\'}}\" translate-value-name=\"<accent>{{modal.maintainer.companyName}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()> <i class=\"fal fa-ban mr\"></i>{{\'REMOVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/remove-margin.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_MARGIN\' | translate}}</h3> </div> <div class=modal-body> <p translate=REMOVE_MARGIN_ARE_YOU_SURE translate-value-name=\"<accent>{{modal.margin.name}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-operation.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_OPERATION\' | translate}}</h3> </div> <div class=modal-body> <p translate=REMOVE_OPERATION_ARE_YOU_SURE translate-value-name=\"<accent>{{modal.operation.name}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-organization.html","<div class=modal-body> <h4 class=text-center translate=ORGANIZATIONS.MODAL.REMOVE_CONFIRM translate-value-name=\"<accent>{{modal.organization.name}}</accent>\"></h4> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=ctrl.removeOrganization(modal.organization)>{{\'ORGANIZATIONS.MODAL.DO_REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-owner.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_OWNER\' | translate}}</h3> </div> <div class=modal-body> <p translate=ASK_REMOVE_OWNER translate-value-name=\"<accent>{{modal.data.name}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\"> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-danger\" type=button ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'COMMON.REMOVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/remove-programed_reboot.html","<div class=modal-header> <h3 class=modal-title>{{\'ACTION.REMOVE_PROGRAMED_REBOOT.DO_REMOVING\' | translate}}</h3> </div> <div class=modal-body> <p translate=ACTION.REMOVE_PROGRAMED_REBOOT.REMOVE_BANNER translate-value-name=\"<accent>{{modal.programedReboot.period}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'ACTION.REMOVE_PROGRAMED_REBOOT.REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-proxy.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_PROXY\' | translate}}</h3> </div> <div class=modal-body> <p translate=ASK_REMOVE_PROXY translate-value-name=\"<accent>{{modal.data.name}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\"> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-danger\" type=button ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'COMMON.REMOVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/remove-recharging-schedule.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_RECHARGE_OF_SCHEDULE\' | translate}}</h3> </div> <div class=modal-body> <p translate=REMOVE_RECHARGE_OF_SCHEDULE_BETWEEN translate-value-name={{modal.removed_period}}></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()> <i class=\"fal fa-times mr\"></i>{{\'REMOVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/remove-restriction.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_RESTRICTION\' | translate}}</h3> </div> <div class=modal-body> <p translate=REMOVE_RESTRICTION_ARE_YOU_SURE translate-value-name=\"<accent>{{modal.restriction.name}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-tariff.html","<div class=modal-header> <h3 class=modal-title>{{\'REMOVE_TARIFF\' | translate}}</h3> </div> <div class=modal-body> <p translate=REMOVE_TARIFF_ARE_YOU_SURE translate-value-name=\"<accent>{{modal.tariff.name}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-user.html","<div class=modal-header> <h3 class=modal-title>{{\'ACTION.REMOVE_ROLE.DO_REMOVING\' | translate}}</h3> </div> <div class=modal-body> <p translate=\"{{(modal.group? \'ACTION.REMOVE_ROLE.REMOVE_GROUP_PERMISSIONS_FOR\' : \'ACTION.REMOVE_ROLE.REMOVE_ORGANIZATIONS_PERMISSIONS_FOR\')}}\" translate-value-name=\"<accent>{{modal.user.username}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-ban mr\"></i>{{\'ACTION.REMOVE_ROLE.REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-userkey-from-domestic-chargepoint.html","<div class=modal-body> <h4 translate=CH.ACTIONS.REMOVE_KEY.REMOVE_KEY translate-value-id=\"<accent>{{modal.userkey.idToken}}</accent>\"></h4> <p class=help>{{\'CH.ACTIONS.REMOVE_KEY.HELP\' | translate}}</p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=ctrl.removeUserkey(modal.userkey)>{{\'CH.ACTIONS.REMOVE_KEY.DO_REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/remove-userkey.html","<div class=modal-body> <h4 translate=USERKEY.REMOVE.REMOVE translate-value-id=\"<accent>{{modal.userkey.idToken}}</accent>\"></h4> <p class=help>{{\'USERKEY.REMOVE.HELP\' | translate}}</p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\">{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-danger\" type=button ng-click=ctrl.removeUserkey(modal.userkey)>{{\'USERKEY.REMOVE.DO_REMOVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/set-userkey-blocked.html","<div class=modal-header> <h3 ng-show=!modal.userkey.blocked class=modal-title translate=USERKEY.BLOCK.LOCK translate-value-id=\"<accent>{{modal.userkey.idToken}}</accent>\"></h3> <h3 ng-show=modal.userkey.blocked class=modal-title translate=USERKEY.BLOCK.UNLOCK translate-value-id=\"<accent>{{modal.userkey.idToken}}</accent>\"></h3> </div> <div class=modal-body> <div ng-show=!modal.userkey.blocked>{{\'USERKEY.BLOCK.CONFIRM_PLEASE\' | translate}}</div> <p ng-show=!modal.userkey.blocked class=help>{{\'USERKEY.BLOCK.USERS_NO_LONGER\' | translate}}</p> <div ng-show=modal.userkey.blocked>{{\'USERKEY.BLOCK.KEY_WILL_BE_ACTIVE\' | translate}}</div> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=!modal.userkey.blocked class=\"btn btn-warning\" type=button ng-click=modal.done()><i class=\"fal fa-lock-alt mr\"></i>{{\'USERKEY.BLOCK.DO_LOCK\' | translate}}</button> <button ng-show=modal.userkey.blocked class=\"btn btn-primary\" type=button ng-click=modal.done()><i class=\"fal fa-unlock-alt mr\"></i>{{\'USERKEY.BLOCK.DO_UNLOCK\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/start-remote-transaction.html","<div class=modal-header> <h3 class=modal-title translate=CH.ACTIONS.SRT.STARTING translate-value-name=\"<accent>{{modal.connector.id}}</accent>\"></h3> </div> <div class=modal-body> <form name=form novalidate> <div class=form-group> <label>{{\'CH.ACTIONS.SRT.AUTH_USERKEYS\' | translate}}</label> <select-component item=modal.userKey items=modal.userKeys custom-display=modal.displayForUserKeys on-search=modal.onSearch search style=\"min-width: 50%\"> </select-component> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=modal.done()>{{\'CH.ACTIONS.SRT.DO_START\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/tfa-setup.html","<div class=modal-header> <h3 class=modal-title>{{\'PROFILE.TFA.TITLE\' | translate}}</h3> </div> <div class=modal-body> <strong>{{\'PROFILE.TFA.HELP\' | translate}}</strong><br> <p class=text-center> <img src={{ctrl.modal.dataUrl}}> <small>{{ctrl.modal.tempSecret}}</small> </p> <form name=form novalidate> <div class=form-group> <label>{{\'PROFILE.TFA.INPUT\' | translate}}</label> <input name=authcode ng-model=ctrl.modal.authcode class=form-control placeholder=\"{{\'PROFILE.TFA.YOUR_CODE\' | translate}}\"> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-info\" type=button ng-click=ctrl.modal.done()><i class=\"fal fa-save mr\"></i>{{\'PROFILE.TFA.SAVE\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/unassign-maintainer.html","<div class=modal-header> <h3 class=modal-title>{{\'UNASSIGN_MAINTAINER\' | translate}}</h3> </div> <div class=modal-body> <p translate=\"{{\'UNASSIGN_MAINTAINER_ARE_YOU_SURE\'}}\" translate-value-name=\"<accent>{{modal.maintainer.companyName}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=\"ctrl.App.closeModal(\'dismiss\')\"> {{\'COMMON.CANCEL\' | translate}} </button> <button class=\"btn btn-danger\" type=button ng-click=modal.done()><i class=\"fal fa-ban mr\"></i>{{\'UNASSIGN\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/unbind-userkey.html","<div class=modal-header> <h3 class=modal-title>{{\'USERKEY.UNBIND.UNBIND\' | translate}}</h3> </div> <div class=modal-body> <div ng-show=!modal.userkey.blocked translate=USERKEY.UNBIND.HELP translate-value-name=\"<accent>{{modal.userkey.customerName}}</accent>\"></div> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=modal.done()>{{\'USERKEY.UNBIND.DO_UNBIND\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/unblock-user.html","<div class=modal-header> <h3 class=modal-title>{{\'ACTION.UNBLOCK.CUSTOMER\' | translate}}</h3> </div> <div class=modal-body> <p translate=ACTION.UNBLOCK.CUSTOMER_ARE_YOU_SURE translate-value-name=\"<accent>{{modal.user}}</accent>\"></p> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-warning\" type=button ng-disabled=forms.modal.$invalid ng-click=modal.done()><i class=\"fal fa-times mr\"></i>{{\'ACTION.UNBLOCK.DO\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/unlock-chargepoint-connector.html","<div class=modal-header> <h3 class=modal-title translate=CH.ACTIONS.UNLOCK.UNLOCKING translate-value-name=\"<accent>{{modal.connector.id}}</accent>\"></h3> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=modal.done()>{{\'CH.ACTIONS.UNLOCK.DO_UNLOCK\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/update-firmware.html","<div class=modal-header> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> <h3> <span class=modal-title>{{\'CH.ACTIONS.UPDATE_FW.UPDATING\' | translate}}</span> <span class=spinner ng-show=\"modal.state==\'loading\'\"> <div></div> </span> </h3> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=form novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.FTP_DIRECTORY\' | translate}}</label> <input name=location ng-model=modal.firmware.location type=text class=form-control auto-select-all autofocus-on=\"modal.wizard.steps[modal.wizard.step].id===\'location\'\"> </div> <p class=help>{{\'CH.ACTIONS.UPDATE_FW.FTP_DIRECTORY_HELP\' | translate}}</p> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.RETRIES_POLICY\' | translate}}</label> <select name=retryPolicy ng-model=modal.retryPolicy class=form-control ng-options=\"retryPolicy as retryPolicy.display for retryPolicy in modal.retryPolicies\"></select> </div> <p class=help>{{\'CH.ACTIONS.UPDATE_FW.RETRIES_POLICY_HELP\' | translate}}</p> <div ng-show=\"modal.retryPolicy.id===\'custom\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.RETRIES_NUMBER\' | translate}}</label> <input name=retries ng-model=modal.inputs.retries.value type=number class=form-control> </div> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.TIME_BETWEEN_RETRIES\' | translate}}</label> <input name=retryInterval ng-model=modal.inputs.retryInterval.value type=number class=form-control> </div> <p class=help>{{\'CH.ACTIONS.UPDATE_FW.TIME_BETWEEN_RETRIES_HELP\' | translate}}</p> </div> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CH.ACTIONS.UPDATE_FW.UPDADING_FW_FOR translate-value-name=\"<accent>{{modal.chargepoint.name}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'retrieve\'\"> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.AVAILABLE_FROM_DATE\' | translate}}</label> <div class=input-group> <input name=from type=text class=form-control style=width:120px ng-model=modal.inputs.from.value uib-datepicker-popup={{modal.inputs.from.format}} on-open-focus=false is-open=modal.inputs.from.opened datepicker-options=modal.inputs.from.options show-button-bar=false> <span class=input-group-append> <button type=button class=\"btn btn-light active\" ng-click=\"modal.inputs.from.opened=!modal.inputs.from.opened\"><i class=\"fal fa-calendar\"></i></button> </span> </div> </div> <p class=help>{{\'CH.ACTIONS.UPDATE_FW.AVAILABLE_FROM_DATE_HELP\' | translate}}</p> <div class=\"help colophon\"><i class=\"fal fa-info mr\"></i><span translate=CH.ACTIONS.UPDATE_FW.UPDADING_FW_FOR translate-value-name=\"<accent>{{modal.chargepoint.name}}</accent>\"></span></div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\" class=close-to-edge> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.FTP_DIRECTORY\' | translate}}</label> <div uib-tooltip={{modal.firmware.location}}>{{modal.firmware.location}}</div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.RETRIES_POLICY\' | translate}}</label> <div ng-show=\"modal.retryPolicy.id===\'localPolicy\'\">{{modal.retryPolicy.display}}</div> <div ng-show=\"modal.retryPolicy.id===\'custom\'\" translate=CH.ACTIONS.UPDATE_FW.CUSTOM_RETRIES translate-value-n={{modal.firmware.retries}} translate-value-s={{modal.firmware.retryInterval}}> </div> </div> <div class=form-group> <label>{{\'CH.ACTIONS.UPDATE_FW.AVAILABLE_DATE\' | translate}}</label> <div translate=CH.ACTIONS.UPDATE_FW.TIME_RANGE_FROM translate-value-start=\"<accent-alt>{{modal.firmware.retrieveDate | toDate}}</accent-alt>\"> </div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()>{{\'COMMON.CANCEL\' | translate}}</button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=\"(modal.wizard.step=modal.wizard.step-1)\">{{\'COMMON.PREV\' | translate}}</button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=\"modal.next(modal); (modal.wizard.step=modal.wizard.step+1)\">{{\'COMMON.NEXT\' | translate}}</button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"!modal.isValid(modal, this)\" ng-click=modal.done()> <i class=\"fal fa-box-alt mr\"></i>{{\'CH.ACTIONS.UPDATE_FW.DO_UPDATE_FW\' | translate}}</button> </div>");
$templateCache.put("app/views/modals/upload-xlsx-file.html","<div class=modal-header> <h3>{{\'UPLOAD_XLSX_FILE\' | translate}}</h3> </div> <div class=\"upload-xlsx-file-modal-body modal-body\"> <div ng-if=\"modal.tab === 0\"> <div class=message> <p ng-bind-html=\"\'UPLOAD_FILE_TEMPLATE_DOWNLOAD\' | translate: { xlsxFilePath: \'assets/templates/userkeys-template.xlsx\' }\"> </p> </div> <upload-file disabled=modal.isUploading external-error-message=modal.externalErrorMessage max-file-size-attr=3145728 allowed-extensions=\"[\'.xlsx\']\" allowed-types=\"[\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\']\" on-file-selected=modal.onFileSelected(file) on-upload-success=modal.onUploadSuccess(file) on-file-removed=modal.onFileRemoved()> </upload-file> </div> <div ng-if=\"modal.tab === 1\"> <div class=error-list-table> <div class=error-list-table-header> <div class=error-list-table-cell>{{\'UPLOAD_ID_TOKEN_FIELD\' | translate}}</div> <div class=error-list-table-cell>{{\'UPLOAD_ERROR_FIELD\' | translate}}</div> </div> <div class=error-list-table-body> <div class=error-list-table-row ng-repeat=\"error in modal.errorList\"> <div class=error-list-table-cell>{{error.token.idToken}}</div> <div class=error-list-table-cell>{{error.error}}</div> </div> </div> </div> </div> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=ctrl.App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <div ng-if=\"modal.tab === 0\"> <button ng-if=!modal.errorList class=\"btn btn-primary\" type=button ng-disabled=\"modal.isUploading || !modal.file || modal.externalErrorMessage\" ng-click=modal.done()> {{\'UPLOAD_FILE\' | translate}} </button> <button ng-if=modal.errorList class=\"btn btn-primary\" type=button ng-click=modal.changeTab(1)> {{\'UPLOAD_SHOW_ERRORS\' | translate}} </button> </div> <div ng-if=\"modal.tab === 1\"> <button class=\"btn btn-primary\" type=button ng-click=modal.changeTab(0)> {{\'APP.ACTION.BACK\' | translate}} </button> </div> </div>");
$templateCache.put("app/views/modals/upsert-location-to-tariff.html","<div class=modal-header> <h3 class=modal-title>{{\'ADD_ZONE\' | translate}}</h3> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'configuration\'\"> <locations-table-component data=modal.configurationView.locationTableData api=modal.configurationView.locationTableApi> </locations-table-component> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'locations\'\"> <locations-table-component data=modal.locationView.locationTableData api=modal.locationView.locationTableApi> </locations-table-component> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'LOCATIONS\' | translate}}</label> <div>{{modal.locationView.locationTableData.locations | locationsToList}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=modal.close()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.done(modal)> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/upsert-margin.html","<div class=modal-header> <h3 class=modal-title translate=\"{{ modal.isEdit ? \'EDIT_MARGIN\' : \'ADD_MARGIN\' }}\"> </h3> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'configuration\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <input name=name ng-model=modal.margin.name type=text class=form-control autofocus required> </div> <div class=form-group> <label>{{\'FLAT\' | translate}}</label> <div class=flex-direction-column> <label>{{\'PRICE_WITH_TAXES\' | translate}}</label> <div class=inline-flex> <input min=0 max=999.999 name=fixed step=0.001 ng-model=modal.flatWithVat type=number class=\"form-control width-120\" decimal-number=3> <span class=ml-xs></span> <span class=ml-xs>€</span> </div> </div> <div class=inline-flex> <i class=\"fa fa-arrow-alt-right ml-s mr-s\"></i> </div> <div class=flex-direction-column> <label>{{\'PRICE_WITHOUT_TAXES\' | translate}}</label> <div class=inline-flex> <input name=price-without-vat type=number class=\"form-control width-150\" ng-model=modal.margin.flat recalculate-price operation=withoutVat source-price=modal.flatWithVat target-price=modal.margin.flat vat=modal.margin.vat disabled=disabled> <span class=ml-xs></span> <span class=ml-xs>€</span> </div> </div> </div> <div class=form-group> <label>{{\'PERCENTAGE\' | translate}}</label> <div class=inline-flex> <md-autocomplete class=vat-autocomplete md-autocomplete-focus-open md-search-text=modal.percentageView md-selected-item=modal.selectedPercentage md-items=\"item in modal.marginPercentageOptions\" md-item-text=item.display vat-autocomplete=modal.margin.percentage only-numbers> <span ng-class=\"{\'highlight\': item.display == modal.percentageView}\">{{item.display}}</span> </md-autocomplete> <span class=ml-xs> <span class=ml-xs>%</span> </span> </div> </div> <div class=form-group> <label>{{\'TAXES\' | translate}}</label> <div class=inline-flex> <md-autocomplete class=vat-autocomplete md-autocomplete-focus-open md-search-text=modal.vatView md-selected-item=modal.selectedVat md-items=\"item in modal.marginVatOptions\" md-item-text=item.display vat-autocomplete=modal.margin.vat only-numbers> <span md-highlight-text=modal.vatView>{{item.display}}</span> </md-autocomplete> <span class=ml-xs> <span class=ml-xs>%</span> </span> </div> </div> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <div>{{modal.margin.name}}</div> </div> <div class=form-group> <label>{{\'FLAT\' | translate}}</label> <div>{{modal.margin.flat | calculatePriceWithVat: modal.margin.vat}} € <span uib-tooltip=\"{{\'PRICE_WITH_TAXES\' | translate}}\" class=info-hint aria-hidden=false></span></div> </div> <div class=form-group> <label>{{\'PERCENTAGE\' | translate}}</label> <div>{{modal.margin.percentage}} %</div> </div> <div class=form-group> <label>{{\'TAXES\' | translate}}</label> <div>{{modal.margin.vat}} %</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.done(modal)> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/upsert-operation.html","<div class=modal-header> <h3 class=modal-title translate=\"{{ modal.isEdit ? \'EDIT_OPERATION\' : \'ADD_OPERATION\' }}\"> </h3> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'name\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <input name=name ng-model=modal.operation.name type=text class=form-control autofocus required> </div> <p class=\"help margin-bottom-unset\">{{\'IDENTIFICATION_LOCATIONS_WITH_EXAMPLE\' | translate}}</p> <p class=\"help text-danger\" ng-show=\"forms.modal.name.$error.required && forms.modal.name.$touched\"> {{ \'NAME_FIELD_IS_REQUIRED\' | translate }} </p> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'configuration\'\"> <locations-table-component data=modal.configurationView.locationTableData api=modal.configurationView.locationTableApi> </locations-table-component> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'locations\'\"> <locations-table-component data=modal.atomicView.locationTableData api=modal.atomicView.locationTableApi> </locations-table-component> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'agreements\'\"> <dual-list-component data=modal.agreementView.dualListData api=modal.agreementView.dualListApi></dual-list-component> </div> <div ng-show=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <div class=form-group> <label>{{\'NAME\' | translate}}</label> <div>{{modal.operation.name}}</div> </div> <div class=form-group> <label>{{\'LOCATIONS\' | translate}}</label> <div>{{modal.atomicView.locationTableData.locations | locationsToList}}</div> </div> <div class=form-group> <label>{{\'AGREEMENTS\' | translate}}</label> <div>{{modal.agreementView.dualListData.assigned | agreementsToNameList}}</div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"forms.modal.$invalid || !modal.isValid(modal, this)\" ng-click=modal.done(modal)> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/modals/upsert-restriction.html","<div class=modal-header> <h3 class=modal-title translate=RESTRICTION></h3> <div class=path> <div ng-repeat=\"step in modal.wizard.steps\" class=step ng-class=\"{\'current\': ($index == modal.wizard.step), \'done\': ($index < modal.wizard.step)}\"> <span class=number>{{$index+1}}</span>{{step.title}} </div> </div> </div> <div class=\"modal-body wizard\" state={{modal.state}}> <form name=forms.modal novalidate> <div class=intro>{{modal.wizard.steps[modal.wizard.step].intro}}</div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'general\'\"> <div class=form-group> <label>{{\'VALID_HOURS\' | translate}}</label> <widget-slider name=hour-range range=modal.startEndTimeSlider.value params=modal.startEndTimeSlider.options on-change=modal.startEndTimeSlider.onChange hour-range-validator> </widget-slider> </div> <div class=form-group> <label>{{\'DAYS\' | translate}}</label> <multi-select-component class=width-full item=modal.daysOfWeek items=modal.daysOfWeekOptions field=\"\'display\'\" search days-of-week-validator> </multi-select-component> </div><!-- <div class=\"form-group\">\n        <label>{{\'IS_HOLIDAY\' | translate}}</label>\n        <widget-switch model=\"modal.restriction.isHoliday\"></widget-switch>\n      </div>\n      <div class=\"mt-n3 mb-2 text-start\" style=\"margin-left: 20%;\">\n        <span class=\"help\">{{\'SPECIFY_IF_TARIFF_APPLIES_ON_HOLIDAYS\' | translate}}</span>\n      </div> --> <div class=\"form-group flex-row align-items-center\"> <label>{{\'TIME_STRETCH\' | translate}}</label> <widget-switch model=modal.withDuration on-change=modal.reviewSteps on-change-arg=\"\'duration\'\" clear-duration-on-disable> </widget-switch> </div> <div class=\"mt-n3 mb-2 text-start\" style=\"margin-left: 20%\"> <span class=help>{{\'ENABLE_TARIFF_BY_DURATION\' | translate}}</span> </div> <div class=\"form-group flex-row align-items-center\"> <label>{{\'ENERGY_STRETCH\' | translate}}</label> <widget-switch model=modal.withEnergy on-change=modal.reviewSteps on-change-arg=\"\'energy\'\" clear-energy-on-disable> </widget-switch> </div> <div class=\"mt-n3 mb-2 text-start\" style=\"margin-left: 20%\"> <span class=help style=\"margin-top: -6px\"> {{\'ENABLE_TARIFF_BY_ENERGY\' | translate}} </span> </div> <div class=form-group> <div class=\"mt-n3 mb-2 text-start margin-top-10\" style=\"margin-left: 20%\"> <span class=help>{{\'ENERGY_TIME_RESTRICTION_NOTE\' | translate}}</span> </div> </div> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'duration\'\"> <div class=form-group> <div class=flex-column> <div> <div class=\"nowrap mr-xs\"> {{\'FROM\' | translate}} <span class=\"accent-alt ml-xs\" uib-tooltip=\"{{\'MINIMUM_DURATION_THRESHOLD\' | translate}}\"> <i class=\"fa fa-info-circle help-hint\"></i> </span> </div> <input type=number min=0 name=minDuration class=form-control ng-model=modal.restriction.minDuration ng-init=\"modal.restriction.minDuration = modal.restriction.minDuration || 0\" min-duration=modal.restriction.minDuration max-duration=modal.restriction.maxDuration duration-validator only-numbers s-to-min required> </div> <span class=help style=\"margin-top: -6px\"> {{\'MINUTES\' | translate}} </span> </div> <div class=flex-column> <div> <div class=\"nowrap mr-xs\"> {{\'TO\' | translate}} <span class=\"accent-alt ml-xs\" uib-tooltip=\"{{\'MAXIMUM_DURATION_THRESHOLD\' | translate}}\"> <i class=\"fa fa-info-circle help-hint\"></i> </span> </div> <md-autocomplete class=range-autocomplete md-search-text=modal.maxDurationView md-selected-item=modal.selectedMaxDuration md-items=\"item in modal.maxDurationOptions\" md-item-text=item.display s-to-min-autocomplete=modal.restriction.maxDuration only-numbers> <span md-highlight-text=modal.maxDurationView>{{item.display}}</span> </md-autocomplete> </div> <span class=help style=\"margin-top: -6px\"> {{\'MINUTES\' | translate}} </span> </div> </div> <p class=text-danger ng-show=forms.modal.minDuration.$error.durationValidator> {{ \'INVALID_DURATION_RANGE\' | translate }} </p> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'energy\'\"> <div class=form-group> <div class=flex-column> <div> <div class=\"nowrap mr-xs\"> {{\'FROM\' | translate}} <span class=\"accent-alt ml-xs\" uib-tooltip=\"{{\'MINIMUM_ENERGY_THRESHOLD\' | translate}}\"> <i class=\"fa fa-info-circle help-hint\"></i> </span> </div> <input type=number min=0 name=minWh class=form-control ng-model=modal.restriction.minWh ng-init=\"modal.restriction.minWh = modal.restriction.minWh || 0\" min-wh=modal.restriction.minWh max-wh=modal.restriction.maxWh energy-validator only-numbers wh-to-kwh required> </div> <div class=help>{{\'KWH\' | translate}}</div> </div> <div class=flex-column> <div> <div class=\"nowrap mr-xs\"> {{\'TO\' | translate}} <span class=\"accent-alt ml-xs\" uib-tooltip=\"{{\'MAXIMUM_ENERGY_THRESHOLD\' | translate}}\"> <i class=\"fa fa-info-circle help-hint\"></i> </span> </div> <md-autocomplete class=range-autocomplete md-search-text=modal.maxWhView md-selected-item=modal.selectedMaxWh md-items=\"item in modal.maxWhOptions\" md-item-text=item.display wh-to-kwh-autocomplete=modal.restriction.maxWh only-numbers> <span md-highlight-text=modal.maxWhView>{{item.display}}</span> </md-autocomplete> </div> <div class=help>{{\'KWH\' | translate}}</div> </div> </div> <p class=text-danger ng-show=forms.modal.minWh.$error.energyValidator> {{ \'INVALID_ENERGY_RANGE\' | translate }} </p> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'cost\'\"><!-- Header --> <div style=\"display: grid; grid-template-columns: 110px 200px 140px 20px 250px; gap: 15px\"> <div class=inline-flex>{{\'TYPE\' | translate}} <span class=\"accent-alt ml-xs\" uib-tooltip=\"{{\'CHARGING_TARIFF_TYPE_EXPLANATION\' | translate}}\"> <i class=\"fa fa-info-circle help-hint\"></i> </span> </div> <div>{{\'PRICE_WITH_TAXES\' | translate}}</div> <div>{{\'TAXES\' | translate}}</div> <div></div> <div>{{\'PRICE_WITHOUT_TAXES\' | translate}}</div> </div> <price-component-cost price-components=modal.restriction.priceComponents default-price-component=modal.defaultPriceComponent price-component-type-options=modal.priceComponentTypeOptions price-component-vat-options=modal.priceComponentVatOptions price-components-validator> </price-component-cost> </div> <div ng-if=\"modal.wizard.steps[modal.wizard.step].id===\'summary\'\"> <p ng-if=modal.hasOverlapText class=\"text-danger text-center\"> {{ modal.hasOverlapText }} </p> <div class=form-group> <label>{{\'START_TIME\' | translate}}</label> <div>{{modal.restriction.startTime}}</div> </div> <div class=form-group> <label>{{\'END_TIME\' | translate}}</label> <div>{{modal.restriction.endTime}}</div> </div> <div class=form-group> <label>{{\'DAYS_OF_WEEK\' | translate}}</label> <div> {{ modal.restriction.daysOfWeek | getDaysOfWeek}}</div> </div><!--      <div class=\"form-group\">--><!--        <label>{{\'IS_HOLIDAY\' | translate}}</label>--><!--        <div>{{modal.restriction.isHoliday | yesno}}</div>--><!--      </div>--> <div ng-show=modal.withEnergy class=form-group> <label>{{\'MIN_KWH\' | translate}}</label> <div>{{modal.restriction.minWh | wToKw}}</div> </div> <div ng-show=modal.withEnergy class=form-group> <label>{{\'MAX_KWH\' | translate}}</label> <div> {{ modal.restriction.maxWh != null ? (modal.restriction.maxWh | wToKw) : (ctrl.$translate.instant(\'NO_LIMIT\')) }} </div> </div> <div ng-show=modal.withDuration class=form-group> <label>{{\'MIN_DURATION\' | translate}}</label> <div>{{modal.restriction.minDuration | sToMin}}</div> </div> <div ng-show=modal.withDuration class=form-group> <label>{{\'MAX_DURATION\' | translate}}</label> <div> {{ modal.restriction.maxDuration != null ? (modal.restriction.maxDuration | sToMin) : (ctrl.$translate.instant(\'NO_LIMIT\')) }} </div> </div> <div class=form-group> <label>{{\'RRP\' | translate}}</label> <div ng-bind-html=\"modal.restriction.priceComponents | priceComponentDescription\"></div> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-light active\" type=button ng-click=App.closeModal()> {{\'COMMON.CANCEL\' | translate}} </button> <button ng-show=\"modal.wizard.step>0\" class=\"btn btn-light active\" type=button ng-click=modal.back(modal);> {{\'COMMON.PREV\' | translate}} </button> <button ng-show=\"modal.wizard.step<modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"\n    !modal.hourRangeValid ||\n    !modal.daysOfWeekValid ||\n    (modal.priceComponentsValid !== undefined && !modal.priceComponentsValid) ||\n    forms.modal.minDuration.$error.durationValidator ||\n    forms.modal.minWh.$error.energyValidator\" ng-click=modal.next(modal);> {{\'COMMON.NEXT\' | translate}} </button> <button ng-show=\"modal.wizard.step>=modal.wizard.steps.length-1\" class=\"btn btn-primary\" type=button ng-disabled=\"\n    !modal.hourRangeValid ||\n    !modal.daysOfWeekValid ||\n    (modal.priceComponentsValid !== undefined && !modal.priceComponentsValid) ||\n    forms.modal.minDuration.$error.durationValidator ||\n    forms.modal.minWh.$error.energyValidator\" ng-click=modal.done()> <i class=\"fal fa-check mr\"></i> {{\'COMMON.SAVE\' | translate}} </button> </div>");
$templateCache.put("app/views/organization/organization.html","<div id=state-app-organization class=indented-fluid> <div class=panels> <div class=left-panel><!-- <widget-properties-editor params=\"properties.general\" item=\"organization\"></widget-properties-editor> --> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=ctrl.organization></widget-properties-editor> </div> <div class=main-panel><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'ORGANIZATION.GENERAL_INFORMATION\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.organization> </widget-properties-editor> </section> <section> <span class=header>{{\'ORGANIZATION.CONTACT_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.contact item=ctrl.organization> </widget-properties-editor> </section> <section> <span class=header>{{\'ORGANIZATION.PAYMENTS_POLICIES\' | translate}}</span> <div class=section-switch> <div class=form-group> <label>{{\'ORGANIZATION.DENY_FREE_CHARGING\' | translate}}<span uib-tooltip=\"{{\'ORGANIZATION.DENY_FREE_CHARGING_HINT\' | translate}}\" class=info-hint></span></label> <div><widget-switch model=ctrl.state.denyFreeCharging loading=ctrl.state.loading.denyFreeCharging disabled=!ctrl.isProvider() on-change=ctrl.onDenyFreeChargingChanged></widget-switch></div> </div> <span class=help ng-show=!ctrl.isProvider()>{{\'ORGANIZATION.ONLY_PROVIDERS\' | translate}}</span> </div> </section> <section> <span class=header>{{\'PROXY\' | translate}}</span> <div class=section-switch> <div class=form-group> <label>{{\'PROXY_ENABLED\' | translate}}<span uib-tooltip=\"{{\'PROXY_ENABLED_HINT\' | translate}}\" class=info-hint></span></label> <div> <widget-switch model=ctrl.state.proxyEnabled loading=ctrl.state.loading.proxyEnabled disabled=!ctrl.isProvider() on-change=ctrl.onProxyEnabledChanged> </widget-switch> </div> </div> <span class=help ng-show=!ctrl.isProvider()>{{\'ORGANIZATION.ONLY_PROVIDERS\' | translate}}</span> </div> </section> <section> <span class=header>{{\'ORGANIZATION.RESERVATION_QUEUES\' | translate}}</span> <div class=section-switch> <div class=form-group> <label>{{\'ORGANIZATION.RESERVATION_QUEUES_ENABLED\' | translate}}<span uib-tooltip=\"{{\'ORGANIZATION.RESERVATION_QUEUES_ENABLED_HINT\' | translate}}\" class=info-hint></span></label> <div><widget-switch model=ctrl.state.reservationQueues loading=ctrl.state.loading.reservationQueues disabled=!ctrl.isProvider() on-change=ctrl.onReservationQueuesEnabledChanged></widget-switch></div> </div> <span class=help ng-show=!ctrl.isProvider()>{{\'ORGANIZATION.ONLY_PROVIDERS\' | translate}}</span> </div> <div ng-show=ctrl.state.reservationQueues> <div class=\"form-group margin-left-40\"> <widget-properties-editor params=ctrl.properties.reservationQueues item=ctrl.organization></widget-properties-editor> </div> </div> </section> <section> <span class=header>{{\'PRIVATE_USERS_MANAGEMENT\' | translate}}</span> <div class=section-switch> <div class=form-group> <widget-properties-editor params=ctrl.properties.privateUsers item=ctrl.organization></widget-properties-editor> </div> </div> </section> <section> <span class=header>{{\'ACTION.EDIT_NO_MANAGED.NO_MANAGED_CHARGERPOINTS\' | translate}}</span> <div> <div> <p>{{\'ACTION.EDIT_NO_MANAGED.INTRO\' | translate}}</p> <div class=subsection> <div class=subsection-left> <select class=form-control ng-model=ctrl.state.noManagedLanguage ng-options=\"lang.id as lang.display for lang in ctrl.languages\"></select> <div class=help> <span ng-show=\"ctrl.getNoManagedLanguagesSet() == 0\">{{\'ACTION.EDIT_NO_MANAGED.NO_SET\' | translate}}</span> <span translate=ACTION.EDIT_NO_MANAGED.X_OUT_OF_Y_LANGS_SET ng-show=\"ctrl.getNoManagedLanguagesSet() > 0\" ng-class=\"{\'warning\': (ctrl.getNoManagedLanguagesSet() < ctrl.languages.length), \'good\': (ctrl.getNoManagedLanguagesSet() == ctrl.languages.length) }\" translate-value-x={{ctrl.getNoManagedLanguagesSet()}} translate-value-y={{ctrl.languages.length}}></span> </div> </div> <div class=subsection-right> <widget-properties-editor params=ctrl.properties.noManagedInfo item=ctrl.organization.noManagedInfo></widget-properties-editor> <div class=buttons> <button class=\"btn btn-outline-primary\" ng-click=ctrl.askToEditNoManagedChargepoints()><i class=\"fal fa-edit mr\"></i>{{\'ACTION.EDIT_NO_MANAGED.EDIT\' | translate}}</button> </div> </div> </div> </div> </div> </section> <section ng-if=\"ctrl.isAdminProvider() || ctrl.isAdminOfOrganization()\"> <span class=header>{{\'USER_KEYS_MANAGEMENT\' | translate}}</span> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'UPLOAD_XLSX_FILE\' | translate }}\" ng-click=ctrl.uploadCsvFile()><i class=\"fal fa-plus mr\"></i>{{\'UPLOAD_XLSX_FILE\' | translate }}</button> </section> <section> <span class=header>{{\'ORGANIZATION.OTHER_SETTINGS\' | translate}}</span> <widget-properties-editor params=ctrl.properties.misc item=ctrl.organization></widget-properties-editor> </section> </div><!-- EMAILS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'emails\'\"> <section> <span class=header>{{\'ORGANIZATION.COMMUNICATION_WITH_CUSTOMERS\' | translate}}</span> <p>{{\'ORGANIZATION.COMMUNICATION_WITH_CUSTOMERS_HELP\' | translate}}</p> <div class=subsection> <div class=subsection-left> <div class=title>{{\'ORGANIZATION.VALIDATION_EMAIL.TITLE\' | translate}}</div> <div class=help>{{\'ORGANIZATION.VALIDATION_EMAIL.HELP\' | translate}}</div> </div> <div class=subsection-right> <widget-properties-editor params=ctrl.properties.validation item=ctrl.organization></widget-properties-editor> </div> </div> <div class=subsection> <div class=subsection-left> <div class=title>{{\'ORGANIZATION.APP_REPORTS.TITLE\' | translate}}</div> <div class=help>{{\'ORGANIZATION.APP_REPORTS.HELP\' | translate}}</div> </div> <div class=subsection-right> <widget-properties-editor params=ctrl.properties.appReports item=ctrl.organization></widget-properties-editor> </div> </div> </section> </div><!-- BANNERS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'banners\'\"> <section> <span class=header>{{\'ORGANIZATION.COMMUNICATION_WITH_APP\' | translate}}</span> <p>{{\'ORGANIZATION.COMMUNICATION_WITH_APP_HELP\' | translate}}</p> <widget-table params=ctrl.tables.banners items=ctrl.banners on-reload=ctrl.reloadBanners> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'ORGANIZATION.ADD_BANNER_TIP\' | translate}}\" ng-click=ctrl.askToAddBanner()><i class=\"fal fa-plus mr\"></i>{{\'ORGANIZATION.ADD_BANNER\' | translate}}</button> </div> </section> </div><!-- USERS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'users\'\"> <section> <p translate=ORGANIZATION.ROLES_AT translate-value-name=\"<accent>{{ctrl.organization.name | safe}}</accent>\"></p> <widget-table params=ctrl.tables.roles items=ctrl.roles on-reload=ctrl.getPrivate> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'ORGANIZATION.ADD_ROLE_TIP\' | translate:\'{name: &quot;\' + ctrl.organization.name + \'&quot;}\' }}\" ng-click=ctrl.askToAddUser()><i class=\"fal fa-plus mr\"></i>{{\'ORGANIZATION.ADD_ROLE\' | translate}}</button> </div> </section> </div><!-- PAYMENTS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'payments\'\"> <section> <span class=header>{{\'CONFIGURATION\' | translate}}</span> <widget-properties-editor params=ctrl.properties.payments item=ctrl.payments> </widget-properties-editor> </section> </div><!-- CONSENTS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'consents\'\"> <section> <span class=header>{{\'CONSENTS\' | translate}}</span> <widget-table params=ctrl.tables.consents items=ctrl.allConsents.consents on-reload=ctrl.reload></widget-table> <div class=subsection> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToAddConsent()><i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}}</button> </div> </div> </section> <section> <span class=header>{{\'CONSENT_SUMMARY\' | translate}}</span> <p style=\"font-weight: bold\">{{\'LANG\' | translate}}</p> <div class=subsection style=\"margin-bottom: 25px\"> <div class=subsection-left> <select class=form-control ng-model=ctrl.state.consentSummaryLanguage ng-options=\"lang.id as lang.display for lang in ctrl.languages\"></select> </div> </div> <div class=subsection style=\"margin-bottom: 25px\"> <widget-properties-editor params=ctrl.properties.consentSummaryInfo item=ctrl.allConsents></widget-properties-editor> </div> <div class=subsection> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToEditConsentSummary()><i class=\"fal fa-edit mr\"></i>{{\'COMMON.EDIT\' | translate}}</button> </div> </div> </section> </div><!-- OWNERS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'owners\'\"> <section> <span class=header>{{\'OWNERS\' | translate}}</span> <widget-table params=ctrl.tables.owners items=ctrl.owners></widget-table> <div class=subsection> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToAddOwner()><i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}}</button> </div> </div> </section> </div><!-- FISCAL INFORMATION TAB --> <div ng-show=\"ctrl.tabs.active.id == \'fiscalInformation\'\"> <section> <span class=header>{{\'CONFIGURATION\' | translate}}</span> <widget-properties-editor params=ctrl.properties.fiscalInformation item=ctrl.fiscalInformation> </widget-properties-editor> </section> </div> <div ng-show=\"ctrl.tabs.active.id == \'maintainers\'\"> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.maintainers on-reload=ctrl.getMaintainers></widget-filters> </div> <widget-table params=ctrl.tables.maintainers items=ctrl.maintainers on-reload=ctrl.getMaintainers> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToAddMaintainer()> <i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}} </button> </div> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/organizations/organizations.html","<div id=state-app-organizations class=indented-fluid> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters on-reload=ctrl.reload controls=ctrl.filterControls></widget-filters> </div> <widget-table params=ctrl.table items=ctrl.organizations on-item-click=ctrl.onOrganizationClick on-reload=ctrl.reload> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'ORGANIZATIONS.NEW\' | translate}}\" ng-click=ctrl.askToAddOrganization()><i class=\"fal fa-plus mr\"></i>{{\'ORGANIZATIONS.NEW\' | translate}}</button> </div> </section></div>");
$templateCache.put("app/views/profile/profile.html","<div id=state-app-profile class=indented-fluid> <div class=panels> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=user></widget-properties-editor> </div> <div class=main-panel><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'PROFILE.INFO.ACCOUNT_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=user> </widget-properties-editor> </section> <section> <span class=header>{{\'PROFILE.INFO.ACCESS_CONTROL\' | translate}}</span> <div> <span>{{\'PROFILE.INFO.ACCOUNT_PROTECTED_BY_LOGIN_PASSWORD\' | translate}}</span> <div class=buttons> <button class=\"btn btn-info\" uib-tooltip=\"{{\'PROFILE.INFO.CHANGE_PASSWORD_HELP\' | translate}}\" ng-click=ctrl.askToChangePassword()> <i class=\"fal fa-key mr\"></i>{{\'PROFILE.INFO.CHANGE_PASSWORD\' | translate}} </button> </div> </div> </section> <section> <span class=header>{{\'PROFILE.TFA.TITLE\' | translate}}</span> <div> <span ng-show=ctrl.isTfaEnabled>{{\'PROFILE.TFA.ENABLED\' | translate}}</span> <span ng-show=!ctrl.isTfaEnabled>{{\'PROFILE.TFA.DISABLED\' | translate}}</span> <div class=buttons> <button ng-show=!ctrl.isTfaEnabled class=\"btn btn-info\" uib-tooltip=\"{{\'PROFILE.TFA.INFO\' | translate}}\" ng-click=ctrl.showTfaSetup()> <i class=\"fal fa-mobile mr\"></i>{{\'PROFILE.TFA.ENABLE\' | translate}} </button> <button ng-show=ctrl.isTfaEnabled class=\"btn btn-info\" uib-tooltip=\"{{\'PROFILE.TFA.DISABLE\' | translate}}\" ng-click=ctrl.disableTfa()> <i class=\"fal fa-mobile mr\"></i>{{\'PROFILE.TFA.DISABLE\' | translate}} </button> </div> </div> </section> </div><!-- ROLES TAB --> <div ng-show=\"ctrl.tabs.active.id == \'permissions\'\"> <section> <p translate=PROFILE.ROLES.ROLES_FOR translate-value-name=\"<accent>{{user.displayName | safe}}</accent>\"></p> <widget-table params=ctrl.tables.permissions items=roles></widget-table> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/reset-password/reset-password.html","<div id=state-reset-password class=\"fullscreen center\"> <div class=login-box ng-show=ctrl.user> <div class=branding> <div class=branding-logo> <div></div> </div> <h2>{{ENV.APP.NAME}}</h2> </div> <h4 translate=RESET_PWD.HELLO translate-value-name=\"<accent>{{(ctrl.user.displayName | safe) || ctrl.user.username}}</accent>\"></h4> <p class=neutral>{{\'RESET_PWD.ENTER_NEW_PASSWORD\' | translate}}</p> <form name=form novalidate> <input class=hidden name=username type=hidden ng-model=ctrl.user.username autocomplete=username> <div class=form-group> <label>{{\'RESET_PWD.NEW_PASSWORD\' | translate}}</label> <input name=password type=password class=form-control ng-model=ctrl.password required autocomplete=password> <p class=help> <t translate=RESET_PWD.SET_PASSWORD.HELP_CONSTRAINTS_1></t> <br> <t translate=RESET_PWD.SET_PASSWORD.HELP_CONSTRAINTS_2></t> </p> </div> <div class=\"buttons align-right\"> <button class=\"right-part btn btn-primary\" ng-click=ctrl.setPassword() ng-disabled=form.password.$invalid><i class=\"fal fa-key mr\"></i>{{\'RESET_PWD.DO_SAVE\' | translate}}</button> </div> </form> <div class=login-footer> <a href=https://www.efimob.com translate=RESET_PWD.DEVELOPED_BY translate-value-efimob=\"<strong>Efimob</strong>\"></a> </div> </div> </div>");
$templateCache.put("app/views/settings/settings.html","<div id=state-app-settings class=indented-fluid> <div class=panels> <div class=left-panel> <widget-tabs params=ctrl.tabs> </div> <div class=right-panel right-panel> <widget-properties-editor params=ctrl.properties.right item=ctrl.provider> </div> <div class=main-panel><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'SETTINGS.INFO.PROVIDER\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.provider> </section> <section> <span class=header>{{\'SETTINGS.INFO.CONTACT_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.contact item=ctrl.privateData> </section> <section> <span class=header>{{\'SETTINGS.INFO.CHARGEPOINTS\' | translate}}</span> <div> <div class=buttons> <button class=\"btn btn-info\" uib-tooltip=\"{{\'SETTINGS.INFO.EXPORT_AS_CSV\' | translate}}\" ng-click=ctrl.exportChargepoints()> <i class=\"fal fa-file-export mr\"></i>{{\'SETTINGS.INFO.EXPORT\' | translate}} </button> </div> </div> </section> </div><!-- USERS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'users\'\"> <section> <p translate=SETTINGS.USERS.STAFF_FOR translate-value-id=\"<accent>{{ctrl.provider.id}}</accent>\"> </p> <widget-table params=ctrl.tables.roles items=ctrl.roles on-item-click=ctrl.onRoleClick on-reload=ctrl.getPrivate> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" uib-tooltip=\"{{ctrl.$translate.instant(\'SETTINGS.USERS.ADD_USER_HELP\', {id: ctrl.provider.id})}}\" ng-click=ctrl.askToAddUser()> <i class=\"fal fa-plus mr\"></i>{{\'SETTINGS.USERS.ADD_USER\' | translate}} </button> </div> </section> </div><!-- BILLING TAB --> <div ng-show=\"ctrl.tabs.active.id == \'billing\'\"> <section> <span class=header>{{\'CHARGE_POINT_BILLING\' | translate}}</span> <widget-filters style=\"margin-left: 0px\" display-button=false params=ctrl.filters.billing></widget-filters> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.getChargePointBilling()> <i class=\"fal fa-download mr\"></i>{{\'Download\' | translate}} </button> </div></section> </div><!-- Proxy TAB --> <div ng-show=\"ctrl.tabs.active.id == \'proxy\'\"> <section> <widget-table params=ctrl.tables.proxies items=ctrl.proxies on-reload=ctrl.getProxies> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToAddProxy()> <i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}} </button> </div> </section> </div> <div ng-show=\"ctrl.tabs.active.id == \'holidays\'\"> <section> <widget-table params=ctrl.tables.holidays items=ctrl.holidays on-reload=ctrl.getHolidays> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToAddHoliday()> <i class=\"fal fa-plus mr\"></i>{{\'COMMON.ADD\' | translate}} </button> </div> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/signup/signup.html","<div id=state-signup class=\"fullscreen center\"> <div class=login-box> <div class=branding> <div class=branding-logo> <div></div> </div> <h2>{{ENV.APP.NAME}}</h2> </div> <h5>Vamos a crear una cuenta para ti</h5> <p class=neutral> Sólo necesitamos una dirección de correo electrónico válida, un nombre y la contraseña que elijas </p> <form novalidate> <div class=form-group> <label>Email</label> <input name=newEmail type=text class=form-control ng-model=ctrl.username> <span class=help>Enviaremos un email para confirmarlo</span> </div> <div class=form-group> <label>Nombre</label> <input name=newDisplayName type=text class=form-control ng-model=ctrl.displayName> <p class=help>¿Cómo quieres que te llamemos?</p> </div> <div class=form-group> <label>Contraseña</label> <input name=newPassword type=password class=form-control ng-model=ctrl.password autocomplete=password><!-- <p class=\"help\">Podrás cambiarla más adelante</p> --> </div> <div class=\"buttons align-right\"> <button class=\"right-part btn btn-success\" ng-click=ctrl.signup()> <i class=\"fal fa-user-plus mr\"></i>Registrar </button> </div> <div class=\"buttons align-right\"> <a ui-sref=login class=small-text><i class=\"fal fa-sign-in-alt mr\"></i>Ya tengo usuario</a> </div> </form> <div class=login-footer> </div> </div> </div>");
$templateCache.put("app/views/tariff/tariff.html","<div id=state-app-tariff class=indented-fluid> <div class=panels> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=main-panel> <div ng-show=\"ctrl.tabs.active.id == \'general\'\"> <section style=\"margin-bottom: 20px\"> <div class=buttons style=\"display: flex;justify-content: flex-end\"> <button class=\"btn btn-primary\" ng-click=ctrl.saveTariff() ng-show=\"ctrl.canEdit() && !ctrl.properties.controls.onEdition\"> <i class=\"fal fa-save mr\"></i>{{\'SAVE\' | translate }} </button> <button class=\"btn btn-primary\" ng-click=ctrl.editionMode() ng-show=!ctrl.isCreate> <i class=\"fal fa-edit mr\"></i>{{ ctrl.canEdit() ? \'CANCEL\' : \'EDIT\' | translate }} </button> <button class=\"btn btn-danger\" ng-click=ctrl.removeTariff()> <i class=\"fal fa-times mr\"></i>{{ ctrl.isCreate ? \'CANCEL\' : \'REMOVE\' | translate }} </button> </div> </section> <section> <span class=header>{{\'INFORMATION\' | translate}}</span> <widget-properties-editor params=ctrl.properties item=ctrl.tariff enabled=ctrl.canEdit()> </widget-properties-editor> </section><!-- Roaming --> <section ng-if=\"ctrl.tariff.scope == \'CPO\'\"> <span class=header>{{\'AGREEMENT_ID\' | translate}}</span> <div class=\"d-flex flex-column\"> <span> <b>{{\'AGREEMENT_ID\' | translate}}</b> </span> <agreement-input-component disabled=!ctrl.isCreate style=\"width: 50%\" value=ctrl.tariff.roamingAgreementId organization=ctrl.organization on-change=ctrl.onAgreementChanged search> </agreement-input-component> </div> </section><!-- !Roaming --><!-- QR --> <section ng-if=\"ctrl.tariff.scope == \'QR\'\"> <span class=header>{{\'PREAUTHORIZATION\' | translate}}</span> <div class=\"form-group mt-l\"> <div class=inline-flex> <input ng-disabled=!ctrl.canEdit() ng-model=ctrl.tariff.preAuthorizationAmount type=number class=\"width-100 form-control\" decimal-number=2 min=0 step=0.01> <span class=ml-xs>€</span> </div> </div> <p class=help>{{\'PREAUTHORIZATION_HELP\' | translate}}</p> </section><!-- !QR --><!-- Grace Period --> <section> <span class=header>{{\'GRACE_PERIOD\' | translate}}</span> <div class=\"form-group mt-l\"> <widget-switch model=ctrl.withGracePeriod on-change=ctrl.onWithGracePeriodChanged disabled=\"!ctrl.canEdit() || ctrl.properties.controls.onEdition\"></widget-switch> </div> <p class=help ng-if=!ctrl.withGracePeriod>{{\'ACTION.ADD_TARIFF.GRACE_PERIOD_HELP\' | translate}}</p> <div ng-if=ctrl.withGracePeriod> <div class=form-group> <label></label> <div class=inline-flex> <span class=\"nowrap mr-xs\" translate=ACTION.ADD_TARIFF.FREE_WHEN translate-value-free=\"<b><warning>{{\'ACTION.ADD_TARIFF.FREE\' | translate}}</warning></b>\"></span> <input name=energyGracePeriod ng-disabled=!ctrl.canEdit() ng-model=ctrl.tariff.gracePeriods type=number min=0 step=0.01 class=\"width-100 form-control\" grace-period-model=energy decimal-number=2 wh-to-kwh> <span class=ml-xs>KWh</span> </div> </div> <div class=form-group> <label></label> <div class=inline-flex> <span class=\"nowrap mr-xs\" translate=ACTION.ADD_TARIFF.FREE_WHEN translate-value-free=\"<b><warning>{{\'ACTION.ADD_TARIFF.FREE\' | translate}}</warning></b>\"></span> <input name=timeGracePeriod ng-disabled=!ctrl.canEdit() ng-model=ctrl.tariff.gracePeriods type=number min=0 step=1 class=\"width-100 form-control\" grace-period-model=time only-numbers s-to-min> <span class=ml-xs>{{\'ACTION.ADD_TARIFF.MINUTES\' | translate}}</span> </div> </div> </div> </section><!-- !Grace Period --><!-- Location --> <section> <span class=header>{{\'LOCATIONS\' | translate}}</span> <div class=\"d-flex flex-column\"> <widget-table params=ctrl.locationTable items=ctrl.tariff.locations> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.upsertLocation() ng-show=ctrl.canEdit()> <i class=\"fal fa-edit mr\"></i>{{\'EDIT\' | translate }} </button> </div> </div> </section><!-- !Location --> <section> <span class=header>{{\'RESTRICTIONS\' | translate}}</span> <widget-table params=ctrl.tables.restrictions items=ctrl.tariff.restrictions> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.addNewRestriction() ng-show=\"ctrl.canEdit() && !ctrl.properties.controls.onEdition\"> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate }} </button> </div> </section> </div> <div ng-show=\"ctrl.tabs.active.id == \'chargePoint\'\"> <section> <widget-table params=ctrl.tables.chargePoints items=ctrl.chargePoints on-reload=ctrl.reloadChargePoints> </widget-table> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/tariffs/tariffs.html","<div id=state-app-tariffs class=indented-fluid> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters on-reload=ctrl.reload controls=ctrl.filterControls> </widget-filters> </div> <widget-table params=ctrl.table items=ctrl.tariffs on-item-click=ctrl.upsertTariff on-reload=ctrl.reload> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.upsertTariff()> <i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate }} </button> </div> </section> </div>");
$templateCache.put("app/views/user-key/user-key.html","<div id=state-app-userkey class=indented-fluid> <div class=panels> <div class=right-panel right-panel ng-if=ctrl.userkey.organizationId> <widget-properties-editor params=ctrl.properties.right item=ctrl.userkey></widget-properties-editor> </div> <div class=left-panel> <widget-tabs params=ctrl.tabs></widget-tabs> </div> <div class=main-panel><!-- INFO TAB --> <div ng-show=\"ctrl.tabs.active.id == \'info\'\"> <section> <span class=header>{{\'USERKEY.GENERAL_INFO\' | translate}}</span> <widget-properties-editor params=ctrl.properties.general item=ctrl.userkey> </widget-properties-editor> </section><!-- PREPAID CARD SECTION --> <section ng-if=ctrl.showPrepaidSection()> <span class=header>{{\'PREPAID_CARD\' | translate}}</span> <div class=form-group> <widget-properties-editor params=ctrl.properties.prepaid item=ctrl.userkey> </widget-properties-editor> </div> </section><!-- END PREPAID CARD SECTION --> <section ng-show=\"role.entity === \'provider\'\"> <span class=header>{{\'USERKEY.COMPANY\' | translate}}</span> <div> <div ng-show=ctrl.userkey.organizationId> <p>{{\'USERKEY.ASSIGNED_TO_COMPANY\' | translate}} <a ui-sref=\"efimob.organizations.item({id: ctrl.userkey.organizationId})\"> {{ctrl.userkey.organizationName}} </a> </p> </div> <div ng-show=\"ctrl.userkey.organizationId===null\"> <p>{{\'USERKEY.NOT_ASSIGNED_TO_COMPANY\' | translate}}</p> <button class=\"btn btn-primary\" ng-click=ctrl.askToChangeOrganization() ng-show=\"role.role===\'admin\'\"> <i class=\"fal fa-building mr\"></i> {{\'USERKEY.DO_ASSIGN_TO_COMPANY\' | translate}} </button> </div> </div> </section> <section> <span class=header>{{\'USERKEY.CUSTOMER\' | translate}}</span> <div> <p ng-show=ctrl.userkey.customerId> {{\'USERKEY.ASSIGNED_TO_CUSTOMER\' | translate}} <a ui-sref=\"efimob.customers.item({\'id\': ctrl.userkey.customerId, \'organization\':ctrl.userkey.organizationId})\"> {{ctrl.userkey.customerName}} </a> </p> <p ng-show=\"(ctrl.userkey && !ctrl.userkey.customerId)\"> {{\'USERKEY.NOT_ASSIGNED_TO_CUSTOMER\' | translate}} <span ng-show=\"ctrl.userkey.organizationId===null\" class=warning> {{\'USERKEY.PRIOR_TO_CUSTOMER_ASSIGN\' | translate}} </span> </p> <div class=buttons ng-show=ctrl.userkey.organizationId> <button class=\"btn btn-primary\" ng-click=ctrl.askToBindToCustomer()><i class=\"fal fa-{{ctrl.App.icon[\'customer\']}} mr\"></i> <span ng-show=\"(ctrl.userkey && !ctrl.userkey.customerId)\">{{\'USERKEY.DO_ASSIGN_TO_CUSTOMER\' | translate}}</span> <span ng-show=ctrl.userkey.customerId>{{\'USERKEY.CHANGE_CUSTOMER\' | translate}}</span> </button> <button class=\"btn btn-outline-secondary\" ng-show=ctrl.userkey.customerId ng-click=ctrl.askToUnbind()>{{\'USERKEY.MARK_NO_CUSTOMER\' | translate}}</button> </div> </div> </section> <section> <span class=header>{{\'USERKEY.STATE\' | translate}}</span> <div> <widget-properties-editor params=ctrl.properties.state item=ctrl.userkey> </widget-properties-editor> <div ng-show=ctrl.userkey.organizationId class=buttons> <button ng-show=!ctrl.userkey.blocked class=\"btn btn-warning\" ng-click=ctrl.askToToggleBlocked()> <i class=\"fal fa-lock-alt mr\"></i>{{\'USERKEY.LOCK_KEY\' | translate}} </button> <button ng-show=ctrl.userkey.blocked class=\"btn btn-primary\" ng-click=ctrl.askToToggleBlocked()> <i class=\"fal fa-unlock-alt mr\"></i>{{\'USERKEY.UNLOCK_KEY\' | translate}} </button> </div> </div> </section> <section ng-show=ctrl.organization> <span class=header>{{\'USERKEY.MASTER_KEY\' | translate}}</span> <div> <widget-properties-editor params=ctrl.properties.master item=ctrl.userkey> </widget-properties-editor> <div class=buttons> <button ng-show=!ctrl.userkey.master class=\"btn btn-info\" ng-click=ctrl.toggleMaster()> {{\'USERKEY.SET_MASTER\' | translate}} </button> <button ng-show=ctrl.userkey.master class=\"btn btn-secondary\" ng-click=ctrl.toggleMaster()>{{\'USERKEY.UNSET_MASTER\' | translate}}</button> </div> <p class=help> {{\'USERKEY.MASTER_KEY_HINT\' | translate}} </p> </div> </section> <section ng-show=ctrl.canAdminUserkey()> <span class=header>{{\'USERKEY.DELETE\' | translate}}</span> <div> <p>{{\'USERKEY.WHEN_DELETED\' | translate}}</p> <div> <button class=\"btn btn-danger\" type=button ng-click=ctrl.askToRemoveUserkey()> {{\'USERKEY.DO_DELETE\' | translate}} </button> </div> </div> </section> </div><!-- GROUPS TAB --> <div ng-show=\"ctrl.tabs.active.id == \'groups\'\"> <section> <p>{{\'USERKEY.KEY_ONLY_WORKS\' | translate}}</p> <widget-table params=ctrl.tables.groups items=ctrl.userkey.groups on-item-click=ctrl.onGroupClick> </widget-table> <div class=buttons> <button class=\"btn btn-primary\" ng-click=ctrl.askToAddGroup()> <i class=\"fal fa-project-diagram mr\"></i>{{\'USERKEY.AUTH_GROUP\' | translate}} </button> </div> </section> </div><!-- CHARGES TAB --> <div ng-show=\"ctrl.tabs.active.id == \'charges\'\"> <section> <p translate=USERKEY.CHARGES_OF_KEY translate-value-id=\"<accent>{{ctrl.userkey.idToken}}</accent>\"> </p> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters.charges on-reload=ctrl.reloadCharges></widget-filters> </div> <widget-table params=ctrl.tables.charges items=ctrl.charges on-item-click=ctrl.onChargeClick on-reload=ctrl.reloadCharges></widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" uib-tooltip=\"{{\'USERKEY.EXPORT_HINT\' | translate}}\" ng-click=ctrl.exportCharges()> <i class=\"fal fa-file-export mr\"></i>{{\'USERKEY.EXPORT\' | translate}} </button> </div> </section> </div> </div> </div> </div>");
$templateCache.put("app/views/user-keys/user-keys.html","<div id=state-app-userkeys class=indented-fluid> <section> <div class=\"filters-container top\"> <widget-filters params=ctrl.filters on-reload=ctrl.reload controls=ctrl.filterControls></widget-filters> </div> <widget-table params=ctrl.table items=ctrl.userkeys on-item-click=ctrl.onUserkeyClick on-reload=ctrl.reload> </widget-table> <div class=buttons> <button class=\"btn btn-outline-primary\" tooltip-placement=auto uib-tooltip=\"{{\'EXPORT_KEYS_TO_CSV_FILE\' | translate }}\" ng-click=ctrl.exportUserkeys()><i class=\"fal fa-file-export mr\"></i>{{\'EXPORT_CSV\' | translate }}</button> <button class=\"btn btn-primary\" uib-tooltip=\"{{\'NEW_KEY\' | translate }}\" ng-click=ctrl.askToAddUserkey() ng-show=ctrl.isAdmin()><i class=\"fal fa-plus mr\"></i>{{\'ADD\' | translate }}</button> </div> </section> </div>");
$templateCache.put("app/views/welcome/welcome.html","<div id=state-welcome class=\"fullscreen center\"> <div class=login-box ng-show=ctrl.user> <div class=branding> <div class=branding-logo> <div></div> </div> <h2>{{ENV.APP.NAME}}</h2> </div> <h4 translate=WELCOME.HELLO translate-value-name=\"<accent>{{(ctrl.user.displayName | safe) || ctrl.user.username}}</accent>\"></h4> <p class=neutral> {{\'WELCOME.ENTER_NEW_PASSWORD\' | translate}} </p> <form name=form novalidate> <input class=hidden name=username type=hidden ng-model=ctrl.user.username autocomplete=username> <div class=form-group> <label>{{\'WELCOME.NEW_PASSWORD\' | translate}}</label> <input name=password type=password class=form-control ng-model=ctrl.input.password required autocomplete=password> <p class=help> <t translate=WELCOME.SET_PASSWORD.HELP_CONSTRAINTS_1></t> <br> <t translate=WELCOME.SET_PASSWORD.HELP_CONSTRAINTS_2></t> </p> </div> <div class=\"buttons align-right\"> <button class=\"right-part btn btn-primary\" ng-click=ctrl.setPassword() ng-disabled=form.password.$invalid><i class=\"fal fa-key mr\"></i>{{\'WELCOME.DO_SAVE\' | translate}}</button> </div> </form> <div class=login-footer> <a href=https://www.efimob.com translate=WELCOME.DEVELOPED_BY translate-value-efimob=\"<strong>Efimob</strong>\"></a> </div> </div> </div>");
$templateCache.put("app/views/tariff/directives/price-component-cost/price-component-cost.html","<div> <div ng-repeat=\"priceComponent in ctrl.priceComponents\" class=\"inline-flex align-items-center\" style=\"display: grid; grid-template-columns: 110px 200px 140px 20px 260px; gap: 15px\"> <div class=form-group> <md-select ng-model=ctrl.typeMap[$index] class=form-control ng-change=\"ctrl.typeChanged(ctrl.typeMap[$index], priceComponent)\" ng-init=\"ctrl.typeMap[$index] = ctrl.initType(priceComponent)\" data-md-container-class=selectHeader> <md-option ng-value=priceComponentTypeOption ng-repeat=\"priceComponentTypeOption in ctrl.priceComponentTypeOptions\" ng-if=\"ctrl.isTypeAvailable(priceComponentTypeOption, priceComponent)\"> {{priceComponentTypeOption.display}} </md-option> </md-select> </div> <div class=form-group> <div class=\"inline-flex margin-right-0\"> <input name=price-with-vat min=0 max=999.999 name=price step=0.001 ng-model=priceComponent.priceWithVat type=number class=\"form-control width-150\" reset-on-type-change decimal-number=3 price-with-vat-initializer> <span class=ml-xs> {{priceComponent.type | priceComponentUnit}} </span> </div> </div> <div class=form-group> <div class=inline-flex> <md-autocomplete class=vat-autocomplete md-autocomplete-focus-open md-search-text=modal.vatView md-selected-item=modal.selectedVat md-items=\"item in ctrl.priceComponentVatOptions\" md-item-text=item.display vat-autocomplete=priceComponent.vat vat-no-taxes-text=\"{{ ctrl.$translate.instant(\'NO_TAXES\') }}\" only-numbers> <span md-highlight-text=priceComponent.vatView>{{item.display}}</span> </md-autocomplete> <span class=ml-xs> <span class=ml-xs>%</span> </span> </div> </div> <div class=form-group> <div class=inline-flex> <i class=\"fa fa-arrow-alt-right ml-s mr-s\"></i> </div> </div> <div class=form-group> <div class=\"inline-flex justify-content-between\"> <div class=inline-flex> <input name=price-without-vat type=number class=\"form-control width-150\" ng-model=priceComponent.price readonly=readonly recalculate-price-without-vat price-adapter={{ctrl.getConversionFactor(priceComponent.type)}}> <span class=ml-xs> {{priceComponent.type | priceComponentUnit}} </span> </div> <a class=remover ng-if=\"$index>0\" ng-click=ctrl.removeItem($index)> <i class=\"fa fa-times ml-s\"></i> </a> </div> </div> </div> <div class=margin-top-5> <a ng-if=\"ctrl.priceComponents.length < ctrl.priceComponentTypeOptions.length\" ng-click=ctrl.addItem()> <i class=\"fal fa-plus mr\"></i> {{\'COMMON.ADD\' | translate}} </a> </div> </div>");}]);